webpackJsonp([0],[
/* 0 */
/***/ (function(module, exports) {

/* globals __VUE_SSR_CONTEXT__ */

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = injectStyles
  }

  if (hook) {
    var functional = options.functional
    var existing = functional
      ? options.render
      : options.beforeCreate
    if (!functional) {
      // inject component registration as beforeCreate hook
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    } else {
      // register for functioal component in vue file
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return existing(h, context)
      }
    }
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var bind = __webpack_require__(8);

/*global toString:true*/

// utils is a library of generic helper functions non-specific to axios

var toString = Object.prototype.toString;

/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Array, otherwise false
 */
function isArray(val) {
  return toString.call(val) === '[object Array]';
}

/**
 * Determine if a value is undefined
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if the value is undefined, otherwise false
 */
function isUndefined(val) {
  return typeof val === 'undefined';
}

/**
 * Determine if a value is a Buffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Buffer, otherwise false
 */
function isBuffer(val) {
  return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor)
    && typeof val.constructor.isBuffer === 'function' && val.constructor.isBuffer(val);
}

/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */
function isArrayBuffer(val) {
  return toString.call(val) === '[object ArrayBuffer]';
}

/**
 * Determine if a value is a FormData
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an FormData, otherwise false
 */
function isFormData(val) {
  return (typeof FormData !== 'undefined') && (val instanceof FormData);
}

/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */
function isArrayBufferView(val) {
  var result;
  if ((typeof ArrayBuffer !== 'undefined') && (ArrayBuffer.isView)) {
    result = ArrayBuffer.isView(val);
  } else {
    result = (val) && (val.buffer) && (val.buffer instanceof ArrayBuffer);
  }
  return result;
}

/**
 * Determine if a value is a String
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a String, otherwise false
 */
function isString(val) {
  return typeof val === 'string';
}

/**
 * Determine if a value is a Number
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Number, otherwise false
 */
function isNumber(val) {
  return typeof val === 'number';
}

/**
 * Determine if a value is an Object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is an Object, otherwise false
 */
function isObject(val) {
  return val !== null && typeof val === 'object';
}

/**
 * Determine if a value is a Date
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Date, otherwise false
 */
function isDate(val) {
  return toString.call(val) === '[object Date]';
}

/**
 * Determine if a value is a File
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a File, otherwise false
 */
function isFile(val) {
  return toString.call(val) === '[object File]';
}

/**
 * Determine if a value is a Blob
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Blob, otherwise false
 */
function isBlob(val) {
  return toString.call(val) === '[object Blob]';
}

/**
 * Determine if a value is a Function
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */
function isFunction(val) {
  return toString.call(val) === '[object Function]';
}

/**
 * Determine if a value is a Stream
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a Stream, otherwise false
 */
function isStream(val) {
  return isObject(val) && isFunction(val.pipe);
}

/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {Object} val The value to test
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */
function isURLSearchParams(val) {
  return typeof URLSearchParams !== 'undefined' && val instanceof URLSearchParams;
}

/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 * @returns {String} The String freed of excess whitespace
 */
function trim(str) {
  return str.replace(/^\s*/, '').replace(/\s*$/, '');
}

/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 */
function isStandardBrowserEnv() {
  if (typeof navigator !== 'undefined' && (navigator.product === 'ReactNative' ||
                                           navigator.product === 'NativeScript' ||
                                           navigator.product === 'NS')) {
    return false;
  }
  return (
    typeof window !== 'undefined' &&
    typeof document !== 'undefined'
  );
}

/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 */
function forEach(obj, fn) {
  // Don't bother if no value provided
  if (obj === null || typeof obj === 'undefined') {
    return;
  }

  // Force an array if not already something iterable
  if (typeof obj !== 'object') {
    /*eslint no-param-reassign:0*/
    obj = [obj];
  }

  if (isArray(obj)) {
    // Iterate over array values
    for (var i = 0, l = obj.length; i < l; i++) {
      fn.call(null, obj[i], i, obj);
    }
  } else {
    // Iterate over object keys
    for (var key in obj) {
      if (Object.prototype.hasOwnProperty.call(obj, key)) {
        fn.call(null, obj[key], key, obj);
      }
    }
  }
}

/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function merge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = merge(result[key], val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Function equal to merge with the difference being that no reference
 * to original objects is kept.
 *
 * @see merge
 * @param {Object} obj1 Object to merge
 * @returns {Object} Result of all merge properties
 */
function deepMerge(/* obj1, obj2, obj3, ... */) {
  var result = {};
  function assignValue(val, key) {
    if (typeof result[key] === 'object' && typeof val === 'object') {
      result[key] = deepMerge(result[key], val);
    } else if (typeof val === 'object') {
      result[key] = deepMerge({}, val);
    } else {
      result[key] = val;
    }
  }

  for (var i = 0, l = arguments.length; i < l; i++) {
    forEach(arguments[i], assignValue);
  }
  return result;
}

/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 * @return {Object} The resulting value of object a
 */
function extend(a, b, thisArg) {
  forEach(b, function assignValue(val, key) {
    if (thisArg && typeof val === 'function') {
      a[key] = bind(val, thisArg);
    } else {
      a[key] = val;
    }
  });
  return a;
}

module.exports = {
  isArray: isArray,
  isArrayBuffer: isArrayBuffer,
  isBuffer: isBuffer,
  isFormData: isFormData,
  isArrayBufferView: isArrayBufferView,
  isString: isString,
  isNumber: isNumber,
  isObject: isObject,
  isUndefined: isUndefined,
  isDate: isDate,
  isFile: isFile,
  isBlob: isBlob,
  isFunction: isFunction,
  isStream: isStream,
  isURLSearchParams: isURLSearchParams,
  isStandardBrowserEnv: isStandardBrowserEnv,
  forEach: forEach,
  merge: merge,
  deepMerge: deepMerge,
  extend: extend,
  trim: trim
};


/***/ }),
/* 2 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global, setImmediate) {/*!
 * Vue.js v2.6.12
 * (c) 2014-2020 Evan You
 * Released under the MIT License.
 */
/*  */

var emptyObject = Object.freeze({});

// These helpers produce better VM code in JS engines due to their
// explicitness and function inlining.
function isUndef (v) {
  return v === undefined || v === null
}

function isDef (v) {
  return v !== undefined && v !== null
}

function isTrue (v) {
  return v === true
}

function isFalse (v) {
  return v === false
}

/**
 * Check if value is primitive.
 */
function isPrimitive (value) {
  return (
    typeof value === 'string' ||
    typeof value === 'number' ||
    // $flow-disable-line
    typeof value === 'symbol' ||
    typeof value === 'boolean'
  )
}

/**
 * Quick object check - this is primarily used to tell
 * Objects from primitive values when we know the value
 * is a JSON-compliant type.
 */
function isObject (obj) {
  return obj !== null && typeof obj === 'object'
}

/**
 * Get the raw type string of a value, e.g., [object Object].
 */
var _toString = Object.prototype.toString;

function toRawType (value) {
  return _toString.call(value).slice(8, -1)
}

/**
 * Strict object type check. Only returns true
 * for plain JavaScript objects.
 */
function isPlainObject (obj) {
  return _toString.call(obj) === '[object Object]'
}

function isRegExp (v) {
  return _toString.call(v) === '[object RegExp]'
}

/**
 * Check if val is a valid array index.
 */
function isValidArrayIndex (val) {
  var n = parseFloat(String(val));
  return n >= 0 && Math.floor(n) === n && isFinite(val)
}

function isPromise (val) {
  return (
    isDef(val) &&
    typeof val.then === 'function' &&
    typeof val.catch === 'function'
  )
}

/**
 * Convert a value to a string that is actually rendered.
 */
function toString (val) {
  return val == null
    ? ''
    : Array.isArray(val) || (isPlainObject(val) && val.toString === _toString)
      ? JSON.stringify(val, null, 2)
      : String(val)
}

/**
 * Convert an input value to a number for persistence.
 * If the conversion fails, return original string.
 */
function toNumber (val) {
  var n = parseFloat(val);
  return isNaN(n) ? val : n
}

/**
 * Make a map and return a function for checking if a key
 * is in that map.
 */
function makeMap (
  str,
  expectsLowerCase
) {
  var map = Object.create(null);
  var list = str.split(',');
  for (var i = 0; i < list.length; i++) {
    map[list[i]] = true;
  }
  return expectsLowerCase
    ? function (val) { return map[val.toLowerCase()]; }
    : function (val) { return map[val]; }
}

/**
 * Check if a tag is a built-in tag.
 */
var isBuiltInTag = makeMap('slot,component', true);

/**
 * Check if an attribute is a reserved attribute.
 */
var isReservedAttribute = makeMap('key,ref,slot,slot-scope,is');

/**
 * Remove an item from an array.
 */
function remove (arr, item) {
  if (arr.length) {
    var index = arr.indexOf(item);
    if (index > -1) {
      return arr.splice(index, 1)
    }
  }
}

/**
 * Check whether an object has the property.
 */
var hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwn (obj, key) {
  return hasOwnProperty.call(obj, key)
}

/**
 * Create a cached version of a pure function.
 */
function cached (fn) {
  var cache = Object.create(null);
  return (function cachedFn (str) {
    var hit = cache[str];
    return hit || (cache[str] = fn(str))
  })
}

/**
 * Camelize a hyphen-delimited string.
 */
var camelizeRE = /-(\w)/g;
var camelize = cached(function (str) {
  return str.replace(camelizeRE, function (_, c) { return c ? c.toUpperCase() : ''; })
});

/**
 * Capitalize a string.
 */
var capitalize = cached(function (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
});

/**
 * Hyphenate a camelCase string.
 */
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = cached(function (str) {
  return str.replace(hyphenateRE, '-$1').toLowerCase()
});

/**
 * Simple bind polyfill for environments that do not support it,
 * e.g., PhantomJS 1.x. Technically, we don't need this anymore
 * since native bind is now performant enough in most browsers.
 * But removing it would mean breaking code that was able to run in
 * PhantomJS 1.x, so this must be kept for backward compatibility.
 */

/* istanbul ignore next */
function polyfillBind (fn, ctx) {
  function boundFn (a) {
    var l = arguments.length;
    return l
      ? l > 1
        ? fn.apply(ctx, arguments)
        : fn.call(ctx, a)
      : fn.call(ctx)
  }

  boundFn._length = fn.length;
  return boundFn
}

function nativeBind (fn, ctx) {
  return fn.bind(ctx)
}

var bind = Function.prototype.bind
  ? nativeBind
  : polyfillBind;

/**
 * Convert an Array-like object to a real Array.
 */
function toArray (list, start) {
  start = start || 0;
  var i = list.length - start;
  var ret = new Array(i);
  while (i--) {
    ret[i] = list[i + start];
  }
  return ret
}

/**
 * Mix properties into target object.
 */
function extend (to, _from) {
  for (var key in _from) {
    to[key] = _from[key];
  }
  return to
}

/**
 * Merge an Array of Objects into a single Object.
 */
function toObject (arr) {
  var res = {};
  for (var i = 0; i < arr.length; i++) {
    if (arr[i]) {
      extend(res, arr[i]);
    }
  }
  return res
}

/* eslint-disable no-unused-vars */

/**
 * Perform no operation.
 * Stubbing args to make Flow happy without leaving useless transpiled code
 * with ...rest (https://flow.org/blog/2017/05/07/Strict-Function-Call-Arity/).
 */
function noop (a, b, c) {}

/**
 * Always return false.
 */
var no = function (a, b, c) { return false; };

/* eslint-enable no-unused-vars */

/**
 * Return the same value.
 */
var identity = function (_) { return _; };

/**
 * Generate a string containing static keys from compiler modules.
 */
function genStaticKeys (modules) {
  return modules.reduce(function (keys, m) {
    return keys.concat(m.staticKeys || [])
  }, []).join(',')
}

/**
 * Check if two values are loosely equal - that is,
 * if they are plain objects, do they have the same shape?
 */
function looseEqual (a, b) {
  if (a === b) { return true }
  var isObjectA = isObject(a);
  var isObjectB = isObject(b);
  if (isObjectA && isObjectB) {
    try {
      var isArrayA = Array.isArray(a);
      var isArrayB = Array.isArray(b);
      if (isArrayA && isArrayB) {
        return a.length === b.length && a.every(function (e, i) {
          return looseEqual(e, b[i])
        })
      } else if (a instanceof Date && b instanceof Date) {
        return a.getTime() === b.getTime()
      } else if (!isArrayA && !isArrayB) {
        var keysA = Object.keys(a);
        var keysB = Object.keys(b);
        return keysA.length === keysB.length && keysA.every(function (key) {
          return looseEqual(a[key], b[key])
        })
      } else {
        /* istanbul ignore next */
        return false
      }
    } catch (e) {
      /* istanbul ignore next */
      return false
    }
  } else if (!isObjectA && !isObjectB) {
    return String(a) === String(b)
  } else {
    return false
  }
}

/**
 * Return the first index at which a loosely equal value can be
 * found in the array (if value is a plain object, the array must
 * contain an object of the same shape), or -1 if it is not present.
 */
function looseIndexOf (arr, val) {
  for (var i = 0; i < arr.length; i++) {
    if (looseEqual(arr[i], val)) { return i }
  }
  return -1
}

/**
 * Ensure a function is called only once.
 */
function once (fn) {
  var called = false;
  return function () {
    if (!called) {
      called = true;
      fn.apply(this, arguments);
    }
  }
}

var SSR_ATTR = 'data-server-rendered';

var ASSET_TYPES = [
  'component',
  'directive',
  'filter'
];

var LIFECYCLE_HOOKS = [
  'beforeCreate',
  'created',
  'beforeMount',
  'mounted',
  'beforeUpdate',
  'updated',
  'beforeDestroy',
  'destroyed',
  'activated',
  'deactivated',
  'errorCaptured',
  'serverPrefetch'
];

/*  */



var config = ({
  /**
   * Option merge strategies (used in core/util/options)
   */
  // $flow-disable-line
  optionMergeStrategies: Object.create(null),

  /**
   * Whether to suppress warnings.
   */
  silent: false,

  /**
   * Show production mode tip message on boot?
   */
  productionTip: "production" !== 'production',

  /**
   * Whether to enable devtools
   */
  devtools: "production" !== 'production',

  /**
   * Whether to record perf
   */
  performance: false,

  /**
   * Error handler for watcher errors
   */
  errorHandler: null,

  /**
   * Warn handler for watcher warns
   */
  warnHandler: null,

  /**
   * Ignore certain custom elements
   */
  ignoredElements: [],

  /**
   * Custom user key aliases for v-on
   */
  // $flow-disable-line
  keyCodes: Object.create(null),

  /**
   * Check if a tag is reserved so that it cannot be registered as a
   * component. This is platform-dependent and may be overwritten.
   */
  isReservedTag: no,

  /**
   * Check if an attribute is reserved so that it cannot be used as a component
   * prop. This is platform-dependent and may be overwritten.
   */
  isReservedAttr: no,

  /**
   * Check if a tag is an unknown element.
   * Platform-dependent.
   */
  isUnknownElement: no,

  /**
   * Get the namespace of an element
   */
  getTagNamespace: noop,

  /**
   * Parse the real tag name for the specific platform.
   */
  parsePlatformTagName: identity,

  /**
   * Check if an attribute must be bound using property, e.g. value
   * Platform-dependent.
   */
  mustUseProp: no,

  /**
   * Perform updates asynchronously. Intended to be used by Vue Test Utils
   * This will significantly reduce performance if set to false.
   */
  async: true,

  /**
   * Exposed for legacy reasons
   */
  _lifecycleHooks: LIFECYCLE_HOOKS
});

/*  */

/**
 * unicode letters used for parsing html tags, component names and property paths.
 * using https://www.w3.org/TR/html53/semantics-scripting.html#potentialcustomelementname
 * skipping \u10000-\uEFFFF due to it freezing up PhantomJS
 */
var unicodeRegExp = /a-zA-Z\u00B7\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u037D\u037F-\u1FFF\u200C-\u200D\u203F-\u2040\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD/;

/**
 * Check if a string starts with $ or _
 */
function isReserved (str) {
  var c = (str + '').charCodeAt(0);
  return c === 0x24 || c === 0x5F
}

/**
 * Define a property.
 */
function def (obj, key, val, enumerable) {
  Object.defineProperty(obj, key, {
    value: val,
    enumerable: !!enumerable,
    writable: true,
    configurable: true
  });
}

/**
 * Parse simple path.
 */
var bailRE = new RegExp(("[^" + (unicodeRegExp.source) + ".$_\\d]"));
function parsePath (path) {
  if (bailRE.test(path)) {
    return
  }
  var segments = path.split('.');
  return function (obj) {
    for (var i = 0; i < segments.length; i++) {
      if (!obj) { return }
      obj = obj[segments[i]];
    }
    return obj
  }
}

/*  */

// can we use __proto__?
var hasProto = '__proto__' in {};

// Browser environment sniffing
var inBrowser = typeof window !== 'undefined';
var inWeex = typeof WXEnvironment !== 'undefined' && !!WXEnvironment.platform;
var weexPlatform = inWeex && WXEnvironment.platform.toLowerCase();
var UA = inBrowser && window.navigator.userAgent.toLowerCase();
var isIE = UA && /msie|trident/.test(UA);
var isIE9 = UA && UA.indexOf('msie 9.0') > 0;
var isEdge = UA && UA.indexOf('edge/') > 0;
var isAndroid = (UA && UA.indexOf('android') > 0) || (weexPlatform === 'android');
var isIOS = (UA && /iphone|ipad|ipod|ios/.test(UA)) || (weexPlatform === 'ios');
var isChrome = UA && /chrome\/\d+/.test(UA) && !isEdge;
var isPhantomJS = UA && /phantomjs/.test(UA);
var isFF = UA && UA.match(/firefox\/(\d+)/);

// Firefox has a "watch" function on Object.prototype...
var nativeWatch = ({}).watch;

var supportsPassive = false;
if (inBrowser) {
  try {
    var opts = {};
    Object.defineProperty(opts, 'passive', ({
      get: function get () {
        /* istanbul ignore next */
        supportsPassive = true;
      }
    })); // https://github.com/facebook/flow/issues/285
    window.addEventListener('test-passive', null, opts);
  } catch (e) {}
}

// this needs to be lazy-evaled because vue may be required before
// vue-server-renderer can set VUE_ENV
var _isServer;
var isServerRendering = function () {
  if (_isServer === undefined) {
    /* istanbul ignore if */
    if (!inBrowser && !inWeex && typeof global !== 'undefined') {
      // detect presence of vue-server-renderer and avoid
      // Webpack shimming the process
      _isServer = global['process'] && global['process'].env.VUE_ENV === 'server';
    } else {
      _isServer = false;
    }
  }
  return _isServer
};

// detect devtools
var devtools = inBrowser && window.__VUE_DEVTOOLS_GLOBAL_HOOK__;

/* istanbul ignore next */
function isNative (Ctor) {
  return typeof Ctor === 'function' && /native code/.test(Ctor.toString())
}

var hasSymbol =
  typeof Symbol !== 'undefined' && isNative(Symbol) &&
  typeof Reflect !== 'undefined' && isNative(Reflect.ownKeys);

var _Set;
/* istanbul ignore if */ // $flow-disable-line
if (typeof Set !== 'undefined' && isNative(Set)) {
  // use native Set when available.
  _Set = Set;
} else {
  // a non-standard Set polyfill that only works with primitive keys.
  _Set = /*@__PURE__*/(function () {
    function Set () {
      this.set = Object.create(null);
    }
    Set.prototype.has = function has (key) {
      return this.set[key] === true
    };
    Set.prototype.add = function add (key) {
      this.set[key] = true;
    };
    Set.prototype.clear = function clear () {
      this.set = Object.create(null);
    };

    return Set;
  }());
}

/*  */

var warn = noop;
var tip = noop;
var generateComponentTrace = (noop); // work around flow check
var formatComponentName = (noop);

if (false) {
  var hasConsole = typeof console !== 'undefined';
  var classifyRE = /(?:^|[-_])(\w)/g;
  var classify = function (str) { return str
    .replace(classifyRE, function (c) { return c.toUpperCase(); })
    .replace(/[-_]/g, ''); };

  warn = function (msg, vm) {
    var trace = vm ? generateComponentTrace(vm) : '';

    if (config.warnHandler) {
      config.warnHandler.call(null, msg, vm, trace);
    } else if (hasConsole && (!config.silent)) {
      console.error(("[Vue warn]: " + msg + trace));
    }
  };

  tip = function (msg, vm) {
    if (hasConsole && (!config.silent)) {
      console.warn("[Vue tip]: " + msg + (
        vm ? generateComponentTrace(vm) : ''
      ));
    }
  };

  formatComponentName = function (vm, includeFile) {
    if (vm.$root === vm) {
      return '<Root>'
    }
    var options = typeof vm === 'function' && vm.cid != null
      ? vm.options
      : vm._isVue
        ? vm.$options || vm.constructor.options
        : vm;
    var name = options.name || options._componentTag;
    var file = options.__file;
    if (!name && file) {
      var match = file.match(/([^/\\]+)\.vue$/);
      name = match && match[1];
    }

    return (
      (name ? ("<" + (classify(name)) + ">") : "<Anonymous>") +
      (file && includeFile !== false ? (" at " + file) : '')
    )
  };

  var repeat = function (str, n) {
    var res = '';
    while (n) {
      if (n % 2 === 1) { res += str; }
      if (n > 1) { str += str; }
      n >>= 1;
    }
    return res
  };

  generateComponentTrace = function (vm) {
    if (vm._isVue && vm.$parent) {
      var tree = [];
      var currentRecursiveSequence = 0;
      while (vm) {
        if (tree.length > 0) {
          var last = tree[tree.length - 1];
          if (last.constructor === vm.constructor) {
            currentRecursiveSequence++;
            vm = vm.$parent;
            continue
          } else if (currentRecursiveSequence > 0) {
            tree[tree.length - 1] = [last, currentRecursiveSequence];
            currentRecursiveSequence = 0;
          }
        }
        tree.push(vm);
        vm = vm.$parent;
      }
      return '\n\nfound in\n\n' + tree
        .map(function (vm, i) { return ("" + (i === 0 ? '---> ' : repeat(' ', 5 + i * 2)) + (Array.isArray(vm)
            ? ((formatComponentName(vm[0])) + "... (" + (vm[1]) + " recursive calls)")
            : formatComponentName(vm))); })
        .join('\n')
    } else {
      return ("\n\n(found in " + (formatComponentName(vm)) + ")")
    }
  };
}

/*  */

var uid = 0;

/**
 * A dep is an observable that can have multiple
 * directives subscribing to it.
 */
var Dep = function Dep () {
  this.id = uid++;
  this.subs = [];
};

Dep.prototype.addSub = function addSub (sub) {
  this.subs.push(sub);
};

Dep.prototype.removeSub = function removeSub (sub) {
  remove(this.subs, sub);
};

Dep.prototype.depend = function depend () {
  if (Dep.target) {
    Dep.target.addDep(this);
  }
};

Dep.prototype.notify = function notify () {
  // stabilize the subscriber list first
  var subs = this.subs.slice();
  if (false) {
    // subs aren't sorted in scheduler if not running async
    // we need to sort them now to make sure they fire in correct
    // order
    subs.sort(function (a, b) { return a.id - b.id; });
  }
  for (var i = 0, l = subs.length; i < l; i++) {
    subs[i].update();
  }
};

// The current target watcher being evaluated.
// This is globally unique because only one watcher
// can be evaluated at a time.
Dep.target = null;
var targetStack = [];

function pushTarget (target) {
  targetStack.push(target);
  Dep.target = target;
}

function popTarget () {
  targetStack.pop();
  Dep.target = targetStack[targetStack.length - 1];
}

/*  */

var VNode = function VNode (
  tag,
  data,
  children,
  text,
  elm,
  context,
  componentOptions,
  asyncFactory
) {
  this.tag = tag;
  this.data = data;
  this.children = children;
  this.text = text;
  this.elm = elm;
  this.ns = undefined;
  this.context = context;
  this.fnContext = undefined;
  this.fnOptions = undefined;
  this.fnScopeId = undefined;
  this.key = data && data.key;
  this.componentOptions = componentOptions;
  this.componentInstance = undefined;
  this.parent = undefined;
  this.raw = false;
  this.isStatic = false;
  this.isRootInsert = true;
  this.isComment = false;
  this.isCloned = false;
  this.isOnce = false;
  this.asyncFactory = asyncFactory;
  this.asyncMeta = undefined;
  this.isAsyncPlaceholder = false;
};

var prototypeAccessors = { child: { configurable: true } };

// DEPRECATED: alias for componentInstance for backwards compat.
/* istanbul ignore next */
prototypeAccessors.child.get = function () {
  return this.componentInstance
};

Object.defineProperties( VNode.prototype, prototypeAccessors );

var createEmptyVNode = function (text) {
  if ( text === void 0 ) text = '';

  var node = new VNode();
  node.text = text;
  node.isComment = true;
  return node
};

function createTextVNode (val) {
  return new VNode(undefined, undefined, undefined, String(val))
}

// optimized shallow clone
// used for static nodes and slot nodes because they may be reused across
// multiple renders, cloning them avoids errors when DOM manipulations rely
// on their elm reference.
function cloneVNode (vnode) {
  var cloned = new VNode(
    vnode.tag,
    vnode.data,
    // #7975
    // clone children array to avoid mutating original in case of cloning
    // a child.
    vnode.children && vnode.children.slice(),
    vnode.text,
    vnode.elm,
    vnode.context,
    vnode.componentOptions,
    vnode.asyncFactory
  );
  cloned.ns = vnode.ns;
  cloned.isStatic = vnode.isStatic;
  cloned.key = vnode.key;
  cloned.isComment = vnode.isComment;
  cloned.fnContext = vnode.fnContext;
  cloned.fnOptions = vnode.fnOptions;
  cloned.fnScopeId = vnode.fnScopeId;
  cloned.asyncMeta = vnode.asyncMeta;
  cloned.isCloned = true;
  return cloned
}

/*
 * not type checking this file because flow doesn't play well with
 * dynamically accessing methods on Array prototype
 */

var arrayProto = Array.prototype;
var arrayMethods = Object.create(arrayProto);

var methodsToPatch = [
  'push',
  'pop',
  'shift',
  'unshift',
  'splice',
  'sort',
  'reverse'
];

/**
 * Intercept mutating methods and emit events
 */
methodsToPatch.forEach(function (method) {
  // cache original method
  var original = arrayProto[method];
  def(arrayMethods, method, function mutator () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    var result = original.apply(this, args);
    var ob = this.__ob__;
    var inserted;
    switch (method) {
      case 'push':
      case 'unshift':
        inserted = args;
        break
      case 'splice':
        inserted = args.slice(2);
        break
    }
    if (inserted) { ob.observeArray(inserted); }
    // notify change
    ob.dep.notify();
    return result
  });
});

/*  */

var arrayKeys = Object.getOwnPropertyNames(arrayMethods);

/**
 * In some cases we may want to disable observation inside a component's
 * update computation.
 */
var shouldObserve = true;

function toggleObserving (value) {
  shouldObserve = value;
}

/**
 * Observer class that is attached to each observed
 * object. Once attached, the observer converts the target
 * object's property keys into getter/setters that
 * collect dependencies and dispatch updates.
 */
var Observer = function Observer (value) {
  this.value = value;
  this.dep = new Dep();
  this.vmCount = 0;
  def(value, '__ob__', this);
  if (Array.isArray(value)) {
    if (hasProto) {
      protoAugment(value, arrayMethods);
    } else {
      copyAugment(value, arrayMethods, arrayKeys);
    }
    this.observeArray(value);
  } else {
    this.walk(value);
  }
};

/**
 * Walk through all properties and convert them into
 * getter/setters. This method should only be called when
 * value type is Object.
 */
Observer.prototype.walk = function walk (obj) {
  var keys = Object.keys(obj);
  for (var i = 0; i < keys.length; i++) {
    defineReactive$$1(obj, keys[i]);
  }
};

/**
 * Observe a list of Array items.
 */
Observer.prototype.observeArray = function observeArray (items) {
  for (var i = 0, l = items.length; i < l; i++) {
    observe(items[i]);
  }
};

// helpers

/**
 * Augment a target Object or Array by intercepting
 * the prototype chain using __proto__
 */
function protoAugment (target, src) {
  /* eslint-disable no-proto */
  target.__proto__ = src;
  /* eslint-enable no-proto */
}

/**
 * Augment a target Object or Array by defining
 * hidden properties.
 */
/* istanbul ignore next */
function copyAugment (target, src, keys) {
  for (var i = 0, l = keys.length; i < l; i++) {
    var key = keys[i];
    def(target, key, src[key]);
  }
}

/**
 * Attempt to create an observer instance for a value,
 * returns the new observer if successfully observed,
 * or the existing observer if the value already has one.
 */
function observe (value, asRootData) {
  if (!isObject(value) || value instanceof VNode) {
    return
  }
  var ob;
  if (hasOwn(value, '__ob__') && value.__ob__ instanceof Observer) {
    ob = value.__ob__;
  } else if (
    shouldObserve &&
    !isServerRendering() &&
    (Array.isArray(value) || isPlainObject(value)) &&
    Object.isExtensible(value) &&
    !value._isVue
  ) {
    ob = new Observer(value);
  }
  if (asRootData && ob) {
    ob.vmCount++;
  }
  return ob
}

/**
 * Define a reactive property on an Object.
 */
function defineReactive$$1 (
  obj,
  key,
  val,
  customSetter,
  shallow
) {
  var dep = new Dep();

  var property = Object.getOwnPropertyDescriptor(obj, key);
  if (property && property.configurable === false) {
    return
  }

  // cater for pre-defined getter/setters
  var getter = property && property.get;
  var setter = property && property.set;
  if ((!getter || setter) && arguments.length === 2) {
    val = obj[key];
  }

  var childOb = !shallow && observe(val);
  Object.defineProperty(obj, key, {
    enumerable: true,
    configurable: true,
    get: function reactiveGetter () {
      var value = getter ? getter.call(obj) : val;
      if (Dep.target) {
        dep.depend();
        if (childOb) {
          childOb.dep.depend();
          if (Array.isArray(value)) {
            dependArray(value);
          }
        }
      }
      return value
    },
    set: function reactiveSetter (newVal) {
      var value = getter ? getter.call(obj) : val;
      /* eslint-disable no-self-compare */
      if (newVal === value || (newVal !== newVal && value !== value)) {
        return
      }
      /* eslint-enable no-self-compare */
      if (false) {
        customSetter();
      }
      // #7981: for accessor properties without setter
      if (getter && !setter) { return }
      if (setter) {
        setter.call(obj, newVal);
      } else {
        val = newVal;
      }
      childOb = !shallow && observe(newVal);
      dep.notify();
    }
  });
}

/**
 * Set a property on an object. Adds the new property and
 * triggers change notification if the property doesn't
 * already exist.
 */
function set (target, key, val) {
  if (false
  ) {
    warn(("Cannot set reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.length = Math.max(target.length, key);
    target.splice(key, 1, val);
    return val
  }
  if (key in target && !(key in Object.prototype)) {
    target[key] = val;
    return val
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid adding reactive properties to a Vue instance or its root $data ' +
      'at runtime - declare it upfront in the data option.'
    );
    return val
  }
  if (!ob) {
    target[key] = val;
    return val
  }
  defineReactive$$1(ob.value, key, val);
  ob.dep.notify();
  return val
}

/**
 * Delete a property and trigger change if necessary.
 */
function del (target, key) {
  if (false
  ) {
    warn(("Cannot delete reactive property on undefined, null, or primitive value: " + ((target))));
  }
  if (Array.isArray(target) && isValidArrayIndex(key)) {
    target.splice(key, 1);
    return
  }
  var ob = (target).__ob__;
  if (target._isVue || (ob && ob.vmCount)) {
    "production" !== 'production' && warn(
      'Avoid deleting properties on a Vue instance or its root $data ' +
      '- just set it to null.'
    );
    return
  }
  if (!hasOwn(target, key)) {
    return
  }
  delete target[key];
  if (!ob) {
    return
  }
  ob.dep.notify();
}

/**
 * Collect dependencies on array elements when the array is touched, since
 * we cannot intercept array element access like property getters.
 */
function dependArray (value) {
  for (var e = (void 0), i = 0, l = value.length; i < l; i++) {
    e = value[i];
    e && e.__ob__ && e.__ob__.dep.depend();
    if (Array.isArray(e)) {
      dependArray(e);
    }
  }
}

/*  */

/**
 * Option overwriting strategies are functions that handle
 * how to merge a parent option value and a child option
 * value into the final value.
 */
var strats = config.optionMergeStrategies;

/**
 * Options with restrictions
 */
if (false) {
  strats.el = strats.propsData = function (parent, child, vm, key) {
    if (!vm) {
      warn(
        "option \"" + key + "\" can only be used during instance " +
        'creation with the `new` keyword.'
      );
    }
    return defaultStrat(parent, child)
  };
}

/**
 * Helper that recursively merges two data objects together.
 */
function mergeData (to, from) {
  if (!from) { return to }
  var key, toVal, fromVal;

  var keys = hasSymbol
    ? Reflect.ownKeys(from)
    : Object.keys(from);

  for (var i = 0; i < keys.length; i++) {
    key = keys[i];
    // in case the object is already observed...
    if (key === '__ob__') { continue }
    toVal = to[key];
    fromVal = from[key];
    if (!hasOwn(to, key)) {
      set(to, key, fromVal);
    } else if (
      toVal !== fromVal &&
      isPlainObject(toVal) &&
      isPlainObject(fromVal)
    ) {
      mergeData(toVal, fromVal);
    }
  }
  return to
}

/**
 * Data
 */
function mergeDataOrFn (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    // in a Vue.extend merge, both should be functions
    if (!childVal) {
      return parentVal
    }
    if (!parentVal) {
      return childVal
    }
    // when parentVal & childVal are both present,
    // we need to return a function that returns the
    // merged result of both functions... no need to
    // check if parentVal is a function here because
    // it has to be a function to pass previous merges.
    return function mergedDataFn () {
      return mergeData(
        typeof childVal === 'function' ? childVal.call(this, this) : childVal,
        typeof parentVal === 'function' ? parentVal.call(this, this) : parentVal
      )
    }
  } else {
    return function mergedInstanceDataFn () {
      // instance merge
      var instanceData = typeof childVal === 'function'
        ? childVal.call(vm, vm)
        : childVal;
      var defaultData = typeof parentVal === 'function'
        ? parentVal.call(vm, vm)
        : parentVal;
      if (instanceData) {
        return mergeData(instanceData, defaultData)
      } else {
        return defaultData
      }
    }
  }
}

strats.data = function (
  parentVal,
  childVal,
  vm
) {
  if (!vm) {
    if (childVal && typeof childVal !== 'function') {
      "production" !== 'production' && warn(
        'The "data" option should be a function ' +
        'that returns a per-instance value in component ' +
        'definitions.',
        vm
      );

      return parentVal
    }
    return mergeDataOrFn(parentVal, childVal)
  }

  return mergeDataOrFn(parentVal, childVal, vm)
};

/**
 * Hooks and props are merged as arrays.
 */
function mergeHook (
  parentVal,
  childVal
) {
  var res = childVal
    ? parentVal
      ? parentVal.concat(childVal)
      : Array.isArray(childVal)
        ? childVal
        : [childVal]
    : parentVal;
  return res
    ? dedupeHooks(res)
    : res
}

function dedupeHooks (hooks) {
  var res = [];
  for (var i = 0; i < hooks.length; i++) {
    if (res.indexOf(hooks[i]) === -1) {
      res.push(hooks[i]);
    }
  }
  return res
}

LIFECYCLE_HOOKS.forEach(function (hook) {
  strats[hook] = mergeHook;
});

/**
 * Assets
 *
 * When a vm is present (instance creation), we need to do
 * a three-way merge between constructor options, instance
 * options and parent options.
 */
function mergeAssets (
  parentVal,
  childVal,
  vm,
  key
) {
  var res = Object.create(parentVal || null);
  if (childVal) {
    "production" !== 'production' && assertObjectType(key, childVal, vm);
    return extend(res, childVal)
  } else {
    return res
  }
}

ASSET_TYPES.forEach(function (type) {
  strats[type + 's'] = mergeAssets;
});

/**
 * Watchers.
 *
 * Watchers hashes should not overwrite one
 * another, so we merge them as arrays.
 */
strats.watch = function (
  parentVal,
  childVal,
  vm,
  key
) {
  // work around Firefox's Object.prototype.watch...
  if (parentVal === nativeWatch) { parentVal = undefined; }
  if (childVal === nativeWatch) { childVal = undefined; }
  /* istanbul ignore if */
  if (!childVal) { return Object.create(parentVal || null) }
  if (false) {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = {};
  extend(ret, parentVal);
  for (var key$1 in childVal) {
    var parent = ret[key$1];
    var child = childVal[key$1];
    if (parent && !Array.isArray(parent)) {
      parent = [parent];
    }
    ret[key$1] = parent
      ? parent.concat(child)
      : Array.isArray(child) ? child : [child];
  }
  return ret
};

/**
 * Other object hashes.
 */
strats.props =
strats.methods =
strats.inject =
strats.computed = function (
  parentVal,
  childVal,
  vm,
  key
) {
  if (childVal && "production" !== 'production') {
    assertObjectType(key, childVal, vm);
  }
  if (!parentVal) { return childVal }
  var ret = Object.create(null);
  extend(ret, parentVal);
  if (childVal) { extend(ret, childVal); }
  return ret
};
strats.provide = mergeDataOrFn;

/**
 * Default strategy.
 */
var defaultStrat = function (parentVal, childVal) {
  return childVal === undefined
    ? parentVal
    : childVal
};

/**
 * Validate component names
 */
function checkComponents (options) {
  for (var key in options.components) {
    validateComponentName(key);
  }
}

function validateComponentName (name) {
  if (!new RegExp(("^[a-zA-Z][\\-\\.0-9_" + (unicodeRegExp.source) + "]*$")).test(name)) {
    warn(
      'Invalid component name: "' + name + '". Component names ' +
      'should conform to valid custom element name in html5 specification.'
    );
  }
  if (isBuiltInTag(name) || config.isReservedTag(name)) {
    warn(
      'Do not use built-in or reserved HTML elements as component ' +
      'id: ' + name
    );
  }
}

/**
 * Ensure all props option syntax are normalized into the
 * Object-based format.
 */
function normalizeProps (options, vm) {
  var props = options.props;
  if (!props) { return }
  var res = {};
  var i, val, name;
  if (Array.isArray(props)) {
    i = props.length;
    while (i--) {
      val = props[i];
      if (typeof val === 'string') {
        name = camelize(val);
        res[name] = { type: null };
      } else if (false) {
        warn('props must be strings when using array syntax.');
      }
    }
  } else if (isPlainObject(props)) {
    for (var key in props) {
      val = props[key];
      name = camelize(key);
      res[name] = isPlainObject(val)
        ? val
        : { type: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"props\": expected an Array or an Object, " +
      "but got " + (toRawType(props)) + ".",
      vm
    );
  }
  options.props = res;
}

/**
 * Normalize all injections into Object-based format
 */
function normalizeInject (options, vm) {
  var inject = options.inject;
  if (!inject) { return }
  var normalized = options.inject = {};
  if (Array.isArray(inject)) {
    for (var i = 0; i < inject.length; i++) {
      normalized[inject[i]] = { from: inject[i] };
    }
  } else if (isPlainObject(inject)) {
    for (var key in inject) {
      var val = inject[key];
      normalized[key] = isPlainObject(val)
        ? extend({ from: key }, val)
        : { from: val };
    }
  } else if (false) {
    warn(
      "Invalid value for option \"inject\": expected an Array or an Object, " +
      "but got " + (toRawType(inject)) + ".",
      vm
    );
  }
}

/**
 * Normalize raw function directives into object format.
 */
function normalizeDirectives (options) {
  var dirs = options.directives;
  if (dirs) {
    for (var key in dirs) {
      var def$$1 = dirs[key];
      if (typeof def$$1 === 'function') {
        dirs[key] = { bind: def$$1, update: def$$1 };
      }
    }
  }
}

function assertObjectType (name, value, vm) {
  if (!isPlainObject(value)) {
    warn(
      "Invalid value for option \"" + name + "\": expected an Object, " +
      "but got " + (toRawType(value)) + ".",
      vm
    );
  }
}

/**
 * Merge two option objects into a new one.
 * Core utility used in both instantiation and inheritance.
 */
function mergeOptions (
  parent,
  child,
  vm
) {
  if (false) {
    checkComponents(child);
  }

  if (typeof child === 'function') {
    child = child.options;
  }

  normalizeProps(child, vm);
  normalizeInject(child, vm);
  normalizeDirectives(child);

  // Apply extends and mixins on the child options,
  // but only if it is a raw options object that isn't
  // the result of another mergeOptions call.
  // Only merged options has the _base property.
  if (!child._base) {
    if (child.extends) {
      parent = mergeOptions(parent, child.extends, vm);
    }
    if (child.mixins) {
      for (var i = 0, l = child.mixins.length; i < l; i++) {
        parent = mergeOptions(parent, child.mixins[i], vm);
      }
    }
  }

  var options = {};
  var key;
  for (key in parent) {
    mergeField(key);
  }
  for (key in child) {
    if (!hasOwn(parent, key)) {
      mergeField(key);
    }
  }
  function mergeField (key) {
    var strat = strats[key] || defaultStrat;
    options[key] = strat(parent[key], child[key], vm, key);
  }
  return options
}

/**
 * Resolve an asset.
 * This function is used because child instances need access
 * to assets defined in its ancestor chain.
 */
function resolveAsset (
  options,
  type,
  id,
  warnMissing
) {
  /* istanbul ignore if */
  if (typeof id !== 'string') {
    return
  }
  var assets = options[type];
  // check local registration variations first
  if (hasOwn(assets, id)) { return assets[id] }
  var camelizedId = camelize(id);
  if (hasOwn(assets, camelizedId)) { return assets[camelizedId] }
  var PascalCaseId = capitalize(camelizedId);
  if (hasOwn(assets, PascalCaseId)) { return assets[PascalCaseId] }
  // fallback to prototype chain
  var res = assets[id] || assets[camelizedId] || assets[PascalCaseId];
  if (false) {
    warn(
      'Failed to resolve ' + type.slice(0, -1) + ': ' + id,
      options
    );
  }
  return res
}

/*  */



function validateProp (
  key,
  propOptions,
  propsData,
  vm
) {
  var prop = propOptions[key];
  var absent = !hasOwn(propsData, key);
  var value = propsData[key];
  // boolean casting
  var booleanIndex = getTypeIndex(Boolean, prop.type);
  if (booleanIndex > -1) {
    if (absent && !hasOwn(prop, 'default')) {
      value = false;
    } else if (value === '' || value === hyphenate(key)) {
      // only cast empty string / same name to boolean if
      // boolean has higher priority
      var stringIndex = getTypeIndex(String, prop.type);
      if (stringIndex < 0 || booleanIndex < stringIndex) {
        value = true;
      }
    }
  }
  // check default value
  if (value === undefined) {
    value = getPropDefaultValue(vm, prop, key);
    // since the default value is a fresh copy,
    // make sure to observe it.
    var prevShouldObserve = shouldObserve;
    toggleObserving(true);
    observe(value);
    toggleObserving(prevShouldObserve);
  }
  if (
    false
  ) {
    assertProp(prop, key, value, vm, absent);
  }
  return value
}

/**
 * Get the default value of a prop.
 */
function getPropDefaultValue (vm, prop, key) {
  // no default, return undefined
  if (!hasOwn(prop, 'default')) {
    return undefined
  }
  var def = prop.default;
  // warn against non-factory defaults for Object & Array
  if (false) {
    warn(
      'Invalid default value for prop "' + key + '": ' +
      'Props with type Object/Array must use a factory function ' +
      'to return the default value.',
      vm
    );
  }
  // the raw prop value was also undefined from previous render,
  // return previous default value to avoid unnecessary watcher trigger
  if (vm && vm.$options.propsData &&
    vm.$options.propsData[key] === undefined &&
    vm._props[key] !== undefined
  ) {
    return vm._props[key]
  }
  // call factory function for non-Function types
  // a value is Function if its prototype is function even across different execution context
  return typeof def === 'function' && getType(prop.type) !== 'Function'
    ? def.call(vm)
    : def
}

/**
 * Assert whether a prop is valid.
 */
function assertProp (
  prop,
  name,
  value,
  vm,
  absent
) {
  if (prop.required && absent) {
    warn(
      'Missing required prop: "' + name + '"',
      vm
    );
    return
  }
  if (value == null && !prop.required) {
    return
  }
  var type = prop.type;
  var valid = !type || type === true;
  var expectedTypes = [];
  if (type) {
    if (!Array.isArray(type)) {
      type = [type];
    }
    for (var i = 0; i < type.length && !valid; i++) {
      var assertedType = assertType(value, type[i]);
      expectedTypes.push(assertedType.expectedType || '');
      valid = assertedType.valid;
    }
  }

  if (!valid) {
    warn(
      getInvalidTypeMessage(name, value, expectedTypes),
      vm
    );
    return
  }
  var validator = prop.validator;
  if (validator) {
    if (!validator(value)) {
      warn(
        'Invalid prop: custom validator check failed for prop "' + name + '".',
        vm
      );
    }
  }
}

var simpleCheckRE = /^(String|Number|Boolean|Function|Symbol)$/;

function assertType (value, type) {
  var valid;
  var expectedType = getType(type);
  if (simpleCheckRE.test(expectedType)) {
    var t = typeof value;
    valid = t === expectedType.toLowerCase();
    // for primitive wrapper objects
    if (!valid && t === 'object') {
      valid = value instanceof type;
    }
  } else if (expectedType === 'Object') {
    valid = isPlainObject(value);
  } else if (expectedType === 'Array') {
    valid = Array.isArray(value);
  } else {
    valid = value instanceof type;
  }
  return {
    valid: valid,
    expectedType: expectedType
  }
}

/**
 * Use function string name to check built-in types,
 * because a simple equality check will fail when running
 * across different vms / iframes.
 */
function getType (fn) {
  var match = fn && fn.toString().match(/^\s*function (\w+)/);
  return match ? match[1] : ''
}

function isSameType (a, b) {
  return getType(a) === getType(b)
}

function getTypeIndex (type, expectedTypes) {
  if (!Array.isArray(expectedTypes)) {
    return isSameType(expectedTypes, type) ? 0 : -1
  }
  for (var i = 0, len = expectedTypes.length; i < len; i++) {
    if (isSameType(expectedTypes[i], type)) {
      return i
    }
  }
  return -1
}

function getInvalidTypeMessage (name, value, expectedTypes) {
  var message = "Invalid prop: type check failed for prop \"" + name + "\"." +
    " Expected " + (expectedTypes.map(capitalize).join(', '));
  var expectedType = expectedTypes[0];
  var receivedType = toRawType(value);
  var expectedValue = styleValue(value, expectedType);
  var receivedValue = styleValue(value, receivedType);
  // check if we need to specify expected value
  if (expectedTypes.length === 1 &&
      isExplicable(expectedType) &&
      !isBoolean(expectedType, receivedType)) {
    message += " with value " + expectedValue;
  }
  message += ", got " + receivedType + " ";
  // check if we need to specify received value
  if (isExplicable(receivedType)) {
    message += "with value " + receivedValue + ".";
  }
  return message
}

function styleValue (value, type) {
  if (type === 'String') {
    return ("\"" + value + "\"")
  } else if (type === 'Number') {
    return ("" + (Number(value)))
  } else {
    return ("" + value)
  }
}

function isExplicable (value) {
  var explicitTypes = ['string', 'number', 'boolean'];
  return explicitTypes.some(function (elem) { return value.toLowerCase() === elem; })
}

function isBoolean () {
  var args = [], len = arguments.length;
  while ( len-- ) args[ len ] = arguments[ len ];

  return args.some(function (elem) { return elem.toLowerCase() === 'boolean'; })
}

/*  */

function handleError (err, vm, info) {
  // Deactivate deps tracking while processing error handler to avoid possible infinite rendering.
  // See: https://github.com/vuejs/vuex/issues/1505
  pushTarget();
  try {
    if (vm) {
      var cur = vm;
      while ((cur = cur.$parent)) {
        var hooks = cur.$options.errorCaptured;
        if (hooks) {
          for (var i = 0; i < hooks.length; i++) {
            try {
              var capture = hooks[i].call(cur, err, vm, info) === false;
              if (capture) { return }
            } catch (e) {
              globalHandleError(e, cur, 'errorCaptured hook');
            }
          }
        }
      }
    }
    globalHandleError(err, vm, info);
  } finally {
    popTarget();
  }
}

function invokeWithErrorHandling (
  handler,
  context,
  args,
  vm,
  info
) {
  var res;
  try {
    res = args ? handler.apply(context, args) : handler.call(context);
    if (res && !res._isVue && isPromise(res) && !res._handled) {
      res.catch(function (e) { return handleError(e, vm, info + " (Promise/async)"); });
      // issue #9511
      // avoid catch triggering multiple times when nested calls
      res._handled = true;
    }
  } catch (e) {
    handleError(e, vm, info);
  }
  return res
}

function globalHandleError (err, vm, info) {
  if (config.errorHandler) {
    try {
      return config.errorHandler.call(null, err, vm, info)
    } catch (e) {
      // if the user intentionally throws the original error in the handler,
      // do not log it twice
      if (e !== err) {
        logError(e, null, 'config.errorHandler');
      }
    }
  }
  logError(err, vm, info);
}

function logError (err, vm, info) {
  if (false) {
    warn(("Error in " + info + ": \"" + (err.toString()) + "\""), vm);
  }
  /* istanbul ignore else */
  if ((inBrowser || inWeex) && typeof console !== 'undefined') {
    console.error(err);
  } else {
    throw err
  }
}

/*  */

var isUsingMicroTask = false;

var callbacks = [];
var pending = false;

function flushCallbacks () {
  pending = false;
  var copies = callbacks.slice(0);
  callbacks.length = 0;
  for (var i = 0; i < copies.length; i++) {
    copies[i]();
  }
}

// Here we have async deferring wrappers using microtasks.
// In 2.5 we used (macro) tasks (in combination with microtasks).
// However, it has subtle problems when state is changed right before repaint
// (e.g. #6813, out-in transitions).
// Also, using (macro) tasks in event handler would cause some weird behaviors
// that cannot be circumvented (e.g. #7109, #7153, #7546, #7834, #8109).
// So we now use microtasks everywhere, again.
// A major drawback of this tradeoff is that there are some scenarios
// where microtasks have too high a priority and fire in between supposedly
// sequential events (e.g. #4521, #6690, which have workarounds)
// or even between bubbling of the same event (#6566).
var timerFunc;

// The nextTick behavior leverages the microtask queue, which can be accessed
// via either native Promise.then or MutationObserver.
// MutationObserver has wider support, however it is seriously bugged in
// UIWebView in iOS >= 9.3.3 when triggered in touch event handlers. It
// completely stops working after triggering a few times... so, if native
// Promise is available, we will use it:
/* istanbul ignore next, $flow-disable-line */
if (typeof Promise !== 'undefined' && isNative(Promise)) {
  var p = Promise.resolve();
  timerFunc = function () {
    p.then(flushCallbacks);
    // In problematic UIWebViews, Promise.then doesn't completely break, but
    // it can get stuck in a weird state where callbacks are pushed into the
    // microtask queue but the queue isn't being flushed, until the browser
    // needs to do some other work, e.g. handle a timer. Therefore we can
    // "force" the microtask queue to be flushed by adding an empty timer.
    if (isIOS) { setTimeout(noop); }
  };
  isUsingMicroTask = true;
} else if (!isIE && typeof MutationObserver !== 'undefined' && (
  isNative(MutationObserver) ||
  // PhantomJS and iOS 7.x
  MutationObserver.toString() === '[object MutationObserverConstructor]'
)) {
  // Use MutationObserver where native Promise is not available,
  // e.g. PhantomJS, iOS7, Android 4.4
  // (#6466 MutationObserver is unreliable in IE11)
  var counter = 1;
  var observer = new MutationObserver(flushCallbacks);
  var textNode = document.createTextNode(String(counter));
  observer.observe(textNode, {
    characterData: true
  });
  timerFunc = function () {
    counter = (counter + 1) % 2;
    textNode.data = String(counter);
  };
  isUsingMicroTask = true;
} else if (typeof setImmediate !== 'undefined' && isNative(setImmediate)) {
  // Fallback to setImmediate.
  // Technically it leverages the (macro) task queue,
  // but it is still a better choice than setTimeout.
  timerFunc = function () {
    setImmediate(flushCallbacks);
  };
} else {
  // Fallback to setTimeout.
  timerFunc = function () {
    setTimeout(flushCallbacks, 0);
  };
}

function nextTick (cb, ctx) {
  var _resolve;
  callbacks.push(function () {
    if (cb) {
      try {
        cb.call(ctx);
      } catch (e) {
        handleError(e, ctx, 'nextTick');
      }
    } else if (_resolve) {
      _resolve(ctx);
    }
  });
  if (!pending) {
    pending = true;
    timerFunc();
  }
  // $flow-disable-line
  if (!cb && typeof Promise !== 'undefined') {
    return new Promise(function (resolve) {
      _resolve = resolve;
    })
  }
}

/*  */

var mark;
var measure;

if (false) {
  var perf = inBrowser && window.performance;
  /* istanbul ignore if */
  if (
    perf &&
    perf.mark &&
    perf.measure &&
    perf.clearMarks &&
    perf.clearMeasures
  ) {
    mark = function (tag) { return perf.mark(tag); };
    measure = function (name, startTag, endTag) {
      perf.measure(name, startTag, endTag);
      perf.clearMarks(startTag);
      perf.clearMarks(endTag);
      // perf.clearMeasures(name)
    };
  }
}

/* not type checking this file because flow doesn't play well with Proxy */

var initProxy;

if (false) {
  var allowedGlobals = makeMap(
    'Infinity,undefined,NaN,isFinite,isNaN,' +
    'parseFloat,parseInt,decodeURI,decodeURIComponent,encodeURI,encodeURIComponent,' +
    'Math,Number,Date,Array,Object,Boolean,String,RegExp,Map,Set,JSON,Intl,' +
    'require' // for Webpack/Browserify
  );

  var warnNonPresent = function (target, key) {
    warn(
      "Property or method \"" + key + "\" is not defined on the instance but " +
      'referenced during render. Make sure that this property is reactive, ' +
      'either in the data option, or for class-based components, by ' +
      'initializing the property. ' +
      'See: https://vuejs.org/v2/guide/reactivity.html#Declaring-Reactive-Properties.',
      target
    );
  };

  var warnReservedPrefix = function (target, key) {
    warn(
      "Property \"" + key + "\" must be accessed with \"$data." + key + "\" because " +
      'properties starting with "$" or "_" are not proxied in the Vue instance to ' +
      'prevent conflicts with Vue internals. ' +
      'See: https://vuejs.org/v2/api/#data',
      target
    );
  };

  var hasProxy =
    typeof Proxy !== 'undefined' && isNative(Proxy);

  if (hasProxy) {
    var isBuiltInModifier = makeMap('stop,prevent,self,ctrl,shift,alt,meta,exact');
    config.keyCodes = new Proxy(config.keyCodes, {
      set: function set (target, key, value) {
        if (isBuiltInModifier(key)) {
          warn(("Avoid overwriting built-in modifier in config.keyCodes: ." + key));
          return false
        } else {
          target[key] = value;
          return true
        }
      }
    });
  }

  var hasHandler = {
    has: function has (target, key) {
      var has = key in target;
      var isAllowed = allowedGlobals(key) ||
        (typeof key === 'string' && key.charAt(0) === '_' && !(key in target.$data));
      if (!has && !isAllowed) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return has || !isAllowed
    }
  };

  var getHandler = {
    get: function get (target, key) {
      if (typeof key === 'string' && !(key in target)) {
        if (key in target.$data) { warnReservedPrefix(target, key); }
        else { warnNonPresent(target, key); }
      }
      return target[key]
    }
  };

  initProxy = function initProxy (vm) {
    if (hasProxy) {
      // determine which proxy handler to use
      var options = vm.$options;
      var handlers = options.render && options.render._withStripped
        ? getHandler
        : hasHandler;
      vm._renderProxy = new Proxy(vm, handlers);
    } else {
      vm._renderProxy = vm;
    }
  };
}

/*  */

var seenObjects = new _Set();

/**
 * Recursively traverse an object to evoke all converted
 * getters, so that every nested property inside the object
 * is collected as a "deep" dependency.
 */
function traverse (val) {
  _traverse(val, seenObjects);
  seenObjects.clear();
}

function _traverse (val, seen) {
  var i, keys;
  var isA = Array.isArray(val);
  if ((!isA && !isObject(val)) || Object.isFrozen(val) || val instanceof VNode) {
    return
  }
  if (val.__ob__) {
    var depId = val.__ob__.dep.id;
    if (seen.has(depId)) {
      return
    }
    seen.add(depId);
  }
  if (isA) {
    i = val.length;
    while (i--) { _traverse(val[i], seen); }
  } else {
    keys = Object.keys(val);
    i = keys.length;
    while (i--) { _traverse(val[keys[i]], seen); }
  }
}

/*  */

var normalizeEvent = cached(function (name) {
  var passive = name.charAt(0) === '&';
  name = passive ? name.slice(1) : name;
  var once$$1 = name.charAt(0) === '~'; // Prefixed last, checked first
  name = once$$1 ? name.slice(1) : name;
  var capture = name.charAt(0) === '!';
  name = capture ? name.slice(1) : name;
  return {
    name: name,
    once: once$$1,
    capture: capture,
    passive: passive
  }
});

function createFnInvoker (fns, vm) {
  function invoker () {
    var arguments$1 = arguments;

    var fns = invoker.fns;
    if (Array.isArray(fns)) {
      var cloned = fns.slice();
      for (var i = 0; i < cloned.length; i++) {
        invokeWithErrorHandling(cloned[i], null, arguments$1, vm, "v-on handler");
      }
    } else {
      // return handler return value for single handlers
      return invokeWithErrorHandling(fns, null, arguments, vm, "v-on handler")
    }
  }
  invoker.fns = fns;
  return invoker
}

function updateListeners (
  on,
  oldOn,
  add,
  remove$$1,
  createOnceHandler,
  vm
) {
  var name, def$$1, cur, old, event;
  for (name in on) {
    def$$1 = cur = on[name];
    old = oldOn[name];
    event = normalizeEvent(name);
    if (isUndef(cur)) {
      "production" !== 'production' && warn(
        "Invalid handler for event \"" + (event.name) + "\": got " + String(cur),
        vm
      );
    } else if (isUndef(old)) {
      if (isUndef(cur.fns)) {
        cur = on[name] = createFnInvoker(cur, vm);
      }
      if (isTrue(event.once)) {
        cur = on[name] = createOnceHandler(event.name, cur, event.capture);
      }
      add(event.name, cur, event.capture, event.passive, event.params);
    } else if (cur !== old) {
      old.fns = cur;
      on[name] = old;
    }
  }
  for (name in oldOn) {
    if (isUndef(on[name])) {
      event = normalizeEvent(name);
      remove$$1(event.name, oldOn[name], event.capture);
    }
  }
}

/*  */

function mergeVNodeHook (def, hookKey, hook) {
  if (def instanceof VNode) {
    def = def.data.hook || (def.data.hook = {});
  }
  var invoker;
  var oldHook = def[hookKey];

  function wrappedHook () {
    hook.apply(this, arguments);
    // important: remove merged hook to ensure it's called only once
    // and prevent memory leak
    remove(invoker.fns, wrappedHook);
  }

  if (isUndef(oldHook)) {
    // no existing hook
    invoker = createFnInvoker([wrappedHook]);
  } else {
    /* istanbul ignore if */
    if (isDef(oldHook.fns) && isTrue(oldHook.merged)) {
      // already a merged invoker
      invoker = oldHook;
      invoker.fns.push(wrappedHook);
    } else {
      // existing plain hook
      invoker = createFnInvoker([oldHook, wrappedHook]);
    }
  }

  invoker.merged = true;
  def[hookKey] = invoker;
}

/*  */

function extractPropsFromVNodeData (
  data,
  Ctor,
  tag
) {
  // we are only extracting raw values here.
  // validation and default values are handled in the child
  // component itself.
  var propOptions = Ctor.options.props;
  if (isUndef(propOptions)) {
    return
  }
  var res = {};
  var attrs = data.attrs;
  var props = data.props;
  if (isDef(attrs) || isDef(props)) {
    for (var key in propOptions) {
      var altKey = hyphenate(key);
      if (false) {
        var keyInLowerCase = key.toLowerCase();
        if (
          key !== keyInLowerCase &&
          attrs && hasOwn(attrs, keyInLowerCase)
        ) {
          tip(
            "Prop \"" + keyInLowerCase + "\" is passed to component " +
            (formatComponentName(tag || Ctor)) + ", but the declared prop name is" +
            " \"" + key + "\". " +
            "Note that HTML attributes are case-insensitive and camelCased " +
            "props need to use their kebab-case equivalents when using in-DOM " +
            "templates. You should probably use \"" + altKey + "\" instead of \"" + key + "\"."
          );
        }
      }
      checkProp(res, props, key, altKey, true) ||
      checkProp(res, attrs, key, altKey, false);
    }
  }
  return res
}

function checkProp (
  res,
  hash,
  key,
  altKey,
  preserve
) {
  if (isDef(hash)) {
    if (hasOwn(hash, key)) {
      res[key] = hash[key];
      if (!preserve) {
        delete hash[key];
      }
      return true
    } else if (hasOwn(hash, altKey)) {
      res[key] = hash[altKey];
      if (!preserve) {
        delete hash[altKey];
      }
      return true
    }
  }
  return false
}

/*  */

// The template compiler attempts to minimize the need for normalization by
// statically analyzing the template at compile time.
//
// For plain HTML markup, normalization can be completely skipped because the
// generated render function is guaranteed to return Array<VNode>. There are
// two cases where extra normalization is needed:

// 1. When the children contains components - because a functional component
// may return an Array instead of a single root. In this case, just a simple
// normalization is needed - if any child is an Array, we flatten the whole
// thing with Array.prototype.concat. It is guaranteed to be only 1-level deep
// because functional components already normalize their own children.
function simpleNormalizeChildren (children) {
  for (var i = 0; i < children.length; i++) {
    if (Array.isArray(children[i])) {
      return Array.prototype.concat.apply([], children)
    }
  }
  return children
}

// 2. When the children contains constructs that always generated nested Arrays,
// e.g. <template>, <slot>, v-for, or when the children is provided by user
// with hand-written render functions / JSX. In such cases a full normalization
// is needed to cater to all possible types of children values.
function normalizeChildren (children) {
  return isPrimitive(children)
    ? [createTextVNode(children)]
    : Array.isArray(children)
      ? normalizeArrayChildren(children)
      : undefined
}

function isTextNode (node) {
  return isDef(node) && isDef(node.text) && isFalse(node.isComment)
}

function normalizeArrayChildren (children, nestedIndex) {
  var res = [];
  var i, c, lastIndex, last;
  for (i = 0; i < children.length; i++) {
    c = children[i];
    if (isUndef(c) || typeof c === 'boolean') { continue }
    lastIndex = res.length - 1;
    last = res[lastIndex];
    //  nested
    if (Array.isArray(c)) {
      if (c.length > 0) {
        c = normalizeArrayChildren(c, ((nestedIndex || '') + "_" + i));
        // merge adjacent text nodes
        if (isTextNode(c[0]) && isTextNode(last)) {
          res[lastIndex] = createTextVNode(last.text + (c[0]).text);
          c.shift();
        }
        res.push.apply(res, c);
      }
    } else if (isPrimitive(c)) {
      if (isTextNode(last)) {
        // merge adjacent text nodes
        // this is necessary for SSR hydration because text nodes are
        // essentially merged when rendered to HTML strings
        res[lastIndex] = createTextVNode(last.text + c);
      } else if (c !== '') {
        // convert primitive to vnode
        res.push(createTextVNode(c));
      }
    } else {
      if (isTextNode(c) && isTextNode(last)) {
        // merge adjacent text nodes
        res[lastIndex] = createTextVNode(last.text + c.text);
      } else {
        // default key for nested array children (likely generated by v-for)
        if (isTrue(children._isVList) &&
          isDef(c.tag) &&
          isUndef(c.key) &&
          isDef(nestedIndex)) {
          c.key = "__vlist" + nestedIndex + "_" + i + "__";
        }
        res.push(c);
      }
    }
  }
  return res
}

/*  */

function initProvide (vm) {
  var provide = vm.$options.provide;
  if (provide) {
    vm._provided = typeof provide === 'function'
      ? provide.call(vm)
      : provide;
  }
}

function initInjections (vm) {
  var result = resolveInject(vm.$options.inject, vm);
  if (result) {
    toggleObserving(false);
    Object.keys(result).forEach(function (key) {
      /* istanbul ignore else */
      if (false) {
        defineReactive$$1(vm, key, result[key], function () {
          warn(
            "Avoid mutating an injected value directly since the changes will be " +
            "overwritten whenever the provided component re-renders. " +
            "injection being mutated: \"" + key + "\"",
            vm
          );
        });
      } else {
        defineReactive$$1(vm, key, result[key]);
      }
    });
    toggleObserving(true);
  }
}

function resolveInject (inject, vm) {
  if (inject) {
    // inject is :any because flow is not smart enough to figure out cached
    var result = Object.create(null);
    var keys = hasSymbol
      ? Reflect.ownKeys(inject)
      : Object.keys(inject);

    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      // #6574 in case the inject object is observed...
      if (key === '__ob__') { continue }
      var provideKey = inject[key].from;
      var source = vm;
      while (source) {
        if (source._provided && hasOwn(source._provided, provideKey)) {
          result[key] = source._provided[provideKey];
          break
        }
        source = source.$parent;
      }
      if (!source) {
        if ('default' in inject[key]) {
          var provideDefault = inject[key].default;
          result[key] = typeof provideDefault === 'function'
            ? provideDefault.call(vm)
            : provideDefault;
        } else if (false) {
          warn(("Injection \"" + key + "\" not found"), vm);
        }
      }
    }
    return result
  }
}

/*  */



/**
 * Runtime helper for resolving raw children VNodes into a slot object.
 */
function resolveSlots (
  children,
  context
) {
  if (!children || !children.length) {
    return {}
  }
  var slots = {};
  for (var i = 0, l = children.length; i < l; i++) {
    var child = children[i];
    var data = child.data;
    // remove slot attribute if the node is resolved as a Vue slot node
    if (data && data.attrs && data.attrs.slot) {
      delete data.attrs.slot;
    }
    // named slots should only be respected if the vnode was rendered in the
    // same context.
    if ((child.context === context || child.fnContext === context) &&
      data && data.slot != null
    ) {
      var name = data.slot;
      var slot = (slots[name] || (slots[name] = []));
      if (child.tag === 'template') {
        slot.push.apply(slot, child.children || []);
      } else {
        slot.push(child);
      }
    } else {
      (slots.default || (slots.default = [])).push(child);
    }
  }
  // ignore slots that contains only whitespace
  for (var name$1 in slots) {
    if (slots[name$1].every(isWhitespace)) {
      delete slots[name$1];
    }
  }
  return slots
}

function isWhitespace (node) {
  return (node.isComment && !node.asyncFactory) || node.text === ' '
}

/*  */

function normalizeScopedSlots (
  slots,
  normalSlots,
  prevSlots
) {
  var res;
  var hasNormalSlots = Object.keys(normalSlots).length > 0;
  var isStable = slots ? !!slots.$stable : !hasNormalSlots;
  var key = slots && slots.$key;
  if (!slots) {
    res = {};
  } else if (slots._normalized) {
    // fast path 1: child component re-render only, parent did not change
    return slots._normalized
  } else if (
    isStable &&
    prevSlots &&
    prevSlots !== emptyObject &&
    key === prevSlots.$key &&
    !hasNormalSlots &&
    !prevSlots.$hasNormal
  ) {
    // fast path 2: stable scoped slots w/ no normal slots to proxy,
    // only need to normalize once
    return prevSlots
  } else {
    res = {};
    for (var key$1 in slots) {
      if (slots[key$1] && key$1[0] !== '$') {
        res[key$1] = normalizeScopedSlot(normalSlots, key$1, slots[key$1]);
      }
    }
  }
  // expose normal slots on scopedSlots
  for (var key$2 in normalSlots) {
    if (!(key$2 in res)) {
      res[key$2] = proxyNormalSlot(normalSlots, key$2);
    }
  }
  // avoriaz seems to mock a non-extensible $scopedSlots object
  // and when that is passed down this would cause an error
  if (slots && Object.isExtensible(slots)) {
    (slots)._normalized = res;
  }
  def(res, '$stable', isStable);
  def(res, '$key', key);
  def(res, '$hasNormal', hasNormalSlots);
  return res
}

function normalizeScopedSlot(normalSlots, key, fn) {
  var normalized = function () {
    var res = arguments.length ? fn.apply(null, arguments) : fn({});
    res = res && typeof res === 'object' && !Array.isArray(res)
      ? [res] // single vnode
      : normalizeChildren(res);
    return res && (
      res.length === 0 ||
      (res.length === 1 && res[0].isComment) // #9658
    ) ? undefined
      : res
  };
  // this is a slot using the new v-slot syntax without scope. although it is
  // compiled as a scoped slot, render fn users would expect it to be present
  // on this.$slots because the usage is semantically a normal slot.
  if (fn.proxy) {
    Object.defineProperty(normalSlots, key, {
      get: normalized,
      enumerable: true,
      configurable: true
    });
  }
  return normalized
}

function proxyNormalSlot(slots, key) {
  return function () { return slots[key]; }
}

/*  */

/**
 * Runtime helper for rendering v-for lists.
 */
function renderList (
  val,
  render
) {
  var ret, i, l, keys, key;
  if (Array.isArray(val) || typeof val === 'string') {
    ret = new Array(val.length);
    for (i = 0, l = val.length; i < l; i++) {
      ret[i] = render(val[i], i);
    }
  } else if (typeof val === 'number') {
    ret = new Array(val);
    for (i = 0; i < val; i++) {
      ret[i] = render(i + 1, i);
    }
  } else if (isObject(val)) {
    if (hasSymbol && val[Symbol.iterator]) {
      ret = [];
      var iterator = val[Symbol.iterator]();
      var result = iterator.next();
      while (!result.done) {
        ret.push(render(result.value, ret.length));
        result = iterator.next();
      }
    } else {
      keys = Object.keys(val);
      ret = new Array(keys.length);
      for (i = 0, l = keys.length; i < l; i++) {
        key = keys[i];
        ret[i] = render(val[key], key, i);
      }
    }
  }
  if (!isDef(ret)) {
    ret = [];
  }
  (ret)._isVList = true;
  return ret
}

/*  */

/**
 * Runtime helper for rendering <slot>
 */
function renderSlot (
  name,
  fallback,
  props,
  bindObject
) {
  var scopedSlotFn = this.$scopedSlots[name];
  var nodes;
  if (scopedSlotFn) { // scoped slot
    props = props || {};
    if (bindObject) {
      if (false) {
        warn(
          'slot v-bind without argument expects an Object',
          this
        );
      }
      props = extend(extend({}, bindObject), props);
    }
    nodes = scopedSlotFn(props) || fallback;
  } else {
    nodes = this.$slots[name] || fallback;
  }

  var target = props && props.slot;
  if (target) {
    return this.$createElement('template', { slot: target }, nodes)
  } else {
    return nodes
  }
}

/*  */

/**
 * Runtime helper for resolving filters
 */
function resolveFilter (id) {
  return resolveAsset(this.$options, 'filters', id, true) || identity
}

/*  */

function isKeyNotMatch (expect, actual) {
  if (Array.isArray(expect)) {
    return expect.indexOf(actual) === -1
  } else {
    return expect !== actual
  }
}

/**
 * Runtime helper for checking keyCodes from config.
 * exposed as Vue.prototype._k
 * passing in eventKeyName as last argument separately for backwards compat
 */
function checkKeyCodes (
  eventKeyCode,
  key,
  builtInKeyCode,
  eventKeyName,
  builtInKeyName
) {
  var mappedKeyCode = config.keyCodes[key] || builtInKeyCode;
  if (builtInKeyName && eventKeyName && !config.keyCodes[key]) {
    return isKeyNotMatch(builtInKeyName, eventKeyName)
  } else if (mappedKeyCode) {
    return isKeyNotMatch(mappedKeyCode, eventKeyCode)
  } else if (eventKeyName) {
    return hyphenate(eventKeyName) !== key
  }
}

/*  */

/**
 * Runtime helper for merging v-bind="object" into a VNode's data.
 */
function bindObjectProps (
  data,
  tag,
  value,
  asProp,
  isSync
) {
  if (value) {
    if (!isObject(value)) {
      "production" !== 'production' && warn(
        'v-bind without argument expects an Object or Array value',
        this
      );
    } else {
      if (Array.isArray(value)) {
        value = toObject(value);
      }
      var hash;
      var loop = function ( key ) {
        if (
          key === 'class' ||
          key === 'style' ||
          isReservedAttribute(key)
        ) {
          hash = data;
        } else {
          var type = data.attrs && data.attrs.type;
          hash = asProp || config.mustUseProp(tag, type, key)
            ? data.domProps || (data.domProps = {})
            : data.attrs || (data.attrs = {});
        }
        var camelizedKey = camelize(key);
        var hyphenatedKey = hyphenate(key);
        if (!(camelizedKey in hash) && !(hyphenatedKey in hash)) {
          hash[key] = value[key];

          if (isSync) {
            var on = data.on || (data.on = {});
            on[("update:" + key)] = function ($event) {
              value[key] = $event;
            };
          }
        }
      };

      for (var key in value) loop( key );
    }
  }
  return data
}

/*  */

/**
 * Runtime helper for rendering static trees.
 */
function renderStatic (
  index,
  isInFor
) {
  var cached = this._staticTrees || (this._staticTrees = []);
  var tree = cached[index];
  // if has already-rendered static tree and not inside v-for,
  // we can reuse the same tree.
  if (tree && !isInFor) {
    return tree
  }
  // otherwise, render a fresh tree.
  tree = cached[index] = this.$options.staticRenderFns[index].call(
    this._renderProxy,
    null,
    this // for render fns generated for functional component templates
  );
  markStatic(tree, ("__static__" + index), false);
  return tree
}

/**
 * Runtime helper for v-once.
 * Effectively it means marking the node as static with a unique key.
 */
function markOnce (
  tree,
  index,
  key
) {
  markStatic(tree, ("__once__" + index + (key ? ("_" + key) : "")), true);
  return tree
}

function markStatic (
  tree,
  key,
  isOnce
) {
  if (Array.isArray(tree)) {
    for (var i = 0; i < tree.length; i++) {
      if (tree[i] && typeof tree[i] !== 'string') {
        markStaticNode(tree[i], (key + "_" + i), isOnce);
      }
    }
  } else {
    markStaticNode(tree, key, isOnce);
  }
}

function markStaticNode (node, key, isOnce) {
  node.isStatic = true;
  node.key = key;
  node.isOnce = isOnce;
}

/*  */

function bindObjectListeners (data, value) {
  if (value) {
    if (!isPlainObject(value)) {
      "production" !== 'production' && warn(
        'v-on without argument expects an Object value',
        this
      );
    } else {
      var on = data.on = data.on ? extend({}, data.on) : {};
      for (var key in value) {
        var existing = on[key];
        var ours = value[key];
        on[key] = existing ? [].concat(existing, ours) : ours;
      }
    }
  }
  return data
}

/*  */

function resolveScopedSlots (
  fns, // see flow/vnode
  res,
  // the following are added in 2.6
  hasDynamicKeys,
  contentHashKey
) {
  res = res || { $stable: !hasDynamicKeys };
  for (var i = 0; i < fns.length; i++) {
    var slot = fns[i];
    if (Array.isArray(slot)) {
      resolveScopedSlots(slot, res, hasDynamicKeys);
    } else if (slot) {
      // marker for reverse proxying v-slot without scope on this.$slots
      if (slot.proxy) {
        slot.fn.proxy = true;
      }
      res[slot.key] = slot.fn;
    }
  }
  if (contentHashKey) {
    (res).$key = contentHashKey;
  }
  return res
}

/*  */

function bindDynamicKeys (baseObj, values) {
  for (var i = 0; i < values.length; i += 2) {
    var key = values[i];
    if (typeof key === 'string' && key) {
      baseObj[values[i]] = values[i + 1];
    } else if (false) {
      // null is a special value for explicitly removing a binding
      warn(
        ("Invalid value for dynamic directive argument (expected string or null): " + key),
        this
      );
    }
  }
  return baseObj
}

// helper to dynamically append modifier runtime markers to event names.
// ensure only append when value is already string, otherwise it will be cast
// to string and cause the type check to miss.
function prependModifier (value, symbol) {
  return typeof value === 'string' ? symbol + value : value
}

/*  */

function installRenderHelpers (target) {
  target._o = markOnce;
  target._n = toNumber;
  target._s = toString;
  target._l = renderList;
  target._t = renderSlot;
  target._q = looseEqual;
  target._i = looseIndexOf;
  target._m = renderStatic;
  target._f = resolveFilter;
  target._k = checkKeyCodes;
  target._b = bindObjectProps;
  target._v = createTextVNode;
  target._e = createEmptyVNode;
  target._u = resolveScopedSlots;
  target._g = bindObjectListeners;
  target._d = bindDynamicKeys;
  target._p = prependModifier;
}

/*  */

function FunctionalRenderContext (
  data,
  props,
  children,
  parent,
  Ctor
) {
  var this$1 = this;

  var options = Ctor.options;
  // ensure the createElement function in functional components
  // gets a unique context - this is necessary for correct named slot check
  var contextVm;
  if (hasOwn(parent, '_uid')) {
    contextVm = Object.create(parent);
    // $flow-disable-line
    contextVm._original = parent;
  } else {
    // the context vm passed in is a functional context as well.
    // in this case we want to make sure we are able to get a hold to the
    // real context instance.
    contextVm = parent;
    // $flow-disable-line
    parent = parent._original;
  }
  var isCompiled = isTrue(options._compiled);
  var needNormalization = !isCompiled;

  this.data = data;
  this.props = props;
  this.children = children;
  this.parent = parent;
  this.listeners = data.on || emptyObject;
  this.injections = resolveInject(options.inject, parent);
  this.slots = function () {
    if (!this$1.$slots) {
      normalizeScopedSlots(
        data.scopedSlots,
        this$1.$slots = resolveSlots(children, parent)
      );
    }
    return this$1.$slots
  };

  Object.defineProperty(this, 'scopedSlots', ({
    enumerable: true,
    get: function get () {
      return normalizeScopedSlots(data.scopedSlots, this.slots())
    }
  }));

  // support for compiled functional template
  if (isCompiled) {
    // exposing $options for renderStatic()
    this.$options = options;
    // pre-resolve slots for renderSlot()
    this.$slots = this.slots();
    this.$scopedSlots = normalizeScopedSlots(data.scopedSlots, this.$slots);
  }

  if (options._scopeId) {
    this._c = function (a, b, c, d) {
      var vnode = createElement(contextVm, a, b, c, d, needNormalization);
      if (vnode && !Array.isArray(vnode)) {
        vnode.fnScopeId = options._scopeId;
        vnode.fnContext = parent;
      }
      return vnode
    };
  } else {
    this._c = function (a, b, c, d) { return createElement(contextVm, a, b, c, d, needNormalization); };
  }
}

installRenderHelpers(FunctionalRenderContext.prototype);

function createFunctionalComponent (
  Ctor,
  propsData,
  data,
  contextVm,
  children
) {
  var options = Ctor.options;
  var props = {};
  var propOptions = options.props;
  if (isDef(propOptions)) {
    for (var key in propOptions) {
      props[key] = validateProp(key, propOptions, propsData || emptyObject);
    }
  } else {
    if (isDef(data.attrs)) { mergeProps(props, data.attrs); }
    if (isDef(data.props)) { mergeProps(props, data.props); }
  }

  var renderContext = new FunctionalRenderContext(
    data,
    props,
    children,
    contextVm,
    Ctor
  );

  var vnode = options.render.call(null, renderContext._c, renderContext);

  if (vnode instanceof VNode) {
    return cloneAndMarkFunctionalResult(vnode, data, renderContext.parent, options, renderContext)
  } else if (Array.isArray(vnode)) {
    var vnodes = normalizeChildren(vnode) || [];
    var res = new Array(vnodes.length);
    for (var i = 0; i < vnodes.length; i++) {
      res[i] = cloneAndMarkFunctionalResult(vnodes[i], data, renderContext.parent, options, renderContext);
    }
    return res
  }
}

function cloneAndMarkFunctionalResult (vnode, data, contextVm, options, renderContext) {
  // #7817 clone node before setting fnContext, otherwise if the node is reused
  // (e.g. it was from a cached normal slot) the fnContext causes named slots
  // that should not be matched to match.
  var clone = cloneVNode(vnode);
  clone.fnContext = contextVm;
  clone.fnOptions = options;
  if (false) {
    (clone.devtoolsMeta = clone.devtoolsMeta || {}).renderContext = renderContext;
  }
  if (data.slot) {
    (clone.data || (clone.data = {})).slot = data.slot;
  }
  return clone
}

function mergeProps (to, from) {
  for (var key in from) {
    to[camelize(key)] = from[key];
  }
}

/*  */

/*  */

/*  */

/*  */

// inline hooks to be invoked on component VNodes during patch
var componentVNodeHooks = {
  init: function init (vnode, hydrating) {
    if (
      vnode.componentInstance &&
      !vnode.componentInstance._isDestroyed &&
      vnode.data.keepAlive
    ) {
      // kept-alive components, treat as a patch
      var mountedNode = vnode; // work around flow
      componentVNodeHooks.prepatch(mountedNode, mountedNode);
    } else {
      var child = vnode.componentInstance = createComponentInstanceForVnode(
        vnode,
        activeInstance
      );
      child.$mount(hydrating ? vnode.elm : undefined, hydrating);
    }
  },

  prepatch: function prepatch (oldVnode, vnode) {
    var options = vnode.componentOptions;
    var child = vnode.componentInstance = oldVnode.componentInstance;
    updateChildComponent(
      child,
      options.propsData, // updated props
      options.listeners, // updated listeners
      vnode, // new parent vnode
      options.children // new children
    );
  },

  insert: function insert (vnode) {
    var context = vnode.context;
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isMounted) {
      componentInstance._isMounted = true;
      callHook(componentInstance, 'mounted');
    }
    if (vnode.data.keepAlive) {
      if (context._isMounted) {
        // vue-router#1212
        // During updates, a kept-alive component's child components may
        // change, so directly walking the tree here may call activated hooks
        // on incorrect children. Instead we push them into a queue which will
        // be processed after the whole patch process ended.
        queueActivatedComponent(componentInstance);
      } else {
        activateChildComponent(componentInstance, true /* direct */);
      }
    }
  },

  destroy: function destroy (vnode) {
    var componentInstance = vnode.componentInstance;
    if (!componentInstance._isDestroyed) {
      if (!vnode.data.keepAlive) {
        componentInstance.$destroy();
      } else {
        deactivateChildComponent(componentInstance, true /* direct */);
      }
    }
  }
};

var hooksToMerge = Object.keys(componentVNodeHooks);

function createComponent (
  Ctor,
  data,
  context,
  children,
  tag
) {
  if (isUndef(Ctor)) {
    return
  }

  var baseCtor = context.$options._base;

  // plain options object: turn it into a constructor
  if (isObject(Ctor)) {
    Ctor = baseCtor.extend(Ctor);
  }

  // if at this stage it's not a constructor or an async component factory,
  // reject.
  if (typeof Ctor !== 'function') {
    if (false) {
      warn(("Invalid Component definition: " + (String(Ctor))), context);
    }
    return
  }

  // async component
  var asyncFactory;
  if (isUndef(Ctor.cid)) {
    asyncFactory = Ctor;
    Ctor = resolveAsyncComponent(asyncFactory, baseCtor);
    if (Ctor === undefined) {
      // return a placeholder node for async component, which is rendered
      // as a comment node but preserves all the raw information for the node.
      // the information will be used for async server-rendering and hydration.
      return createAsyncPlaceholder(
        asyncFactory,
        data,
        context,
        children,
        tag
      )
    }
  }

  data = data || {};

  // resolve constructor options in case global mixins are applied after
  // component constructor creation
  resolveConstructorOptions(Ctor);

  // transform component v-model data into props & events
  if (isDef(data.model)) {
    transformModel(Ctor.options, data);
  }

  // extract props
  var propsData = extractPropsFromVNodeData(data, Ctor, tag);

  // functional component
  if (isTrue(Ctor.options.functional)) {
    return createFunctionalComponent(Ctor, propsData, data, context, children)
  }

  // extract listeners, since these needs to be treated as
  // child component listeners instead of DOM listeners
  var listeners = data.on;
  // replace with listeners with .native modifier
  // so it gets processed during parent component patch.
  data.on = data.nativeOn;

  if (isTrue(Ctor.options.abstract)) {
    // abstract components do not keep anything
    // other than props & listeners & slot

    // work around flow
    var slot = data.slot;
    data = {};
    if (slot) {
      data.slot = slot;
    }
  }

  // install component management hooks onto the placeholder node
  installComponentHooks(data);

  // return a placeholder vnode
  var name = Ctor.options.name || tag;
  var vnode = new VNode(
    ("vue-component-" + (Ctor.cid) + (name ? ("-" + name) : '')),
    data, undefined, undefined, undefined, context,
    { Ctor: Ctor, propsData: propsData, listeners: listeners, tag: tag, children: children },
    asyncFactory
  );

  return vnode
}

function createComponentInstanceForVnode (
  vnode, // we know it's MountedComponentVNode but flow doesn't
  parent // activeInstance in lifecycle state
) {
  var options = {
    _isComponent: true,
    _parentVnode: vnode,
    parent: parent
  };
  // check inline-template render functions
  var inlineTemplate = vnode.data.inlineTemplate;
  if (isDef(inlineTemplate)) {
    options.render = inlineTemplate.render;
    options.staticRenderFns = inlineTemplate.staticRenderFns;
  }
  return new vnode.componentOptions.Ctor(options)
}

function installComponentHooks (data) {
  var hooks = data.hook || (data.hook = {});
  for (var i = 0; i < hooksToMerge.length; i++) {
    var key = hooksToMerge[i];
    var existing = hooks[key];
    var toMerge = componentVNodeHooks[key];
    if (existing !== toMerge && !(existing && existing._merged)) {
      hooks[key] = existing ? mergeHook$1(toMerge, existing) : toMerge;
    }
  }
}

function mergeHook$1 (f1, f2) {
  var merged = function (a, b) {
    // flow complains about extra args which is why we use any
    f1(a, b);
    f2(a, b);
  };
  merged._merged = true;
  return merged
}

// transform component v-model info (value and callback) into
// prop and event handler respectively.
function transformModel (options, data) {
  var prop = (options.model && options.model.prop) || 'value';
  var event = (options.model && options.model.event) || 'input'
  ;(data.attrs || (data.attrs = {}))[prop] = data.model.value;
  var on = data.on || (data.on = {});
  var existing = on[event];
  var callback = data.model.callback;
  if (isDef(existing)) {
    if (
      Array.isArray(existing)
        ? existing.indexOf(callback) === -1
        : existing !== callback
    ) {
      on[event] = [callback].concat(existing);
    }
  } else {
    on[event] = callback;
  }
}

/*  */

var SIMPLE_NORMALIZE = 1;
var ALWAYS_NORMALIZE = 2;

// wrapper function for providing a more flexible interface
// without getting yelled at by flow
function createElement (
  context,
  tag,
  data,
  children,
  normalizationType,
  alwaysNormalize
) {
  if (Array.isArray(data) || isPrimitive(data)) {
    normalizationType = children;
    children = data;
    data = undefined;
  }
  if (isTrue(alwaysNormalize)) {
    normalizationType = ALWAYS_NORMALIZE;
  }
  return _createElement(context, tag, data, children, normalizationType)
}

function _createElement (
  context,
  tag,
  data,
  children,
  normalizationType
) {
  if (isDef(data) && isDef((data).__ob__)) {
    "production" !== 'production' && warn(
      "Avoid using observed data object as vnode data: " + (JSON.stringify(data)) + "\n" +
      'Always create fresh vnode data objects in each render!',
      context
    );
    return createEmptyVNode()
  }
  // object syntax in v-bind
  if (isDef(data) && isDef(data.is)) {
    tag = data.is;
  }
  if (!tag) {
    // in case of component :is set to falsy value
    return createEmptyVNode()
  }
  // warn against non-primitive key
  if (false
  ) {
    {
      warn(
        'Avoid using non-primitive value as key, ' +
        'use string/number value instead.',
        context
      );
    }
  }
  // support single function children as default scoped slot
  if (Array.isArray(children) &&
    typeof children[0] === 'function'
  ) {
    data = data || {};
    data.scopedSlots = { default: children[0] };
    children.length = 0;
  }
  if (normalizationType === ALWAYS_NORMALIZE) {
    children = normalizeChildren(children);
  } else if (normalizationType === SIMPLE_NORMALIZE) {
    children = simpleNormalizeChildren(children);
  }
  var vnode, ns;
  if (typeof tag === 'string') {
    var Ctor;
    ns = (context.$vnode && context.$vnode.ns) || config.getTagNamespace(tag);
    if (config.isReservedTag(tag)) {
      // platform built-in elements
      if (false) {
        warn(
          ("The .native modifier for v-on is only valid on components but it was used on <" + tag + ">."),
          context
        );
      }
      vnode = new VNode(
        config.parsePlatformTagName(tag), data, children,
        undefined, undefined, context
      );
    } else if ((!data || !data.pre) && isDef(Ctor = resolveAsset(context.$options, 'components', tag))) {
      // component
      vnode = createComponent(Ctor, data, context, children, tag);
    } else {
      // unknown or unlisted namespaced elements
      // check at runtime because it may get assigned a namespace when its
      // parent normalizes children
      vnode = new VNode(
        tag, data, children,
        undefined, undefined, context
      );
    }
  } else {
    // direct component options / constructor
    vnode = createComponent(tag, data, context, children);
  }
  if (Array.isArray(vnode)) {
    return vnode
  } else if (isDef(vnode)) {
    if (isDef(ns)) { applyNS(vnode, ns); }
    if (isDef(data)) { registerDeepBindings(data); }
    return vnode
  } else {
    return createEmptyVNode()
  }
}

function applyNS (vnode, ns, force) {
  vnode.ns = ns;
  if (vnode.tag === 'foreignObject') {
    // use default namespace inside foreignObject
    ns = undefined;
    force = true;
  }
  if (isDef(vnode.children)) {
    for (var i = 0, l = vnode.children.length; i < l; i++) {
      var child = vnode.children[i];
      if (isDef(child.tag) && (
        isUndef(child.ns) || (isTrue(force) && child.tag !== 'svg'))) {
        applyNS(child, ns, force);
      }
    }
  }
}

// ref #5318
// necessary to ensure parent re-render when deep bindings like :style and
// :class are used on slot nodes
function registerDeepBindings (data) {
  if (isObject(data.style)) {
    traverse(data.style);
  }
  if (isObject(data.class)) {
    traverse(data.class);
  }
}

/*  */

function initRender (vm) {
  vm._vnode = null; // the root of the child tree
  vm._staticTrees = null; // v-once cached trees
  var options = vm.$options;
  var parentVnode = vm.$vnode = options._parentVnode; // the placeholder node in parent tree
  var renderContext = parentVnode && parentVnode.context;
  vm.$slots = resolveSlots(options._renderChildren, renderContext);
  vm.$scopedSlots = emptyObject;
  // bind the createElement fn to this instance
  // so that we get proper render context inside it.
  // args order: tag, data, children, normalizationType, alwaysNormalize
  // internal version is used by render functions compiled from templates
  vm._c = function (a, b, c, d) { return createElement(vm, a, b, c, d, false); };
  // normalization is always applied for the public version, used in
  // user-written render functions.
  vm.$createElement = function (a, b, c, d) { return createElement(vm, a, b, c, d, true); };

  // $attrs & $listeners are exposed for easier HOC creation.
  // they need to be reactive so that HOCs using them are always updated
  var parentData = parentVnode && parentVnode.data;

  /* istanbul ignore else */
  if (false) {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, function () {
      !isUpdatingChildComponent && warn("$attrs is readonly.", vm);
    }, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, function () {
      !isUpdatingChildComponent && warn("$listeners is readonly.", vm);
    }, true);
  } else {
    defineReactive$$1(vm, '$attrs', parentData && parentData.attrs || emptyObject, null, true);
    defineReactive$$1(vm, '$listeners', options._parentListeners || emptyObject, null, true);
  }
}

var currentRenderingInstance = null;

function renderMixin (Vue) {
  // install runtime convenience helpers
  installRenderHelpers(Vue.prototype);

  Vue.prototype.$nextTick = function (fn) {
    return nextTick(fn, this)
  };

  Vue.prototype._render = function () {
    var vm = this;
    var ref = vm.$options;
    var render = ref.render;
    var _parentVnode = ref._parentVnode;

    if (_parentVnode) {
      vm.$scopedSlots = normalizeScopedSlots(
        _parentVnode.data.scopedSlots,
        vm.$slots,
        vm.$scopedSlots
      );
    }

    // set parent vnode. this allows render functions to have access
    // to the data on the placeholder node.
    vm.$vnode = _parentVnode;
    // render self
    var vnode;
    try {
      // There's no need to maintain a stack because all render fns are called
      // separately from one another. Nested component's render fns are called
      // when parent component is patched.
      currentRenderingInstance = vm;
      vnode = render.call(vm._renderProxy, vm.$createElement);
    } catch (e) {
      handleError(e, vm, "render");
      // return error render result,
      // or previous vnode to prevent render error causing blank component
      /* istanbul ignore else */
      if (false) {
        try {
          vnode = vm.$options.renderError.call(vm._renderProxy, vm.$createElement, e);
        } catch (e) {
          handleError(e, vm, "renderError");
          vnode = vm._vnode;
        }
      } else {
        vnode = vm._vnode;
      }
    } finally {
      currentRenderingInstance = null;
    }
    // if the returned array contains only a single node, allow it
    if (Array.isArray(vnode) && vnode.length === 1) {
      vnode = vnode[0];
    }
    // return empty vnode in case the render function errored out
    if (!(vnode instanceof VNode)) {
      if (false) {
        warn(
          'Multiple root nodes returned from render function. Render function ' +
          'should return a single root node.',
          vm
        );
      }
      vnode = createEmptyVNode();
    }
    // set parent
    vnode.parent = _parentVnode;
    return vnode
  };
}

/*  */

function ensureCtor (comp, base) {
  if (
    comp.__esModule ||
    (hasSymbol && comp[Symbol.toStringTag] === 'Module')
  ) {
    comp = comp.default;
  }
  return isObject(comp)
    ? base.extend(comp)
    : comp
}

function createAsyncPlaceholder (
  factory,
  data,
  context,
  children,
  tag
) {
  var node = createEmptyVNode();
  node.asyncFactory = factory;
  node.asyncMeta = { data: data, context: context, children: children, tag: tag };
  return node
}

function resolveAsyncComponent (
  factory,
  baseCtor
) {
  if (isTrue(factory.error) && isDef(factory.errorComp)) {
    return factory.errorComp
  }

  if (isDef(factory.resolved)) {
    return factory.resolved
  }

  var owner = currentRenderingInstance;
  if (owner && isDef(factory.owners) && factory.owners.indexOf(owner) === -1) {
    // already pending
    factory.owners.push(owner);
  }

  if (isTrue(factory.loading) && isDef(factory.loadingComp)) {
    return factory.loadingComp
  }

  if (owner && !isDef(factory.owners)) {
    var owners = factory.owners = [owner];
    var sync = true;
    var timerLoading = null;
    var timerTimeout = null

    ;(owner).$on('hook:destroyed', function () { return remove(owners, owner); });

    var forceRender = function (renderCompleted) {
      for (var i = 0, l = owners.length; i < l; i++) {
        (owners[i]).$forceUpdate();
      }

      if (renderCompleted) {
        owners.length = 0;
        if (timerLoading !== null) {
          clearTimeout(timerLoading);
          timerLoading = null;
        }
        if (timerTimeout !== null) {
          clearTimeout(timerTimeout);
          timerTimeout = null;
        }
      }
    };

    var resolve = once(function (res) {
      // cache resolved
      factory.resolved = ensureCtor(res, baseCtor);
      // invoke callbacks only if this is not a synchronous resolve
      // (async resolves are shimmed as synchronous during SSR)
      if (!sync) {
        forceRender(true);
      } else {
        owners.length = 0;
      }
    });

    var reject = once(function (reason) {
      "production" !== 'production' && warn(
        "Failed to resolve async component: " + (String(factory)) +
        (reason ? ("\nReason: " + reason) : '')
      );
      if (isDef(factory.errorComp)) {
        factory.error = true;
        forceRender(true);
      }
    });

    var res = factory(resolve, reject);

    if (isObject(res)) {
      if (isPromise(res)) {
        // () => Promise
        if (isUndef(factory.resolved)) {
          res.then(resolve, reject);
        }
      } else if (isPromise(res.component)) {
        res.component.then(resolve, reject);

        if (isDef(res.error)) {
          factory.errorComp = ensureCtor(res.error, baseCtor);
        }

        if (isDef(res.loading)) {
          factory.loadingComp = ensureCtor(res.loading, baseCtor);
          if (res.delay === 0) {
            factory.loading = true;
          } else {
            timerLoading = setTimeout(function () {
              timerLoading = null;
              if (isUndef(factory.resolved) && isUndef(factory.error)) {
                factory.loading = true;
                forceRender(false);
              }
            }, res.delay || 200);
          }
        }

        if (isDef(res.timeout)) {
          timerTimeout = setTimeout(function () {
            timerTimeout = null;
            if (isUndef(factory.resolved)) {
              reject(
                 false
                  ? ("timeout (" + (res.timeout) + "ms)")
                  : null
              );
            }
          }, res.timeout);
        }
      }
    }

    sync = false;
    // return in case resolved synchronously
    return factory.loading
      ? factory.loadingComp
      : factory.resolved
  }
}

/*  */

function isAsyncPlaceholder (node) {
  return node.isComment && node.asyncFactory
}

/*  */

function getFirstComponentChild (children) {
  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      var c = children[i];
      if (isDef(c) && (isDef(c.componentOptions) || isAsyncPlaceholder(c))) {
        return c
      }
    }
  }
}

/*  */

/*  */

function initEvents (vm) {
  vm._events = Object.create(null);
  vm._hasHookEvent = false;
  // init parent attached events
  var listeners = vm.$options._parentListeners;
  if (listeners) {
    updateComponentListeners(vm, listeners);
  }
}

var target;

function add (event, fn) {
  target.$on(event, fn);
}

function remove$1 (event, fn) {
  target.$off(event, fn);
}

function createOnceHandler (event, fn) {
  var _target = target;
  return function onceHandler () {
    var res = fn.apply(null, arguments);
    if (res !== null) {
      _target.$off(event, onceHandler);
    }
  }
}

function updateComponentListeners (
  vm,
  listeners,
  oldListeners
) {
  target = vm;
  updateListeners(listeners, oldListeners || {}, add, remove$1, createOnceHandler, vm);
  target = undefined;
}

function eventsMixin (Vue) {
  var hookRE = /^hook:/;
  Vue.prototype.$on = function (event, fn) {
    var vm = this;
    if (Array.isArray(event)) {
      for (var i = 0, l = event.length; i < l; i++) {
        vm.$on(event[i], fn);
      }
    } else {
      (vm._events[event] || (vm._events[event] = [])).push(fn);
      // optimize hook:event cost by using a boolean flag marked at registration
      // instead of a hash lookup
      if (hookRE.test(event)) {
        vm._hasHookEvent = true;
      }
    }
    return vm
  };

  Vue.prototype.$once = function (event, fn) {
    var vm = this;
    function on () {
      vm.$off(event, on);
      fn.apply(vm, arguments);
    }
    on.fn = fn;
    vm.$on(event, on);
    return vm
  };

  Vue.prototype.$off = function (event, fn) {
    var vm = this;
    // all
    if (!arguments.length) {
      vm._events = Object.create(null);
      return vm
    }
    // array of events
    if (Array.isArray(event)) {
      for (var i$1 = 0, l = event.length; i$1 < l; i$1++) {
        vm.$off(event[i$1], fn);
      }
      return vm
    }
    // specific event
    var cbs = vm._events[event];
    if (!cbs) {
      return vm
    }
    if (!fn) {
      vm._events[event] = null;
      return vm
    }
    // specific handler
    var cb;
    var i = cbs.length;
    while (i--) {
      cb = cbs[i];
      if (cb === fn || cb.fn === fn) {
        cbs.splice(i, 1);
        break
      }
    }
    return vm
  };

  Vue.prototype.$emit = function (event) {
    var vm = this;
    if (false) {
      var lowerCaseEvent = event.toLowerCase();
      if (lowerCaseEvent !== event && vm._events[lowerCaseEvent]) {
        tip(
          "Event \"" + lowerCaseEvent + "\" is emitted in component " +
          (formatComponentName(vm)) + " but the handler is registered for \"" + event + "\". " +
          "Note that HTML attributes are case-insensitive and you cannot use " +
          "v-on to listen to camelCase events when using in-DOM templates. " +
          "You should probably use \"" + (hyphenate(event)) + "\" instead of \"" + event + "\"."
        );
      }
    }
    var cbs = vm._events[event];
    if (cbs) {
      cbs = cbs.length > 1 ? toArray(cbs) : cbs;
      var args = toArray(arguments, 1);
      var info = "event handler for \"" + event + "\"";
      for (var i = 0, l = cbs.length; i < l; i++) {
        invokeWithErrorHandling(cbs[i], vm, args, vm, info);
      }
    }
    return vm
  };
}

/*  */

var activeInstance = null;
var isUpdatingChildComponent = false;

function setActiveInstance(vm) {
  var prevActiveInstance = activeInstance;
  activeInstance = vm;
  return function () {
    activeInstance = prevActiveInstance;
  }
}

function initLifecycle (vm) {
  var options = vm.$options;

  // locate first non-abstract parent
  var parent = options.parent;
  if (parent && !options.abstract) {
    while (parent.$options.abstract && parent.$parent) {
      parent = parent.$parent;
    }
    parent.$children.push(vm);
  }

  vm.$parent = parent;
  vm.$root = parent ? parent.$root : vm;

  vm.$children = [];
  vm.$refs = {};

  vm._watcher = null;
  vm._inactive = null;
  vm._directInactive = false;
  vm._isMounted = false;
  vm._isDestroyed = false;
  vm._isBeingDestroyed = false;
}

function lifecycleMixin (Vue) {
  Vue.prototype._update = function (vnode, hydrating) {
    var vm = this;
    var prevEl = vm.$el;
    var prevVnode = vm._vnode;
    var restoreActiveInstance = setActiveInstance(vm);
    vm._vnode = vnode;
    // Vue.prototype.__patch__ is injected in entry points
    // based on the rendering backend used.
    if (!prevVnode) {
      // initial render
      vm.$el = vm.__patch__(vm.$el, vnode, hydrating, false /* removeOnly */);
    } else {
      // updates
      vm.$el = vm.__patch__(prevVnode, vnode);
    }
    restoreActiveInstance();
    // update __vue__ reference
    if (prevEl) {
      prevEl.__vue__ = null;
    }
    if (vm.$el) {
      vm.$el.__vue__ = vm;
    }
    // if parent is an HOC, update its $el as well
    if (vm.$vnode && vm.$parent && vm.$vnode === vm.$parent._vnode) {
      vm.$parent.$el = vm.$el;
    }
    // updated hook is called by the scheduler to ensure that children are
    // updated in a parent's updated hook.
  };

  Vue.prototype.$forceUpdate = function () {
    var vm = this;
    if (vm._watcher) {
      vm._watcher.update();
    }
  };

  Vue.prototype.$destroy = function () {
    var vm = this;
    if (vm._isBeingDestroyed) {
      return
    }
    callHook(vm, 'beforeDestroy');
    vm._isBeingDestroyed = true;
    // remove self from parent
    var parent = vm.$parent;
    if (parent && !parent._isBeingDestroyed && !vm.$options.abstract) {
      remove(parent.$children, vm);
    }
    // teardown watchers
    if (vm._watcher) {
      vm._watcher.teardown();
    }
    var i = vm._watchers.length;
    while (i--) {
      vm._watchers[i].teardown();
    }
    // remove reference from data ob
    // frozen object may not have observer.
    if (vm._data.__ob__) {
      vm._data.__ob__.vmCount--;
    }
    // call the last hook...
    vm._isDestroyed = true;
    // invoke destroy hooks on current rendered tree
    vm.__patch__(vm._vnode, null);
    // fire destroyed hook
    callHook(vm, 'destroyed');
    // turn off all instance listeners.
    vm.$off();
    // remove __vue__ reference
    if (vm.$el) {
      vm.$el.__vue__ = null;
    }
    // release circular reference (#6759)
    if (vm.$vnode) {
      vm.$vnode.parent = null;
    }
  };
}

function mountComponent (
  vm,
  el,
  hydrating
) {
  vm.$el = el;
  if (!vm.$options.render) {
    vm.$options.render = createEmptyVNode;
    if (false) {
      /* istanbul ignore if */
      if ((vm.$options.template && vm.$options.template.charAt(0) !== '#') ||
        vm.$options.el || el) {
        warn(
          'You are using the runtime-only build of Vue where the template ' +
          'compiler is not available. Either pre-compile the templates into ' +
          'render functions, or use the compiler-included build.',
          vm
        );
      } else {
        warn(
          'Failed to mount component: template or render function not defined.',
          vm
        );
      }
    }
  }
  callHook(vm, 'beforeMount');

  var updateComponent;
  /* istanbul ignore if */
  if (false) {
    updateComponent = function () {
      var name = vm._name;
      var id = vm._uid;
      var startTag = "vue-perf-start:" + id;
      var endTag = "vue-perf-end:" + id;

      mark(startTag);
      var vnode = vm._render();
      mark(endTag);
      measure(("vue " + name + " render"), startTag, endTag);

      mark(startTag);
      vm._update(vnode, hydrating);
      mark(endTag);
      measure(("vue " + name + " patch"), startTag, endTag);
    };
  } else {
    updateComponent = function () {
      vm._update(vm._render(), hydrating);
    };
  }

  // we set this to vm._watcher inside the watcher's constructor
  // since the watcher's initial patch may call $forceUpdate (e.g. inside child
  // component's mounted hook), which relies on vm._watcher being already defined
  new Watcher(vm, updateComponent, noop, {
    before: function before () {
      if (vm._isMounted && !vm._isDestroyed) {
        callHook(vm, 'beforeUpdate');
      }
    }
  }, true /* isRenderWatcher */);
  hydrating = false;

  // manually mounted instance, call mounted on self
  // mounted is called for render-created child components in its inserted hook
  if (vm.$vnode == null) {
    vm._isMounted = true;
    callHook(vm, 'mounted');
  }
  return vm
}

function updateChildComponent (
  vm,
  propsData,
  listeners,
  parentVnode,
  renderChildren
) {
  if (false) {
    isUpdatingChildComponent = true;
  }

  // determine whether component has slot children
  // we need to do this before overwriting $options._renderChildren.

  // check if there are dynamic scopedSlots (hand-written or compiled but with
  // dynamic slot names). Static scoped slots compiled from template has the
  // "$stable" marker.
  var newScopedSlots = parentVnode.data.scopedSlots;
  var oldScopedSlots = vm.$scopedSlots;
  var hasDynamicScopedSlot = !!(
    (newScopedSlots && !newScopedSlots.$stable) ||
    (oldScopedSlots !== emptyObject && !oldScopedSlots.$stable) ||
    (newScopedSlots && vm.$scopedSlots.$key !== newScopedSlots.$key)
  );

  // Any static slot children from the parent may have changed during parent's
  // update. Dynamic scoped slots may also have changed. In such cases, a forced
  // update is necessary to ensure correctness.
  var needsForceUpdate = !!(
    renderChildren ||               // has new static slots
    vm.$options._renderChildren ||  // has old static slots
    hasDynamicScopedSlot
  );

  vm.$options._parentVnode = parentVnode;
  vm.$vnode = parentVnode; // update vm's placeholder node without re-render

  if (vm._vnode) { // update child tree's parent
    vm._vnode.parent = parentVnode;
  }
  vm.$options._renderChildren = renderChildren;

  // update $attrs and $listeners hash
  // these are also reactive so they may trigger child update if the child
  // used them during render
  vm.$attrs = parentVnode.data.attrs || emptyObject;
  vm.$listeners = listeners || emptyObject;

  // update props
  if (propsData && vm.$options.props) {
    toggleObserving(false);
    var props = vm._props;
    var propKeys = vm.$options._propKeys || [];
    for (var i = 0; i < propKeys.length; i++) {
      var key = propKeys[i];
      var propOptions = vm.$options.props; // wtf flow?
      props[key] = validateProp(key, propOptions, propsData, vm);
    }
    toggleObserving(true);
    // keep a copy of raw propsData
    vm.$options.propsData = propsData;
  }

  // update listeners
  listeners = listeners || emptyObject;
  var oldListeners = vm.$options._parentListeners;
  vm.$options._parentListeners = listeners;
  updateComponentListeners(vm, listeners, oldListeners);

  // resolve slots + force update if has children
  if (needsForceUpdate) {
    vm.$slots = resolveSlots(renderChildren, parentVnode.context);
    vm.$forceUpdate();
  }

  if (false) {
    isUpdatingChildComponent = false;
  }
}

function isInInactiveTree (vm) {
  while (vm && (vm = vm.$parent)) {
    if (vm._inactive) { return true }
  }
  return false
}

function activateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = false;
    if (isInInactiveTree(vm)) {
      return
    }
  } else if (vm._directInactive) {
    return
  }
  if (vm._inactive || vm._inactive === null) {
    vm._inactive = false;
    for (var i = 0; i < vm.$children.length; i++) {
      activateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'activated');
  }
}

function deactivateChildComponent (vm, direct) {
  if (direct) {
    vm._directInactive = true;
    if (isInInactiveTree(vm)) {
      return
    }
  }
  if (!vm._inactive) {
    vm._inactive = true;
    for (var i = 0; i < vm.$children.length; i++) {
      deactivateChildComponent(vm.$children[i]);
    }
    callHook(vm, 'deactivated');
  }
}

function callHook (vm, hook) {
  // #7573 disable dep collection when invoking lifecycle hooks
  pushTarget();
  var handlers = vm.$options[hook];
  var info = hook + " hook";
  if (handlers) {
    for (var i = 0, j = handlers.length; i < j; i++) {
      invokeWithErrorHandling(handlers[i], vm, null, vm, info);
    }
  }
  if (vm._hasHookEvent) {
    vm.$emit('hook:' + hook);
  }
  popTarget();
}

/*  */

var MAX_UPDATE_COUNT = 100;

var queue = [];
var activatedChildren = [];
var has = {};
var circular = {};
var waiting = false;
var flushing = false;
var index = 0;

/**
 * Reset the scheduler's state.
 */
function resetSchedulerState () {
  index = queue.length = activatedChildren.length = 0;
  has = {};
  if (false) {
    circular = {};
  }
  waiting = flushing = false;
}

// Async edge case #6566 requires saving the timestamp when event listeners are
// attached. However, calling performance.now() has a perf overhead especially
// if the page has thousands of event listeners. Instead, we take a timestamp
// every time the scheduler flushes and use that for all event listeners
// attached during that flush.
var currentFlushTimestamp = 0;

// Async edge case fix requires storing an event listener's attach timestamp.
var getNow = Date.now;

// Determine what event timestamp the browser is using. Annoyingly, the
// timestamp can either be hi-res (relative to page load) or low-res
// (relative to UNIX epoch), so in order to compare time we have to use the
// same timestamp type when saving the flush timestamp.
// All IE versions use low-res event timestamps, and have problematic clock
// implementations (#9632)
if (inBrowser && !isIE) {
  var performance = window.performance;
  if (
    performance &&
    typeof performance.now === 'function' &&
    getNow() > document.createEvent('Event').timeStamp
  ) {
    // if the event timestamp, although evaluated AFTER the Date.now(), is
    // smaller than it, it means the event is using a hi-res timestamp,
    // and we need to use the hi-res version for event listener timestamps as
    // well.
    getNow = function () { return performance.now(); };
  }
}

/**
 * Flush both queues and run the watchers.
 */
function flushSchedulerQueue () {
  currentFlushTimestamp = getNow();
  flushing = true;
  var watcher, id;

  // Sort queue before flush.
  // This ensures that:
  // 1. Components are updated from parent to child. (because parent is always
  //    created before the child)
  // 2. A component's user watchers are run before its render watcher (because
  //    user watchers are created before the render watcher)
  // 3. If a component is destroyed during a parent component's watcher run,
  //    its watchers can be skipped.
  queue.sort(function (a, b) { return a.id - b.id; });

  // do not cache length because more watchers might be pushed
  // as we run existing watchers
  for (index = 0; index < queue.length; index++) {
    watcher = queue[index];
    if (watcher.before) {
      watcher.before();
    }
    id = watcher.id;
    has[id] = null;
    watcher.run();
    // in dev build, check and stop circular updates.
    if (false) {
      circular[id] = (circular[id] || 0) + 1;
      if (circular[id] > MAX_UPDATE_COUNT) {
        warn(
          'You may have an infinite update loop ' + (
            watcher.user
              ? ("in watcher with expression \"" + (watcher.expression) + "\"")
              : "in a component render function."
          ),
          watcher.vm
        );
        break
      }
    }
  }

  // keep copies of post queues before resetting state
  var activatedQueue = activatedChildren.slice();
  var updatedQueue = queue.slice();

  resetSchedulerState();

  // call component updated and activated hooks
  callActivatedHooks(activatedQueue);
  callUpdatedHooks(updatedQueue);

  // devtool hook
  /* istanbul ignore if */
  if (devtools && config.devtools) {
    devtools.emit('flush');
  }
}

function callUpdatedHooks (queue) {
  var i = queue.length;
  while (i--) {
    var watcher = queue[i];
    var vm = watcher.vm;
    if (vm._watcher === watcher && vm._isMounted && !vm._isDestroyed) {
      callHook(vm, 'updated');
    }
  }
}

/**
 * Queue a kept-alive component that was activated during patch.
 * The queue will be processed after the entire tree has been patched.
 */
function queueActivatedComponent (vm) {
  // setting _inactive to false here so that a render function can
  // rely on checking whether it's in an inactive tree (e.g. router-view)
  vm._inactive = false;
  activatedChildren.push(vm);
}

function callActivatedHooks (queue) {
  for (var i = 0; i < queue.length; i++) {
    queue[i]._inactive = true;
    activateChildComponent(queue[i], true /* true */);
  }
}

/**
 * Push a watcher into the watcher queue.
 * Jobs with duplicate IDs will be skipped unless it's
 * pushed when the queue is being flushed.
 */
function queueWatcher (watcher) {
  var id = watcher.id;
  if (has[id] == null) {
    has[id] = true;
    if (!flushing) {
      queue.push(watcher);
    } else {
      // if already flushing, splice the watcher based on its id
      // if already past its id, it will be run next immediately.
      var i = queue.length - 1;
      while (i > index && queue[i].id > watcher.id) {
        i--;
      }
      queue.splice(i + 1, 0, watcher);
    }
    // queue the flush
    if (!waiting) {
      waiting = true;

      if (false) {
        flushSchedulerQueue();
        return
      }
      nextTick(flushSchedulerQueue);
    }
  }
}

/*  */



var uid$2 = 0;

/**
 * A watcher parses an expression, collects dependencies,
 * and fires callback when the expression value changes.
 * This is used for both the $watch() api and directives.
 */
var Watcher = function Watcher (
  vm,
  expOrFn,
  cb,
  options,
  isRenderWatcher
) {
  this.vm = vm;
  if (isRenderWatcher) {
    vm._watcher = this;
  }
  vm._watchers.push(this);
  // options
  if (options) {
    this.deep = !!options.deep;
    this.user = !!options.user;
    this.lazy = !!options.lazy;
    this.sync = !!options.sync;
    this.before = options.before;
  } else {
    this.deep = this.user = this.lazy = this.sync = false;
  }
  this.cb = cb;
  this.id = ++uid$2; // uid for batching
  this.active = true;
  this.dirty = this.lazy; // for lazy watchers
  this.deps = [];
  this.newDeps = [];
  this.depIds = new _Set();
  this.newDepIds = new _Set();
  this.expression =  false
    ? expOrFn.toString()
    : '';
  // parse expression for getter
  if (typeof expOrFn === 'function') {
    this.getter = expOrFn;
  } else {
    this.getter = parsePath(expOrFn);
    if (!this.getter) {
      this.getter = noop;
      "production" !== 'production' && warn(
        "Failed watching path: \"" + expOrFn + "\" " +
        'Watcher only accepts simple dot-delimited paths. ' +
        'For full control, use a function instead.',
        vm
      );
    }
  }
  this.value = this.lazy
    ? undefined
    : this.get();
};

/**
 * Evaluate the getter, and re-collect dependencies.
 */
Watcher.prototype.get = function get () {
  pushTarget(this);
  var value;
  var vm = this.vm;
  try {
    value = this.getter.call(vm, vm);
  } catch (e) {
    if (this.user) {
      handleError(e, vm, ("getter for watcher \"" + (this.expression) + "\""));
    } else {
      throw e
    }
  } finally {
    // "touch" every property so they are all tracked as
    // dependencies for deep watching
    if (this.deep) {
      traverse(value);
    }
    popTarget();
    this.cleanupDeps();
  }
  return value
};

/**
 * Add a dependency to this directive.
 */
Watcher.prototype.addDep = function addDep (dep) {
  var id = dep.id;
  if (!this.newDepIds.has(id)) {
    this.newDepIds.add(id);
    this.newDeps.push(dep);
    if (!this.depIds.has(id)) {
      dep.addSub(this);
    }
  }
};

/**
 * Clean up for dependency collection.
 */
Watcher.prototype.cleanupDeps = function cleanupDeps () {
  var i = this.deps.length;
  while (i--) {
    var dep = this.deps[i];
    if (!this.newDepIds.has(dep.id)) {
      dep.removeSub(this);
    }
  }
  var tmp = this.depIds;
  this.depIds = this.newDepIds;
  this.newDepIds = tmp;
  this.newDepIds.clear();
  tmp = this.deps;
  this.deps = this.newDeps;
  this.newDeps = tmp;
  this.newDeps.length = 0;
};

/**
 * Subscriber interface.
 * Will be called when a dependency changes.
 */
Watcher.prototype.update = function update () {
  /* istanbul ignore else */
  if (this.lazy) {
    this.dirty = true;
  } else if (this.sync) {
    this.run();
  } else {
    queueWatcher(this);
  }
};

/**
 * Scheduler job interface.
 * Will be called by the scheduler.
 */
Watcher.prototype.run = function run () {
  if (this.active) {
    var value = this.get();
    if (
      value !== this.value ||
      // Deep watchers and watchers on Object/Arrays should fire even
      // when the value is the same, because the value may
      // have mutated.
      isObject(value) ||
      this.deep
    ) {
      // set new value
      var oldValue = this.value;
      this.value = value;
      if (this.user) {
        try {
          this.cb.call(this.vm, value, oldValue);
        } catch (e) {
          handleError(e, this.vm, ("callback for watcher \"" + (this.expression) + "\""));
        }
      } else {
        this.cb.call(this.vm, value, oldValue);
      }
    }
  }
};

/**
 * Evaluate the value of the watcher.
 * This only gets called for lazy watchers.
 */
Watcher.prototype.evaluate = function evaluate () {
  this.value = this.get();
  this.dirty = false;
};

/**
 * Depend on all deps collected by this watcher.
 */
Watcher.prototype.depend = function depend () {
  var i = this.deps.length;
  while (i--) {
    this.deps[i].depend();
  }
};

/**
 * Remove self from all dependencies' subscriber list.
 */
Watcher.prototype.teardown = function teardown () {
  if (this.active) {
    // remove self from vm's watcher list
    // this is a somewhat expensive operation so we skip it
    // if the vm is being destroyed.
    if (!this.vm._isBeingDestroyed) {
      remove(this.vm._watchers, this);
    }
    var i = this.deps.length;
    while (i--) {
      this.deps[i].removeSub(this);
    }
    this.active = false;
  }
};

/*  */

var sharedPropertyDefinition = {
  enumerable: true,
  configurable: true,
  get: noop,
  set: noop
};

function proxy (target, sourceKey, key) {
  sharedPropertyDefinition.get = function proxyGetter () {
    return this[sourceKey][key]
  };
  sharedPropertyDefinition.set = function proxySetter (val) {
    this[sourceKey][key] = val;
  };
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function initState (vm) {
  vm._watchers = [];
  var opts = vm.$options;
  if (opts.props) { initProps(vm, opts.props); }
  if (opts.methods) { initMethods(vm, opts.methods); }
  if (opts.data) {
    initData(vm);
  } else {
    observe(vm._data = {}, true /* asRootData */);
  }
  if (opts.computed) { initComputed(vm, opts.computed); }
  if (opts.watch && opts.watch !== nativeWatch) {
    initWatch(vm, opts.watch);
  }
}

function initProps (vm, propsOptions) {
  var propsData = vm.$options.propsData || {};
  var props = vm._props = {};
  // cache prop keys so that future props updates can iterate using Array
  // instead of dynamic object key enumeration.
  var keys = vm.$options._propKeys = [];
  var isRoot = !vm.$parent;
  // root instance props should be converted
  if (!isRoot) {
    toggleObserving(false);
  }
  var loop = function ( key ) {
    keys.push(key);
    var value = validateProp(key, propsOptions, propsData, vm);
    /* istanbul ignore else */
    if (false) {
      var hyphenatedKey = hyphenate(key);
      if (isReservedAttribute(hyphenatedKey) ||
          config.isReservedAttr(hyphenatedKey)) {
        warn(
          ("\"" + hyphenatedKey + "\" is a reserved attribute and cannot be used as component prop."),
          vm
        );
      }
      defineReactive$$1(props, key, value, function () {
        if (!isRoot && !isUpdatingChildComponent) {
          warn(
            "Avoid mutating a prop directly since the value will be " +
            "overwritten whenever the parent component re-renders. " +
            "Instead, use a data or computed property based on the prop's " +
            "value. Prop being mutated: \"" + key + "\"",
            vm
          );
        }
      });
    } else {
      defineReactive$$1(props, key, value);
    }
    // static props are already proxied on the component's prototype
    // during Vue.extend(). We only need to proxy props defined at
    // instantiation here.
    if (!(key in vm)) {
      proxy(vm, "_props", key);
    }
  };

  for (var key in propsOptions) loop( key );
  toggleObserving(true);
}

function initData (vm) {
  var data = vm.$options.data;
  data = vm._data = typeof data === 'function'
    ? getData(data, vm)
    : data || {};
  if (!isPlainObject(data)) {
    data = {};
    "production" !== 'production' && warn(
      'data functions should return an object:\n' +
      'https://vuejs.org/v2/guide/components.html#data-Must-Be-a-Function',
      vm
    );
  }
  // proxy data on instance
  var keys = Object.keys(data);
  var props = vm.$options.props;
  var methods = vm.$options.methods;
  var i = keys.length;
  while (i--) {
    var key = keys[i];
    if (false) {
      if (methods && hasOwn(methods, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a data property."),
          vm
        );
      }
    }
    if (props && hasOwn(props, key)) {
      "production" !== 'production' && warn(
        "The data property \"" + key + "\" is already declared as a prop. " +
        "Use prop default value instead.",
        vm
      );
    } else if (!isReserved(key)) {
      proxy(vm, "_data", key);
    }
  }
  // observe data
  observe(data, true /* asRootData */);
}

function getData (data, vm) {
  // #7573 disable dep collection when invoking data getters
  pushTarget();
  try {
    return data.call(vm, vm)
  } catch (e) {
    handleError(e, vm, "data()");
    return {}
  } finally {
    popTarget();
  }
}

var computedWatcherOptions = { lazy: true };

function initComputed (vm, computed) {
  // $flow-disable-line
  var watchers = vm._computedWatchers = Object.create(null);
  // computed properties are just getters during SSR
  var isSSR = isServerRendering();

  for (var key in computed) {
    var userDef = computed[key];
    var getter = typeof userDef === 'function' ? userDef : userDef.get;
    if (false) {
      warn(
        ("Getter is missing for computed property \"" + key + "\"."),
        vm
      );
    }

    if (!isSSR) {
      // create internal watcher for the computed property.
      watchers[key] = new Watcher(
        vm,
        getter || noop,
        noop,
        computedWatcherOptions
      );
    }

    // component-defined computed properties are already defined on the
    // component prototype. We only need to define computed properties defined
    // at instantiation here.
    if (!(key in vm)) {
      defineComputed(vm, key, userDef);
    } else if (false) {
      if (key in vm.$data) {
        warn(("The computed property \"" + key + "\" is already defined in data."), vm);
      } else if (vm.$options.props && key in vm.$options.props) {
        warn(("The computed property \"" + key + "\" is already defined as a prop."), vm);
      }
    }
  }
}

function defineComputed (
  target,
  key,
  userDef
) {
  var shouldCache = !isServerRendering();
  if (typeof userDef === 'function') {
    sharedPropertyDefinition.get = shouldCache
      ? createComputedGetter(key)
      : createGetterInvoker(userDef);
    sharedPropertyDefinition.set = noop;
  } else {
    sharedPropertyDefinition.get = userDef.get
      ? shouldCache && userDef.cache !== false
        ? createComputedGetter(key)
        : createGetterInvoker(userDef.get)
      : noop;
    sharedPropertyDefinition.set = userDef.set || noop;
  }
  if (false) {
    sharedPropertyDefinition.set = function () {
      warn(
        ("Computed property \"" + key + "\" was assigned to but it has no setter."),
        this
      );
    };
  }
  Object.defineProperty(target, key, sharedPropertyDefinition);
}

function createComputedGetter (key) {
  return function computedGetter () {
    var watcher = this._computedWatchers && this._computedWatchers[key];
    if (watcher) {
      if (watcher.dirty) {
        watcher.evaluate();
      }
      if (Dep.target) {
        watcher.depend();
      }
      return watcher.value
    }
  }
}

function createGetterInvoker(fn) {
  return function computedGetter () {
    return fn.call(this, this)
  }
}

function initMethods (vm, methods) {
  var props = vm.$options.props;
  for (var key in methods) {
    if (false) {
      if (typeof methods[key] !== 'function') {
        warn(
          "Method \"" + key + "\" has type \"" + (typeof methods[key]) + "\" in the component definition. " +
          "Did you reference the function correctly?",
          vm
        );
      }
      if (props && hasOwn(props, key)) {
        warn(
          ("Method \"" + key + "\" has already been defined as a prop."),
          vm
        );
      }
      if ((key in vm) && isReserved(key)) {
        warn(
          "Method \"" + key + "\" conflicts with an existing Vue instance method. " +
          "Avoid defining component methods that start with _ or $."
        );
      }
    }
    vm[key] = typeof methods[key] !== 'function' ? noop : bind(methods[key], vm);
  }
}

function initWatch (vm, watch) {
  for (var key in watch) {
    var handler = watch[key];
    if (Array.isArray(handler)) {
      for (var i = 0; i < handler.length; i++) {
        createWatcher(vm, key, handler[i]);
      }
    } else {
      createWatcher(vm, key, handler);
    }
  }
}

function createWatcher (
  vm,
  expOrFn,
  handler,
  options
) {
  if (isPlainObject(handler)) {
    options = handler;
    handler = handler.handler;
  }
  if (typeof handler === 'string') {
    handler = vm[handler];
  }
  return vm.$watch(expOrFn, handler, options)
}

function stateMixin (Vue) {
  // flow somehow has problems with directly declared definition object
  // when using Object.defineProperty, so we have to procedurally build up
  // the object here.
  var dataDef = {};
  dataDef.get = function () { return this._data };
  var propsDef = {};
  propsDef.get = function () { return this._props };
  if (false) {
    dataDef.set = function () {
      warn(
        'Avoid replacing instance root $data. ' +
        'Use nested data properties instead.',
        this
      );
    };
    propsDef.set = function () {
      warn("$props is readonly.", this);
    };
  }
  Object.defineProperty(Vue.prototype, '$data', dataDef);
  Object.defineProperty(Vue.prototype, '$props', propsDef);

  Vue.prototype.$set = set;
  Vue.prototype.$delete = del;

  Vue.prototype.$watch = function (
    expOrFn,
    cb,
    options
  ) {
    var vm = this;
    if (isPlainObject(cb)) {
      return createWatcher(vm, expOrFn, cb, options)
    }
    options = options || {};
    options.user = true;
    var watcher = new Watcher(vm, expOrFn, cb, options);
    if (options.immediate) {
      try {
        cb.call(vm, watcher.value);
      } catch (error) {
        handleError(error, vm, ("callback for immediate watcher \"" + (watcher.expression) + "\""));
      }
    }
    return function unwatchFn () {
      watcher.teardown();
    }
  };
}

/*  */

var uid$3 = 0;

function initMixin (Vue) {
  Vue.prototype._init = function (options) {
    var vm = this;
    // a uid
    vm._uid = uid$3++;

    var startTag, endTag;
    /* istanbul ignore if */
    if (false) {
      startTag = "vue-perf-start:" + (vm._uid);
      endTag = "vue-perf-end:" + (vm._uid);
      mark(startTag);
    }

    // a flag to avoid this being observed
    vm._isVue = true;
    // merge options
    if (options && options._isComponent) {
      // optimize internal component instantiation
      // since dynamic options merging is pretty slow, and none of the
      // internal component options needs special treatment.
      initInternalComponent(vm, options);
    } else {
      vm.$options = mergeOptions(
        resolveConstructorOptions(vm.constructor),
        options || {},
        vm
      );
    }
    /* istanbul ignore else */
    if (false) {
      initProxy(vm);
    } else {
      vm._renderProxy = vm;
    }
    // expose real self
    vm._self = vm;
    initLifecycle(vm);
    initEvents(vm);
    initRender(vm);
    callHook(vm, 'beforeCreate');
    initInjections(vm); // resolve injections before data/props
    initState(vm);
    initProvide(vm); // resolve provide after data/props
    callHook(vm, 'created');

    /* istanbul ignore if */
    if (false) {
      vm._name = formatComponentName(vm, false);
      mark(endTag);
      measure(("vue " + (vm._name) + " init"), startTag, endTag);
    }

    if (vm.$options.el) {
      vm.$mount(vm.$options.el);
    }
  };
}

function initInternalComponent (vm, options) {
  var opts = vm.$options = Object.create(vm.constructor.options);
  // doing this because it's faster than dynamic enumeration.
  var parentVnode = options._parentVnode;
  opts.parent = options.parent;
  opts._parentVnode = parentVnode;

  var vnodeComponentOptions = parentVnode.componentOptions;
  opts.propsData = vnodeComponentOptions.propsData;
  opts._parentListeners = vnodeComponentOptions.listeners;
  opts._renderChildren = vnodeComponentOptions.children;
  opts._componentTag = vnodeComponentOptions.tag;

  if (options.render) {
    opts.render = options.render;
    opts.staticRenderFns = options.staticRenderFns;
  }
}

function resolveConstructorOptions (Ctor) {
  var options = Ctor.options;
  if (Ctor.super) {
    var superOptions = resolveConstructorOptions(Ctor.super);
    var cachedSuperOptions = Ctor.superOptions;
    if (superOptions !== cachedSuperOptions) {
      // super option changed,
      // need to resolve new options.
      Ctor.superOptions = superOptions;
      // check if there are any late-modified/attached options (#4976)
      var modifiedOptions = resolveModifiedOptions(Ctor);
      // update base extend options
      if (modifiedOptions) {
        extend(Ctor.extendOptions, modifiedOptions);
      }
      options = Ctor.options = mergeOptions(superOptions, Ctor.extendOptions);
      if (options.name) {
        options.components[options.name] = Ctor;
      }
    }
  }
  return options
}

function resolveModifiedOptions (Ctor) {
  var modified;
  var latest = Ctor.options;
  var sealed = Ctor.sealedOptions;
  for (var key in latest) {
    if (latest[key] !== sealed[key]) {
      if (!modified) { modified = {}; }
      modified[key] = latest[key];
    }
  }
  return modified
}

function Vue (options) {
  if (false
  ) {
    warn('Vue is a constructor and should be called with the `new` keyword');
  }
  this._init(options);
}

initMixin(Vue);
stateMixin(Vue);
eventsMixin(Vue);
lifecycleMixin(Vue);
renderMixin(Vue);

/*  */

function initUse (Vue) {
  Vue.use = function (plugin) {
    var installedPlugins = (this._installedPlugins || (this._installedPlugins = []));
    if (installedPlugins.indexOf(plugin) > -1) {
      return this
    }

    // additional parameters
    var args = toArray(arguments, 1);
    args.unshift(this);
    if (typeof plugin.install === 'function') {
      plugin.install.apply(plugin, args);
    } else if (typeof plugin === 'function') {
      plugin.apply(null, args);
    }
    installedPlugins.push(plugin);
    return this
  };
}

/*  */

function initMixin$1 (Vue) {
  Vue.mixin = function (mixin) {
    this.options = mergeOptions(this.options, mixin);
    return this
  };
}

/*  */

function initExtend (Vue) {
  /**
   * Each instance constructor, including Vue, has a unique
   * cid. This enables us to create wrapped "child
   * constructors" for prototypal inheritance and cache them.
   */
  Vue.cid = 0;
  var cid = 1;

  /**
   * Class inheritance
   */
  Vue.extend = function (extendOptions) {
    extendOptions = extendOptions || {};
    var Super = this;
    var SuperId = Super.cid;
    var cachedCtors = extendOptions._Ctor || (extendOptions._Ctor = {});
    if (cachedCtors[SuperId]) {
      return cachedCtors[SuperId]
    }

    var name = extendOptions.name || Super.options.name;
    if (false) {
      validateComponentName(name);
    }

    var Sub = function VueComponent (options) {
      this._init(options);
    };
    Sub.prototype = Object.create(Super.prototype);
    Sub.prototype.constructor = Sub;
    Sub.cid = cid++;
    Sub.options = mergeOptions(
      Super.options,
      extendOptions
    );
    Sub['super'] = Super;

    // For props and computed properties, we define the proxy getters on
    // the Vue instances at extension time, on the extended prototype. This
    // avoids Object.defineProperty calls for each instance created.
    if (Sub.options.props) {
      initProps$1(Sub);
    }
    if (Sub.options.computed) {
      initComputed$1(Sub);
    }

    // allow further extension/mixin/plugin usage
    Sub.extend = Super.extend;
    Sub.mixin = Super.mixin;
    Sub.use = Super.use;

    // create asset registers, so extended classes
    // can have their private assets too.
    ASSET_TYPES.forEach(function (type) {
      Sub[type] = Super[type];
    });
    // enable recursive self-lookup
    if (name) {
      Sub.options.components[name] = Sub;
    }

    // keep a reference to the super options at extension time.
    // later at instantiation we can check if Super's options have
    // been updated.
    Sub.superOptions = Super.options;
    Sub.extendOptions = extendOptions;
    Sub.sealedOptions = extend({}, Sub.options);

    // cache constructor
    cachedCtors[SuperId] = Sub;
    return Sub
  };
}

function initProps$1 (Comp) {
  var props = Comp.options.props;
  for (var key in props) {
    proxy(Comp.prototype, "_props", key);
  }
}

function initComputed$1 (Comp) {
  var computed = Comp.options.computed;
  for (var key in computed) {
    defineComputed(Comp.prototype, key, computed[key]);
  }
}

/*  */

function initAssetRegisters (Vue) {
  /**
   * Create asset registration methods.
   */
  ASSET_TYPES.forEach(function (type) {
    Vue[type] = function (
      id,
      definition
    ) {
      if (!definition) {
        return this.options[type + 's'][id]
      } else {
        /* istanbul ignore if */
        if (false) {
          validateComponentName(id);
        }
        if (type === 'component' && isPlainObject(definition)) {
          definition.name = definition.name || id;
          definition = this.options._base.extend(definition);
        }
        if (type === 'directive' && typeof definition === 'function') {
          definition = { bind: definition, update: definition };
        }
        this.options[type + 's'][id] = definition;
        return definition
      }
    };
  });
}

/*  */



function getComponentName (opts) {
  return opts && (opts.Ctor.options.name || opts.tag)
}

function matches (pattern, name) {
  if (Array.isArray(pattern)) {
    return pattern.indexOf(name) > -1
  } else if (typeof pattern === 'string') {
    return pattern.split(',').indexOf(name) > -1
  } else if (isRegExp(pattern)) {
    return pattern.test(name)
  }
  /* istanbul ignore next */
  return false
}

function pruneCache (keepAliveInstance, filter) {
  var cache = keepAliveInstance.cache;
  var keys = keepAliveInstance.keys;
  var _vnode = keepAliveInstance._vnode;
  for (var key in cache) {
    var cachedNode = cache[key];
    if (cachedNode) {
      var name = getComponentName(cachedNode.componentOptions);
      if (name && !filter(name)) {
        pruneCacheEntry(cache, key, keys, _vnode);
      }
    }
  }
}

function pruneCacheEntry (
  cache,
  key,
  keys,
  current
) {
  var cached$$1 = cache[key];
  if (cached$$1 && (!current || cached$$1.tag !== current.tag)) {
    cached$$1.componentInstance.$destroy();
  }
  cache[key] = null;
  remove(keys, key);
}

var patternTypes = [String, RegExp, Array];

var KeepAlive = {
  name: 'keep-alive',
  abstract: true,

  props: {
    include: patternTypes,
    exclude: patternTypes,
    max: [String, Number]
  },

  created: function created () {
    this.cache = Object.create(null);
    this.keys = [];
  },

  destroyed: function destroyed () {
    for (var key in this.cache) {
      pruneCacheEntry(this.cache, key, this.keys);
    }
  },

  mounted: function mounted () {
    var this$1 = this;

    this.$watch('include', function (val) {
      pruneCache(this$1, function (name) { return matches(val, name); });
    });
    this.$watch('exclude', function (val) {
      pruneCache(this$1, function (name) { return !matches(val, name); });
    });
  },

  render: function render () {
    var slot = this.$slots.default;
    var vnode = getFirstComponentChild(slot);
    var componentOptions = vnode && vnode.componentOptions;
    if (componentOptions) {
      // check pattern
      var name = getComponentName(componentOptions);
      var ref = this;
      var include = ref.include;
      var exclude = ref.exclude;
      if (
        // not included
        (include && (!name || !matches(include, name))) ||
        // excluded
        (exclude && name && matches(exclude, name))
      ) {
        return vnode
      }

      var ref$1 = this;
      var cache = ref$1.cache;
      var keys = ref$1.keys;
      var key = vnode.key == null
        // same constructor may get registered as different local components
        // so cid alone is not enough (#3269)
        ? componentOptions.Ctor.cid + (componentOptions.tag ? ("::" + (componentOptions.tag)) : '')
        : vnode.key;
      if (cache[key]) {
        vnode.componentInstance = cache[key].componentInstance;
        // make current key freshest
        remove(keys, key);
        keys.push(key);
      } else {
        cache[key] = vnode;
        keys.push(key);
        // prune oldest entry
        if (this.max && keys.length > parseInt(this.max)) {
          pruneCacheEntry(cache, keys[0], keys, this._vnode);
        }
      }

      vnode.data.keepAlive = true;
    }
    return vnode || (slot && slot[0])
  }
};

var builtInComponents = {
  KeepAlive: KeepAlive
};

/*  */

function initGlobalAPI (Vue) {
  // config
  var configDef = {};
  configDef.get = function () { return config; };
  if (false) {
    configDef.set = function () {
      warn(
        'Do not replace the Vue.config object, set individual fields instead.'
      );
    };
  }
  Object.defineProperty(Vue, 'config', configDef);

  // exposed util methods.
  // NOTE: these are not considered part of the public API - avoid relying on
  // them unless you are aware of the risk.
  Vue.util = {
    warn: warn,
    extend: extend,
    mergeOptions: mergeOptions,
    defineReactive: defineReactive$$1
  };

  Vue.set = set;
  Vue.delete = del;
  Vue.nextTick = nextTick;

  // 2.6 explicit observable API
  Vue.observable = function (obj) {
    observe(obj);
    return obj
  };

  Vue.options = Object.create(null);
  ASSET_TYPES.forEach(function (type) {
    Vue.options[type + 's'] = Object.create(null);
  });

  // this is used to identify the "base" constructor to extend all plain-object
  // components with in Weex's multi-instance scenarios.
  Vue.options._base = Vue;

  extend(Vue.options.components, builtInComponents);

  initUse(Vue);
  initMixin$1(Vue);
  initExtend(Vue);
  initAssetRegisters(Vue);
}

initGlobalAPI(Vue);

Object.defineProperty(Vue.prototype, '$isServer', {
  get: isServerRendering
});

Object.defineProperty(Vue.prototype, '$ssrContext', {
  get: function get () {
    /* istanbul ignore next */
    return this.$vnode && this.$vnode.ssrContext
  }
});

// expose FunctionalRenderContext for ssr runtime helper installation
Object.defineProperty(Vue, 'FunctionalRenderContext', {
  value: FunctionalRenderContext
});

Vue.version = '2.6.12';

/*  */

// these are reserved for web because they are directly compiled away
// during template compilation
var isReservedAttr = makeMap('style,class');

// attributes that should be using props for binding
var acceptValue = makeMap('input,textarea,option,select,progress');
var mustUseProp = function (tag, type, attr) {
  return (
    (attr === 'value' && acceptValue(tag)) && type !== 'button' ||
    (attr === 'selected' && tag === 'option') ||
    (attr === 'checked' && tag === 'input') ||
    (attr === 'muted' && tag === 'video')
  )
};

var isEnumeratedAttr = makeMap('contenteditable,draggable,spellcheck');

var isValidContentEditableValue = makeMap('events,caret,typing,plaintext-only');

var convertEnumeratedValue = function (key, value) {
  return isFalsyAttrValue(value) || value === 'false'
    ? 'false'
    // allow arbitrary string value for contenteditable
    : key === 'contenteditable' && isValidContentEditableValue(value)
      ? value
      : 'true'
};

var isBooleanAttr = makeMap(
  'allowfullscreen,async,autofocus,autoplay,checked,compact,controls,declare,' +
  'default,defaultchecked,defaultmuted,defaultselected,defer,disabled,' +
  'enabled,formnovalidate,hidden,indeterminate,inert,ismap,itemscope,loop,multiple,' +
  'muted,nohref,noresize,noshade,novalidate,nowrap,open,pauseonexit,readonly,' +
  'required,reversed,scoped,seamless,selected,sortable,translate,' +
  'truespeed,typemustmatch,visible'
);

var xlinkNS = 'http://www.w3.org/1999/xlink';

var isXlink = function (name) {
  return name.charAt(5) === ':' && name.slice(0, 5) === 'xlink'
};

var getXlinkProp = function (name) {
  return isXlink(name) ? name.slice(6, name.length) : ''
};

var isFalsyAttrValue = function (val) {
  return val == null || val === false
};

/*  */

function genClassForVnode (vnode) {
  var data = vnode.data;
  var parentNode = vnode;
  var childNode = vnode;
  while (isDef(childNode.componentInstance)) {
    childNode = childNode.componentInstance._vnode;
    if (childNode && childNode.data) {
      data = mergeClassData(childNode.data, data);
    }
  }
  while (isDef(parentNode = parentNode.parent)) {
    if (parentNode && parentNode.data) {
      data = mergeClassData(data, parentNode.data);
    }
  }
  return renderClass(data.staticClass, data.class)
}

function mergeClassData (child, parent) {
  return {
    staticClass: concat(child.staticClass, parent.staticClass),
    class: isDef(child.class)
      ? [child.class, parent.class]
      : parent.class
  }
}

function renderClass (
  staticClass,
  dynamicClass
) {
  if (isDef(staticClass) || isDef(dynamicClass)) {
    return concat(staticClass, stringifyClass(dynamicClass))
  }
  /* istanbul ignore next */
  return ''
}

function concat (a, b) {
  return a ? b ? (a + ' ' + b) : a : (b || '')
}

function stringifyClass (value) {
  if (Array.isArray(value)) {
    return stringifyArray(value)
  }
  if (isObject(value)) {
    return stringifyObject(value)
  }
  if (typeof value === 'string') {
    return value
  }
  /* istanbul ignore next */
  return ''
}

function stringifyArray (value) {
  var res = '';
  var stringified;
  for (var i = 0, l = value.length; i < l; i++) {
    if (isDef(stringified = stringifyClass(value[i])) && stringified !== '') {
      if (res) { res += ' '; }
      res += stringified;
    }
  }
  return res
}

function stringifyObject (value) {
  var res = '';
  for (var key in value) {
    if (value[key]) {
      if (res) { res += ' '; }
      res += key;
    }
  }
  return res
}

/*  */

var namespaceMap = {
  svg: 'http://www.w3.org/2000/svg',
  math: 'http://www.w3.org/1998/Math/MathML'
};

var isHTMLTag = makeMap(
  'html,body,base,head,link,meta,style,title,' +
  'address,article,aside,footer,header,h1,h2,h3,h4,h5,h6,hgroup,nav,section,' +
  'div,dd,dl,dt,figcaption,figure,picture,hr,img,li,main,ol,p,pre,ul,' +
  'a,b,abbr,bdi,bdo,br,cite,code,data,dfn,em,i,kbd,mark,q,rp,rt,rtc,ruby,' +
  's,samp,small,span,strong,sub,sup,time,u,var,wbr,area,audio,map,track,video,' +
  'embed,object,param,source,canvas,script,noscript,del,ins,' +
  'caption,col,colgroup,table,thead,tbody,td,th,tr,' +
  'button,datalist,fieldset,form,input,label,legend,meter,optgroup,option,' +
  'output,progress,select,textarea,' +
  'details,dialog,menu,menuitem,summary,' +
  'content,element,shadow,template,blockquote,iframe,tfoot'
);

// this map is intentionally selective, only covering SVG elements that may
// contain child elements.
var isSVG = makeMap(
  'svg,animate,circle,clippath,cursor,defs,desc,ellipse,filter,font-face,' +
  'foreignObject,g,glyph,image,line,marker,mask,missing-glyph,path,pattern,' +
  'polygon,polyline,rect,switch,symbol,text,textpath,tspan,use,view',
  true
);

var isPreTag = function (tag) { return tag === 'pre'; };

var isReservedTag = function (tag) {
  return isHTMLTag(tag) || isSVG(tag)
};

function getTagNamespace (tag) {
  if (isSVG(tag)) {
    return 'svg'
  }
  // basic support for MathML
  // note it doesn't support other MathML elements being component roots
  if (tag === 'math') {
    return 'math'
  }
}

var unknownElementCache = Object.create(null);
function isUnknownElement (tag) {
  /* istanbul ignore if */
  if (!inBrowser) {
    return true
  }
  if (isReservedTag(tag)) {
    return false
  }
  tag = tag.toLowerCase();
  /* istanbul ignore if */
  if (unknownElementCache[tag] != null) {
    return unknownElementCache[tag]
  }
  var el = document.createElement(tag);
  if (tag.indexOf('-') > -1) {
    // http://stackoverflow.com/a/28210364/1070244
    return (unknownElementCache[tag] = (
      el.constructor === window.HTMLUnknownElement ||
      el.constructor === window.HTMLElement
    ))
  } else {
    return (unknownElementCache[tag] = /HTMLUnknownElement/.test(el.toString()))
  }
}

var isTextInputType = makeMap('text,number,password,search,email,tel,url');

/*  */

/**
 * Query an element selector if it's not an element already.
 */
function query (el) {
  if (typeof el === 'string') {
    var selected = document.querySelector(el);
    if (!selected) {
      "production" !== 'production' && warn(
        'Cannot find element: ' + el
      );
      return document.createElement('div')
    }
    return selected
  } else {
    return el
  }
}

/*  */

function createElement$1 (tagName, vnode) {
  var elm = document.createElement(tagName);
  if (tagName !== 'select') {
    return elm
  }
  // false or null will remove the attribute but undefined will not
  if (vnode.data && vnode.data.attrs && vnode.data.attrs.multiple !== undefined) {
    elm.setAttribute('multiple', 'multiple');
  }
  return elm
}

function createElementNS (namespace, tagName) {
  return document.createElementNS(namespaceMap[namespace], tagName)
}

function createTextNode (text) {
  return document.createTextNode(text)
}

function createComment (text) {
  return document.createComment(text)
}

function insertBefore (parentNode, newNode, referenceNode) {
  parentNode.insertBefore(newNode, referenceNode);
}

function removeChild (node, child) {
  node.removeChild(child);
}

function appendChild (node, child) {
  node.appendChild(child);
}

function parentNode (node) {
  return node.parentNode
}

function nextSibling (node) {
  return node.nextSibling
}

function tagName (node) {
  return node.tagName
}

function setTextContent (node, text) {
  node.textContent = text;
}

function setStyleScope (node, scopeId) {
  node.setAttribute(scopeId, '');
}

var nodeOps = /*#__PURE__*/Object.freeze({
  createElement: createElement$1,
  createElementNS: createElementNS,
  createTextNode: createTextNode,
  createComment: createComment,
  insertBefore: insertBefore,
  removeChild: removeChild,
  appendChild: appendChild,
  parentNode: parentNode,
  nextSibling: nextSibling,
  tagName: tagName,
  setTextContent: setTextContent,
  setStyleScope: setStyleScope
});

/*  */

var ref = {
  create: function create (_, vnode) {
    registerRef(vnode);
  },
  update: function update (oldVnode, vnode) {
    if (oldVnode.data.ref !== vnode.data.ref) {
      registerRef(oldVnode, true);
      registerRef(vnode);
    }
  },
  destroy: function destroy (vnode) {
    registerRef(vnode, true);
  }
};

function registerRef (vnode, isRemoval) {
  var key = vnode.data.ref;
  if (!isDef(key)) { return }

  var vm = vnode.context;
  var ref = vnode.componentInstance || vnode.elm;
  var refs = vm.$refs;
  if (isRemoval) {
    if (Array.isArray(refs[key])) {
      remove(refs[key], ref);
    } else if (refs[key] === ref) {
      refs[key] = undefined;
    }
  } else {
    if (vnode.data.refInFor) {
      if (!Array.isArray(refs[key])) {
        refs[key] = [ref];
      } else if (refs[key].indexOf(ref) < 0) {
        // $flow-disable-line
        refs[key].push(ref);
      }
    } else {
      refs[key] = ref;
    }
  }
}

/**
 * Virtual DOM patching algorithm based on Snabbdom by
 * Simon Friis Vindum (@paldepind)
 * Licensed under the MIT License
 * https://github.com/paldepind/snabbdom/blob/master/LICENSE
 *
 * modified by Evan You (@yyx990803)
 *
 * Not type-checking this because this file is perf-critical and the cost
 * of making flow understand it is not worth it.
 */

var emptyNode = new VNode('', {}, []);

var hooks = ['create', 'activate', 'update', 'remove', 'destroy'];

function sameVnode (a, b) {
  return (
    a.key === b.key && (
      (
        a.tag === b.tag &&
        a.isComment === b.isComment &&
        isDef(a.data) === isDef(b.data) &&
        sameInputType(a, b)
      ) || (
        isTrue(a.isAsyncPlaceholder) &&
        a.asyncFactory === b.asyncFactory &&
        isUndef(b.asyncFactory.error)
      )
    )
  )
}

function sameInputType (a, b) {
  if (a.tag !== 'input') { return true }
  var i;
  var typeA = isDef(i = a.data) && isDef(i = i.attrs) && i.type;
  var typeB = isDef(i = b.data) && isDef(i = i.attrs) && i.type;
  return typeA === typeB || isTextInputType(typeA) && isTextInputType(typeB)
}

function createKeyToOldIdx (children, beginIdx, endIdx) {
  var i, key;
  var map = {};
  for (i = beginIdx; i <= endIdx; ++i) {
    key = children[i].key;
    if (isDef(key)) { map[key] = i; }
  }
  return map
}

function createPatchFunction (backend) {
  var i, j;
  var cbs = {};

  var modules = backend.modules;
  var nodeOps = backend.nodeOps;

  for (i = 0; i < hooks.length; ++i) {
    cbs[hooks[i]] = [];
    for (j = 0; j < modules.length; ++j) {
      if (isDef(modules[j][hooks[i]])) {
        cbs[hooks[i]].push(modules[j][hooks[i]]);
      }
    }
  }

  function emptyNodeAt (elm) {
    return new VNode(nodeOps.tagName(elm).toLowerCase(), {}, [], undefined, elm)
  }

  function createRmCb (childElm, listeners) {
    function remove$$1 () {
      if (--remove$$1.listeners === 0) {
        removeNode(childElm);
      }
    }
    remove$$1.listeners = listeners;
    return remove$$1
  }

  function removeNode (el) {
    var parent = nodeOps.parentNode(el);
    // element may have already been removed due to v-html / v-text
    if (isDef(parent)) {
      nodeOps.removeChild(parent, el);
    }
  }

  function isUnknownElement$$1 (vnode, inVPre) {
    return (
      !inVPre &&
      !vnode.ns &&
      !(
        config.ignoredElements.length &&
        config.ignoredElements.some(function (ignore) {
          return isRegExp(ignore)
            ? ignore.test(vnode.tag)
            : ignore === vnode.tag
        })
      ) &&
      config.isUnknownElement(vnode.tag)
    )
  }

  var creatingElmInVPre = 0;

  function createElm (
    vnode,
    insertedVnodeQueue,
    parentElm,
    refElm,
    nested,
    ownerArray,
    index
  ) {
    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // This vnode was used in a previous render!
      // now it's used as a new node, overwriting its elm would cause
      // potential patch errors down the road when it's used as an insertion
      // reference node. Instead, we clone the node on-demand before creating
      // associated DOM element for it.
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    vnode.isRootInsert = !nested; // for transition enter check
    if (createComponent(vnode, insertedVnodeQueue, parentElm, refElm)) {
      return
    }

    var data = vnode.data;
    var children = vnode.children;
    var tag = vnode.tag;
    if (isDef(tag)) {
      if (false) {
        if (data && data.pre) {
          creatingElmInVPre++;
        }
        if (isUnknownElement$$1(vnode, creatingElmInVPre)) {
          warn(
            'Unknown custom element: <' + tag + '> - did you ' +
            'register the component correctly? For recursive components, ' +
            'make sure to provide the "name" option.',
            vnode.context
          );
        }
      }

      vnode.elm = vnode.ns
        ? nodeOps.createElementNS(vnode.ns, tag)
        : nodeOps.createElement(tag, vnode);
      setScope(vnode);

      /* istanbul ignore if */
      {
        createChildren(vnode, children, insertedVnodeQueue);
        if (isDef(data)) {
          invokeCreateHooks(vnode, insertedVnodeQueue);
        }
        insert(parentElm, vnode.elm, refElm);
      }

      if (false) {
        creatingElmInVPre--;
      }
    } else if (isTrue(vnode.isComment)) {
      vnode.elm = nodeOps.createComment(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    } else {
      vnode.elm = nodeOps.createTextNode(vnode.text);
      insert(parentElm, vnode.elm, refElm);
    }
  }

  function createComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i = vnode.data;
    if (isDef(i)) {
      var isReactivated = isDef(vnode.componentInstance) && i.keepAlive;
      if (isDef(i = i.hook) && isDef(i = i.init)) {
        i(vnode, false /* hydrating */);
      }
      // after calling the init hook, if the vnode is a child component
      // it should've created a child instance and mounted it. the child
      // component also has set the placeholder vnode's elm.
      // in that case we can just return the element and be done.
      if (isDef(vnode.componentInstance)) {
        initComponent(vnode, insertedVnodeQueue);
        insert(parentElm, vnode.elm, refElm);
        if (isTrue(isReactivated)) {
          reactivateComponent(vnode, insertedVnodeQueue, parentElm, refElm);
        }
        return true
      }
    }
  }

  function initComponent (vnode, insertedVnodeQueue) {
    if (isDef(vnode.data.pendingInsert)) {
      insertedVnodeQueue.push.apply(insertedVnodeQueue, vnode.data.pendingInsert);
      vnode.data.pendingInsert = null;
    }
    vnode.elm = vnode.componentInstance.$el;
    if (isPatchable(vnode)) {
      invokeCreateHooks(vnode, insertedVnodeQueue);
      setScope(vnode);
    } else {
      // empty component root.
      // skip all element-related modules except for ref (#3455)
      registerRef(vnode);
      // make sure to invoke the insert hook
      insertedVnodeQueue.push(vnode);
    }
  }

  function reactivateComponent (vnode, insertedVnodeQueue, parentElm, refElm) {
    var i;
    // hack for #4339: a reactivated component with inner transition
    // does not trigger because the inner node's created hooks are not called
    // again. It's not ideal to involve module-specific logic in here but
    // there doesn't seem to be a better way to do it.
    var innerNode = vnode;
    while (innerNode.componentInstance) {
      innerNode = innerNode.componentInstance._vnode;
      if (isDef(i = innerNode.data) && isDef(i = i.transition)) {
        for (i = 0; i < cbs.activate.length; ++i) {
          cbs.activate[i](emptyNode, innerNode);
        }
        insertedVnodeQueue.push(innerNode);
        break
      }
    }
    // unlike a newly created component,
    // a reactivated keep-alive component doesn't insert itself
    insert(parentElm, vnode.elm, refElm);
  }

  function insert (parent, elm, ref$$1) {
    if (isDef(parent)) {
      if (isDef(ref$$1)) {
        if (nodeOps.parentNode(ref$$1) === parent) {
          nodeOps.insertBefore(parent, elm, ref$$1);
        }
      } else {
        nodeOps.appendChild(parent, elm);
      }
    }
  }

  function createChildren (vnode, children, insertedVnodeQueue) {
    if (Array.isArray(children)) {
      if (false) {
        checkDuplicateKeys(children);
      }
      for (var i = 0; i < children.length; ++i) {
        createElm(children[i], insertedVnodeQueue, vnode.elm, null, true, children, i);
      }
    } else if (isPrimitive(vnode.text)) {
      nodeOps.appendChild(vnode.elm, nodeOps.createTextNode(String(vnode.text)));
    }
  }

  function isPatchable (vnode) {
    while (vnode.componentInstance) {
      vnode = vnode.componentInstance._vnode;
    }
    return isDef(vnode.tag)
  }

  function invokeCreateHooks (vnode, insertedVnodeQueue) {
    for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
      cbs.create[i$1](emptyNode, vnode);
    }
    i = vnode.data.hook; // Reuse variable
    if (isDef(i)) {
      if (isDef(i.create)) { i.create(emptyNode, vnode); }
      if (isDef(i.insert)) { insertedVnodeQueue.push(vnode); }
    }
  }

  // set scope id attribute for scoped CSS.
  // this is implemented as a special case to avoid the overhead
  // of going through the normal attribute patching process.
  function setScope (vnode) {
    var i;
    if (isDef(i = vnode.fnScopeId)) {
      nodeOps.setStyleScope(vnode.elm, i);
    } else {
      var ancestor = vnode;
      while (ancestor) {
        if (isDef(i = ancestor.context) && isDef(i = i.$options._scopeId)) {
          nodeOps.setStyleScope(vnode.elm, i);
        }
        ancestor = ancestor.parent;
      }
    }
    // for slot content they should also get the scopeId from the host instance.
    if (isDef(i = activeInstance) &&
      i !== vnode.context &&
      i !== vnode.fnContext &&
      isDef(i = i.$options._scopeId)
    ) {
      nodeOps.setStyleScope(vnode.elm, i);
    }
  }

  function addVnodes (parentElm, refElm, vnodes, startIdx, endIdx, insertedVnodeQueue) {
    for (; startIdx <= endIdx; ++startIdx) {
      createElm(vnodes[startIdx], insertedVnodeQueue, parentElm, refElm, false, vnodes, startIdx);
    }
  }

  function invokeDestroyHook (vnode) {
    var i, j;
    var data = vnode.data;
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.destroy)) { i(vnode); }
      for (i = 0; i < cbs.destroy.length; ++i) { cbs.destroy[i](vnode); }
    }
    if (isDef(i = vnode.children)) {
      for (j = 0; j < vnode.children.length; ++j) {
        invokeDestroyHook(vnode.children[j]);
      }
    }
  }

  function removeVnodes (vnodes, startIdx, endIdx) {
    for (; startIdx <= endIdx; ++startIdx) {
      var ch = vnodes[startIdx];
      if (isDef(ch)) {
        if (isDef(ch.tag)) {
          removeAndInvokeRemoveHook(ch);
          invokeDestroyHook(ch);
        } else { // Text node
          removeNode(ch.elm);
        }
      }
    }
  }

  function removeAndInvokeRemoveHook (vnode, rm) {
    if (isDef(rm) || isDef(vnode.data)) {
      var i;
      var listeners = cbs.remove.length + 1;
      if (isDef(rm)) {
        // we have a recursively passed down rm callback
        // increase the listeners count
        rm.listeners += listeners;
      } else {
        // directly removing
        rm = createRmCb(vnode.elm, listeners);
      }
      // recursively invoke hooks on child component root node
      if (isDef(i = vnode.componentInstance) && isDef(i = i._vnode) && isDef(i.data)) {
        removeAndInvokeRemoveHook(i, rm);
      }
      for (i = 0; i < cbs.remove.length; ++i) {
        cbs.remove[i](vnode, rm);
      }
      if (isDef(i = vnode.data.hook) && isDef(i = i.remove)) {
        i(vnode, rm);
      } else {
        rm();
      }
    } else {
      removeNode(vnode.elm);
    }
  }

  function updateChildren (parentElm, oldCh, newCh, insertedVnodeQueue, removeOnly) {
    var oldStartIdx = 0;
    var newStartIdx = 0;
    var oldEndIdx = oldCh.length - 1;
    var oldStartVnode = oldCh[0];
    var oldEndVnode = oldCh[oldEndIdx];
    var newEndIdx = newCh.length - 1;
    var newStartVnode = newCh[0];
    var newEndVnode = newCh[newEndIdx];
    var oldKeyToIdx, idxInOld, vnodeToMove, refElm;

    // removeOnly is a special flag used only by <transition-group>
    // to ensure removed elements stay in correct relative positions
    // during leaving transitions
    var canMove = !removeOnly;

    if (false) {
      checkDuplicateKeys(newCh);
    }

    while (oldStartIdx <= oldEndIdx && newStartIdx <= newEndIdx) {
      if (isUndef(oldStartVnode)) {
        oldStartVnode = oldCh[++oldStartIdx]; // Vnode has been moved left
      } else if (isUndef(oldEndVnode)) {
        oldEndVnode = oldCh[--oldEndIdx];
      } else if (sameVnode(oldStartVnode, newStartVnode)) {
        patchVnode(oldStartVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        oldStartVnode = oldCh[++oldStartIdx];
        newStartVnode = newCh[++newStartIdx];
      } else if (sameVnode(oldEndVnode, newEndVnode)) {
        patchVnode(oldEndVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        oldEndVnode = oldCh[--oldEndIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldStartVnode, newEndVnode)) { // Vnode moved right
        patchVnode(oldStartVnode, newEndVnode, insertedVnodeQueue, newCh, newEndIdx);
        canMove && nodeOps.insertBefore(parentElm, oldStartVnode.elm, nodeOps.nextSibling(oldEndVnode.elm));
        oldStartVnode = oldCh[++oldStartIdx];
        newEndVnode = newCh[--newEndIdx];
      } else if (sameVnode(oldEndVnode, newStartVnode)) { // Vnode moved left
        patchVnode(oldEndVnode, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
        canMove && nodeOps.insertBefore(parentElm, oldEndVnode.elm, oldStartVnode.elm);
        oldEndVnode = oldCh[--oldEndIdx];
        newStartVnode = newCh[++newStartIdx];
      } else {
        if (isUndef(oldKeyToIdx)) { oldKeyToIdx = createKeyToOldIdx(oldCh, oldStartIdx, oldEndIdx); }
        idxInOld = isDef(newStartVnode.key)
          ? oldKeyToIdx[newStartVnode.key]
          : findIdxInOld(newStartVnode, oldCh, oldStartIdx, oldEndIdx);
        if (isUndef(idxInOld)) { // New element
          createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
        } else {
          vnodeToMove = oldCh[idxInOld];
          if (sameVnode(vnodeToMove, newStartVnode)) {
            patchVnode(vnodeToMove, newStartVnode, insertedVnodeQueue, newCh, newStartIdx);
            oldCh[idxInOld] = undefined;
            canMove && nodeOps.insertBefore(parentElm, vnodeToMove.elm, oldStartVnode.elm);
          } else {
            // same key but different element. treat as new element
            createElm(newStartVnode, insertedVnodeQueue, parentElm, oldStartVnode.elm, false, newCh, newStartIdx);
          }
        }
        newStartVnode = newCh[++newStartIdx];
      }
    }
    if (oldStartIdx > oldEndIdx) {
      refElm = isUndef(newCh[newEndIdx + 1]) ? null : newCh[newEndIdx + 1].elm;
      addVnodes(parentElm, refElm, newCh, newStartIdx, newEndIdx, insertedVnodeQueue);
    } else if (newStartIdx > newEndIdx) {
      removeVnodes(oldCh, oldStartIdx, oldEndIdx);
    }
  }

  function checkDuplicateKeys (children) {
    var seenKeys = {};
    for (var i = 0; i < children.length; i++) {
      var vnode = children[i];
      var key = vnode.key;
      if (isDef(key)) {
        if (seenKeys[key]) {
          warn(
            ("Duplicate keys detected: '" + key + "'. This may cause an update error."),
            vnode.context
          );
        } else {
          seenKeys[key] = true;
        }
      }
    }
  }

  function findIdxInOld (node, oldCh, start, end) {
    for (var i = start; i < end; i++) {
      var c = oldCh[i];
      if (isDef(c) && sameVnode(node, c)) { return i }
    }
  }

  function patchVnode (
    oldVnode,
    vnode,
    insertedVnodeQueue,
    ownerArray,
    index,
    removeOnly
  ) {
    if (oldVnode === vnode) {
      return
    }

    if (isDef(vnode.elm) && isDef(ownerArray)) {
      // clone reused vnode
      vnode = ownerArray[index] = cloneVNode(vnode);
    }

    var elm = vnode.elm = oldVnode.elm;

    if (isTrue(oldVnode.isAsyncPlaceholder)) {
      if (isDef(vnode.asyncFactory.resolved)) {
        hydrate(oldVnode.elm, vnode, insertedVnodeQueue);
      } else {
        vnode.isAsyncPlaceholder = true;
      }
      return
    }

    // reuse element for static trees.
    // note we only do this if the vnode is cloned -
    // if the new node is not cloned it means the render functions have been
    // reset by the hot-reload-api and we need to do a proper re-render.
    if (isTrue(vnode.isStatic) &&
      isTrue(oldVnode.isStatic) &&
      vnode.key === oldVnode.key &&
      (isTrue(vnode.isCloned) || isTrue(vnode.isOnce))
    ) {
      vnode.componentInstance = oldVnode.componentInstance;
      return
    }

    var i;
    var data = vnode.data;
    if (isDef(data) && isDef(i = data.hook) && isDef(i = i.prepatch)) {
      i(oldVnode, vnode);
    }

    var oldCh = oldVnode.children;
    var ch = vnode.children;
    if (isDef(data) && isPatchable(vnode)) {
      for (i = 0; i < cbs.update.length; ++i) { cbs.update[i](oldVnode, vnode); }
      if (isDef(i = data.hook) && isDef(i = i.update)) { i(oldVnode, vnode); }
    }
    if (isUndef(vnode.text)) {
      if (isDef(oldCh) && isDef(ch)) {
        if (oldCh !== ch) { updateChildren(elm, oldCh, ch, insertedVnodeQueue, removeOnly); }
      } else if (isDef(ch)) {
        if (false) {
          checkDuplicateKeys(ch);
        }
        if (isDef(oldVnode.text)) { nodeOps.setTextContent(elm, ''); }
        addVnodes(elm, null, ch, 0, ch.length - 1, insertedVnodeQueue);
      } else if (isDef(oldCh)) {
        removeVnodes(oldCh, 0, oldCh.length - 1);
      } else if (isDef(oldVnode.text)) {
        nodeOps.setTextContent(elm, '');
      }
    } else if (oldVnode.text !== vnode.text) {
      nodeOps.setTextContent(elm, vnode.text);
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.postpatch)) { i(oldVnode, vnode); }
    }
  }

  function invokeInsertHook (vnode, queue, initial) {
    // delay insert hooks for component root nodes, invoke them after the
    // element is really inserted
    if (isTrue(initial) && isDef(vnode.parent)) {
      vnode.parent.data.pendingInsert = queue;
    } else {
      for (var i = 0; i < queue.length; ++i) {
        queue[i].data.hook.insert(queue[i]);
      }
    }
  }

  var hydrationBailed = false;
  // list of modules that can skip create hook during hydration because they
  // are already rendered on the client or has no need for initialization
  // Note: style is excluded because it relies on initial clone for future
  // deep updates (#7063).
  var isRenderedModule = makeMap('attrs,class,staticClass,staticStyle,key');

  // Note: this is a browser-only function so we can assume elms are DOM nodes.
  function hydrate (elm, vnode, insertedVnodeQueue, inVPre) {
    var i;
    var tag = vnode.tag;
    var data = vnode.data;
    var children = vnode.children;
    inVPre = inVPre || (data && data.pre);
    vnode.elm = elm;

    if (isTrue(vnode.isComment) && isDef(vnode.asyncFactory)) {
      vnode.isAsyncPlaceholder = true;
      return true
    }
    // assert node match
    if (false) {
      if (!assertNodeMatch(elm, vnode, inVPre)) {
        return false
      }
    }
    if (isDef(data)) {
      if (isDef(i = data.hook) && isDef(i = i.init)) { i(vnode, true /* hydrating */); }
      if (isDef(i = vnode.componentInstance)) {
        // child component. it should have hydrated its own tree.
        initComponent(vnode, insertedVnodeQueue);
        return true
      }
    }
    if (isDef(tag)) {
      if (isDef(children)) {
        // empty element, allow client to pick up and populate children
        if (!elm.hasChildNodes()) {
          createChildren(vnode, children, insertedVnodeQueue);
        } else {
          // v-html and domProps: innerHTML
          if (isDef(i = data) && isDef(i = i.domProps) && isDef(i = i.innerHTML)) {
            if (i !== elm.innerHTML) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('server innerHTML: ', i);
                console.warn('client innerHTML: ', elm.innerHTML);
              }
              return false
            }
          } else {
            // iterate and compare children lists
            var childrenMatch = true;
            var childNode = elm.firstChild;
            for (var i$1 = 0; i$1 < children.length; i$1++) {
              if (!childNode || !hydrate(childNode, children[i$1], insertedVnodeQueue, inVPre)) {
                childrenMatch = false;
                break
              }
              childNode = childNode.nextSibling;
            }
            // if childNode is not null, it means the actual childNodes list is
            // longer than the virtual children list.
            if (!childrenMatch || childNode) {
              /* istanbul ignore if */
              if (false
              ) {
                hydrationBailed = true;
                console.warn('Parent: ', elm);
                console.warn('Mismatching childNodes vs. VNodes: ', elm.childNodes, children);
              }
              return false
            }
          }
        }
      }
      if (isDef(data)) {
        var fullInvoke = false;
        for (var key in data) {
          if (!isRenderedModule(key)) {
            fullInvoke = true;
            invokeCreateHooks(vnode, insertedVnodeQueue);
            break
          }
        }
        if (!fullInvoke && data['class']) {
          // ensure collecting deps for deep class bindings for future updates
          traverse(data['class']);
        }
      }
    } else if (elm.data !== vnode.text) {
      elm.data = vnode.text;
    }
    return true
  }

  function assertNodeMatch (node, vnode, inVPre) {
    if (isDef(vnode.tag)) {
      return vnode.tag.indexOf('vue-component') === 0 || (
        !isUnknownElement$$1(vnode, inVPre) &&
        vnode.tag.toLowerCase() === (node.tagName && node.tagName.toLowerCase())
      )
    } else {
      return node.nodeType === (vnode.isComment ? 8 : 3)
    }
  }

  return function patch (oldVnode, vnode, hydrating, removeOnly) {
    if (isUndef(vnode)) {
      if (isDef(oldVnode)) { invokeDestroyHook(oldVnode); }
      return
    }

    var isInitialPatch = false;
    var insertedVnodeQueue = [];

    if (isUndef(oldVnode)) {
      // empty mount (likely as component), create new root element
      isInitialPatch = true;
      createElm(vnode, insertedVnodeQueue);
    } else {
      var isRealElement = isDef(oldVnode.nodeType);
      if (!isRealElement && sameVnode(oldVnode, vnode)) {
        // patch existing root node
        patchVnode(oldVnode, vnode, insertedVnodeQueue, null, null, removeOnly);
      } else {
        if (isRealElement) {
          // mounting to a real element
          // check if this is server-rendered content and if we can perform
          // a successful hydration.
          if (oldVnode.nodeType === 1 && oldVnode.hasAttribute(SSR_ATTR)) {
            oldVnode.removeAttribute(SSR_ATTR);
            hydrating = true;
          }
          if (isTrue(hydrating)) {
            if (hydrate(oldVnode, vnode, insertedVnodeQueue)) {
              invokeInsertHook(vnode, insertedVnodeQueue, true);
              return oldVnode
            } else if (false) {
              warn(
                'The client-side rendered virtual DOM tree is not matching ' +
                'server-rendered content. This is likely caused by incorrect ' +
                'HTML markup, for example nesting block-level elements inside ' +
                '<p>, or missing <tbody>. Bailing hydration and performing ' +
                'full client-side render.'
              );
            }
          }
          // either not server-rendered, or hydration failed.
          // create an empty node and replace it
          oldVnode = emptyNodeAt(oldVnode);
        }

        // replacing existing element
        var oldElm = oldVnode.elm;
        var parentElm = nodeOps.parentNode(oldElm);

        // create new node
        createElm(
          vnode,
          insertedVnodeQueue,
          // extremely rare edge case: do not insert if old element is in a
          // leaving transition. Only happens when combining transition +
          // keep-alive + HOCs. (#4590)
          oldElm._leaveCb ? null : parentElm,
          nodeOps.nextSibling(oldElm)
        );

        // update parent placeholder node element, recursively
        if (isDef(vnode.parent)) {
          var ancestor = vnode.parent;
          var patchable = isPatchable(vnode);
          while (ancestor) {
            for (var i = 0; i < cbs.destroy.length; ++i) {
              cbs.destroy[i](ancestor);
            }
            ancestor.elm = vnode.elm;
            if (patchable) {
              for (var i$1 = 0; i$1 < cbs.create.length; ++i$1) {
                cbs.create[i$1](emptyNode, ancestor);
              }
              // #6513
              // invoke insert hooks that may have been merged by create hooks.
              // e.g. for directives that uses the "inserted" hook.
              var insert = ancestor.data.hook.insert;
              if (insert.merged) {
                // start at index 1 to avoid re-invoking component mounted hook
                for (var i$2 = 1; i$2 < insert.fns.length; i$2++) {
                  insert.fns[i$2]();
                }
              }
            } else {
              registerRef(ancestor);
            }
            ancestor = ancestor.parent;
          }
        }

        // destroy old node
        if (isDef(parentElm)) {
          removeVnodes([oldVnode], 0, 0);
        } else if (isDef(oldVnode.tag)) {
          invokeDestroyHook(oldVnode);
        }
      }
    }

    invokeInsertHook(vnode, insertedVnodeQueue, isInitialPatch);
    return vnode.elm
  }
}

/*  */

var directives = {
  create: updateDirectives,
  update: updateDirectives,
  destroy: function unbindDirectives (vnode) {
    updateDirectives(vnode, emptyNode);
  }
};

function updateDirectives (oldVnode, vnode) {
  if (oldVnode.data.directives || vnode.data.directives) {
    _update(oldVnode, vnode);
  }
}

function _update (oldVnode, vnode) {
  var isCreate = oldVnode === emptyNode;
  var isDestroy = vnode === emptyNode;
  var oldDirs = normalizeDirectives$1(oldVnode.data.directives, oldVnode.context);
  var newDirs = normalizeDirectives$1(vnode.data.directives, vnode.context);

  var dirsWithInsert = [];
  var dirsWithPostpatch = [];

  var key, oldDir, dir;
  for (key in newDirs) {
    oldDir = oldDirs[key];
    dir = newDirs[key];
    if (!oldDir) {
      // new directive, bind
      callHook$1(dir, 'bind', vnode, oldVnode);
      if (dir.def && dir.def.inserted) {
        dirsWithInsert.push(dir);
      }
    } else {
      // existing directive, update
      dir.oldValue = oldDir.value;
      dir.oldArg = oldDir.arg;
      callHook$1(dir, 'update', vnode, oldVnode);
      if (dir.def && dir.def.componentUpdated) {
        dirsWithPostpatch.push(dir);
      }
    }
  }

  if (dirsWithInsert.length) {
    var callInsert = function () {
      for (var i = 0; i < dirsWithInsert.length; i++) {
        callHook$1(dirsWithInsert[i], 'inserted', vnode, oldVnode);
      }
    };
    if (isCreate) {
      mergeVNodeHook(vnode, 'insert', callInsert);
    } else {
      callInsert();
    }
  }

  if (dirsWithPostpatch.length) {
    mergeVNodeHook(vnode, 'postpatch', function () {
      for (var i = 0; i < dirsWithPostpatch.length; i++) {
        callHook$1(dirsWithPostpatch[i], 'componentUpdated', vnode, oldVnode);
      }
    });
  }

  if (!isCreate) {
    for (key in oldDirs) {
      if (!newDirs[key]) {
        // no longer present, unbind
        callHook$1(oldDirs[key], 'unbind', oldVnode, oldVnode, isDestroy);
      }
    }
  }
}

var emptyModifiers = Object.create(null);

function normalizeDirectives$1 (
  dirs,
  vm
) {
  var res = Object.create(null);
  if (!dirs) {
    // $flow-disable-line
    return res
  }
  var i, dir;
  for (i = 0; i < dirs.length; i++) {
    dir = dirs[i];
    if (!dir.modifiers) {
      // $flow-disable-line
      dir.modifiers = emptyModifiers;
    }
    res[getRawDirName(dir)] = dir;
    dir.def = resolveAsset(vm.$options, 'directives', dir.name, true);
  }
  // $flow-disable-line
  return res
}

function getRawDirName (dir) {
  return dir.rawName || ((dir.name) + "." + (Object.keys(dir.modifiers || {}).join('.')))
}

function callHook$1 (dir, hook, vnode, oldVnode, isDestroy) {
  var fn = dir.def && dir.def[hook];
  if (fn) {
    try {
      fn(vnode.elm, dir, vnode, oldVnode, isDestroy);
    } catch (e) {
      handleError(e, vnode.context, ("directive " + (dir.name) + " " + hook + " hook"));
    }
  }
}

var baseModules = [
  ref,
  directives
];

/*  */

function updateAttrs (oldVnode, vnode) {
  var opts = vnode.componentOptions;
  if (isDef(opts) && opts.Ctor.options.inheritAttrs === false) {
    return
  }
  if (isUndef(oldVnode.data.attrs) && isUndef(vnode.data.attrs)) {
    return
  }
  var key, cur, old;
  var elm = vnode.elm;
  var oldAttrs = oldVnode.data.attrs || {};
  var attrs = vnode.data.attrs || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(attrs.__ob__)) {
    attrs = vnode.data.attrs = extend({}, attrs);
  }

  for (key in attrs) {
    cur = attrs[key];
    old = oldAttrs[key];
    if (old !== cur) {
      setAttr(elm, key, cur);
    }
  }
  // #4391: in IE9, setting type can reset value for input[type=radio]
  // #6666: IE/Edge forces progress value down to 1 before setting a max
  /* istanbul ignore if */
  if ((isIE || isEdge) && attrs.value !== oldAttrs.value) {
    setAttr(elm, 'value', attrs.value);
  }
  for (key in oldAttrs) {
    if (isUndef(attrs[key])) {
      if (isXlink(key)) {
        elm.removeAttributeNS(xlinkNS, getXlinkProp(key));
      } else if (!isEnumeratedAttr(key)) {
        elm.removeAttribute(key);
      }
    }
  }
}

function setAttr (el, key, value) {
  if (el.tagName.indexOf('-') > -1) {
    baseSetAttr(el, key, value);
  } else if (isBooleanAttr(key)) {
    // set attribute for blank value
    // e.g. <option disabled>Select one</option>
    if (isFalsyAttrValue(value)) {
      el.removeAttribute(key);
    } else {
      // technically allowfullscreen is a boolean attribute for <iframe>,
      // but Flash expects a value of "true" when used on <embed> tag
      value = key === 'allowfullscreen' && el.tagName === 'EMBED'
        ? 'true'
        : key;
      el.setAttribute(key, value);
    }
  } else if (isEnumeratedAttr(key)) {
    el.setAttribute(key, convertEnumeratedValue(key, value));
  } else if (isXlink(key)) {
    if (isFalsyAttrValue(value)) {
      el.removeAttributeNS(xlinkNS, getXlinkProp(key));
    } else {
      el.setAttributeNS(xlinkNS, key, value);
    }
  } else {
    baseSetAttr(el, key, value);
  }
}

function baseSetAttr (el, key, value) {
  if (isFalsyAttrValue(value)) {
    el.removeAttribute(key);
  } else {
    // #7138: IE10 & 11 fires input event when setting placeholder on
    // <textarea>... block the first input event and remove the blocker
    // immediately.
    /* istanbul ignore if */
    if (
      isIE && !isIE9 &&
      el.tagName === 'TEXTAREA' &&
      key === 'placeholder' && value !== '' && !el.__ieph
    ) {
      var blocker = function (e) {
        e.stopImmediatePropagation();
        el.removeEventListener('input', blocker);
      };
      el.addEventListener('input', blocker);
      // $flow-disable-line
      el.__ieph = true; /* IE placeholder patched */
    }
    el.setAttribute(key, value);
  }
}

var attrs = {
  create: updateAttrs,
  update: updateAttrs
};

/*  */

function updateClass (oldVnode, vnode) {
  var el = vnode.elm;
  var data = vnode.data;
  var oldData = oldVnode.data;
  if (
    isUndef(data.staticClass) &&
    isUndef(data.class) && (
      isUndef(oldData) || (
        isUndef(oldData.staticClass) &&
        isUndef(oldData.class)
      )
    )
  ) {
    return
  }

  var cls = genClassForVnode(vnode);

  // handle transition classes
  var transitionClass = el._transitionClasses;
  if (isDef(transitionClass)) {
    cls = concat(cls, stringifyClass(transitionClass));
  }

  // set the class
  if (cls !== el._prevClass) {
    el.setAttribute('class', cls);
    el._prevClass = cls;
  }
}

var klass = {
  create: updateClass,
  update: updateClass
};

/*  */

var validDivisionCharRE = /[\w).+\-_$\]]/;

function parseFilters (exp) {
  var inSingle = false;
  var inDouble = false;
  var inTemplateString = false;
  var inRegex = false;
  var curly = 0;
  var square = 0;
  var paren = 0;
  var lastFilterIndex = 0;
  var c, prev, i, expression, filters;

  for (i = 0; i < exp.length; i++) {
    prev = c;
    c = exp.charCodeAt(i);
    if (inSingle) {
      if (c === 0x27 && prev !== 0x5C) { inSingle = false; }
    } else if (inDouble) {
      if (c === 0x22 && prev !== 0x5C) { inDouble = false; }
    } else if (inTemplateString) {
      if (c === 0x60 && prev !== 0x5C) { inTemplateString = false; }
    } else if (inRegex) {
      if (c === 0x2f && prev !== 0x5C) { inRegex = false; }
    } else if (
      c === 0x7C && // pipe
      exp.charCodeAt(i + 1) !== 0x7C &&
      exp.charCodeAt(i - 1) !== 0x7C &&
      !curly && !square && !paren
    ) {
      if (expression === undefined) {
        // first filter, end of expression
        lastFilterIndex = i + 1;
        expression = exp.slice(0, i).trim();
      } else {
        pushFilter();
      }
    } else {
      switch (c) {
        case 0x22: inDouble = true; break         // "
        case 0x27: inSingle = true; break         // '
        case 0x60: inTemplateString = true; break // `
        case 0x28: paren++; break                 // (
        case 0x29: paren--; break                 // )
        case 0x5B: square++; break                // [
        case 0x5D: square--; break                // ]
        case 0x7B: curly++; break                 // {
        case 0x7D: curly--; break                 // }
      }
      if (c === 0x2f) { // /
        var j = i - 1;
        var p = (void 0);
        // find first non-whitespace prev char
        for (; j >= 0; j--) {
          p = exp.charAt(j);
          if (p !== ' ') { break }
        }
        if (!p || !validDivisionCharRE.test(p)) {
          inRegex = true;
        }
      }
    }
  }

  if (expression === undefined) {
    expression = exp.slice(0, i).trim();
  } else if (lastFilterIndex !== 0) {
    pushFilter();
  }

  function pushFilter () {
    (filters || (filters = [])).push(exp.slice(lastFilterIndex, i).trim());
    lastFilterIndex = i + 1;
  }

  if (filters) {
    for (i = 0; i < filters.length; i++) {
      expression = wrapFilter(expression, filters[i]);
    }
  }

  return expression
}

function wrapFilter (exp, filter) {
  var i = filter.indexOf('(');
  if (i < 0) {
    // _f: resolveFilter
    return ("_f(\"" + filter + "\")(" + exp + ")")
  } else {
    var name = filter.slice(0, i);
    var args = filter.slice(i + 1);
    return ("_f(\"" + name + "\")(" + exp + (args !== ')' ? ',' + args : args))
  }
}

/*  */



/* eslint-disable no-unused-vars */
function baseWarn (msg, range) {
  console.error(("[Vue compiler]: " + msg));
}
/* eslint-enable no-unused-vars */

function pluckModuleFunction (
  modules,
  key
) {
  return modules
    ? modules.map(function (m) { return m[key]; }).filter(function (_) { return _; })
    : []
}

function addProp (el, name, value, range, dynamic) {
  (el.props || (el.props = [])).push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

function addAttr (el, name, value, range, dynamic) {
  var attrs = dynamic
    ? (el.dynamicAttrs || (el.dynamicAttrs = []))
    : (el.attrs || (el.attrs = []));
  attrs.push(rangeSetItem({ name: name, value: value, dynamic: dynamic }, range));
  el.plain = false;
}

// add a raw attr (use this in preTransforms)
function addRawAttr (el, name, value, range) {
  el.attrsMap[name] = value;
  el.attrsList.push(rangeSetItem({ name: name, value: value }, range));
}

function addDirective (
  el,
  name,
  rawName,
  value,
  arg,
  isDynamicArg,
  modifiers,
  range
) {
  (el.directives || (el.directives = [])).push(rangeSetItem({
    name: name,
    rawName: rawName,
    value: value,
    arg: arg,
    isDynamicArg: isDynamicArg,
    modifiers: modifiers
  }, range));
  el.plain = false;
}

function prependModifierMarker (symbol, name, dynamic) {
  return dynamic
    ? ("_p(" + name + ",\"" + symbol + "\")")
    : symbol + name // mark the event as captured
}

function addHandler (
  el,
  name,
  value,
  modifiers,
  important,
  warn,
  range,
  dynamic
) {
  modifiers = modifiers || emptyObject;
  // warn prevent and passive modifier
  /* istanbul ignore if */
  if (
    false
  ) {
    warn(
      'passive and prevent can\'t be used together. ' +
      'Passive handler can\'t prevent default event.',
      range
    );
  }

  // normalize click.right and click.middle since they don't actually fire
  // this is technically browser-specific, but at least for now browsers are
  // the only target envs that have right/middle clicks.
  if (modifiers.right) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'contextmenu':(" + name + ")";
    } else if (name === 'click') {
      name = 'contextmenu';
      delete modifiers.right;
    }
  } else if (modifiers.middle) {
    if (dynamic) {
      name = "(" + name + ")==='click'?'mouseup':(" + name + ")";
    } else if (name === 'click') {
      name = 'mouseup';
    }
  }

  // check capture modifier
  if (modifiers.capture) {
    delete modifiers.capture;
    name = prependModifierMarker('!', name, dynamic);
  }
  if (modifiers.once) {
    delete modifiers.once;
    name = prependModifierMarker('~', name, dynamic);
  }
  /* istanbul ignore if */
  if (modifiers.passive) {
    delete modifiers.passive;
    name = prependModifierMarker('&', name, dynamic);
  }

  var events;
  if (modifiers.native) {
    delete modifiers.native;
    events = el.nativeEvents || (el.nativeEvents = {});
  } else {
    events = el.events || (el.events = {});
  }

  var newHandler = rangeSetItem({ value: value.trim(), dynamic: dynamic }, range);
  if (modifiers !== emptyObject) {
    newHandler.modifiers = modifiers;
  }

  var handlers = events[name];
  /* istanbul ignore if */
  if (Array.isArray(handlers)) {
    important ? handlers.unshift(newHandler) : handlers.push(newHandler);
  } else if (handlers) {
    events[name] = important ? [newHandler, handlers] : [handlers, newHandler];
  } else {
    events[name] = newHandler;
  }

  el.plain = false;
}

function getRawBindingAttr (
  el,
  name
) {
  return el.rawAttrsMap[':' + name] ||
    el.rawAttrsMap['v-bind:' + name] ||
    el.rawAttrsMap[name]
}

function getBindingAttr (
  el,
  name,
  getStatic
) {
  var dynamicValue =
    getAndRemoveAttr(el, ':' + name) ||
    getAndRemoveAttr(el, 'v-bind:' + name);
  if (dynamicValue != null) {
    return parseFilters(dynamicValue)
  } else if (getStatic !== false) {
    var staticValue = getAndRemoveAttr(el, name);
    if (staticValue != null) {
      return JSON.stringify(staticValue)
    }
  }
}

// note: this only removes the attr from the Array (attrsList) so that it
// doesn't get processed by processAttrs.
// By default it does NOT remove it from the map (attrsMap) because the map is
// needed during codegen.
function getAndRemoveAttr (
  el,
  name,
  removeFromMap
) {
  var val;
  if ((val = el.attrsMap[name]) != null) {
    var list = el.attrsList;
    for (var i = 0, l = list.length; i < l; i++) {
      if (list[i].name === name) {
        list.splice(i, 1);
        break
      }
    }
  }
  if (removeFromMap) {
    delete el.attrsMap[name];
  }
  return val
}

function getAndRemoveAttrByRegex (
  el,
  name
) {
  var list = el.attrsList;
  for (var i = 0, l = list.length; i < l; i++) {
    var attr = list[i];
    if (name.test(attr.name)) {
      list.splice(i, 1);
      return attr
    }
  }
}

function rangeSetItem (
  item,
  range
) {
  if (range) {
    if (range.start != null) {
      item.start = range.start;
    }
    if (range.end != null) {
      item.end = range.end;
    }
  }
  return item
}

/*  */

/**
 * Cross-platform code generation for component v-model
 */
function genComponentModel (
  el,
  value,
  modifiers
) {
  var ref = modifiers || {};
  var number = ref.number;
  var trim = ref.trim;

  var baseValueExpression = '$$v';
  var valueExpression = baseValueExpression;
  if (trim) {
    valueExpression =
      "(typeof " + baseValueExpression + " === 'string'" +
      "? " + baseValueExpression + ".trim()" +
      ": " + baseValueExpression + ")";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }
  var assignment = genAssignmentCode(value, valueExpression);

  el.model = {
    value: ("(" + value + ")"),
    expression: JSON.stringify(value),
    callback: ("function (" + baseValueExpression + ") {" + assignment + "}")
  };
}

/**
 * Cross-platform codegen helper for generating v-model value assignment code.
 */
function genAssignmentCode (
  value,
  assignment
) {
  var res = parseModel(value);
  if (res.key === null) {
    return (value + "=" + assignment)
  } else {
    return ("$set(" + (res.exp) + ", " + (res.key) + ", " + assignment + ")")
  }
}

/**
 * Parse a v-model expression into a base path and a final key segment.
 * Handles both dot-path and possible square brackets.
 *
 * Possible cases:
 *
 * - test
 * - test[key]
 * - test[test1[key]]
 * - test["a"][key]
 * - xxx.test[a[a].test1[key]]
 * - test.xxx.a["asa"][test1[key]]
 *
 */

var len, str, chr, index$1, expressionPos, expressionEndPos;



function parseModel (val) {
  // Fix https://github.com/vuejs/vue/pull/7730
  // allow v-model="obj.val " (trailing whitespace)
  val = val.trim();
  len = val.length;

  if (val.indexOf('[') < 0 || val.lastIndexOf(']') < len - 1) {
    index$1 = val.lastIndexOf('.');
    if (index$1 > -1) {
      return {
        exp: val.slice(0, index$1),
        key: '"' + val.slice(index$1 + 1) + '"'
      }
    } else {
      return {
        exp: val,
        key: null
      }
    }
  }

  str = val;
  index$1 = expressionPos = expressionEndPos = 0;

  while (!eof()) {
    chr = next();
    /* istanbul ignore if */
    if (isStringStart(chr)) {
      parseString(chr);
    } else if (chr === 0x5B) {
      parseBracket(chr);
    }
  }

  return {
    exp: val.slice(0, expressionPos),
    key: val.slice(expressionPos + 1, expressionEndPos)
  }
}

function next () {
  return str.charCodeAt(++index$1)
}

function eof () {
  return index$1 >= len
}

function isStringStart (chr) {
  return chr === 0x22 || chr === 0x27
}

function parseBracket (chr) {
  var inBracket = 1;
  expressionPos = index$1;
  while (!eof()) {
    chr = next();
    if (isStringStart(chr)) {
      parseString(chr);
      continue
    }
    if (chr === 0x5B) { inBracket++; }
    if (chr === 0x5D) { inBracket--; }
    if (inBracket === 0) {
      expressionEndPos = index$1;
      break
    }
  }
}

function parseString (chr) {
  var stringQuote = chr;
  while (!eof()) {
    chr = next();
    if (chr === stringQuote) {
      break
    }
  }
}

/*  */

var warn$1;

// in some cases, the event used has to be determined at runtime
// so we used some reserved tokens during compile.
var RANGE_TOKEN = '__r';
var CHECKBOX_RADIO_TOKEN = '__c';

function model (
  el,
  dir,
  _warn
) {
  warn$1 = _warn;
  var value = dir.value;
  var modifiers = dir.modifiers;
  var tag = el.tag;
  var type = el.attrsMap.type;

  if (false) {
    // inputs with type="file" are read only and setting the input's
    // value will throw an error.
    if (tag === 'input' && type === 'file') {
      warn$1(
        "<" + (el.tag) + " v-model=\"" + value + "\" type=\"file\">:\n" +
        "File inputs are read only. Use a v-on:change listener instead.",
        el.rawAttrsMap['v-model']
      );
    }
  }

  if (el.component) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (tag === 'select') {
    genSelect(el, value, modifiers);
  } else if (tag === 'input' && type === 'checkbox') {
    genCheckboxModel(el, value, modifiers);
  } else if (tag === 'input' && type === 'radio') {
    genRadioModel(el, value, modifiers);
  } else if (tag === 'input' || tag === 'textarea') {
    genDefaultModel(el, value, modifiers);
  } else if (!config.isReservedTag(tag)) {
    genComponentModel(el, value, modifiers);
    // component v-model doesn't need extra runtime
    return false
  } else if (false) {
    warn$1(
      "<" + (el.tag) + " v-model=\"" + value + "\">: " +
      "v-model is not supported on this element type. " +
      'If you are working with contenteditable, it\'s recommended to ' +
      'wrap a library dedicated for that purpose inside a custom component.',
      el.rawAttrsMap['v-model']
    );
  }

  // ensure runtime directive metadata
  return true
}

function genCheckboxModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  var trueValueBinding = getBindingAttr(el, 'true-value') || 'true';
  var falseValueBinding = getBindingAttr(el, 'false-value') || 'false';
  addProp(el, 'checked',
    "Array.isArray(" + value + ")" +
    "?_i(" + value + "," + valueBinding + ")>-1" + (
      trueValueBinding === 'true'
        ? (":(" + value + ")")
        : (":_q(" + value + "," + trueValueBinding + ")")
    )
  );
  addHandler(el, 'change',
    "var $$a=" + value + "," +
        '$$el=$event.target,' +
        "$$c=$$el.checked?(" + trueValueBinding + "):(" + falseValueBinding + ");" +
    'if(Array.isArray($$a)){' +
      "var $$v=" + (number ? '_n(' + valueBinding + ')' : valueBinding) + "," +
          '$$i=_i($$a,$$v);' +
      "if($$el.checked){$$i<0&&(" + (genAssignmentCode(value, '$$a.concat([$$v])')) + ")}" +
      "else{$$i>-1&&(" + (genAssignmentCode(value, '$$a.slice(0,$$i).concat($$a.slice($$i+1))')) + ")}" +
    "}else{" + (genAssignmentCode(value, '$$c')) + "}",
    null, true
  );
}

function genRadioModel (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var valueBinding = getBindingAttr(el, 'value') || 'null';
  valueBinding = number ? ("_n(" + valueBinding + ")") : valueBinding;
  addProp(el, 'checked', ("_q(" + value + "," + valueBinding + ")"));
  addHandler(el, 'change', genAssignmentCode(value, valueBinding), null, true);
}

function genSelect (
  el,
  value,
  modifiers
) {
  var number = modifiers && modifiers.number;
  var selectedVal = "Array.prototype.filter" +
    ".call($event.target.options,function(o){return o.selected})" +
    ".map(function(o){var val = \"_value\" in o ? o._value : o.value;" +
    "return " + (number ? '_n(val)' : 'val') + "})";

  var assignment = '$event.target.multiple ? $$selectedVal : $$selectedVal[0]';
  var code = "var $$selectedVal = " + selectedVal + ";";
  code = code + " " + (genAssignmentCode(value, assignment));
  addHandler(el, 'change', code, null, true);
}

function genDefaultModel (
  el,
  value,
  modifiers
) {
  var type = el.attrsMap.type;

  // warn if v-bind:value conflicts with v-model
  // except for inputs with v-bind:type
  if (false) {
    var value$1 = el.attrsMap['v-bind:value'] || el.attrsMap[':value'];
    var typeBinding = el.attrsMap['v-bind:type'] || el.attrsMap[':type'];
    if (value$1 && !typeBinding) {
      var binding = el.attrsMap['v-bind:value'] ? 'v-bind:value' : ':value';
      warn$1(
        binding + "=\"" + value$1 + "\" conflicts with v-model on the same element " +
        'because the latter already expands to a value binding internally',
        el.rawAttrsMap[binding]
      );
    }
  }

  var ref = modifiers || {};
  var lazy = ref.lazy;
  var number = ref.number;
  var trim = ref.trim;
  var needCompositionGuard = !lazy && type !== 'range';
  var event = lazy
    ? 'change'
    : type === 'range'
      ? RANGE_TOKEN
      : 'input';

  var valueExpression = '$event.target.value';
  if (trim) {
    valueExpression = "$event.target.value.trim()";
  }
  if (number) {
    valueExpression = "_n(" + valueExpression + ")";
  }

  var code = genAssignmentCode(value, valueExpression);
  if (needCompositionGuard) {
    code = "if($event.target.composing)return;" + code;
  }

  addProp(el, 'value', ("(" + value + ")"));
  addHandler(el, event, code, null, true);
  if (trim || number) {
    addHandler(el, 'blur', '$forceUpdate()');
  }
}

/*  */

// normalize v-model event tokens that can only be determined at runtime.
// it's important to place the event as the first in the array because
// the whole point is ensuring the v-model callback gets called before
// user-attached handlers.
function normalizeEvents (on) {
  /* istanbul ignore if */
  if (isDef(on[RANGE_TOKEN])) {
    // IE input[type=range] only supports `change` event
    var event = isIE ? 'change' : 'input';
    on[event] = [].concat(on[RANGE_TOKEN], on[event] || []);
    delete on[RANGE_TOKEN];
  }
  // This was originally intended to fix #4521 but no longer necessary
  // after 2.5. Keeping it for backwards compat with generated code from < 2.4
  /* istanbul ignore if */
  if (isDef(on[CHECKBOX_RADIO_TOKEN])) {
    on.change = [].concat(on[CHECKBOX_RADIO_TOKEN], on.change || []);
    delete on[CHECKBOX_RADIO_TOKEN];
  }
}

var target$1;

function createOnceHandler$1 (event, handler, capture) {
  var _target = target$1; // save current target element in closure
  return function onceHandler () {
    var res = handler.apply(null, arguments);
    if (res !== null) {
      remove$2(event, onceHandler, capture, _target);
    }
  }
}

// #9446: Firefox <= 53 (in particular, ESR 52) has incorrect Event.timeStamp
// implementation and does not fire microtasks in between event propagation, so
// safe to exclude.
var useMicrotaskFix = isUsingMicroTask && !(isFF && Number(isFF[1]) <= 53);

function add$1 (
  name,
  handler,
  capture,
  passive
) {
  // async edge case #6566: inner click event triggers patch, event handler
  // attached to outer element during patch, and triggered again. This
  // happens because browsers fire microtask ticks between event propagation.
  // the solution is simple: we save the timestamp when a handler is attached,
  // and the handler would only fire if the event passed to it was fired
  // AFTER it was attached.
  if (useMicrotaskFix) {
    var attachedTimestamp = currentFlushTimestamp;
    var original = handler;
    handler = original._wrapper = function (e) {
      if (
        // no bubbling, should always fire.
        // this is just a safety net in case event.timeStamp is unreliable in
        // certain weird environments...
        e.target === e.currentTarget ||
        // event is fired after handler attachment
        e.timeStamp >= attachedTimestamp ||
        // bail for environments that have buggy event.timeStamp implementations
        // #9462 iOS 9 bug: event.timeStamp is 0 after history.pushState
        // #9681 QtWebEngine event.timeStamp is negative value
        e.timeStamp <= 0 ||
        // #9448 bail if event is fired in another document in a multi-page
        // electron/nw.js app, since event.timeStamp will be using a different
        // starting reference
        e.target.ownerDocument !== document
      ) {
        return original.apply(this, arguments)
      }
    };
  }
  target$1.addEventListener(
    name,
    handler,
    supportsPassive
      ? { capture: capture, passive: passive }
      : capture
  );
}

function remove$2 (
  name,
  handler,
  capture,
  _target
) {
  (_target || target$1).removeEventListener(
    name,
    handler._wrapper || handler,
    capture
  );
}

function updateDOMListeners (oldVnode, vnode) {
  if (isUndef(oldVnode.data.on) && isUndef(vnode.data.on)) {
    return
  }
  var on = vnode.data.on || {};
  var oldOn = oldVnode.data.on || {};
  target$1 = vnode.elm;
  normalizeEvents(on);
  updateListeners(on, oldOn, add$1, remove$2, createOnceHandler$1, vnode.context);
  target$1 = undefined;
}

var events = {
  create: updateDOMListeners,
  update: updateDOMListeners
};

/*  */

var svgContainer;

function updateDOMProps (oldVnode, vnode) {
  if (isUndef(oldVnode.data.domProps) && isUndef(vnode.data.domProps)) {
    return
  }
  var key, cur;
  var elm = vnode.elm;
  var oldProps = oldVnode.data.domProps || {};
  var props = vnode.data.domProps || {};
  // clone observed objects, as the user probably wants to mutate it
  if (isDef(props.__ob__)) {
    props = vnode.data.domProps = extend({}, props);
  }

  for (key in oldProps) {
    if (!(key in props)) {
      elm[key] = '';
    }
  }

  for (key in props) {
    cur = props[key];
    // ignore children if the node has textContent or innerHTML,
    // as these will throw away existing DOM nodes and cause removal errors
    // on subsequent patches (#3360)
    if (key === 'textContent' || key === 'innerHTML') {
      if (vnode.children) { vnode.children.length = 0; }
      if (cur === oldProps[key]) { continue }
      // #6601 work around Chrome version <= 55 bug where single textNode
      // replaced by innerHTML/textContent retains its parentNode property
      if (elm.childNodes.length === 1) {
        elm.removeChild(elm.childNodes[0]);
      }
    }

    if (key === 'value' && elm.tagName !== 'PROGRESS') {
      // store value as _value as well since
      // non-string values will be stringified
      elm._value = cur;
      // avoid resetting cursor position when value is the same
      var strCur = isUndef(cur) ? '' : String(cur);
      if (shouldUpdateValue(elm, strCur)) {
        elm.value = strCur;
      }
    } else if (key === 'innerHTML' && isSVG(elm.tagName) && isUndef(elm.innerHTML)) {
      // IE doesn't support innerHTML for SVG elements
      svgContainer = svgContainer || document.createElement('div');
      svgContainer.innerHTML = "<svg>" + cur + "</svg>";
      var svg = svgContainer.firstChild;
      while (elm.firstChild) {
        elm.removeChild(elm.firstChild);
      }
      while (svg.firstChild) {
        elm.appendChild(svg.firstChild);
      }
    } else if (
      // skip the update if old and new VDOM state is the same.
      // `value` is handled separately because the DOM value may be temporarily
      // out of sync with VDOM state due to focus, composition and modifiers.
      // This  #4521 by skipping the unnecessary `checked` update.
      cur !== oldProps[key]
    ) {
      // some property updates can throw
      // e.g. `value` on <progress> w/ non-finite value
      try {
        elm[key] = cur;
      } catch (e) {}
    }
  }
}

// check platforms/web/util/attrs.js acceptValue


function shouldUpdateValue (elm, checkVal) {
  return (!elm.composing && (
    elm.tagName === 'OPTION' ||
    isNotInFocusAndDirty(elm, checkVal) ||
    isDirtyWithModifiers(elm, checkVal)
  ))
}

function isNotInFocusAndDirty (elm, checkVal) {
  // return true when textbox (.number and .trim) loses focus and its value is
  // not equal to the updated value
  var notInFocus = true;
  // #6157
  // work around IE bug when accessing document.activeElement in an iframe
  try { notInFocus = document.activeElement !== elm; } catch (e) {}
  return notInFocus && elm.value !== checkVal
}

function isDirtyWithModifiers (elm, newVal) {
  var value = elm.value;
  var modifiers = elm._vModifiers; // injected by v-model runtime
  if (isDef(modifiers)) {
    if (modifiers.number) {
      return toNumber(value) !== toNumber(newVal)
    }
    if (modifiers.trim) {
      return value.trim() !== newVal.trim()
    }
  }
  return value !== newVal
}

var domProps = {
  create: updateDOMProps,
  update: updateDOMProps
};

/*  */

var parseStyleText = cached(function (cssText) {
  var res = {};
  var listDelimiter = /;(?![^(]*\))/g;
  var propertyDelimiter = /:(.+)/;
  cssText.split(listDelimiter).forEach(function (item) {
    if (item) {
      var tmp = item.split(propertyDelimiter);
      tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
    }
  });
  return res
});

// merge static and dynamic style data on the same vnode
function normalizeStyleData (data) {
  var style = normalizeStyleBinding(data.style);
  // static style is pre-processed into an object during compilation
  // and is always a fresh object, so it's safe to merge into it
  return data.staticStyle
    ? extend(data.staticStyle, style)
    : style
}

// normalize possible array / string values into Object
function normalizeStyleBinding (bindingStyle) {
  if (Array.isArray(bindingStyle)) {
    return toObject(bindingStyle)
  }
  if (typeof bindingStyle === 'string') {
    return parseStyleText(bindingStyle)
  }
  return bindingStyle
}

/**
 * parent component style should be after child's
 * so that parent component's style could override it
 */
function getStyle (vnode, checkChild) {
  var res = {};
  var styleData;

  if (checkChild) {
    var childNode = vnode;
    while (childNode.componentInstance) {
      childNode = childNode.componentInstance._vnode;
      if (
        childNode && childNode.data &&
        (styleData = normalizeStyleData(childNode.data))
      ) {
        extend(res, styleData);
      }
    }
  }

  if ((styleData = normalizeStyleData(vnode.data))) {
    extend(res, styleData);
  }

  var parentNode = vnode;
  while ((parentNode = parentNode.parent)) {
    if (parentNode.data && (styleData = normalizeStyleData(parentNode.data))) {
      extend(res, styleData);
    }
  }
  return res
}

/*  */

var cssVarRE = /^--/;
var importantRE = /\s*!important$/;
var setProp = function (el, name, val) {
  /* istanbul ignore if */
  if (cssVarRE.test(name)) {
    el.style.setProperty(name, val);
  } else if (importantRE.test(val)) {
    el.style.setProperty(hyphenate(name), val.replace(importantRE, ''), 'important');
  } else {
    var normalizedName = normalize(name);
    if (Array.isArray(val)) {
      // Support values array created by autoprefixer, e.g.
      // {display: ["-webkit-box", "-ms-flexbox", "flex"]}
      // Set them one by one, and the browser will only set those it can recognize
      for (var i = 0, len = val.length; i < len; i++) {
        el.style[normalizedName] = val[i];
      }
    } else {
      el.style[normalizedName] = val;
    }
  }
};

var vendorNames = ['Webkit', 'Moz', 'ms'];

var emptyStyle;
var normalize = cached(function (prop) {
  emptyStyle = emptyStyle || document.createElement('div').style;
  prop = camelize(prop);
  if (prop !== 'filter' && (prop in emptyStyle)) {
    return prop
  }
  var capName = prop.charAt(0).toUpperCase() + prop.slice(1);
  for (var i = 0; i < vendorNames.length; i++) {
    var name = vendorNames[i] + capName;
    if (name in emptyStyle) {
      return name
    }
  }
});

function updateStyle (oldVnode, vnode) {
  var data = vnode.data;
  var oldData = oldVnode.data;

  if (isUndef(data.staticStyle) && isUndef(data.style) &&
    isUndef(oldData.staticStyle) && isUndef(oldData.style)
  ) {
    return
  }

  var cur, name;
  var el = vnode.elm;
  var oldStaticStyle = oldData.staticStyle;
  var oldStyleBinding = oldData.normalizedStyle || oldData.style || {};

  // if static style exists, stylebinding already merged into it when doing normalizeStyleData
  var oldStyle = oldStaticStyle || oldStyleBinding;

  var style = normalizeStyleBinding(vnode.data.style) || {};

  // store normalized style under a different key for next diff
  // make sure to clone it if it's reactive, since the user likely wants
  // to mutate it.
  vnode.data.normalizedStyle = isDef(style.__ob__)
    ? extend({}, style)
    : style;

  var newStyle = getStyle(vnode, true);

  for (name in oldStyle) {
    if (isUndef(newStyle[name])) {
      setProp(el, name, '');
    }
  }
  for (name in newStyle) {
    cur = newStyle[name];
    if (cur !== oldStyle[name]) {
      // ie9 setting to null has no effect, must use empty string
      setProp(el, name, cur == null ? '' : cur);
    }
  }
}

var style = {
  create: updateStyle,
  update: updateStyle
};

/*  */

var whitespaceRE = /\s+/;

/**
 * Add class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function addClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.add(c); });
    } else {
      el.classList.add(cls);
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    if (cur.indexOf(' ' + cls + ' ') < 0) {
      el.setAttribute('class', (cur + cls).trim());
    }
  }
}

/**
 * Remove class with compatibility for SVG since classList is not supported on
 * SVG elements in IE
 */
function removeClass (el, cls) {
  /* istanbul ignore if */
  if (!cls || !(cls = cls.trim())) {
    return
  }

  /* istanbul ignore else */
  if (el.classList) {
    if (cls.indexOf(' ') > -1) {
      cls.split(whitespaceRE).forEach(function (c) { return el.classList.remove(c); });
    } else {
      el.classList.remove(cls);
    }
    if (!el.classList.length) {
      el.removeAttribute('class');
    }
  } else {
    var cur = " " + (el.getAttribute('class') || '') + " ";
    var tar = ' ' + cls + ' ';
    while (cur.indexOf(tar) >= 0) {
      cur = cur.replace(tar, ' ');
    }
    cur = cur.trim();
    if (cur) {
      el.setAttribute('class', cur);
    } else {
      el.removeAttribute('class');
    }
  }
}

/*  */

function resolveTransition (def$$1) {
  if (!def$$1) {
    return
  }
  /* istanbul ignore else */
  if (typeof def$$1 === 'object') {
    var res = {};
    if (def$$1.css !== false) {
      extend(res, autoCssTransition(def$$1.name || 'v'));
    }
    extend(res, def$$1);
    return res
  } else if (typeof def$$1 === 'string') {
    return autoCssTransition(def$$1)
  }
}

var autoCssTransition = cached(function (name) {
  return {
    enterClass: (name + "-enter"),
    enterToClass: (name + "-enter-to"),
    enterActiveClass: (name + "-enter-active"),
    leaveClass: (name + "-leave"),
    leaveToClass: (name + "-leave-to"),
    leaveActiveClass: (name + "-leave-active")
  }
});

var hasTransition = inBrowser && !isIE9;
var TRANSITION = 'transition';
var ANIMATION = 'animation';

// Transition property/event sniffing
var transitionProp = 'transition';
var transitionEndEvent = 'transitionend';
var animationProp = 'animation';
var animationEndEvent = 'animationend';
if (hasTransition) {
  /* istanbul ignore if */
  if (window.ontransitionend === undefined &&
    window.onwebkittransitionend !== undefined
  ) {
    transitionProp = 'WebkitTransition';
    transitionEndEvent = 'webkitTransitionEnd';
  }
  if (window.onanimationend === undefined &&
    window.onwebkitanimationend !== undefined
  ) {
    animationProp = 'WebkitAnimation';
    animationEndEvent = 'webkitAnimationEnd';
  }
}

// binding to window is necessary to make hot reload work in IE in strict mode
var raf = inBrowser
  ? window.requestAnimationFrame
    ? window.requestAnimationFrame.bind(window)
    : setTimeout
  : /* istanbul ignore next */ function (fn) { return fn(); };

function nextFrame (fn) {
  raf(function () {
    raf(fn);
  });
}

function addTransitionClass (el, cls) {
  var transitionClasses = el._transitionClasses || (el._transitionClasses = []);
  if (transitionClasses.indexOf(cls) < 0) {
    transitionClasses.push(cls);
    addClass(el, cls);
  }
}

function removeTransitionClass (el, cls) {
  if (el._transitionClasses) {
    remove(el._transitionClasses, cls);
  }
  removeClass(el, cls);
}

function whenTransitionEnds (
  el,
  expectedType,
  cb
) {
  var ref = getTransitionInfo(el, expectedType);
  var type = ref.type;
  var timeout = ref.timeout;
  var propCount = ref.propCount;
  if (!type) { return cb() }
  var event = type === TRANSITION ? transitionEndEvent : animationEndEvent;
  var ended = 0;
  var end = function () {
    el.removeEventListener(event, onEnd);
    cb();
  };
  var onEnd = function (e) {
    if (e.target === el) {
      if (++ended >= propCount) {
        end();
      }
    }
  };
  setTimeout(function () {
    if (ended < propCount) {
      end();
    }
  }, timeout + 1);
  el.addEventListener(event, onEnd);
}

var transformRE = /\b(transform|all)(,|$)/;

function getTransitionInfo (el, expectedType) {
  var styles = window.getComputedStyle(el);
  // JSDOM may return undefined for transition properties
  var transitionDelays = (styles[transitionProp + 'Delay'] || '').split(', ');
  var transitionDurations = (styles[transitionProp + 'Duration'] || '').split(', ');
  var transitionTimeout = getTimeout(transitionDelays, transitionDurations);
  var animationDelays = (styles[animationProp + 'Delay'] || '').split(', ');
  var animationDurations = (styles[animationProp + 'Duration'] || '').split(', ');
  var animationTimeout = getTimeout(animationDelays, animationDurations);

  var type;
  var timeout = 0;
  var propCount = 0;
  /* istanbul ignore if */
  if (expectedType === TRANSITION) {
    if (transitionTimeout > 0) {
      type = TRANSITION;
      timeout = transitionTimeout;
      propCount = transitionDurations.length;
    }
  } else if (expectedType === ANIMATION) {
    if (animationTimeout > 0) {
      type = ANIMATION;
      timeout = animationTimeout;
      propCount = animationDurations.length;
    }
  } else {
    timeout = Math.max(transitionTimeout, animationTimeout);
    type = timeout > 0
      ? transitionTimeout > animationTimeout
        ? TRANSITION
        : ANIMATION
      : null;
    propCount = type
      ? type === TRANSITION
        ? transitionDurations.length
        : animationDurations.length
      : 0;
  }
  var hasTransform =
    type === TRANSITION &&
    transformRE.test(styles[transitionProp + 'Property']);
  return {
    type: type,
    timeout: timeout,
    propCount: propCount,
    hasTransform: hasTransform
  }
}

function getTimeout (delays, durations) {
  /* istanbul ignore next */
  while (delays.length < durations.length) {
    delays = delays.concat(delays);
  }

  return Math.max.apply(null, durations.map(function (d, i) {
    return toMs(d) + toMs(delays[i])
  }))
}

// Old versions of Chromium (below 61.0.3163.100) formats floating pointer numbers
// in a locale-dependent way, using a comma instead of a dot.
// If comma is not replaced with a dot, the input will be rounded down (i.e. acting
// as a floor function) causing unexpected behaviors
function toMs (s) {
  return Number(s.slice(0, -1).replace(',', '.')) * 1000
}

/*  */

function enter (vnode, toggleDisplay) {
  var el = vnode.elm;

  // call leave callback now
  if (isDef(el._leaveCb)) {
    el._leaveCb.cancelled = true;
    el._leaveCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data)) {
    return
  }

  /* istanbul ignore if */
  if (isDef(el._enterCb) || el.nodeType !== 1) {
    return
  }

  var css = data.css;
  var type = data.type;
  var enterClass = data.enterClass;
  var enterToClass = data.enterToClass;
  var enterActiveClass = data.enterActiveClass;
  var appearClass = data.appearClass;
  var appearToClass = data.appearToClass;
  var appearActiveClass = data.appearActiveClass;
  var beforeEnter = data.beforeEnter;
  var enter = data.enter;
  var afterEnter = data.afterEnter;
  var enterCancelled = data.enterCancelled;
  var beforeAppear = data.beforeAppear;
  var appear = data.appear;
  var afterAppear = data.afterAppear;
  var appearCancelled = data.appearCancelled;
  var duration = data.duration;

  // activeInstance will always be the <transition> component managing this
  // transition. One edge case to check is when the <transition> is placed
  // as the root node of a child component. In that case we need to check
  // <transition>'s parent for appear check.
  var context = activeInstance;
  var transitionNode = activeInstance.$vnode;
  while (transitionNode && transitionNode.parent) {
    context = transitionNode.context;
    transitionNode = transitionNode.parent;
  }

  var isAppear = !context._isMounted || !vnode.isRootInsert;

  if (isAppear && !appear && appear !== '') {
    return
  }

  var startClass = isAppear && appearClass
    ? appearClass
    : enterClass;
  var activeClass = isAppear && appearActiveClass
    ? appearActiveClass
    : enterActiveClass;
  var toClass = isAppear && appearToClass
    ? appearToClass
    : enterToClass;

  var beforeEnterHook = isAppear
    ? (beforeAppear || beforeEnter)
    : beforeEnter;
  var enterHook = isAppear
    ? (typeof appear === 'function' ? appear : enter)
    : enter;
  var afterEnterHook = isAppear
    ? (afterAppear || afterEnter)
    : afterEnter;
  var enterCancelledHook = isAppear
    ? (appearCancelled || enterCancelled)
    : enterCancelled;

  var explicitEnterDuration = toNumber(
    isObject(duration)
      ? duration.enter
      : duration
  );

  if (false) {
    checkDuration(explicitEnterDuration, 'enter', vnode);
  }

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(enterHook);

  var cb = el._enterCb = once(function () {
    if (expectsCSS) {
      removeTransitionClass(el, toClass);
      removeTransitionClass(el, activeClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, startClass);
      }
      enterCancelledHook && enterCancelledHook(el);
    } else {
      afterEnterHook && afterEnterHook(el);
    }
    el._enterCb = null;
  });

  if (!vnode.data.show) {
    // remove pending leave element on enter by injecting an insert hook
    mergeVNodeHook(vnode, 'insert', function () {
      var parent = el.parentNode;
      var pendingNode = parent && parent._pending && parent._pending[vnode.key];
      if (pendingNode &&
        pendingNode.tag === vnode.tag &&
        pendingNode.elm._leaveCb
      ) {
        pendingNode.elm._leaveCb();
      }
      enterHook && enterHook(el, cb);
    });
  }

  // start enter transition
  beforeEnterHook && beforeEnterHook(el);
  if (expectsCSS) {
    addTransitionClass(el, startClass);
    addTransitionClass(el, activeClass);
    nextFrame(function () {
      removeTransitionClass(el, startClass);
      if (!cb.cancelled) {
        addTransitionClass(el, toClass);
        if (!userWantsControl) {
          if (isValidDuration(explicitEnterDuration)) {
            setTimeout(cb, explicitEnterDuration);
          } else {
            whenTransitionEnds(el, type, cb);
          }
        }
      }
    });
  }

  if (vnode.data.show) {
    toggleDisplay && toggleDisplay();
    enterHook && enterHook(el, cb);
  }

  if (!expectsCSS && !userWantsControl) {
    cb();
  }
}

function leave (vnode, rm) {
  var el = vnode.elm;

  // call enter callback now
  if (isDef(el._enterCb)) {
    el._enterCb.cancelled = true;
    el._enterCb();
  }

  var data = resolveTransition(vnode.data.transition);
  if (isUndef(data) || el.nodeType !== 1) {
    return rm()
  }

  /* istanbul ignore if */
  if (isDef(el._leaveCb)) {
    return
  }

  var css = data.css;
  var type = data.type;
  var leaveClass = data.leaveClass;
  var leaveToClass = data.leaveToClass;
  var leaveActiveClass = data.leaveActiveClass;
  var beforeLeave = data.beforeLeave;
  var leave = data.leave;
  var afterLeave = data.afterLeave;
  var leaveCancelled = data.leaveCancelled;
  var delayLeave = data.delayLeave;
  var duration = data.duration;

  var expectsCSS = css !== false && !isIE9;
  var userWantsControl = getHookArgumentsLength(leave);

  var explicitLeaveDuration = toNumber(
    isObject(duration)
      ? duration.leave
      : duration
  );

  if (false) {
    checkDuration(explicitLeaveDuration, 'leave', vnode);
  }

  var cb = el._leaveCb = once(function () {
    if (el.parentNode && el.parentNode._pending) {
      el.parentNode._pending[vnode.key] = null;
    }
    if (expectsCSS) {
      removeTransitionClass(el, leaveToClass);
      removeTransitionClass(el, leaveActiveClass);
    }
    if (cb.cancelled) {
      if (expectsCSS) {
        removeTransitionClass(el, leaveClass);
      }
      leaveCancelled && leaveCancelled(el);
    } else {
      rm();
      afterLeave && afterLeave(el);
    }
    el._leaveCb = null;
  });

  if (delayLeave) {
    delayLeave(performLeave);
  } else {
    performLeave();
  }

  function performLeave () {
    // the delayed leave may have already been cancelled
    if (cb.cancelled) {
      return
    }
    // record leaving element
    if (!vnode.data.show && el.parentNode) {
      (el.parentNode._pending || (el.parentNode._pending = {}))[(vnode.key)] = vnode;
    }
    beforeLeave && beforeLeave(el);
    if (expectsCSS) {
      addTransitionClass(el, leaveClass);
      addTransitionClass(el, leaveActiveClass);
      nextFrame(function () {
        removeTransitionClass(el, leaveClass);
        if (!cb.cancelled) {
          addTransitionClass(el, leaveToClass);
          if (!userWantsControl) {
            if (isValidDuration(explicitLeaveDuration)) {
              setTimeout(cb, explicitLeaveDuration);
            } else {
              whenTransitionEnds(el, type, cb);
            }
          }
        }
      });
    }
    leave && leave(el, cb);
    if (!expectsCSS && !userWantsControl) {
      cb();
    }
  }
}

// only used in dev mode
function checkDuration (val, name, vnode) {
  if (typeof val !== 'number') {
    warn(
      "<transition> explicit " + name + " duration is not a valid number - " +
      "got " + (JSON.stringify(val)) + ".",
      vnode.context
    );
  } else if (isNaN(val)) {
    warn(
      "<transition> explicit " + name + " duration is NaN - " +
      'the duration expression might be incorrect.',
      vnode.context
    );
  }
}

function isValidDuration (val) {
  return typeof val === 'number' && !isNaN(val)
}

/**
 * Normalize a transition hook's argument length. The hook may be:
 * - a merged hook (invoker) with the original in .fns
 * - a wrapped component method (check ._length)
 * - a plain function (.length)
 */
function getHookArgumentsLength (fn) {
  if (isUndef(fn)) {
    return false
  }
  var invokerFns = fn.fns;
  if (isDef(invokerFns)) {
    // invoker
    return getHookArgumentsLength(
      Array.isArray(invokerFns)
        ? invokerFns[0]
        : invokerFns
    )
  } else {
    return (fn._length || fn.length) > 1
  }
}

function _enter (_, vnode) {
  if (vnode.data.show !== true) {
    enter(vnode);
  }
}

var transition = inBrowser ? {
  create: _enter,
  activate: _enter,
  remove: function remove$$1 (vnode, rm) {
    /* istanbul ignore else */
    if (vnode.data.show !== true) {
      leave(vnode, rm);
    } else {
      rm();
    }
  }
} : {};

var platformModules = [
  attrs,
  klass,
  events,
  domProps,
  style,
  transition
];

/*  */

// the directive module should be applied last, after all
// built-in modules have been applied.
var modules = platformModules.concat(baseModules);

var patch = createPatchFunction({ nodeOps: nodeOps, modules: modules });

/**
 * Not type checking this file because flow doesn't like attaching
 * properties to Elements.
 */

/* istanbul ignore if */
if (isIE9) {
  // http://www.matts411.com/post/internet-explorer-9-oninput/
  document.addEventListener('selectionchange', function () {
    var el = document.activeElement;
    if (el && el.vmodel) {
      trigger(el, 'input');
    }
  });
}

var directive = {
  inserted: function inserted (el, binding, vnode, oldVnode) {
    if (vnode.tag === 'select') {
      // #6903
      if (oldVnode.elm && !oldVnode.elm._vOptions) {
        mergeVNodeHook(vnode, 'postpatch', function () {
          directive.componentUpdated(el, binding, vnode);
        });
      } else {
        setSelected(el, binding, vnode.context);
      }
      el._vOptions = [].map.call(el.options, getValue);
    } else if (vnode.tag === 'textarea' || isTextInputType(el.type)) {
      el._vModifiers = binding.modifiers;
      if (!binding.modifiers.lazy) {
        el.addEventListener('compositionstart', onCompositionStart);
        el.addEventListener('compositionend', onCompositionEnd);
        // Safari < 10.2 & UIWebView doesn't fire compositionend when
        // switching focus before confirming composition choice
        // this also fixes the issue where some browsers e.g. iOS Chrome
        // fires "change" instead of "input" on autocomplete.
        el.addEventListener('change', onCompositionEnd);
        /* istanbul ignore if */
        if (isIE9) {
          el.vmodel = true;
        }
      }
    }
  },

  componentUpdated: function componentUpdated (el, binding, vnode) {
    if (vnode.tag === 'select') {
      setSelected(el, binding, vnode.context);
      // in case the options rendered by v-for have changed,
      // it's possible that the value is out-of-sync with the rendered options.
      // detect such cases and filter out values that no longer has a matching
      // option in the DOM.
      var prevOptions = el._vOptions;
      var curOptions = el._vOptions = [].map.call(el.options, getValue);
      if (curOptions.some(function (o, i) { return !looseEqual(o, prevOptions[i]); })) {
        // trigger change event if
        // no matching option found for at least one value
        var needReset = el.multiple
          ? binding.value.some(function (v) { return hasNoMatchingOption(v, curOptions); })
          : binding.value !== binding.oldValue && hasNoMatchingOption(binding.value, curOptions);
        if (needReset) {
          trigger(el, 'change');
        }
      }
    }
  }
};

function setSelected (el, binding, vm) {
  actuallySetSelected(el, binding, vm);
  /* istanbul ignore if */
  if (isIE || isEdge) {
    setTimeout(function () {
      actuallySetSelected(el, binding, vm);
    }, 0);
  }
}

function actuallySetSelected (el, binding, vm) {
  var value = binding.value;
  var isMultiple = el.multiple;
  if (isMultiple && !Array.isArray(value)) {
    "production" !== 'production' && warn(
      "<select multiple v-model=\"" + (binding.expression) + "\"> " +
      "expects an Array value for its binding, but got " + (Object.prototype.toString.call(value).slice(8, -1)),
      vm
    );
    return
  }
  var selected, option;
  for (var i = 0, l = el.options.length; i < l; i++) {
    option = el.options[i];
    if (isMultiple) {
      selected = looseIndexOf(value, getValue(option)) > -1;
      if (option.selected !== selected) {
        option.selected = selected;
      }
    } else {
      if (looseEqual(getValue(option), value)) {
        if (el.selectedIndex !== i) {
          el.selectedIndex = i;
        }
        return
      }
    }
  }
  if (!isMultiple) {
    el.selectedIndex = -1;
  }
}

function hasNoMatchingOption (value, options) {
  return options.every(function (o) { return !looseEqual(o, value); })
}

function getValue (option) {
  return '_value' in option
    ? option._value
    : option.value
}

function onCompositionStart (e) {
  e.target.composing = true;
}

function onCompositionEnd (e) {
  // prevent triggering an input event for no reason
  if (!e.target.composing) { return }
  e.target.composing = false;
  trigger(e.target, 'input');
}

function trigger (el, type) {
  var e = document.createEvent('HTMLEvents');
  e.initEvent(type, true, true);
  el.dispatchEvent(e);
}

/*  */

// recursively search for possible transition defined inside the component root
function locateNode (vnode) {
  return vnode.componentInstance && (!vnode.data || !vnode.data.transition)
    ? locateNode(vnode.componentInstance._vnode)
    : vnode
}

var show = {
  bind: function bind (el, ref, vnode) {
    var value = ref.value;

    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    var originalDisplay = el.__vOriginalDisplay =
      el.style.display === 'none' ? '' : el.style.display;
    if (value && transition$$1) {
      vnode.data.show = true;
      enter(vnode, function () {
        el.style.display = originalDisplay;
      });
    } else {
      el.style.display = value ? originalDisplay : 'none';
    }
  },

  update: function update (el, ref, vnode) {
    var value = ref.value;
    var oldValue = ref.oldValue;

    /* istanbul ignore if */
    if (!value === !oldValue) { return }
    vnode = locateNode(vnode);
    var transition$$1 = vnode.data && vnode.data.transition;
    if (transition$$1) {
      vnode.data.show = true;
      if (value) {
        enter(vnode, function () {
          el.style.display = el.__vOriginalDisplay;
        });
      } else {
        leave(vnode, function () {
          el.style.display = 'none';
        });
      }
    } else {
      el.style.display = value ? el.__vOriginalDisplay : 'none';
    }
  },

  unbind: function unbind (
    el,
    binding,
    vnode,
    oldVnode,
    isDestroy
  ) {
    if (!isDestroy) {
      el.style.display = el.__vOriginalDisplay;
    }
  }
};

var platformDirectives = {
  model: directive,
  show: show
};

/*  */

var transitionProps = {
  name: String,
  appear: Boolean,
  css: Boolean,
  mode: String,
  type: String,
  enterClass: String,
  leaveClass: String,
  enterToClass: String,
  leaveToClass: String,
  enterActiveClass: String,
  leaveActiveClass: String,
  appearClass: String,
  appearActiveClass: String,
  appearToClass: String,
  duration: [Number, String, Object]
};

// in case the child is also an abstract component, e.g. <keep-alive>
// we want to recursively retrieve the real component to be rendered
function getRealChild (vnode) {
  var compOptions = vnode && vnode.componentOptions;
  if (compOptions && compOptions.Ctor.options.abstract) {
    return getRealChild(getFirstComponentChild(compOptions.children))
  } else {
    return vnode
  }
}

function extractTransitionData (comp) {
  var data = {};
  var options = comp.$options;
  // props
  for (var key in options.propsData) {
    data[key] = comp[key];
  }
  // events.
  // extract listeners and pass them directly to the transition methods
  var listeners = options._parentListeners;
  for (var key$1 in listeners) {
    data[camelize(key$1)] = listeners[key$1];
  }
  return data
}

function placeholder (h, rawChild) {
  if (/\d-keep-alive$/.test(rawChild.tag)) {
    return h('keep-alive', {
      props: rawChild.componentOptions.propsData
    })
  }
}

function hasParentTransition (vnode) {
  while ((vnode = vnode.parent)) {
    if (vnode.data.transition) {
      return true
    }
  }
}

function isSameChild (child, oldChild) {
  return oldChild.key === child.key && oldChild.tag === child.tag
}

var isNotTextNode = function (c) { return c.tag || isAsyncPlaceholder(c); };

var isVShowDirective = function (d) { return d.name === 'show'; };

var Transition = {
  name: 'transition',
  props: transitionProps,
  abstract: true,

  render: function render (h) {
    var this$1 = this;

    var children = this.$slots.default;
    if (!children) {
      return
    }

    // filter out text nodes (possible whitespaces)
    children = children.filter(isNotTextNode);
    /* istanbul ignore if */
    if (!children.length) {
      return
    }

    // warn multiple elements
    if (false) {
      warn(
        '<transition> can only be used on a single element. Use ' +
        '<transition-group> for lists.',
        this.$parent
      );
    }

    var mode = this.mode;

    // warn invalid mode
    if (false
    ) {
      warn(
        'invalid <transition> mode: ' + mode,
        this.$parent
      );
    }

    var rawChild = children[0];

    // if this is a component root node and the component's
    // parent container node also has transition, skip.
    if (hasParentTransition(this.$vnode)) {
      return rawChild
    }

    // apply transition data to child
    // use getRealChild() to ignore abstract components e.g. keep-alive
    var child = getRealChild(rawChild);
    /* istanbul ignore if */
    if (!child) {
      return rawChild
    }

    if (this._leaving) {
      return placeholder(h, rawChild)
    }

    // ensure a key that is unique to the vnode type and to this transition
    // component instance. This key will be used to remove pending leaving nodes
    // during entering.
    var id = "__transition-" + (this._uid) + "-";
    child.key = child.key == null
      ? child.isComment
        ? id + 'comment'
        : id + child.tag
      : isPrimitive(child.key)
        ? (String(child.key).indexOf(id) === 0 ? child.key : id + child.key)
        : child.key;

    var data = (child.data || (child.data = {})).transition = extractTransitionData(this);
    var oldRawChild = this._vnode;
    var oldChild = getRealChild(oldRawChild);

    // mark v-show
    // so that the transition module can hand over the control to the directive
    if (child.data.directives && child.data.directives.some(isVShowDirective)) {
      child.data.show = true;
    }

    if (
      oldChild &&
      oldChild.data &&
      !isSameChild(child, oldChild) &&
      !isAsyncPlaceholder(oldChild) &&
      // #6687 component root is a comment node
      !(oldChild.componentInstance && oldChild.componentInstance._vnode.isComment)
    ) {
      // replace old child transition data with fresh one
      // important for dynamic transitions!
      var oldData = oldChild.data.transition = extend({}, data);
      // handle transition mode
      if (mode === 'out-in') {
        // return placeholder node and queue update when leave finishes
        this._leaving = true;
        mergeVNodeHook(oldData, 'afterLeave', function () {
          this$1._leaving = false;
          this$1.$forceUpdate();
        });
        return placeholder(h, rawChild)
      } else if (mode === 'in-out') {
        if (isAsyncPlaceholder(child)) {
          return oldRawChild
        }
        var delayedLeave;
        var performLeave = function () { delayedLeave(); };
        mergeVNodeHook(data, 'afterEnter', performLeave);
        mergeVNodeHook(data, 'enterCancelled', performLeave);
        mergeVNodeHook(oldData, 'delayLeave', function (leave) { delayedLeave = leave; });
      }
    }

    return rawChild
  }
};

/*  */

var props = extend({
  tag: String,
  moveClass: String
}, transitionProps);

delete props.mode;

var TransitionGroup = {
  props: props,

  beforeMount: function beforeMount () {
    var this$1 = this;

    var update = this._update;
    this._update = function (vnode, hydrating) {
      var restoreActiveInstance = setActiveInstance(this$1);
      // force removing pass
      this$1.__patch__(
        this$1._vnode,
        this$1.kept,
        false, // hydrating
        true // removeOnly (!important, avoids unnecessary moves)
      );
      this$1._vnode = this$1.kept;
      restoreActiveInstance();
      update.call(this$1, vnode, hydrating);
    };
  },

  render: function render (h) {
    var tag = this.tag || this.$vnode.data.tag || 'span';
    var map = Object.create(null);
    var prevChildren = this.prevChildren = this.children;
    var rawChildren = this.$slots.default || [];
    var children = this.children = [];
    var transitionData = extractTransitionData(this);

    for (var i = 0; i < rawChildren.length; i++) {
      var c = rawChildren[i];
      if (c.tag) {
        if (c.key != null && String(c.key).indexOf('__vlist') !== 0) {
          children.push(c);
          map[c.key] = c
          ;(c.data || (c.data = {})).transition = transitionData;
        } else if (false) {
          var opts = c.componentOptions;
          var name = opts ? (opts.Ctor.options.name || opts.tag || '') : c.tag;
          warn(("<transition-group> children must be keyed: <" + name + ">"));
        }
      }
    }

    if (prevChildren) {
      var kept = [];
      var removed = [];
      for (var i$1 = 0; i$1 < prevChildren.length; i$1++) {
        var c$1 = prevChildren[i$1];
        c$1.data.transition = transitionData;
        c$1.data.pos = c$1.elm.getBoundingClientRect();
        if (map[c$1.key]) {
          kept.push(c$1);
        } else {
          removed.push(c$1);
        }
      }
      this.kept = h(tag, null, kept);
      this.removed = removed;
    }

    return h(tag, null, children)
  },

  updated: function updated () {
    var children = this.prevChildren;
    var moveClass = this.moveClass || ((this.name || 'v') + '-move');
    if (!children.length || !this.hasMove(children[0].elm, moveClass)) {
      return
    }

    // we divide the work into three loops to avoid mixing DOM reads and writes
    // in each iteration - which helps prevent layout thrashing.
    children.forEach(callPendingCbs);
    children.forEach(recordPosition);
    children.forEach(applyTranslation);

    // force reflow to put everything in position
    // assign to this to avoid being removed in tree-shaking
    // $flow-disable-line
    this._reflow = document.body.offsetHeight;

    children.forEach(function (c) {
      if (c.data.moved) {
        var el = c.elm;
        var s = el.style;
        addTransitionClass(el, moveClass);
        s.transform = s.WebkitTransform = s.transitionDuration = '';
        el.addEventListener(transitionEndEvent, el._moveCb = function cb (e) {
          if (e && e.target !== el) {
            return
          }
          if (!e || /transform$/.test(e.propertyName)) {
            el.removeEventListener(transitionEndEvent, cb);
            el._moveCb = null;
            removeTransitionClass(el, moveClass);
          }
        });
      }
    });
  },

  methods: {
    hasMove: function hasMove (el, moveClass) {
      /* istanbul ignore if */
      if (!hasTransition) {
        return false
      }
      /* istanbul ignore if */
      if (this._hasMove) {
        return this._hasMove
      }
      // Detect whether an element with the move class applied has
      // CSS transitions. Since the element may be inside an entering
      // transition at this very moment, we make a clone of it and remove
      // all other transition classes applied to ensure only the move class
      // is applied.
      var clone = el.cloneNode();
      if (el._transitionClasses) {
        el._transitionClasses.forEach(function (cls) { removeClass(clone, cls); });
      }
      addClass(clone, moveClass);
      clone.style.display = 'none';
      this.$el.appendChild(clone);
      var info = getTransitionInfo(clone);
      this.$el.removeChild(clone);
      return (this._hasMove = info.hasTransform)
    }
  }
};

function callPendingCbs (c) {
  /* istanbul ignore if */
  if (c.elm._moveCb) {
    c.elm._moveCb();
  }
  /* istanbul ignore if */
  if (c.elm._enterCb) {
    c.elm._enterCb();
  }
}

function recordPosition (c) {
  c.data.newPos = c.elm.getBoundingClientRect();
}

function applyTranslation (c) {
  var oldPos = c.data.pos;
  var newPos = c.data.newPos;
  var dx = oldPos.left - newPos.left;
  var dy = oldPos.top - newPos.top;
  if (dx || dy) {
    c.data.moved = true;
    var s = c.elm.style;
    s.transform = s.WebkitTransform = "translate(" + dx + "px," + dy + "px)";
    s.transitionDuration = '0s';
  }
}

var platformComponents = {
  Transition: Transition,
  TransitionGroup: TransitionGroup
};

/*  */

// install platform specific utils
Vue.config.mustUseProp = mustUseProp;
Vue.config.isReservedTag = isReservedTag;
Vue.config.isReservedAttr = isReservedAttr;
Vue.config.getTagNamespace = getTagNamespace;
Vue.config.isUnknownElement = isUnknownElement;

// install platform runtime directives & components
extend(Vue.options.directives, platformDirectives);
extend(Vue.options.components, platformComponents);

// install platform patch function
Vue.prototype.__patch__ = inBrowser ? patch : noop;

// public mount method
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && inBrowser ? query(el) : undefined;
  return mountComponent(this, el, hydrating)
};

// devtools global hook
/* istanbul ignore next */
if (inBrowser) {
  setTimeout(function () {
    if (config.devtools) {
      if (devtools) {
        devtools.emit('init', Vue);
      } else if (
        false
      ) {
        console[console.info ? 'info' : 'log'](
          'Download the Vue Devtools extension for a better development experience:\n' +
          'https://github.com/vuejs/vue-devtools'
        );
      }
    }
    if (false
    ) {
      console[console.info ? 'info' : 'log'](
        "You are running Vue in development mode.\n" +
        "Make sure to turn on production mode when deploying for production.\n" +
        "See more tips at https://vuejs.org/guide/deployment.html"
      );
    }
  }, 0);
}

/*  */

var defaultTagRE = /\{\{((?:.|\r?\n)+?)\}\}/g;
var regexEscapeRE = /[-.*+?^${}()|[\]\/\\]/g;

var buildRegex = cached(function (delimiters) {
  var open = delimiters[0].replace(regexEscapeRE, '\\$&');
  var close = delimiters[1].replace(regexEscapeRE, '\\$&');
  return new RegExp(open + '((?:.|\\n)+?)' + close, 'g')
});



function parseText (
  text,
  delimiters
) {
  var tagRE = delimiters ? buildRegex(delimiters) : defaultTagRE;
  if (!tagRE.test(text)) {
    return
  }
  var tokens = [];
  var rawTokens = [];
  var lastIndex = tagRE.lastIndex = 0;
  var match, index, tokenValue;
  while ((match = tagRE.exec(text))) {
    index = match.index;
    // push text token
    if (index > lastIndex) {
      rawTokens.push(tokenValue = text.slice(lastIndex, index));
      tokens.push(JSON.stringify(tokenValue));
    }
    // tag token
    var exp = parseFilters(match[1].trim());
    tokens.push(("_s(" + exp + ")"));
    rawTokens.push({ '@binding': exp });
    lastIndex = index + match[0].length;
  }
  if (lastIndex < text.length) {
    rawTokens.push(tokenValue = text.slice(lastIndex));
    tokens.push(JSON.stringify(tokenValue));
  }
  return {
    expression: tokens.join('+'),
    tokens: rawTokens
  }
}

/*  */

function transformNode (el, options) {
  var warn = options.warn || baseWarn;
  var staticClass = getAndRemoveAttr(el, 'class');
  if (false) {
    var res = parseText(staticClass, options.delimiters);
    if (res) {
      warn(
        "class=\"" + staticClass + "\": " +
        'Interpolation inside attributes has been removed. ' +
        'Use v-bind or the colon shorthand instead. For example, ' +
        'instead of <div class="{{ val }}">, use <div :class="val">.',
        el.rawAttrsMap['class']
      );
    }
  }
  if (staticClass) {
    el.staticClass = JSON.stringify(staticClass);
  }
  var classBinding = getBindingAttr(el, 'class', false /* getStatic */);
  if (classBinding) {
    el.classBinding = classBinding;
  }
}

function genData (el) {
  var data = '';
  if (el.staticClass) {
    data += "staticClass:" + (el.staticClass) + ",";
  }
  if (el.classBinding) {
    data += "class:" + (el.classBinding) + ",";
  }
  return data
}

var klass$1 = {
  staticKeys: ['staticClass'],
  transformNode: transformNode,
  genData: genData
};

/*  */

function transformNode$1 (el, options) {
  var warn = options.warn || baseWarn;
  var staticStyle = getAndRemoveAttr(el, 'style');
  if (staticStyle) {
    /* istanbul ignore if */
    if (false) {
      var res = parseText(staticStyle, options.delimiters);
      if (res) {
        warn(
          "style=\"" + staticStyle + "\": " +
          'Interpolation inside attributes has been removed. ' +
          'Use v-bind or the colon shorthand instead. For example, ' +
          'instead of <div style="{{ val }}">, use <div :style="val">.',
          el.rawAttrsMap['style']
        );
      }
    }
    el.staticStyle = JSON.stringify(parseStyleText(staticStyle));
  }

  var styleBinding = getBindingAttr(el, 'style', false /* getStatic */);
  if (styleBinding) {
    el.styleBinding = styleBinding;
  }
}

function genData$1 (el) {
  var data = '';
  if (el.staticStyle) {
    data += "staticStyle:" + (el.staticStyle) + ",";
  }
  if (el.styleBinding) {
    data += "style:(" + (el.styleBinding) + "),";
  }
  return data
}

var style$1 = {
  staticKeys: ['staticStyle'],
  transformNode: transformNode$1,
  genData: genData$1
};

/*  */

var decoder;

var he = {
  decode: function decode (html) {
    decoder = decoder || document.createElement('div');
    decoder.innerHTML = html;
    return decoder.textContent
  }
};

/*  */

var isUnaryTag = makeMap(
  'area,base,br,col,embed,frame,hr,img,input,isindex,keygen,' +
  'link,meta,param,source,track,wbr'
);

// Elements that you can, intentionally, leave open
// (and which close themselves)
var canBeLeftOpenTag = makeMap(
  'colgroup,dd,dt,li,options,p,td,tfoot,th,thead,tr,source'
);

// HTML5 tags https://html.spec.whatwg.org/multipage/indices.html#elements-3
// Phrasing Content https://html.spec.whatwg.org/multipage/dom.html#phrasing-content
var isNonPhrasingTag = makeMap(
  'address,article,aside,base,blockquote,body,caption,col,colgroup,dd,' +
  'details,dialog,div,dl,dt,fieldset,figcaption,figure,footer,form,' +
  'h1,h2,h3,h4,h5,h6,head,header,hgroup,hr,html,legend,li,menuitem,meta,' +
  'optgroup,option,param,rp,rt,source,style,summary,tbody,td,tfoot,th,thead,' +
  'title,tr,track'
);

/**
 * Not type-checking this file because it's mostly vendor code.
 */

// Regular Expressions for parsing tags and attributes
var attribute = /^\s*([^\s"'<>\/=]+)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var dynamicArgAttribute = /^\s*((?:v-[\w-]+:|@|:|#)\[[^=]+\][^\s"'<>\/=]*)(?:\s*(=)\s*(?:"([^"]*)"+|'([^']*)'+|([^\s"'=<>`]+)))?/;
var ncname = "[a-zA-Z_][\\-\\.0-9_a-zA-Z" + (unicodeRegExp.source) + "]*";
var qnameCapture = "((?:" + ncname + "\\:)?" + ncname + ")";
var startTagOpen = new RegExp(("^<" + qnameCapture));
var startTagClose = /^\s*(\/?)>/;
var endTag = new RegExp(("^<\\/" + qnameCapture + "[^>]*>"));
var doctype = /^<!DOCTYPE [^>]+>/i;
// #7298: escape - to avoid being passed as HTML comment when inlined in page
var comment = /^<!\--/;
var conditionalComment = /^<!\[/;

// Special Elements (can contain anything)
var isPlainTextElement = makeMap('script,style,textarea', true);
var reCache = {};

var decodingMap = {
  '&lt;': '<',
  '&gt;': '>',
  '&quot;': '"',
  '&amp;': '&',
  '&#10;': '\n',
  '&#9;': '\t',
  '&#39;': "'"
};
var encodedAttr = /&(?:lt|gt|quot|amp|#39);/g;
var encodedAttrWithNewLines = /&(?:lt|gt|quot|amp|#39|#10|#9);/g;

// #5992
var isIgnoreNewlineTag = makeMap('pre,textarea', true);
var shouldIgnoreFirstNewline = function (tag, html) { return tag && isIgnoreNewlineTag(tag) && html[0] === '\n'; };

function decodeAttr (value, shouldDecodeNewlines) {
  var re = shouldDecodeNewlines ? encodedAttrWithNewLines : encodedAttr;
  return value.replace(re, function (match) { return decodingMap[match]; })
}

function parseHTML (html, options) {
  var stack = [];
  var expectHTML = options.expectHTML;
  var isUnaryTag$$1 = options.isUnaryTag || no;
  var canBeLeftOpenTag$$1 = options.canBeLeftOpenTag || no;
  var index = 0;
  var last, lastTag;
  while (html) {
    last = html;
    // Make sure we're not in a plaintext content element like script/style
    if (!lastTag || !isPlainTextElement(lastTag)) {
      var textEnd = html.indexOf('<');
      if (textEnd === 0) {
        // Comment:
        if (comment.test(html)) {
          var commentEnd = html.indexOf('-->');

          if (commentEnd >= 0) {
            if (options.shouldKeepComment) {
              options.comment(html.substring(4, commentEnd), index, index + commentEnd + 3);
            }
            advance(commentEnd + 3);
            continue
          }
        }

        // http://en.wikipedia.org/wiki/Conditional_comment#Downlevel-revealed_conditional_comment
        if (conditionalComment.test(html)) {
          var conditionalEnd = html.indexOf(']>');

          if (conditionalEnd >= 0) {
            advance(conditionalEnd + 2);
            continue
          }
        }

        // Doctype:
        var doctypeMatch = html.match(doctype);
        if (doctypeMatch) {
          advance(doctypeMatch[0].length);
          continue
        }

        // End tag:
        var endTagMatch = html.match(endTag);
        if (endTagMatch) {
          var curIndex = index;
          advance(endTagMatch[0].length);
          parseEndTag(endTagMatch[1], curIndex, index);
          continue
        }

        // Start tag:
        var startTagMatch = parseStartTag();
        if (startTagMatch) {
          handleStartTag(startTagMatch);
          if (shouldIgnoreFirstNewline(startTagMatch.tagName, html)) {
            advance(1);
          }
          continue
        }
      }

      var text = (void 0), rest = (void 0), next = (void 0);
      if (textEnd >= 0) {
        rest = html.slice(textEnd);
        while (
          !endTag.test(rest) &&
          !startTagOpen.test(rest) &&
          !comment.test(rest) &&
          !conditionalComment.test(rest)
        ) {
          // < in plain text, be forgiving and treat it as text
          next = rest.indexOf('<', 1);
          if (next < 0) { break }
          textEnd += next;
          rest = html.slice(textEnd);
        }
        text = html.substring(0, textEnd);
      }

      if (textEnd < 0) {
        text = html;
      }

      if (text) {
        advance(text.length);
      }

      if (options.chars && text) {
        options.chars(text, index - text.length, index);
      }
    } else {
      var endTagLength = 0;
      var stackedTag = lastTag.toLowerCase();
      var reStackedTag = reCache[stackedTag] || (reCache[stackedTag] = new RegExp('([\\s\\S]*?)(</' + stackedTag + '[^>]*>)', 'i'));
      var rest$1 = html.replace(reStackedTag, function (all, text, endTag) {
        endTagLength = endTag.length;
        if (!isPlainTextElement(stackedTag) && stackedTag !== 'noscript') {
          text = text
            .replace(/<!\--([\s\S]*?)-->/g, '$1') // #7298
            .replace(/<!\[CDATA\[([\s\S]*?)]]>/g, '$1');
        }
        if (shouldIgnoreFirstNewline(stackedTag, text)) {
          text = text.slice(1);
        }
        if (options.chars) {
          options.chars(text);
        }
        return ''
      });
      index += html.length - rest$1.length;
      html = rest$1;
      parseEndTag(stackedTag, index - endTagLength, index);
    }

    if (html === last) {
      options.chars && options.chars(html);
      if (false) {
        options.warn(("Mal-formatted tag at end of template: \"" + html + "\""), { start: index + html.length });
      }
      break
    }
  }

  // Clean up any remaining tags
  parseEndTag();

  function advance (n) {
    index += n;
    html = html.substring(n);
  }

  function parseStartTag () {
    var start = html.match(startTagOpen);
    if (start) {
      var match = {
        tagName: start[1],
        attrs: [],
        start: index
      };
      advance(start[0].length);
      var end, attr;
      while (!(end = html.match(startTagClose)) && (attr = html.match(dynamicArgAttribute) || html.match(attribute))) {
        attr.start = index;
        advance(attr[0].length);
        attr.end = index;
        match.attrs.push(attr);
      }
      if (end) {
        match.unarySlash = end[1];
        advance(end[0].length);
        match.end = index;
        return match
      }
    }
  }

  function handleStartTag (match) {
    var tagName = match.tagName;
    var unarySlash = match.unarySlash;

    if (expectHTML) {
      if (lastTag === 'p' && isNonPhrasingTag(tagName)) {
        parseEndTag(lastTag);
      }
      if (canBeLeftOpenTag$$1(tagName) && lastTag === tagName) {
        parseEndTag(tagName);
      }
    }

    var unary = isUnaryTag$$1(tagName) || !!unarySlash;

    var l = match.attrs.length;
    var attrs = new Array(l);
    for (var i = 0; i < l; i++) {
      var args = match.attrs[i];
      var value = args[3] || args[4] || args[5] || '';
      var shouldDecodeNewlines = tagName === 'a' && args[1] === 'href'
        ? options.shouldDecodeNewlinesForHref
        : options.shouldDecodeNewlines;
      attrs[i] = {
        name: args[1],
        value: decodeAttr(value, shouldDecodeNewlines)
      };
      if (false) {
        attrs[i].start = args.start + args[0].match(/^\s*/).length;
        attrs[i].end = args.end;
      }
    }

    if (!unary) {
      stack.push({ tag: tagName, lowerCasedTag: tagName.toLowerCase(), attrs: attrs, start: match.start, end: match.end });
      lastTag = tagName;
    }

    if (options.start) {
      options.start(tagName, attrs, unary, match.start, match.end);
    }
  }

  function parseEndTag (tagName, start, end) {
    var pos, lowerCasedTagName;
    if (start == null) { start = index; }
    if (end == null) { end = index; }

    // Find the closest opened tag of the same type
    if (tagName) {
      lowerCasedTagName = tagName.toLowerCase();
      for (pos = stack.length - 1; pos >= 0; pos--) {
        if (stack[pos].lowerCasedTag === lowerCasedTagName) {
          break
        }
      }
    } else {
      // If no tag name is provided, clean shop
      pos = 0;
    }

    if (pos >= 0) {
      // Close all the open elements, up the stack
      for (var i = stack.length - 1; i >= pos; i--) {
        if (false
        ) {
          options.warn(
            ("tag <" + (stack[i].tag) + "> has no matching end tag."),
            { start: stack[i].start, end: stack[i].end }
          );
        }
        if (options.end) {
          options.end(stack[i].tag, start, end);
        }
      }

      // Remove the open elements from the stack
      stack.length = pos;
      lastTag = pos && stack[pos - 1].tag;
    } else if (lowerCasedTagName === 'br') {
      if (options.start) {
        options.start(tagName, [], true, start, end);
      }
    } else if (lowerCasedTagName === 'p') {
      if (options.start) {
        options.start(tagName, [], false, start, end);
      }
      if (options.end) {
        options.end(tagName, start, end);
      }
    }
  }
}

/*  */

var onRE = /^@|^v-on:/;
var dirRE = /^v-|^@|^:|^#/;
var forAliasRE = /([\s\S]*?)\s+(?:in|of)\s+([\s\S]*)/;
var forIteratorRE = /,([^,\}\]]*)(?:,([^,\}\]]*))?$/;
var stripParensRE = /^\(|\)$/g;
var dynamicArgRE = /^\[.*\]$/;

var argRE = /:(.*)$/;
var bindRE = /^:|^\.|^v-bind:/;
var modifierRE = /\.[^.\]]+(?=[^\]]*$)/g;

var slotRE = /^v-slot(:|$)|^#/;

var lineBreakRE = /[\r\n]/;
var whitespaceRE$1 = /\s+/g;

var invalidAttributeRE = /[\s"'<>\/=]/;

var decodeHTMLCached = cached(he.decode);

var emptySlotScopeToken = "_empty_";

// configurable state
var warn$2;
var delimiters;
var transforms;
var preTransforms;
var postTransforms;
var platformIsPreTag;
var platformMustUseProp;
var platformGetTagNamespace;
var maybeComponent;

function createASTElement (
  tag,
  attrs,
  parent
) {
  return {
    type: 1,
    tag: tag,
    attrsList: attrs,
    attrsMap: makeAttrsMap(attrs),
    rawAttrsMap: {},
    parent: parent,
    children: []
  }
}

/**
 * Convert HTML string to AST.
 */
function parse (
  template,
  options
) {
  warn$2 = options.warn || baseWarn;

  platformIsPreTag = options.isPreTag || no;
  platformMustUseProp = options.mustUseProp || no;
  platformGetTagNamespace = options.getTagNamespace || no;
  var isReservedTag = options.isReservedTag || no;
  maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };

  transforms = pluckModuleFunction(options.modules, 'transformNode');
  preTransforms = pluckModuleFunction(options.modules, 'preTransformNode');
  postTransforms = pluckModuleFunction(options.modules, 'postTransformNode');

  delimiters = options.delimiters;

  var stack = [];
  var preserveWhitespace = options.preserveWhitespace !== false;
  var whitespaceOption = options.whitespace;
  var root;
  var currentParent;
  var inVPre = false;
  var inPre = false;
  var warned = false;

  function warnOnce (msg, range) {
    if (!warned) {
      warned = true;
      warn$2(msg, range);
    }
  }

  function closeElement (element) {
    trimEndingWhitespace(element);
    if (!inVPre && !element.processed) {
      element = processElement(element, options);
    }
    // tree management
    if (!stack.length && element !== root) {
      // allow root elements with v-if, v-else-if and v-else
      if (root.if && (element.elseif || element.else)) {
        if (false) {
          checkRootConstraints(element);
        }
        addIfCondition(root, {
          exp: element.elseif,
          block: element
        });
      } else if (false) {
        warnOnce(
          "Component template should contain exactly one root element. " +
          "If you are using v-if on multiple elements, " +
          "use v-else-if to chain them instead.",
          { start: element.start }
        );
      }
    }
    if (currentParent && !element.forbidden) {
      if (element.elseif || element.else) {
        processIfConditions(element, currentParent);
      } else {
        if (element.slotScope) {
          // scoped slot
          // keep it in the children list so that v-else(-if) conditions can
          // find it as the prev node.
          var name = element.slotTarget || '"default"'
          ;(currentParent.scopedSlots || (currentParent.scopedSlots = {}))[name] = element;
        }
        currentParent.children.push(element);
        element.parent = currentParent;
      }
    }

    // final children cleanup
    // filter out scoped slots
    element.children = element.children.filter(function (c) { return !(c).slotScope; });
    // remove trailing whitespace node again
    trimEndingWhitespace(element);

    // check pre state
    if (element.pre) {
      inVPre = false;
    }
    if (platformIsPreTag(element.tag)) {
      inPre = false;
    }
    // apply post-transforms
    for (var i = 0; i < postTransforms.length; i++) {
      postTransforms[i](element, options);
    }
  }

  function trimEndingWhitespace (el) {
    // remove trailing whitespace node
    if (!inPre) {
      var lastNode;
      while (
        (lastNode = el.children[el.children.length - 1]) &&
        lastNode.type === 3 &&
        lastNode.text === ' '
      ) {
        el.children.pop();
      }
    }
  }

  function checkRootConstraints (el) {
    if (el.tag === 'slot' || el.tag === 'template') {
      warnOnce(
        "Cannot use <" + (el.tag) + "> as component root element because it may " +
        'contain multiple nodes.',
        { start: el.start }
      );
    }
    if (el.attrsMap.hasOwnProperty('v-for')) {
      warnOnce(
        'Cannot use v-for on stateful component root element because ' +
        'it renders multiple elements.',
        el.rawAttrsMap['v-for']
      );
    }
  }

  parseHTML(template, {
    warn: warn$2,
    expectHTML: options.expectHTML,
    isUnaryTag: options.isUnaryTag,
    canBeLeftOpenTag: options.canBeLeftOpenTag,
    shouldDecodeNewlines: options.shouldDecodeNewlines,
    shouldDecodeNewlinesForHref: options.shouldDecodeNewlinesForHref,
    shouldKeepComment: options.comments,
    outputSourceRange: options.outputSourceRange,
    start: function start (tag, attrs, unary, start$1, end) {
      // check namespace.
      // inherit parent ns if there is one
      var ns = (currentParent && currentParent.ns) || platformGetTagNamespace(tag);

      // handle IE svg bug
      /* istanbul ignore if */
      if (isIE && ns === 'svg') {
        attrs = guardIESVGBug(attrs);
      }

      var element = createASTElement(tag, attrs, currentParent);
      if (ns) {
        element.ns = ns;
      }

      if (false) {
        if (options.outputSourceRange) {
          element.start = start$1;
          element.end = end;
          element.rawAttrsMap = element.attrsList.reduce(function (cumulated, attr) {
            cumulated[attr.name] = attr;
            return cumulated
          }, {});
        }
        attrs.forEach(function (attr) {
          if (invalidAttributeRE.test(attr.name)) {
            warn$2(
              "Invalid dynamic argument expression: attribute names cannot contain " +
              "spaces, quotes, <, >, / or =.",
              {
                start: attr.start + attr.name.indexOf("["),
                end: attr.start + attr.name.length
              }
            );
          }
        });
      }

      if (isForbiddenTag(element) && !isServerRendering()) {
        element.forbidden = true;
        "production" !== 'production' && warn$2(
          'Templates should only be responsible for mapping the state to the ' +
          'UI. Avoid placing tags with side-effects in your templates, such as ' +
          "<" + tag + ">" + ', as they will not be parsed.',
          { start: element.start }
        );
      }

      // apply pre-transforms
      for (var i = 0; i < preTransforms.length; i++) {
        element = preTransforms[i](element, options) || element;
      }

      if (!inVPre) {
        processPre(element);
        if (element.pre) {
          inVPre = true;
        }
      }
      if (platformIsPreTag(element.tag)) {
        inPre = true;
      }
      if (inVPre) {
        processRawAttrs(element);
      } else if (!element.processed) {
        // structural directives
        processFor(element);
        processIf(element);
        processOnce(element);
      }

      if (!root) {
        root = element;
        if (false) {
          checkRootConstraints(root);
        }
      }

      if (!unary) {
        currentParent = element;
        stack.push(element);
      } else {
        closeElement(element);
      }
    },

    end: function end (tag, start, end$1) {
      var element = stack[stack.length - 1];
      // pop stack
      stack.length -= 1;
      currentParent = stack[stack.length - 1];
      if (false) {
        element.end = end$1;
      }
      closeElement(element);
    },

    chars: function chars (text, start, end) {
      if (!currentParent) {
        if (false) {
          if (text === template) {
            warnOnce(
              'Component template requires a root element, rather than just text.',
              { start: start }
            );
          } else if ((text = text.trim())) {
            warnOnce(
              ("text \"" + text + "\" outside root element will be ignored."),
              { start: start }
            );
          }
        }
        return
      }
      // IE textarea placeholder bug
      /* istanbul ignore if */
      if (isIE &&
        currentParent.tag === 'textarea' &&
        currentParent.attrsMap.placeholder === text
      ) {
        return
      }
      var children = currentParent.children;
      if (inPre || text.trim()) {
        text = isTextTag(currentParent) ? text : decodeHTMLCached(text);
      } else if (!children.length) {
        // remove the whitespace-only node right after an opening tag
        text = '';
      } else if (whitespaceOption) {
        if (whitespaceOption === 'condense') {
          // in condense mode, remove the whitespace node if it contains
          // line break, otherwise condense to a single space
          text = lineBreakRE.test(text) ? '' : ' ';
        } else {
          text = ' ';
        }
      } else {
        text = preserveWhitespace ? ' ' : '';
      }
      if (text) {
        if (!inPre && whitespaceOption === 'condense') {
          // condense consecutive whitespaces into single space
          text = text.replace(whitespaceRE$1, ' ');
        }
        var res;
        var child;
        if (!inVPre && text !== ' ' && (res = parseText(text, delimiters))) {
          child = {
            type: 2,
            expression: res.expression,
            tokens: res.tokens,
            text: text
          };
        } else if (text !== ' ' || !children.length || children[children.length - 1].text !== ' ') {
          child = {
            type: 3,
            text: text
          };
        }
        if (child) {
          if (false) {
            child.start = start;
            child.end = end;
          }
          children.push(child);
        }
      }
    },
    comment: function comment (text, start, end) {
      // adding anything as a sibling to the root node is forbidden
      // comments should still be allowed, but ignored
      if (currentParent) {
        var child = {
          type: 3,
          text: text,
          isComment: true
        };
        if (false) {
          child.start = start;
          child.end = end;
        }
        currentParent.children.push(child);
      }
    }
  });
  return root
}

function processPre (el) {
  if (getAndRemoveAttr(el, 'v-pre') != null) {
    el.pre = true;
  }
}

function processRawAttrs (el) {
  var list = el.attrsList;
  var len = list.length;
  if (len) {
    var attrs = el.attrs = new Array(len);
    for (var i = 0; i < len; i++) {
      attrs[i] = {
        name: list[i].name,
        value: JSON.stringify(list[i].value)
      };
      if (list[i].start != null) {
        attrs[i].start = list[i].start;
        attrs[i].end = list[i].end;
      }
    }
  } else if (!el.pre) {
    // non root node in pre blocks with no attributes
    el.plain = true;
  }
}

function processElement (
  element,
  options
) {
  processKey(element);

  // determine whether this is a plain element after
  // removing structural attributes
  element.plain = (
    !element.key &&
    !element.scopedSlots &&
    !element.attrsList.length
  );

  processRef(element);
  processSlotContent(element);
  processSlotOutlet(element);
  processComponent(element);
  for (var i = 0; i < transforms.length; i++) {
    element = transforms[i](element, options) || element;
  }
  processAttrs(element);
  return element
}

function processKey (el) {
  var exp = getBindingAttr(el, 'key');
  if (exp) {
    if (false) {
      if (el.tag === 'template') {
        warn$2(
          "<template> cannot be keyed. Place the key on real elements instead.",
          getRawBindingAttr(el, 'key')
        );
      }
      if (el.for) {
        var iterator = el.iterator2 || el.iterator1;
        var parent = el.parent;
        if (iterator && iterator === exp && parent && parent.tag === 'transition-group') {
          warn$2(
            "Do not use v-for index as key on <transition-group> children, " +
            "this is the same as not using keys.",
            getRawBindingAttr(el, 'key'),
            true /* tip */
          );
        }
      }
    }
    el.key = exp;
  }
}

function processRef (el) {
  var ref = getBindingAttr(el, 'ref');
  if (ref) {
    el.ref = ref;
    el.refInFor = checkInFor(el);
  }
}

function processFor (el) {
  var exp;
  if ((exp = getAndRemoveAttr(el, 'v-for'))) {
    var res = parseFor(exp);
    if (res) {
      extend(el, res);
    } else if (false) {
      warn$2(
        ("Invalid v-for expression: " + exp),
        el.rawAttrsMap['v-for']
      );
    }
  }
}



function parseFor (exp) {
  var inMatch = exp.match(forAliasRE);
  if (!inMatch) { return }
  var res = {};
  res.for = inMatch[2].trim();
  var alias = inMatch[1].trim().replace(stripParensRE, '');
  var iteratorMatch = alias.match(forIteratorRE);
  if (iteratorMatch) {
    res.alias = alias.replace(forIteratorRE, '').trim();
    res.iterator1 = iteratorMatch[1].trim();
    if (iteratorMatch[2]) {
      res.iterator2 = iteratorMatch[2].trim();
    }
  } else {
    res.alias = alias;
  }
  return res
}

function processIf (el) {
  var exp = getAndRemoveAttr(el, 'v-if');
  if (exp) {
    el.if = exp;
    addIfCondition(el, {
      exp: exp,
      block: el
    });
  } else {
    if (getAndRemoveAttr(el, 'v-else') != null) {
      el.else = true;
    }
    var elseif = getAndRemoveAttr(el, 'v-else-if');
    if (elseif) {
      el.elseif = elseif;
    }
  }
}

function processIfConditions (el, parent) {
  var prev = findPrevElement(parent.children);
  if (prev && prev.if) {
    addIfCondition(prev, {
      exp: el.elseif,
      block: el
    });
  } else if (false) {
    warn$2(
      "v-" + (el.elseif ? ('else-if="' + el.elseif + '"') : 'else') + " " +
      "used on element <" + (el.tag) + "> without corresponding v-if.",
      el.rawAttrsMap[el.elseif ? 'v-else-if' : 'v-else']
    );
  }
}

function findPrevElement (children) {
  var i = children.length;
  while (i--) {
    if (children[i].type === 1) {
      return children[i]
    } else {
      if (false) {
        warn$2(
          "text \"" + (children[i].text.trim()) + "\" between v-if and v-else(-if) " +
          "will be ignored.",
          children[i]
        );
      }
      children.pop();
    }
  }
}

function addIfCondition (el, condition) {
  if (!el.ifConditions) {
    el.ifConditions = [];
  }
  el.ifConditions.push(condition);
}

function processOnce (el) {
  var once$$1 = getAndRemoveAttr(el, 'v-once');
  if (once$$1 != null) {
    el.once = true;
  }
}

// handle content being passed to a component as slot,
// e.g. <template slot="xxx">, <div slot-scope="xxx">
function processSlotContent (el) {
  var slotScope;
  if (el.tag === 'template') {
    slotScope = getAndRemoveAttr(el, 'scope');
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "the \"scope\" attribute for scoped slots have been deprecated and " +
        "replaced by \"slot-scope\" since 2.5. The new \"slot-scope\" attribute " +
        "can also be used on plain elements in addition to <template> to " +
        "denote scoped slots.",
        el.rawAttrsMap['scope'],
        true
      );
    }
    el.slotScope = slotScope || getAndRemoveAttr(el, 'slot-scope');
  } else if ((slotScope = getAndRemoveAttr(el, 'slot-scope'))) {
    /* istanbul ignore if */
    if (false) {
      warn$2(
        "Ambiguous combined usage of slot-scope and v-for on <" + (el.tag) + "> " +
        "(v-for takes higher priority). Use a wrapper <template> for the " +
        "scoped slot to make it clearer.",
        el.rawAttrsMap['slot-scope'],
        true
      );
    }
    el.slotScope = slotScope;
  }

  // slot="xxx"
  var slotTarget = getBindingAttr(el, 'slot');
  if (slotTarget) {
    el.slotTarget = slotTarget === '""' ? '"default"' : slotTarget;
    el.slotTargetDynamic = !!(el.attrsMap[':slot'] || el.attrsMap['v-bind:slot']);
    // preserve slot as an attribute for native shadow DOM compat
    // only for non-scoped slots.
    if (el.tag !== 'template' && !el.slotScope) {
      addAttr(el, 'slot', slotTarget, getRawBindingAttr(el, 'slot'));
    }
  }

  // 2.6 v-slot syntax
  {
    if (el.tag === 'template') {
      // v-slot on <template>
      var slotBinding = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding) {
        if (false) {
          if (el.slotTarget || el.slotScope) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.parent && !maybeComponent(el.parent)) {
            warn$2(
              "<template v-slot> can only appear at the root level inside " +
              "the receiving component",
              el
            );
          }
        }
        var ref = getSlotName(slotBinding);
        var name = ref.name;
        var dynamic = ref.dynamic;
        el.slotTarget = name;
        el.slotTargetDynamic = dynamic;
        el.slotScope = slotBinding.value || emptySlotScopeToken; // force it into a scoped slot for perf
      }
    } else {
      // v-slot on component, denotes default slot
      var slotBinding$1 = getAndRemoveAttrByRegex(el, slotRE);
      if (slotBinding$1) {
        if (false) {
          if (!maybeComponent(el)) {
            warn$2(
              "v-slot can only be used on components or <template>.",
              slotBinding$1
            );
          }
          if (el.slotScope || el.slotTarget) {
            warn$2(
              "Unexpected mixed usage of different slot syntaxes.",
              el
            );
          }
          if (el.scopedSlots) {
            warn$2(
              "To avoid scope ambiguity, the default slot should also use " +
              "<template> syntax when there are other named slots.",
              slotBinding$1
            );
          }
        }
        // add the component's children to its default slot
        var slots = el.scopedSlots || (el.scopedSlots = {});
        var ref$1 = getSlotName(slotBinding$1);
        var name$1 = ref$1.name;
        var dynamic$1 = ref$1.dynamic;
        var slotContainer = slots[name$1] = createASTElement('template', [], el);
        slotContainer.slotTarget = name$1;
        slotContainer.slotTargetDynamic = dynamic$1;
        slotContainer.children = el.children.filter(function (c) {
          if (!c.slotScope) {
            c.parent = slotContainer;
            return true
          }
        });
        slotContainer.slotScope = slotBinding$1.value || emptySlotScopeToken;
        // remove children as they are returned from scopedSlots now
        el.children = [];
        // mark el non-plain so data gets generated
        el.plain = false;
      }
    }
  }
}

function getSlotName (binding) {
  var name = binding.name.replace(slotRE, '');
  if (!name) {
    if (binding.name[0] !== '#') {
      name = 'default';
    } else if (false) {
      warn$2(
        "v-slot shorthand syntax requires a slot name.",
        binding
      );
    }
  }
  return dynamicArgRE.test(name)
    // dynamic [name]
    ? { name: name.slice(1, -1), dynamic: true }
    // static name
    : { name: ("\"" + name + "\""), dynamic: false }
}

// handle <slot/> outlets
function processSlotOutlet (el) {
  if (el.tag === 'slot') {
    el.slotName = getBindingAttr(el, 'name');
    if (false) {
      warn$2(
        "`key` does not work on <slot> because slots are abstract outlets " +
        "and can possibly expand into multiple elements. " +
        "Use the key on a wrapping element instead.",
        getRawBindingAttr(el, 'key')
      );
    }
  }
}

function processComponent (el) {
  var binding;
  if ((binding = getBindingAttr(el, 'is'))) {
    el.component = binding;
  }
  if (getAndRemoveAttr(el, 'inline-template') != null) {
    el.inlineTemplate = true;
  }
}

function processAttrs (el) {
  var list = el.attrsList;
  var i, l, name, rawName, value, modifiers, syncGen, isDynamic;
  for (i = 0, l = list.length; i < l; i++) {
    name = rawName = list[i].name;
    value = list[i].value;
    if (dirRE.test(name)) {
      // mark element as dynamic
      el.hasBindings = true;
      // modifiers
      modifiers = parseModifiers(name.replace(dirRE, ''));
      // support .foo shorthand syntax for the .prop modifier
      if (modifiers) {
        name = name.replace(modifierRE, '');
      }
      if (bindRE.test(name)) { // v-bind
        name = name.replace(bindRE, '');
        value = parseFilters(value);
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        if (
          false
        ) {
          warn$2(
            ("The value for a v-bind expression cannot be empty. Found in \"v-bind:" + name + "\"")
          );
        }
        if (modifiers) {
          if (modifiers.prop && !isDynamic) {
            name = camelize(name);
            if (name === 'innerHtml') { name = 'innerHTML'; }
          }
          if (modifiers.camel && !isDynamic) {
            name = camelize(name);
          }
          if (modifiers.sync) {
            syncGen = genAssignmentCode(value, "$event");
            if (!isDynamic) {
              addHandler(
                el,
                ("update:" + (camelize(name))),
                syncGen,
                null,
                false,
                warn$2,
                list[i]
              );
              if (hyphenate(name) !== camelize(name)) {
                addHandler(
                  el,
                  ("update:" + (hyphenate(name))),
                  syncGen,
                  null,
                  false,
                  warn$2,
                  list[i]
                );
              }
            } else {
              // handler w/ dynamic event name
              addHandler(
                el,
                ("\"update:\"+(" + name + ")"),
                syncGen,
                null,
                false,
                warn$2,
                list[i],
                true // dynamic
              );
            }
          }
        }
        if ((modifiers && modifiers.prop) || (
          !el.component && platformMustUseProp(el.tag, el.attrsMap.type, name)
        )) {
          addProp(el, name, value, list[i], isDynamic);
        } else {
          addAttr(el, name, value, list[i], isDynamic);
        }
      } else if (onRE.test(name)) { // v-on
        name = name.replace(onRE, '');
        isDynamic = dynamicArgRE.test(name);
        if (isDynamic) {
          name = name.slice(1, -1);
        }
        addHandler(el, name, value, modifiers, false, warn$2, list[i], isDynamic);
      } else { // normal directives
        name = name.replace(dirRE, '');
        // parse arg
        var argMatch = name.match(argRE);
        var arg = argMatch && argMatch[1];
        isDynamic = false;
        if (arg) {
          name = name.slice(0, -(arg.length + 1));
          if (dynamicArgRE.test(arg)) {
            arg = arg.slice(1, -1);
            isDynamic = true;
          }
        }
        addDirective(el, name, rawName, value, arg, isDynamic, modifiers, list[i]);
        if (false) {
          checkForAliasModel(el, value);
        }
      }
    } else {
      // literal attribute
      if (false) {
        var res = parseText(value, delimiters);
        if (res) {
          warn$2(
            name + "=\"" + value + "\": " +
            'Interpolation inside attributes has been removed. ' +
            'Use v-bind or the colon shorthand instead. For example, ' +
            'instead of <div id="{{ val }}">, use <div :id="val">.',
            list[i]
          );
        }
      }
      addAttr(el, name, JSON.stringify(value), list[i]);
      // #6887 firefox doesn't update muted state if set via attribute
      // even immediately after element creation
      if (!el.component &&
          name === 'muted' &&
          platformMustUseProp(el.tag, el.attrsMap.type, name)) {
        addProp(el, name, 'true', list[i]);
      }
    }
  }
}

function checkInFor (el) {
  var parent = el;
  while (parent) {
    if (parent.for !== undefined) {
      return true
    }
    parent = parent.parent;
  }
  return false
}

function parseModifiers (name) {
  var match = name.match(modifierRE);
  if (match) {
    var ret = {};
    match.forEach(function (m) { ret[m.slice(1)] = true; });
    return ret
  }
}

function makeAttrsMap (attrs) {
  var map = {};
  for (var i = 0, l = attrs.length; i < l; i++) {
    if (
      false
    ) {
      warn$2('duplicate attribute: ' + attrs[i].name, attrs[i]);
    }
    map[attrs[i].name] = attrs[i].value;
  }
  return map
}

// for script (e.g. type="x/template") or style, do not decode content
function isTextTag (el) {
  return el.tag === 'script' || el.tag === 'style'
}

function isForbiddenTag (el) {
  return (
    el.tag === 'style' ||
    (el.tag === 'script' && (
      !el.attrsMap.type ||
      el.attrsMap.type === 'text/javascript'
    ))
  )
}

var ieNSBug = /^xmlns:NS\d+/;
var ieNSPrefix = /^NS\d+:/;

/* istanbul ignore next */
function guardIESVGBug (attrs) {
  var res = [];
  for (var i = 0; i < attrs.length; i++) {
    var attr = attrs[i];
    if (!ieNSBug.test(attr.name)) {
      attr.name = attr.name.replace(ieNSPrefix, '');
      res.push(attr);
    }
  }
  return res
}

function checkForAliasModel (el, value) {
  var _el = el;
  while (_el) {
    if (_el.for && _el.alias === value) {
      warn$2(
        "<" + (el.tag) + " v-model=\"" + value + "\">: " +
        "You are binding v-model directly to a v-for iteration alias. " +
        "This will not be able to modify the v-for source array because " +
        "writing to the alias is like modifying a function local variable. " +
        "Consider using an array of objects and use v-model on an object property instead.",
        el.rawAttrsMap['v-model']
      );
    }
    _el = _el.parent;
  }
}

/*  */

function preTransformNode (el, options) {
  if (el.tag === 'input') {
    var map = el.attrsMap;
    if (!map['v-model']) {
      return
    }

    var typeBinding;
    if (map[':type'] || map['v-bind:type']) {
      typeBinding = getBindingAttr(el, 'type');
    }
    if (!map.type && !typeBinding && map['v-bind']) {
      typeBinding = "(" + (map['v-bind']) + ").type";
    }

    if (typeBinding) {
      var ifCondition = getAndRemoveAttr(el, 'v-if', true);
      var ifConditionExtra = ifCondition ? ("&&(" + ifCondition + ")") : "";
      var hasElse = getAndRemoveAttr(el, 'v-else', true) != null;
      var elseIfCondition = getAndRemoveAttr(el, 'v-else-if', true);
      // 1. checkbox
      var branch0 = cloneASTElement(el);
      // process for on the main node
      processFor(branch0);
      addRawAttr(branch0, 'type', 'checkbox');
      processElement(branch0, options);
      branch0.processed = true; // prevent it from double-processed
      branch0.if = "(" + typeBinding + ")==='checkbox'" + ifConditionExtra;
      addIfCondition(branch0, {
        exp: branch0.if,
        block: branch0
      });
      // 2. add radio else-if condition
      var branch1 = cloneASTElement(el);
      getAndRemoveAttr(branch1, 'v-for', true);
      addRawAttr(branch1, 'type', 'radio');
      processElement(branch1, options);
      addIfCondition(branch0, {
        exp: "(" + typeBinding + ")==='radio'" + ifConditionExtra,
        block: branch1
      });
      // 3. other
      var branch2 = cloneASTElement(el);
      getAndRemoveAttr(branch2, 'v-for', true);
      addRawAttr(branch2, ':type', typeBinding);
      processElement(branch2, options);
      addIfCondition(branch0, {
        exp: ifCondition,
        block: branch2
      });

      if (hasElse) {
        branch0.else = true;
      } else if (elseIfCondition) {
        branch0.elseif = elseIfCondition;
      }

      return branch0
    }
  }
}

function cloneASTElement (el) {
  return createASTElement(el.tag, el.attrsList.slice(), el.parent)
}

var model$1 = {
  preTransformNode: preTransformNode
};

var modules$1 = [
  klass$1,
  style$1,
  model$1
];

/*  */

function text (el, dir) {
  if (dir.value) {
    addProp(el, 'textContent', ("_s(" + (dir.value) + ")"), dir);
  }
}

/*  */

function html (el, dir) {
  if (dir.value) {
    addProp(el, 'innerHTML', ("_s(" + (dir.value) + ")"), dir);
  }
}

var directives$1 = {
  model: model,
  text: text,
  html: html
};

/*  */

var baseOptions = {
  expectHTML: true,
  modules: modules$1,
  directives: directives$1,
  isPreTag: isPreTag,
  isUnaryTag: isUnaryTag,
  mustUseProp: mustUseProp,
  canBeLeftOpenTag: canBeLeftOpenTag,
  isReservedTag: isReservedTag,
  getTagNamespace: getTagNamespace,
  staticKeys: genStaticKeys(modules$1)
};

/*  */

var isStaticKey;
var isPlatformReservedTag;

var genStaticKeysCached = cached(genStaticKeys$1);

/**
 * Goal of the optimizer: walk the generated template AST tree
 * and detect sub-trees that are purely static, i.e. parts of
 * the DOM that never needs to change.
 *
 * Once we detect these sub-trees, we can:
 *
 * 1. Hoist them into constants, so that we no longer need to
 *    create fresh nodes for them on each re-render;
 * 2. Completely skip them in the patching process.
 */
function optimize (root, options) {
  if (!root) { return }
  isStaticKey = genStaticKeysCached(options.staticKeys || '');
  isPlatformReservedTag = options.isReservedTag || no;
  // first pass: mark all non-static nodes.
  markStatic$1(root);
  // second pass: mark static roots.
  markStaticRoots(root, false);
}

function genStaticKeys$1 (keys) {
  return makeMap(
    'type,tag,attrsList,attrsMap,plain,parent,children,attrs,start,end,rawAttrsMap' +
    (keys ? ',' + keys : '')
  )
}

function markStatic$1 (node) {
  node.static = isStatic(node);
  if (node.type === 1) {
    // do not make component slot content static. this avoids
    // 1. components not able to mutate slot nodes
    // 2. static slot content fails for hot-reloading
    if (
      !isPlatformReservedTag(node.tag) &&
      node.tag !== 'slot' &&
      node.attrsMap['inline-template'] == null
    ) {
      return
    }
    for (var i = 0, l = node.children.length; i < l; i++) {
      var child = node.children[i];
      markStatic$1(child);
      if (!child.static) {
        node.static = false;
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        var block = node.ifConditions[i$1].block;
        markStatic$1(block);
        if (!block.static) {
          node.static = false;
        }
      }
    }
  }
}

function markStaticRoots (node, isInFor) {
  if (node.type === 1) {
    if (node.static || node.once) {
      node.staticInFor = isInFor;
    }
    // For a node to qualify as a static root, it should have children that
    // are not just static text. Otherwise the cost of hoisting out will
    // outweigh the benefits and it's better off to just always render it fresh.
    if (node.static && node.children.length && !(
      node.children.length === 1 &&
      node.children[0].type === 3
    )) {
      node.staticRoot = true;
      return
    } else {
      node.staticRoot = false;
    }
    if (node.children) {
      for (var i = 0, l = node.children.length; i < l; i++) {
        markStaticRoots(node.children[i], isInFor || !!node.for);
      }
    }
    if (node.ifConditions) {
      for (var i$1 = 1, l$1 = node.ifConditions.length; i$1 < l$1; i$1++) {
        markStaticRoots(node.ifConditions[i$1].block, isInFor);
      }
    }
  }
}

function isStatic (node) {
  if (node.type === 2) { // expression
    return false
  }
  if (node.type === 3) { // text
    return true
  }
  return !!(node.pre || (
    !node.hasBindings && // no dynamic bindings
    !node.if && !node.for && // not v-if or v-for or v-else
    !isBuiltInTag(node.tag) && // not a built-in
    isPlatformReservedTag(node.tag) && // not a component
    !isDirectChildOfTemplateFor(node) &&
    Object.keys(node).every(isStaticKey)
  ))
}

function isDirectChildOfTemplateFor (node) {
  while (node.parent) {
    node = node.parent;
    if (node.tag !== 'template') {
      return false
    }
    if (node.for) {
      return true
    }
  }
  return false
}

/*  */

var fnExpRE = /^([\w$_]+|\([^)]*?\))\s*=>|^function(?:\s+[\w$]+)?\s*\(/;
var fnInvokeRE = /\([^)]*?\);*$/;
var simplePathRE = /^[A-Za-z_$][\w$]*(?:\.[A-Za-z_$][\w$]*|\['[^']*?']|\["[^"]*?"]|\[\d+]|\[[A-Za-z_$][\w$]*])*$/;

// KeyboardEvent.keyCode aliases
var keyCodes = {
  esc: 27,
  tab: 9,
  enter: 13,
  space: 32,
  up: 38,
  left: 37,
  right: 39,
  down: 40,
  'delete': [8, 46]
};

// KeyboardEvent.key aliases
var keyNames = {
  // #7880: IE11 and Edge use `Esc` for Escape key name.
  esc: ['Esc', 'Escape'],
  tab: 'Tab',
  enter: 'Enter',
  // #9112: IE11 uses `Spacebar` for Space key name.
  space: [' ', 'Spacebar'],
  // #7806: IE11 uses key names without `Arrow` prefix for arrow keys.
  up: ['Up', 'ArrowUp'],
  left: ['Left', 'ArrowLeft'],
  right: ['Right', 'ArrowRight'],
  down: ['Down', 'ArrowDown'],
  // #9112: IE11 uses `Del` for Delete key name.
  'delete': ['Backspace', 'Delete', 'Del']
};

// #4868: modifiers that prevent the execution of the listener
// need to explicitly return null so that we can determine whether to remove
// the listener for .once
var genGuard = function (condition) { return ("if(" + condition + ")return null;"); };

var modifierCode = {
  stop: '$event.stopPropagation();',
  prevent: '$event.preventDefault();',
  self: genGuard("$event.target !== $event.currentTarget"),
  ctrl: genGuard("!$event.ctrlKey"),
  shift: genGuard("!$event.shiftKey"),
  alt: genGuard("!$event.altKey"),
  meta: genGuard("!$event.metaKey"),
  left: genGuard("'button' in $event && $event.button !== 0"),
  middle: genGuard("'button' in $event && $event.button !== 1"),
  right: genGuard("'button' in $event && $event.button !== 2")
};

function genHandlers (
  events,
  isNative
) {
  var prefix = isNative ? 'nativeOn:' : 'on:';
  var staticHandlers = "";
  var dynamicHandlers = "";
  for (var name in events) {
    var handlerCode = genHandler(events[name]);
    if (events[name] && events[name].dynamic) {
      dynamicHandlers += name + "," + handlerCode + ",";
    } else {
      staticHandlers += "\"" + name + "\":" + handlerCode + ",";
    }
  }
  staticHandlers = "{" + (staticHandlers.slice(0, -1)) + "}";
  if (dynamicHandlers) {
    return prefix + "_d(" + staticHandlers + ",[" + (dynamicHandlers.slice(0, -1)) + "])"
  } else {
    return prefix + staticHandlers
  }
}

function genHandler (handler) {
  if (!handler) {
    return 'function(){}'
  }

  if (Array.isArray(handler)) {
    return ("[" + (handler.map(function (handler) { return genHandler(handler); }).join(',')) + "]")
  }

  var isMethodPath = simplePathRE.test(handler.value);
  var isFunctionExpression = fnExpRE.test(handler.value);
  var isFunctionInvocation = simplePathRE.test(handler.value.replace(fnInvokeRE, ''));

  if (!handler.modifiers) {
    if (isMethodPath || isFunctionExpression) {
      return handler.value
    }
    return ("function($event){" + (isFunctionInvocation ? ("return " + (handler.value)) : handler.value) + "}") // inline statement
  } else {
    var code = '';
    var genModifierCode = '';
    var keys = [];
    for (var key in handler.modifiers) {
      if (modifierCode[key]) {
        genModifierCode += modifierCode[key];
        // left/right
        if (keyCodes[key]) {
          keys.push(key);
        }
      } else if (key === 'exact') {
        var modifiers = (handler.modifiers);
        genModifierCode += genGuard(
          ['ctrl', 'shift', 'alt', 'meta']
            .filter(function (keyModifier) { return !modifiers[keyModifier]; })
            .map(function (keyModifier) { return ("$event." + keyModifier + "Key"); })
            .join('||')
        );
      } else {
        keys.push(key);
      }
    }
    if (keys.length) {
      code += genKeyFilter(keys);
    }
    // Make sure modifiers like prevent and stop get executed after key filtering
    if (genModifierCode) {
      code += genModifierCode;
    }
    var handlerCode = isMethodPath
      ? ("return " + (handler.value) + "($event)")
      : isFunctionExpression
        ? ("return (" + (handler.value) + ")($event)")
        : isFunctionInvocation
          ? ("return " + (handler.value))
          : handler.value;
    return ("function($event){" + code + handlerCode + "}")
  }
}

function genKeyFilter (keys) {
  return (
    // make sure the key filters only apply to KeyboardEvents
    // #9441: can't use 'keyCode' in $event because Chrome autofill fires fake
    // key events that do not have keyCode property...
    "if(!$event.type.indexOf('key')&&" +
    (keys.map(genFilterCode).join('&&')) + ")return null;"
  )
}

function genFilterCode (key) {
  var keyVal = parseInt(key, 10);
  if (keyVal) {
    return ("$event.keyCode!==" + keyVal)
  }
  var keyCode = keyCodes[key];
  var keyName = keyNames[key];
  return (
    "_k($event.keyCode," +
    (JSON.stringify(key)) + "," +
    (JSON.stringify(keyCode)) + "," +
    "$event.key," +
    "" + (JSON.stringify(keyName)) +
    ")"
  )
}

/*  */

function on (el, dir) {
  if (false) {
    warn("v-on without argument does not support modifiers.");
  }
  el.wrapListeners = function (code) { return ("_g(" + code + "," + (dir.value) + ")"); };
}

/*  */

function bind$1 (el, dir) {
  el.wrapData = function (code) {
    return ("_b(" + code + ",'" + (el.tag) + "'," + (dir.value) + "," + (dir.modifiers && dir.modifiers.prop ? 'true' : 'false') + (dir.modifiers && dir.modifiers.sync ? ',true' : '') + ")")
  };
}

/*  */

var baseDirectives = {
  on: on,
  bind: bind$1,
  cloak: noop
};

/*  */





var CodegenState = function CodegenState (options) {
  this.options = options;
  this.warn = options.warn || baseWarn;
  this.transforms = pluckModuleFunction(options.modules, 'transformCode');
  this.dataGenFns = pluckModuleFunction(options.modules, 'genData');
  this.directives = extend(extend({}, baseDirectives), options.directives);
  var isReservedTag = options.isReservedTag || no;
  this.maybeComponent = function (el) { return !!el.component || !isReservedTag(el.tag); };
  this.onceId = 0;
  this.staticRenderFns = [];
  this.pre = false;
};



function generate (
  ast,
  options
) {
  var state = new CodegenState(options);
  var code = ast ? genElement(ast, state) : '_c("div")';
  return {
    render: ("with(this){return " + code + "}"),
    staticRenderFns: state.staticRenderFns
  }
}

function genElement (el, state) {
  if (el.parent) {
    el.pre = el.pre || el.parent.pre;
  }

  if (el.staticRoot && !el.staticProcessed) {
    return genStatic(el, state)
  } else if (el.once && !el.onceProcessed) {
    return genOnce(el, state)
  } else if (el.for && !el.forProcessed) {
    return genFor(el, state)
  } else if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.tag === 'template' && !el.slotTarget && !state.pre) {
    return genChildren(el, state) || 'void 0'
  } else if (el.tag === 'slot') {
    return genSlot(el, state)
  } else {
    // component or element
    var code;
    if (el.component) {
      code = genComponent(el.component, el, state);
    } else {
      var data;
      if (!el.plain || (el.pre && state.maybeComponent(el))) {
        data = genData$2(el, state);
      }

      var children = el.inlineTemplate ? null : genChildren(el, state, true);
      code = "_c('" + (el.tag) + "'" + (data ? ("," + data) : '') + (children ? ("," + children) : '') + ")";
    }
    // module transforms
    for (var i = 0; i < state.transforms.length; i++) {
      code = state.transforms[i](el, code);
    }
    return code
  }
}

// hoist static sub-trees out
function genStatic (el, state) {
  el.staticProcessed = true;
  // Some elements (templates) need to behave differently inside of a v-pre
  // node.  All pre nodes are static roots, so we can use this as a location to
  // wrap a state change and reset it upon exiting the pre node.
  var originalPreState = state.pre;
  if (el.pre) {
    state.pre = el.pre;
  }
  state.staticRenderFns.push(("with(this){return " + (genElement(el, state)) + "}"));
  state.pre = originalPreState;
  return ("_m(" + (state.staticRenderFns.length - 1) + (el.staticInFor ? ',true' : '') + ")")
}

// v-once
function genOnce (el, state) {
  el.onceProcessed = true;
  if (el.if && !el.ifProcessed) {
    return genIf(el, state)
  } else if (el.staticInFor) {
    var key = '';
    var parent = el.parent;
    while (parent) {
      if (parent.for) {
        key = parent.key;
        break
      }
      parent = parent.parent;
    }
    if (!key) {
      "production" !== 'production' && state.warn(
        "v-once can only be used inside v-for that is keyed. ",
        el.rawAttrsMap['v-once']
      );
      return genElement(el, state)
    }
    return ("_o(" + (genElement(el, state)) + "," + (state.onceId++) + "," + key + ")")
  } else {
    return genStatic(el, state)
  }
}

function genIf (
  el,
  state,
  altGen,
  altEmpty
) {
  el.ifProcessed = true; // avoid recursion
  return genIfConditions(el.ifConditions.slice(), state, altGen, altEmpty)
}

function genIfConditions (
  conditions,
  state,
  altGen,
  altEmpty
) {
  if (!conditions.length) {
    return altEmpty || '_e()'
  }

  var condition = conditions.shift();
  if (condition.exp) {
    return ("(" + (condition.exp) + ")?" + (genTernaryExp(condition.block)) + ":" + (genIfConditions(conditions, state, altGen, altEmpty)))
  } else {
    return ("" + (genTernaryExp(condition.block)))
  }

  // v-if with v-once should generate code like (a)?_m(0):_m(1)
  function genTernaryExp (el) {
    return altGen
      ? altGen(el, state)
      : el.once
        ? genOnce(el, state)
        : genElement(el, state)
  }
}

function genFor (
  el,
  state,
  altGen,
  altHelper
) {
  var exp = el.for;
  var alias = el.alias;
  var iterator1 = el.iterator1 ? ("," + (el.iterator1)) : '';
  var iterator2 = el.iterator2 ? ("," + (el.iterator2)) : '';

  if (false
  ) {
    state.warn(
      "<" + (el.tag) + " v-for=\"" + alias + " in " + exp + "\">: component lists rendered with " +
      "v-for should have explicit keys. " +
      "See https://vuejs.org/guide/list.html#key for more info.",
      el.rawAttrsMap['v-for'],
      true /* tip */
    );
  }

  el.forProcessed = true; // avoid recursion
  return (altHelper || '_l') + "((" + exp + ")," +
    "function(" + alias + iterator1 + iterator2 + "){" +
      "return " + ((altGen || genElement)(el, state)) +
    '})'
}

function genData$2 (el, state) {
  var data = '{';

  // directives first.
  // directives may mutate the el's other properties before they are generated.
  var dirs = genDirectives(el, state);
  if (dirs) { data += dirs + ','; }

  // key
  if (el.key) {
    data += "key:" + (el.key) + ",";
  }
  // ref
  if (el.ref) {
    data += "ref:" + (el.ref) + ",";
  }
  if (el.refInFor) {
    data += "refInFor:true,";
  }
  // pre
  if (el.pre) {
    data += "pre:true,";
  }
  // record original tag name for components using "is" attribute
  if (el.component) {
    data += "tag:\"" + (el.tag) + "\",";
  }
  // module data generation functions
  for (var i = 0; i < state.dataGenFns.length; i++) {
    data += state.dataGenFns[i](el);
  }
  // attributes
  if (el.attrs) {
    data += "attrs:" + (genProps(el.attrs)) + ",";
  }
  // DOM props
  if (el.props) {
    data += "domProps:" + (genProps(el.props)) + ",";
  }
  // event handlers
  if (el.events) {
    data += (genHandlers(el.events, false)) + ",";
  }
  if (el.nativeEvents) {
    data += (genHandlers(el.nativeEvents, true)) + ",";
  }
  // slot target
  // only for non-scoped slots
  if (el.slotTarget && !el.slotScope) {
    data += "slot:" + (el.slotTarget) + ",";
  }
  // scoped slots
  if (el.scopedSlots) {
    data += (genScopedSlots(el, el.scopedSlots, state)) + ",";
  }
  // component v-model
  if (el.model) {
    data += "model:{value:" + (el.model.value) + ",callback:" + (el.model.callback) + ",expression:" + (el.model.expression) + "},";
  }
  // inline-template
  if (el.inlineTemplate) {
    var inlineTemplate = genInlineTemplate(el, state);
    if (inlineTemplate) {
      data += inlineTemplate + ",";
    }
  }
  data = data.replace(/,$/, '') + '}';
  // v-bind dynamic argument wrap
  // v-bind with dynamic arguments must be applied using the same v-bind object
  // merge helper so that class/style/mustUseProp attrs are handled correctly.
  if (el.dynamicAttrs) {
    data = "_b(" + data + ",\"" + (el.tag) + "\"," + (genProps(el.dynamicAttrs)) + ")";
  }
  // v-bind data wrap
  if (el.wrapData) {
    data = el.wrapData(data);
  }
  // v-on data wrap
  if (el.wrapListeners) {
    data = el.wrapListeners(data);
  }
  return data
}

function genDirectives (el, state) {
  var dirs = el.directives;
  if (!dirs) { return }
  var res = 'directives:[';
  var hasRuntime = false;
  var i, l, dir, needRuntime;
  for (i = 0, l = dirs.length; i < l; i++) {
    dir = dirs[i];
    needRuntime = true;
    var gen = state.directives[dir.name];
    if (gen) {
      // compile-time directive that manipulates AST.
      // returns true if it also needs a runtime counterpart.
      needRuntime = !!gen(el, dir, state.warn);
    }
    if (needRuntime) {
      hasRuntime = true;
      res += "{name:\"" + (dir.name) + "\",rawName:\"" + (dir.rawName) + "\"" + (dir.value ? (",value:(" + (dir.value) + "),expression:" + (JSON.stringify(dir.value))) : '') + (dir.arg ? (",arg:" + (dir.isDynamicArg ? dir.arg : ("\"" + (dir.arg) + "\""))) : '') + (dir.modifiers ? (",modifiers:" + (JSON.stringify(dir.modifiers))) : '') + "},";
    }
  }
  if (hasRuntime) {
    return res.slice(0, -1) + ']'
  }
}

function genInlineTemplate (el, state) {
  var ast = el.children[0];
  if (false) {
    state.warn(
      'Inline-template components must have exactly one child element.',
      { start: el.start }
    );
  }
  if (ast && ast.type === 1) {
    var inlineRenderFns = generate(ast, state.options);
    return ("inlineTemplate:{render:function(){" + (inlineRenderFns.render) + "},staticRenderFns:[" + (inlineRenderFns.staticRenderFns.map(function (code) { return ("function(){" + code + "}"); }).join(',')) + "]}")
  }
}

function genScopedSlots (
  el,
  slots,
  state
) {
  // by default scoped slots are considered "stable", this allows child
  // components with only scoped slots to skip forced updates from parent.
  // but in some cases we have to bail-out of this optimization
  // for example if the slot contains dynamic names, has v-if or v-for on them...
  var needsForceUpdate = el.for || Object.keys(slots).some(function (key) {
    var slot = slots[key];
    return (
      slot.slotTargetDynamic ||
      slot.if ||
      slot.for ||
      containsSlotChild(slot) // is passing down slot from parent which may be dynamic
    )
  });

  // #9534: if a component with scoped slots is inside a conditional branch,
  // it's possible for the same component to be reused but with different
  // compiled slot content. To avoid that, we generate a unique key based on
  // the generated code of all the slot contents.
  var needsKey = !!el.if;

  // OR when it is inside another scoped slot or v-for (the reactivity may be
  // disconnected due to the intermediate scope variable)
  // #9438, #9506
  // TODO: this can be further optimized by properly analyzing in-scope bindings
  // and skip force updating ones that do not actually use scope variables.
  if (!needsForceUpdate) {
    var parent = el.parent;
    while (parent) {
      if (
        (parent.slotScope && parent.slotScope !== emptySlotScopeToken) ||
        parent.for
      ) {
        needsForceUpdate = true;
        break
      }
      if (parent.if) {
        needsKey = true;
      }
      parent = parent.parent;
    }
  }

  var generatedSlots = Object.keys(slots)
    .map(function (key) { return genScopedSlot(slots[key], state); })
    .join(',');

  return ("scopedSlots:_u([" + generatedSlots + "]" + (needsForceUpdate ? ",null,true" : "") + (!needsForceUpdate && needsKey ? (",null,false," + (hash(generatedSlots))) : "") + ")")
}

function hash(str) {
  var hash = 5381;
  var i = str.length;
  while(i) {
    hash = (hash * 33) ^ str.charCodeAt(--i);
  }
  return hash >>> 0
}

function containsSlotChild (el) {
  if (el.type === 1) {
    if (el.tag === 'slot') {
      return true
    }
    return el.children.some(containsSlotChild)
  }
  return false
}

function genScopedSlot (
  el,
  state
) {
  var isLegacySyntax = el.attrsMap['slot-scope'];
  if (el.if && !el.ifProcessed && !isLegacySyntax) {
    return genIf(el, state, genScopedSlot, "null")
  }
  if (el.for && !el.forProcessed) {
    return genFor(el, state, genScopedSlot)
  }
  var slotScope = el.slotScope === emptySlotScopeToken
    ? ""
    : String(el.slotScope);
  var fn = "function(" + slotScope + "){" +
    "return " + (el.tag === 'template'
      ? el.if && isLegacySyntax
        ? ("(" + (el.if) + ")?" + (genChildren(el, state) || 'undefined') + ":undefined")
        : genChildren(el, state) || 'undefined'
      : genElement(el, state)) + "}";
  // reverse proxy v-slot without scope on this.$slots
  var reverseProxy = slotScope ? "" : ",proxy:true";
  return ("{key:" + (el.slotTarget || "\"default\"") + ",fn:" + fn + reverseProxy + "}")
}

function genChildren (
  el,
  state,
  checkSkip,
  altGenElement,
  altGenNode
) {
  var children = el.children;
  if (children.length) {
    var el$1 = children[0];
    // optimize single v-for
    if (children.length === 1 &&
      el$1.for &&
      el$1.tag !== 'template' &&
      el$1.tag !== 'slot'
    ) {
      var normalizationType = checkSkip
        ? state.maybeComponent(el$1) ? ",1" : ",0"
        : "";
      return ("" + ((altGenElement || genElement)(el$1, state)) + normalizationType)
    }
    var normalizationType$1 = checkSkip
      ? getNormalizationType(children, state.maybeComponent)
      : 0;
    var gen = altGenNode || genNode;
    return ("[" + (children.map(function (c) { return gen(c, state); }).join(',')) + "]" + (normalizationType$1 ? ("," + normalizationType$1) : ''))
  }
}

// determine the normalization needed for the children array.
// 0: no normalization needed
// 1: simple normalization needed (possible 1-level deep nested array)
// 2: full normalization needed
function getNormalizationType (
  children,
  maybeComponent
) {
  var res = 0;
  for (var i = 0; i < children.length; i++) {
    var el = children[i];
    if (el.type !== 1) {
      continue
    }
    if (needsNormalization(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return needsNormalization(c.block); }))) {
      res = 2;
      break
    }
    if (maybeComponent(el) ||
        (el.ifConditions && el.ifConditions.some(function (c) { return maybeComponent(c.block); }))) {
      res = 1;
    }
  }
  return res
}

function needsNormalization (el) {
  return el.for !== undefined || el.tag === 'template' || el.tag === 'slot'
}

function genNode (node, state) {
  if (node.type === 1) {
    return genElement(node, state)
  } else if (node.type === 3 && node.isComment) {
    return genComment(node)
  } else {
    return genText(node)
  }
}

function genText (text) {
  return ("_v(" + (text.type === 2
    ? text.expression // no need for () because already wrapped in _s()
    : transformSpecialNewlines(JSON.stringify(text.text))) + ")")
}

function genComment (comment) {
  return ("_e(" + (JSON.stringify(comment.text)) + ")")
}

function genSlot (el, state) {
  var slotName = el.slotName || '"default"';
  var children = genChildren(el, state);
  var res = "_t(" + slotName + (children ? ("," + children) : '');
  var attrs = el.attrs || el.dynamicAttrs
    ? genProps((el.attrs || []).concat(el.dynamicAttrs || []).map(function (attr) { return ({
        // slot props are camelized
        name: camelize(attr.name),
        value: attr.value,
        dynamic: attr.dynamic
      }); }))
    : null;
  var bind$$1 = el.attrsMap['v-bind'];
  if ((attrs || bind$$1) && !children) {
    res += ",null";
  }
  if (attrs) {
    res += "," + attrs;
  }
  if (bind$$1) {
    res += (attrs ? '' : ',null') + "," + bind$$1;
  }
  return res + ')'
}

// componentName is el.component, take it as argument to shun flow's pessimistic refinement
function genComponent (
  componentName,
  el,
  state
) {
  var children = el.inlineTemplate ? null : genChildren(el, state, true);
  return ("_c(" + componentName + "," + (genData$2(el, state)) + (children ? ("," + children) : '') + ")")
}

function genProps (props) {
  var staticProps = "";
  var dynamicProps = "";
  for (var i = 0; i < props.length; i++) {
    var prop = props[i];
    var value = transformSpecialNewlines(prop.value);
    if (prop.dynamic) {
      dynamicProps += (prop.name) + "," + value + ",";
    } else {
      staticProps += "\"" + (prop.name) + "\":" + value + ",";
    }
  }
  staticProps = "{" + (staticProps.slice(0, -1)) + "}";
  if (dynamicProps) {
    return ("_d(" + staticProps + ",[" + (dynamicProps.slice(0, -1)) + "])")
  } else {
    return staticProps
  }
}

// #3895, #4268
function transformSpecialNewlines (text) {
  return text
    .replace(/\u2028/g, '\\u2028')
    .replace(/\u2029/g, '\\u2029')
}

/*  */



// these keywords should not appear inside expressions, but operators like
// typeof, instanceof and in are allowed
var prohibitedKeywordRE = new RegExp('\\b' + (
  'do,if,for,let,new,try,var,case,else,with,await,break,catch,class,const,' +
  'super,throw,while,yield,delete,export,import,return,switch,default,' +
  'extends,finally,continue,debugger,function,arguments'
).split(',').join('\\b|\\b') + '\\b');

// these unary operators should not be used as property/method names
var unaryOperatorsRE = new RegExp('\\b' + (
  'delete,typeof,void'
).split(',').join('\\s*\\([^\\)]*\\)|\\b') + '\\s*\\([^\\)]*\\)');

// strip strings in expressions
var stripStringRE = /'(?:[^'\\]|\\.)*'|"(?:[^"\\]|\\.)*"|`(?:[^`\\]|\\.)*\$\{|\}(?:[^`\\]|\\.)*`|`(?:[^`\\]|\\.)*`/g;

// detect problematic expressions in a template
function detectErrors (ast, warn) {
  if (ast) {
    checkNode(ast, warn);
  }
}

function checkNode (node, warn) {
  if (node.type === 1) {
    for (var name in node.attrsMap) {
      if (dirRE.test(name)) {
        var value = node.attrsMap[name];
        if (value) {
          var range = node.rawAttrsMap[name];
          if (name === 'v-for') {
            checkFor(node, ("v-for=\"" + value + "\""), warn, range);
          } else if (name === 'v-slot' || name[0] === '#') {
            checkFunctionParameterExpression(value, (name + "=\"" + value + "\""), warn, range);
          } else if (onRE.test(name)) {
            checkEvent(value, (name + "=\"" + value + "\""), warn, range);
          } else {
            checkExpression(value, (name + "=\"" + value + "\""), warn, range);
          }
        }
      }
    }
    if (node.children) {
      for (var i = 0; i < node.children.length; i++) {
        checkNode(node.children[i], warn);
      }
    }
  } else if (node.type === 2) {
    checkExpression(node.expression, node.text, warn, node);
  }
}

function checkEvent (exp, text, warn, range) {
  var stripped = exp.replace(stripStringRE, '');
  var keywordMatch = stripped.match(unaryOperatorsRE);
  if (keywordMatch && stripped.charAt(keywordMatch.index - 1) !== '$') {
    warn(
      "avoid using JavaScript unary operator as property name: " +
      "\"" + (keywordMatch[0]) + "\" in expression " + (text.trim()),
      range
    );
  }
  checkExpression(exp, text, warn, range);
}

function checkFor (node, text, warn, range) {
  checkExpression(node.for || '', text, warn, range);
  checkIdentifier(node.alias, 'v-for alias', text, warn, range);
  checkIdentifier(node.iterator1, 'v-for iterator', text, warn, range);
  checkIdentifier(node.iterator2, 'v-for iterator', text, warn, range);
}

function checkIdentifier (
  ident,
  type,
  text,
  warn,
  range
) {
  if (typeof ident === 'string') {
    try {
      new Function(("var " + ident + "=_"));
    } catch (e) {
      warn(("invalid " + type + " \"" + ident + "\" in expression: " + (text.trim())), range);
    }
  }
}

function checkExpression (exp, text, warn, range) {
  try {
    new Function(("return " + exp));
  } catch (e) {
    var keywordMatch = exp.replace(stripStringRE, '').match(prohibitedKeywordRE);
    if (keywordMatch) {
      warn(
        "avoid using JavaScript keyword as property name: " +
        "\"" + (keywordMatch[0]) + "\"\n  Raw expression: " + (text.trim()),
        range
      );
    } else {
      warn(
        "invalid expression: " + (e.message) + " in\n\n" +
        "    " + exp + "\n\n" +
        "  Raw expression: " + (text.trim()) + "\n",
        range
      );
    }
  }
}

function checkFunctionParameterExpression (exp, text, warn, range) {
  try {
    new Function(exp, '');
  } catch (e) {
    warn(
      "invalid function parameter expression: " + (e.message) + " in\n\n" +
      "    " + exp + "\n\n" +
      "  Raw expression: " + (text.trim()) + "\n",
      range
    );
  }
}

/*  */

var range = 2;

function generateCodeFrame (
  source,
  start,
  end
) {
  if ( start === void 0 ) start = 0;
  if ( end === void 0 ) end = source.length;

  var lines = source.split(/\r?\n/);
  var count = 0;
  var res = [];
  for (var i = 0; i < lines.length; i++) {
    count += lines[i].length + 1;
    if (count >= start) {
      for (var j = i - range; j <= i + range || end > count; j++) {
        if (j < 0 || j >= lines.length) { continue }
        res.push(("" + (j + 1) + (repeat$1(" ", 3 - String(j + 1).length)) + "|  " + (lines[j])));
        var lineLength = lines[j].length;
        if (j === i) {
          // push underline
          var pad = start - (count - lineLength) + 1;
          var length = end > count ? lineLength - pad : end - start;
          res.push("   |  " + repeat$1(" ", pad) + repeat$1("^", length));
        } else if (j > i) {
          if (end > count) {
            var length$1 = Math.min(end - count, lineLength);
            res.push("   |  " + repeat$1("^", length$1));
          }
          count += lineLength + 1;
        }
      }
      break
    }
  }
  return res.join('\n')
}

function repeat$1 (str, n) {
  var result = '';
  if (n > 0) {
    while (true) { // eslint-disable-line
      if (n & 1) { result += str; }
      n >>>= 1;
      if (n <= 0) { break }
      str += str;
    }
  }
  return result
}

/*  */



function createFunction (code, errors) {
  try {
    return new Function(code)
  } catch (err) {
    errors.push({ err: err, code: code });
    return noop
  }
}

function createCompileToFunctionFn (compile) {
  var cache = Object.create(null);

  return function compileToFunctions (
    template,
    options,
    vm
  ) {
    options = extend({}, options);
    var warn$$1 = options.warn || warn;
    delete options.warn;

    /* istanbul ignore if */
    if (false) {
      // detect possible CSP restriction
      try {
        new Function('return 1');
      } catch (e) {
        if (e.toString().match(/unsafe-eval|CSP/)) {
          warn$$1(
            'It seems you are using the standalone build of Vue.js in an ' +
            'environment with Content Security Policy that prohibits unsafe-eval. ' +
            'The template compiler cannot work in this environment. Consider ' +
            'relaxing the policy to allow unsafe-eval or pre-compiling your ' +
            'templates into render functions.'
          );
        }
      }
    }

    // check cache
    var key = options.delimiters
      ? String(options.delimiters) + template
      : template;
    if (cache[key]) {
      return cache[key]
    }

    // compile
    var compiled = compile(template, options);

    // check compilation errors/tips
    if (false) {
      if (compiled.errors && compiled.errors.length) {
        if (options.outputSourceRange) {
          compiled.errors.forEach(function (e) {
            warn$$1(
              "Error compiling template:\n\n" + (e.msg) + "\n\n" +
              generateCodeFrame(template, e.start, e.end),
              vm
            );
          });
        } else {
          warn$$1(
            "Error compiling template:\n\n" + template + "\n\n" +
            compiled.errors.map(function (e) { return ("- " + e); }).join('\n') + '\n',
            vm
          );
        }
      }
      if (compiled.tips && compiled.tips.length) {
        if (options.outputSourceRange) {
          compiled.tips.forEach(function (e) { return tip(e.msg, vm); });
        } else {
          compiled.tips.forEach(function (msg) { return tip(msg, vm); });
        }
      }
    }

    // turn code into functions
    var res = {};
    var fnGenErrors = [];
    res.render = createFunction(compiled.render, fnGenErrors);
    res.staticRenderFns = compiled.staticRenderFns.map(function (code) {
      return createFunction(code, fnGenErrors)
    });

    // check function generation errors.
    // this should only happen if there is a bug in the compiler itself.
    // mostly for codegen development use
    /* istanbul ignore if */
    if (false) {
      if ((!compiled.errors || !compiled.errors.length) && fnGenErrors.length) {
        warn$$1(
          "Failed to generate render function:\n\n" +
          fnGenErrors.map(function (ref) {
            var err = ref.err;
            var code = ref.code;

            return ((err.toString()) + " in\n\n" + code + "\n");
        }).join('\n'),
          vm
        );
      }
    }

    return (cache[key] = res)
  }
}

/*  */

function createCompilerCreator (baseCompile) {
  return function createCompiler (baseOptions) {
    function compile (
      template,
      options
    ) {
      var finalOptions = Object.create(baseOptions);
      var errors = [];
      var tips = [];

      var warn = function (msg, range, tip) {
        (tip ? tips : errors).push(msg);
      };

      if (options) {
        if (false) {
          // $flow-disable-line
          var leadingSpaceLength = template.match(/^\s*/)[0].length;

          warn = function (msg, range, tip) {
            var data = { msg: msg };
            if (range) {
              if (range.start != null) {
                data.start = range.start + leadingSpaceLength;
              }
              if (range.end != null) {
                data.end = range.end + leadingSpaceLength;
              }
            }
            (tip ? tips : errors).push(data);
          };
        }
        // merge custom modules
        if (options.modules) {
          finalOptions.modules =
            (baseOptions.modules || []).concat(options.modules);
        }
        // merge custom directives
        if (options.directives) {
          finalOptions.directives = extend(
            Object.create(baseOptions.directives || null),
            options.directives
          );
        }
        // copy other options
        for (var key in options) {
          if (key !== 'modules' && key !== 'directives') {
            finalOptions[key] = options[key];
          }
        }
      }

      finalOptions.warn = warn;

      var compiled = baseCompile(template.trim(), finalOptions);
      if (false) {
        detectErrors(compiled.ast, warn);
      }
      compiled.errors = errors;
      compiled.tips = tips;
      return compiled
    }

    return {
      compile: compile,
      compileToFunctions: createCompileToFunctionFn(compile)
    }
  }
}

/*  */

// `createCompilerCreator` allows creating compilers that use alternative
// parser/optimizer/codegen, e.g the SSR optimizing compiler.
// Here we just export a default compiler using the default parts.
var createCompiler = createCompilerCreator(function baseCompile (
  template,
  options
) {
  var ast = parse(template.trim(), options);
  if (options.optimize !== false) {
    optimize(ast, options);
  }
  var code = generate(ast, options);
  return {
    ast: ast,
    render: code.render,
    staticRenderFns: code.staticRenderFns
  }
});

/*  */

var ref$1 = createCompiler(baseOptions);
var compile = ref$1.compile;
var compileToFunctions = ref$1.compileToFunctions;

/*  */

// check whether current browser encodes a char inside attribute values
var div;
function getShouldDecode (href) {
  div = div || document.createElement('div');
  div.innerHTML = href ? "<a href=\"\n\"/>" : "<div a=\"\n\"/>";
  return div.innerHTML.indexOf('&#10;') > 0
}

// #3663: IE encodes newlines inside attribute values while other browsers don't
var shouldDecodeNewlines = inBrowser ? getShouldDecode(false) : false;
// #6828: chrome encodes content in a[href]
var shouldDecodeNewlinesForHref = inBrowser ? getShouldDecode(true) : false;

/*  */

var idToTemplate = cached(function (id) {
  var el = query(id);
  return el && el.innerHTML
});

var mount = Vue.prototype.$mount;
Vue.prototype.$mount = function (
  el,
  hydrating
) {
  el = el && query(el);

  /* istanbul ignore if */
  if (el === document.body || el === document.documentElement) {
    "production" !== 'production' && warn(
      "Do not mount Vue to <html> or <body> - mount to normal elements instead."
    );
    return this
  }

  var options = this.$options;
  // resolve template/el and convert to render function
  if (!options.render) {
    var template = options.template;
    if (template) {
      if (typeof template === 'string') {
        if (template.charAt(0) === '#') {
          template = idToTemplate(template);
          /* istanbul ignore if */
          if (false) {
            warn(
              ("Template element not found or is empty: " + (options.template)),
              this
            );
          }
        }
      } else if (template.nodeType) {
        template = template.innerHTML;
      } else {
        if (false) {
          warn('invalid template option:' + template, this);
        }
        return this
      }
    } else if (el) {
      template = getOuterHTML(el);
    }
    if (template) {
      /* istanbul ignore if */
      if (false) {
        mark('compile');
      }

      var ref = compileToFunctions(template, {
        outputSourceRange: "production" !== 'production',
        shouldDecodeNewlines: shouldDecodeNewlines,
        shouldDecodeNewlinesForHref: shouldDecodeNewlinesForHref,
        delimiters: options.delimiters,
        comments: options.comments
      }, this);
      var render = ref.render;
      var staticRenderFns = ref.staticRenderFns;
      options.render = render;
      options.staticRenderFns = staticRenderFns;

      /* istanbul ignore if */
      if (false) {
        mark('compile end');
        measure(("vue " + (this._name) + " compile"), 'compile', 'compile end');
      }
    }
  }
  return mount.call(this, el, hydrating)
};

/**
 * Get outerHTML of elements, taking care
 * of SVG elements in IE as well.
 */
function getOuterHTML (el) {
  if (el.outerHTML) {
    return el.outerHTML
  } else {
    var container = document.createElement('div');
    container.appendChild(el.cloneNode(true));
    return container.innerHTML
  }
}

Vue.compile = compileToFunctions;

/* harmony default export */ __webpack_exports__["a"] = (Vue);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(4), __webpack_require__(18).setImmediate))

/***/ }),
/* 4 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]());

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(25),
  /* template */
  __webpack_require__(28),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(26),
  /* template */
  __webpack_require__(27),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function bind(fn, thisArg) {
  return function wrap() {
    var args = new Array(arguments.length);
    for (var i = 0; i < args.length; i++) {
      args[i] = arguments[i];
    }
    return fn.apply(thisArg, args);
  };
};


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function encode(val) {
  return encodeURIComponent(val).
    replace(/%40/gi, '@').
    replace(/%3A/gi, ':').
    replace(/%24/g, '$').
    replace(/%2C/gi, ',').
    replace(/%20/g, '+').
    replace(/%5B/gi, '[').
    replace(/%5D/gi, ']');
}

/**
 * Build a URL by appending params to the end
 *
 * @param {string} url The base of the url (e.g., http://www.google.com)
 * @param {object} [params] The params to be appended
 * @returns {string} The formatted url
 */
module.exports = function buildURL(url, params, paramsSerializer) {
  /*eslint no-param-reassign:0*/
  if (!params) {
    return url;
  }

  var serializedParams;
  if (paramsSerializer) {
    serializedParams = paramsSerializer(params);
  } else if (utils.isURLSearchParams(params)) {
    serializedParams = params.toString();
  } else {
    var parts = [];

    utils.forEach(params, function serialize(val, key) {
      if (val === null || typeof val === 'undefined') {
        return;
      }

      if (utils.isArray(val)) {
        key = key + '[]';
      } else {
        val = [val];
      }

      utils.forEach(val, function parseValue(v) {
        if (utils.isDate(v)) {
          v = v.toISOString();
        } else if (utils.isObject(v)) {
          v = JSON.stringify(v);
        }
        parts.push(encode(key) + '=' + encode(v));
      });
    });

    serializedParams = parts.join('&');
  }

  if (serializedParams) {
    var hashmarkIndex = url.indexOf('#');
    if (hashmarkIndex !== -1) {
      url = url.slice(0, hashmarkIndex);
    }

    url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
  }

  return url;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = function isCancel(value) {
  return !!(value && value.__CANCEL__);
};


/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

var utils = __webpack_require__(1);
var normalizeHeaderName = __webpack_require__(35);

var DEFAULT_CONTENT_TYPE = {
  'Content-Type': 'application/x-www-form-urlencoded'
};

function setContentTypeIfUnset(headers, value) {
  if (!utils.isUndefined(headers) && utils.isUndefined(headers['Content-Type'])) {
    headers['Content-Type'] = value;
  }
}

function getDefaultAdapter() {
  var adapter;
  if (typeof XMLHttpRequest !== 'undefined') {
    // For browsers use XHR adapter
    adapter = __webpack_require__(12);
  } else if (typeof process !== 'undefined' && Object.prototype.toString.call(process) === '[object process]') {
    // For node use HTTP adapter
    adapter = __webpack_require__(12);
  }
  return adapter;
}

var defaults = {
  adapter: getDefaultAdapter(),

  transformRequest: [function transformRequest(data, headers) {
    normalizeHeaderName(headers, 'Accept');
    normalizeHeaderName(headers, 'Content-Type');
    if (utils.isFormData(data) ||
      utils.isArrayBuffer(data) ||
      utils.isBuffer(data) ||
      utils.isStream(data) ||
      utils.isFile(data) ||
      utils.isBlob(data)
    ) {
      return data;
    }
    if (utils.isArrayBufferView(data)) {
      return data.buffer;
    }
    if (utils.isURLSearchParams(data)) {
      setContentTypeIfUnset(headers, 'application/x-www-form-urlencoded;charset=utf-8');
      return data.toString();
    }
    if (utils.isObject(data)) {
      setContentTypeIfUnset(headers, 'application/json;charset=utf-8');
      return JSON.stringify(data);
    }
    return data;
  }],

  transformResponse: [function transformResponse(data) {
    /*eslint no-param-reassign:0*/
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) { /* Ignore */ }
    }
    return data;
  }],

  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,

  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',

  maxContentLength: -1,

  validateStatus: function validateStatus(status) {
    return status >= 200 && status < 300;
  }
};

defaults.headers = {
  common: {
    'Accept': 'application/json, text/plain, */*'
  }
};

utils.forEach(['delete', 'get', 'head'], function forEachMethodNoData(method) {
  defaults.headers[method] = {};
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  defaults.headers[method] = utils.merge(DEFAULT_CONTENT_TYPE);
});

module.exports = defaults;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var settle = __webpack_require__(36);
var buildURL = __webpack_require__(9);
var buildFullPath = __webpack_require__(38);
var parseHeaders = __webpack_require__(41);
var isURLSameOrigin = __webpack_require__(42);
var createError = __webpack_require__(13);

module.exports = function xhrAdapter(config) {
  return new Promise(function dispatchXhrRequest(resolve, reject) {
    var requestData = config.data;
    var requestHeaders = config.headers;

    if (utils.isFormData(requestData)) {
      delete requestHeaders['Content-Type']; // Let the browser set it
    }

    var request = new XMLHttpRequest();

    // HTTP basic authentication
    if (config.auth) {
      var username = config.auth.username || '';
      var password = config.auth.password || '';
      requestHeaders.Authorization = 'Basic ' + btoa(username + ':' + password);
    }

    var fullPath = buildFullPath(config.baseURL, config.url);
    request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);

    // Set the request timeout in MS
    request.timeout = config.timeout;

    // Listen for ready state
    request.onreadystatechange = function handleLoad() {
      if (!request || request.readyState !== 4) {
        return;
      }

      // The request errored out and we didn't get a response, this will be
      // handled by onerror instead
      // With one exception: request that using file: protocol, most browsers
      // will return status as 0 even though it's a successful request
      if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf('file:') === 0)) {
        return;
      }

      // Prepare the response
      var responseHeaders = 'getAllResponseHeaders' in request ? parseHeaders(request.getAllResponseHeaders()) : null;
      var responseData = !config.responseType || config.responseType === 'text' ? request.responseText : request.response;
      var response = {
        data: responseData,
        status: request.status,
        statusText: request.statusText,
        headers: responseHeaders,
        config: config,
        request: request
      };

      settle(resolve, reject, response);

      // Clean up request
      request = null;
    };

    // Handle browser request cancellation (as opposed to a manual cancellation)
    request.onabort = function handleAbort() {
      if (!request) {
        return;
      }

      reject(createError('Request aborted', config, 'ECONNABORTED', request));

      // Clean up request
      request = null;
    };

    // Handle low level network errors
    request.onerror = function handleError() {
      // Real errors are hidden from us by the browser
      // onerror should only fire if it's a network error
      reject(createError('Network Error', config, null, request));

      // Clean up request
      request = null;
    };

    // Handle timeout
    request.ontimeout = function handleTimeout() {
      var timeoutErrorMessage = 'timeout of ' + config.timeout + 'ms exceeded';
      if (config.timeoutErrorMessage) {
        timeoutErrorMessage = config.timeoutErrorMessage;
      }
      reject(createError(timeoutErrorMessage, config, 'ECONNABORTED',
        request));

      // Clean up request
      request = null;
    };

    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if (utils.isStandardBrowserEnv()) {
      var cookies = __webpack_require__(43);

      // Add xsrf header
      var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ?
        cookies.read(config.xsrfCookieName) :
        undefined;

      if (xsrfValue) {
        requestHeaders[config.xsrfHeaderName] = xsrfValue;
      }
    }

    // Add headers to the request
    if ('setRequestHeader' in request) {
      utils.forEach(requestHeaders, function setRequestHeader(val, key) {
        if (typeof requestData === 'undefined' && key.toLowerCase() === 'content-type') {
          // Remove Content-Type if data is undefined
          delete requestHeaders[key];
        } else {
          // Otherwise add header to the request
          request.setRequestHeader(key, val);
        }
      });
    }

    // Add withCredentials to request if needed
    if (!utils.isUndefined(config.withCredentials)) {
      request.withCredentials = !!config.withCredentials;
    }

    // Add responseType to request if needed
    if (config.responseType) {
      try {
        request.responseType = config.responseType;
      } catch (e) {
        // Expected DOMException thrown by browsers not compatible XMLHttpRequest Level 2.
        // But, this can be suppressed for 'json' type as it can be parsed by default 'transformResponse' function.
        if (config.responseType !== 'json') {
          throw e;
        }
      }
    }

    // Handle progress if needed
    if (typeof config.onDownloadProgress === 'function') {
      request.addEventListener('progress', config.onDownloadProgress);
    }

    // Not all browsers support upload events
    if (typeof config.onUploadProgress === 'function' && request.upload) {
      request.upload.addEventListener('progress', config.onUploadProgress);
    }

    if (config.cancelToken) {
      // Handle cancellation
      config.cancelToken.promise.then(function onCanceled(cancel) {
        if (!request) {
          return;
        }

        request.abort();
        reject(cancel);
        // Clean up request
        request = null;
      });
    }

    if (requestData === undefined) {
      requestData = null;
    }

    // Send the request
    request.send(requestData);
  });
};


/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var enhanceError = __webpack_require__(37);

/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The created error.
 */
module.exports = function createError(message, config, code, request, response) {
  var error = new Error(message);
  return enhanceError(error, config, code, request, response);
};


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Config-specific merge-function which creates a new config-object
 * by merging two configuration objects together.
 *
 * @param {Object} config1
 * @param {Object} config2
 * @returns {Object} New object resulting from merging config2 to config1
 */
module.exports = function mergeConfig(config1, config2) {
  // eslint-disable-next-line no-param-reassign
  config2 = config2 || {};
  var config = {};

  var valueFromConfig2Keys = ['url', 'method', 'params', 'data'];
  var mergeDeepPropertiesKeys = ['headers', 'auth', 'proxy'];
  var defaultToConfig2Keys = [
    'baseURL', 'url', 'transformRequest', 'transformResponse', 'paramsSerializer',
    'timeout', 'withCredentials', 'adapter', 'responseType', 'xsrfCookieName',
    'xsrfHeaderName', 'onUploadProgress', 'onDownloadProgress',
    'maxContentLength', 'validateStatus', 'maxRedirects', 'httpAgent',
    'httpsAgent', 'cancelToken', 'socketPath'
  ];

  utils.forEach(valueFromConfig2Keys, function valueFromConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    }
  });

  utils.forEach(mergeDeepPropertiesKeys, function mergeDeepProperties(prop) {
    if (utils.isObject(config2[prop])) {
      config[prop] = utils.deepMerge(config1[prop], config2[prop]);
    } else if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (utils.isObject(config1[prop])) {
      config[prop] = utils.deepMerge(config1[prop]);
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  utils.forEach(defaultToConfig2Keys, function defaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  var axiosKeys = valueFromConfig2Keys
    .concat(mergeDeepPropertiesKeys)
    .concat(defaultToConfig2Keys);

  var otherKeys = Object
    .keys(config2)
    .filter(function filterAxiosKeys(key) {
      return axiosKeys.indexOf(key) === -1;
    });

  utils.forEach(otherKeys, function otherKeysDefaultToConfig2(prop) {
    if (typeof config2[prop] !== 'undefined') {
      config[prop] = config2[prop];
    } else if (typeof config1[prop] !== 'undefined') {
      config[prop] = config1[prop];
    }
  });

  return config;
};


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * A `Cancel` is an object that is thrown when an operation is canceled.
 *
 * @class
 * @param {string=} message The message.
 */
function Cancel(message) {
  this.message = message;
}

Cancel.prototype.toString = function toString() {
  return 'Cancel' + (this.message ? ': ' + this.message : '');
};

Cancel.prototype.__CANCEL__ = true;

module.exports = Cancel;


/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_touch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_touch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_resource__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_analytics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_analytics__);
/*jshint esversion: 6 */
/* The Vue build version to load with the `import` command
(runtime-only or standalone) has been set in webpack.base.conf with an alias. */

var path = __webpack_require__(17);










__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_4_vue_shortkey___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_6_vue_resource__["a" /* default */]);

__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a.config.swipe = {
  direction: 'horizontal',
  threshold: 10,
  velocity: 0.3,
  pointers: 1
};

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_5_vue_touch___default.a, { name: 'v-touch' });

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_7_vue_analytics___default.a, {
  id: ['UA-137347938-1', 'UA-64435914-1'],
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  autoTracking: {
    pageviewTemplate: function pageviewTemplate(route) {
      return {
        page: path.join(window.location.pathname, route.path),
        title: document.title,
        location: window.location.href
      };
    }
  },
  debug: {
    enabled: false
  }
});

var app = new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  data: {},
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
}).$mount('#app');

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// .dirname, .basename, and .extname methods are extracted from Node.js v8.11.1,
// backported and transplited with Babel, with backwards-compat fixes

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

// resolves . and .. elements in a path array with directory names there
// must be no slashes, empty elements, or device names (c:\) in the array
// (so also no leading and trailing slashes - it does not distinguish
// relative and absolute paths)
function normalizeArray(parts, allowAboveRoot) {
  // if the path tries to go above the root, `up` ends up > 0
  var up = 0;
  for (var i = parts.length - 1; i >= 0; i--) {
    var last = parts[i];
    if (last === '.') {
      parts.splice(i, 1);
    } else if (last === '..') {
      parts.splice(i, 1);
      up++;
    } else if (up) {
      parts.splice(i, 1);
      up--;
    }
  }

  // if the path is allowed to go above the root, restore leading ..s
  if (allowAboveRoot) {
    for (; up--; up) {
      parts.unshift('..');
    }
  }

  return parts;
}

// path.resolve([from ...], to)
// posix version
exports.resolve = function() {
  var resolvedPath = '',
      resolvedAbsolute = false;

  for (var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--) {
    var path = (i >= 0) ? arguments[i] : process.cwd();

    // Skip empty and invalid entries
    if (typeof path !== 'string') {
      throw new TypeError('Arguments to path.resolve must be strings');
    } else if (!path) {
      continue;
    }

    resolvedPath = path + '/' + resolvedPath;
    resolvedAbsolute = path.charAt(0) === '/';
  }

  // At this point the path should be resolved to a full absolute path, but
  // handle relative paths to be safe (might happen when process.cwd() fails)

  // Normalize the path
  resolvedPath = normalizeArray(filter(resolvedPath.split('/'), function(p) {
    return !!p;
  }), !resolvedAbsolute).join('/');

  return ((resolvedAbsolute ? '/' : '') + resolvedPath) || '.';
};

// path.normalize(path)
// posix version
exports.normalize = function(path) {
  var isAbsolute = exports.isAbsolute(path),
      trailingSlash = substr(path, -1) === '/';

  // Normalize the path
  path = normalizeArray(filter(path.split('/'), function(p) {
    return !!p;
  }), !isAbsolute).join('/');

  if (!path && !isAbsolute) {
    path = '.';
  }
  if (path && trailingSlash) {
    path += '/';
  }

  return (isAbsolute ? '/' : '') + path;
};

// posix version
exports.isAbsolute = function(path) {
  return path.charAt(0) === '/';
};

// posix version
exports.join = function() {
  var paths = Array.prototype.slice.call(arguments, 0);
  return exports.normalize(filter(paths, function(p, index) {
    if (typeof p !== 'string') {
      throw new TypeError('Arguments to path.join must be strings');
    }
    return p;
  }).join('/'));
};


// path.relative(from, to)
// posix version
exports.relative = function(from, to) {
  from = exports.resolve(from).substr(1);
  to = exports.resolve(to).substr(1);

  function trim(arr) {
    var start = 0;
    for (; start < arr.length; start++) {
      if (arr[start] !== '') break;
    }

    var end = arr.length - 1;
    for (; end >= 0; end--) {
      if (arr[end] !== '') break;
    }

    if (start > end) return [];
    return arr.slice(start, end - start + 1);
  }

  var fromParts = trim(from.split('/'));
  var toParts = trim(to.split('/'));

  var length = Math.min(fromParts.length, toParts.length);
  var samePartsLength = length;
  for (var i = 0; i < length; i++) {
    if (fromParts[i] !== toParts[i]) {
      samePartsLength = i;
      break;
    }
  }

  var outputParts = [];
  for (var i = samePartsLength; i < fromParts.length; i++) {
    outputParts.push('..');
  }

  outputParts = outputParts.concat(toParts.slice(samePartsLength));

  return outputParts.join('/');
};

exports.sep = '/';
exports.delimiter = ':';

exports.dirname = function (path) {
  if (typeof path !== 'string') path = path + '';
  if (path.length === 0) return '.';
  var code = path.charCodeAt(0);
  var hasRoot = code === 47 /*/*/;
  var end = -1;
  var matchedSlash = true;
  for (var i = path.length - 1; i >= 1; --i) {
    code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        if (!matchedSlash) {
          end = i;
          break;
        }
      } else {
      // We saw the first non-path separator
      matchedSlash = false;
    }
  }

  if (end === -1) return hasRoot ? '/' : '.';
  if (hasRoot && end === 1) {
    // return '//';
    // Backwards-compat fix:
    return '/';
  }
  return path.slice(0, end);
};

function basename(path) {
  if (typeof path !== 'string') path = path + '';

  var start = 0;
  var end = -1;
  var matchedSlash = true;
  var i;

  for (i = path.length - 1; i >= 0; --i) {
    if (path.charCodeAt(i) === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          start = i + 1;
          break;
        }
      } else if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // path component
      matchedSlash = false;
      end = i + 1;
    }
  }

  if (end === -1) return '';
  return path.slice(start, end);
}

// Uses a mixed approach for backwards-compatibility, as ext behavior changed
// in new Node.js versions, so only basename() above is backported here
exports.basename = function (path, ext) {
  var f = basename(path);
  if (ext && f.substr(-1 * ext.length) === ext) {
    f = f.substr(0, f.length - ext.length);
  }
  return f;
};

exports.extname = function (path) {
  if (typeof path !== 'string') path = path + '';
  var startDot = -1;
  var startPart = 0;
  var end = -1;
  var matchedSlash = true;
  // Track the state of characters (if any) we see before our first dot and
  // after any path separator we find
  var preDotState = 0;
  for (var i = path.length - 1; i >= 0; --i) {
    var code = path.charCodeAt(i);
    if (code === 47 /*/*/) {
        // If we reached a path separator that was not part of a set of path
        // separators at the end of the string, stop now
        if (!matchedSlash) {
          startPart = i + 1;
          break;
        }
        continue;
      }
    if (end === -1) {
      // We saw the first non-path separator, mark this as the end of our
      // extension
      matchedSlash = false;
      end = i + 1;
    }
    if (code === 46 /*.*/) {
        // If this is our first dot, mark it as the start of our extension
        if (startDot === -1)
          startDot = i;
        else if (preDotState !== 1)
          preDotState = 1;
    } else if (startDot !== -1) {
      // We saw a non-dot and non-path separator before our dot, so we should
      // have a good chance at having a non-empty extension
      preDotState = -1;
    }
  }

  if (startDot === -1 || end === -1 ||
      // We saw a non-dot character immediately before the dot
      preDotState === 0 ||
      // The (right-most) trimmed path component is exactly '..'
      preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return '';
  }
  return path.slice(startDot, end);
};

function filter (xs, f) {
    if (xs.filter) return xs.filter(f);
    var res = [];
    for (var i = 0; i < xs.length; i++) {
        if (f(xs[i], i, xs)) res.push(xs[i]);
    }
    return res;
}

// String.prototype.substr - negative index don't work in IE8
var substr = 'ab'.substr(-1) === 'b'
    ? function (str, start, len) { return str.substr(start, len) }
    : function (str, start, len) {
        if (start < 0) start = str.length + start;
        return str.substr(start, len);
    }
;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2)))

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
            (typeof self !== "undefined" && self) ||
            window;
var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(scope, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(19);
// On some exotic environments, it's not clear which object `setimmediate` was
// able to install onto.  Search each possibility in the same order as the
// `setimmediate` library.
exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
                       (typeof global !== "undefined" && global.setImmediate) ||
                       (this && this.setImmediate);
exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
                         (typeof global !== "undefined" && global.clearImmediate) ||
                         (this && this.clearImmediate);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4)))

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(4), __webpack_require__(2)))

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(21)
  __webpack_require__(22)
  __webpack_require__(23)
}
var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(24),
  /* template */
  __webpack_require__(46),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 22 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 23 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Reader_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(29);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  props: {
    pageNum: {
      type: Number,
      default: 0
    },
    ttlPages: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      pageNumber: this.pageNum,
      totalPages: this.ttlPages,
      info: false,
      buyBar: true,
      buyMenu: false,
      socialMenu: false,
      otherBooks: false,
      focused: false,
      dialogBuy: false,
      dialogShare: false,
      notifications: false,
      sound: true,
      widgets: false,
      show: false,
      iSize: 50,
      selectBook: "Books",
      home: this.$route.path,
      drawer: false,
      drawerRight: false,
      items: [],
      books: [],
      booksChanged: '',
      socials: [{
        title: "LinkedIn",
        img: "static/img/linkedin-logo.svg",
        url: "https://www.linkedin.com/shareArticle?mini=true&url=https://textcafe.co/books/12YW9uc/%3F1702846312124&title=Liberty%20and%20Sexuality&summary=Pulitzer%20Prize%26ndash%3Bwinning%20author%20David%20J.%20Garrow%26rsquo%3Bs%20stirring%20and%20essential%20history%20of%20the%20politics%20of%20abortion%20and%20America%26rsquo%3Bs%20battle%20for%20the%20right%20to%20choose%20In%201973%2C%20the%20Supreme%20Court%20handed%20down%20its%20landmark%20Roe%20v.%20Wade&source=LinkedIn",
        icon: "ion-social-linkedin"
      }, {
        title: "Facebook",
        img: "static/img/facebook-logo.svg",
        url: "https://www.facebook.com/sharer/sharer.php?u=https://textcafe.co/books/12YW9uc/%3F1702846312124",
        icon: "ion-social-facebook"
      }, {
        title: "Twitter",
        img: "static/img/twitter-logo-silhouette.svg",
        url: "https://twitter.com/intent/tweet?text=Pulitzer%20Prize%26ndash%3Bwinning%20author%20David%20J.%20Garrow%26rsquo%3Bs%20stirring%20and%20essential%20history%20of%20the%20politics%20of%20abortion%20and%20America%26rsquo%3Bs%20ba%0Dhttps://textcafe.co/books/12YW9uc/%3F1702846312124&amp;via=textcafecom",
        icon: "ion-social-twitter"
      }, {
        title: "Tumblr",
        img: "static/img/tumblr-letter-logo.svg",
        url: "https://www.tumblr.com/widgets/share/tool?canonicalUrl=https://textcafe.co/books/12YW9uc/%3F1702846312124&posttype=link&caption=Pulitzer%20Prize%26ndash%3Bwinning%20author%20David%20J.%20Garrow%26rsquo%3Bs%20stirring%20and%20essential%20history%20of%20the%20politics%20of%20abortion%20and%20America%26rsquo%3Bs%20battle%20for%20the%20right%20to%20choose%20In%201973%2C%20the%20Supreme%20Court%20handed%20down%20its%20landmark%20Roe%20v.%20Wade",
        icon: "ion-social-tumblr"
      }, {
        title: "Pinterest",
        img: "static/img/pinterest-logo.svg",
        url: "http://www.pinterest.com/pin/create/button/?url=https://textcafe.co/books/12YW9uc/%3F1702846312124&description=Pulitzer%20Prize%26ndash%3Bwinning%20author%20David%20J.%20Garrow%26rsquo%3Bs%20stirring%20and%20essential%20history%20of%20the%20politics%20of%20abortion%20and%20America%26rsquo%3Bs%20battle%20for%20the%20right%20to%20choose%20In%201973%2C%20the%20Supreme%20Court%20handed%20down%20its%20landmark%20Roe%20v.%20Wade&media=https://textcafe.co/books/12YW9uc/tc-custom/9781504015554.jpg",
        icon: "ion-social-pinterest"
      }],
      buys: [{
        title: 'Amazon US',
        img: 'https://textcafe.co/domain-icons/Amazon.com_A_Smile.svg',
        url: 'https://www.amazon.com/s?k=9781504015554&i=stripbooks&linkCode=qs&tag=mobilebookcom-20',
        alt: 'None'
      }, {
        title: 'Google Play',
        img: 'https://textcafe.co/global-css/img/Google_Play_symbol.svg',
        url: 'https://play.google.com/store/books/details?id=CiRwCQAAQBAJ&amp;rdid=book-CiRwCQAAQBAJ&amp;rdot=1&amp;source=gbs_atb&amp;pcampaignid=books_booksearch_atb&gl=us',
        alt: 'None'
      }],
      right: null,
      left: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    __WEBPACK_IMPORTED_MODULE_3_axios___default.a.get('https://www.textcafe.com/widget/get-samples.json?related=9781504015554').then(function (response) {
      return _this.books = response.data.map(function (item) {
        return {
          title: item.title,
          img: item.coverImagePath,
          url: item.socialUrl,
          alt: "This image is the cover for the book " + item.title
        };
      });
    }).catch(function (error) {
      return (
        // handle error
        console.log(error)
      );
    });
  },

  created: function created() {
    var _this2 = this;

    this.$router.options.routes.forEach(function (route) {
      _this2.items.push({
        path: route.path,
        name: route.name,
        component: route.component,
        //image: "static/img/ilG6Mf.jpg"
        image: '/books/12YW9uc/tc-custom/9781504015554.jpg?1702846312124',
        alt: 'Liberty and Sexuality'
      });
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("pageNum", function (newValue) {
      _this2.pageNum = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$on("ttlPages", function (newValue) {
      _this2.ttlPages = newValue;
    });
  },
  watch: {
    $route: function $route(to, from) {
      if (to.path === "/") {
        this.home = this.$route.path;
      } else {
        this.home = null;
      }
    },

    iSize: function iSize(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("iSizeChanged", newValue);
    },
    books: function books(newValue) {
      __WEBPACK_IMPORTED_MODULE_2__event_hub_js__["a" /* default */].$emit("booksChanged", Date.now());
    }
  },
  methods: {
    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    },
    onBlur: function onBlur() {
      if (this.show === true) {
        this.show = false;
        this.$emit("blur");
      }
    },
    onFocus: function onFocus() {
      if (this.show === false) {
        this.show = true;
        this.$el.querySelector(".book-page").$emit("focus");
      }
    },
    buyClick: function buyClick(url) {
      //const url = '/foo/bar'
      // this.$ga.query('send', 'event', 'outbound', 'click', url, {
      //     transport: 'beacon',
      //     hitCallback () {
      //        //document.location = url
      //     }
      // })
      this.$ga.event({
        eventCategory: 'purchase',
        eventAction: 'click',
        eventLabel: url
        // eventValue: 123
      });
    },
    shareClick: function shareClick(network) {
      this.$ga.event({
        eventCategory: 'share',
        eventAction: 'click',
        eventLabel: network
        // eventValue: 123
      });
    }
  },
  components: {
    settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings_vue___default.a,
    reader: __WEBPACK_IMPORTED_MODULE_0__components_Reader_vue___default.a
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Settings___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_Settings__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var SLIDE_TIME = document.documentElement.clientWidth > 480 ? 500 : 300;

/* harmony default export */ __webpack_exports__["default"] = ({
  name: "reader",
  props: {
    value1: {
      type: Number,
      default: 22
    },
    selected: {
      type: String
    },
    ex8: {
      type: String,
      default: "Auto"
    },
    value2: {
      type: Number
    },
    value3: {
      type: Number,
      default: 100
    }
  },
  data: function data() {
    return {
      pageNum: 0,
      pageNumber: 1,
      ttlPages: 0,
      totalPages: 0,
      home: false,
      div: 0,
      prevX: null,
      xDownEnd: null,
      fontSize: this.value1,
      fontFamily: this.selected,
      columns: this.ex8,
      widthSize: this.value2,
      brightness: this.value3,
      currentColor: "#f3f3f3",
      cols: "2 220px",
      position: { scrollTop: 0, scrollLeft: 0 },
      offset: null,
      height: 0,
      isOver: false,
      routeNames: ["home", "xhtml/contents", "xhtml/frontmatter01", "xhtml/chapter001", "xhtml/chapter002", "xhtml/chapter003", "last"],
      routeTransition: "slide-left",
      rest: true,
      selectedView: "Book1",
      progress: 0,
      hiddenEl: false,
      brandReaderUrl: "",
      brandLogoUrl: "",
      currentUrl: "https://textcafe.co/books/12YW9uc/",
      waiting: false
    };
  },

  created: function created() {
    var _this = this;

    document.addEventListener("mousewheel", this.onScroll, false);
    window.addEventListener('resize', this.resize);
    this.resize();
    this.getTtlPages();

    if (document.documentElement.offsetWidth >= 768) {
      this.hiddenEl = true;
    } else {
      this.hiddenEl = false;
    }

    this.$router.options.routes.forEach(function (route) {
      _this.routeNames.push(route.name);
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontSizeChanged", function (newValue) {
      _this.fontSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("fontFamilyChanged", function (newValue) {
      _this.fontFamily = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("columnsCountChanged", function (newValue) {
      _this.columns = newValue;
      if (_this.columns === "Single") {
        _this.cols = "1 auto";
      } else if (_this.columns === "Auto") {
        _this.cols = "2 220px";
      }
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("widthChanged", function (newValue) {
      _this.widthSize = newValue;
    });
    __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$on("brightnessChanged", function (newValue) {
      _this.brightness = newValue;
    });
  },

  destroyed: function destroyed() {
    document.removeEventListener("mousewheel", this.onScroll, false);
    document.removeEventListener("resize", this.resize, false);
  },
  updated: function updated() {
    this.getTtlPages();
    this.resize();
    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };
  },
  mounted: function mounted() {
    this.resize();

    var links = document.getElementsByTagName("a");
    for (var i = 0; i < links.length; i++) {
      var that = this;
      var url = "/" + document.location.hash.split("#/")[1];
      if (links[i].href.split("#")[1] === url) {
        links[i].style.textDecoration = "underline";
        links[i].style.textDecorationStyle = "dotted";
        links[i].onclick = function (e) {
          e.preventDefault();
          var refr = this.href.split("#")[2];
          that.linkTo(refr);
        };
      };
    };

    this.getTtlPages();

    var bgColor = document.getElementsByClassName("book-content")[0].style.backgroundColor,
        hexDigits = new Array("0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f");
    function rgb2hex(rgb) {
      rgb = rgb.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
      return "#" + hex(rgb[1]) + hex(rgb[2]) + hex(rgb[3]);
    }
    function hex(x) {
      return isNaN(x) ? "00" : hexDigits[(x - x % 16) / 16] + hexDigits[x % 16];
    }
    this.currentColor = rgb2hex(bgColor);
  },

  watch: {
    $route: function $route(to, from, next) {
      var toDepth = this.routeNames.indexOf(to.name);
      var fromDepth = this.routeNames.indexOf(from.name);
      this.routeTransition = toDepth < fromDepth ? "slide-right" : "slide-left";

      this.progress = 0;
      this.pageNumber = 1;
    },

    pageNum: function pageNum(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("pageNum", newValue);
    },
    ttlPages: function ttlPages(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("ttlPages", newValue);
    }
  },
  methods: {
    resize: function resize() {
      this.height = document.documentElement.clientHeight;
    },
    linkTo: function linkTo(refName) {
      var element = document.getElementById(refName);
      var elementOffset = Math.ceil(element.offsetLeft);
      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);
      var onStart = Math.ceil(page.scrollLeft);
      var destinationOffset = Math.floor(elementOffset / (page.offsetWidth + gap));
      var target = destinationOffset * (page.offsetWidth + gap) - onStart;
      if (destinationOffset + 1 !== this.pageNumber) {
        this.scrollIt(target, 300, "easeOutQuad", false);
        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pctScrolled = Math.floor(destinationOffset * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
        this.pageNumber = destinationOffset + 1;
      }
    },
    getTtlPages: function getTtlPages() {
      this.$nextTick(function () {
        var page = this.$el.querySelector(".book-page");

        var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10);

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));
        this.ttlPages = ttlPages;
        this.totalPages = this.ttlPages + 1;
      });
    },
    tapped: function tapped() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    tappedIn: function tappedIn() {
      var el = this.$el.querySelector(".touch-swipe");
      this.hiddenEl = !this.hiddenEl;
    },
    scrollIt: function scrollIt(destination) {
      var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;

      var _this2 = this;

      var easing = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "easeInOutQuart";
      var callback = arguments[3];

      var easings = {
        linear: function linear(t) {
          return t;
        },
        easeInQuad: function easeInQuad(t) {
          return t * t;
        },
        easeOutQuad: function easeOutQuad(t) {
          return t * (2 - t);
        },
        easeInOutQuad: function easeInOutQuad(t) {
          return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
        },
        easeInCubic: function easeInCubic(t) {
          return t * t * t;
        },
        easeOutCubic: function easeOutCubic(t) {
          return --t * t * t + 1;
        },
        easeInOutCubic: function easeInOutCubic(t) {
          return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
        },
        easeInQuart: function easeInQuart(t) {
          return t * t * t * t;
        },
        easeOutQuart: function easeOutQuart(t) {
          return 1 - --t * t * t * t;
        },
        easeInOutQuart: function easeInOutQuart(t) {
          return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * --t * t * t * t;
        },
        easeInQuint: function easeInQuint(t) {
          return t * t * t * t * t;
        },
        easeOutQuint: function easeOutQuint(t) {
          return 1 + --t * t * t * t * t;
        },
        easeInOutQuint: function easeInOutQuint(t) {
          return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * --t * t * t * t * t;
        }
      };

      var page = this.$el.querySelector(".book-page");
      var gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap;

      var start = Math.ceil(page.scrollLeft);

      var startTime = "now" in window.performance ? performance.now() : new Date().getTime();

      var documentWidth = Math.max(page.scrollWidth || page.offsetWidth || page.clientWidth);

      var windowWidth = window.innerWidth || window.clientWidth;

      var destinationOffsetToScroll = start + destination;

      function scroll() {
        var now = "now" in window.performance ? performance.now() : new Date().getTime();
        var time = Math.min(1, (now - startTime) / duration);
        var timeFunction = easings[easing](time);
        page.scroll(Math.ceil(timeFunction * (destinationOffsetToScroll - start) + start), 0);
        if (timeFunction === 1 || start === destinationOffsetToScroll) {
          if (callback) {
            callback();
          }
          return;
        }
        requestAnimationFrame(scroll);
      }
      scroll();
      setTimeout(function () {
        _this2.waiting = false;
      }, 250);
    },


    next: function next(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";
      var book = this.$el.querySelector(".book-content");
      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;
      var windowWidth = window.innerWidth || window.clientWidth;
      var trackLength = scrollArea - (page.offsetWidth + gap);

      // var pageNum = Math.floor(page.scrollLeft / (page.offsetWidth + gap));
      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.floor(scrollLeft / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      pageNum += 1;

      this.pageNumber += 1;

      if (page.scrollWidth - (scrollLeft + page.offsetWidth) !== 0 && pctScrolled !== 100) {
        var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = nextPage - scrollLeft;

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index + 1] });

        this.pageNumber = 1;
        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    prev: function prev(e) {
      var el = this.$el.querySelector(".touch-swipe");
      if (el) el.style.pointerEvents = "auto";

      var page = this.$el.querySelector(".book-page"),
          gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
          offset = page.offsetWidth + gap,
          index = this.routeNames.indexOf(this.$route.name);

      var scrollArea = page.scrollWidth - page.offsetWidth;

      var scrollLeft = Math.ceil(page.scrollLeft);
      var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
      var ttlPages = Math.round(scrollArea / (page.offsetWidth + gap));

      this.pageNum = pageNum;

      this.pageNumber -= 1;

      var currentPage = Math.floor(pageNum * (page.offsetWidth + gap));

      if (scrollLeft !== 0 && pageNum !== 0) {
        var pageNum = Math.round(scrollLeft / (page.offsetWidth + gap));
        var pageNumber = Math.floor(scrollLeft / (page.offsetWidth + gap));

        pageNum -= 1;
        var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

        var destination = -1 * (scrollLeft - prevPage);

        this.scrollIt(destination, 300, "easeOutQuad", false);
      } else {
        this.$router.push({ name: this.routeNames[index - 1] });

        this.pageNumber = 1;

        pageNum = 0;
        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;
      }
      var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
      this.progress = pctScrolled;
    },
    over: function over() {
      this.isOver = true;
    },
    out: function out() {
      this.isOver = false;
    },
    onScroll: function onScroll(e, position) {
      this.position = position;
      if (this.isOver === true) {
        var page = this.$el.querySelector(".book-page"),
            gap = parseInt(window.getComputedStyle(page).getPropertyValue("column-gap"), 10),
            deltaX = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail)),
            end = page.scrollWidth - (page.scrollLeft + page.offsetWidth),
            offset = page.offsetWidth + gap;

        var scrollArea = page.scrollWidth - page.offsetWidth;
        var pageNum = Math.round(page.scrollLeft / (page.offsetWidth + gap));

        var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
        this.progress = pctScrolled;

        if (deltaX === 1) {
          if (page.scrollLeft !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum -= 1;

            this.pageNumber -= 1;
            var prevPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = -1 * (page.scrollLeft - prevPage);

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        } else if (deltaX === -1) {
          if (page.scrollWidth - (page.scrollLeft + page.offsetWidth) !== 0) {
            if (this.waiting) {
              return;
            }
            this.waiting = true;

            pageNum += 1;

            this.pageNumber += 1;
            var nextPage = Math.floor(pageNum * (page.offsetWidth + gap));

            var destination = nextPage - page.scrollLeft;

            this.scrollIt(destination, 300, "easeOutQuad", false);

            var pctScrolled = Math.floor(pageNum * (page.offsetWidth + gap) / scrollArea * 100);
            this.progress = pctScrolled;
          }
        }
      } else {
        return;
      }
    },
    fadeIn: function fadeIn() {
      var page = this.$el.querySelector(".book-page");
      page.style.opacity = 0;
      var last = +new Date();
      var tick = function tick() {
        page.style.opacity = +page.style.opacity + (new Date() - last) / 400;
        last = +new Date();
        if (+page.style.opacity < 1) {
          window.requestAnimationFrame && requestAnimationFrame(tick) || setTimeout(tick, 16);
        }
      };
      tick();
    },

    resetScroll: function resetScroll() {
      var page = this.$el.querySelector(".book-page");
      page.scrollLeft = 0;
    }
  },
  computed: {
    isMobile: function isMobile() {
      var check = false;
      (function (a) {
        if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    }
  },
  components: {
    Settings: __WEBPACK_IMPORTED_MODULE_1__components_Settings___default.a
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__event_hub_js__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: "settings",
  data: function data() {
    return {
      events: [],
      value1: 22,
      value2: 70,
      value3: 100,
      ex8: "Auto",
      selected: "Old-Cabin",
      fonts: ["Old-Cabin", "Raleway-Bitter", "Ubuntu-Abel", "Droid-Abril", "Garamond-Clicker", "Alice-Playfair", "Judson-Quando"],
      classes: ["white", "black", "sepia"]
    };
  },

  watch: {
    value1: function value1(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontSizeChanged", newValue);
    },
    selected: function selected(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("fontFamilyChanged", newValue);
    },
    ex8: function ex8(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("columnsCountChanged", newValue);
    },
    value2: function value2(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("widthChanged", newValue);
    },
    value3: function value3(newValue) {
      __WEBPACK_IMPORTED_MODULE_0__event_hub_js__["a" /* default */].$emit("brightnessChanged", newValue);
    }
  },
  methods: {
    reloadBook: function reloadBook() {
      window.location.reload(true);
    },
    changeClassWhite: function changeClassWhite() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      console.log(document.getElementsByTagName("footer")[0]);
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("white");
        el2.classList.add("white");
        el3.classList.add("white");
        el4.classList.add("white");
      } else {
        el.className += " white";
        el2.className += " white";
        el3.className += " white";
        el4.className += " white";
      }
    },
    changeClassBlack: function changeClassBlack() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.remove("sepia");
        el2.classList.remove("sepia");
        el3.classList.remove("sepia");
        el4.classList.remove("sepia");
        el.classList.add("black");
        el2.classList.add("black");
        el3.classList.add("black");
        el4.classList.add("black");
      } else {
        el.className += " black";
        el2.className += " black";
        el3.className += " black";
        el4.className += " black";
      }
    },
    changeClassSepia: function changeClassSepia() {
      var el = document.getElementsByClassName("book-content")[0];
      var el2 = document.getElementsByClassName("nav-btn")[0];
      var el3 = document.getElementsByClassName("nav-btn")[1];
      var el4 = document.getElementsByTagName("footer")[0];
      if (el.classList && el2.classList && el3.classList && el4.classList) {
        el.classList.remove("black");
        el2.classList.remove("black");
        el3.classList.remove("black");
        el4.classList.remove("black");
        el.classList.remove("white");
        el2.classList.remove("white");
        el3.classList.remove("white");
        el4.classList.remove("white");
        el.classList.add("sepia");
        el2.classList.add("sepia");
        el3.classList.add("sepia");
        el4.classList.add("sepia");
      } else {
        el.className += " sepia";
        el2.className += " sepia";
        el3.className += " sepia";
        el4.className += " sepia";
      }
    }
  }
});

/***/ }),
/* 27 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "settings"
  }, [_c('ul', {
    staticClass: "settings-list"
  }, [_c('li', [_c('span', [_vm._v("Reload book: ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "reloadBookBtn",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.reloadBook()
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-loop-strong")])], 1)], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font:")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "items": _vm.fonts,
      "overflow": "",
      "single-line": "",
      "return-objectauto": "",
      "append-icon": "ion-ios-arrow-down",
      "hide-details": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = true
      }
    },
    model: {
      value: (_vm.selected),
      callback: function($$v) {
        _vm.selected = $$v
      },
      expression: "selected"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Font size:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value1 + 'px' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 17,
      "max": 27,
      "step": 1
    },
    model: {
      value: (_vm.value1),
      callback: function($$v) {
        _vm.value1 = $$v
      },
      expression: "value1"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "columns-setting"
  }, [_c('span', [_vm._v("Page columns:")]), _c('br'), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Auto",
      "value": "Auto",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "Single",
      "value": "Single",
      "flat": "",
      "ripple": false,
      "prepend-icon": ""
    },
    model: {
      value: (_vm.ex8),
      callback: function($$v) {
        _vm.ex8 = $$v
      },
      expression: "ex8"
    }
  })], 1), _vm._v(" "), _c('li', {
    staticClass: "width-setting"
  }, [_c('span', [_vm._v("Page width:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s(_vm.value2 + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "min": 50,
      "max": 90
    },
    model: {
      value: (_vm.value2),
      callback: function($$v) {
        _vm.value2 = $$v
      },
      expression: "value2"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Brightness:")]), _vm._v(" "), _c('p', {
    staticClass: "bold-font",
    domProps: {
      "innerHTML": _vm._s((_vm.value3 - 100) + '%' || null)
    }
  }), _vm._v(" "), _c('v-slider', {
    attrs: {
      "step": 1,
      "min": 0,
      "max": 200
    },
    model: {
      value: (_vm.value3),
      callback: function($$v) {
        _vm.value3 = $$v
      },
      expression: "value3"
    }
  })], 1), _vm._v(" "), _c('li', [_c('span', [_vm._v("Color mode:")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', {
    attrs: {
      "id": "colors"
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "id": "white",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassWhite()
      }
    }
  }, [_vm._v("\n          White\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "black",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassBlack()
      }
    }
  }, [_vm._v("\n          Black\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "id": "sepia",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.changeClassSepia()
      }
    }
  }, [_vm._v("\n          Sepia\n        ")])], 1)])])])
},staticRenderFns: []}

/***/ }),
/* 28 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap",
    style: ({
      'filter': 'brightness(' + _vm.brightness + '%)',
      'height': _vm.height - 49 + 'px'
    })
  }, [_c('v-progress-linear', {
    model: {
      value: (_vm.progress),
      callback: function($$v) {
        _vm.progress = $$v
      },
      expression: "progress"
    }
  }), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowleft']),
      expression: "['arrowleft']"
    }],
    staticClass: "nav-btn left",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.prev($event)
      },
      "shortkey": _vm.prev
    }
  }, [_c('v-icon', {
    style: ({
      'left': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "shortkey",
      rawName: "v-shortkey",
      value: (['arrowright']),
      expression: "['arrowright']"
    }],
    staticClass: "nav-btn right",
    style: ({
      width: (100 - _vm.widthSize) + '%'
    }),
    attrs: {
      "ripple": false
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.next($event)
      },
      "shortkey": _vm.next
    }
  }, [_c('v-icon', {
    style: ({
      'right': (_vm.widthSize / 3.5) + '%'
    })
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "book-content",
    style: ({
      'width': _vm.widthSize + '%',
      'background-color': _vm.currentColor,
      'height': _vm.height - 78 + 'px'
    }),
    on: {
      "mouseenter": _vm.over,
      "mouseleave": _vm.out
    }
  }, [(_vm.isMobile) ? _c('v-touch', {
    staticClass: "touch-swipe",
    class: {
      active: _vm.hiddenEl
    },
    on: {
      "swipeleft": _vm.next,
      "swiperight": _vm.prev,
      "tap": _vm.tapped
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    key: _vm.div,
    staticClass: "book-page",
    class: _vm.fontFamily,
    style: ({
      'font-size': _vm.fontSize + 'px',
      'columns': _vm.cols
    }),
    attrs: {
      "enable-resize-watcher": ""
    },
    on: {
      "tap": _vm.tappedIn,
      "swipe": _vm.tappedIn,
      "click": _vm.tappedIn
    }
  }, [_c('transition', {
    attrs: {
      "name": _vm.routeTransition,
      "mode": "out-in"
    }
  }, [_c('router-view', {
    key: _vm.$route.name,
    staticClass: "view"
  })], 1)], 1)], 1), _vm._v(" "), _c('footer', {
    class: _vm.fontFamily,
    style: ({
      'font-size': (_vm.fontSize - 5) + 'px'
    })
  }, [(_vm.brandReaderUrl) ? _c('div', [_c('v-btn', {
    staticClass: "HC-footer-button",
    attrs: {
      "flat": "",
      "ripple": false,
      "tag": "a",
      "href": _vm.brandReaderUrl,
      "target": "_blank"
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = false, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('i', [_c('img', {
    attrs: {
      "src": _vm.brandLogoUrl
    }
  })])])], 1) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', {
    staticClass: "foots"
  }, [_c('span', [_c('em', [_vm._v(_vm._s(this.$route.name))])]), _vm._v(" - page "), _c('span', [_c('em', [_vm._v(_vm._s(this.pageNumber))])]), _vm._v(" "), (this.totalPages > 1) ? _c('span', [_c('em', [_vm._v(_vm._s("/ " + this.totalPages))])]) : _vm._e()]), _vm._v(" "), _c('v-spacer')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 29 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(30);

/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var bind = __webpack_require__(8);
var Axios = __webpack_require__(31);
var mergeConfig = __webpack_require__(14);
var defaults = __webpack_require__(11);

/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 * @return {Axios} A new instance of Axios
 */
function createInstance(defaultConfig) {
  var context = new Axios(defaultConfig);
  var instance = bind(Axios.prototype.request, context);

  // Copy axios.prototype to instance
  utils.extend(instance, Axios.prototype, context);

  // Copy context to instance
  utils.extend(instance, context);

  return instance;
}

// Create the default instance to be exported
var axios = createInstance(defaults);

// Expose Axios class to allow class inheritance
axios.Axios = Axios;

// Factory for creating new instances
axios.create = function create(instanceConfig) {
  return createInstance(mergeConfig(axios.defaults, instanceConfig));
};

// Expose Cancel & CancelToken
axios.Cancel = __webpack_require__(15);
axios.CancelToken = __webpack_require__(44);
axios.isCancel = __webpack_require__(10);

// Expose all/spread
axios.all = function all(promises) {
  return Promise.all(promises);
};
axios.spread = __webpack_require__(45);

module.exports = axios;

// Allow use of default import syntax in TypeScript
module.exports.default = axios;


/***/ }),
/* 31 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var buildURL = __webpack_require__(9);
var InterceptorManager = __webpack_require__(32);
var dispatchRequest = __webpack_require__(33);
var mergeConfig = __webpack_require__(14);

/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 */
function Axios(instanceConfig) {
  this.defaults = instanceConfig;
  this.interceptors = {
    request: new InterceptorManager(),
    response: new InterceptorManager()
  };
}

/**
 * Dispatch a request
 *
 * @param {Object} config The config specific for this request (merged with this.defaults)
 */
Axios.prototype.request = function request(config) {
  /*eslint no-param-reassign:0*/
  // Allow for axios('example/url'[, config]) a la fetch API
  if (typeof config === 'string') {
    config = arguments[1] || {};
    config.url = arguments[0];
  } else {
    config = config || {};
  }

  config = mergeConfig(this.defaults, config);

  // Set config.method
  if (config.method) {
    config.method = config.method.toLowerCase();
  } else if (this.defaults.method) {
    config.method = this.defaults.method.toLowerCase();
  } else {
    config.method = 'get';
  }

  // Hook up interceptors middleware
  var chain = [dispatchRequest, undefined];
  var promise = Promise.resolve(config);

  this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
    chain.unshift(interceptor.fulfilled, interceptor.rejected);
  });

  this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
    chain.push(interceptor.fulfilled, interceptor.rejected);
  });

  while (chain.length) {
    promise = promise.then(chain.shift(), chain.shift());
  }

  return promise;
};

Axios.prototype.getUri = function getUri(config) {
  config = mergeConfig(this.defaults, config);
  return buildURL(config.url, config.params, config.paramsSerializer).replace(/^\?/, '');
};

// Provide aliases for supported request methods
utils.forEach(['delete', 'get', 'head', 'options'], function forEachMethodNoData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url
    }));
  };
});

utils.forEach(['post', 'put', 'patch'], function forEachMethodWithData(method) {
  /*eslint func-names:0*/
  Axios.prototype[method] = function(url, data, config) {
    return this.request(utils.merge(config || {}, {
      method: method,
      url: url,
      data: data
    }));
  };
});

module.exports = Axios;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

function InterceptorManager() {
  this.handlers = [];
}

/**
 * Add a new interceptor to the stack
 *
 * @param {Function} fulfilled The function to handle `then` for a `Promise`
 * @param {Function} rejected The function to handle `reject` for a `Promise`
 *
 * @return {Number} An ID used to remove interceptor later
 */
InterceptorManager.prototype.use = function use(fulfilled, rejected) {
  this.handlers.push({
    fulfilled: fulfilled,
    rejected: rejected
  });
  return this.handlers.length - 1;
};

/**
 * Remove an interceptor from the stack
 *
 * @param {Number} id The ID that was returned by `use`
 */
InterceptorManager.prototype.eject = function eject(id) {
  if (this.handlers[id]) {
    this.handlers[id] = null;
  }
};

/**
 * Iterate over all the registered interceptors
 *
 * This method is particularly useful for skipping over any
 * interceptors that may have become `null` calling `eject`.
 *
 * @param {Function} fn The function to call for each interceptor
 */
InterceptorManager.prototype.forEach = function forEach(fn) {
  utils.forEach(this.handlers, function forEachHandler(h) {
    if (h !== null) {
      fn(h);
    }
  });
};

module.exports = InterceptorManager;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);
var transformData = __webpack_require__(34);
var isCancel = __webpack_require__(10);
var defaults = __webpack_require__(11);

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
function throwIfCancellationRequested(config) {
  if (config.cancelToken) {
    config.cancelToken.throwIfRequested();
  }
}

/**
 * Dispatch a request to the server using the configured adapter.
 *
 * @param {object} config The config that is to be used for the request
 * @returns {Promise} The Promise to be fulfilled
 */
module.exports = function dispatchRequest(config) {
  throwIfCancellationRequested(config);

  // Ensure headers exist
  config.headers = config.headers || {};

  // Transform request data
  config.data = transformData(
    config.data,
    config.headers,
    config.transformRequest
  );

  // Flatten headers
  config.headers = utils.merge(
    config.headers.common || {},
    config.headers[config.method] || {},
    config.headers
  );

  utils.forEach(
    ['delete', 'get', 'head', 'post', 'put', 'patch', 'common'],
    function cleanHeaderConfig(method) {
      delete config.headers[method];
    }
  );

  var adapter = config.adapter || defaults.adapter;

  return adapter(config).then(function onAdapterResolution(response) {
    throwIfCancellationRequested(config);

    // Transform response data
    response.data = transformData(
      response.data,
      response.headers,
      config.transformResponse
    );

    return response;
  }, function onAdapterRejection(reason) {
    if (!isCancel(reason)) {
      throwIfCancellationRequested(config);

      // Transform response data
      if (reason && reason.response) {
        reason.response.data = transformData(
          reason.response.data,
          reason.response.headers,
          config.transformResponse
        );
      }
    }

    return Promise.reject(reason);
  });
};


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

/**
 * Transform the data for a request or a response
 *
 * @param {Object|String} data The data to be transformed
 * @param {Array} headers The headers for the request or response
 * @param {Array|Function} fns A single function or Array of functions
 * @returns {*} The resulting transformed data
 */
module.exports = function transformData(data, headers, fns) {
  /*eslint no-param-reassign:0*/
  utils.forEach(fns, function transform(fn) {
    data = fn(data, headers);
  });

  return data;
};


/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = function normalizeHeaderName(headers, normalizedName) {
  utils.forEach(headers, function processHeader(value, name) {
    if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
      headers[normalizedName] = value;
      delete headers[name];
    }
  });
};


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var createError = __webpack_require__(13);

/**
 * Resolve or reject a Promise based on response status.
 *
 * @param {Function} resolve A function that resolves the promise.
 * @param {Function} reject A function that rejects the promise.
 * @param {object} response The response.
 */
module.exports = function settle(resolve, reject, response) {
  var validateStatus = response.config.validateStatus;
  if (!validateStatus || validateStatus(response.status)) {
    resolve(response);
  } else {
    reject(createError(
      'Request failed with status code ' + response.status,
      response.config,
      null,
      response.request,
      response
    ));
  }
};


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Update an Error with the specified config, error code, and response.
 *
 * @param {Error} error The error to update.
 * @param {Object} config The config.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 * @returns {Error} The error.
 */
module.exports = function enhanceError(error, config, code, request, response) {
  error.config = config;
  if (code) {
    error.code = code;
  }

  error.request = request;
  error.response = response;
  error.isAxiosError = true;

  error.toJSON = function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: this.config,
      code: this.code
    };
  };
  return error;
};


/***/ }),
/* 38 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isAbsoluteURL = __webpack_require__(39);
var combineURLs = __webpack_require__(40);

/**
 * Creates a new URL by combining the baseURL with the requestedURL,
 * only when the requestedURL is not already an absolute URL.
 * If the requestURL is absolute, this function returns the requestedURL untouched.
 *
 * @param {string} baseURL The base URL
 * @param {string} requestedURL Absolute or relative URL to combine
 * @returns {string} The combined full path
 */
module.exports = function buildFullPath(baseURL, requestedURL) {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineURLs(baseURL, requestedURL);
  }
  return requestedURL;
};


/***/ }),
/* 39 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Determines whether the specified URL is absolute
 *
 * @param {string} url The URL to test
 * @returns {boolean} True if the specified URL is absolute, otherwise false
 */
module.exports = function isAbsoluteURL(url) {
  // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
  // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
  // by any combination of letters, digits, plus, period, or hyphen.
  return /^([a-z][a-z\d\+\-\.]*:)?\/\//i.test(url);
};


/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Creates a new URL by combining the specified URLs
 *
 * @param {string} baseURL The base URL
 * @param {string} relativeURL The relative URL
 * @returns {string} The combined URL
 */
module.exports = function combineURLs(baseURL, relativeURL) {
  return relativeURL
    ? baseURL.replace(/\/+$/, '') + '/' + relativeURL.replace(/^\/+/, '')
    : baseURL;
};


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

// Headers whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
var ignoreDuplicateOf = [
  'age', 'authorization', 'content-length', 'content-type', 'etag',
  'expires', 'from', 'host', 'if-modified-since', 'if-unmodified-since',
  'last-modified', 'location', 'max-forwards', 'proxy-authorization',
  'referer', 'retry-after', 'user-agent'
];

/**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} headers Headers needing to be parsed
 * @returns {Object} Headers parsed into an object
 */
module.exports = function parseHeaders(headers) {
  var parsed = {};
  var key;
  var val;
  var i;

  if (!headers) { return parsed; }

  utils.forEach(headers.split('\n'), function parser(line) {
    i = line.indexOf(':');
    key = utils.trim(line.substr(0, i)).toLowerCase();
    val = utils.trim(line.substr(i + 1));

    if (key) {
      if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
        return;
      }
      if (key === 'set-cookie') {
        parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
      } else {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
  });

  return parsed;
};


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
    (function standardBrowserEnv() {
      var msie = /(msie|trident)/i.test(navigator.userAgent);
      var urlParsingNode = document.createElement('a');
      var originURL;

      /**
    * Parse a URL to discover it's components
    *
    * @param {String} url The URL to be parsed
    * @returns {Object}
    */
      function resolveURL(url) {
        var href = url;

        if (msie) {
        // IE needs attribute set twice to normalize properties
          urlParsingNode.setAttribute('href', href);
          href = urlParsingNode.href;
        }

        urlParsingNode.setAttribute('href', href);

        // urlParsingNode provides the UrlUtils interface - http://url.spec.whatwg.org/#urlutils
        return {
          href: urlParsingNode.href,
          protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
          host: urlParsingNode.host,
          search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
          hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
          hostname: urlParsingNode.hostname,
          port: urlParsingNode.port,
          pathname: (urlParsingNode.pathname.charAt(0) === '/') ?
            urlParsingNode.pathname :
            '/' + urlParsingNode.pathname
        };
      }

      originURL = resolveURL(window.location.href);

      /**
    * Determine if a URL shares the same origin as the current location
    *
    * @param {String} requestURL The URL to test
    * @returns {boolean} True if URL shares the same origin, otherwise false
    */
      return function isURLSameOrigin(requestURL) {
        var parsed = (utils.isString(requestURL)) ? resolveURL(requestURL) : requestURL;
        return (parsed.protocol === originURL.protocol &&
            parsed.host === originURL.host);
      };
    })() :

  // Non standard browser envs (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return function isURLSameOrigin() {
        return true;
      };
    })()
);


/***/ }),
/* 43 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var utils = __webpack_require__(1);

module.exports = (
  utils.isStandardBrowserEnv() ?

  // Standard browser envs support document.cookie
    (function standardBrowserEnv() {
      return {
        write: function write(name, value, expires, path, domain, secure) {
          var cookie = [];
          cookie.push(name + '=' + encodeURIComponent(value));

          if (utils.isNumber(expires)) {
            cookie.push('expires=' + new Date(expires).toGMTString());
          }

          if (utils.isString(path)) {
            cookie.push('path=' + path);
          }

          if (utils.isString(domain)) {
            cookie.push('domain=' + domain);
          }

          if (secure === true) {
            cookie.push('secure');
          }

          document.cookie = cookie.join('; ');
        },

        read: function read(name) {
          var match = document.cookie.match(new RegExp('(^|;\\s*)(' + name + ')=([^;]*)'));
          return (match ? decodeURIComponent(match[3]) : null);
        },

        remove: function remove(name) {
          this.write(name, '', Date.now() - 86400000);
        }
      };
    })() :

  // Non standard browser env (web workers, react-native) lack needed support.
    (function nonStandardBrowserEnv() {
      return {
        write: function write() {},
        read: function read() { return null; },
        remove: function remove() {}
      };
    })()
);


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Cancel = __webpack_require__(15);

/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @class
 * @param {Function} executor The executor function.
 */
function CancelToken(executor) {
  if (typeof executor !== 'function') {
    throw new TypeError('executor must be a function.');
  }

  var resolvePromise;
  this.promise = new Promise(function promiseExecutor(resolve) {
    resolvePromise = resolve;
  });

  var token = this;
  executor(function cancel(message) {
    if (token.reason) {
      // Cancellation has already been requested
      return;
    }

    token.reason = new Cancel(message);
    resolvePromise(token.reason);
  });
}

/**
 * Throws a `Cancel` if cancellation has been requested.
 */
CancelToken.prototype.throwIfRequested = function throwIfRequested() {
  if (this.reason) {
    throw this.reason;
  }
};

/**
 * Returns an object that contains a new `CancelToken` and a function that, when called,
 * cancels the `CancelToken`.
 */
CancelToken.source = function source() {
  var cancel;
  var token = new CancelToken(function executor(c) {
    cancel = c;
  });
  return {
    token: token,
    cancel: cancel
  };
};

module.exports = CancelToken;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Syntactic sugar for invoking a function and expanding an array for arguments.
 *
 * Common use case would be to use `Function.prototype.apply`.
 *
 *  ```js
 *  function f(x, y, z) {}
 *  var args = [1, 2, 3];
 *  f.apply(null, args);
 *  ```
 *
 * With `spread` this example can be re-written.
 *
 *  ```js
 *  spread(function(x, y, z) {})([1, 2, 3]);
 *  ```
 *
 * @param {Function} callback
 * @returns {Function}
 */
module.exports = function spread(callback) {
  return function wrap(arr) {
    return callback.apply(null, arr);
  };
};


/***/ }),
/* 46 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "toolbar": ""
    }
  }, [_c('v-dialog', {
    attrs: {
      "fullscreen": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info
      }
    },
    model: {
      value: (_vm.info),
      callback: function($$v) {
        _vm.info = $$v
      },
      expression: "info"
    }
  }, [_c('v-card', {
    staticClass: "infoDialog"
  }, [_c('div', {
    staticClass: "menuIns"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-navicon")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-browsers-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Contents")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Navigate to book chapters")])]), _vm._v(" "), _c('div', {
    staticClass: "menuInsTip2"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Related Books")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Other books you might like")])]), _vm._v(" "), _c('div', {
    staticClass: "socMenu"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-linkedin")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-facebook")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-twitter")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-tumblr")]), _vm._v(" "), _c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-social-pinterest")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuMob"
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('div', {
    staticClass: "socMenuTip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Share Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Share book to your social network")])]), _vm._v(" "), _c('div', {
    staticClass: "resize-settings"
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1), _vm._v(" "), _c('div', {
    staticClass: "resize-settings-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Settings button")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Change colors and fonts")])]), _vm._v(" "), _c('div', {
    staticClass: "left-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-left")])], 1), _vm._v(" "), _c('div', {
    staticClass: "left-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Left/Previous")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to previous page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe right.")])]), _vm._v(" "), _c('div', {
    staticClass: "right-button"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-ios-arrow-right")])], 1), _vm._v(" "), _c('div', {
    staticClass: "right-button-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Right/Next")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Go to next page or chapter in book view."), _c('br'), _vm._v("On touch screen swipe left.")])]), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-mob"
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('div', {
    staticClass: "buy-buttons-tip"
  }, [_c('br'), _vm._v(" "), _c('strong', [_vm._v("Buy Book")]), _c('br'), _vm._v(" "), _c('small', [_vm._v("Click to stores where you can buy this book")])]), _vm._v(" "), _c('div', {
    staticClass: "headline"
  }, [_vm._v("Instructions")]), _vm._v(" "), _c('v-btn', {
    staticClass: "closeDialog",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = false
      }
    }
  }, [_vm._v("Close")])], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "menu",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', _vm._l((_vm.items), function(item) {
    return _c('v-list-tile', {
      key: item.name,
      attrs: {
        "href": item.path,
        "to": item.path,
        "exact": "",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "height": "55px",
        "alt": item.alt,
        "src": item.image
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(item.name))])], 1)], 1)
  }), 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "otherBooks",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "enable-resize-watcher": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks
      }
    },
    model: {
      value: (_vm.otherBooks),
      callback: function($$v) {
        _vm.otherBooks = $$v
      },
      expression: "otherBooks"
    }
  }, [_c('v-list', [_c('h6', [_vm._v("Other books you might like:")]), _vm._v(" "), _vm._l((_vm.books), function(book) {
    return _c('v-list-tile', {
      key: book.title,
      attrs: {
        "href": book.url,
        "target": "_blank",
        "ripple": false,
        "width": "100%"
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": book.alt,
        "src": book.img
      }
    })]), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      attrs: {
        "active": ""
      }
    }, [_vm._v(_vm._s(book.title))])], 1)], 1)
  })], 2)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "settings-drawer",
    attrs: {
      "temporary": "",
      "hide-overlay": "",
      "clipped": "",
      "right": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.drawerRight),
      callback: function($$v) {
        _vm.drawerRight = $$v
      },
      expression: "drawerRight"
    }
  }, [_c('v-list', [_c('settings')], 1)], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "mini-bar",
    attrs: {
      "mini-variant": "",
      "enable-resize-watcher": "",
      "touchless": ""
    },
    model: {
      value: (_vm.buyBar),
      callback: function($$v) {
        _vm.buyBar = $$v
      },
      expression: "buyBar"
    }
  }, [_c('v-list', {
    attrs: {
      "ripple": false
    }
  }, [_vm._v("Shop:\n      "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })])
  })], 2)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "main-menu",
    attrs: {
      "fixed": "",
      "persistent": ""
    }
  }, [_c('v-btn', {
    staticClass: "main-menu-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-navicon")])], 1), _vm._v(" "), (_vm.books.length > 0) ? _c('v-btn', {
    key: _vm.booksChanged,
    staticClass: "otherBooks-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.otherBooks = !_vm.otherBooks, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.drawer = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-browsers-outline")])], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "desktop-social-btn",
    staticStyle: {
      "margin-left": "5%"
    }
  }, _vm._l((_vm.socials), function(social) {
    return _c('v-btn', {
      key: social.title,
      attrs: {
        "flat": "",
        "href": social.url,
        "target": "_blank",
        "ripple": false
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1)
  }), 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-buy-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu, _vm.info = false, _vm.drawer = false, _vm.socialMenu = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-bag")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "buy-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.buyMenu = !_vm.buyMenu
      }
    },
    model: {
      value: (_vm.buyMenu),
      callback: function($$v) {
        _vm.buyMenu = $$v
      },
      expression: "buyMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Purchase this book: ")]), _vm._v(" "), _vm._l((_vm.buys), function(buy) {
    return _c('v-list-tile', {
      key: buy.title,
      attrs: {
        "href": buy.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.buyClick(buy.url)
        }
      }
    }, [_c('v-list-tile-action', [_c('img', {
      attrs: {
        "alt": buy.alt,
        "src": buy.img
      }
    })]), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(buy.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "mobile-social-btn",
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu, _vm.info = false, _vm.buyMenu = false, _vm.drawer = false, _vm.drawerRight = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-android-share-alt")])], 1), _vm._v(" "), _c('v-navigation-drawer', {
    staticClass: "social-menu",
    attrs: {
      "width": "100vw",
      "height": "auto",
      "hide-overlay": "",
      "temporary": "",
      "clipped": "",
      "disable-route-watcher": "",
      "persistent": "",
      "touchless": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.socialMenu = !_vm.socialMenu
      }
    },
    model: {
      value: (_vm.socialMenu),
      callback: function($$v) {
        _vm.socialMenu = $$v
      },
      expression: "socialMenu"
    }
  }, [_c('v-list', [_c('span', [_vm._v("Share this book: ")]), _vm._v(" "), _vm._l((_vm.socials), function(social) {
    return _c('v-list-tile', {
      key: social.title,
      attrs: {
        "href": social.url,
        "target": "_blank"
      },
      on: {
        "click": function($event) {
          return _vm.shareClick(social.title)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(social.icon))])], 1), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(social.title)
      }
    })], 1)
  })], 2)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    staticClass: "info-btn",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.info = !_vm.info, _vm.drawer = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawerRight = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-information-outline")])], 1), _vm._v(" "), _c('v-btn', {
    staticClass: "settings-button",
    attrs: {
      "flat": "",
      "ripple": false
    },
    nativeOn: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawerRight = !_vm.drawerRight, _vm.info = false, _vm.buyMenu = false, _vm.socialMenu = false, _vm.drawer = false, _vm.otherBooks = false
      }
    }
  }, [_c('v-icon', [_vm._v("ion-ios-gear-outline")])], 1)], 1), _vm._v(" "), _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('reader')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Reader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Reader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_xhtml_cover__ = __webpack_require__(52);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_xhtml_cover___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_xhtml_cover__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_xhtml_birdsfront__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_xhtml_birdsfront___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_xhtml_birdsfront__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_xhtml_love_1__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_xhtml_love_1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_xhtml_love_1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_xhtml_title__ = __webpack_require__(61);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_xhtml_title___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_xhtml_title__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_xhtml_contents__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_xhtml_contents___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_xhtml_contents__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_xhtml_frontmatter01__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_xhtml_frontmatter01___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_xhtml_frontmatter01__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_xhtml_chapter001__ = __webpack_require__(70);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_xhtml_chapter001___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_xhtml_chapter001__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_xhtml_chapter002__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_xhtml_chapter002___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_xhtml_chapter002__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_xhtml_chapter003__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_xhtml_chapter003___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_xhtml_chapter003__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_xhtml_chapter004__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_xhtml_chapter004___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_xhtml_chapter004__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_xhtml_chapter005__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_xhtml_chapter005___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_xhtml_chapter005__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_xhtml_chapter006__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_xhtml_chapter006___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_xhtml_chapter006__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_xhtml_chapter007__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_xhtml_chapter007___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_xhtml_chapter007__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_xhtml_chapter008__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_xhtml_chapter008___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_xhtml_chapter008__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_xhtml_chapter008a__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_xhtml_chapter008a___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_xhtml_chapter008a__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_xhtml_chapter009__ = __webpack_require__(97);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_xhtml_chapter009___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_xhtml_chapter009__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_xhtml_chapter009a__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_xhtml_chapter009a___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_xhtml_chapter009a__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_xhtml_love_2__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_xhtml_love_2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_xhtml_love_2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_xhtml_endmatter01__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_xhtml_endmatter01___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_xhtml_endmatter01__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_xhtml_endmatter02__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_xhtml_endmatter02___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_xhtml_endmatter02__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_xhtml_endmatter03__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_xhtml_endmatter03___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__components_xhtml_endmatter03__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_xhtml_endmatter04__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_xhtml_endmatter04___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_xhtml_endmatter04__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_xhtml_notes1__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__components_xhtml_notes1___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__components_xhtml_notes1__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_xhtml_notes2__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_xhtml_notes2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__components_xhtml_notes2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_xhtml_notes3__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__components_xhtml_notes3___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__components_xhtml_notes3__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_xhtml_notes4__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__components_xhtml_notes4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__components_xhtml_notes4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_xhtml_notes5__ = __webpack_require__(130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components_xhtml_notes5___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30__components_xhtml_notes5__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_xhtml_bibliography__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__components_xhtml_bibliography___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__components_xhtml_bibliography__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_xhtml_index__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__components_xhtml_index___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__components_xhtml_index__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_xhtml_indexa__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__components_xhtml_indexa___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__components_xhtml_indexa__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_xhtml_endmatter05__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__components_xhtml_endmatter05___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__components_xhtml_endmatter05__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_xhtml_copyright__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__components_xhtml_copyright___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35__components_xhtml_copyright__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_xhtml_birdsback__ = __webpack_require__(148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__components_xhtml_birdsback___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36__components_xhtml_birdsback__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_xhtml_backad__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__components_xhtml_backad___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37__components_xhtml_backad__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_xhtml_endmatter06__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__components_xhtml_endmatter06___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38__components_xhtml_endmatter06__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_last__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__components_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39__components_last__);
/*jshint esversion: 6 */










































__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    "path": "/",
    "name": "home",
    "component": __WEBPACK_IMPORTED_MODULE_3__components_home___default.a
  }, {
    "path": "/xhtml/contents",
    "name": "xhtml/contents",
    "component": __WEBPACK_IMPORTED_MODULE_8__components_xhtml_contents___default.a
  }, {
    "path": "/xhtml/frontmatter01",
    "name": "xhtml/frontmatter01",
    "component": __WEBPACK_IMPORTED_MODULE_9__components_xhtml_frontmatter01___default.a
  }, {
    "path": "/xhtml/chapter001",
    "name": "xhtml/chapter001",
    "component": __WEBPACK_IMPORTED_MODULE_10__components_xhtml_chapter001___default.a
  }, {
    "path": "/xhtml/chapter002",
    "name": "xhtml/chapter002",
    "component": __WEBPACK_IMPORTED_MODULE_11__components_xhtml_chapter002___default.a
  }, {
    "path": "/xhtml/chapter003",
    "name": "xhtml/chapter003",
    "component": __WEBPACK_IMPORTED_MODULE_12__components_xhtml_chapter003___default.a
  }, {
    "path": "/last",
    "name": "last",
    "component": __WEBPACK_IMPORTED_MODULE_39__components_last___default.a
  }]
}));

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/**
  * vue-router v2.8.1
  * (c) 2017 Evan You
  * @license MIT
  */
/*  */

function assert (condition, message) {
  if (!condition) {
    throw new Error(("[vue-router] " + message))
  }
}

function warn (condition, message) {
  if (false) {
    typeof console !== 'undefined' && console.warn(("[vue-router] " + message));
  }
}

function isError (err) {
  return Object.prototype.toString.call(err).indexOf('Error') > -1
}

var View = {
  name: 'router-view',
  functional: true,
  props: {
    name: {
      type: String,
      default: 'default'
    }
  },
  render: function render (_, ref) {
    var props = ref.props;
    var children = ref.children;
    var parent = ref.parent;
    var data = ref.data;

    data.routerView = true;

    // directly use parent context's createElement() function
    // so that components rendered by router-view can resolve named slots
    var h = parent.$createElement;
    var name = props.name;
    var route = parent.$route;
    var cache = parent._routerViewCache || (parent._routerViewCache = {});

    // determine current view depth, also check to see if the tree
    // has been toggled inactive but kept-alive.
    var depth = 0;
    var inactive = false;
    while (parent && parent._routerRoot !== parent) {
      if (parent.$vnode && parent.$vnode.data.routerView) {
        depth++;
      }
      if (parent._inactive) {
        inactive = true;
      }
      parent = parent.$parent;
    }
    data.routerViewDepth = depth;

    // render previous view if the tree is inactive and kept-alive
    if (inactive) {
      return h(cache[name], data, children)
    }

    var matched = route.matched[depth];
    // render empty node if no matched route
    if (!matched) {
      cache[name] = null;
      return h()
    }

    var component = cache[name] = matched.components[name];

    // attach instance registration hook
    // this will be called in the instance's injected lifecycle hooks
    data.registerRouteInstance = function (vm, val) {
      // val could be undefined for unregistration
      var current = matched.instances[name];
      if (
        (val && current !== vm) ||
        (!val && current === vm)
      ) {
        matched.instances[name] = val;
      }
    }

    // also register instance in prepatch hook
    // in case the same component instance is reused across different routes
    ;(data.hook || (data.hook = {})).prepatch = function (_, vnode) {
      matched.instances[name] = vnode.componentInstance;
    };

    // resolve props
    var propsToPass = data.props = resolveProps(route, matched.props && matched.props[name]);
    if (propsToPass) {
      // clone to prevent mutation
      propsToPass = data.props = extend({}, propsToPass);
      // pass non-declared props as attrs
      var attrs = data.attrs = data.attrs || {};
      for (var key in propsToPass) {
        if (!component.props || !(key in component.props)) {
          attrs[key] = propsToPass[key];
          delete propsToPass[key];
        }
      }
    }

    return h(component, data, children)
  }
};

function resolveProps (route, config) {
  switch (typeof config) {
    case 'undefined':
      return
    case 'object':
      return config
    case 'function':
      return config(route)
    case 'boolean':
      return config ? route.params : undefined
    default:
      if (false) {
        warn(
          false,
          "props in \"" + (route.path) + "\" is a " + (typeof config) + ", " +
          "expecting an object, function or boolean."
        );
      }
  }
}

function extend (to, from) {
  for (var key in from) {
    to[key] = from[key];
  }
  return to
}

/*  */

var encodeReserveRE = /[!'()*]/g;
var encodeReserveReplacer = function (c) { return '%' + c.charCodeAt(0).toString(16); };
var commaRE = /%2C/g;

// fixed encodeURIComponent which is more conformant to RFC3986:
// - escapes [!'()*]
// - preserve commas
var encode = function (str) { return encodeURIComponent(str)
  .replace(encodeReserveRE, encodeReserveReplacer)
  .replace(commaRE, ','); };

var decode = decodeURIComponent;

function resolveQuery (
  query,
  extraQuery,
  _parseQuery
) {
  if ( extraQuery === void 0 ) extraQuery = {};

  var parse = _parseQuery || parseQuery;
  var parsedQuery;
  try {
    parsedQuery = parse(query || '');
  } catch (e) {
    "production" !== 'production' && warn(false, e.message);
    parsedQuery = {};
  }
  for (var key in extraQuery) {
    parsedQuery[key] = extraQuery[key];
  }
  return parsedQuery
}

function parseQuery (query) {
  var res = {};

  query = query.trim().replace(/^(\?|#|&)/, '');

  if (!query) {
    return res
  }

  query.split('&').forEach(function (param) {
    var parts = param.replace(/\+/g, ' ').split('=');
    var key = decode(parts.shift());
    var val = parts.length > 0
      ? decode(parts.join('='))
      : null;

    if (res[key] === undefined) {
      res[key] = val;
    } else if (Array.isArray(res[key])) {
      res[key].push(val);
    } else {
      res[key] = [res[key], val];
    }
  });

  return res
}

function stringifyQuery (obj) {
  var res = obj ? Object.keys(obj).map(function (key) {
    var val = obj[key];

    if (val === undefined) {
      return ''
    }

    if (val === null) {
      return encode(key)
    }

    if (Array.isArray(val)) {
      var result = [];
      val.forEach(function (val2) {
        if (val2 === undefined) {
          return
        }
        if (val2 === null) {
          result.push(encode(key));
        } else {
          result.push(encode(key) + '=' + encode(val2));
        }
      });
      return result.join('&')
    }

    return encode(key) + '=' + encode(val)
  }).filter(function (x) { return x.length > 0; }).join('&') : null;
  return res ? ("?" + res) : ''
}

/*  */


var trailingSlashRE = /\/?$/;

function createRoute (
  record,
  location,
  redirectedFrom,
  router
) {
  var stringifyQuery$$1 = router && router.options.stringifyQuery;

  var query = location.query || {};
  try {
    query = clone(query);
  } catch (e) {}

  var route = {
    name: location.name || (record && record.name),
    meta: (record && record.meta) || {},
    path: location.path || '/',
    hash: location.hash || '',
    query: query,
    params: location.params || {},
    fullPath: getFullPath(location, stringifyQuery$$1),
    matched: record ? formatMatch(record) : []
  };
  if (redirectedFrom) {
    route.redirectedFrom = getFullPath(redirectedFrom, stringifyQuery$$1);
  }
  return Object.freeze(route)
}

function clone (value) {
  if (Array.isArray(value)) {
    return value.map(clone)
  } else if (value && typeof value === 'object') {
    var res = {};
    for (var key in value) {
      res[key] = clone(value[key]);
    }
    return res
  } else {
    return value
  }
}

// the starting route that represents the initial state
var START = createRoute(null, {
  path: '/'
});

function formatMatch (record) {
  var res = [];
  while (record) {
    res.unshift(record);
    record = record.parent;
  }
  return res
}

function getFullPath (
  ref,
  _stringifyQuery
) {
  var path = ref.path;
  var query = ref.query; if ( query === void 0 ) query = {};
  var hash = ref.hash; if ( hash === void 0 ) hash = '';

  var stringify = _stringifyQuery || stringifyQuery;
  return (path || '/') + stringify(query) + hash
}

function isSameRoute (a, b) {
  if (b === START) {
    return a === b
  } else if (!b) {
    return false
  } else if (a.path && b.path) {
    return (
      a.path.replace(trailingSlashRE, '') === b.path.replace(trailingSlashRE, '') &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query)
    )
  } else if (a.name && b.name) {
    return (
      a.name === b.name &&
      a.hash === b.hash &&
      isObjectEqual(a.query, b.query) &&
      isObjectEqual(a.params, b.params)
    )
  } else {
    return false
  }
}

function isObjectEqual (a, b) {
  if ( a === void 0 ) a = {};
  if ( b === void 0 ) b = {};

  // handle null value #1566
  if (!a || !b) { return a === b }
  var aKeys = Object.keys(a);
  var bKeys = Object.keys(b);
  if (aKeys.length !== bKeys.length) {
    return false
  }
  return aKeys.every(function (key) {
    var aVal = a[key];
    var bVal = b[key];
    // check nested equality
    if (typeof aVal === 'object' && typeof bVal === 'object') {
      return isObjectEqual(aVal, bVal)
    }
    return String(aVal) === String(bVal)
  })
}

function isIncludedRoute (current, target) {
  return (
    current.path.replace(trailingSlashRE, '/').indexOf(
      target.path.replace(trailingSlashRE, '/')
    ) === 0 &&
    (!target.hash || current.hash === target.hash) &&
    queryIncludes(current.query, target.query)
  )
}

function queryIncludes (current, target) {
  for (var key in target) {
    if (!(key in current)) {
      return false
    }
  }
  return true
}

/*  */

// work around weird flow bug
var toTypes = [String, Object];
var eventTypes = [String, Array];

var Link = {
  name: 'router-link',
  props: {
    to: {
      type: toTypes,
      required: true
    },
    tag: {
      type: String,
      default: 'a'
    },
    exact: Boolean,
    append: Boolean,
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    event: {
      type: eventTypes,
      default: 'click'
    }
  },
  render: function render (h) {
    var this$1 = this;

    var router = this.$router;
    var current = this.$route;
    var ref = router.resolve(this.to, current, this.append);
    var location = ref.location;
    var route = ref.route;
    var href = ref.href;

    var classes = {};
    var globalActiveClass = router.options.linkActiveClass;
    var globalExactActiveClass = router.options.linkExactActiveClass;
    // Support global empty active class
    var activeClassFallback = globalActiveClass == null
            ? 'router-link-active'
            : globalActiveClass;
    var exactActiveClassFallback = globalExactActiveClass == null
            ? 'router-link-exact-active'
            : globalExactActiveClass;
    var activeClass = this.activeClass == null
            ? activeClassFallback
            : this.activeClass;
    var exactActiveClass = this.exactActiveClass == null
            ? exactActiveClassFallback
            : this.exactActiveClass;
    var compareTarget = location.path
      ? createRoute(null, location, null, router)
      : route;

    classes[exactActiveClass] = isSameRoute(current, compareTarget);
    classes[activeClass] = this.exact
      ? classes[exactActiveClass]
      : isIncludedRoute(current, compareTarget);

    var handler = function (e) {
      if (guardEvent(e)) {
        if (this$1.replace) {
          router.replace(location);
        } else {
          router.push(location);
        }
      }
    };

    var on = { click: guardEvent };
    if (Array.isArray(this.event)) {
      this.event.forEach(function (e) { on[e] = handler; });
    } else {
      on[this.event] = handler;
    }

    var data = {
      class: classes
    };

    if (this.tag === 'a') {
      data.on = on;
      data.attrs = { href: href };
    } else {
      // find the first <a> child and apply listener and href
      var a = findAnchor(this.$slots.default);
      if (a) {
        // in case the <a> is a static node
        a.isStatic = false;
        var extend = _Vue.util.extend;
        var aData = a.data = extend({}, a.data);
        aData.on = on;
        var aAttrs = a.data.attrs = extend({}, a.data.attrs);
        aAttrs.href = href;
      } else {
        // doesn't have <a> child, apply listener to self
        data.on = on;
      }
    }

    return h(this.tag, data, this.$slots.default)
  }
};

function guardEvent (e) {
  // don't redirect with control keys
  if (e.metaKey || e.altKey || e.ctrlKey || e.shiftKey) { return }
  // don't redirect when preventDefault called
  if (e.defaultPrevented) { return }
  // don't redirect on right click
  if (e.button !== undefined && e.button !== 0) { return }
  // don't redirect if `target="_blank"`
  if (e.currentTarget && e.currentTarget.getAttribute) {
    var target = e.currentTarget.getAttribute('target');
    if (/\b_blank\b/i.test(target)) { return }
  }
  // this may be a Weex event which doesn't have this method
  if (e.preventDefault) {
    e.preventDefault();
  }
  return true
}

function findAnchor (children) {
  if (children) {
    var child;
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      if (child.tag === 'a') {
        return child
      }
      if (child.children && (child = findAnchor(child.children))) {
        return child
      }
    }
  }
}

var _Vue;

function install (Vue) {
  if (install.installed && _Vue === Vue) { return }
  install.installed = true;

  _Vue = Vue;

  var isDef = function (v) { return v !== undefined; };

  var registerInstance = function (vm, callVal) {
    var i = vm.$options._parentVnode;
    if (isDef(i) && isDef(i = i.data) && isDef(i = i.registerRouteInstance)) {
      i(vm, callVal);
    }
  };

  Vue.mixin({
    beforeCreate: function beforeCreate () {
      if (isDef(this.$options.router)) {
        this._routerRoot = this;
        this._router = this.$options.router;
        this._router.init(this);
        Vue.util.defineReactive(this, '_route', this._router.history.current);
      } else {
        this._routerRoot = (this.$parent && this.$parent._routerRoot) || this;
      }
      registerInstance(this, this);
    },
    destroyed: function destroyed () {
      registerInstance(this);
    }
  });

  Object.defineProperty(Vue.prototype, '$router', {
    get: function get () { return this._routerRoot._router }
  });

  Object.defineProperty(Vue.prototype, '$route', {
    get: function get () { return this._routerRoot._route }
  });

  Vue.component('router-view', View);
  Vue.component('router-link', Link);

  var strats = Vue.config.optionMergeStrategies;
  // use the same hook merging strategy for route hooks
  strats.beforeRouteEnter = strats.beforeRouteLeave = strats.beforeRouteUpdate = strats.created;
}

/*  */

var inBrowser = typeof window !== 'undefined';

/*  */

function resolvePath (
  relative,
  base,
  append
) {
  var firstChar = relative.charAt(0);
  if (firstChar === '/') {
    return relative
  }

  if (firstChar === '?' || firstChar === '#') {
    return base + relative
  }

  var stack = base.split('/');

  // remove trailing segment if:
  // - not appending
  // - appending to trailing slash (last segment is empty)
  if (!append || !stack[stack.length - 1]) {
    stack.pop();
  }

  // resolve relative path
  var segments = relative.replace(/^\//, '').split('/');
  for (var i = 0; i < segments.length; i++) {
    var segment = segments[i];
    if (segment === '..') {
      stack.pop();
    } else if (segment !== '.') {
      stack.push(segment);
    }
  }

  // ensure leading slash
  if (stack[0] !== '') {
    stack.unshift('');
  }

  return stack.join('/')
}

function parsePath (path) {
  var hash = '';
  var query = '';

  var hashIndex = path.indexOf('#');
  if (hashIndex >= 0) {
    hash = path.slice(hashIndex);
    path = path.slice(0, hashIndex);
  }

  var queryIndex = path.indexOf('?');
  if (queryIndex >= 0) {
    query = path.slice(queryIndex + 1);
    path = path.slice(0, queryIndex);
  }

  return {
    path: path,
    query: query,
    hash: hash
  }
}

function cleanPath (path) {
  return path.replace(/\/\//g, '/')
}

var isarray = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};

/**
 * Expose `pathToRegexp`.
 */
var pathToRegexp_1 = pathToRegexp;
var parse_1 = parse;
var compile_1 = compile;
var tokensToFunction_1 = tokensToFunction;
var tokensToRegExp_1 = tokensToRegExp;

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g');

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = [];
  var key = 0;
  var index = 0;
  var path = '';
  var defaultDelimiter = options && options.delimiter || '/';
  var res;

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0];
    var escaped = res[1];
    var offset = res.index;
    path += str.slice(index, offset);
    index = offset + m.length;

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1];
      continue
    }

    var next = str[index];
    var prefix = res[2];
    var name = res[3];
    var capture = res[4];
    var group = res[5];
    var modifier = res[6];
    var asterisk = res[7];

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path);
      path = '';
    }

    var partial = prefix != null && next != null && next !== prefix;
    var repeat = modifier === '+' || modifier === '*';
    var optional = modifier === '?' || modifier === '*';
    var delimiter = res[2] || defaultDelimiter;
    var pattern = capture || group;

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    });
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index);
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path);
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options))
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length);

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$');
    }
  }

  return function (obj, opts) {
    var path = '';
    var data = obj || {};
    var options = opts || {};
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent;

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i];

      if (typeof token === 'string') {
        path += token;

        continue
      }

      var value = data[token.name];
      var segment;

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix;
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j]);

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment;
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value);

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment;
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys;
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g);

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      });
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = [];

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source);
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options));

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  var strict = options.strict;
  var end = options.end !== false;
  var route = '';

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i];

    if (typeof token === 'string') {
      route += escapeString(token);
    } else {
      var prefix = escapeString(token.prefix);
      var capture = '(?:' + token.pattern + ')';

      keys.push(token);

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*';
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?';
        } else {
          capture = prefix + '(' + capture + ')?';
        }
      } else {
        capture = prefix + '(' + capture + ')';
      }

      route += capture;
    }
  }

  var delimiter = escapeString(options.delimiter || '/');
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter;

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?';
  }

  if (end) {
    route += '$';
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)';
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options);
    keys = [];
  }

  options = options || {};

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}

pathToRegexp_1.parse = parse_1;
pathToRegexp_1.compile = compile_1;
pathToRegexp_1.tokensToFunction = tokensToFunction_1;
pathToRegexp_1.tokensToRegExp = tokensToRegExp_1;

/*  */

// $flow-disable-line
var regexpCompileCache = Object.create(null);

function fillParams (
  path,
  params,
  routeMsg
) {
  try {
    var filler =
      regexpCompileCache[path] ||
      (regexpCompileCache[path] = pathToRegexp_1.compile(path));
    return filler(params || {}, { pretty: true })
  } catch (e) {
    if (false) {
      warn(false, ("missing param for " + routeMsg + ": " + (e.message)));
    }
    return ''
  }
}

/*  */

function createRouteMap (
  routes,
  oldPathList,
  oldPathMap,
  oldNameMap
) {
  // the path list is used to control path matching priority
  var pathList = oldPathList || [];
  // $flow-disable-line
  var pathMap = oldPathMap || Object.create(null);
  // $flow-disable-line
  var nameMap = oldNameMap || Object.create(null);

  routes.forEach(function (route) {
    addRouteRecord(pathList, pathMap, nameMap, route);
  });

  // ensure wildcard routes are always at the end
  for (var i = 0, l = pathList.length; i < l; i++) {
    if (pathList[i] === '*') {
      pathList.push(pathList.splice(i, 1)[0]);
      l--;
      i--;
    }
  }

  return {
    pathList: pathList,
    pathMap: pathMap,
    nameMap: nameMap
  }
}

function addRouteRecord (
  pathList,
  pathMap,
  nameMap,
  route,
  parent,
  matchAs
) {
  var path = route.path;
  var name = route.name;
  if (false) {
    assert(path != null, "\"path\" is required in a route configuration.");
    assert(
      typeof route.component !== 'string',
      "route config \"component\" for path: " + (String(path || name)) + " cannot be a " +
      "string id. Use an actual component instead."
    );
  }

  var pathToRegexpOptions = route.pathToRegexpOptions || {};
  var normalizedPath = normalizePath(
    path,
    parent,
    pathToRegexpOptions.strict
  );

  if (typeof route.caseSensitive === 'boolean') {
    pathToRegexpOptions.sensitive = route.caseSensitive;
  }

  var record = {
    path: normalizedPath,
    regex: compileRouteRegex(normalizedPath, pathToRegexpOptions),
    components: route.components || { default: route.component },
    instances: {},
    name: name,
    parent: parent,
    matchAs: matchAs,
    redirect: route.redirect,
    beforeEnter: route.beforeEnter,
    meta: route.meta || {},
    props: route.props == null
      ? {}
      : route.components
        ? route.props
        : { default: route.props }
  };

  if (route.children) {
    // Warn if route is named, does not redirect and has a default child route.
    // If users navigate to this route by name, the default child will
    // not be rendered (GH Issue #629)
    if (false) {
      if (route.name && !route.redirect && route.children.some(function (child) { return /^\/?$/.test(child.path); })) {
        warn(
          false,
          "Named Route '" + (route.name) + "' has a default child route. " +
          "When navigating to this named route (:to=\"{name: '" + (route.name) + "'\"), " +
          "the default child route will not be rendered. Remove the name from " +
          "this route and use the name of the default child route for named " +
          "links instead."
        );
      }
    }
    route.children.forEach(function (child) {
      var childMatchAs = matchAs
        ? cleanPath((matchAs + "/" + (child.path)))
        : undefined;
      addRouteRecord(pathList, pathMap, nameMap, child, record, childMatchAs);
    });
  }

  if (route.alias !== undefined) {
    var aliases = Array.isArray(route.alias)
      ? route.alias
      : [route.alias];

    aliases.forEach(function (alias) {
      var aliasRoute = {
        path: alias,
        children: route.children
      };
      addRouteRecord(
        pathList,
        pathMap,
        nameMap,
        aliasRoute,
        parent,
        record.path || '/' // matchAs
      );
    });
  }

  if (!pathMap[record.path]) {
    pathList.push(record.path);
    pathMap[record.path] = record;
  }

  if (name) {
    if (!nameMap[name]) {
      nameMap[name] = record;
    } else if (false) {
      warn(
        false,
        "Duplicate named routes definition: " +
        "{ name: \"" + name + "\", path: \"" + (record.path) + "\" }"
      );
    }
  }
}

function compileRouteRegex (path, pathToRegexpOptions) {
  var regex = pathToRegexp_1(path, [], pathToRegexpOptions);
  if (false) {
    var keys = Object.create(null);
    regex.keys.forEach(function (key) {
      warn(!keys[key.name], ("Duplicate param keys in route with path: \"" + path + "\""));
      keys[key.name] = true;
    });
  }
  return regex
}

function normalizePath (path, parent, strict) {
  if (!strict) { path = path.replace(/\/$/, ''); }
  if (path[0] === '/') { return path }
  if (parent == null) { return path }
  return cleanPath(((parent.path) + "/" + path))
}

/*  */


function normalizeLocation (
  raw,
  current,
  append,
  router
) {
  var next = typeof raw === 'string' ? { path: raw } : raw;
  // named target
  if (next.name || next._normalized) {
    return next
  }

  // relative params
  if (!next.path && next.params && current) {
    next = assign({}, next);
    next._normalized = true;
    var params = assign(assign({}, current.params), next.params);
    if (current.name) {
      next.name = current.name;
      next.params = params;
    } else if (current.matched.length) {
      var rawPath = current.matched[current.matched.length - 1].path;
      next.path = fillParams(rawPath, params, ("path " + (current.path)));
    } else if (false) {
      warn(false, "relative params navigation requires a current route.");
    }
    return next
  }

  var parsedPath = parsePath(next.path || '');
  var basePath = (current && current.path) || '/';
  var path = parsedPath.path
    ? resolvePath(parsedPath.path, basePath, append || next.append)
    : basePath;

  var query = resolveQuery(
    parsedPath.query,
    next.query,
    router && router.options.parseQuery
  );

  var hash = next.hash || parsedPath.hash;
  if (hash && hash.charAt(0) !== '#') {
    hash = "#" + hash;
  }

  return {
    _normalized: true,
    path: path,
    query: query,
    hash: hash
  }
}

function assign (a, b) {
  for (var key in b) {
    a[key] = b[key];
  }
  return a
}

/*  */


function createMatcher (
  routes,
  router
) {
  var ref = createRouteMap(routes);
  var pathList = ref.pathList;
  var pathMap = ref.pathMap;
  var nameMap = ref.nameMap;

  function addRoutes (routes) {
    createRouteMap(routes, pathList, pathMap, nameMap);
  }

  function match (
    raw,
    currentRoute,
    redirectedFrom
  ) {
    var location = normalizeLocation(raw, currentRoute, false, router);
    var name = location.name;

    if (name) {
      var record = nameMap[name];
      if (false) {
        warn(record, ("Route with name '" + name + "' does not exist"));
      }
      if (!record) { return _createRoute(null, location) }
      var paramNames = record.regex.keys
        .filter(function (key) { return !key.optional; })
        .map(function (key) { return key.name; });

      if (typeof location.params !== 'object') {
        location.params = {};
      }

      if (currentRoute && typeof currentRoute.params === 'object') {
        for (var key in currentRoute.params) {
          if (!(key in location.params) && paramNames.indexOf(key) > -1) {
            location.params[key] = currentRoute.params[key];
          }
        }
      }

      if (record) {
        location.path = fillParams(record.path, location.params, ("named route \"" + name + "\""));
        return _createRoute(record, location, redirectedFrom)
      }
    } else if (location.path) {
      location.params = {};
      for (var i = 0; i < pathList.length; i++) {
        var path = pathList[i];
        var record$1 = pathMap[path];
        if (matchRoute(record$1.regex, location.path, location.params)) {
          return _createRoute(record$1, location, redirectedFrom)
        }
      }
    }
    // no match
    return _createRoute(null, location)
  }

  function redirect (
    record,
    location
  ) {
    var originalRedirect = record.redirect;
    var redirect = typeof originalRedirect === 'function'
        ? originalRedirect(createRoute(record, location, null, router))
        : originalRedirect;

    if (typeof redirect === 'string') {
      redirect = { path: redirect };
    }

    if (!redirect || typeof redirect !== 'object') {
      if (false) {
        warn(
          false, ("invalid redirect option: " + (JSON.stringify(redirect)))
        );
      }
      return _createRoute(null, location)
    }

    var re = redirect;
    var name = re.name;
    var path = re.path;
    var query = location.query;
    var hash = location.hash;
    var params = location.params;
    query = re.hasOwnProperty('query') ? re.query : query;
    hash = re.hasOwnProperty('hash') ? re.hash : hash;
    params = re.hasOwnProperty('params') ? re.params : params;

    if (name) {
      // resolved named direct
      var targetRecord = nameMap[name];
      if (false) {
        assert(targetRecord, ("redirect failed: named route \"" + name + "\" not found."));
      }
      return match({
        _normalized: true,
        name: name,
        query: query,
        hash: hash,
        params: params
      }, undefined, location)
    } else if (path) {
      // 1. resolve relative redirect
      var rawPath = resolveRecordPath(path, record);
      // 2. resolve params
      var resolvedPath = fillParams(rawPath, params, ("redirect route with path \"" + rawPath + "\""));
      // 3. rematch with existing query and hash
      return match({
        _normalized: true,
        path: resolvedPath,
        query: query,
        hash: hash
      }, undefined, location)
    } else {
      if (false) {
        warn(false, ("invalid redirect option: " + (JSON.stringify(redirect))));
      }
      return _createRoute(null, location)
    }
  }

  function alias (
    record,
    location,
    matchAs
  ) {
    var aliasedPath = fillParams(matchAs, location.params, ("aliased route with path \"" + matchAs + "\""));
    var aliasedMatch = match({
      _normalized: true,
      path: aliasedPath
    });
    if (aliasedMatch) {
      var matched = aliasedMatch.matched;
      var aliasedRecord = matched[matched.length - 1];
      location.params = aliasedMatch.params;
      return _createRoute(aliasedRecord, location)
    }
    return _createRoute(null, location)
  }

  function _createRoute (
    record,
    location,
    redirectedFrom
  ) {
    if (record && record.redirect) {
      return redirect(record, redirectedFrom || location)
    }
    if (record && record.matchAs) {
      return alias(record, location, record.matchAs)
    }
    return createRoute(record, location, redirectedFrom, router)
  }

  return {
    match: match,
    addRoutes: addRoutes
  }
}

function matchRoute (
  regex,
  path,
  params
) {
  var m = path.match(regex);

  if (!m) {
    return false
  } else if (!params) {
    return true
  }

  for (var i = 1, len = m.length; i < len; ++i) {
    var key = regex.keys[i - 1];
    var val = typeof m[i] === 'string' ? decodeURIComponent(m[i]) : m[i];
    if (key) {
      params[key.name] = val;
    }
  }

  return true
}

function resolveRecordPath (path, record) {
  return resolvePath(path, record.parent ? record.parent.path : '/', true)
}

/*  */


var positionStore = Object.create(null);

function setupScroll () {
  // Fix for #1585 for Firefox
  window.history.replaceState({ key: getStateKey() }, '');
  window.addEventListener('popstate', function (e) {
    saveScrollPosition();
    if (e.state && e.state.key) {
      setStateKey(e.state.key);
    }
  });
}

function handleScroll (
  router,
  to,
  from,
  isPop
) {
  if (!router.app) {
    return
  }

  var behavior = router.options.scrollBehavior;
  if (!behavior) {
    return
  }

  if (false) {
    assert(typeof behavior === 'function', "scrollBehavior must be a function");
  }

  // wait until re-render finishes before scrolling
  router.app.$nextTick(function () {
    var position = getScrollPosition();
    var shouldScroll = behavior(to, from, isPop ? position : null);

    if (!shouldScroll) {
      return
    }

    if (typeof shouldScroll.then === 'function') {
      shouldScroll.then(function (shouldScroll) {
        scrollToPosition((shouldScroll), position);
      }).catch(function (err) {
        if (false) {
          assert(false, err.toString());
        }
      });
    } else {
      scrollToPosition(shouldScroll, position);
    }
  });
}

function saveScrollPosition () {
  var key = getStateKey();
  if (key) {
    positionStore[key] = {
      x: window.pageXOffset,
      y: window.pageYOffset
    };
  }
}

function getScrollPosition () {
  var key = getStateKey();
  if (key) {
    return positionStore[key]
  }
}

function getElementPosition (el, offset) {
  var docEl = document.documentElement;
  var docRect = docEl.getBoundingClientRect();
  var elRect = el.getBoundingClientRect();
  return {
    x: elRect.left - docRect.left - offset.x,
    y: elRect.top - docRect.top - offset.y
  }
}

function isValidPosition (obj) {
  return isNumber(obj.x) || isNumber(obj.y)
}

function normalizePosition (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : window.pageXOffset,
    y: isNumber(obj.y) ? obj.y : window.pageYOffset
  }
}

function normalizeOffset (obj) {
  return {
    x: isNumber(obj.x) ? obj.x : 0,
    y: isNumber(obj.y) ? obj.y : 0
  }
}

function isNumber (v) {
  return typeof v === 'number'
}

function scrollToPosition (shouldScroll, position) {
  var isObject = typeof shouldScroll === 'object';
  if (isObject && typeof shouldScroll.selector === 'string') {
    var el = document.querySelector(shouldScroll.selector);
    if (el) {
      var offset = shouldScroll.offset && typeof shouldScroll.offset === 'object' ? shouldScroll.offset : {};
      offset = normalizeOffset(offset);
      position = getElementPosition(el, offset);
    } else if (isValidPosition(shouldScroll)) {
      position = normalizePosition(shouldScroll);
    }
  } else if (isObject && isValidPosition(shouldScroll)) {
    position = normalizePosition(shouldScroll);
  }

  if (position) {
    window.scrollTo(position.x, position.y);
  }
}

/*  */

var supportsPushState = inBrowser && (function () {
  var ua = window.navigator.userAgent;

  if (
    (ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) &&
    ua.indexOf('Mobile Safari') !== -1 &&
    ua.indexOf('Chrome') === -1 &&
    ua.indexOf('Windows Phone') === -1
  ) {
    return false
  }

  return window.history && 'pushState' in window.history
})();

// use User Timing api (if present) for more accurate key precision
var Time = inBrowser && window.performance && window.performance.now
  ? window.performance
  : Date;

var _key = genKey();

function genKey () {
  return Time.now().toFixed(3)
}

function getStateKey () {
  return _key
}

function setStateKey (key) {
  _key = key;
}

function pushState (url, replace) {
  saveScrollPosition();
  // try...catch the pushState call to get around Safari
  // DOM Exception 18 where it limits to 100 pushState calls
  var history = window.history;
  try {
    if (replace) {
      history.replaceState({ key: _key }, '', url);
    } else {
      _key = genKey();
      history.pushState({ key: _key }, '', url);
    }
  } catch (e) {
    window.location[replace ? 'replace' : 'assign'](url);
  }
}

function replaceState (url) {
  pushState(url, true);
}

/*  */

function runQueue (queue, fn, cb) {
  var step = function (index) {
    if (index >= queue.length) {
      cb();
    } else {
      if (queue[index]) {
        fn(queue[index], function () {
          step(index + 1);
        });
      } else {
        step(index + 1);
      }
    }
  };
  step(0);
}

/*  */

function resolveAsyncComponents (matched) {
  return function (to, from, next) {
    var hasAsync = false;
    var pending = 0;
    var error = null;

    flatMapComponents(matched, function (def, _, match, key) {
      // if it's a function and doesn't have cid attached,
      // assume it's an async component resolve function.
      // we are not using Vue's default async resolving mechanism because
      // we want to halt the navigation until the incoming component has been
      // resolved.
      if (typeof def === 'function' && def.cid === undefined) {
        hasAsync = true;
        pending++;

        var resolve = once(function (resolvedDef) {
          if (isESModule(resolvedDef)) {
            resolvedDef = resolvedDef.default;
          }
          // save resolved on async factory in case it's used elsewhere
          def.resolved = typeof resolvedDef === 'function'
            ? resolvedDef
            : _Vue.extend(resolvedDef);
          match.components[key] = resolvedDef;
          pending--;
          if (pending <= 0) {
            next();
          }
        });

        var reject = once(function (reason) {
          var msg = "Failed to resolve async component " + key + ": " + reason;
          "production" !== 'production' && warn(false, msg);
          if (!error) {
            error = isError(reason)
              ? reason
              : new Error(msg);
            next(error);
          }
        });

        var res;
        try {
          res = def(resolve, reject);
        } catch (e) {
          reject(e);
        }
        if (res) {
          if (typeof res.then === 'function') {
            res.then(resolve, reject);
          } else {
            // new syntax in Vue 2.3
            var comp = res.component;
            if (comp && typeof comp.then === 'function') {
              comp.then(resolve, reject);
            }
          }
        }
      }
    });

    if (!hasAsync) { next(); }
  }
}

function flatMapComponents (
  matched,
  fn
) {
  return flatten(matched.map(function (m) {
    return Object.keys(m.components).map(function (key) { return fn(
      m.components[key],
      m.instances[key],
      m, key
    ); })
  }))
}

function flatten (arr) {
  return Array.prototype.concat.apply([], arr)
}

var hasSymbol =
  typeof Symbol === 'function' &&
  typeof Symbol.toStringTag === 'symbol';

function isESModule (obj) {
  return obj.__esModule || (hasSymbol && obj[Symbol.toStringTag] === 'Module')
}

// in Webpack 2, require.ensure now also returns a Promise
// so the resolve/reject functions may get called an extra time
// if the user uses an arrow function shorthand that happens to
// return that Promise.
function once (fn) {
  var called = false;
  return function () {
    var args = [], len = arguments.length;
    while ( len-- ) args[ len ] = arguments[ len ];

    if (called) { return }
    called = true;
    return fn.apply(this, args)
  }
}

/*  */

var History = function History (router, base) {
  this.router = router;
  this.base = normalizeBase(base);
  // start with a route object that stands for "nowhere"
  this.current = START;
  this.pending = null;
  this.ready = false;
  this.readyCbs = [];
  this.readyErrorCbs = [];
  this.errorCbs = [];
};

History.prototype.listen = function listen (cb) {
  this.cb = cb;
};

History.prototype.onReady = function onReady (cb, errorCb) {
  if (this.ready) {
    cb();
  } else {
    this.readyCbs.push(cb);
    if (errorCb) {
      this.readyErrorCbs.push(errorCb);
    }
  }
};

History.prototype.onError = function onError (errorCb) {
  this.errorCbs.push(errorCb);
};

History.prototype.transitionTo = function transitionTo (location, onComplete, onAbort) {
    var this$1 = this;

  var route = this.router.match(location, this.current);
  this.confirmTransition(route, function () {
    this$1.updateRoute(route);
    onComplete && onComplete(route);
    this$1.ensureURL();

    // fire ready cbs once
    if (!this$1.ready) {
      this$1.ready = true;
      this$1.readyCbs.forEach(function (cb) { cb(route); });
    }
  }, function (err) {
    if (onAbort) {
      onAbort(err);
    }
    if (err && !this$1.ready) {
      this$1.ready = true;
      this$1.readyErrorCbs.forEach(function (cb) { cb(err); });
    }
  });
};

History.prototype.confirmTransition = function confirmTransition (route, onComplete, onAbort) {
    var this$1 = this;

  var current = this.current;
  var abort = function (err) {
    if (isError(err)) {
      if (this$1.errorCbs.length) {
        this$1.errorCbs.forEach(function (cb) { cb(err); });
      } else {
        warn(false, 'uncaught error during route navigation:');
        console.error(err);
      }
    }
    onAbort && onAbort(err);
  };
  if (
    isSameRoute(route, current) &&
    // in the case the route map has been dynamically appended to
    route.matched.length === current.matched.length
  ) {
    this.ensureURL();
    return abort()
  }

  var ref = resolveQueue(this.current.matched, route.matched);
    var updated = ref.updated;
    var deactivated = ref.deactivated;
    var activated = ref.activated;

  var queue = [].concat(
    // in-component leave guards
    extractLeaveGuards(deactivated),
    // global before hooks
    this.router.beforeHooks,
    // in-component update hooks
    extractUpdateHooks(updated),
    // in-config enter guards
    activated.map(function (m) { return m.beforeEnter; }),
    // async components
    resolveAsyncComponents(activated)
  );

  this.pending = route;
  var iterator = function (hook, next) {
    if (this$1.pending !== route) {
      return abort()
    }
    try {
      hook(route, current, function (to) {
        if (to === false || isError(to)) {
          // next(false) -> abort navigation, ensure current URL
          this$1.ensureURL(true);
          abort(to);
        } else if (
          typeof to === 'string' ||
          (typeof to === 'object' && (
            typeof to.path === 'string' ||
            typeof to.name === 'string'
          ))
        ) {
          // next('/') or next({ path: '/' }) -> redirect
          abort();
          if (typeof to === 'object' && to.replace) {
            this$1.replace(to);
          } else {
            this$1.push(to);
          }
        } else {
          // confirm transition and pass on the value
          next(to);
        }
      });
    } catch (e) {
      abort(e);
    }
  };

  runQueue(queue, iterator, function () {
    var postEnterCbs = [];
    var isValid = function () { return this$1.current === route; };
    // wait until async components are resolved before
    // extracting in-component enter guards
    var enterGuards = extractEnterGuards(activated, postEnterCbs, isValid);
    var queue = enterGuards.concat(this$1.router.resolveHooks);
    runQueue(queue, iterator, function () {
      if (this$1.pending !== route) {
        return abort()
      }
      this$1.pending = null;
      onComplete(route);
      if (this$1.router.app) {
        this$1.router.app.$nextTick(function () {
          postEnterCbs.forEach(function (cb) { cb(); });
        });
      }
    });
  });
};

History.prototype.updateRoute = function updateRoute (route) {
  var prev = this.current;
  this.current = route;
  this.cb && this.cb(route);
  this.router.afterHooks.forEach(function (hook) {
    hook && hook(route, prev);
  });
};

function normalizeBase (base) {
  if (!base) {
    if (inBrowser) {
      // respect <base> tag
      var baseEl = document.querySelector('base');
      base = (baseEl && baseEl.getAttribute('href')) || '/';
      // strip full URL origin
      base = base.replace(/^https?:\/\/[^\/]+/, '');
    } else {
      base = '/';
    }
  }
  // make sure there's the starting slash
  if (base.charAt(0) !== '/') {
    base = '/' + base;
  }
  // remove trailing slash
  return base.replace(/\/$/, '')
}

function resolveQueue (
  current,
  next
) {
  var i;
  var max = Math.max(current.length, next.length);
  for (i = 0; i < max; i++) {
    if (current[i] !== next[i]) {
      break
    }
  }
  return {
    updated: next.slice(0, i),
    activated: next.slice(i),
    deactivated: current.slice(i)
  }
}

function extractGuards (
  records,
  name,
  bind,
  reverse
) {
  var guards = flatMapComponents(records, function (def, instance, match, key) {
    var guard = extractGuard(def, name);
    if (guard) {
      return Array.isArray(guard)
        ? guard.map(function (guard) { return bind(guard, instance, match, key); })
        : bind(guard, instance, match, key)
    }
  });
  return flatten(reverse ? guards.reverse() : guards)
}

function extractGuard (
  def,
  key
) {
  if (typeof def !== 'function') {
    // extend now so that global mixins are applied.
    def = _Vue.extend(def);
  }
  return def.options[key]
}

function extractLeaveGuards (deactivated) {
  return extractGuards(deactivated, 'beforeRouteLeave', bindGuard, true)
}

function extractUpdateHooks (updated) {
  return extractGuards(updated, 'beforeRouteUpdate', bindGuard)
}

function bindGuard (guard, instance) {
  if (instance) {
    return function boundRouteGuard () {
      return guard.apply(instance, arguments)
    }
  }
}

function extractEnterGuards (
  activated,
  cbs,
  isValid
) {
  return extractGuards(activated, 'beforeRouteEnter', function (guard, _, match, key) {
    return bindEnterGuard(guard, match, key, cbs, isValid)
  })
}

function bindEnterGuard (
  guard,
  match,
  key,
  cbs,
  isValid
) {
  return function routeEnterGuard (to, from, next) {
    return guard(to, from, function (cb) {
      next(cb);
      if (typeof cb === 'function') {
        cbs.push(function () {
          // #750
          // if a router-view is wrapped with an out-in transition,
          // the instance may not have been registered at this time.
          // we will need to poll for registration until current route
          // is no longer valid.
          poll(cb, match.instances, key, isValid);
        });
      }
    })
  }
}

function poll (
  cb, // somehow flow cannot infer this is a function
  instances,
  key,
  isValid
) {
  if (instances[key]) {
    cb(instances[key]);
  } else if (isValid()) {
    setTimeout(function () {
      poll(cb, instances, key, isValid);
    }, 16);
  }
}

/*  */


var HTML5History = (function (History$$1) {
  function HTML5History (router, base) {
    var this$1 = this;

    History$$1.call(this, router, base);

    var expectScroll = router.options.scrollBehavior;

    if (expectScroll) {
      setupScroll();
    }

    var initLocation = getLocation(this.base);
    window.addEventListener('popstate', function (e) {
      var current = this$1.current;

      // Avoiding first `popstate` event dispatched in some browsers but first
      // history route not updated since async guard at the same time.
      var location = getLocation(this$1.base);
      if (this$1.current === START && location === initLocation) {
        return
      }

      this$1.transitionTo(location, function (route) {
        if (expectScroll) {
          handleScroll(router, route, current, true);
        }
      });
    });
  }

  if ( History$$1 ) HTML5History.__proto__ = History$$1;
  HTML5History.prototype = Object.create( History$$1 && History$$1.prototype );
  HTML5History.prototype.constructor = HTML5History;

  HTML5History.prototype.go = function go (n) {
    window.history.go(n);
  };

  HTML5History.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceState(cleanPath(this$1.base + route.fullPath));
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HTML5History.prototype.ensureURL = function ensureURL (push) {
    if (getLocation(this.base) !== this.current.fullPath) {
      var current = cleanPath(this.base + this.current.fullPath);
      push ? pushState(current) : replaceState(current);
    }
  };

  HTML5History.prototype.getCurrentLocation = function getCurrentLocation () {
    return getLocation(this.base)
  };

  return HTML5History;
}(History));

function getLocation (base) {
  var path = window.location.pathname;
  if (base && path.indexOf(base) === 0) {
    path = path.slice(base.length);
  }
  return (path || '/') + window.location.search + window.location.hash
}

/*  */


var HashHistory = (function (History$$1) {
  function HashHistory (router, base, fallback) {
    History$$1.call(this, router, base);
    // check history fallback deeplinking
    if (fallback && checkFallback(this.base)) {
      return
    }
    ensureSlash();
  }

  if ( History$$1 ) HashHistory.__proto__ = History$$1;
  HashHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  HashHistory.prototype.constructor = HashHistory;

  // this is delayed until the app mounts
  // to avoid the hashchange listener being fired too early
  HashHistory.prototype.setupListeners = function setupListeners () {
    var this$1 = this;

    var router = this.router;
    var expectScroll = router.options.scrollBehavior;
    var supportsScroll = supportsPushState && expectScroll;

    if (supportsScroll) {
      setupScroll();
    }

    window.addEventListener(supportsPushState ? 'popstate' : 'hashchange', function () {
      var current = this$1.current;
      if (!ensureSlash()) {
        return
      }
      this$1.transitionTo(getHash(), function (route) {
        if (supportsScroll) {
          handleScroll(this$1.router, route, current, true);
        }
        if (!supportsPushState) {
          replaceHash(route.fullPath);
        }
      });
    });
  };

  HashHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      pushHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    var ref = this;
    var fromRoute = ref.current;
    this.transitionTo(location, function (route) {
      replaceHash(route.fullPath);
      handleScroll(this$1.router, route, fromRoute, false);
      onComplete && onComplete(route);
    }, onAbort);
  };

  HashHistory.prototype.go = function go (n) {
    window.history.go(n);
  };

  HashHistory.prototype.ensureURL = function ensureURL (push) {
    var current = this.current.fullPath;
    if (getHash() !== current) {
      push ? pushHash(current) : replaceHash(current);
    }
  };

  HashHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    return getHash()
  };

  return HashHistory;
}(History));

function checkFallback (base) {
  var location = getLocation(base);
  if (!/^\/#/.test(location)) {
    window.location.replace(
      cleanPath(base + '/#' + location)
    );
    return true
  }
}

function ensureSlash () {
  var path = getHash();
  if (path.charAt(0) === '/') {
    return true
  }
  replaceHash('/' + path);
  return false
}

function getHash () {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var index = href.indexOf('#');
  return index === -1 ? '' : href.slice(index + 1)
}

function getUrl (path) {
  var href = window.location.href;
  var i = href.indexOf('#');
  var base = i >= 0 ? href.slice(0, i) : href;
  return (base + "#" + path)
}

function pushHash (path) {
  if (supportsPushState) {
    pushState(getUrl(path));
  } else {
    window.location.hash = path;
  }
}

function replaceHash (path) {
  if (supportsPushState) {
    replaceState(getUrl(path));
  } else {
    window.location.replace(getUrl(path));
  }
}

/*  */


var AbstractHistory = (function (History$$1) {
  function AbstractHistory (router, base) {
    History$$1.call(this, router, base);
    this.stack = [];
    this.index = -1;
  }

  if ( History$$1 ) AbstractHistory.__proto__ = History$$1;
  AbstractHistory.prototype = Object.create( History$$1 && History$$1.prototype );
  AbstractHistory.prototype.constructor = AbstractHistory;

  AbstractHistory.prototype.push = function push (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index + 1).concat(route);
      this$1.index++;
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.replace = function replace (location, onComplete, onAbort) {
    var this$1 = this;

    this.transitionTo(location, function (route) {
      this$1.stack = this$1.stack.slice(0, this$1.index).concat(route);
      onComplete && onComplete(route);
    }, onAbort);
  };

  AbstractHistory.prototype.go = function go (n) {
    var this$1 = this;

    var targetIndex = this.index + n;
    if (targetIndex < 0 || targetIndex >= this.stack.length) {
      return
    }
    var route = this.stack[targetIndex];
    this.confirmTransition(route, function () {
      this$1.index = targetIndex;
      this$1.updateRoute(route);
    });
  };

  AbstractHistory.prototype.getCurrentLocation = function getCurrentLocation () {
    var current = this.stack[this.stack.length - 1];
    return current ? current.fullPath : '/'
  };

  AbstractHistory.prototype.ensureURL = function ensureURL () {
    // noop
  };

  return AbstractHistory;
}(History));

/*  */

var VueRouter = function VueRouter (options) {
  if ( options === void 0 ) options = {};

  this.app = null;
  this.apps = [];
  this.options = options;
  this.beforeHooks = [];
  this.resolveHooks = [];
  this.afterHooks = [];
  this.matcher = createMatcher(options.routes || [], this);

  var mode = options.mode || 'hash';
  this.fallback = mode === 'history' && !supportsPushState && options.fallback !== false;
  if (this.fallback) {
    mode = 'hash';
  }
  if (!inBrowser) {
    mode = 'abstract';
  }
  this.mode = mode;

  switch (mode) {
    case 'history':
      this.history = new HTML5History(this, options.base);
      break
    case 'hash':
      this.history = new HashHistory(this, options.base, this.fallback);
      break
    case 'abstract':
      this.history = new AbstractHistory(this, options.base);
      break
    default:
      if (false) {
        assert(false, ("invalid mode: " + mode));
      }
  }
};

var prototypeAccessors = { currentRoute: { configurable: true } };

VueRouter.prototype.match = function match (
  raw,
  current,
  redirectedFrom
) {
  return this.matcher.match(raw, current, redirectedFrom)
};

prototypeAccessors.currentRoute.get = function () {
  return this.history && this.history.current
};

VueRouter.prototype.init = function init (app /* Vue component instance */) {
    var this$1 = this;

  "production" !== 'production' && assert(
    install.installed,
    "not installed. Make sure to call `Vue.use(VueRouter)` " +
    "before creating root instance."
  );

  this.apps.push(app);

  // main app already initialized.
  if (this.app) {
    return
  }

  this.app = app;

  var history = this.history;

  if (history instanceof HTML5History) {
    history.transitionTo(history.getCurrentLocation());
  } else if (history instanceof HashHistory) {
    var setupHashListener = function () {
      history.setupListeners();
    };
    history.transitionTo(
      history.getCurrentLocation(),
      setupHashListener,
      setupHashListener
    );
  }

  history.listen(function (route) {
    this$1.apps.forEach(function (app) {
      app._route = route;
    });
  });
};

VueRouter.prototype.beforeEach = function beforeEach (fn) {
  return registerHook(this.beforeHooks, fn)
};

VueRouter.prototype.beforeResolve = function beforeResolve (fn) {
  return registerHook(this.resolveHooks, fn)
};

VueRouter.prototype.afterEach = function afterEach (fn) {
  return registerHook(this.afterHooks, fn)
};

VueRouter.prototype.onReady = function onReady (cb, errorCb) {
  this.history.onReady(cb, errorCb);
};

VueRouter.prototype.onError = function onError (errorCb) {
  this.history.onError(errorCb);
};

VueRouter.prototype.push = function push (location, onComplete, onAbort) {
  this.history.push(location, onComplete, onAbort);
};

VueRouter.prototype.replace = function replace (location, onComplete, onAbort) {
  this.history.replace(location, onComplete, onAbort);
};

VueRouter.prototype.go = function go (n) {
  this.history.go(n);
};

VueRouter.prototype.back = function back () {
  this.go(-1);
};

VueRouter.prototype.forward = function forward () {
  this.go(1);
};

VueRouter.prototype.getMatchedComponents = function getMatchedComponents (to) {
  var route = to
    ? to.matched
      ? to
      : this.resolve(to).route
    : this.currentRoute;
  if (!route) {
    return []
  }
  return [].concat.apply([], route.matched.map(function (m) {
    return Object.keys(m.components).map(function (key) {
      return m.components[key]
    })
  }))
};

VueRouter.prototype.resolve = function resolve (
  to,
  current,
  append
) {
  var location = normalizeLocation(
    to,
    current || this.history.current,
    append,
    this
  );
  var route = this.match(location, current);
  var fullPath = route.redirectedFrom || route.fullPath;
  var base = this.history.base;
  var href = createHref(base, fullPath, this.mode);
  return {
    location: location,
    route: route,
    href: href,
    // for backwards compat
    normalizedTo: location,
    resolved: route
  }
};

VueRouter.prototype.addRoutes = function addRoutes (routes) {
  this.matcher.addRoutes(routes);
  if (this.history.current !== START) {
    this.history.transitionTo(this.history.getCurrentLocation());
  }
};

Object.defineProperties( VueRouter.prototype, prototypeAccessors );

function registerHook (list, fn) {
  list.push(fn);
  return function () {
    var i = list.indexOf(fn);
    if (i > -1) { list.splice(i, 1); }
  }
}

function createHref (base, fullPath, mode) {
  var path = mode === 'hash' ? '#' + fullPath : fullPath;
  return base ? cleanPath(base + '/' + path) : path
}

VueRouter.install = install;
VueRouter.version = '2.8.1';

if (inBrowser && window.Vue) {
  window.Vue.use(VueRouter);
}

/* harmony default export */ __webpack_exports__["a"] = (VueRouter);


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(50),
  /* template */
  __webpack_require__(51),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Navigation from '@/components/Navigation'
/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {};
  },

  components: {
    // 'navigation': Navigation
  }
});

/***/ }),
/* 51 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      David J. Garrow\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("David J. Garrow is a Pulitzer Prize–winning historian who is presently professor of law and history and Distinguished Faculty Scholar at the University of Pittsburgh School of Law. Garrow, who earned his PhD from Duke University, is an acclaimed scholar of the United States’ black freedom struggle and reproductive rights movement, as well as of the US Supreme Court. His definitive biography of Martin Luther King Jr., "), _c('I', [_vm._v("Bearing the Cross: Martin Luther King, Jr., and the Southern Christian Leadership Conference")]), _vm._v(", was honored with the 1987 Pulitzer Prize for biography and the seventh-annual Robert F. Kennedy Book Award."), _c('BR'), _c('BR'), _vm._v(" Garrow’s other books are "), _c('I', [_vm._v("Protest at Selma: Martin Luther King, Jr., and the Voting Rights Act of 1965")]), _vm._v(", "), _c('I', [_vm._v("The FBI and Martin Luther King, Jr.: From “Solo” to Memphis")]), _vm._v(", and "), _c('I', [_vm._v("Liberty and Sexuality: The Right to Privacy and the Making of Roe v. Wade")]), _vm._v(". He also served as a senior adviser to "), _c('I', [_vm._v("Eyes on the Prize")]), _vm._v(", the award-winning PBS documentary series on the civil rights movement."), _c('BR')], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/12YW9uc/tc-custom/9781504015554.jpg?1702846312124",
      "alt": "This image is the cover for the book Liberty and Sexuality"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Liberty and Sexuality\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Pulitzer Prize–winning author David J. Garrow’s stirring and essential history of the politics of abortion and America’s battle for the right to choose")]), _c('br'), _c('br'), _vm._v(" In 1973, the Supreme Court handed down its landmark "), _c('i', [_vm._v("Roe v. Wade")]), _vm._v(" decision legalizing abortion, and more than forty years later the issue continues to spark controversy and divisiveness. But behind this historic legal case lie the battles women fought to establish their rights to use contraceptives and choose to have an abortion. "), _c('i', [_vm._v("Liberty and Sexuality")]), _vm._v(" traces these political and legal struggles in the decades leading up to "), _c('i', [_vm._v("Roe v. Wade")]), _vm._v("—including the momentous 1965 Supreme Court ruling in "), _c('i', [_vm._v("Griswold v. Connecticut")]), _vm._v(" that established a constitutional “right to privacy.” Garrow personalizes the struggles by detailing the vital contributions made by dozens of crusaders who tirelessly paved the way."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" This expansive and substantial work also addresses the threats to sexual privacy and the legality of abortion that have risen since "), _c('i', [_vm._v("Roe v. Wade")]), _vm._v(". With abortion still a contentious subject on the national political landscape, "), _c('i', [_vm._v("Liberty and Sexuality")]), _vm._v(" is not just a historical account of the right to choose, but an indispensable read about preserving a freedom that continues to divide America."), _c('br')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Integrated Media\n   ")])])
}]}

/***/ }),
/* 52 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(54),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 54 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(56),
  /* template */
  __webpack_require__(57),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 57 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(59),
  /* template */
  __webpack_require__(60),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 60 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(62),
  /* template */
  __webpack_require__(63),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 63 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [
    [_c('div', {
      staticClass: "chapter"
    }, [_c('div', {
      staticClass: "inner_page"
    }, [
      [_vm._m(0)]
    ], 2)])]
  ], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(65),
  /* template */
  __webpack_require__(66),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 66 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc-title"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_vm._v("CONTENTS")])])]), _c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _c('p', {
    staticClass: "toc-entry"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }, [_c('span')]), _c('a', {
    attrs: {
      "href": "#/xhtml/frontmatter01"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter001"
    }
  }, [_vm._v("1.  The Waterbury Origins of "), _c('i', [_vm._v("Roe")]), _vm._v(" v. "), _c('i', [_vm._v("Wade")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter002"
    }
  }, [_vm._v("2.  No Further Service: Connecticut’s Struggle for the Legalization of Birth Control, 1940–1953")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('span', [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter003"
    }
  }, [_vm._v("3.  One Vote Shy: Estelle Griswold, Fowler Harper, and the U.S. Supreme Court, 1954–1961")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.  Creating the Right to Privacy: Estelle Griswold and the U.S. Supreme Court, 1961–1965")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.  Lonely Voices: Abortion Reformers and the Origins of Change, 1933–1967")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.  From Reform to Repeal: The "), _c('i', [_vm._v("Right")]), _vm._v(" to Abortion, 1967–1969")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.  Into the Courts: "), _c('i', [_vm._v("Roe, Doe")]), _vm._v(", and the Right to Abortion, 1969–1971")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.  The Right to Abortion and the U.S. Supreme Court, 1971–1973")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entrya"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.  Liberty and Sexuality Since "), _c('i', [_vm._v("Roe")]), _vm._v(" v. "), _c('i', [_vm._v("Wade")])])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/endmatter01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Epilogue")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/endmatter02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afterword")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/endmatter03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/endmatter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgments (1998)")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Notes")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/index",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Index")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-entry"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/xhtml/endmatter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])])
}]}

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(68),
  /* template */
  __webpack_require__(69),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 69 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chapter-h1"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_vm._v("PREFACE TO THE 1998 EDITION")])])]), _c('a', {
    attrs: {
      "id": "page_ix"
    }
  }, [_c('p', {
    staticClass: "normal"
  }, [_vm._v("This big book tells three sequential stories. First, it relates how the forty-year struggle to overturn Connecticut’s criminalization of even married couples’ "), _c('i', [_vm._v("use")]), _vm._v(" of contraceptives finally triumphed in the landmark 1965 Supreme Court right-to-privacy ruling in "), _c('i', [_vm._v("Griswold")]), _vm._v(" v. "), _c('i', [_vm._v("Connecticut")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Second, "), _c('i', [_vm._v("Liberty and Sexuality")]), _vm._v(" details how that recognition of a fundamental right to privacy in "), _c('i', [_vm._v("Griswold")]), _vm._v(" opened the constitutional door to a previously unimagined argument: that women with unwanted pregnancies ought to have access to legal abortion as a fundamental right. The earliest abortion law reformers had sought liberalization of the strictures that had outlawed—but not actually prevented—almost all abortions since the middle of the nineteenth century, but between 1966 and 1969 that goal of reform was quickly supplanted by repeal: state antiabortion laws could be challenged in federal court as infringements of women’s newly recognized constitutional right to privacy. Out of that litigation campaign—a quest that got under way late in 1969 and triumphed in January 1973—came both "), _c('i', [_vm._v("Roe")]), _vm._v(" v. "), _c('i', [_vm._v("Wade")]), _vm._v(" and its lesser-known but equally important companion case, "), _c('i', [_vm._v("Doe")]), _vm._v(" v. "), _c('i', [_vm._v("Bolton")]), _vm._v(". The second part of "), _c('i', [_vm._v("Liberty and Sexuality")]), _vm._v("—chapters five through eight—tells the story of the early activists and young lawyers who created those cases and the Supreme Court justices who in 1972–1973 accepted their constitutional claims.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Third, "), _c('i', [_vm._v("Liberty and Sexuality")]), _vm._v(" describes the twenty-five years of abortion litigation and congressional debates that have transpired since "), _c('i', [_vm._v("Roe")]), _vm._v(" and "), _c('i', [_vm._v("Doe")]), _vm._v(". The first portion of that aftermath culminated in part in the huge setback that sexual liberty claims suffered in 1986 with the explicitly antigay Supreme Court decision in "), _c('i', [_vm._v("Bowers")]), _vm._v(" v. "), _c('i', [_vm._v("Hardwick")]), _vm._v(". Far more encouragingly, repeated threats to "), _c('i', [_vm._v("Roe")]), _vm._v("’s protection of abortion rights, threats that in 1989–1991 looked likely to prove fatal, surprisingly climaxed instead in the landmark 1992 Supreme Court ruling in "), _c('i', [_vm._v("Planned Parenthood of Southeastern Pennsylvania")]), _vm._v(" v. "), _c('i', [_vm._v("Casey")]), _vm._v(" which powerfully reaffirmed "), _c('i', [_vm._v("Roe")]), _vm._v("’s constitutional core.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_vm._v("The second portion of the post-"), _c('i', [_vm._v("Roe")]), _vm._v(" story, the many developments that have occurred since 1993, is newly added to this edition of "), _c('i', [_vm._v("Liberty and Sexuality")]), _vm._v(". The year 1994 witnessed two double homicides of abortion workers by right-to-life terrorists, but it also witnessed passage of a comprehensive federal statute, the Freedom of Access to Clinic Entrances Act (FACE), which quickly put an end to the violently obstructive mass protests that had besieged so many abortion clinics during the late 1980s and early 1990s.")])]), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Antiabortion protests were well past their peak by the time of "), _c('i', [_vm._v("Roe")]), _vm._v(" and "), _c('i', [_vm._v("Doe")]), _vm._v("’s twenty-fifth anniversaries in January 1998. However, in one of the two most important developments of the post-"), _c('i', [_vm._v("Casey")]), _vm._v(" years, abortion opponents garnered significant political success by making “partial birth” abortions the subject of debate in legislatures all across the country. Courts constrained antiabortion legislation less comprehensively than they limited antiabortion protests, but the Supreme Court, in a crucial post-"), _c('i', [_vm._v("Casey")]), _vm._v(" milestone, gave gay Americans their greatest legal victory ever in a 1996 ruling, "), _c('i', [_vm._v("Romer")]), _vm._v(" v. "), _c('i', [_vm._v("Evans")]), _vm._v(", that left "), _c('i', [_vm._v("Bowers")]), _vm._v(" in symbolic shreds.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('i', [_vm._v("Roe")]), _vm._v(" v. "), _c('i', [_vm._v("Wade")]), _vm._v("’s creation and "), _c('i', [_vm._v("Roe")]), _vm._v(" v. "), _c('i', [_vm._v("Wade")]), _vm._v("’s legacy represent one of the two greatest stories—the other is "), _c('i', [_vm._v("Brown")]), _vm._v(" v. "), _c('i', [_vm._v("Board of Education")]), _vm._v("—in twentieth-century American legal history. "), _c('i', [_vm._v("Liberty and Sexuality")]), _vm._v(" seeks to tell that story as comprehensively as possible, for it—like "), _c('i', [_vm._v("Brown")]), _vm._v("—has altered and improved the lives of millions of Americans.")])])])])
}]}

/***/ }),
/* 70 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(71),
  /* template */
  __webpack_require__(72),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 72 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("CHAPTER ONE")])])]), _c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_c('p', {
    staticClass: "chap-title-1"
  }, [_c('span', [_vm._v("The Waterbury Origins of "), _c('i', [_vm._v("Roe")]), _vm._v(" v. "), _c('i', [_vm._v("Wade")])])])]), _c('p', {
    staticClass: "normal"
  }, [_c('a', {
    attrs: {
      "id": "page_1"
    }
  }, [_vm._v("Katharine Houghton Hepburn had never doubted that Sallie Pease was an ideal president for the Connecticut Birth Control League (CBCL). Hepburn’s next-door neighbor in Hartford since 1927, a Smith College graduate, and the mother of three school-age boys, Pease was only thirty-seven—nineteen years Hepburn’s junior—when she became league president in 1934. For eleven years, since 1923, when nationally noted birth control crusader Margaret Sanger had first visited Hartford, Kit Hepburn had played a central role in holding the league together. Little headway had been made toward the league’s goal of winning legislative repeal of Connecticut’s unique 1879 criminal statute that made the use and/or prescription of any form of birth control a crime for both woman and doctor alike, but in the summer of 1935 Sallie Pease had taken the lead in the league’s dramatic but initially unpublicized decision to go ahead and simply "), _c('i', [_vm._v("open")]), _vm._v(" a public birth control clinic in Hartford. Just as the league had hoped, no one moved to enforce the law or to close the clinic, and in its first year of operation the clinic’s women doctors provided birth control counseling and devices to over four hundred married women, many of them first- or second-generation ethnic immigrants from Hartford’s poorer neighborhoods."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-1",
      "id": "ch01-01-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")]), _vm._v(" Quietly ecstatic at their success in extending to poor women the same medical advice that privately was available to those who could afford family physicians, by the summer of 1936 the Connecticut League also had clinics functioning in Greenwich, New Haven, and Stamford. The following two years witnessed similar growth and expansion, as clinic services opened in Norwalk, Danbury, New Britain, New London, and Bridgeport."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-2",
      "id": "ch01-02-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" The Bridgeport city prosecutor expressly told inquiring reporters that the 1879 statute represented no bar to the services that the Bridgeport clinic was providing,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-3",
      "id": "ch01-03-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" and six months later, in October of 1938, the league achieved its hope "), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("of having clinic services available in all of Connecticut’s large cities when a one-morning-a-week clinic quietly opened in downtown Waterbury, Connecticut’s most ethnically diverse—and most heavily Roman Catholic—city.")])]), _c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Sallie Pease and Kit Hepburn were rightfully proud of the tremendous progress that had been attained by simply going ahead and opening clinics, rather than by unsuccessfully continuing to petition each biennial session of the Connecticut legislature for a statutory change, as the league had from 1923 through 1935. Neither public officials nor religious groups seemed actively interested in mounting any effort to enforce a now seemingly dead-letter law, and the Connecticut League would be able to continue moving forward with its real purpose of providing actual services to more and more needy women who wanted to limit the number of their children.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_2"
    }
  }, [_vm._v("So when the Connecticut League convened for its annual luncheon meeting at the Farmington Country Club on Thursday, June 8, 1939, Sallie Pease had no hesitancy in speaking plainly about their new successes. The general director of the national Birth Control Federation of America (BCFA)—the newly renamed organization that was the direct descendant of Margaret Sanger’s initial work two decades earlier—Dr. Woodbridge E. Morris, had himself come up to central Connecticut for the luncheon, and while Hartford reporters took notes on Morris’s remarks about the regrettable level of maternal mortality in America, they also listened to Sallie Pease’s presidential report, in which she highlighted the opening of the Waterbury clinic as the league’s most prominent achievement in the preceding year. What was especially notable, she stressed, was that the Waterbury clinic, unlike any of its other Connecticut predecessors, was operating “in a public institution,” in the Chase Dispensary outpatient building of the Waterbury Hospital. So far, Pease said, it has “received no publicity, but it is there in working order and will grow.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-4",
      "id": "ch01-04-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sallie Pease was a brash and flashy person, quite different in style and persona from the Greenwich and Fairfield County women who comprised much of the Connecticut League, and she hadn’t given any thought to the possible press coverage of her luncheon remarks."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-5",
      "id": "ch01-05-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" Friday morning’s "), _c('i', [_vm._v("Hartford Courant")]), _vm._v(" ran a modest story on page twenty-four, noting in passing the newly announced Waterbury clinic in the Chase Dispensary, but the Associated Press put the "), _c('i', [_vm._v("Courant")]), _vm._v(" story on the state news wire, and Friday morning’s "), _c('i', [_vm._v("Waterbury Republican")]), _vm._v(" printed it on page fifteen, under a headline reading “U.S. Maternal Mortality Rate Reported Poor.” Several paragraphs down, however, it stated how "), _c('a', {
    attrs: {
      "id": "page_3"
    }
  }, [_vm._v("Pease had reported “that during the year the first clinic in a public institution in Connecticut was opened at the Chase Dispensary in Waterbury.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-6",
      "id": "ch01-06-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The "), _c('i', [_vm._v("Waterbury Republican")]), _vm._v(", and its sister paper, the afternoon "), _c('i', [_vm._v("Waterbury American")]), _vm._v(", were not the city’s only newspapers, however. There was also the afternoon "), _c('i', [_vm._v("Waterbury Democrat")]), _vm._v(", which in many ways—as its name indicated—was the antithesis of the "), _c('i', [_vm._v("Republican. Republican-American")]), _vm._v(" publisher William J. Pape had been an outspoken and crusading opponent of the city’s mostly corrupt Democratic political establishment, and it was in large part because of the "), _c('i', [_vm._v("Republican")]), _vm._v("’s efforts that Waterbury Mayor—and Connecticut Lieutenant Governor—T. Frank Hayes and over twenty fellow defendants were currently on trial for looting the city treasury. The "), _c('i', [_vm._v("Democrat")]), _vm._v(" had spoken up for the Hayes regime, and if the Pape papers were a voice for the Anglo-Saxon Yankee population that found its political home in the Republican party, the "), _c('i', [_vm._v("Democrat")]), _vm._v(" was viewed as the voice for Waterbury’s Irish, Italian, French-Canadian, and Lithuanian immigrant populations. Some 72,000 of Waterbury’s 99,000 citizens were either first- or second-generation immigrants to America, and while the ethnic parishes where most of them attended church might differ greatly in custom and in language, they were almost all Roman Catholic."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-7",
      "id": "ch01-07-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Friday afternoon’s "), _c('i', [_vm._v("Waterbury Democrat")]), _vm._v(" featured a front-page headline, “Birth Control Clinic Is Operating In City,” and quoted Chase Dispensary supervisor Jeannie Heppel as confirming Sallie Pease’s unintentional announcement. “Pastors of Catholic churches had no comment to make today,” the "), _c('i', [_vm._v("Democrat")]), _vm._v(" went on, but the paper hardly had to tell its readers that Connecticut’s Catholic hierarchy, the Diocese of Hartford, was a staunch and unyielding opponent of birth control. Church representatives had turned out at every legislative session from 1923 to 1935 to oppose the CBCL’s petitions for statutory change, and just four weeks earlier the Reverend John S. Kennedy, associate editor of the diocese’s weekly newspaper, the "), _c('i', [_vm._v("Catholic Transcript")]), _vm._v(", had been prominently quoted in the "), _c('i', [_vm._v("Democrat")]), _vm._v(" as telling three hundred Waterbury Catholics at a special Mother’s Day Communion breakfast that he was puzzled as to why some Connecticut prosecutors were “so anxious” to go after bingo game operators “while birth control clinics were allowed to flourish.” One Hartford woman who had received a birth control circular, Kennedy said, had contacted the "), _c('i', [_vm._v("Transcript")]), _vm._v(" to complain. Kennedy’s remarks, the "), _c('i', [_vm._v("Democrat")]), _vm._v(" volunteered, had been “most inspirational.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-8",
      "id": "ch01-08-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Different readers reacted to the "), _c('i', [_vm._v("Democrat")]), _vm._v("’s story in different ways. "), _c('a', {
    attrs: {
      "id": "page_4"
    }
  }, [_vm._v("Waterbury Hospital superintendent Dr. B. Henry Mason and gynecology clinic chief Dr. Charles L. Larkin both told reporters that no “birth control clinic” was operating at the Chase Dispensary, and Saturday’s "), _c('i', [_vm._v("Republican")]), _vm._v(" prominently headlined their claim—“Doctors Deny Birth Control Clinic in City”—despite Heppel’s statements to the contrary. The problem, Dr. Mason explained, was simply a matter of terminology. A gynecological clinic, the "), _c('i', [_vm._v("Republican")]), _vm._v(" said, “includes in the normal course of its work the giving of some information on birth control.” But such advice, Mason said, “is provided purely on a health basis. A woman whose health would be seriously endangered by child bearing might get medical advice at the clinic on birth control, but not robust, healthy women.” Dr. Larkin agreed: “That’s a long way from the popular conception of a birth control clinic where any woman may go who doesn’t want to have children.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-9",
      "id": "ch01-09-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By Saturday morning the hospital staffers finally had their stories straight, as that afternoon’s "), _c('i', [_vm._v("American")]), _vm._v(" emphasized: “Miss Heppel Agrees With Dr. Mason: Waterbury Has No Birth Control Clinic.” But Heppel’s actual statement, much like Mason’s and Larkin’s, did not exactly square with the headline: “Nobody can come here for information unless they are referred by doctors for reasons of their health,” supervisor Heppel explained. “People can’t just come in as they please and get information.” Clinic sessions were held each Tuesday, the "), _c('i', [_vm._v("American")]), _vm._v(" added, had begun last October, and were actually conducted by two young doctors, William A. Goodrich and Roger B. Nelson, who reported to Larkin."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-10",
      "id": "ch01-010-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But the hospital officials were not the most significant readers of the Waterbury press. Friday’s "), _c('i', [_vm._v("Democrat")]), _vm._v(" had observed that the city’s Catholic clergy “might” refer the matter to Hartford Bishop Maurice F. McAuliffe, but Father Eugene P. Cryne, president of the Catholic Clergy Association of Waterbury, already had called a special meeting of the association for Saturday morning in the rectory of Immaculate Conception parish, Waterbury’s oldest Roman Catholic church. Cryne was not the most prominent or the most senior of Waterbury’s Catholic clergy, but Immaculate’s own pastor had been formally installed only one year earlier, and Monsignor Joseph Valdambrini, pastor of Our Lady of Lourdes parish and the son of a Vatican banker with a royal title, was out of town on a four-month visit to Italy. A fifty-six-year-old Connecticut native, Cryne, like many Connecticut priests, had received his religious training at St. Thomas Seminary. He had become pastor of St. Patrick’s Church, one of Waterbury’s more modest parishes, but with seventeen hundred members, mostly of Irish "), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("background, in 1933, after having previously served in a junior role at Immaculate and then in parishes just outside of Waterbury."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-11",
      "id": "ch01-011-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eugene Cryne was, however, in the eyes of his fellow priests, “a very forceful individual” who had a very definite sense of right and wrong. “When rules and regulations were made, they had to be abided by,” a younger priest who served under Cryne explained. Although a “very kind” man, Eugene Cryne was “a very determined person.” And the resolution that was drawn up at that special Saturday morning meeting of Waterbury’s Catholic clergy at the Immaculate rectory was a very determined and very forceful resolution:")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_vm._v("Whereas, it is the teaching of the Catholic church that birth control is contrary to the natural law and therefore immoral, and")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent1"
  }, [_vm._v("Whereas, it is forbidden by statute law to disseminate birth control information for any reason whatsoever or in any circumstance, and")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent1"
  }, [_vm._v("Whereas, it has been brought to our attention that a so-called birth control clinic, sometimes called a maternal health center, is existing in Waterbury as admitted by the superintendent of Chase Dispensary, according to the papers, therefore, be it")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent1"
  }, [_vm._v("Resolved, that this association go on record as being unalterably opposed to the existence of such a clinic in our city and we hereby urge our Catholic people to avoid contact with it and we hereby publicly call the attention of the public prosecutors to its existence and demand that they investigate and if necessary prosecute to the full extent of the law."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-12",
      "id": "ch01-012-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("William B. Fitzgerald, the State’s Attorney in Waterbury, had like Father Cryne seen the stories in the Friday and Saturday Waterbury newspapers. And while news of the Catholic Clergy resolution did not appear in the Sunday "), _c('i', [_vm._v("Republican")]), _vm._v(", Bill Fitzgerald certainly heard of it Sunday morning at the latest, for he faithfully attended St. Margaret’s Roman Catholic Church, and that morning—as Bill Fitzgerald remembered even decades later—the text of the clergy’s resolution was read from the pulpit of each and every Catholic church in Waterbury and in surrounding towns."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-13",
      "id": "ch01-013-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bill Fitzgerald had been State’s Attorney for only one year. Thirty-seven years old, a Waterbury native, and an alumnus of Holy Cross College, Fitzgerald had opened a Waterbury law office immediately after graduating from Harvard Law School and passing the bar in 1926. Two years later he became a prosecutor in the city’s misdemeanor court, and in 1931 he became assistant state’s attorney, both part-time positions that supplemented an attorney’s private law practice. In May 1938, however, the special grand jury that had been impaneled to "), _c('a', {
    attrs: {
      "id": "page_6"
    }
  }, [_vm._v("investigate Mayor Hayes and the city’s financial scandals issued a detailed, seventy-four-page report to accompany its charges, and included in it was a brief but harsh condemnation of Fitzgerald’s boss, State’s Attorney Lawrence L. Lewis, for failing until very recently to take any action against the presence of gambling devices in Waterbury social clubs. “The fact that these violations of the law were known but not prosecuted by State’s Attorney Lewis,” and others, “is a matter of distinct concern to this Grand Jury. The law enforcement authorities of the city and of the district are, therefore, deserving of the severest censure for having permitted this widespread and flagrant violation of law to continue.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-14",
      "id": "ch01-014-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Larry Lewis felt he had no choice but to resign and return to full-time private practice in his firm of Bronson, Lewis & Bronson, but Bill Fitzgerald rebuffed Lewis’s notion that Fitzgerald too had to step down, indicating instead that he’d like to be Lewis’s successor. That choice lay with Waterbury’s local judges, particularly resident Superior Court Judge Frank P. McEvoy, the first Roman Catholic member of Connecticut’s premier trial court bench, and on June 6, 1938, Bill Fitzgerald received their official blessing and became the first Roman Catholic State’s Attorney at Waterbury. Fitzgerald voiced high praise of Larry Lewis at his swearing in, but moved swiftly to eliminate gambling from the city, with widespread raids receiving coverage even in the "), _c('i', [_vm._v("New York Times")]), _vm._v("."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-15",
      "id": "ch01-015-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bill Fitzgerald “had a first class mind,” one lifelong attorney friend and courtroom adversary later remembered, but he was “a very, very strict Catholic.” Another attorney friend, also once a communicant at St. Margaret’s, agreed that Fitzgerald was “very bright,” but was nonetheless “a very parochial, insular guy,” someone “very strongly receptive to and influenced by the clergy.” Bill Fitzgerald was active in a number of civic and church groups, and, like Judge McEvoy, served on the advisory board of Waterbury’s Diocesan Bureau of Social Service, which was directed by Father Eugene Cryne. But most people who knew Bill Fitzgerald felt that the pressure to act came largely from within, rather than from without, that even in the absence of a phone call, Bill Fitzgerald believed there was only one thing to do. After all, just one year earlier his predecessor had had to resign because of public complaints that he had failed to enforce the often-ignored but nonetheless still-valid gambling laws aggressively, and the old 1879 prohibition against birth control was certainly still on the statute books. Yes, Bill Fitzgerald was a “devout” Catholic, but “I don’t think Fitzgerald was any crusader at all,” his one-time fellow member of St. "), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("Margaret’s emphasized. As almost everyone saw it, the state’s attorney simply felt he had to do his duty. Eight days later Fitzgerald would indicate that he had been “acting upon complaints” in the wake of the newspaper stories, but probably as early as Saturday morning Bill Fitzgerald had decided that an active investigation of the Chase Dispensary clinic would have to be mounted."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-16",
      "id": "ch01-016-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Monday morning’s "), _c('i', [_vm._v("Republican")]), _vm._v(" headlined the Catholic Clergy Association’s resolution, but devoted more attention to the continuing claims that the clinic was not what its critics said it was. Like Doctors Mason and Larkin, Dr. William A. Goodrich was portrayed as minimizing the clinic’s work: “Out of 250 women who come to the clinic yearly, he said, an average of perhaps 15 come for birth control advice. They get the same advice, he said, that women who can afford personal physicians get from their own physicians.” More pointedly, the "), _c('i', [_vm._v("Republican")]), _vm._v(" also highlighted a conversation the newspaper had had with a Hartford attorney who had represented the original CBCL clinic there. He asserted “that there is apparently no state statute under which a birth control clinic can be prosecuted as long as the clinic is operated on a health basis,” the "), _c('i', [_vm._v("Republican")]), _vm._v(" said. “The lawyer pointed out that prohibiting the giving of birth control information to women for health reasons would run counter to the public health laws of the state. The Hartford authorities were asked to prosecute, he said, by the Hartford Catholic clergy, and decided at the time that there was no basis for prosecution.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-17",
      "id": "ch01-017-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But the "), _c('i', [_vm._v("Republican")]), _vm._v("’s effort was in vain. Early Monday morning William Fitzgerald took a search warrant application to the chambers of Judge McEvoy. Fitzgerald’s request stated “That he is informed and that he suspects and has reason to suspect that books, records, registers, instruments, apparatus and appliances used and kept for the purpose of violating the criminal laws,” specifically Sections 6246 and 6562, “are kept, deposited, stored and used in” the Chase Dispensary at 43 Field Street."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-18",
      "id": "ch01-018-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Birth control was not a new subject to Frank P. McEvoy. A sixty-year-old Waterbury native, an active member of Blessed Sacrament Roman Catholic Church, and, like Bill Fitzgerald, a member of the advisory board of Father Cryne’s Diocesan Bureau of Social Service, Frank McEvoy had attended a small Roman Catholic college in New York, graduated from Yale Law School in 1907, and practiced law in Waterbury until being named a superior court judge in 1930. Friends thought of him as “soft spoken” and knew he was an “ardent horseman,” but Waterbury attorneys considered him “narrow and reluctant "), _c('a', {
    attrs: {
      "id": "page_8"
    }
  }, [_vm._v("to accept change.” A much younger fellow Catholic attorney remembered McEvoy as “wildly Irish Catholic” and “very parochial.” Perhaps most notably, seven years earlier his wife had played the leading role in blocking any endorsement of birth control by the state convention of the Connecticut League of Women Voters. As the "), _c('i', [_vm._v("Republican")]), _vm._v(" had described it, Mrs. McEvoy “opposed it violently and threatened that she and all Catholic women would resign if it were adopted. Largely because of this, the proposal … was voted down,” and Mrs. McEvoy had received nationwide praise from some Catholic spokesmen for her activism on the issue."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-19",
      "id": "ch01-019-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Frank McEvoy immediately granted the warrant application that Bill Fitzgerald put in front of him: “I find probable cause exists for said complaint.” Minutes later, a little before 10 a.m., Deputy Sheriff Al Francis and County Detective Koland G. Alling took the warrant and went the three short blocks that separated the Chase Dispensary from the state’s attorney’s office in the courthouse. Dispensary supervisor Jeannie Heppel had left on Saturday on vacation, but her assistant, Berta Verba, showed the two lawmen to the second floor rooms at the northwest corner of the building that the birth control clinic used. As the clinic operated only on Tuesday mornings, no one else was present, but as the "), _c('i', [_vm._v("Waterbury Democrat")]), _vm._v(" described it, the two officers “confiscated several bags and boxes of articles and returned with them to the courthouse.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bill Fitzgerald declined comment to inquiring reporters and sat down with his assistant, Walter Smyth, and Detective Alling to review the seized materials. They prepared a show-cause order, signed later that day by Judge McEvoy, directing Waterbury Hospital superintendent B. Henry Mason to appear in court the following Monday to explain why the diaphragms and other contraceptive articles that had been seized should not be condemned and destroyed. But much more importantly, Bill Fitzgerald noted two other things as he examined what Alling and Francis had seized. First, all of the patient records, the clinical cards that would identify who had been seen and for what reasons, were not at the dispensary, but were in the possession of a young Junior League volunteer, Virginia Goss, who maintained the clinic’s records and was married to a prominent young executive at Waterbury’s most famous manufacturing firm, Scovill Brass. And then, second, Bill Fitzgerald also learned that the founder and moving force behind the Waterbury Maternal Health Center was not one or another of the doctors from Waterbury Hospital, but instead was his next-door neighbor and family friend, Clara Lee McTernan."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-20",
      "id": "ch01-020-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal1"
  }, [_c('a', {
    attrs: {
      "id": "page_9"
    }
  }, [_vm._v("Kit Hepburn and her children would always remember the phone call that had interrupted her daughter Marion Hepburn Grant’s wedding that Monday in the garden of the Hepburn family home at 201 Bloomfield Avenue in Hartford. But then it was utterly natural for Clara McTernan to call Kit Hepburn, for not only had Hepburn come to Waterbury to spur creation of the clinic, she had been making political waves across Connecticut years before Margaret Sanger had ever thought up the phrase “birth control.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-21",
      "id": "ch01-021-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Katharine Houghton Hepburn was a twenty-six-year-old newlywed when she and her husband, Dr. Thomas N. Hepburn, first moved to Hartford in 1904. Orphaned as a teenager when her father committed suicide and her mother died of cancer, Katharine Houghton graduated from Bryn Mawr in 1899, earned a master’s degree there the following year, and met Tom Hepburn, a medical student at Johns Hopkins, through her sister Edith, who was also in medical school. Thomas Hepburn’s internship and residency took place at Hartford Hospital, and in 1905 their first son was born, followed two years later by their first daughter, Katharine’s namesake, who later would win a 1934 Academy Award and Hollywood fame.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The following year Kit Hepburn, perhaps at the urging of her sister Edith, attended a speech at Hartford’s Parsons Theatre by English suffragist Emmeline Pankhurst and adopted women’s right to vote as her cause too. The Connecticut Women’s Suffrage Association (CWSA) had been founded back in 1869, but now was slightly moribund. Kit Hepburn’s urge to activism was initially hindered by a tremendous fear of attempting to speak in public, but she soon overcame it, and along with her friend and neighbor Josephine Day Bennett she helped create the Hartford Equal Franchise League. In 1910 Hepburn and Jo Bennett expanded their efforts into the CWSA itself, with Kit Hepburn becoming president for 1910–1911 and again in 1913. Kit Hepburn was also busy having additional children—two more boys in 1911 and 1913, and two more girls in 1916 and 1918—and Dr. Tom Hepburn was channeling much of his energy into antivenereal disease work. He played a significant role in the 1913 founding of the American Social Hygiene Association, and a very central role in its affiliate, the Connecticut Social Hygiene Association. One of Kit’s older colleagues in CWSA work, Annie Webb Porritt, an immigrant from England, was also very active in the antivenereal disease efforts, as was Jo Bennett’s father, George H. Day. Jo’s mother, Katharine Beach Day, was a major source of funds for her daughter and Kit Hepburn’s female suffrage endeavors."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-22",
      "id": "ch01-022-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_10"
    }
  }, [_vm._v("By 1917 Kit Hepburn was testifying before the Connecticut legislature’s Judiciary Committee on behalf of the CWSA and appearing with Montana Congresswoman and suffragist Jeanette Rankin at a Parsons Theatre rally. But in the fall of that year, in the wake of Alice Paul and other national activists’ departure from Carrie Chapman Catt’s National American Woman Suffrage Association (NAWSA) to form the National Woman’s Party (NWP), Kit Hepburn resigned the presidency of the 35,000 member CWSA and along with Jo Bennett and her other colleagues began directing most of her energies into the NWP. Both groups championed congressional approval of a federal constitutional amendment that would give American women the right to vote, but Hepburn and others felt that the NWP was the more active force. In January 1919, the House of Representatives approved a woman’s suffrage amendment, and in June the Senate followed suit. Fourteen months later, in August 1920, Tennessee became the crucial thirty-sixth state to ratify the Nineteenth Amendment, and female suffrage had been won. Several weeks later the Connecticut legislature added its assent."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-23",
      "id": "ch01-023-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The suffrage victory allowed the Connecticut activists to direct their energies toward other issues. Annie Porritt, already an elected member of the Hartford Board of Education, helped set up the League of Women Voters as a direct successor to NAWSA, continued her work with Dr. Hepburn in the Social Hygiene Association, and became active in the Joint Committee on Delinquent Women."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-24",
      "id": "ch01-024-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" But another issue that both Mrs. Porritt and Katharine Beach Day began to take an interest in by the fall of 1921 was birth control.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Margaret Sanger’s first enthusiastic follower in the state of Connecticut was a male attorney from Hazardville, a small village in the north-central part of the state, Henry F. Fletcher. Single-handedly, Fletcher four years earlier, in January 1917, had prevailed upon his local representative in Connecticut’s lower house to introduce, “by request,” a bill repealing the 1879 antibirth control statute. How Fletcher’s interest first occurred is unknown, but by the fall of 1916 most readers of the American press knew full well who Margaret Sanger was. Then thirty-seven years old, Sanger had first begun championing a woman’s right to control her own fertility in the summer of 1914 in her self-published monthly magazine "), _c('i', [_vm._v("The Woman Rebel")]), _vm._v(". Heavily influenced by her own and her husband William’s political roots in socialist politics, and particularly by the perspective of Emma Goldman, Margaret quite purposefully hoped that her in-print advocacy of birth control would launch a direct challenge against the "), _c('a', {
    attrs: {
      "id": "page_11"
    }
  }, [_vm._v("enforcement of the 1873 federal antiobscenity and anticontraception statutes that most everyone spoke of as the “Comstock Laws,” after their still very active principal proponent, New York moralist Anthony Comstock."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-25",
      "id": "ch01-025-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sanger’s hope of generating a federal case in which to take on those prohibitions against the interstate shipment or importation of any goods, articles or literature dealing with sexuality or reproduction quickly came to pass: in August 1914 the U.S. Attorney’s office in New York charged her with four counts of violating the Comstock statutes. Rather than prepare a defense, Sanger sat down and wrote a sixteen-page statement of her views, arranged for the printing of a hundred thousand copies of it under the title "), _c('i', [_vm._v("Family Limitation")]), _vm._v(", obtained false identity documents, and fled to England rather than stand trial. The ensuing twelve months in Europe constituted perhaps the most intellectually important period in Sanger’s long life, but her flight from prosecution did relatively little if any harm to America’s growing popular support for women’s right to control their fertility."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-26",
      "id": "ch01-026-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While Sanger was away, however, her husband Bill was entrapped into giving a copy of the "), _c('i', [_vm._v("Family Limitation")]), _vm._v(" pamphlet to a government agent, and in September 1915, he was tried, convicted, and sentenced to a thirty-day jail sentence. One later historian calculated that Bill Sanger’s arrest “proved a powerful magnet which drew many hundreds into active participation in the birth control movement,” and that “Sanger’s trial generated considerable support for birth control as a free-speech issue.” That blossoming support also helped convince Margaret that the time was right to return to the United States, and in October 1915 she did. While she had been away the country’s first birth control advocacy group, the National Birth Control League, had been formed by Mary Ware Dennett and a number of other upper-class, northeastern women. In January 1916—with Margaret rejecting lawyers’ advice that she agree to a negotiated guilty plea in order to dispose of the 1914 federal charges still pending against her—the new league held a heavily publicized New York dinner honoring Sanger the evening before her scheduled trial. Indecisive prosecutors postponed the case once, and then again, as press interest heightened, before finally simply dropping the charges on February 18, 1916."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-27",
      "id": "ch01-027-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The government’s surrender elevated Margaret Sanger to celebrity status. Several weeks later she began a three-and-a-half-month coast-to-coast speaking tour, and birth control became more heavily publicized in America’s newspapers than ever before. In Portland, Oregon, local authorities arrested her for handing out copies "), _c('a', {
    attrs: {
      "id": "page_12"
    }
  }, [_vm._v("of "), _c('i', [_vm._v("Family Limitation")]), _vm._v(", but a supportive judge immediately released her. In Boston, however, when a young man named Van Kleeck Allison decided to distribute birth control pamphlets to passersby who soon included an undercover detective, a speedy trial resulted in a quick conviction and a three-year sentence, which later was reduced to sixty days. Allison’s experience did have the effect of stimulating creation of an Allison Birth Control Defense League that then changed its name to the Birth Control League of Massachusetts, and local birth control groups also emerged in other cities across the country as a result of Sanger’s triumphant tour."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-28",
      "id": "ch01-028-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Upon returning to New York, however, much of Sanger’s energy went into a deepening competition with Mary Ware Dennett for leadership of this burgeoning national movement. Sanger intensely resented that someone other than she had founded the first national birth control group, and while the NBCL was of very modest size, Dennett in early 1917 succeeded in getting a birth control legalization bill introduced into the New York State legislature. Just as with Henry Fletcher’s contemporaneous legislative effort in Connecticut, however, Dennett’s bill attracted almost no support and never emerged from committee. But Sanger’s primary interest was not legislative lobbying, and on October 16, 1916, along with her sister and fellow nurse Ethel Byrne, and several other women supporters, Margaret Sanger opened America’s first public birth control clinic at 46 Amboy Street in the Brownsville section of Brooklyn."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-29",
      "id": "ch01-029-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sanger had been unable to recruit a licensed physician to operate the clinic, but even on its first morning of operation a waiting line of forty-five women had formed on the sidewalk. Sanger and her colleagues fully expected to be raided and closed down by the police within days or even hours of opening, but nine days passed before a transparently obvious female undercover police officer arrived and insisted upon paying two dollars for one of Margaret’s ten-cent pamphlets. The next day she returned with three fellow officers. The clinic’s supplies were seized, and Sanger and an aide were carted off to jail. Ethel Byrne was promptly arrested as well. Released on bail after one night in custody, Sanger soon reopened the clinic but was quickly raided and rearrested.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sanger and Byrne’s lawyer, Jonah J. Goldstein, was determined to use the arrests to challenge the constitutionality of New York’s Comstockian anticontraception statutes, and at one preliminary hearing he told the presiding judge that the law denied a woman “her absolute right of enjoyment of intercourse unless the act be so conducted that pregnancy be the result of the exercise. This clearly is an "), _c('a', {
    attrs: {
      "id": "page_13"
    }
  }, [_vm._v("infringement upon her free exercise of conscience and pursuit of happiness.” The judge, however, expressed astonishment at Goldstein’s argument: “A right of copulation without conception is asserted upon behalf of women in general; defendant claims this is a personal right that cannot be invaded by the Legislature.” Any such contention was hogwash, he held: “That men and women and boys and girls lacking in moral stamina are deterred from fornication by the fear of detection through the pregnancy of the female cannot be doubted.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-30",
      "id": "ch01-030-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Goldstein nonetheless mounted a variety of legal challenges on behalf of his defendants, but in early January 1917, Ethel Byrne went to trial and was convicted. Margaret’s sex education pamphlet which Ethel had given the undercover officer was titled “What Every Girl Should Know,” but the trial court commented that “This contains matters which not only should not be known by every girl, but which perhaps should not be known by any.” On January 22 Byrne was sentenced to thirty days’ confinement and was soon jailed despite Goldstein’s protests that she be freed pending appeal. Byrne announced she would go on a hunger strike until she was released, and amidst heavy publicity and flourishing support from the upper-class women of the NBCL, Margaret’s own trial then got underway on January 29. Goldstein attempted to persuade both Sanger and the court to accept a guilty plea accompanied by only a suspended sentence so that his constitutional arguments could be appealed to higher courts without Margaret having to accept punishment in the interim, but no agreement could be arranged. On February 2, one day after Ethel had been released from jail on account of her rapidly failing health, Margaret was convicted and chose thirty days’ imprisonment in lieu of a five-thousand-dollar fine."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-31",
      "id": "ch01-031-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Margaret’s own jail time passed quietly, and four months later an intermediate appellate court affirmed her conviction. Goldstein then took his arguments to New York’s highest court, and in January 1918, that bench reaffirmed her conviction but also stated, in an indirect but nonetheless tremendously important victory, that New York’s anticontraception statute could not prevent a physician from prescribing birth control to a married woman for whom it would help prevent “disease,” a word which the court then defined in a most broad and inclusive manner. Goldstein resolved to appeal the case yet further, to the U.S. Supreme Court (which eventually dismissed the appeal), but the birth controllers had already registered a crucial if underpublicized triumph."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-32",
      "id": "ch01-032-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The New York court’s emphasis upon doctors’ rights and "), _c('a', {
    attrs: {
      "id": "page_14"
    }
  }, [_vm._v("obligations to protect patients against threats to their health significantly encouraged Margaret Sanger’s ongoing evolution toward a more professionalized—and less politically radical—championing of birth control. Mary Ware Dennett was committed to advocating the complete "), _c('i', [_vm._v("repeal")]), _vm._v(" of all state and federal anticontraceptive statutes, and early in 1919 created the Voluntary Parenthood League, largely a successor to her earlier NBCL, to help recruit a congressional sponsor for a federal repeal bill. Sanger, however, was increasingly persuaded that milder reform measures, legalizing only the “medically supervised” prescription of birth control, stood far, far better chances of winning support and approval. Writing in mid-1919, Sanger now argued that “when instruction in the use of contraceptives is given, it should be given by the kind of persons best suited by training and experience to give it scientifically and accurately. If everyone is permitted to impart information, those who receive it have no guaranty that it is correct or suitable to the individual’s physical requirements. Incorrect, unscientific information may bring good results in some cases, but it is more likely to cause a vast amount of disappointment and anxiety in others.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-33",
      "id": "ch01-033-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In November 1921 Sanger and her supporters convened the First American Birth Control Conference at New York’s Plaza Hotel. Intended in part to refocus the birth control spotlight on Sanger rather than Dennett, it also brought out-of-town birth control supporters to New York, including Katharine Beach Day, Annie Porritt, Jo Bennett, and Henry Fletcher and his wife from Connecticut. The conference’s concluding event was a large public meeting on November 13, but it was interrupted almost before it could begin by a band of New York City policemen who said they were acting at the behest of Roman Catholic Archbishop Patrick Hayes. They removed a prominent English guest speaker from the stage, and then carted Sanger off to jail when she objected. The police action set off a firestorm of press criticism and coverage, and generated a major municipal investigation of how it had been instigated. The church’s blunder transformed the conference into a national news story, and as "), _c('i', [_vm._v("The New Republic")]), _vm._v(" observed two weeks later, thanks to the church “the outlook for the birth control movement is brighter than it ever was.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-34",
      "id": "ch01-034-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One of Sanger’s primary aims for the conference was to create a new national organization of her own, which was christened the American Birth Control League (ABCL). Katharine Beach Day played a principal financial role in helping launch the new group, and by the spring of 1922 Annie Porritt was taking a major role in the editing and publication of its monthly magazine, the "), _c('i', [_vm._v("Birth Control Review")]), _vm._v(", which Sanger "), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("had initiated several years earlier. Before the year was out both Day and Porritt were formal members of the ABCL’s board of directors, and in October 1922, some weeks after returning from a London birth control conference that both she, Sanger, and Porritt had attended, Mrs. Day told Hartford reporters that Mrs. Sanger would be coming to town to speak in January. In mid-November both Day and Porritt attended the annual convention of the Connecticut League of Women Voters, distributed birth control literature, and spoke about mounting an effort in the upcoming 1923 Connecticut legislature to amend the state’s 1879 anticontraception statute. By early January ABCL organization secretary Clara Louise Rowe was in Hartford planning for Sanger’s visit, and Henry Fletcher had recruited Enfield state representative Samuel Sisisky to introduce a birth control bill when the legislature convened."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-35",
      "id": "ch01-035-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Creation of state birth control leagues as affiliates of her national organization was a central part of Sanger’s plan for the ABCL, as was her firm conviction that medically supervised birth control was the goal to advocate. Just a few weeks earlier, after finally recruiting a willing female doctor, Sanger had quietly opened a New York birth control clinic, right across the hall from her ABCL office, under the rubric of a “clinical research bureau.” In Washington, Mary Ware Dennett had finally, after several years effort, found a member of Congress who was willing to sponsor a Comstock repeal measure, but in Connecticut Representative Sisisky’s House Bill 504, formally introduced on January 25, provided only that the “giving of information or advice or medicine or articles for prevention of conception by a doctor or nurse shall not be a violation” of Connecticut’s 1879 statute."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-36",
      "id": "ch01-036-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Neither Sisisky, nor Henry Fletcher, nor the other 1923 Connecticut reformers had a clear understanding of how or why the 1879 law had come into being in the form that it had, largely because neither the surviving legislative records nor the contemporaneous newspapers provided any explanatory comments or details about the statute’s consideration or passage. It had been introduced by New Haven state senator Carlos Smith just two days after a similar bill had been put before the Massachusetts legislature as a result of the efforts of the New England Society for the Suppression of Vice, a Comstock organization that boasted the presidents of Amherst, Brown, Dartmouth, and Yale among its members. The New England Society had been created as an antiobscenity lobby following a May 1878, visit to Boston by Comstock himself, and in Massachusetts its bill quickly passed the legislature without any apparent dissent or debate. The Connecticut bill was referred to the legislature’s Joint Committee on "), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Temperance, favorably reported less than a week later, and passed by the senate, but then returned to the committee by the house. The committee, chaired by sixty-nine-year-old Bridgeport Representative and temperance advocate Phineas T. Barnum, of circus fame, then prepared a substitute bill, including for the first time the unique language that forbid not only trafficking in “obscene” literature and materials concerning sex or reproduction, but also the “"), _c('i', [_vm._v("use")]), _vm._v("” of “any drug, medicine, article, or instrument” for the “purpose of preventing conception.” The revised measure was adopted by the senate, explained to the house by Barnum, approved by the house in slightly amended form, and then again concurred in by the senate. On March 28, 1879, it became law."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-37",
      "id": "ch01-037-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The kickoff event for the 1923 reform campaign was a Sunday afternoon rally and speech by Margaret Sanger at Hartford’s Parsons Theatre, just two days before the legislative joint committee hearing on Sisisky’s bill at which Sanger herself would also testify. The Sunday event drew an impressive crowd of eight hundred to twelve hundred people, approximately two thirds of whom were women, and received extensive coverage in the Connecticut press. The "), _c('i', [_vm._v("Hartford Courant")]), _vm._v(" characterized Sanger as “speaking with a sincerity which her listeners seemed quick to appreciate,” and explained that “at the close of her talk many in the audience wrote questions which were brought up to the stage for Mrs. Sanger to answer.” In her speech she had emphasized that “We want to free women from incessant child bearing; we want to free her from undesired pregnancy”; during the question and answer period she “bitterly attacked” the Connecticut statute while also emphasizing that birth control “must be handled in clinics,” “places with doctors and nurses in charge where a man or woman may come for individual instruction in the use of contraceptives.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-38",
      "id": "ch01-038-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("During her Hartford visit Sanger stayed at the home of Mrs. Day, and either that evening or the next Mrs. Day and her daughter Jo Bennett had Katharine Hepburn join them for dinner with Sanger. Day and Porritt had already been laying the groundwork for formally starting a Connecticut branch of the ABCL, and that night at dinner the plan was ratified, with Mrs. Day becoming the group’s president. Tuesday afternoon February 13, when the legislature’s joint House/Senate Judiciary Committee convened for a ninety-minute hearing on Sisisky’s bill, “the old Senate chamber was packed, people standing in the back of the room and on both sides,” and with the galleries full as well. Henry Fletcher and then Annie Porritt spoke first for the birth control proponents, with Mrs. Porritt declaring that “We ask "), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("this knowledge for the poor; it is now obtainable by the rich.” Hartford attorney and city corporation counsel Robert P. Butler, an active Democrat, added his endorsement, and then Margaret Sanger stepped forward. She “was loudly applauded when she took the floor,” the "), _c('i', [_vm._v("Courant")]), _vm._v(" reported the next morning. “She wore a dark dress and a string of large amber beads. She talked directly to the committee in a low voice, but so clearly that it carried to the gallery.” Sanger spoke “not on the bill specifically, but on the general subject of birth control,” one paper said, and she “emphasized strongly that the advocates of birth control are not in favor of abortion, but desire only to prevent the beginning of life.”")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("Then opponents of the bill, beginning with Hartford Alderman and Catholic Council of Men representative Francis E. Jones, had their turn. He was followed by Roman Catholic Auxiliary Bishop John G. Murray of Hartford, who “talked directly at Mrs. Sanger and the advocates of the bill” in a manner that one reporter characterized as “intense.” “This method is a violation of a natural law,” Murray declared. “The Creator gave the sex function for just one purpose and to exercise it for any other purpose is a perversion of that function.” The Bishop went on to say, the "), _c('i', [_vm._v("Courant")]), _vm._v(" reported, that many families already were having too few children: “The races from northern Europe which he called the finest type of people, are doomed to extinction, unless each family produces at least four children.” After two female opponents also spoke, the hearing concluded with Sanger being given a few moments for a brief and very effective rebuttal. “The gentlemen say it is against the laws of nature to prevent conception,” Sanger declared, “yet they themselves are celibates.” As the crowd applauded, Sanger closed by joking that by her opponents’ standards, men shaving their beards also violated the law of nature and ought similarly to be prohibited."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-39",
      "id": "ch01-039-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By any public standard the hearing and its press coverage, like the Sunday rally, had been a great success and an auspicious debut for the Connecticut birth controllers. But their rhetorical success with the crowds stood them in little stead with the legislature, for several weeks later, without debate, both the house and then the senate accepted and approved the judiciary committee’s rejection of the Sisisky bill."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-40",
      "id": "ch01-040-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" In Washington Mary Ware Dennett’s efforts with the U.S. Congress fared no better, as two days of hearings in early 1924 were similarly followed by judiciary committee rejection of the repeal proposal. Sanger’s ABCL—which now, with Katharine Hepburn’s addition, had three Connecticut women on its board—was quite open in all but opposing "), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Dennett’s congressional efforts. The March issue of the ABCL’s "), _c('i', [_vm._v("Birth Control Review")]), _vm._v(" stressed the league’s opposition to the “indiscriminate dissemination” of birth control information and declared that any “campaign for the repeal of these Federal laws was of secondary importance until some educational work had been done.” Indeed, the league warned, “removal of the Federal restrictions would almost certainly be followed by a flood of widespread advertising, of hastily written and probably misleading books and pamphlets.” Instead the ABCL was drafting a bill which “would free the hands of the medical profession and enable the clinical data to be passed from one group of doctors to another.” The essence of Sanger’s political strategy was conveyed most starkly in a frosty letter that Annie Porritt sent to Dennett, removing her name from Dennett’s list of sponsors. After careful study, Porritt declared, “I am emphatically of the opinion that Birth Control is primarily, in its practical aspects, a medical question, and I am also convinced that promiscuous distribution of advice without medical examinations and care, would tend to degrade the whole question, and to prevent that hearty cooperation on the part of the medical profession which is the chief hope of success.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-41",
      "id": "ch01-041-41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The 1923 Connecticut legislative hearing had featured only one rather tardy appearance and endorsement of birth control by a medical doctor, but the reformers carefully arranged to have Boston M.D. James F. Cooper, whom Sanger had recently hired as the ABCL’s medical director and primary ambassador to physicians, in attendance along with Sanger herself when the 1925 hearing convened on March 12. The 1925 reform bill, in clear contrast to the 1923 one, authorized medically supervised birth control by amending the old 1879 statute so as to provide for a “fifty dollars fine where drugs which may prevent conception are sold without physician’s prescription.” The 1925 hearing drew a smaller crowd than the 1923 one—about one hundred proponents and some fifteen opponents, the "), _c('i', [_vm._v("New Haven Journal-Courier")]), _vm._v(" estimated, but “the idea seemed to have gained in popularity since it was brought up two years ago.” Dr. Cooper was the principal speaker for the reformers, supplemented by Sanger, Katharine Hepburn, and an Episcopalian minister from New York. The judiciary committee “was plainly on the defensive throughout the hearing,” the "), _c('i', [_vm._v("Hartford Times")]), _vm._v(" commented, but the “questions asked by the committee indicated much skepticism.” One senator asked Sanger if birth control information ought to be available to unmarried women, and Sanger said no: “Married women are entitled to the information, because they have moral obligations, which unmarried women haven’t.” The clergyman, "), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("Reverend Thomas H. Garth, contended that “no woman can be free … until she has the right of her person and can say how many children she shall bear and when,” but he was quickly contradicted by the day’s only opposition speaker, Mrs. Louise H. Fisher, representing the Connecticut Council of Catholic Women. “Legislation of this kind will increase the trend toward evading of responsibilities on the part of married people,” Fisher warned. “Persons shouldn’t enter into the married life unless they are willing to accept the obligation of children.” Noting that she herself was a mother of five, Mrs. Fisher closed by declaring that “There is already too much love of luxury and ease and this bill would encourage that very thing.”")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("Once again, as in 1923, the Connecticut reformers were generally pleased with the hearing, but just like two years earlier the judiciary committee quickly recommended rejection of the bill, a recommendation that was accepted without debate by both the senate and house."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-42",
      "id": "ch01-042-42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")]), _vm._v(" Katharine Beach Day turned some of her attention toward assisting Sanger in new political explorations that the ABCL was making in Washington with an eye toward finding a congressional sponsor for a reform bill. Henry Fletcher provided Day and ABCL executive secretary Anne Kennedy with a letter of introduction to Connecticut Senator George P. McLean, whom the women found “most sympathetic,” but neither McLean nor any of a number of other senators with whom Day and Kennedy visited early in 1926, including Nebraska’s George W. Norris, stepped forward to sponsor a bill. Mary Ware Dennett had already given up her Washington efforts and retired from the scene, and by the end of 1926, the ABCL had pulled back as well."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-43",
      "id": "ch01-043-43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Birth control activism was ebbing significantly, with the ABCL registering only 2,800 new members in 1926, as opposed to over 13,000 in 1923 and over 10,000 in 1924, and in mid-1926 Connecticut showed only forty-seven subscribers to the ABCL’s "), _c('i', [_vm._v("Birth Control Review")]), _vm._v(". Sanger spent much of late 1926 and most of 1927 in Europe, on leave from the ABCL, and when Connecticut’s 1927 legislative hearing occurred in early March, Dr. Hannah M. Stone, the director of Sanger’s Birth Control Clinical Research Bureau in New York, came in her boss’s stead. In 1927 the Connecticut women had resolved to champion a repeal bill, and Annie Porritt told the ABCL that while “it will be a miracle if it passes,” the Connecticut women “would not consider anything else.” Porritt explained in another letter that “You can buy condoms and pessaries at the drug stores” if you knew to ask for articles that were not on open display, and that the real and continuing harm done by the 1879 statute stemmed from how it “undoubtedly has "), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("deterred the doctors from recommending something which it would be illegal for his [sic] patients to put into practice.” The hearing itself featured Hannah Stone, accompanied by Day, Porritt, Fletcher, and Hepburn, telling the judiciary committee that “contraception is distinctly a medical problem” and that “it should be the duty and the privilege of the physician to advise his patients in regard to it.” The only opposing speaker, Mrs. Richard. F. Jones of West Hartford, who claimed “that there are more women in hospitals as a result of the use of preventives than on account of natural births,” was apparently not questioned on her unintended acknowledgment that tens of thousands of Connecticut women indeed did want to limit and control their fertility. Although both the Connecticut senate and house once again without debate ratified a judiciary committee recommendation that the repeal bill be rejected, one small press report stated that the negative vote in committee had been by a margin of only seven to six."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-44",
      "id": "ch01-044-44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By early 1928 Margaret Sanger was back in the United States, but Eleanor Dwight Jones, who had been the acting ABCL president during Sanger’s absence, was successfully resisting Sanger’s efforts to reassume her previous level of organizational control. With the ABCL board, including board secretary Annie Porritt, resolutely backing Jones, Sanger in June 1928 resigned as ABCL president. Political struggles persisted throughout the year as Sanger and Jones fought for control of both the Birth Control Clinical Research Bureau and the "), _c('i', [_vm._v("Birth Control Review")]), _vm._v(", with Sanger winning on the former and losing on the latter. Porritt tried to be something of a mediator, warning Jones that “Mrs. Sanger is scarcely sane on the point of her antagonism to you,” but adding that she fully agreed with Sanger that the Clinical Research Bureau was a separate enterprise. Otherwise the Connecticut women were largely untouched by the New York battling, and focused their efforts on building some visible local support for birth control legalization in advance of the 1929 legislative session. ABCL staff organizer Constance Heck was detailed to the Fairfield County towns of Greenwich, Norwalk, and Darien to stimulate the creation of local birth control committees, and contacts were made with Protestant ministers in Hartford, Bridgeport, Stamford, and Waterbury. Up in Massachusetts the arrest and quick acquittal of one female doctor, Dr. Antoinette F. Konikow, for giving a lecture on birth control had had the effect of reviving a state league that had been moribund for almost a decade, but the great New England success of 1928 came in November when the general conference of Congregational Churches in Connecticut endorsed the upcoming repeal bill at the behest of ministers who had been recruited by the Connecticut women."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-45",
      "id": "ch01-045-45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("The success with the Congregational clergy, and the creation of a total of fourteen local town or city birth control committees, gave the birth control advocates a major boost going into the 1929 legislative session. Margaret Sanger said no to Katharine Hepburn’s request that she come up for the February 28 hearing, but an overflow crowd of almost a thousand people turned out, and the Associated Press reported that “The support was stronger this session than ever before.” Hepburn, Porritt, Jo Bennett, and Henry Fletcher were joined as affirmative speakers by Leon F. Whitney of New Haven, executive secretary of the American Eugenics Society, Bridgeport’s Reverend T. F. Rutledge Beale, the prime mover behind the Congregational Church endorsement, and prominent Hartford physician James Raglan Miller, an old acquaintance of Porritt and the Hepburns from the Social Hygiene Association.")])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The afternoon was without a doubt the most lively legislative hearing the Connecticut effort had yet experienced. At the outset, Katharine Houghton Hepburn stole the show. “Three quarters of the men and women in this room are common criminals and ought to be in jail,” she declared, drawing “indignant whispers” and “scattered hisses” from some as the crowd understood her allusion to the anticontraception law. Instead, she went on, “The crime is in having too many children where parents are too poor, too unintelligent to raise many children, in raising children that can never be adjusted to society.” Also, Hepburn said, even “Roman Catholic women are coming to realize that this is their concern and not that of their priests; that they, and not the priests, have to bear the children.” When she finished, the "), _c('i', [_vm._v("New Haven Journal-Courier")]), _vm._v(" reported, “Tremendous applause went through the room.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("At least half-a-dozen members of the legislature, including three women, stood to register their support for the bill, and then it was the opponents’ turn. “The leader of the opposition,” B. L. Garrity of Shelton, announced that he had been told to oppose the bill by his wife, the mother of their nine children. “More humorous than serious,” the "), _c('i', [_vm._v("Journal-Courier")]), _vm._v(" added, “the opposition leader advised that, instead of birth control being allowed among the ‘upper stratum’ a law be passed that all couples married ten years should be forced to have five children, or be sent to jail for the rest of their lives.” “If they want the sex relationship,” he declared, “let them take what goes with it.” Garrity went on to compare birth control clinics to houses “which people don’t speak about in polite society,” but when a female committee member sought to ask Garrity whether having so many children had threatened his wife’s health, “a fight nearly developed” and the ")]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("committee chairman ruled the question out of order as too personal. Louise Fisher’s opposition testimony produced no such outbursts, but another Hartford woman asserted that the bill “savors of barbarism and paganism.” Katharine Hepburn was allotted several minutes for a closing rebuttal, and tried to reiterate her earlier point that immigrant women “don’t believe it’s any business of the priests, since they, the women are the real sufferers,” but she was angrily interrupted by an opposing legislator from Bridgeport who shouted that people simply needed to “control their lust.” “Let them practice self-control, not birth control!” The hearing concluded with the committee asking the audience for a show of hands, pro and con, which one reporter estimated looked essentially even, “about 400 to 400.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-46",
      "id": "ch01-046-46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Only five days later, however, the judiciary committee issued a negative report on the bill, and even its supposed sponsor, Senator Ernest W. Christ, told reporters that he was not in disagreement with the committee’s action. The Connecticut women were sorely disappointed, but soon learned, as Katharine Beach Day later reported, that “The Republican leaders had decreed the defeat of the bill.” The women’s organizing efforts had in part been for naught because they had insufficiently appreciated the extent to which legislative policy decisions in Connecticut were made in a “top-down” manner. In the largely one-party Republican world of the Connecticut legislature, where Republicans that year dominated the house by 194 to 68, and the senate by the much narrower margin of 21 to 14, most members followed the recommendations issued by their leaders.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One member who did not, however, was sixty-nine-year-old Bristol lawyer and legal scholar Epaphroditus Peck. While the senate accepted the judiciary committee’s negative recommendation without debate, Peck forced a floor debate and vote in the house—the first time a birth control bill had gotten that far. Like the earlier hearing, however, the floor debate turned into a raucous affair. With Katharine Hepburn in “a front row seat in the well-filled gallery,” Representative Peck spoke about how the anticontraception statute was essentially religious legislation and how there had never been a prosecution under it. He noted how at the hearing opposition to its repeal had come “exclusively from Roman Catholic sources,” and emphasized how the entire topic involved “matters purely personal.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The primary opposition speaker was Representative Caroline T. Platt of Milford, who admitted that some liberalization might be desirable for women with health problems but contended that even most Protestants did not favor total repeal. “Trembling, seemingly with deep "), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("emotion,” Mrs. Platt argued that if birth control was legalized, population growth would come only from immigrants, and “she pleaded for ‘keeping up the proper element.’” This bill, she went on, “opens the way for every girl to become a prostitute,” and “seventy-five per cent of them will.” That statement generated “such a chorus of protesting hisses that Mrs. Platt was silenced, standing erect, her trembling hand holding a sheet of paper with her notes.” Platt then concluded by calling for “a conference of ‘conscientious doctors and wise lawyers’” to draft an amendment. Her speech, the "), _c('i', [_vm._v("Hartford Courant")]), _vm._v(" declared, had been “the first time in the history of the State” that “occupants of the galleries hissed a member of the House for arguments advanced on the floor.”")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("Six other representatives, four of them women, also spoke before the vote was tallied. The "), _c('i', [_vm._v("Courant")]), _vm._v(", terming the debate “bitter,” explained that “applause for speakers both for and against the bill from onlookers and legislators went unchecked throughout the long discussion.” Representatives Helen Lewis of Stratford, Georgina Davids of Greenwich, and Marjory Cheney of Manchester all spoke in favor. In opposition, Mrs. Marion Roberts of Hartford declared that “birth control is an unnatural process and leads to degeneracy,” and a male representative from Clinton advanced an economic argument: “The workers come from the lower classes and it is here that births would be limited by such a bill. Workers are needed, and the upper classes should not put into effect legislation that will tend to reduce their number.” Then the tally was taken, and the repeal bill was rejected by the overwhelming margin of 226 to 18. Eight of the affirmative votes were from women."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-47",
      "id": "ch01-047-47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The house debate had been the most dramatic event in the Connecticut struggle to date, and the women praised Peck’s effort while welcoming the extensive favorable press coverage. Several weeks later, however, the birth control movement received its biggest national publicity boost since the New York police action in 1921 canceling Sanger’s mass rally when another New York City police raiding party descended upon the Birth Control Clinical Research Bureau on April 15. The eight officers had arrest warrants for Dr. Hannah Stone, another physician, and three clinic nurses, and carted them off in patrol wagons while also seizing all of the clinic’s medical and patient records. The raid had clearly been in preparation for some time, for undercover policewoman Ann K. McNamara had made several visits to the clinic under the guise of being a patient, and two examinations had found McNamara experiencing “several pelvic disorders.” Sanger was "), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("outraged, noting that the clinic had been “minding its own business and hoping that its powerful ecclesiastical neighbors would mind theirs,” but her new attorney, Morris L. Ernst, and many supporters found the raid nothing short of astounding, for the 1918 New York court decision in Sanger’s own case had explicitly ratified doctors’ provision of birth control advice and devices in any and all situations where they were medically appropriate for a woman’s health.")])]), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("Authorities returned the patient records four days after the raid, but New York doctors were infuriated at such a police invasion of doctor-patient confidentiality, and within a week the New York County Medical Society officially adopted a resolution condemning the raid. An initial hearing on the charges against the staff members was adjourned after only Officer McNamara’s testimony, but Ernst explained his defense strategy to the press: “If the doctor is acting in good faith with the thought that the birth control information will prevent disease, that is all we have to prove. It is the burden of the prosecution to prove the bad faith of the doctor.” Five days later, when the defense got its turn in court, several very prominent doctors, including a former city health commissioner, took the stand on behalf of the clinic workers. The presiding magistrate reserved decision, but the city police commissioner issued what the "), _c('i', [_vm._v("New York Times")]), _vm._v(" termed “a virtual apology” to the clinic and the medical community, saying he agreed “absolutely” that “the relationship between patient and physician should forever remain inviolate.” Several days later the police commander responsible for the raid was demoted, and three days after that the court dismissed the charges, agreeing with Ernst that “good faith” on the part of the doctor was indeed “the test of guilt or innocence.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-48",
      "id": "ch01-048-48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The police and/or church blunder of raiding the New York clinic, just like the 1921 intrusion, redounded greatly to the birth control movement’s advantage. The "), _c('i', [_vm._v("Birth Control Review")]), _vm._v(" declared that the controversy had “furthered the cause of birth control beyond the most optimistic hopes of its supporters,” especially because of how “the medical profession aligned itself more definitely than ever before on the side of birth control.” Just days before the raid Sanger had resolved to take new congressional soundings on the prospects for a federal reform bill by creating what she called the National Commitee on Federal Legislation for Birth Control, and while Catholic spokesmen continued to decry birth control as “intrinsically evil,” Sanger responded that it will “enable a woman to act as a free, self-directed, autonomous personality.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-49",
      "id": "ch01-049-49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By the fall of 1929 Sanger was attempting to recruit a hesitant "), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("Katharine Hepburn as legislative chairman for her National Committee, and the Connecticut women were looking ahead to the 1930 elections, hoping to boost the number of birth control supporters who would sit in the 1931 legislature. Nationwide there was now a grand total of fifty-five birth control clinics in twenty-three cities in twelve states, but while Katharine Beach Day reported to the ABCL that “it is very evident that there is a steady growth of sentiment throughout the state in favor of birth control,” she also stated that “it is impossible to attempt to establish a clinic until the doctors shall be free from their present dilemma” under the 1879 statute. Sanger’s National Committee sporadically sent staff organizers into Connecticut to raise money and recruit new supporters, and these efforts generated some funds, plus modest numbers of new endorsers—including, on one small Waterbury list, Miss Jeannie Heppel. However, a preliminary contact by one staffer in the summer of 1930 with a small group of Greenwich women who had had some initial discussions about possibly sponsoring a clinic just across the state line in New York came to naught."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-50",
      "id": "ch01-050-50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While the newly titled Connecticut Birth Control League had no discernable impact on the state’s November elections, the results nonetheless were extremely notable: for the first time in twenty years a Democrat—grandfatherly Yale English professor Wilbur L. Cross—won the governorship. Liberals were ecstatic, believing that Cross’s triumph over the one-party conservative Republican dominance of the state represented a “stinging rebuke” to the reticent millionaire power company president, J. Henry Roraback, who had served as Republican state chairman since 1912 and was widely believed to choose Republican gubernatorial candidates—and legislative leaders—quite single-handedly. Reformers had long accused passive state Democratic leaders of having an insidious but informal working relationship with Roraback, and while the Republicans still controlled both houses of the legislature, many thought that a new political era might be dawning in Connecticut."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-51",
      "id": "ch01-051-51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Not long after that election the CBCL women decided that their 1931 initiative would have to be a “doctors’ bill” rather than a repeal one. There was “a pretty general feeling,” they told the ABCL, “especially on the part of the women members of the legislature, that there would be less opposition to the ‘doctors’ bill’ than to a straight repeal bill,” which some supporters had “criticized as too ‘radical’ a step.” In New York, however, the national birth control strategy debate had taken a new and very important turn when one young supportive "), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("woman lawyer, Dorothy Kenyon, had advanced the novel contention that rather than continuing to focus on winning legislative repeal of federal and state anticontraception laws, it would be preferable “to get away from the law by the simple expedient of forgetting about it.” Terming this option “nullification,” Kenyon argued that it would be better to bypass legislative bodies “and concentrate upon public opinion, in the hope that some day the sentiment of the community may be strong enough to impress our enforcement officers” into nonenforcement. Kenyon’s article stimulated considerable discussion. Birth control historian Norman Himes agreed that the key would be “the failure of prosecutors to bring cases before the courts,” and attorney Alexander Lindey concurred: “nullification promises the only speedy relief.” Morris Ernst saw it somewhat differently: “Nullification will take place by the constant whittling away of the law by judicial decisions.” Birth control statutes “will not be repealed until they have already been nullified,” Ernst predicted, but the essence of change would be judicial incrementalism: “Courts which are too cowardly to declare laws in conflict with our basic Constitution wheedle out of dilemmas by casting new interpretations on old statutes, eventually destroying the word of the law givers.” One of the very few dissents came from semiretired Mary Ware Dennett: not only was legislative repeal “far easier to accomplish than has been assumed,” but “under the nullification process, one can never know where or when the lightning of occasional prosecution may strike.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-52",
      "id": "ch01-052-52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ernst appeared quite prescient when, hardly two weeks later, the U.S. Court of Appeals for the Second Circuit ruled in a trademark infringement lawsuit involving the manufacturer of Trojans brand condoms that there was nothing improper about such items since, under the New York court decision in Sanger’s case twelve years earlier, physicians could supply or prescribe contraceptive articles for health purposes, and condoms of course could prevent the spread of disease. Legal commentators heralded this "), _c('i', [_vm._v("Youngs Rubber")]), _vm._v(" ruling as a major step toward nullifying the federal 1873 Comstock provisions, but Margaret Sanger remained focused upon pursuing congressional approval of a doctors amendment. She had finally succeeded in recruiting a sponsor—ageing lameduck Massachusetts Senator Frederick H. Gillett—and in mid-February 1931 a judiciary subcommittee held two days of hearings on his bill, even though it had no prospects for passage, or even committee approval. Katharine Hepburn preceded Sanger as the proponents’ first speaker, telling the subcommittee that human beings should not be denied “the right to regulate intelligently the birth rate.” "), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("A prominent doctor, a well-known Protestant clergyman, and a woman representing the New York City Junior League also spoke in favor. For the opponents, an attorney representing the National Patriotic League alleged that birth controllers were puppets of “communistic agents” and a spokesman for the National Catholic Welfare Conference warned against “perverting youth through the spread of contraceptive propaganda.” An American Federation of Labor official, a female member of Congress from New Jersey, and Massachusetts Representative John W McCormack—a future speaker of the House—completed the opponents’ roster, with McCormack declaring that “I can conceive of no more dangerous piece of legislation to the future of America” than Sanger’s modest reform bill."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-53",
      "id": "ch01-053-53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hardly a week after the Washington session, a legislative hearing was held in Boston on a doctors-exception bill that was the first significant initiative to come from Massachusetts birth control advocates in over a decade. The Birth Control League’s female officers had carefully recruited physician support, even to the extent of sponsoring a supportive article in the "), _c('i', [_vm._v("New England Journal of Medicine")]), _vm._v(", but the bill went nowhere and some Massachusetts activists argued that efforts should be directed toward simply opening a clinic rather than appealing to the legislature."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-54",
      "id": "ch01-054-54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In Connecticut the 1931 birth control campaign followed much the same path as in Washington and Boston. Annie Porritt was now the acting chairman of the league, as an ageing Katharine Beach Day spent more and more time in Florida, and Porritt had taken the lead in being sure that an advance text of a doctors-exception bill had been circulated among Connecticut M.D.s for their endorsement. When prominent Hartford gynecologist James Raglan Miller appeared as the leadoff speaker at the judiciary committee’s birth control hearing on February 24, he was able to present the members with a list of more than four hundred Connecticut doctors who were backing reform. The CBCL women had been deeply pleased by the extent of medical support, and while the proponents’ presentation was heavily directed toward portraying the issue as a medical question, the same standing-room-only crowd of female supporters was once again present. Three other doctors joined Miller and Katharine Hepburn among the affirmative witnesses, but primary opposition speaker Francis E. Jones, representing the Bishop of Hartford, was joined by an opposing M.D. as well as by one Mrs. T. M. Sullivan of Hartford, who warned that if the bill passed, “twenty-five years from today the State of Connecticut will be a mass of crumbling ruins.” The largely female audience laughed loudly when Mr. Jones was "), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("forced to concede that “child-bearing has its difficulties,” but the opposing doctor, Daniel E. Shea, firmly told the committee that if Connecticut doctors really backed reform, the Connecticut State Medical Society itself would be appearing before them.")])]), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The judiciary committee’s reactions were noncommittal, but some three weeks after the hearing the committee "), _c('i', [_vm._v("favorably")]), _vm._v(" reported an amended and more modest bill, allowing for doctors to prescribe birth control, but only for specific individual health needs. While it was the first time that any birth control bill had received a committee endorsement, birth control advocates voiced mixed reactions, with Katharine Hepburn terming it “much too conservative.” Although the "), _c('i', [_vm._v("Hartford Courant")]), _vm._v(" termed the favorable report “one of the surprises of the session,” the day before house floor action the "), _c('i', [_vm._v("Courant")]), _vm._v(" also reported that “opponents of the bill have been energetic in bringing pressure to bear upon their representatives ever since the bill received a favorable report.” The paper added that “A considerable number of legislators are loath to vote contrary to the wishes of constituents and equally unwilling to vote against the bill. A good many of the members of both houses are exceedingly anxious to avoid a record vote on the bill.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("When the committee’s bill was brought up for house floor debate on April 1, Bristol’s Epaphroditus Peck, as in 1929, led the fight for the proponents, joined by Marjory Cheney of Manchester and a new young Republican from Stratford, Raymond E. Baldwin. One of the three M.D.s in the house, Clinton’s David A. Fox, spoke against the bill, saying that passage would result in young people having “a bottle of gin in one hand and a birth control certificate in the other.” Legislative leaders attempted to avoid a recorded vote, but fifty-two members, all Democrats—and just two more than the required minimum—forced a formal tally. When the numbers were totaled, the bill was rejected by 172 to 76—a wide margin, but considerably closer than 1929’s 226 to 18. Nine women representatives voted in favor and ten against. The following day the judiciary committee’s favorable report was taken up in the senate. One of only two senate proponents told his colleagues that “The state has no business telling me or you or anybody else how we shall conduct our marital affairs.” His compatriot added that “some day we will laugh at our fear of passing such a bill,” but when a voice vote rejecting the bill was taken, reporters judged that only three or four of the thirty-three senators present voted aye."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-55",
      "id": "ch01-055-55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That legislative struggle and defeat mobilized a number of new medical supporters of birth control, and in very short order led to a significant alteration in the leadership—and the agenda—of the "), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("Connecticut League. Taking the lead in these changes was fifty-four year-old Yale public health professor Charles-Edward A. Winslow, who had founded the public health program at Yale and who had long known Porritt, the Hepburns, and Mrs. Day through their mutual earlier involvement in the Social Hygiene Association. Along with two gynecologist friends, A. Nowell Creadick and Yale faculty member Herbert Thoms, Winslow resolved that medical men ought to “take some rather active steps to lay a foundation” for a successful 1933 legislative effort. The first step, Winslow and his colleagues told other doctors, was “to reorganize the Connecticut Birth Control League so that it can be made a really vigorous and effective organization. What we expect to do is to concentrate our efforts entirely on the amendment that was proposed” in the 1931 legislature—i.e., authorizing doctors to provide birth control advice and supplies "), _c('i', [_vm._v("only")]), _vm._v(" to women whose health needs justified it—“and to build up an organization throughout the counties and towns of the state so that we can really exert some influence.”")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("The New Haven trio, along with two New Haven female supporters, Betty Whittemore and Elizabeth Reed, laid plans for a June 1 annual meeting of the CBCL and agreed that Creadick would become the league’s new president, “as it seems very important to have a medical man in that position and he seems by far the best fitted.” In advance of that session, however, Doctors Thoms and Creadick successfully brought the issue of birth control before the May 21 annual meeting of the Connecticut State Medical Society. Thoms had prepared a statement saying that the CSMS supported “legalizing the dissemination of contraceptive advice for medical purposes by licensed practitioners” as per the judiciary committee’s bill, and Creadick delivered a stem-winding speech on its behalf, explicitly denouncing the doctors in the state house who had failed to back that bill. “Dr. Creadick’s discussion evoked applause” from the delegates, the Society’s minutes recorded, and it was “voted (unanimously) … that the sentiments expressed in the above statement be approved by the Society.” Ten days later, at a luncheon at the New Haven Lawn Club, the CBCL elected Creadick as its new president and unanimously resolved to pursue a 1933 edition of the judiciary committee bill in the next legislature. Annie Porritt and Katharine Beach Day remained on the board, with Porritt’s daughter-in-law, Alison Hastings Porritt, becoming the new CBCL treasurer, and Mrs. Hepburn’s friend Sallie Pease being named Hartford County chairman."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-56",
      "id": "ch01-056-56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On the national scene the American Birth Control League "), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("continued to endorse practical nullification arguments while stressing that the actual opening of clinics, rather than Sanger’s emphasis upon appealing to the Congress, was the direction in which birth control activists should move. New England’s first public birth control clinic was opened in Providence in July 1931 by the newly formed Rhode Island Birth Control League, and encountered no legal difficulties, but Sanger, in an autobiographical book published in September, continued to call for winning “the ultimate victory through congressional legislation.” The Connecticut activists, now headquartered at Creadick’s office at 79 Trumbull Street in New Haven, took note of the Rhode Island step, but resolved that an educational campaign aimed particularly at rural legislators was their only option: “The Board felt that no step towards the establishment of clinics could be taken so long as the law makes penal the use of contraceptives, and thus puts any clinic in the position of being a school of crime.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-57",
      "id": "ch01-057-57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In February 1932 Creadick, in conjunction with New Haven’s Leon Whitney, executive secretary of the American Eugenics Society, invited Margaret Sanger to town for a major speech, with Creadick informing Sanger that “the ladies of my Board are eager to meet you and entertain you.” New Haven Police Chief Philip T. Smith did not share those sentiments, and announced he would have Sanger arrested “if she says one word over the bounds” during her March 8 talk at the Fox College theater. Sanger drew a capacity crowd of fifteen hundred, including numerous police officers, but she was not interrupted, and Smith told reporters that “I don’t propose to make a martyr of any group.” Sanger thanked Creadick for the Connecticut League’s steadfast defense of her right to speak, writing that “I had to rub my eyes to remember that this was the year of 1932 and not back in the days of 1914.” Sanger added that she had come to the “definite conclusion … that no man or woman with Catholic affiliations has any moral right to hold a position of authority for the State. They cannot help but give their first allegiance to the Church and become subject to the demands of any high official of the Church.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-58",
      "id": "ch01-058-58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sanger’s leading preoccupation remained her focus on pursuing a congressional reform bill, and in May 1932 both a Senate judiciary subcommittee and the House Ways and Means Committee held hearings on similar bills introduced by two openly noncommittal legislators, West Virginia Senator—and doctor—Henry D. Hatfield and North Carolina Representative Frank Hancock. Katharine Hepburn accompanied Sanger to both hearings, telling the House committee that birth control advocates were not opposed to large families. “I personally believe in large families. I have one.” Sanger herself stressed to "), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("the committee that birth control “does not mean the interruption of life after conception occurs.” The Senate committee, however, never even voted on the bill, and when the House one did, it was defeated by a margin of 19 to 4."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-59",
      "id": "ch01-059-59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In New England, however, birth control discussion was increasingly turning to clinics, not legislatures. Nowell Creadick acknowledged in a spring report to his CBCL colleagues that their emphasis upon winning modest future legislative reform “has brought us opposition and criticism from friends,” including some within the league, but Creadick and his fellow doctors remained opposed to what he termed “the flagrant violation method” of opening a clinic. There had been some talk of filing a court case to seek a judicial declaration that doctors were not breaking any law when they sought to protect their patients’ health, but Creadick and his colleagues noted that a suit “takes time and the outcome is uncertain. It will lead us nowhere except to permit any doctor to prescribe in his office to one of his patients.” Again at their instigation, however, the 1932 annual meeting of the Connecticut State Medical Society approved a resolution backing legislation which would legalize birth control in cases where “pregnancy would be detrimental to the health of the patient.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-60",
      "id": "ch01-060-60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Other members of the league, however, and particularly the group of Greenwich women, focused more and more on the question of simply opening a clinic. In May 1932 several of them, particularly Nancy Carnegie Rockefeller and Florence Borden Darrach, launched the Greenwich Committee for Maternal Health with a well-attended mass meeting at Greenwich High School that was addressed by Mrs. Darrach’s husband, a prominent doctor who had just stepped down as dean of Columbia University’s medical school. Nancy Rockefeller in particular had been in contact with New York birth control advocates for almost two years, and several weeks after the rally they took further encouragement when they learned that the Birth Control League of Massachusetts had just opened that state’s first clinic, the Brookline Mothers Health Office. By early August Rockefeller and her colleagues were committed to opening a clinic in Port Chester, New York, just across the state border, with the hope of subsequently moving it into Connecticut proper. Rockefeller asked Hannah Stone, still the director of Sanger’s New York Birth Control Clinical Research Bureau, to recommend a willing physician to them, and in early September 1932, Dr. Cheri Appel, a thirty-one year-old graduate of New York University Medical School, began seeing Connecticut patients at the Port Chester facility. At long last Connecticut—almost—had a clinic."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-61",
      "id": "ch01-061-61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Most of the Connecticut League’s work, however, continued to "), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("point toward lining up backers of a modest reform bill in advance of the 1933 legislature. In late August the league lost one of its three formative figures when Annie Porritt was killed in a Hartford auto accident. A decidedly formal woman—much unlike both Katharine Day and Katharine Hepburn—who had no interest in small talk and whom even her closest friends always called “Mrs. Porritt,” she had been as central as anyone during the league’s first decade, even if her role had receded some when the medical men had moved to the fore. In December Margaret Sanger delivered speeches in Hartford and at Wesleyan University in Middletown, but the more important event was the league’s recruitment of the incoming house majority leader, Raymond E. Baldwin of Stratford, as sponsor of its 1933 bill. The general election had returned Wilbur Cross to the governorship, and the Roosevelt tide had carried a narrow Democratic majority into the state senate, creating divided control of the legislature for the first time in twenty years. Baldwin was young, a relative liberal, and visibly independent of the J. Henry Roraback tradition of Connecticut Republicanism. While the Democrats might be the more liberal party on most issues, the heavy concentration of most Catholic officeholders in Democratic rather than Republican ranks increasingly made the latter party the vehicle of choice for the birth control advocates, and Baldwin was an ideal Republican champion."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-62",
      "id": "ch01-062-62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Baldwin’s House Bill 519 provided that the 1879 ban “shall not apply to [a] licensed physician when in his opinion pregnancy would be detrimental to the health of the patient.” The judiciary committee’s hearing on it took place on March 1, and the CBCL doctors recruited Dr. Charles W. Comfort, a top officer of the Connecticut State Medical Society, as the proponents’ principal speaker. Comfort described the bill as “a purely medical measure for the purpose of preserving the health of our women.” Then Hartford’s Dr. James Raglan Miller detailed how during the final six months of 1932 fifty-seven Connecticut women had died in pregnancy, at least nine from illegal abortions and at least five from heart or kidney problems that would not have proven fatal in the absence of pregnancy. Dr. Creadick presented the committee with some five thousand petition signatures endorsing the bill, including more than a thousand from Connecticut doctors—considerably more than half of the state’s practicing physicians. Opponents, however, countered by presenting four doctors of their own to supplement Louise Fisher of the Connecticut Council of Catholic Women, who had represented opponents eight years earlier in 1925. One of the opposing doctors warned that passage of the bill "), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("would result in “moral degeneracy,” while Mrs. Fisher declared that “the laws of nature and of God are violated by the use of devices preventing conception.” The only morally acceptable answer, she explained, was simple: “for the problems, both ethical and physical, there is but one solution, marital continence.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-63",
      "id": "ch01-063-63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eight weeks passed before the judiciary committee voted on Baldwin’s bill, and when it did, the result was an 8 to 8 tie. Five days later that unfavorable report went to the house floor, and floor leader Baldwin offered an amendment expressly limiting application of the bill’s medical exception to "), _c('i', [_vm._v("married")]), _vm._v(" women. Representative Peck of Bristol, a veteran from previous years, sought to emphasize that this year’s bill was being championed by doctors, not the league, but Republican Montgomery C. Tiers of Colebrook asserted that passage would “open wide the gates of prostitution,” and William J. Lyons of Norwalk insisted that the bill “gives physicians the right to kill.” Peck responded that “the real question is whether you have the right to impose your judgment on me and send me to jail if my judgment is not the same as yours,” and when the tally was taken, Baldwin’s amended bill passed by the impressive margin of 169 to 80. Republican representatives backed the measure by 151 to 35, while Democrats totaled 18 in favor and 45 opposed. Fifteen of eighteen women members voted in favor, and the "), _c('i', [_vm._v("Hartford Courant")]), _vm._v(" noted that while proponents had not previously been optimistic about their chances in the senate, the dramatic house margin now left them “greatly encouraged.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Two days later, however, the senate without debate first rejected, by 18 to 12, the limiting amendment that Baldwin had added in the house, and then the bill itself, with twenty votes in the negative. Dr. Creadick responded by telling reporters that “We have come a long way in the past ten years” and vowing “two years of careful campaigning” to change the result come 1935, but the "), _c('i', [_vm._v("New Haven Journal-Courier")]), _vm._v(" decried the outcome as one that “inhibits medical freedom” and regretted how the opposition was “purely religious.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-64",
      "id": "ch01-064-64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Raymond Baldwin, however, was not ready to give up, and on May 9, at his initiative, the house “voted to insist” on its previous endorsement of his bill and appointed two members, Peck of Bristol and Helen Kitchell of Greenwich, to serve as a conference committee to discuss the bill further with the senate. A single opponent, Raymond J. Devlin, represented the senate, and on May 18 Peck and Kitchell presented the house with a further revised and weakened version of the original Baldwin bill. This newest version would authorize a doctor to provide birth control information and supplies to a married woman if "), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("her health in the doctor’s judgment called for such, so long as that doctor’s judgment was “concurred in by another licensed physician” who would be designated by the state health commissioner after a request was filed by the initial doctor. This new amendment, the "), _c('i', [_vm._v("Courant")]), _vm._v(" reported, “was drafted on information that it would be acceptable to a sufficient number of senators to insure adoption of the bill in that body.”")])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("On May 23 the house adopted the new amendment on a vote of 149 to 45, with Representative Peck explaining quite explicitly that it had been prepared by a senator who previously had voted against the bill. The house then approved the bill itself, by an increased margin of 171 to 72, but the following day the senate simply tabled the entire matter, leaving the issue in abeyance. Among the bill’s ostensible proponents, however, vocal dissent from the further compromise represented by the final house bill was growing, and on May 26 Margaret Sanger sent identical telegrams to Nowell Creadick and to Katharine Hepburn: “Have read with amazement House bill suggesting consultation [with] two physicians for women [to] receive information. Sincerely hope you will protest such shortsighted legislation. I beg you not to accept such compromise with principle and fairness. Better to leave legislation as it is.” Hepburn cabled back that “[I] Entirely agree with you,” but further internal debate over that fundamental strategic choice was precluded when the senate, on June 6, on a motion by Hartford senator Joseph P. Cooney and without apparent opposition, tabled the bill indefinitely."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-65",
      "id": "ch01-065-65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the wake of the 1933 battle, however, Nowell Creadick stepped down as president of the league and was briefly replaced by Hartford minister William T. Hooper, who himself resigned on grounds of ill health in May 1934. The Greenwich women continued to operate successfully their clinic facility in Port Chester, New York, with Dr. Appel seeing 395 women in the first twelve months of operation and then an additional 523 new patients in the clinic’s second year of existence. In November 1933, the league won a significant victory when the Connecticut League of Women Voters reversed their 1931 stance and voted by a narrow margin of 56 to 51 to endorse birth control, and most league activists looked forward to the 1935 legislature with considerable optimism."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-66",
      "id": "ch01-066-66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])]), _vm._v(" Katharine Hepburn joined Margaret Sanger for two more sets of Washington congressional hearings on birth control bills that Sanger’s National Committee was backing, and on the senate side a “doctors’ bill” actually made it to the floor before finally being killed. One commentator observed that “There is little doubt that the bill "), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("would have passed had a fair roll-call vote been taken,” but a more widespread view was that increasing numbers of people viewed the legislative effort as largely a symbolic enterprise, since the availability of some contraceptives, particularly condoms, had increased very noticeably in the wake of the federal appellate court decisions in "), _c('i', [_vm._v("Youngs Rubber")]), _vm._v(" and another subsequent case. Some journalists warned that manufacturers who suggestively advertised “feminine hygiene” products as supposed contraceptives were taking advantage of this new atmosphere to misleadingly market many products that were far less dependable than physician-fitted diaphragms, and "), _c('i', [_vm._v("The New Republic")]), _vm._v(" contended that “the contraceptive business has outgrown the birth control movement.” Even Sanger admitted that “all progress has been through judicial decisions or interpretations” and conceded that her congressional bill would merely “incorporate in the federal laws the exemptions that have already been judicially recognized,” but she continued her legislative efforts in the new Congress that began early in 1935."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-67",
      "id": "ch01-067-67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In October 1934 the Connecticut League named Hepburn’s friend and neighbor Sallie Pease as its president and carefully scrutinized the upcoming legislative elections. The November results for the state senate were mixed, and both Pease and Dr. Creadick, now the league’s legislative chairman, attempted to count possible votes in what ostensibly looked like close to a prospective tie. In late January the 1935 birth control bill, a doctors’ measure, was introduced by Willington Representative Dr. Frank C. Converse, but prospects for a favorable report from the joint judiciary committee looked bleak, and hence house proponents attempted unsuccessfully to have the measure referred to the Public Health and Safety Committee instead. A judiciary committee hearing on the bill was not scheduled until April 5, but the weekly newspaper of the Hartford diocese significantly enlivened the biennial battle by publishing a harsh editorial attack on Katharine Hepburn and Margaret Sanger. “If the communistic theories imported from Russia are widely propagated in our American colleges, it seems quite probable that Mrs. Hepburn and Mrs. Sanger shall come forth from their protracted campaign crowned with the laurels of victory.” The "), _c('i', [_vm._v("Transcript")]), _vm._v(" additionally alleged that during Katharine Hepburn’s own childbirths, her entire family had been invited in to watch the event, and that suggestion was enough to propel Hepburn into sending the diocese what press reports termed “a sizzling telegram.” In the next issue, in an editorial prominently headlined “We Apologize,” the "), _c('i', [_vm._v("Transcript")]), _vm._v(" retracted its odd accusation."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-68",
      "id": "ch01-068-68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The April 5 judiciary committee hearing took place in front of "), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("another overflow crowd, with the proponents’ prominent physicians—James Raglan Miller, Charles Comfort from the Medical Society, and Representative Converse—supplemented this year with New Haven attorney James Wayne Cooper and Episcopalian clergyman William T. Hooper, the former league president. Dr. Comfort declared that if the law was not changed, “it is high time there were some prosecutions under it,” and recommended that “if evidence of violation is to be secured, a law officer should be stationed in each bedroom, bathroom, and doctor’s office.” Cooper argued that without a medical exception, the law was probably unconstitutional under both the Connecticut Constitution and the Fourteenth Amendment to the U.S. Constitution, as an unreasonable infringement of guarantees protecting individual life and liberty. Reverend Hooper added that “It is the sacred right of each and every individual person to determine the size of his family.” For the opponents, four state senators were joined by four M.D.s, as well as by Louise Fisher, this year officially representing the Bishop of Hartford, Maurice F. McAuliffe, plus a spokesman for the Knights of Columbus. The Knights representative called for passage of a bill prohibiting lectures about birth control, and one James W. Fitzpatrick of Waterbury denounced the bill as “the last gesture of an outworn, discredited, degenerate capitalistic system.” In rebuttal, Katharine Hepburn—whom one paper described as having “a striking resemblance” to her now-famous daughter—emphasized that “the greatest bulwark against immorality is happy marriage, and this bill will promote early and happy marriages.”")])]), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("Prospects for any affirmative committee action, however, looked very poor. Sallie Pease reported that “we thought that we had a fighting chance but the Senate has had an almost complete reversal. The reason is simply that they have had a FLOOD OF MAIL FROM THEIR CATHOLIC CONSTITUENTS,” and proponents would have to answer in kind. Hartford supporter Dr. Hilda Crosby Standish responded with a letter to the editor, asking rhetorically, “what kind of birth control shall we have in this state? Shall we have the boot-legged variety, which for the most part is dangerous to health, plus abortion for the foreign born who cannot read English?” Birth control proponents, she explained, were “mostly women interested in saving the health and lives of other women,” and what they proposed was “a safe and harmless method to be taught only by licensed physicians and only to married women who are ill.” Writing to state senators, Standish concluded, might help “save some woman’s life.” By early May, however, hopes had dimmed even further, with reports indicating that a tie vote ")]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("existed within the judiciary committee and that the bill would not emerge, and in early June senate chairman Kenneth J. Bradley confirmed that the bill was indeed dead."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-69",
      "id": "ch01-069-69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On Tuesday, June 4, the Connecticut League held its annual luncheon meeting in Hartford. As Sallie Pease later remembered it, the mood was “most discouraging.” “We had failed dismally in the Legislature and it seemed as though nothing but gloom had descended over the Connecticut Birth Control movement.” Before lunch the board heard an up-to-the minute report on the legislative impasse, and at the luncheon itself that news was shared with a larger group. Afterward Pease was approached by a Hartford woman, Lillian Leiterman Joseloff, whose husband operated a successful grocery store chain. There had been talk for several years, particularly in New Haven, about expanding upon the Greenwich program and opening a clinic actually "), _c('i', [_vm._v("in")]), _vm._v(" Connecticut, but nothing had come of the talk. Lillian Joseloff, however, was more direct: “I would like to finance a clinic in Hartford.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sallie Pease was more than eager to accept and agree. As she later put it, “we were determined not to become discouraged” and simply “wait until the next Assembly to again undertake the same campaign which had gotten us nowhere for the last twelve years.” Joseloff’s offer to support the first year of a clinic’s operation was more than enough to propel Sallie Pease into immediate action, and by the very next day she was writing to friends and potential advisors, soliciting their help. In less than three weeks’ time Pease put together an organizational structure and a board of sponsors for what would be called the Hartford Maternal Health Center, recruited two principal physicians, Hilda Crosby Standish and Eleanor Taylor Calverly, to see patients and fit diaphragms, and endorsed Dr. Standish’s plan to rent four rooms on the ground floor of an apartment building at 100 Retreat Avenue in Hartford, directly across from Hartford Hospital, for the clinic’s physical space. Standish had visited Sanger’s Clinical Research Bureau several times while she had been attending medical school in New York, and Pease herself made several quick visits to gain pointers from clinics operating in nearby states. On June 26, twenty-one members of the new board of sponsors attended a founding meeting at which Pease and Standish detailed their plans for the clinic, which would be open six hours every day to make appointments for the two afternoons each week—Tuesday and Friday—when the physicians would see patients. Standish aimed to hold the first actual clinic session on Tuesday afternoon, July 9—and, thirteen days later, she did."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-70",
      "id": "ch01-070-70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("Pease had recruited an impressive board of sponsors, but she, Standish, and their colleagues had two principal initial fears: publicity and legal vulnerability. One of her most important board recruits, prominent young attorney Lucius F. Robinson, Jr., gave her reassurance on the second score, and the Hartford press itself, Pease later explained, helped on the first: “when we were gathering people together in order to sponsor our clinic it reached the newspapers. We went to the newspapers, asked them to withhold the story for a while, told them our aims, our backers, and gave them full information.” They went along, and throughout the first three months of the Hartford clinic’s successful operation not a word of its existence appeared in either of Hartford’s two newspapers.")])]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("Since “the only advertising was by person to person,” the clinic’s initial numbers were modest, with a total of fifty-three patients seen by its doctors in the first eleven weeks of operation. Additionally, Pease and Standish mandated purposely strict rules as to which women could be seen by clinic doctors: “Married, living with husband, at least one child unless physically unfit for pregnancy, physically or economically unable to have another pregnancy at present and unable to pay for private care.” Fiscally the clinic—which cost a modest two hundred and fifty dollars per month to operate—was separate from the Connecticut League, with its own distinct—but very heavily overlapping—board, but physically the two organizations were hardly distinguishable, as the league moved its own office into the clinic’s rooms at 100 Retreat Avenue in early September."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-71",
      "id": "ch01-071-71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Hartford clinic’s publicity-free inception came to a sudden and unplanned end when Katharine Hepburn mentioned the new facility during a talk at Connecticut State College in Storrs on the evening of October 23 and the Associated Press put a story on the wire, thus forcing the hands of the Hartford newspapers. Lucius F. Robinson, Jr., moved quickly to head off any problems: “The birth control clinic confines itself strictly to advising married patients whose health, in the opinion of competent medical experts, requires the giving of such service,” he told the press. “I do not believe that the” 1879 anticontraception statute “was intended by its framers to preclude such action. If it is to be construed otherwise, then I believe that grave doubts exist as to its constitutionality.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Hilda Standish was surprised by the talk that there might be an actual threat of prosecution, but the Hartford papers said that “a complaint” had been filed with city prosecutor Nicholas F. Rago on October 24 and that “the possibility of legal action” was being studied. “No warrants for "), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("arrests had been issued by mid-afternoon,” the "), _c('i', [_vm._v("Hartford Times")]), _vm._v(" ominously reported, and the next morning’s "), _c('i', [_vm._v("Courant")]), _vm._v(" featured an unnamed clinic official—probably Sallie Pease—saying she was “awfully upset that the whole thing has come out so publicly. We have felt that our best work could be done privately, in cooperation with doctors and social workers” who referred appropriate needy patients. “We realize that the subject is controversial and we have no desire for antagonism.”")])]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Pease and Standish were nonetheless confident “that it was such a stupid law [that] it would never stand up in court,” and the Connecticut press wasted no time in coming to the clinic’s defense. The "), _c('i', [_vm._v("Hartford Times")]), _vm._v(" supportively declared that the clinic operators “have not set out to defy the law but to carry out a medical and sociological service,” and the "), _c('i', [_vm._v("New Haven Journal-Courier")]), _vm._v(" emphasized that there had never been a known prosecution under the 1879 law. “Its enforcement would require a police surveillance over the intimacies of family life [that is] apparently impractical.” But, the paper added, “whether such [birth control] advice can be forbidden under the state and federal constitutions is a question requiring settlement.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("On October 29, with prosecutors having made no move, the Maternal Health Center’s board met to review the situation. Lucius Robinson reported that Rago “does not wish to prosecute unless pressure is brought” upon him, and while there was some possibility that either Pease or Standish might be arrested, Robinson full well expected that nothing further would come of the matter. Dr. Standish asked the board “if some patients could be taken for economic reasons only,” but the issue was parried and it was reiterated “that there should be a strict rule that no patient should be taken unless she were referred directly by a recognized social worker or physician and that her social history should be checked up.” Robinson additionally recommended that each patient should sign her case history, and that “there must be a medical reason and only those whose health requires information should be accepted at present.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-72",
      "id": "ch01-072-72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The brief but successful Hartford crisis convinced the Greenwich women that they now could safely move their Port Chester clinic operation into Connecticut, and on November 15 the Greenwich Maternal Health Center saw its first patient in its new quarters at 191 Lake Avenue in Greenwich. Florence Borden Darrach, the chairman of the Greenwich group, had solicited an extensive review of their possible legal vulnerability from a prominent lawyer who lived in Greenwich, Luke B. Lockwood, and it at least partially reassured the women who reviewed it. Under the 1879 statute, now Section 6246 of the "), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("Connecticut Code, and a companion “accessory” statute, Section 6562, which provided for punishment of anyone who “aided or abetted” the commission of a substantive offense under 6246, it would first be necessary, Lockwood pointed out, for a prosecutor to prove that a female patient “had actually used the articles in question for the purpose of preventing conception, and second that the person charged with accessoryship did actually lend assistance to the principal. As you can imagine,” he went on, “the practical difficulties in the way of proving guilt under Section 6246 are very great and I doubt whether evidence could ever legally be obtained which would result in a conviction.” However, Lockwood added, “the question of whether or not a conviction could be obtained is entirely different from the question of whether or not the activities in question are legal or illegal,” and “it must be obvious … that the activities are illegal but that the chance of a conviction is fairly remote.” Of much greater practical concern, Lockwood warned, was a different provision also dating from the 1879 statute, Section 6244, which prohibited the possession of “any article or instrument of indecent or immoral use or purpose,” which Lockwood feared might be applied to diaphragms and other birth control supplies. In light of “the very real danger of prosecution” under that provision, anyone working for the Greenwich clinic “should be advised of the danger involved.” “I cannot help but feel,” he concluded, “that any such activity would be very unwise.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-73",
      "id": "ch01-073-73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lockwood’s comprehensive but cautious counsel did not cause the Greenwich women to hesitate, and as clinic operations moved forward both there and in Hartford, Sallie Pease became convinced that the extensive newspaper publicity had been all to the good, as the number of patient referrals increased steadily. New Haven and Stamford women were discussing opening clinics in their cities, and New Britain and Winsted supporters were planning to drive women from those towns to the Hartford clinic. Patient acceptance rules were being gradually liberalized, and a favorable early 1936 federal district court decision in a New York case involving birth control supplies that had been shipped from Japan to Dr. Hannah Stone was read by the Connecticut women as another sign that any possible legal problems could be overcome. When both Katharine Hepburn and Dr. Standish spoke at a January 13 meeting of Hartford birth control supporters, the "), _c('i', [_vm._v("Courant")]), _vm._v(" gave the event prominent coverage, and noted Standish’s report that the Hartford clinic had now had over two hundred patients, of whom, she added, “more than 50 per cent were Catholics.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The printing of that statistic, however, was enough to energize one "), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("Hartford priest, Reverend Andrew J. Kelly of St. Anthony’s Roman Catholic Church, who the following Sunday alleged that the Hartford Public Welfare Department and doctors at Hartford Hospital were instructing women clients to go the Maternal Health Center under the threat of losing aid if they did not. “Busybody humanitarians from West Hartford,” a wealthy suburb, should not “foist their kind of morality” on city residents, Kelly declared. Katharine Hepburn immediately denounced the allegation of coercion, but welfare department officials and hospital doctors offered only vague comments on the issue of referrals, with one physician telling the "), _c('i', [_vm._v("Courant")]), _vm._v(" that “It is too bad the subject has to be brought up.” Sallie Pease bluntly responded that “It’s a lucky thing that there are humanitarians in West Hartford who believe that it is merciful to save the life of a mother of eight children,” and the story quickly subsided. Several weeks later Pease in a Boston talk jokingly thanked Father Kelly for his help, saying “We have since been getting his parishioners,” and advising fellow birth control supporters that “I cannot make too strong an appeal [for you] to secure publicity every way you can.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-74",
      "id": "ch01-074-74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Throughout the spring and summer of 1936 the Connecticut clinic facilities continued to expand. A New Haven clinic began operating on May 11, and a Stamford one opened several weeks later. The Greenwich women began providing “visiting” clinic services in Danbury, Westport, and then Norwalk, and the Hartford clinic expanded its patient hours to three afternoons a week. Doctors Standish and Calverly, and Mrs. Hepburn, all kept up a heavy schedule of speaking engagements before church and women’s groups, and word of the league’s clinic services spread more and more widely. When the league’s annual meeting took place in Hartford in mid-June, Sallie Pease stressed that “The opening of more and more clinics all over the State is the work cut out for the League.” There had been ongoing talk as to whether any statutory reform effort should be mounted in the upcoming 1937 legislature, or whether it would be better to “continue as we are now” and “‘let a sleeping dog lie.’” At the meeting “it was decided to leave it entirely in the hands of the doctors and for the League to take no part unless it was requested to do so.” Worries about actual legal vulnerability under the existing statute had almost entirely ceased, as prosecutors to date had done nothing, and in early September Lucius Robinson confidently predicted that “I doubt very much if they ever do.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-75",
      "id": "ch01-075-75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On December 7, 1936, the U.S. Court of Appeals for the Second Circuit gave birth control proponents their most significant legal "), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("achievement ever when it affirmed the earlier district court ruling against the government’s efforts to seize birth control devices that had been shipped to Dr. Hannah Stone from Japan. Stone and Margaret Sanger’s lawyer, Morris Ernst, immediately heralded the ruling, "), _c('i', [_vm._v("United States")]), _vm._v(" v. "), _c('i', [_vm._v("One Package")]), _vm._v(", as “the end of birth control laws,” and later called the decision “the successful termination of a 60 year struggle.” By holding that the federal 1873 Comstock statute could not be applied in ways that obstructed public health, the appellate decision—much like the New York ruling in Sanger’s case almost two decades earlier—effectively meant that birth control could be prescribed and distributed in all instances where doctors believed that the avoidance of pregnancy would be beneficial to a woman’s health. Some commentators read the decision more modestly than Ernst, but most observers agreed that it was likely the final word, as the chances of review by the U.S. Supreme Court seemed slim at best. Sanger and her colleagues, including Katharine Hepburn, held two days of discussions in New York about the decision, and Hepburn emphasized that neither in Congress nor in Connecticut was there any practical value to further legislative efforts: with both clinics and the necessary supplies now fully available, Ernst was right: “I think we should say we have won.” Even Sanger was now persuaded, and she heralded the ruling as a long-sought triumph, “an emancipation proclamation to the motherhood of America.” Through the judiciary, she said, “an informed and potent public opinion finally found expression,” and legal scholars both then and in later years wholeheartedly agreed. The May 1937 issue of the "), _c('i', [_vm._v("Columbia Law Review")]), _vm._v(" observed that “it is difficult to escape the conclusion that the Comstock Act … has been almost emasculated by judicial nullification,” and one respected commentator later termed the "), _c('i', [_vm._v("Youngs Rubber")]), _vm._v(" to "), _c('i', [_vm._v("One Package")]), _vm._v(" set of holdings “a striking illustration of the court[s] adjusting a statute to changing public information and sentiment.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-76",
      "id": "ch01-076-76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Public opinion polling—just beginning to become dependable in the late 1930s—appeared to support Sanger’s interpretation: a clear consensus now existed among the American people that birth control information and supplies should be fully available to those married women and couples who desired them. A May 1936 American Institute for Public Opinion query asked respondents, “Should the distribution of information on birth control be made legal?,” and 70 percent of those who expressed an opinion said yes. A "), _c('i', [_vm._v("Fortune")]), _vm._v(" magazine survey several weeks later asked “Do you believe in the teaching and practice of birth control?,” a decidedly more intimate question, and received 63 percent yes. In July 1937 the American Institute asked “Do you favor "), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("the birth control movement?,” and found a 71 percent yes among those who offered an opinion. When the "), _c('i', [_vm._v("Ladies Home Journal")]), _vm._v(" asked women respondents “Are you in favor of birth control?,” 79 percent answered yes, including 51 percent of Catholic women. In 1937 North Carolina became the first of several states to offer birth control information through its public health program, and when in October 1938 the American Institute, picking up on this development, asked “Would you like to see a government agency furnish birth control information to married people who want it?,” 62 percent said yes and only 24 percent said no. By late 1939 those proportions had shifted to 71 percent yes and 18 percent no."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-77",
      "id": "ch01-077-77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One group that had been lagging significantly behind American public opinion, however, was organized medicine. While the Connecticut State Medical Society had endorsed the legalization of birth control back in 1931, the premier national doctors’ group, the American Medical Association (AMA), had avoided any affirmative statement despite intensive efforts by birth control proponents, particularly Dr. Robert L. Dickinson, to get the Association on record. Dickinson and Morris Ernst saw the "), _c('i', [_vm._v("One Package")]), _vm._v(" decision as a significant aid in prodding the AMA forward, and when U.S. Attorney General Homer Cummings announced in late January 1937 that the government would not even appeal the Second Circuit’s ruling to the Supreme Court, Ernst and Sanger’s National Committee heralded the legal development as “the liberation of the medical profession.” Some doctors, however, and particularly the Director of the AMA’s Bureau of Legal Medicine and Legislation, Dr. W C. Woodward, took a decidedly different stance toward "), _c('i', [_vm._v("One Package")]), _vm._v(". In early April the AMA "), _c('i', [_vm._v("Journal")]), _vm._v(" editorialized that the decision “has no reference to the right of physicians to advise the practice of contraception … or to prescribe or supply articles for the prevention of conception,” and explicitly criticized the National Committee’s statements: “This propaganda is essentially misleading.” When Ernst and several prominent colleagues submitted a letter of rebuttal, Dr. Woodward simply hardened the "), _c('i', [_vm._v("Journal")]), _vm._v("’s stance: “the committee’s propaganda seemed likely to bring physicians unwittingly into conflict with federal and state laws.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But Robert Dickinson and other birth control supporters on the AMA’s Committee on Contraceptive Practices, particularly Massachusetts’s Dr. John Rock, now had a clear majority of votes, and on June 8, the AMA’s House of Delegates formally adopted a committee report endorsing, the dissemination and teaching of the best methods of birth control. The "), _c('i', [_vm._v("New York Times")]), _vm._v(" called the action a “landmark "), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("in the annals of American medicine,” and printed extensive excerpts from the committee’s report in a front-page story. The AMA report read as if it could have been drafted by Sanger or Ernst, and it went out of its way to say that "), _c('i', [_vm._v("One Package")]), _vm._v(" also ought to control the remaining laws in places like Connecticut and Massachusetts: “Although the statutes in force in the several states that forbid the dissemination of information concerning methods for the prevention of conception do not in express terms exempt physicians from their operation, it seems fair nevertheless to assume that the state courts, if called on to construe them, will adopt lines of reasoning similar to those followed in the case cited and in other cases decided by the United States courts, leaving physicians free to give information concerning contraception when required to meet the medical needs of patients.” Sanger was so pleased that she termed the AMA action “really a greater victory” than "), _c('i', [_vm._v("One Package")]), _vm._v(" itself, and with seemingly all obstacles to the establishment of clinics all across the United States now removed, she and her colleagues dissolved the National Committee and declared victory."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-78",
      "id": "ch01-078-78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Connecticut Birth Control League was happily busy operating its four clinic facilities, all of which continued to chalk up steadily increasing numbers of new patients. The league and Connecticut’s doctors had passed up any 1937 legislative campaign, but the issue nonetheless had received helpful publicity when one of the legislature’s most bombastic members, Representative John G. Fitzgerald of Ansonia, had introduced an antibirth control bill specifying that “All members of the legislature who advocate birth control must be sterilized within 30 days after adjournment, by surgeons appointed by the government.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-79",
      "id": "ch01-079-79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")])]), _vm._v(" One young member of the Connecticut League, however, Catherine Jackson Tilson, a recent graduate of Yale Law School and a former patient of Hannah Stone’s, thought that the rosy legal predictions being offered by Ernst and Sanger were highly misleading, and shared her opinion both with her Connecticut colleagues and with Sanger. Tilson feared that optimistic observations “may do us considerable harm,” particularly in Connecticut, because they raised the danger of “antagonizing now latent opposition.” She personally believed that any Connecticut court case would come out favorably, but “an adverse decision is not without the realms of possibility.” Morris Ernst, however, remained fully optimistic, and he told a Hartford audience of birth control supporters that any legal risks were minimal: “I am of the opinion that no locality will successfully attack any practice approved by the federal courts.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-80",
      "id": "ch01-080-80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On June 3, 1937, however—just five days before the AMA’s formal "), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_vm._v("ratification of its landmark birth control resolution—Lieutenant Charles Duffee of the Salem Police Department and three colleagues, armed with a search warrant signed by John J. McGrath of the Salem Board of Health, arrived at the North Shore Mothers Health Center in Salem, one of seven birth control clinics now being operated by the Birth Control League of Massachusetts. As they knew—for undercover policewoman Beatrice V Clark and a female colleague had just left the clinic—Dr. Lucille Lord-Heinstein was in the midst of seeing patients, and the patients were detained and questioned while the officers packed up the clinic’s medical records and supplies. While the staff “displayed marked calmness and at times amusement at” the police methods, Dr. Lord-Heinstein, nurse Flora Rand, and social worker Carolyn T. Gardner were taken to Salem police headquarters for questioning, and all three women were charged with violating the Massachusetts birth control statute by distributing contraceptive devices.")])]), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The Salem clinic had been operating for seven months, and the BCLM had heralded its opening by announcing that it had “the backing of a large committee from Salem and nearby towns, comprised of leading physicians, ministers, public spirited citizens and representatives from the boards of welfare agencies.” The BCLM had also noted that in the opinion of its lawyers, the prominent Boston firm of Palmer, Dodge, “advice given for medical reasons does not come under prohibitions of our statutes,” and in April 1937, when the chief of police in Fitchburg and local Catholic clergy had raised questions about a new clinic that the league had opened there, the league’s attorneys had successfully impressed the chief by stressing that six other clinics were already operating across the state.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_vm._v("But when the three Salem defendants appeared in court on June 22, Judge George B. Sears refused to return the patient records that had been seized and set trial for July 13. The prosecution’s first witness that day was Policewoman Clark, who testified that she had first visited the Salem clinic in late May under a false name, and then had returned on June 3 along with a civilian woman, Rose Barlotta, whom she had paid for her assistance. Mrs. Barlotta had been examined, was found to have severe hypertension, and was fitted for a diaphragm, which she had then turned over to the officers as evidence. Defense attorney Robert G. Dodge put all three defendants, plus three well-known Massachusetts doctors and prominent clinic chairwoman Dorothy Bradford on the stand, and Judge Sears said he would reserve his decision. Dodge filed a posttrial brief that Sears commended as “very able,” ")]), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("but one week later, on July 20, Sears entered a verdict citing the 191 Massachusetts Supreme Judicial Court affirmation of Van Kleec Allison’s conviction and concluding that “I must find the defendant guilty” even though they did not believe “they were acting contrary to law.” He imposed a fine of one hundred dollars upon each of the defendants, and the league filed notices of appeal."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-81",
      "id": "ch01-081-81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Two weeks later, on the evening of August 2, vice squad officer interrupted a clinic session at the Brookline Mothers Health Office the Massachusetts League’s oldest facility. They seized all of the clinic’ supplies, one medical file, and identified and questioned the eight patients who were present. “The raid was conducted in a very courteous manner,” Dr. Ilia Galleani reported, “except when one of the lieutenants asked one of the new patients if she were a single woman. To this she replied indignantly that she had seven children and had had eight.” Criminal charges were soon filed against Dr. Galleani, and the very next morning Boston police arrived at the South End Mother Health Office. Lacking a warrant, the clinic staff refused them entry and promptly removed all records and supplies from the office before the officers returned that afternoon. At that same time other officer visited the headquarters of the Massachusetts League and questioned president Linda M. Hawkridge and staff member Caroline Carter Davis, both of whom were charged and then arraigned the following day. Shell-shocked by the rapid-fire succession of raids and arrests, the league board, with only one member dissenting, quickly voted to close all clinics in the state “temporarily.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Linda Hawkridge sought to take a somewhat more confident stance in public than the doctors and league members exhibited in private “We gladly welcome this investigation, which we hope will clarify the Massachusetts law,” she told reporters. “We have no intention of breaking the law, and we have nothing to hide. We have never denied that we gave contraceptive advice, for we consider that a doctor has the right to do what he can to preserve the life of his patients.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-82",
      "id": "ch01-082-82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ilia Galleani’s September 15 trial was the next legal step for the Massachusetts League. Two Brookline police officers testified that they had gathered their evidence against Dr. Galleani by secretly sitting under a clinic window one evening a week before the raid and listening to her conversations with patients. Galleani herself took the stand, and defense attorney John M. Raymond attempted to emphasize the "), _c('i', [_vm._v("One Package")]), _vm._v(" precedent to Judge Philip S. Parker, but Parker, like Sears in the Salem case, was unpersuaded. “There is a great difference, in my mind between advice given privately by a physician in a particular case to "), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_vm._v("preserve life and an office that is openly conducted like this with free administration and advice to anybody who might apply.” “To open a clinic,” he added, “does not come within the purview of the statute or of the decisions, and to open a clinic may lead to abuse.… Of course,” Parker went on, “contraception may be a good thing. Many people believe in it—I do—although a large number of persons in our community do not believe in it. But there you get into the legislative field, and it would be absolutely improper for a court to say that birth control ought to be practiced. That is a legislative proceeding entirely. While I might be in favor of it, it is not my province to pass on that question.” Dr. Galleani, he said, was guilty, and would be fined four hundred dollars."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-83",
      "id": "ch01-083-83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Within the following week the cases against the three Salem defendants, plus a fourth colleague, clinic volunteer Pamelia Ferris, were set for a hearing in Superior Court, and initial proceedings took place in the cases against Hawkridge and Davis. On October 6 they were found guilty and fined two hundred dollars each, and on October 15 Essex County Superior Court Judge Wilford D. Gray upheld Sears’s verdicts against Lord-Heinstein, Gardner, and Rand, and also levied a hundred-dollar fine against Ferris. BCLM leaders were most pessimistic about the cases against Hawkridge and Davis, who were being prosecuted for the general distribution of birth control literature, rather than for medical instruction of individual patients, as in the Salem and Brookline cases, but everyone involved was shaken. Ilia Galleani told league vice-president Loraine Campbell, “How sad that all that we worked for has been suddenly smashed. I sincerely hope that it will be temporary for the sake of all those poor women who needed the advice so badly.… But let us hope that the higher courts will judge in our favor. It seems difficult to believe that they will not.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("League activists were upset that most of the trial proceedings had been marked by an “absolute failure to show what our work really consisted of,” but the lawyers managed to postpone any further proceedings in either the Brookline or Boston cases while appeals of the Salem convictions went forward to the Massachusetts Supreme Judicial Court. In New York, preeminent birth control lawyer Morris Ernst made light of the Massachusetts worries. “It will take an aroused medical profession to influence the judiciary in Massachusetts,” he told one medical audience, but “I am not much worried.” “If the cases in Boston are fought, as I am sure they will be, in a forthright manner, and if you doctors and lawyers and people with the same point of view will pass your resolutions along to the birth control people in Boston "), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_vm._v("and will give them support, there is no question of the outcome. I say that for this reason: I do not believe there is any such thing as law in the abstract.… The law is nothing more or less than the pressure of public opinion at any particular time on particular judges.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-84",
      "id": "ch01-084-84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fifteen Massachusetts doctors, including John Rock, wrote to the membership of the Massachusetts Medical Society to ask that each doctor join in a statement of protest. “Two fundamental rights of physicians have been violated,” they declared. “First, in the seizure and holding of confidential medical records by the police; second, by police interference with the right of physicians to practice medicine in accordance with accepted methods.” Both "), _c('i', [_vm._v("One Package")]), _vm._v(" and the June AMA resolution had backed “the rights of physicians to give contraceptive advice,” they emphasized, and within several weeks more than seventeen hundred Massachusetts doctors, more than one third of those in the state, joined their petition of protest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ernst might hope that such statements would be determinative, but the Massachusetts women already were seeking their lawyers’ reassurance that the Salem case could be appealed to the U.S. Supreme Court in the event that the Massachusetts court, which would hear the appeal in early February 1938, affirmed rather than reversed the convictions. One person, however, who was vocally unhappy with the way that Massachusetts matters were being handled was Katharine Houghton Hepburn, and as usual she minced no words in stating her opinion. Telling Massachusetts League president Linda Hawkridge that “I am sorry to have said anything that annoyed you,” Hepburn nonetheless insisted that the Massachusetts women were erring seriously: “I can’t help feeling that going to jail is better tactics than paying fines. Have no fines been paid anywhere in Massachusetts? I spoke in Springfield and they had just closed up the clinic without the police even asking them to. It just seemed to me foolish.” Perhaps the Massachusetts League needed more aggressive lawyers, Hepburn volunteered, such as New York’s Morris Ernst."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-85",
      "id": "ch01-085-85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Aside from Hepburn, the Connecticut women had paid the Massachusetts crisis relatively little heed. Busy with expanding and extending clinic operations across the state, Sallie Pease and her colleagues pressed ahead with plans to start additional clinics. The Hartford Maternal Health Center, helped by twelve volunteer interns from Hartford Hospital, had seen almost seven hundred new patients in calendar 1937. A New London doctor, Dorothea H. Scoville, was fitting diaphragms for every needy woman whom league supporters in that area referred to her, and a new clinic had just opened in New "), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_vm._v("Britain. Essential to Pease’s expansion plans was the hiring of a skilled, part-time field worker, someone who could approach and draw together interested potential clinic sponsors in the two major Connecticut cities, Bridgeport and Waterbury, that still lacked clinics. Seeking to reach beyond the very modest fifteen-hundred-dollar annual budget of the Connecticut League, Pease mentioned her hope to Clarence J. Gamble, a wealthy and idiosyncratic nonpracticing Pennsylvania doctor who was affiliated with neither Sanger nor the American Birth Control League but who was actively subsidizing the establishment of new clinics. Gamble told Pease he would be happy to pay half of the salary for such a field worker, and recommended that the league hire forty-five-year-old Leah Tapper Cadbury, a Haverford native and Bryn Mawr graduate with an “attractive personality” who had done birth control work in Philadelphia for Gamble after previously serving as a volunteer nurse during World War I and as executive secretary of the Women’s Educational and Industrial Union of Boston. Cadbury, Gamble said, “would be very effective as an organizer,” and Pease, overjoyed by the recommendation, immediately agreed and sent Cadbury a telegram inviting her to Hartford two days later. On November 15, 1937, Leah Cadbury—with one half her salary paid by Gamble, and the other half by Hartford’s Lillian Joseloff—began work in Bridgeport for the Connecticut League."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-86",
      "id": "ch01-086-86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cadbury’s work in Bridgeport went exceedingly well, and on January 25, 1938, she spoke with her initial Waterbury contact, Anne Chase Hart, a daughter of one of Waterbury’s most prominent families, the founders of the Chase Brass Company, and visited with two local physicians, Joseph L. Hetzel and Waterbury Medical Association president J. Harold Root, both of whom reacted enthusiastically to the idea of a Waterbury clinic. Anne Hart gave Cadbury the names of other Waterbury women, including her sisters Edith Chase and Mildred Chase Ely, and her sister-in-law, Florence Chase, who might be supportive, and on January 29 Cadbury returned to Waterbury intent on organizing an initial meeting of potential clinic sponsors. Some Waterbury residents were preoccupied by the burgeoning news reports of the financial scandals within the city government, but Cadbury was able to schedule a meeting for Monday afternoon, February 7, at the downtown home of Ruth Northrop, and also visited with Waterbury Hospital superintendent Dr. B. Henry Mason and with several Protestant clergymen. She tried firmly but unsuccessfully to persuade Mason to attend the meeting, telling him it would be “quite inadequate without you.” “The public medical service in Waterbury is so "), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_vm._v("completely your province that we can make little progress without your direction and criticism.” One of the clergymen did agree to attend, and another recommended, perhaps surprisingly, that she call on two Roman Catholic clergymen, Eugene P. Cryne and Joseph Valdambrini, and she did. As Cadbury reported back, “I have seen both Father Cryne and Father Valdambrini. Each explained that he could not possibly come to the meeting, but we had, to me, an interesting and delightful interview. Thank you for your suggestion that I see them.”")])]), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_vm._v("The two-hour February 7 meeting at Mrs. Northrop’s drew thirty-two women and the sole clergyman. Cadbury had carefully arranged for Lillian Joseloff, Dr. Eleanor Calverly, and administrator Mabel Robbins from the Hartford clinic to arrive during a break halfway through the session, but first she spoke about the prospects for a Waterbury clinic and invited those present to offer their comments. “Some people thought that no immediate action could be taken at this meeting because they didn’t want to rush into something while they are all upset by the scandals in their city government,” Cadbury reported, but then “Miss Edith Chase suggested, and others agreed, that they all ought to go home and think over the possibility of starting a clinic, and then get together about a month hence, when they could decide if they would like to try to open a clinic with help from the League.” Then Dr. Calverly described to the group how a clinic operates, and the meeting adjourned. “I am much encouraged,” Cadbury wrote to Sallie Pease, “first by the number and the quality of the women there; and second by their suggesting themselves a plan for future activity instead of leaving this to me.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-87",
      "id": "ch01-087-87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cadbury quickly followed up on her initial success. Writing to Edith Chase to thank her for her “very wise” suggestion of a second meeting, Cadbury said she wanted to send out a letter describing the first session to people who were not present but might be interested, and hoped she could include a date and place for the second meeting. Chase responded by suggesting Monday afternoon February 28 at her sister Mildred Ely’s home, but emphasized to Cadbury that the Waterbury women had a particular concern: “Many are interested in the legal side of the matter—and it would be worthwhile, I think, to have some sheets of printed matter showing exactly the Connecticut laws on the subject.” Cadbury then sent out more than ninety copies of a letter describing the first meeting, inviting people to the second, and enclosing several sheets that discussed Connecticut clinics and the law. “A few doctors in the city are already giving contraceptive advice to poorer residents at little or no charge,” she informed her recipients. “It was the feeling of "), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_vm._v("the group” at the first meeting, “however, that a local, properly organized, birth control service is much needed; and that, even if some obstacles now stand in the way, means may be found to remove or avoid them.” Cadbury stated the potential obstacles frankly: “Will some groups in the city be actively hostile?” “Is it dangerous to attempt anything in Waterbury just now which may be illegal?” She closed by encouraging everyone to visit the Hartford clinic whenever might be convenient, and wrote to Sallie Pease that her expectations for Waterbury were very bright: after the second meeting, she estimated, “I doubt if there will be any need for me, even in organizing a committee for a center. All of the women interested are experienced in such work—they know how to form good committees, and how to raise money.”")])]), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_vm._v("Cadbury’s upbeat portrayal of the first meeting, however, drew gentle dissents from some recipients of her letter. Mildred Ely emphasized that while she was happy to host the second session to discuss a clinic, “I am not yet interested enough in it to sponsor it here in Waterbury and am very decidedly against starting a clinic here at the present time,” since other existing local charities were already finding it difficult to secure funds and “it would be almost impossible to raise enough money to get it started.” Ely’s sister Anne Hart, Cadbury’s initial contact, sounded a similar but different note while apologizing that she would be out of the state and unable to attend: “I do feel that there is much feeling of opposition right now in town and think a later time might be better.” Edith Chase and others, however, told Cadbury that the number one reason for hesitation was fear of legal trouble. “I have the greatest sympathy with the dread which many of you feel about any possible difficulties with the law,” Cadbury wrote one concerned woman, but “it appears incredible, however, that any group as astute as the Catholics could attempt a prosecution under the Connecticut law.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-88",
      "id": "ch01-088-88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Only twenty-two people attended the February 28 meeting, in part because of bad weather, but two doctors, two ministers, a hospital social worker, a female employment supervisor at Scovill Brass, and an experienced former nurse were among those who did. The two doctors spoke condescendingly about how inept poorer patients had proven to be with diaphragm usage, and Miss Ruth A. Davis, the social worker, indicated that she sometimes provided contraceptive advice to hospital clinic patients. “The two ministers,” Leah Cadbury later reported, “were surprised to hear that reputable doctors gave contraceptive advice. They had often wanted it for their parishioners, but had not dared to ask for it, thinking that the doctors would be offended.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_vm._v("But then the most significant comment in the meeting, indeed the most significant event in Leah Cadbury’s time in Waterbury, suddenly took place. Clara Lee McTernan, a thirty-nine-year-old former nurse who had not been present at the first meeting, “offered to try to start a transportation service,” taking Waterbury women to the Hartford clinic. Until that moment, Leah Cadbury’s initially optimistic hopes for Waterbury had looked increasingly uncertain. The Chase sisters had appeared to be backing away from any possible sponsorship of a clinic, legal concerns appeared widespread, the disappointing turnout for the second meeting was ten people fewer than had attended the first, and Cadbury’s own time in Connecticut was soon coming to an end. But Clara McTernan meant what she said, and Millicent Pond, the Scovill supervisor, quickly volunteered that she would be willing to drive. For Leah Cadbury, the remainder of the discussion was of lesser significance, and afterward she spoke with both McTernan and Pond. The very next day Clara McTernan drove to Hartford to meet the clinic staff there, and Mabel Robbins “showed her all the workings of the Hartford Center.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-89",
      "id": "ch01-089-89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Writing to Sallie Pease, Leah Cadbury could scarcely contain her delight at the emergence of Clara McTernan. “I believe that she will accomplish something,” Cadbury predicted. McTernan had lived in Waterbury for six years, since her 1932 marriage to widower Charles C. McTernan, seventeen years her senior and founder and headmaster of the McTernan School for boys. Clara, a nursing graduate of St. Barnabas Hospital in Newark, had initially worked as a nurse in the Newark public schools and at a summer camp that Charles McTernan and his first wife operated on the Connecticut shore in Old Saybrook. Two years after the 1930 death of the first Mrs. McTernan, Clara had married Charles, who had two college-age sons, and had moved to Waterbury and begun working at the family school that adjoined their home on Columbia Boulevard. “She has been much concerned,” Leah Cadbury told Pease, “at the lack of facilities for giving the poorer women contraceptive advice.” As a school nurse in Newark “she made constant use of the maternal health center there, and is entirely familiar with clinic service.” And, given the social prominence of the McTernan School, “she is in touch with many people in Waterbury.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mabel Robbins had given McTernan the names of all Waterbury-area women who had visited or written the Hartford clinic. “Her immediate plan,” Cadbury explained, “is to go to some ministers and directors of welfare agencies and offer to arrange transportation of women whom they may want to send to Hartford, provided they will "), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_vm._v("take care of the clinic fee of three dollars for each patient. She hopes to make arrangements for four women by the end of the month.” Additionally, Cadbury would pass on to McTernan the “card file of more than 100 names of the people with whom I have had some contact, or of whose real interest I have learned, so that she will not have to break ground anew for herself, but she has a hard job ahead of her.” The Chase sisters, Cadbury conceded, “do not want to take any active part in the work,” although they might be persuaded to make modest financial contributions. Any idea of trying to establish an independent clinic, Cadbury went on, was almost certainly unwise, particularly because fund-raising obstacles might be heightened further if emergency tax assessments were imposed on residents to make up the large municipal deficit that was one product of the city’s newly revealed financial scandals. But also, Cadbury mentioned for the first time, trying to finance an independent Waterbury clinic might simply prove unnecessary as “there seems to be a good chance of introducing birth control into the maternal health service of the Chase Dispensary, in the not impossibly distant future.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-90",
      "id": "ch01-090-90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Little more than two weeks after her initial visit to the Hartford clinic, Clara McTernan took her first two patients there for a fitting. Leah Cadbury, back home in Pennsylvania, told McTernan she was overjoyed at the news: “Eighteen days to get going! You compete with radishes for speed!… I have been thinking with much appreciation of your courage and determination to start some kind of birth control work in Waterbury,” and explained how “one of the advantages of birth control work over other social reforms is that "), _c('i', [_vm._v("individuals")]), _vm._v(" can really accomplish something! You could slave yourself to death for peace and not make a dent in the armed frontiers of the world, but already you’ve g[iven] two whole families a tremendously important boost toward a fundamentally sound home life. They can never be completely hopeless and without some control over circumstances again. It’s the effectiveness of individual effort in this work that I find so perfectly thrilling.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cadbury also reminded McTernan of the additional plans they had both discussed for Waterbury, and recommended she talk with Edward H. Davis, an enthusiastic supporter and a colleague of Millicent Pond’s at Scovill, about “mapping out your final approach to the Hospital Board about using the Dispensary. I wish you could wangle it somehow so that you don’t have to ask them to approve or disapprove of birth control, but take advantage of Dr. Mason’s statement: ‘It’s none of our business what the doctor and the patient talk about. We hire him "), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_vm._v("to do a good job, and what he prescribes is up to him and the patient.’” Hence, Cadbury suggested, “Perhaps without going to the Board officially, you can make the arrangements with the doctors themselves. But connecting with the Dispensary is work for the future. I think that you are starting in just the right way to build up interest and a demand for local service.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-91",
      "id": "ch01-091-91",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("91")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Less than a month after Clara McTernan took her first patients to Hartford, the other portion of Leah Cadbury’s Connecticut work came to fruition as a committee of Bridgeport area women publicly announced that a clinic would open there on May 1. The following day city prosecutor John P. Flanagan said that unnamed opponents of the clinic had asked him to examine the matter, but within twenty-four hours Flanagan told reporters that “there are no statutes prohibiting such a clinic and that, therefore, he cannot act in the matter.” Flanagan added that “instructions will be given to … the police department that plans for the clinic will not be stopped and that there must be no move toward prosecution, as had been demanded by several of the complainants.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-92",
      "id": "ch01-092-92",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("92")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If prospects for the future seemed bright in Connecticut, such was not the case in Massachusetts, where the Birth Control League’s appeal of the Salem convictions had been argued before the state Supreme Court by attorney Robert G. Dodge on February 7 and 8. Dodge had filed an impressive seventy-page brief with the Massachusetts court, giving particular emphasis to the "), _c('i', [_vm._v("One Package")]), _vm._v(" precedent, and a supporting amicus brief had been submitted on behalf of twenty-one doctors, including John Rock and a former state medical society president, Channing Frothingham. Essex County assistant district attorney John J. Ryan, Jr., answered with an exceedingly modest seven-page submission that argued a simple but basic theme: “If the Legislature had intended to make any exceptions in favor of doctors, nurses, social reformers, or any other class of individuals, it would have been a simple matter to expressly state the exception in the statute” prohibiting the distribution of birth control devices, Ryan stressed. “If these defendants are dissatisfied with the existing laws of this Commonwealth, they should address their complaint to the Legislature.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Even Dodge himself felt that the Massachusetts’ judges questions at oral argument had been “not very encouraging,” but he told league president Linda Hawkridge that if they lost there they should “certainly” appeal to the U.S. Supreme Court. “I do not like to predict the decision of that court on any constitutional point, but I should say that the chances would be sufficiently good to make it distinctly advisable to take "), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_vm._v("the case to Washington.” But some interested observers were still convinced that the Massachusetts League was mishandling the situation, and Katharine Hepburn remained among the most vocal complainants. “I am awfully sorry to have bothered you by things that I have said,” she once again apologized to the Massachusetts leaders, “but closing the clinics, even in towns where they were not raided and appealing cases instead of just refusing to pay the fines is to me—well, I’d better not say what I think. I just wish that you’d had Morris Ernst for your lawyer instead of what you’ve got. I don’t know him—not even his name—so there’s nothing personal about it—but I hope that I don’t meet him on a dark night—I might shoot him. Seriously, I wish you the best of luck and will try to keep my mouth shut—but it’s hard.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-93",
      "id": "ch01-093-93",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("93")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But Hepburn’s best wishes did not do the trick, for on May 26 the Massachusetts court unanimously affirmed the Salem convictions, fully accepting Ryan’s contention that the federal and New York precedents notwithstanding, it was not the province of the judiciary to create exceptions to inclusive statutory language. “The relief here urged,” the court said, “must be sought from the law-making department and not from the judicial department.” The Massachusetts League announced that it was “undaunted” and would appeal to the U.S. Supreme Court. It criticized the Massachusetts ruling as “a decision so out of touch with the realities of the world,” and attorney Dodge told Linda Hawkridge that their appeal to the Supreme Court would focus on the issue of “whether a state legislature may interfere with the practice of medicine under the guise of the police power” regulation of morality and health.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But now even Hawkridge was wondering whether the Massachusetts League should stick with stodgy and proper Robert Dodge, and on June 14 she called on prominent Harvard Law School professor Felix Frankfurter, widely noted as a potential nominee for both past and future Supreme Court vacancies, to seek his advice on whether the league should replace Dodge with New York’s Morris Ernst. Frankfurter’s recommendation was clear and blunt: “Mr. Ernst is a friend of mine and is a fine person for this Jersey City type of thing [a reference to an ongoing case in which Ernst was representing labor union organizers against tough Jersey City Mayor Frank Hague and his political machine], but he is not the person for the United States Supreme Court. Mr. Dodge is.” Frankfurter cautioned Hawkridge, however, that the league’s chances might not be good no matter who argued their case, for “everything that is foolish and socially wrong is by no means unconstitutional.” Dodge’s best strategy, Frankfurter "), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_vm._v("hinted, would be to employ the social and health policy emphases of a “Brandeis brief,” but he added that “More I ought not to say.”")])]), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_vm._v("The Massachusetts outcome also finally raised serious worries in national birth control circles, with Margaret Sanger terming the decision “the most serious setback the movement has ever had.” But while Ernst agreed with Dodge that a Supreme Court appeal was essential, and while Ernst’s junior associate Harriet Pilpel told birth control leaders that "), _c('i', [_vm._v("Gardner")]), _vm._v(" would be “one of the most important cases ever to go before the court,” another prominent birth control lawyer, Charles E. Scribner, contended that any such appeal “would be utterly futile” since the Massachusetts court was clearly correct that statutory changes must be made by the legislature. To settle this strategic disagreement, both Sanger and the leaders of the American Birth Control League, along with Dodge and Hawkridge, convened a lengthy late June meeting in New York. Everyone present agreed that there was much to gain and little to lose by pursuing an appeal, and one ABCL legal advisor reported that he had even half persuaded Scribner, who was absent, that an appeal was the best course. Without any dissent the meeting formally voted to endorse an appeal, but also to do everything possible to keep publicity about the case to an absolute minimum. Six weeks later Dodge filed his petition for Supreme Court consideration, and the Massachusetts Attorney General’s office informed the Court that they would file no opposing papers until the justices ruled in early October on whether they would hear the appeal. Many New England birth control workers, however, were far more pessimistic than the lawyers. Dr. Mabel H. Pearson, who supervised the Connecticut League’s Danbury clinic, wrote to a friend who worked for the Massachusetts League that “to press this legal fight in Massachusetts” was “a great pity.” “The law is on the statute books, the courts are bound to confirm it, and it is most unlikely to be considered unconstitutional. The legal battle causes a great deal of most unfortunate publicity, and its failure gives tremendous impetus to the antagonists of birth control, especially the Catholic faction. They are now only waiting for the final adverse decision to demand a show-down in Connecticut and this may easily result in our clinics being closed also. It would seem to be a much better plan (and this is the considered opinion of many in this state) to abandon the losing legal fight which only clinches the unfortunate result, and to concentrate your money and resources and influence in trying to change the law” in the legislature. Any Supreme Court victory “is most unlikely … and I fear very much that the birth control movement will suffer a bad set-back from this attempt to force their hand.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-94",
      "id": "ch01-094-94",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("94")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_vm._v("In Connecticut, however, all tangible developments continued to be favorable, and league leaders certainly did not share Pearson’s bleak forebodings. Sallie Pease told the CBCL’s annual meeting in early June that “the wind is blowing our way and our ultimate objective—the recognition of birth control as an established social service to the community—is coming slowly but surely.” New state board members elected at that meeting included Clara McTernan, and by late that summer McTernan’s efforts to begin providing birth control services at the Waterbury Hospital’s Chase Dispensary in downtown Waterbury were well on their way to fruition. Undoubtedly Clara McTernan’s most important new Waterbury recruit was a young man whom she had known for years, ever since he had served as a counselor at Charles McTernan’s summer camp while an undergraduate at Yale—William A. Goodrich. A Waterbury native whose father had practiced medicine there until his death in 1929, Bill Goodrich had graduated from the Loomis School, then Yale, and had entered Columbia Medical School in 1931. When he graduated four years later, he went on to a two-year internship at Hartford Hospital, and he had been one of the dozen young interns who had worked with Hilda Standish and Eleanor Calverly at the Hartford Maternal Health Center. In the summer of 1937 he had married and opened his own obstetrics and gynecology practice in Waterbury, and in the summer of 1938 he readily accepted Clara McTernan’s request that he become the lead doctor for what would be called the Waterbury Maternal Health Center.")])]), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_vm._v("Bill Goodrich in turn recruited as a second doctor for the clinic his new friend Roger B. Nelson, an obstetrician who had moved to Waterbury hardly two months earlier after graduating from Cornell Medical School in 1934 and then taking internships and residencies in Rochester and New York City. Nelson had been drawn to Waterbury by one of the city’s senior obstetrician/gynecologists, Dr. Charles L. Larkin, who served as the chief of gynecology at the Waterbury Hospital’s Chase Dispensary and whose son had just graduated from the McTernan School. McTernan discussed with Goodrich her hope of offering birth control services at the Chase Dispensary, either under the auspices of the weekly gynecology clinic or under the auspices of a new and distinct birth control clinic, and Goodrich spoke to a number of the other doctors on her behalf. By mid-September McTernan had recruited another woman with nursing training, Kathryn Jennings, to help her in assisting the two doctors at clinic sessions, another interested supporter, Harriet Griggs, to serve as clinic treasurer, and one of the young Junior League members who often assisted at dispensary clinics, Virginia Goss, to keep the clinic’s records. She wrote to hospital ")]), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_vm._v("superintendent Dr. Mason to ask formal permission for once-a-week use of two rooms at the dispensary, and with most of her preparations complete, she drafted a proper statement of purpose for the nascent Waterbury clinic:")])]), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_c('p', {
    staticClass: "blq-indent"
  }, [_vm._v("Believing that there is a definite need for a clinic where the poor of Waterbury may go for scientific advice about birth control, it is our aim to establish such a clinic in Waterbury. We shall ask the Board of Directors of the Waterbury Hospital to let us use rooms in the Chase Dispensary for this clinic, but it is to be a separate organization and is not to be connected with the Hospital or Dispensary in any way. Funds for its maintenance are to be raised by volunteer subscriptions.")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent1"
  }, [_vm._v("The clinic will be known as the Waterbury Maternal Health Center and will be affiliated with the Connecticut Birth Control League and the Birth Control Clinical Research Bureau of New York City. Records will be kept according to standards set up by these organizations. It will have a Board of Sponsors of about fifty representative Waterbury citizens.")])]), _c('p', {
    staticClass: "indent1"
  }, [_c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_vm._v("Three doctors—Charles L. Larkin, Charles Brown, who had attended one of Leah Cadbury’s meetings, and John G. Foster, another local birth control supporter—“will be the advisory physicians in charge,” McTernan wrote. “Dr. William Goodrich and Dr. [Roger] Nelson will be the acting physicians. At each clinic session there will be a graduate nurse and a secretarial worker in attendance. The services of these workers as well as the services of the doctors will be given without charge.” Information and supplies, she added, “will be given only to married women living with their husbands,” and “the object of this organization is to serve women of limited means.” By early October, without personally having spoken with either Mason or any of the three physicians who ostensibly would be “in charge,” Clara McTernan nonetheless was just about ready to begin conducting weekly Tuesday morning birth control sessions with her young recruits in second-floor rooms at the hospital’s Chase Dispensary."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-95",
      "id": "ch01-095-95",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("95")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On Monday morning October 10, 1938, the United States Supreme Court, in a ruling that stunned and dismayed the birth control lawyers, dismissed the Massachusetts League’s appeal of the Salem convictions. At nine a.m. the very next morning, Tuesday, October 11, Clara McTernan arrived at the Chase Dispensary to begin the first of the Waterbury clinic’s weekly sessions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If the "), _c('i', [_vm._v("Gardner")]), _vm._v(" ruling had no immediate effect on Clara McTernan, however, it shocked and disheartened the Massachusetts and New York activists. Robert Dodge told Linda Hawkridge that “I did not expect "), _c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_vm._v("that the result would be what it is, namely a decision on the merits to the effect that our attack upon the constitutionality of the statute is without any substantial basis.” On Friday the four Salem defendants appeared in court and each paid their hundred-dollar fines, and several days later Hawkridge and Caroline Carter Davis, the defendants in the separate Boston case, withdrew their appeals and each paid their fines of two hundred dollars.")])]), _c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("In New York Morris Ernst and his colleagues now thought that the Massachusetts League had made a huge error in allowing the Salem case to go to the Supreme Court without a detailed account of the clinic’s actual birth control work being included in the record of the appeal. “Interpretation of the statute,” Ernst later wrote, “was asked of the Court in the most abstract and lifeless terms.… No specific evidence was introduced. No particularized human problem was presented,” and in the absence of such, “a naked statement as to clinic procedure was insufficient to stir the Court to a liberalized interpretation of the prohibitory statute.” Instead, Ernst’s junior colleague Harriet Pilpel suggested, what was needed was “a case in which a person’s life and health would be seriously jeopardized if birth control information were denied her.” If that was demonstrated at a trial, “It is not unreasonable to suppose,” Pilpel hypothesized, that “a different result might follow.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On October 19 Ernst visited Boston and told the Massachusetts League that while the "), _c('i', [_vm._v("Gardner")]), _vm._v(" outcome was “a tremendous blow” to birth control nationally, they had no choice but to fight. Ideally, he suggested, they might generate a new court case, perhaps one in which some prosecutor could be persuaded to contest the sale of a "), _c('i', [_vm._v("book")]), _vm._v(" concerning contraception to a willing doctor or to fight an action brought by a doctor and a patient. With Robert Dodge unwilling to serve as Ernst’s junior partner in any such endeavor, the Massachusetts women recruited Boston’s Samuel Hoar as new local counsel, but Katharine Hepburn, watching from Hartford, continued to insist that the best tactics of resistance were being ignored. Caroline Carter Davis replied that Hepburn was wrong: “the question of refusing to pay fines has been discussed again and again and the practically unanimous verdict is ‘Very harmful to the cause—an insane idea.’” Instead, Davis said, “we plan to stage other cases which will be of such a definite, appealing nature that it will be impossible for the courts to befog the issue. Our chance of winning them is very slight,” she conceded, “but we feel that they will furnish the best possible publicity for education should we have to resort to legislation.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_59"
    }
  }), _c('a', {
    attrs: {
      "id": "page_60"
    }
  }, [_vm._v("But recruiting a willing doctor, even from among the league’s leading supporters, proved seemingly impossible because of how a case that would imaginably risk any sort of conviction might thereby place the physician’s license to practice medicine in danger. Finally, in May 1939, just after deciding to change its name from the Birth Control League of Massachusetts to the “Massachusetts Mothers’ Health Council,” the Bay State group resolved to proceed with a “book” case, but by that time attorney Hoar’s schedule for the balance of the year was seemingly full and the women were left in much the same position they had been in eight months earlier when "), _c('i', [_vm._v("Gardner")]), _vm._v(" had been dismissed by the Supreme Court."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-96",
      "id": "ch01-096-96",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("96")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In January 1939 birth control forces had won a significant but little-publicized victory when a federal judge in Puerto Rico had dismissed criminal charges of distributing contraceptive articles that had been brought against two San Juan doctors and four assistants under the old federal Comstock statutes. Relying directly on the "), _c('i', [_vm._v("One Package")]), _vm._v(" precedent, District Judge Robert A. Cooper expressly held in "), _c('i', [_vm._v("United States")]), _vm._v(" v. "), _c('i', [_vm._v("Belaval")]), _vm._v(" that “prescribing or furnishing contraceptive materials by a physician is an exception to the statute.” “It is inconceivable,” he went on, “that Congress could by legislation prevent a physician from prescribing properly to save life or guard health.” Since even antiabortion statutes contained exceptions for life-threatening circumstances, Cooper added, “It can hardly be successfully contended … that a physician is prohibited from giving contraceptive advice and materials in a case where in good faith … he believes it is necessary for the preservation of life or health.” “It is not only the right but the duty of a physician, when in his judgment such is necessary for the protection of life or health,” Cooper concluded, “to prescribe contraceptives.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-97",
      "id": "ch01-097-97",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("97")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("More prominent public attention, however, was given to a January meeting marking the formal ending of the eleven-year-old rift between Sanger and her Birth Control Clinical Research Bureau on the one hand and the American Birth Control League, which Sanger had left in 1928, on the other. Now, with Sanger herself increasingly living in semiretirement in Arizona, the two long-competing groups would merge into one, which would be called the Birth Control Federation of America (BCFA). ABCL president Dr. Richard N. Pierson would become president of the new group, and a younger doctor, Woodbridge E. “Woody” Morris, would soon come on board as general director.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In Connecticut, the months between Clara McTernan’s successful opening of the Waterbury clinic on October 11 and Sallie Pease’s fateful remarks at the Connecticut League’s June 8 annual meeting passed "), _c('a', {
    attrs: {
      "id": "page_61"
    }
  }, [_vm._v("quietly and productively. The once-a-week Waterbury sessions drew very modest numbers of patients, a significant proportion of whom had already received diaphragm fittings at the Hartford or New Haven clinics. Only about one new patient per week had an initial consultation with either Bill Goodrich or Roger Nelson, at which they received a fitting and were instructed to return a week later for contraceptive jelly once they had successfully mastered the diaphragm’s insertion. While in part the small initial numbers testified to the success Clara McTernan already had had in arranging transportation to the Hartford clinic for needy women, McTernan and her colleagues nonetheless felt satisfaction at being able to assist new patients who, as in one case, had had one child each year for four years in a row, or, in another, four children within a five-year period. In both Hartford and New Haven the new patient totals outstripped Waterbury’s by hundreds and hundreds, in part because of patients who were also referring their friends, and also because both clinics had now quietly dispensed with the prior requirement that specific health grounds exist before a married woman could receive a diaphragm fitting and jelly. Like Hartford, New Haven too was discovering that “Catholics predominate more than ever, numbering 214 as against 163 Protestants and 20 Jews” among new patients, and New Haven’s chairman gave an upbeat report to the same luncheon audience that heard Sallie Pease’s proud remarks about their notable achievement in Waterbury: “we feel that the clinic has made a place for itself in the community and that the future holds in store a period of expanding usefulness.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-98",
      "id": "ch01-098-98",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("98")])]), _vm._v(" "), _c('p', {
    staticClass: "normal2"
  }, [_vm._v("Bill Fitzgerald’s top priority late Monday morning June 12 was to locate and obtain the clinic’s patient record cards that were in the possession of Virginia Goss. By that time Ginny Goss already had heard about what had transpired that morning at the Chase Dispensary, and when her good friend Dorothy Chase Carmody, whose attorney husband Ed was one of Bill Fitzgerald’s closest friends, called to tell her that the state’s attorney wanted the clinic’s records, Ginny Goss had no doubt what she should do. With hardly a moment’s hesitation, Ginny Goss took the four dozen or so large yellow record cards and the clinic’s other paperwork and “got out of Waterbury,” heading for a summer home on Fisher’s Island, New York, off the Connecticut shore.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But Bill Fitzgerald would not be so easily stymied. A young attorney in Ed Carmody’s firm of Carmody and Thoms, M. Heminway Merriman, Jr.—hence “Junie” to all who knew him—had previously been recruited as Waterbury’s representative on the Connecticut "), _c('a', {
    attrs: {
      "id": "page_62"
    }
  }, [_vm._v("League’s Legal Advisory Board. Clara McTernan had never had a substantive conversation with him about the clinic, but now Merriman was pressed into service by Ed Carmody. Merriman called Ginny Goss at Fisher’s Island and instructed her to return to Waterbury posthaste, and to bring the clinic records with her. She complied, gave the records to Merriman, and by midday Tuesday Carmody and Thoms had handed over the clinic records—patient cards and all—to Bill Fitzgerald.")])]), _c('a', {
    attrs: {
      "id": "page_62"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_62"
    }
  }, [_vm._v("Sallie Pease and Katharine Hepburn were absolutely livid when they learned that Merriman and Carmody had voluntarily surrendered the patients’ medical records to the state’s attorney, and the two women wasted hardly a moment before heading to Waterbury in person. There, in a scene that Pease would later recall as “brief, concise, and thunderous,” she and Hepburn told the Carmody and Thoms lawyers exactly what they thought of them and announced that the Connecticut League would having nothing further to do with them. In consultation with Clara McTernan and several of the clinic’s local supporters, they began casting about for Waterbury counsel that would energetically defend the clinic’s and the league’s interest, and by late Wednesday, June 14, Pease and Hepburn had found just the right person: J. Warren Upson, a thirty-five-year-old Yale Law School graduate who was a junior partner to former State’s Attorney Larry Lewis in one of Waterbury’s most distinguished law firms, Bronson, Lewis & Bronson."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-99",
      "id": "ch01-099-99",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("99")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Warren Upson knew Bill Fitzgerald well, in part because of Fitzgerald’s seven years of service as Larry Lewis’s deputy. But Warren Upson was already one of Waterbury’s most significant political figures: as attorney for publisher William J. Pape and for the "), _c('i', [_vm._v("Republican-American")]), _vm._v(" newspapers, he had played a leading role in the fight against T. Frank Hayes’s political machine for several years before Hayes and his cronies had finally been indicted on the fiscal corruption charges for which they were now standing trial. Part of Hayes’s operation had been to control the local Republican party, in addition to his own Democratic one, through voter-registration fraud which had allowed dual Republican registration for several thousand loyal Democrats, a scheme that Upson and Pape had successfully challenged in state courts. Afterward, Upson had been the unsuccessful 1936 Republican candidate against local U.S. Congressman J. Joseph Smith, and in 1939 he was in his third year as Republican town chairman, a post that kept him almost constantly in the local news. Waterbury reporters thought of him as “frank and honest,” “brilliant of mind and bed-rock in character.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-100",
      "id": "ch01-0100-100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("100")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_63"
    }
  }, [_vm._v("The legal situation that Warren Upson inherited on Thursday morning June 15 was unsettled but threatening. Bill Fitzgerald had been telling the newspapers little more than “no comment” for three days: “I haven’t anything to say about the investigation and will make no announcement until the investigation is thoroughly completed.” Other figures were similarly evasive, with hospital superintendent Dr. B. Henry Mason insisting “I am too busy to hear anything or think anything about dispensaries or clinics today.” Gynecology chief Dr. Charles Larkin also “said he was too busy to think about the investigation,” but did volunteer that he “hoped he would not be brought into the matter.” Dispensary deputy Berta Verba, whose boss Jeannie Heppel was still away on vacation, declared “I have nothing to say and I don’t know anything about the details.”")])]), _c('a', {
    attrs: {
      "id": "page_63"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("BCFA general director Dr. Woody Morris in New York was fully abreast of the situation, and late Wednesday he managed to get Dr. Mason on the phone. The superintendent indicated “that he was anxious to clear his skirts of the birth control clinic. I inferred from him that the hospital would prefer to be considered as an accommodating landlord,” and nothing more. Morris asked Dr. A. Nowell Creadick in New Haven to be sure that the Waterbury doctors did not lack either resolve or medical support within the state, and Margaret Sanger wrote Creadick to express the same sentiments, warning somewhat prematurely that “the case will never get anywhere unless they do allow themselves to be arrested and take the case to the highest courts.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Wednesday’s and Thursday’s "), _c('i', [_vm._v("Waterbury Democrat")]), _vm._v(" accorded front-page coverage to statements endorsing the Catholic Clergy Association resolution and Fitzgerald’s investigation that had been issued by the Notre Dame Alumnae Association and the Irish-American Social Club, but behind the scenes Warren Upson knew that the real danger lay in the ongoing interviews that Fitzgerald’s office was now conducting with former women patients of the clinic whose identities and addresses had been on Ginny Goss’s yellow record cards. Late Thursday afternoon Fitzgerald’s deputy Walter Smyth told Upson that the state’s attorney wanted Clara McTernan to come in Monday morning for formal questioning, and when Larry Lewis visited with Bill Fitzgerald on Friday, Fitzgerald told him that and more.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_63"
    }
  }, [_vm._v("The state’s attorney would proceed with a prosecution before the end of the month, but “He is undecided as to whom to prosecute—a number or all connected with the local office. If one he probably will select Mrs. McT[ernan].” While Fitzgerald indicated that there was some prospect that he would charge league officials in addition to ")]), _c('a', {
    attrs: {
      "id": "page_64"
    }
  }, [_vm._v("Waterbury clinic personnel, he also indicated that he would be willing to proceed by a detailed stipulation of the facts, rather than by going to trial and “calling witnesses who might be somewhat embarrassed by the nature of the testimony.” He might even agree, Fitzgerald told Lewis, “that in each case there was a health motive behind the instructions and contracepti[ve]s given, but he would refuse to agree that in each case the health of the user was directly or vitally concerned.” That would leave Lewis and Upson to decide “whether it is advisable to take the dignified course of having the question disposed of upon a stipulated statement of facts submitted eventually to the Supreme Court, or whether it is advisable to proceed to the rough and tumble” of a trial. Fitzgerald’s immediate priority, however, he told Lewis, was to establish precisely "), _c('i', [_vm._v("who")]), _vm._v(" was the legal owner of the diaphragms and other supplies that had been seized in the raid: the hospital, the Connecticut League, the clinic group, or some number of individuals. The hospital would certainly refuse to appear at Monday’s scheduled show-cause hearing to assert any claim to the seized materials, and while Lewis and Upson were relatively certain that they themselves would either appear or request a continuance, they were uncertain as to precisely who the claimant ideally ought to be.")])]), _c('a', {
    attrs: {
      "id": "page_64"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_64"
    }
  }, [_vm._v("But Warren Upson was far more worried about their substantive prospects than about the Monday hearing. While the BCFA office in New York already had had Harriet Pilpel send him a detailed file on "), _c('i', [_vm._v("One Package")]), _vm._v(", Upson and Lewis also had discovered and read the Massachusetts court decision in "), _c('i', [_vm._v("Gardner")]), _vm._v(", and they immediately appreciated its significance: “Mass. case probably is decisive & will be followed by Conn. Court,” Lewis jotted to Upson."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-101",
      "id": "ch01-0101-101",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("101")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Saturday morning Sallie Pease issued a bold public statement declaring that the Connecticut League was “delighted that the question of the legality of the birth control clinics throughout the state has been brought up.” “Laws and the interpretation of laws must change with changing times. The growth of birth control clinics all over the United States has been in response to tremendous public demand,” and no “medieval law” such as the 1879 Connecticut statute “can halt the march of progress and health.” Saturday afternoon she, Upson, Kit Hepburn, and Clara McTernan met with Margaret Sanger, BCFA lawyer William J. “Mac” McWilliams, and Harriet Pilpel at Pilpel’s country home in Newtown, not far from Waterbury, along with Bridgeport attorney Johnson Stoddard and New Haven lawyer Morris Tyler, both of whom had supported and advised the league clinics in their cities. The New Yorkers were highly impressed with Upson as he "), _c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_vm._v("described the Waterbury situation, and the group agreed that Upson and Lewis should appear at Monday’s hearing on behalf of both the Connecticut League and the Waterbury Maternal Health Center. They would seek a continuance of the hearing on the seized materials, and after Fitzgerald filed criminal charges against one or more individual defendants, they would seek to proceed by stipulation rather than conduct a full-blown trial.")])]), _c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Monday morning Upson and Larry Lewis, as well as Bill Fitzgerald, appeared before Superior Court Judge Frank McEvoy. Deputy Sheriff Al Francis and Detective K. G. Alling brought four bags and two boxes containing all the seized contraceptive supplies into the courtroom, and Fitzgerald informed McEvoy that the materials had been “kept to violate the criminal laws of the state” and that the Waterbury Hospital had disclaimed any interest in the articles. Upson explained that both the league and the Waterbury clinic wanted to contest Fitzgerald’s motion to have the supplies destroyed, and while McEvoy “examined several of the objects” he pressed Upson to identify exactly who the officers of the Waterbury clinic were. With obvious reluctance Upson named Clara McTernan, Virginia Goss, and Harriet Griggs, whose names thus appeared in the local press for the first time that afternoon, and McEvoy then agreed to continue the hearing on the fate of the seized materials until July 3.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Soon after the proceeding before McEvoy concluded, Warren Upson and Clara McTernan appeared as scheduled at the courthouse office of Bill Fitzgerald. With Walter Smyth, Detective Alling, and a stenographer looking on, the state’s attorney undertook a polite but firm interrogation of his next-door neighbor. Holding the yellow patient record cards, Fitzgerald asked McTernan to confirm that the Waterbury clinic had begun operation in October 1938, and that even earlier she had been referring women patients to Hartford. Fitzgerald asked whether she had ever personally spoken with any members of the executive committee of the Waterbury Hospital’s board of directors, or with Dr. Mason, and McTernan said no. She had sent Mason one letter, “asking if we could have use of the dispensary,” but “I never received an answer.” Fitzgerald then asked her if she had had any personal contact with Doctors Larkin, Brown, and Foster, the clinic’s ostensible advisory committee. “I never spoke to any of these men … I understood from Dr. Goodrich that these men had consented to be on the committee.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_65"
    }
  }, [_vm._v("Fitzgerald moved on to the question of the clinic’s financing, and McTernan noted that “the majority of patients did not pay anything.” ")]), _c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_vm._v("Indeed, as some of the seized records showed, the clinic’s entire income since the day it had started had totaled only ninety-seven dollars, and of that only ten dollars had come from patients. And those patients, she emphasized, “they just couldn’t come there—they were sent either by a doctor or came through the gyn[ecology] clinic.” Fitzgerald had also obtained a twelve-name list of people identified as the “Waterbury Committee,” and while Clara McTernan readily conceded that these people were the clinic’s official sponsors, she stressed that for many of them it involved only pro forma lending of their names. Only Edith Chase, her friend Lucy Burrall, Burrall’s sister Mary, Edward and Edith Davis, and Deborah Elton had contributed any money, and while one or two others, including Ruth Northrop, had attended the group’s only meeting, some on the list—including Jeannie Heppel—had not done even that.")])]), _c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Bill Fitzgerald was also very curious about whether Ginny Goss and Kathryn Jennings, like McTernan herself and the two doctors, had been at all involved in giving contraceptive instructions to patients, but McTernan repeatedly stressed that they had not. He asked whether Sallie Pease had attended a clinic meeting, and McTernan said no, but she answered in the affirmative when he inquired about Katharine Hepburn. Finally, Fitzgerald asked, “in anticipation of opening the clinic or Health Center, did you receive any legal advice or seek any legal advice of, or take into consideration any opinion rendered by any attorney?” “No, I did not,” McTernan responded. “Did it occur to you that it may have been illegal?” “No. Not when a doctor gave advice to a patient for health reasons.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_66"
    }
  }, [_vm._v("That afternoon Ginny Goss underwent similar questioning, and by late in the day Fitzgerald made it clear to Upson and Lewis that criminal charges would be filed by the end of the week, apparently against only McTernan, Goodrich, and Nelson. Fitzgerald agreed that he would furnish them with a draft stipulation at that same time, and Upson formally notified all three prospective defendants that the Connecticut League had engaged him to handle their defense at no cost to themselves. Sallie Pease readily sent Upson an initial retainer of a thousand dollars, which had been contributed by a friend or relative of Kit Hepburn’s, but Pease registered her dissent from the strategy that the Saturday meeting had been agreed upon: “Please have a jury trial and not a stipulation. They are no good.” And when Upson notified her that “I don’t believe that there is any possibility of any person connected with the state organization” being charged by Fitzgerald, Pease was downright distressed: “I am terribly disappointed that he won’t arrest me—the big sissy.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-102",
      "id": "ch01-0102-102",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("102")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_67"
    }
  }, [_vm._v("Monday night Kit Hepburn called Upson to report on her efforts to mobilize the Connecticut State Medical Society, but the group’s new executive secretary, Dr. Creighton Barker, was saying that he could do nothing more than reiterate the general endorsements of birth control that the society had rendered back in 1931 and 1932. Upson was preparing to have Goodrich and Nelson—whom he told Harriet Pilpel “are cooperative to the fullest extent”—and several senior doctors such as A. Nowell Creadick review Fitzgerald’s draft stipulation as soon as it was made available, and with criminal charges on the immediate horizon the Connecticut League appointed a special five-person executive committee—Pease, Hepburn, Upson, Creadick, and Johnson Stoddard—and instructed its other clinics “to proceed with their work as usual.”")])]), _c('a', {
    attrs: {
      "id": "page_67"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_67"
    }
  }, [_vm._v("Late Thursday Upson informed Pease that he believed Fitzgerald would be ready to proceed against the three defendants by sometime Friday, and early Friday afternoon Lewis and Upson, at Fitzgerald’s request, brought Clara McTernan, Bill Goodrich, and Roger Nelson before Superior Court Judge Kenneth Wynne. As all the parties stood before the bench, Wynne formally issued the arrest warrants that Fitzgerald had prepared, and all three defendants immediately pled not guilty. Fitzgerald requested bail of five hundred dollars per person, and Larry Lewis objected, saying such a requirement was unnecessary. Judge Wynne—a savvy veteran of state politics who had served as executive secretary to Governor Simeon Baldwin in 1914–15 and to Wilbur Cross from 1931 to 1935—immediately agreed: “no one can gainsay the fact that they are acting in accordance with what they think they have a right to do,” and released the defendants to Lewis’s custody. Newspapers all across Connecticut greeted the charges with prominent front-page headlines, and accorded significant attention to supporters’ statements. Woody Morris termed the arrests “an outrage to every physician,” and Nowell Creadick insisted that “We welcome the opportunity now offered for a final adjudication.” The old 1879 statute, Kit Hepburn declared, “was designed to prevent immorality and indecency, and not to interfere with competent physicians in protecting the health and well-being of their patients.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-103",
      "id": "ch01-0103-103",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("103")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The precise charges against the three defendants alleged that Goodrich and McTernan had both violated the Connecticut law by furnishing birth control devices to three specific women: a twenty-two-year-old mother of two who had visited the dispensary no fewer than forty-four times for a variety of illnesses in less than four years, a twenty-two-year-old mother who had borne three children within three years, and a twenty-three-year-old mother who had borne four "), _c('a', {
    attrs: {
      "id": "page_68"
    }
  }, [_vm._v("children within four years—and all of whom had made “repeated” use of the devices, the charges said. Roger Nelson similarly was charged with having furnished birth control devices to three other women, one of whom had had four children within five years.")])]), _c('a', {
    attrs: {
      "id": "page_68"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_68"
    }
  }, [_vm._v("Upson and Harriet Pilpel met again on Saturday to review Fitzgerald’s straightforward and largely unobjectionable draft stipulation of facts and to discuss what arguments against the Connecticut law Upson should stress in filing his demurrer—as the document was termed in Connecticut courts—challenging the constitutionality of the charges against McTernan and the doctors. There was some question as to whether Fitzgerald’s declaration in the charges that the women patients had indeed “used” the furnished devices was wholly sufficient to prove the “use” that would be required to convict the three defendants under the accompanying “accessory” section of the law, but Upson and Pilpel were more interested in whether particular “health” grounds for contraception could be shown for most if not all of the Waterbury clinic’s patients. Upson sought unsuccessfully to persuade Fitzgerald to return the patient record cards, both for that purpose and on the grounds that they were really the physicians’ property, but the league did assign a nurse from the Hartford clinic, Mrs. A. L. Wasserman, the difficult task of contacting and interviewing all of the patients beyond those cited in the charges to see if health grounds could be shown. Both Goodrich and Nelson, as well as Woody Morris, reviewed the stipulation, giving particular attention to Fitzgerald’s descriptions of the six particular women patients who were cited, but Upson was disappointed, although not surprised, that Mrs. Wasserman’s inquiries were “not accomplishing much as far as finding more health reasons.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-104",
      "id": "ch01-0104-104",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("104")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On Thursday, June 29, both Upson and Fitzgerald again appeared before Judge Wynne. Fitzgerald filed slightly amended charges which acknowledged that Goodrich and Nelson were “duly licensed physicians” and McTernan a “duly qualified nurse,” and Upson filed a three-page demurrer which straightforwardly challenged the anticontraception statute as “an unconstitutional interference with the individual liberty of the citizens” of Connecticut under both the state constitution and the Fourteenth Amendment to the U.S. Constitution, particularly when there was no exception for a physician “where the life or health of a patient is at stake.” Upson also stressed to the court that Goodrich and Nelson had "), _c('i', [_vm._v("not")]), _vm._v(" received remuneration for their clinic work, and Judge Wynne set July 25 as the deadline for Upson’s full brief challenging the charges and the statute and August 15 for "), _c('a', {
    attrs: {
      "id": "page_69"
    }
  }, [_vm._v("Fitzgerald’s reply. In the interim the question of an actual trial would remain on hold until Wynne ruled on Upson’s basic constitutional challenge. Four days later Judge McEvoy, after hearing a concise exchange in which Fitzgerald cited "), _c('i', [_vm._v("Gardner")]), _vm._v(" to prove that the statute “must be enforced unless it is repealed,” and Upson responded by quoting "), _c('i', [_vm._v("One Package")]), _vm._v(" and "), _c('i', [_vm._v("Belaval")]), _vm._v(", agreed to an identical briefing schedule for the seizure case."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-105",
      "id": "ch01-0105-105",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("105")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In early July all of the Connecticut League’s supportive attorneys met and agreed that henceforth all of the state’s clinics should specify in writing a particular health reason for each married woman to whom they provided birth control services. A sensationalist weekly newspaper that circulated widely in the state, the "), _c('i', [_vm._v("Bridgeport Herald")]), _vm._v(", printed a baseless front-page, banner-headlined story alleging that Fitzgerald’s Waterbury probe “may reveal before long, startling facts concerning alleged abortion practices of two or more Brass City medicos.” The suggestion was wholly fictional, but even more than fifty years later, Roger Nelson and his wife Rosalie remembered the implicit accusation in the "), _c('i', [_vm._v("Herald")]), _vm._v(" as their clearest and most painful memory of the Waterbury case.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On July 25 Warren Upson filed a powerful and impressive fifty-four-page brief in the case before Judge Wynne and a similarly detailed argument in the seizure proceeding. “The decisions of the federal courts are uniformly to the effect that statutes with respect to contraceptive[s] are not to be construed as interfering with the bona fide practice of medicine,” he emphasized. Additionally, Upson argued, the clear intent of Connecticut’s 1879 legislature “was to prohibit the production and dissemination of obscene information and literature,” and “any use of a contraceptive device upon the advice of a physician is not an offense against morality.” What the statute intended to prohibit was the immoral and hence unlawful use of contraceptives, not "), _c('i', [_vm._v("all")]), _vm._v(" use of contraceptives, Upson contended: “it is admitted that, for instance, the indiscriminate dissemination of contraceptive information to high school girls could be prohibited. This would be a justified exercise of the police power, because if contraceptive information was widely available to high school students, the restraint upon immoral practices inherent in the fear of pregnancy would be removed.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Upson presented lengthy renditions of the "), _c('i', [_vm._v("Belaval")]), _vm._v(" and "), _c('i', [_vm._v("One Package")]), _vm._v(" decisions, and then shifted to a higher philosophical plane, asserting that the 1879 statute “does violence to the inherent rights of man.” The state, he went on, “has no right to govern or attempt to govern the conduct of a citizen of a State if his conduct does not in any degree "), _c('a', {
    attrs: {
      "id": "page_70"
    }
  }, [_vm._v("impinge upon a similar freedom of conduct of other citizens of the State.” Relying upon an obscure 1888 decision by the Wisconsin Supreme Court, Upson added that “any citizen of Connecticut may deal with his own body in any way he wants to, and it is his natural right to do, if, in so doing, he does not impair any similar right on the part of another citizen.”")])]), _c('a', {
    attrs: {
      "id": "page_70"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_70"
    }
  }, [_vm._v("Then Upson moved to the specifics at hand: “The power to commence a pregnancy is one of the inalienable rights of the citizens of Connecticut.” Having already called contraception the “antithesis” of abortion, he returned to that contrast: “the State has the right to control abortions, but in the attempt to control conception, the State interferes with a natural right which inheres in its citizens.… the decision as to whether or not a married couple shall have children is a decision peculiarly their own.… If the people of Connecticut have any natural rights whatsoever, one of them certainly is the right to decide whether or not they shall have children, and to this natural right, the right to use contraceptive devices is a natural concomitant.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-106",
      "id": "ch01-0106-106",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("106")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Four days later, and well ahead of schedule, Bill Fitzgerald filed considerably shorter and more modest briefs with both Wynne and McEvoy. Relying almost wholly on the Massachusetts Supreme Judicial Court opinion in "), _c('i', [_vm._v("Gardner")]), _vm._v(", Fitzgerald insisted that “Every claimed constitutional defect asserted by the defendants” here also “was present in the Massachusetts statute involved in the Gardner case.” Within forty-eight hours Frank McEvoy notified Upson and Fitzgerald that the seizure matter would proceed to a full ruling on the merits, and Upson pondered whether to introduce additional evidence—by having McTernan, Dr. Creadick, and perhaps Sallie Pease take the stand at a formal hearing—or simply let the matter proceed to a decision based upon the written contentions that already had been filed. He knew it would be “undesirable to have Dr. Nelson and Dr. Goodrich testify” because that would “enable the State to examine them exhaustively as to the medical indications of all of the patients treated at the Waterbury clinic,” and after discussing the issue with both Connecticut and New York colleagues, Upson on August 4 notified McEvoy that the claimants would add nothing further."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-107",
      "id": "ch01-0107-107",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("107")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Shortly before noon on Monday, August 7, Judge Kenneth Wynne filed a brief opinion upholding Warren Upson’s demurrer to the charges against Clara McTernan and the two doctors. Expressly rejecting Fitzgerald’s claim that "), _c('i', [_vm._v("Gardner")]), _vm._v(" was determinative, Wynne brusquely noted that the Massachusetts statute prohibited "), _c('i', [_vm._v("distribution")]), _vm._v(" of contraceptive articles, while the Connecticut one prohibited "), _c('i', [_vm._v("use")]), _vm._v(". “The "), _c('a', {
    attrs: {
      "id": "page_71"
    }
  }, [_vm._v("court has no right to read exceptions into the statute” for qualified medical personnel, Wynne acknowledged, “but is convinced that without these proper exceptions the statute is defective on the broad constitutional grounds” articulated by Upson.")])]), _c('a', {
    attrs: {
      "id": "page_71"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_71"
    }
  }, [_vm._v("Bill Fitzgerald was away on vacation, and while Warren Upson had little doubt that the state’s attorney would appeal Wynne’s decision to the Connecticut Supreme Court, Upson told reporters that he would move for the formal dismissal of the criminal charges when the local Superior Court resumed its normal term in September. Connecticut papers quoted Kit Hepburn as calling the ruling “a wise and humane decision,” and Sallie Pease termed it “a great triumph of common sense over a ridiculous” law. Woody Morris hailed the outcome as a “milestone,” but in private Warren Upson warned both Pease and BCFA staffers that McEvoy quite likely would rule against them in the seizure case, and that they should keep their expectations in check: “we have been successful so far, but this does not mean ultimate success necessarily.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-108",
      "id": "ch01-0108-108",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("108")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Clara McTernan was away from Waterbury in mid-August but was overjoyed by the news of Wynne’s decision. “You must be the world’s best lawyer to have accomplished what you did,” she wrote Warren Upson. “I would like to open the clinic again in September, or whenever you think it advisable.” She and others also heartily congratulated Upson for his stand against Mayor Hayes, who had been convicted on August 16 after a seven-month trial and would soon resign his office. But not everyone was pleased with Wynne’s ruling, and the pastor of Bill Fitzgerald’s St. Margaret’s Roman Catholic Church used his August 13 sermon to declare that Wynne’s decision had no weight and that regardless of state law, the Catholic church “will continue to follow the law of nature and of God which is opposed to birth control.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At two p.m. on August 23 Frank McEvoy filed a lengthy opinion surveying Connecticut’s birth control struggles reaching all the way back to 1917 and vociferously upholding the 1879 statute and its application to the Waterbury clinic’s supplies. Relying literally word-for-word on Fitzgerald’s July 29 brief, McEvoy stated that the Connecticut use statute was similar to the Massachusetts distribution one and that “Every claimed constitutional defect asserted by the defendants to exist in section 6246 … was present in the Massachusetts statute involved in the Gardner case.” Furthermore, the Connecticut League and its clinics were organized “for the express purpose of violating the plain provisions of section 6246,” and the supplies should indeed be condemned and destroyed. Upson quickly announced that he would appeal "), _c('a', {
    attrs: {
      "id": "page_72"
    }
  }, [_vm._v("McEvoy’s decision to the state Supreme Court, and Sallie Pease told reporters that “I fail to see how he can rule upon the intention of the Connecticut Birth Control League or on physicians with whom it cooperates when they have not appeared before him in court.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-109",
      "id": "ch01-0109-109",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("109")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Upson advised a chagrined Clara McTernan that she should not start making plans to reopen the clinic, but he did approve her request to quietly accept contributions so that the Hartford clinic could provide new supplies of contraceptive jelly to the Waterbury clinic’s indigent former patients. McEvoy’s rhetorical emphasis upon how the Waterbury Hospital had disclaimed any interest in the clinic sufficiently irritated Sallie Pease that she made new efforts to see if any supportive statement could be extracted from the hospital’s board of directors, principally through Ruth Northrup, who had hosted Leah Cadbury’s first meeting and whose husband was the board’s treasurer, but the effort did not come to fruition."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-110",
      "id": "ch01-0110-110",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("110")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On Thursday afternoon September 21 Warren Upson brought McTernan, Goodrich, and Nelson before Judge John A. Cornell to seek formal dismissal of the charges pursuant to Kenneth Wynne’s August ruling. But Cornell, who was sitting in Waterbury pursuant to the rotational system of assignments employed for Connecticut’s Superior Court judges, indicated, much to Upson’s astonishment and consternation, that he was not fully persuaded that Wynne’s opinion included an explicit finding that these individual defendants "), _c('i', [_vm._v("had")]), _vm._v(" indeed been working in a professional medical capacity when they provided birth control services at the Waterbury clinic. Upson understandably thought that this was at best a highly picayune and trivial distinction, but even after he and Lewis, plus Fitzgerald, spent over an hour discussing the matter with Cornell the following day, the judge remained unpersuaded. Four days later Cornell again postponed any decision for another week, and both Upson and Fitzgerald, who could not actually appeal Wynne’s decision until Cornell granted the pro forma dismissals, became even more exasperated with the persnickety judge. In a move that was just as unusual as Cornell’s behavior, the two adversaries jointly went to Hartford to call upon the Chief Justice of Connecticut, William M. Maltbie, to explain their quandary and seek his advice. Maltbie, who himself had served eight years as a Superior Court judge before joining the Supreme Court in 1925 and ascending to the chief justiceship in 1930, was known to his colleagues for his “easy friendliness” and “warm and gentle humility,” and he willingly considered his visitors’ novel predicament. He agreed to review the copies of each side’s papers that Fitzgerald and Upson left with him, "), _c('a', {
    attrs: {
      "id": "page_73"
    }
  }, [_vm._v("and within a day of their visit he sent each of them, and Judge Cornell, a friendly but firm letter intimating that perhaps a further joint stipulation would resolve Cornell’s difficulty and pointedly observing that “The primary purpose is to secure a decision as to the proper interpretation of the statute and its validity rather than to penalize the defendant[s].”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-111",
      "id": "ch01-0111-111",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("111")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Oddly but unfortunately, even Maltbie’s missive did not convince Cornell to resolve the matter. Upson met with him once again, and several days later Cornell informed both Upson and Fitzgerald that he had decided to write to Maltbie and would continue to hold the judgment in abeyance. Upson and Pease consulted with one of Morris Ernst’s junior partners, Alexander Lindey, and Upson concluded that he could either try to persuade Bill Fitzgerald to drop or nolle the charges against Goodrich and Nelson—“so that whatever happens … their right to practice medicine and earn a livelihood will not be affected” by a conviction that would place their medical licenses in jeopardy—and proceed to an eventual ruling on the merits based simply on Clara McTernan’s case, or apply to the Connecticut Supreme Court for a writ of mandamus ordering Cornell to enter a judgment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Early in October Cornell reassured Upson and Fitzgerald he would act once he had a response from the chief justice, but two more weeks passed without news, and finally in late October Bill Fitzgerald wrote to Maltbie, politely observing that the McEvoy case was now on the Supreme Court’s docket and that it made sense for both cases to be heard jointly. Finally, on October 31 Maltbie broke the six-week-old logjam by giving Fitzgerald a letter formally assigning Kenneth Wynne to return to Waterbury for one day to enter the necessary judgments. On Friday afternoon November 3 the three defendants appeared before Wynne, and in a brief, five-minute hearing the judge entered judgments of “not guilty.” State’s Attorney Fitzgerald announced he would appeal, but Warren Upson now felt confident that irrespective of whether the Connecticut Supreme Court affirmed or reversed Judge Wynne on the merits regarding the 1879 statute, “it is almost certain that none of the accused will be convicted or go to jail for violation of the Connecticut law.” Five days later the case was officially forwarded to the Connecticut Supreme Court, with oral argument expected sometime before Christmas. Upson himself remained circumspect about estimating their chances for success with the high court, but his New Haven friend and colleague Morris Tyler confidently told BCFA director Woody Morris that “My own feeling is that our chances are 90 to 10 of a favorable decision.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-112",
      "id": "ch01-0112-112",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("112")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_74"
    }
  }, [_vm._v("While Upson had been busy attempting to extract their apparent legal victory from the procedural morass created by Judge Cornell, the Connecticut League, in part at the urging of the national Birth Control Federation, had been seeking to use the legal crisis as an opportunity to highlight public and medical support for birth control. BCFA representative Edna Rankin McKinnon, the youngest sister of well-known pacifist Jeanette Rankin, pressed the Connecticut League “to emphasize the medical side” and sponsor a Committee for the Defense of Medical Rights which would distribute tens of thousands of flyers stressing the threat to doctors. “This intrigued all except the president,” Sallie Pease, who “was not enthusiastic” about such a strategy, McKinnon told her BCFA superiors, and in short order the BCFA staff began to view Pease as an obstacle to the professional public-relations effort they believed the Connecticut situation required. Upson and his fellow lawyers, however, vetoed any mass mailings while the cases remained in the courts, but the attorneys welcomed the suggestion that a major amicus brief on behalf of doctors be prepared for the Connecticut Supreme Court. Nowell Creadick and the other members of the league’s Medical Advisory Committee issued a strong warning to fellow M.D.s that “the liberty of the doctor to practice as he sees fit” was in danger of “intolerable restraint” if the courts upheld Fitzgerald, and even the Waterbury Women’s Club unanimously passed a resolution calling for quick judicial action so that “physicians may fulfill, without legal handicap, their medical obligations.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-113",
      "id": "ch01-0113-113",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("113")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On November 20 Bill Fitzgerald, confined to bed with “a bad attack of grippe,” requested that the Connecticut Supreme Court hearing be postponed from December until early January. Upson and the Connecticut attorneys, along with BCFA’s advisors in New York, engaged in repeated discussions of how a doctors’ amicus brief should be handled, with some fearing that such an effort would only serve to stimulate submission of an opposing amicus brief on behalf of Roman Catholic M.D.s. In early December the question was finally resolved when Laurence A. Janney, a New York lawyer and Connecticut resident whose wife was active in the state league, took the initiative and volunteered to write one without charge. Focusing on questions of statutory interpretation and presumed legislative intent, rather than on the broader constitutional issues that Upson had emphasized before Judge Wynne, Janney’s skillful brief was submitted to the court on behalf of seventy-six Connecticut doctors."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-114",
      "id": "ch01-0114-114",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("114")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Upson’s own briefs in both the seizure case and in Fitzgerald’s appeal of Wynne’s dismissal of the three criminal charges closely tracked what "), _c('a', {
    attrs: {
      "id": "page_75"
    }
  }, [_vm._v("he had submitted to Wynne and McEvoy, repeating word-for-word the natural rights and individual liberty arguments he had made five months earlier. He devoted somewhat more attention than previously to arguing that "), _c('i', [_vm._v("Gardner")]), _vm._v(" was an inapposite precedent, in that it did not involve a statute criminalizing the "), _c('i', [_vm._v("use")]), _vm._v(" of contraceptives, but just as before, both of Bill Fitzgerald’s briefs emphasized "), _c('i', [_vm._v("Gardner")]), _vm._v(" very extensively. “To say that the Gardner case differs from the cases at bar because Connecticut General Statute 6246 penalizes the "), _c('i', [_vm._v("use")]), _vm._v(" of contraceptives and the Massachusetts statute does not in terms do so is to split hairs,” Fitzgerald declared. What was central here, the state’s attorney stressed, was “the constitutionally permissible purpose of preventing immorality, discouraging promiscuous sexual intercourse … promoting the public morals … protecting purity, preserving chastity, encouraging continence and self-restraint, defending the sanctity of the home,” and “lessening the incidence of the commission of the crime of abortion by those persons married or single who would otherwise be encouraged by the dubious and unproven but supposed power of artificial contraceptives to defeat the process of nature.” Fitzgerald then devoted six full pages, some twenty percent of his brief, to quotations describing how “natural” family planning, or the “rhythm method,” was a perfectly legal alternative to the use of contraceptives for those Connecticut couples who wanted to limit the number of their children."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-115",
      "id": "ch01-0115-115",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("115")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On Thursday, January 4, both Upson and Fitzgerald argued their cases before the five-member Connecticut Supreme Court of Errors—a particularly appropriate name, unsuccessful litigants often joked—and the tenor of the exchanges left both Upson and Sallie Pease extremely worried as to what the decision would be some weeks hence. The justices “did not seem to be particularly favorable to our point of view,” Upson told Woody Morris, as they were not much interested in the federal precedents and “seemed to have a feeling that the law in question was one for the determination of the legislature” rather than the courts. “I am rather pessimistic about the outcome,” Upson warned Mac McWilliams, and he alerted Alexander Lindey that they ought to give some advance thought to preparing for an appeal to the U.S. Supreme Court. Sallie Pease articulated her concern about the Connecticut justices more poignantly, later recalling that “We left with a sinking feeling in our hearts, for they seemed so old, so remote from the urgencies of life, so entangled in the musty depths of the law.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-116",
      "id": "ch01-0116-116",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("116")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Just as Pease thought, the composition of the Connecticut Supreme Court offered few reasons for optimism. Four of the five justices had attended Yale Law School, and the fifth, Harvard, and four were "), _c('a', {
    attrs: {
      "id": "page_76"
    }
  }, [_vm._v("Congregationalists and the fifth a Baptist, but it was not an aggressive or creative court. The two youngest members were each fifty-seven years of age, all five justices were Republicans, and all five had previously served as Superior Court trial judges, in line with a long-established Connecticut tradition. Three of the five had themselves served as members of the legislature, and a fourth, George E. Hinman, had served as an important legislative staff member in half-a-dozen terms. Chief Justice Maltbie was known to be a believer in judicial restraint, and when he retired a decade later, a cumulative tally showed that in his twenty-five years on the court he had written only thirty-three dissents while taking part in over 3,600 decisions. The court’s other most notable member, Newell Jennings, was the only nonlegislative veteran, and while he was known for brief, pithy opinions, he was not viewed as terribly more liberal than Maltbie. Hinman, just weeks away from mandatory retirement at age seventy, was small and visibly frail, and Allyn Brown, the youngest justice, later wrote of their fifth colleague, Christopher L. Avery, a description that in many observers’ eyes could have applied to all five members: “conservative in his views and inclined to be laconic in speech … he could be described as ‘a typical Yankee.’”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-117",
      "id": "ch01-0117-117",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("117")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As Upson, Pease and their colleagues awaited an early or mid-March decision from the Connecticut court, all of the league’s other clinics continued to operate normally. In late January one central Connecticut man thoughtfully wrote to the Hartford clinic to say that his wife, a patient of the clinic for over a decade, had recently left him: “I understand that she is running around a great deal. The authorities tell me that she must be an oversexed person as well as mental.” Dr. Eleanor Calverly immediately wrote on the woman’s chart “Separated from husband—Give her no more supplies. Discontinued,” and Dr. Hilda Standish acknowledged the husband’s letter: “We are very glad to have the information you sent us about your wife as it is not our policy to furnish any supplies to married women who are not living with their husbands.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Connecticut clinics continued to receive supportive press attention, and magazine stories chronicled a new total of at least 553 birth control clinics nationwide, but Warren Upson had realized that he and the league might be in an insoluble strategic bind should the Connecticut Supreme Court reverse Wynne, much as he now feared. If that did happen, he explained to Woody Morris, “I expect that thereupon all these cases would be nolled by Mr. Fitzgerald and the accused would be discharged,” leaving them without punishment but also "), _c('a', {
    attrs: {
      "id": "page_77"
    }
  }, [_vm._v("leaving the league without any means by which to appeal to the U.S. Supreme Court a Connecticut decision affirming the validity of the 1879 statute. “It does not seem to me,” Upson went on, “that we can ask these accused to refuse to accept a nolle,” and hence stand trial on the original criminal charge, “if it is offered by the State. Certainly the two doctors, who want to preserve their status as citizens, so that they can practice medicine, should not jeopardize their future by refusing a nolle.” However, “Mrs. McTernan, if she saw fit to do so, could, I suppose, stand trial in order to have this question clearly presented to the United States Supreme Court,” so long as Fitzgerald nonetheless agreed to grant the two other nolles, and in New York in particular there was a clear appreciation that “it would be better for the future status of the movement if one case could go through the courts to its conclusion.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-118",
      "id": "ch01-0118-118",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("118")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On Wednesday, March 20, the Connecticut Supreme Court handed down its decision in "), _c('i', [_vm._v("State of Connecticut")]), _vm._v(" v. "), _c('i', [_vm._v("Roger B. Nelson et al.:")]), _vm._v(" a 3 to 2 ruling, written by elderly Justice George E. Hinman, that the 1879 statute should not be read as having any implicit exception for doctors and that it "), _c('i', [_vm._v("could")]), _vm._v(" constitutionally be used to prosecute the three Waterbury defendants. Hinman’s opinion—joined by Chief Justice Maltbie and by Justice Allyn Brown—emphasized all the occasions from 1923 through 1935 when the state legislature had declined to repeal the ban on contraception or amend it to exempt qualified medical personnel from its coverage. “Rejection by the Legislature of a specific provision is most persuasive,” Hinman wrote, “that the act should not be construed to include it.” On Upson’s constitutional argument, Hinman went on, there was not only the Massachusetts court’s rejection of it in "), _c('i', [_vm._v("Gardner")]), _vm._v(", but more importantly, there was also the U.S. Supreme Court’s dismissal of the "), _c('i', [_vm._v("Gardner")]), _vm._v(" appeal: “We infer that this action may not be interpreted otherwise than as confirming the constitutionality of the Massachusetts statute in the respects in which it was attacked in the "), _c('i', [_vm._v("Gardner")]), _vm._v(" case,” and the Waterbury trio’s claims here were “essentially analogous.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Finally, the Hinman majority offered some more general views:")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_vm._v("Whatever may be our own opinion regarding the general subject, it is not for us to say that the Legislature might not reasonably hold that the artificial limitation of even legitimate child-bearing would be inimical to the public welfare and, as well, that the use of contraceptives, and assistance therein or tending thereto, would be injurious to public morals; indeed, it is not precluded from considering that not all married people are immune from temptation or inclination to extra-marital indulgence, "), _c('a', {
    attrs: {
      "id": "page_78"
    }
  }, [_vm._v("as to which risk of illegitimate pregnancy is a recognized deterrent deemed desirable in the interests of morality.")])]), _c('a', {
    attrs: {
      "id": "page_78"
    }
  }), _c('p', {
    staticClass: "normal3"
  }, [_c('a', {
    attrs: {
      "id": "page_78"
    }
  }, [_vm._v("Hinman concluded with a common refrain for judicial restraint in the face of suspect statutes: “If all that can be said is that it is unwise or unreasonably comprehensive, appeal must be to the Legislature, not to the judiciary.” Justices Newell Jennings and Christopher Avery dissented without filing an opinion. Almost as little more than a footnote, the Connecticut court unanimously reversed Frank McEvoy in the seizure case, holding that the statute under which McEvoy had granted Fitzgerald’s initial search warrant properly applied only to searches for gambling devices: “the judgment is set aside and the case remanded with direction to dismiss the proceeding and order return of the seized property to the defendants.” In the context of the other decision, this was, to say the very least, an utterly hollow victory."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-119",
      "id": "ch01-0119-119",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("119")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Within several hours of the announcement of the Court’s decision, Warren Upson, Sallie Pease, and several other league activists met hurriedly in New Haven. Hilda Standish was already being quoted by the press as calling “this stupid, outmoded law” and the decision affirming it “a disgrace to our state,” but Sallie Pease had presumed for weeks that if indeed the case was lost, the Connecticut League would have no choice but to close down all of its clinics. Hence, by early afternoon telegrams in her name went out to all of the eight other centers, saying simply “I suggest that it is advisable to close.” Without dissent the local committees agreed; Florence Darrach in Greenwich told reporters that “since this organization is responsible and law abiding, there will be no further service.” And for more than twenty-five years—from March 20, 1940, until the middle of 1965—with only one brief and dramatic exception, there would indeed be no further service until P. T. Barnum’s 1879 handiwork was finally voided by the United States Supreme Court."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch01-120",
      "id": "ch01-0120-120",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("120")])])])])])
}]}

/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(74),
  /* template */
  __webpack_require__(75),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 75 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_79"
    }
  }, [_vm._v("CHAPTER TWO")])])]), _c('a', {
    attrs: {
      "id": "page_79"
    }
  }, [_c('p', {
    staticClass: "chap-title-1"
  }, [_c('span', [_vm._v("No Further Service: Connecticut’s Struggle for the Legalization of Birth Control, 1940–1953")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Many national newspapers viewed the Connecticut Supreme Court decision upholding the 1879 statute as an inexplicable oddity. The "), _c('i', [_vm._v("News and Observer")]), _vm._v(" of Raleigh, North Carolina, commented on Connecticut’s “strange backwardness,” and the "), _c('i', [_vm._v("Des Moines Tribune")]), _vm._v(" forthrightly declared that “the law is an ass.” But the "), _c('i', [_vm._v("Waterbury Democrat")]), _vm._v(", which had championed the clinic raid from the first, enthusiastically called the outcome “encouraging.” Connecticut, it said, “has taken the very defensible position that legally and morally birth control cannot be countenanced through the instrumentality of the medical profession as a clearing house for the dissemination of such information and aid as would defeat the very purpose of matrimony. It is no easy thing to overthrow a natural law and to sustain arguments therefor.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_79"
    }
  }, [_vm._v("Warren Upson’s first reading of the "), _c('i', [_vm._v("Nelson")]), _vm._v(" decision convinced him that birth control proponents had only one alternative: to mount a major campaign to change the statute in the 1941 legislature. Bill Fitzgerald initially declined any comment on the ruling, but both he and Upson faced the question of what to do next when Superior Court in Waterbury reconvened two weeks hence on April 2. Upson, Pease, Florence Darrach, and Catherine Tilson met in New York on March 21 with Woody Morris, Harriet Pilpel, and Morris Ernst, and Upson described his hope of possibly persuading Fitzgerald to nolle the charges against the two doctors while proceeding with Mrs. McTernan alone as a test case. He realized the chances were substantial that Fitzgerald would not be willing to invest the time and energy such an exercise would require, but within the BCFA national staff in New ")]), _c('a', {
    attrs: {
      "id": "page_80"
    }
  }, [_vm._v("York several significant figures thought that the real lesson that should be drawn from "), _c('i', [_vm._v("Nelson")]), _vm._v(", as from "), _c('i', [_vm._v("Gardner")]), _vm._v(" before it, was that the national organization needed to exert much more dominant control over its local affiliates than previously had been the case."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-1",
      "id": "ch02-01-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sallie Pease called a major meeting of the Connecticut League for two p.m. Monday afternoon, March 25, at the Hartford Golf Club, and more than two hundred people attended. The meeting heard Johnson Stoddard and other advisors voice their reactions to the "), _c('i', [_vm._v("Nelson")]), _vm._v(" decision, but aside from general talk about the inevitability of a 1941 legislative push, no particular strategic decisions were made. One set of recommendations presented at the meeting, however, came from BCFA public relations director Charles Magill Smith on behalf of the BCFA staff. The CBCL, he declared, needed to make “changes in organization,” including “formation of a new committee with full authority” whose members would be chosen “primarily for their qualifications” rather than for previous involvement and who would include BCFA as well as Connecticut individuals. Such a committee could then create the Committee for the Defense of Medical Rights that the BCFA staff had been envisioning for six months as the preferable Connecticut publicity vehicle, and it could also take the place of the CBCL’s previous legal advisory committee, which “should disband,” since legal strategy decisions needed to be made primarily within a national rather than a state context. “It will probably seem wise to permit the state leagues and existing committees to become temporarily inactive,” Smith said, and “the hope of victory in this fight depends largely on complete recognition that we are fighting the Catholic Church.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Smith’s flat-footed effort was referred to the CBCL’s Future Policies Committee for consideration, but so blatant an attempt by the BCFA staff to take control of the Connecticut scene in the wake of the "), _c('i', [_vm._v("Nelson")]), _vm._v(" defeat infuriated both Sallie Pease and Kit Hepburn. The very next day the two women went to New York and demanded an opportunity to join a scheduled meeting of the BCFA board’s executive committee. They presented an angry memo protesting Smith’s effort and how his suggestions represented “an insult to the intelligence” of the Connecticut lawyers and advisors, but the committee, withdrawing into executive session, dodged the challenge by explaining that it lacked a quorum and hence could not reach any decisions. Pease and Hepburn headed back to Hartford no less angry than they had come, but the tumultuous scene brought to a head the antipathy that the BCFA staff had been developing toward the independent-minded "), _c('a', {
    attrs: {
      "id": "page_81"
    }
  }, [_vm._v("Pease—and her outspoken mentor—for more than six months. Florence Rose, the BCFA staffer who was Margaret Sanger’s primary confidante and aide in the New York office, claimed to her boss that “Mrs. Pease has long been a headache to lots of the Connecticut people” but stressed that “the sad part is that she and Mrs. Hepburn are evidently ‘buddies’ … which we did "), _c('i', [_vm._v("not")]), _vm._v(" realize.” Pease and Hepburn had “misrepresented grossly the facts” about Smith’s recommendations, Rose claimed, and Hepburn had apparently told BCFA executive committee chairman Gilbert Colgate precisely where he could go: “She is apparently losing her sense of fitness and propriety,” Rose asserted. The best hope, Rose added, would be for Sanger to contact her old friend Hepburn directly: “she can be such a valuable asset if her loyalty to you is greater than to Mrs. Pease.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-2",
      "id": "ch02-02-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While the BCFA staff was busily plotting the takeover of the Connecticut League, Warren Upson was hard at work on the next and final steps in the Waterbury cases. On March 27 Frank McEvoy entered a formal order resolving the seizure case, and two days later the clinic’s now-ageing supplies were returned and then sent to the Clinical Research Bureau in New York, where they could be used legally. Upson had continued to ponder the possibility of attempting to go forward with simply the charges against Clara McTernan, but in a phone conversation with Morris Ernst on the afternoon of March 27 they reluctantly agreed that it “would be undesirable” because no particular health reasons for birth control had existed with the three patients whom McTernan was accused of aiding and abetting. Hence, Upson concluded, “Under the circumstances, if the State offers a nolle, we must accept one,” and on Friday, March 29, he and Sallie Pease met Clara McTernan, Bill Goodrich, and Roger Nelson for lunch at the Waterbury Country Club to review what likely would happen in the formal court session on April 2."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-3",
      "id": "ch02-03-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The tenor of the lunch conversation quickly erased Warren Upson’s remaining ambivalence about accepting three nolles. “It is apparent,” he wrote Morris Ernst several hours later, “that the doctors and Mrs. McTernan want to get out of these cases as quickly as possible. They certainly show no indication of wanting to have any further contest made, and in the light of their point of view, regardless of what the Birth Control League desires, there is only one thing for me to do, and that is to procure a nolle for them, if possible.” After lunch he had spoken again with Bill Fitzgerald, whose position was firm but reasonable: “His view is that the Waterbury doctors are guilty of violation of the law, but that to punish them would be unjust, in view of the fact that "), _c('a', {
    attrs: {
      "id": "page_82"
    }
  }, [_vm._v("there are so many culprits in the State who will go without punishment for this crime. His disposition, therefore, is to nolle the cases,” because “he does not feel that it would be fair to secure a conviction under the circumstances,” even though “he is being subjected to pressure from different sources.”")])]), _c('a', {
    attrs: {
      "id": "page_82"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("At three p.m. on Tuesday, April 2, Clara McTernan, Bill Goodrich, and Roger Nelson filed into the Waterbury courtroom, and some minutes later the clerk called their cases and Bill Fitzgerald rose to read a five page prepared statement. He traced the early course of his investigation, and described how he understood the clinic had come into being: “through the superintendent of the Waterbury Hospital the informal permission of the hospital’s board of directors for the use of space at the Chase Dispensary was obtained. It was the understanding of the superintendent of the hospital and of the defendants Goodrich and Nelson, that three senior members of the hospital gynecological staff had been constituted, and had agreed to function, as an advisory board for this contraceptive clinic, although these physicians, who were supposed to constitute the advisory board, profess complete ignorance of the matter.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fitzgerald acknowledged that the defendants had “cooperated fully in establishing all of the material facts” of the case, and then he began his conclusion: “I am satisfied that these defendants believed that they had a right to do the acts referred to in the informations in these cases. They donated their time and services to what they regarded as a charitable work. I do not believe that they intended to violate the criminal laws of this state. When this Waterbury clinic was opened there were in open operation elsewhere in the state at least eight other contraceptive clinics which had been in existence for a long period of time and no question as to their right to operate had been raised in any court. These facts were known to and relied upon by these defendants.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_82"
    }
  }, [_vm._v("In “the absence of any actual criminal intent,” the charges would be nolled, for “it seems to me unjust to destroy the professional careers of these physicians by a conviction.” However, Fitzgerald emphasized in closing, “Henceforth any person, whether a physician or layman, who violates the provisions of these statutes, must expect to be prosecuted and punished in accordance with the literal provisions of the law.” With that, Judge Carl Foster dismissed the three defendants."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-4",
      "id": "ch02-04-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Bill Goodrich was only thirty, and Roger Nelson thirty-one, and within three years each would be gone from Waterbury, called into military service. After the war Bill Goodrich switched from gynecology to radiology, helped his wife Elizabeth raise two children, and established "), _c('a', {
    attrs: {
      "id": "page_83"
    }
  }, [_vm._v("a successful practice in Hartford before dying at the very young age of forty-nine. Roger Nelson returned from the war and eventually switched from obstetrics to a career as a hospital administrator, spending most of his life quietly in Ann Arbor, Michigan, and outliving his friend Bill Goodrich by well over thirty years.")])]), _c('a', {
    attrs: {
      "id": "page_83"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_83"
    }
  }, [_vm._v("The Fitzgeralds and the McTernans would continue to live just across the driveway from each other until 1948, when Charles McTernan retired as headmaster of the family school and he and Clara moved full time to their summer home on the Connecticut shore in Old Saybrook—where the Fitzgeralds would sometimes visit them. The McTernans “never had any ill feeling” toward Bill Fitzgerald, Clara’s stepson John later explained, because “he really didn’t have a choice.” Clara “wasn’t upset by it,” and “took it in stride,” especially since Bill Fitzgerald had conveyed to them that “he hated to do what he was doing.” Once Bill Fitzgerald privately took the opportunity “to apologize for what he was doing,” and Bill’s son Tony, born four years after the case was concluded, also grew up witnessing both the family’s friendship with the McTernans and his father’s distaste for what had happened: it was as if he had been “kind of holding his nose” during those events of 1939 and 1940."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-5",
      "id": "ch02-05-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sallie Pease and her colleagues at the Hartford clinic resolved to keep the office open even if birth control supplies could not be distributed, and a plaintive “Dear Patient” letter was sent to the hundreds of women who had been helped there. “Some day,” Pease told them, “if we all work together, we will have the clinics open again.” But all working together was not the spirit that was emanating from the BCFA office in New York, and within a day of the final resolution of the Waterbury charges, Sallie Pease received a personal letter from Margaret Sanger that was as unfair and unpleasant as anything Pease and Hepburn had ever suffered at the hands of birth control opponents.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sanger began by volunteering that the Charles Smith recommendations which Pease and Hepburn had found so offensive seemed like “excellent advice,” and went on to blame Pease for the 3 to 2 loss in the Connecticut Supreme Court: “something certainly went wrong somewhere in the Connecticut League, to have lost that case and to have had so adverse and medieval an opinion.” Then Sanger moved toward her real goal: “it is the duty of some one to seek out the cause of this and to eliminate persons or even groups if future progress is to be attained. Weak leadership guided by professional limitations, either legal or medical, usually ends in defeat.” Sanger knew next to nothing about "), _c('a', {
    attrs: {
      "id": "page_84"
    }
  }, [_vm._v("the Connecticut people who had played the major roles over the past ten months, but that did not stop her from offering a clear prescription: “resignations of dead wood or professional bias should be in order,” for “when leadership fails in achieving its goal it resigns its position and lets a new group take hold.… As President of the Connecticut League I hope you and Kate will analyze your material and face the future with a clean slate for that is what is needed.”")])]), _c('a', {
    attrs: {
      "id": "page_84"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_84"
    }
  }, [_vm._v("If some would have thought the letter harsh, Sanger told Woody Morris she feared she had been too gentle: “I should have liked to have been a little more explicit and said definitely that Mrs. Pease should resign the presidency but as I do not know how good a president she has made I only surmise that she has been a weakling.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-6",
      "id": "ch02-06-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sanger’s woeful ignorance was only one aspect of a rapidly developing situation, however. When the BCFA board met two days after the nolles were formally entered, outside counsel Morris Ernst announced a dramatic suggestion, one he repeated in a letter to Pease the following day: all Connecticut clinics should be reopened at once, and several additional clinics should be opened in "), _c('i', [_vm._v("churches")]), _vm._v(". Ernst’s reasoning was that the "), _c('i', [_vm._v("Nelson")]), _vm._v(" opinion, upon careful study, offered them some small but significant room for maneuver, as the Connecticut court had not explicitly spoken to whether the 1879 statute would be valid in a case where the need to avoid pregnancy—and utilize contraceptives—involved a threat to a woman’s very "), _c('i', [_vm._v("life")]), _vm._v(". Hence, he advised, “a statement should be prepared indicating that the Supreme Court had not held that birth control is illegal; it merely held that the statute could be enforced if the test of use was one of general health,” and further indicating that the reopened clinics would prescribe birth control in those cases where pregnancy might involve “jeopardy to life.” In practice such a phrase could be “a generous term,” Ernst told Pease, for “jeopardy to life does not mean jeopardy of death,” and the league should have its friendly doctors draw up an exhaustive and inclusive list of all ailments whereby pregnancy might exacerbate a threat to life, a list that clinic doctors then could make specific reference to in examining each and every woman seeking birth control. “The statement of publicity in regard to the opening should be most dignified,” Ernst advised, should “in no way attack the court and in no way indicate that you are looking for a test case or trouble.” The stakes were high, but decisive action was required: “if you do not take such a step the movement will be dissipated in Connecticut,” which in turn “will encourage further attacks in other jurisdictions.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-7",
      "id": "ch02-07-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The following day, Saturday, April 6, the Connecticut League’s "), _c('a', {
    attrs: {
      "id": "page_85"
    }
  }, [_vm._v("lawyers, doctors, and officers all met in New Haven to hear Sallie Pease present and endorse Ernst’s bold plan of action. She explained that Ernst of course presumed that implementing his plan "), _c('i', [_vm._v("would")]), _vm._v(" generate a test case, but several of the Connecticut attorneys, including Morris Tyler and Warren Upson, firmly believed that such a course would "), _c('i', [_vm._v("not")]), _vm._v(" generate any Connecticut Supreme Court opinion that birth control proponents would welcome. Additionally, any such venture would require the doctors staffing the reopened clinics to put their medical licenses and futures on the line, and, in light of Fitzgerald’s firm statements about enforcement when the Waterbury charges were nolled, it was very likely that such doctors "), _c('i', [_vm._v("would")]), _vm._v(" pay a stiff price if the Connecticut court once again affirmed the 1879 statute. Upson then formally recommended that the Connecticut League focus upon legislative rather than litigative remedies, and his proposal was adopted. Tyler and Johnson Stoddard further proposed that the league advise its clinics "), _c('i', [_vm._v("not")]), _vm._v(" to reopen until the statute was amended, and both that "), _c('i', [_vm._v("and")]), _vm._v(" a vaguely worded addendum saying that clinics "), _c('i', [_vm._v("could")]), _vm._v(" reopen on “life only” grounds if they so chose were approved, subject to revision by a small subcommittee.")])]), _c('a', {
    attrs: {
      "id": "page_85"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_85"
    }
  }, [_vm._v("Pease and Hepburn were about the only Connecticut activists who felt that Ernst’s strategy of reopening the clinics was the wisest. Hilda Standish, the doctor who had opened the initial Hartford clinic in 1935 and helped operate it for almost five years, understood their sentiments but believed that the potential risk to M.D.s’ medical licenses was simply too great a danger to face. Ernst himself was disappointed that the BCFA staff had little interest in his idea, especially as Justice Hinman’s retirement raised the possibility that his successor, Arthur F. Ells, might vote differently. Ernst told friends that he thought the birth control movement was losing the fighting spirit that had carried it through the 1910s and 1920s, but Edna McKinnon of the BCFA explained to others that the national staff was more interested in ousting Pease than in listening to Ernst. Margaret Sanger remained more than a little confused about the Connecticut scene, erroneously continuing to believe that Pease and Hepburn, rather than BCFA, were the primary obstacles to aggressive action. “If there was only a good crowd of women up there who will open the clinics and keep them open until everyone of them were put into jail, they would have a better opportunity to get that law changed,” she blustered to Clarence Gamble. “God only knows how weak and timid and full of fears respectability has made the birth control movement. If we had just half of the fighting spirit that the Roman Catholics have we would lay them low and mow them down.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-8",
      "id": "ch02-08-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_86"
    }
  }, [_vm._v("But in Connecticut matters were finally beginning to move forward. One of Sallie Pease’s biggest burdens was the problem of paying the remaining bills from the Waterbury cases, and when Warren Upson, who so far had received only a very modest fifteen hundred dollars for all his time and efforts, submitted a final statement requesting an additional twenty-six hundred dollars, Pease reluctantly sent her old friend and Bridgeport attorney Johnson Stoddard to ask if he would settle for only a further thousand dollars. Upson raised the question with his partners, and senior partner Richardson “Dick” Bronson endorsed the modification: “I fear we are stuck. When it happens that men of the quality and association of Johnson Stoddard interest themselves to get down on their metaphorical knees and ask that we accept less than that which they admit is our due, we cannot afford to be mussy about it.… We have got to swallow it.” In return Upson received only a thank-you letter from Kit Hepburn for his “very generous” contribution to the league, but the firm’s resolution of an otherwise small matter reflected once again the dedication and distinction with which Upson had handled the Waterbury cases since the first day Pease and Hepburn had come to him."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-9",
      "id": "ch02-09-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("More significantly, other Connecticut activists, particularly Florence Darrach from Greenwich, were now fully convinced that a professionally managed 1941 legislative campaign had to be the league’s next focus, and BCFA staffers from New York were all too happy to encourage this cohort as replacements for the tough-talking, independent-minded duo of Pease and Hepburn. The league’s Future Policies Committee, at Darrach’s initiative, unanimously endorsed the idea of a Committee for the Defense of Medical Rights that had been pending since the previous fall, and even Sallie Pease reluctantly told Morris Ernst that virtually everyone now agreed that a “life-threat” test case would not be an adequate solution: “even if the case were successful … it would not be worthwhile” to limit clinic services to only such patients. “This is really their basic reason for not wanting to go to the courts.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While both Pease and Kit Hepburn believed that the increased Roman Catholic presence in the state legislature, particularly in the state senate, meant that a legislative effort was almost certainly foredoomed to be little more than a waste of money, a special plenary meeting of the Connecticut board was called for April 24 to hear a formal proposal from Darrach and the BCFA’s principal public relations firm, the John Price Jones Corporation (JPJ), a twenty-year-old organization with a staff of fifty. One of JPJ’s principal officers, D. Kenneth "), _c('a', {
    attrs: {
      "id": "page_87"
    }
  }, [_vm._v("Rose, had played a primary role in the merger that had created BCFA two years earlier, and both Rose and a deputy, Paul Franklin, attended the Hartford meeting. They described JPJ’s past experience with BCFA and the consulting assistance they also had provided in recent years to both the Massachusetts and New York state groups. Rose contended that what the Connecticut struggle needed was “a publicity theme that will capture public interest,” and, alluding to the desirability of launching some newly named group, asserted that “what you decide on as the final name and type of organization is going to determine whether you will win or lose.” Franklin conceded that JPJ’s services were expensive but explained that “the chief benefit you get from our type of organization lies in group judgment.” Their specific proposal had two parts: first an intensive ten-week survey of the Connecticut scene and prospects by a JPJ executive at a fee of more than twelve thousand dollars, out of which would come a more detailed—and far more expensive—game plan that the CBCL could either adopt or dismiss. Rose volunteered that “We hope you will hire us to go right through,” for “We won’t take a job unless we think we shall succeed.” A motion approving the initial ten-week study was easily approved, with Darrach promising that Greenwich supporters would meet much if not all of the cost, and a new steering committee to work with JPJ—including Pease and Hepburn—was also ratified. As almost everyone realized, for worse or for better the Connecticut League had taken a step very different from any prior one in its two-decade history."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-10",
      "id": "ch02-010-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In early May the new CBCL steering committee ratified the hiring of JPJ and within less than a week JPJ Vice President Paul Franklin began functioning as executive director of the Connecticut League. He undertook long conversations with Nowell Creadick and Warren Upson to help familiarize himself with the Connecticut scene, and both men agreed that now “the Catholic opposition was much more effectively organized than it had ever been before.” Creadick advised Franklin that doctors were the most effective representatives for birth control before the legislature, while the women could lobby candidates on the issue prior to elections. Upson, like Pease and Hepburn, cautioned Franklin that Democratic—and Roman Catholic—success in the fall elections for the 1941 legislature would leave them with very dim prospects indeed. Birth control supporters suffered a modest setback when the annual meeting of the Connecticut State Medical Society sidestepped the question of reaffirming the society’s 1931 and 1932 endorsements, but Florence Darrach told her colleagues that the Greenwich women had raised more than sixteen thousand dollars "), _c('a', {
    attrs: {
      "id": "page_88"
    }
  }, [_vm._v("within hardly three weeks to finance the JPJ study. Franklin devoted most of his time to one-on-one conversations with attorneys, judges, and political observers from across the state, and the growing presence of Roman Catholic members in the legislature—particularly among Democrats in the state senate—was cited again and again as a serious if not insuperable obstacle. Several savvy politicians noted that ideally one could lobby for the selection of "), _c('i', [_vm._v("non-Roman Catholic")]), _vm._v(" nominees for state senate seats; otherwise, a former house speaker warned, “a legislator’s obligation to the church will outweigh his desire for votes.” Some of the attorneys also pointed out that the Connecticut Supreme Court would be highly unlikely to reverse itself in any test case that attempted to capitalize on Ells’s replacement of Hinman, and that Ells might simply follow Chief Justice Maltbie."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-11",
      "id": "ch02-011-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On June 10 Pease, Darrach, Upson, and Franklin met in New York with Sanger, Harriet Pilpel, Loraine Campbell of the Massachusetts group, and D. Kenneth Rose, who had just moved over from JPJ to become national director of the Birth Control Federation. The experience of both "), _c('i', [_vm._v("Nelson")]), _vm._v(" and "), _c('i', [_vm._v("Gardner")]), _vm._v(" had convinced Sanger that her congressional focus back in the 1920s and early 1930s had indeed been right: “Court victories … are temporary in their effect; legislation is a final answer, for it is an expression of the will of the people.” The others mostly agreed, but with the exceptions of Pease—who voted against any legislative campaign—and Darrach, who voted against any further consideration of a test case, the participants did not clearly identify a specific strategy for the Connecticut effort to follow.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On both June 18, at the annual meeting of the Hartford clinic, and on June 26, at the annual meeting of the Connecticut League, Sallie Pease delivered her valedictory speeches as president of the Connecticut struggle. Poignant, powerful, and moving, she spoke of the emotional peaks and valleys of the preceding year, of the many intense moments since her speech a year earlier that had kicked off the Waterbury confrontation. But the bottom line, she reminded everyone, was both clear and simple: “The Women of Connecticut must have the right to decide for themselves when their children shall be born.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The league’s annual meeting affirmed two important JPJ and Florence Darrach initiatives: formal creation some weeks hence of a publicity vehicle that would be called the Connecticut Committee to Make Birth Control Legal, and installation of the very handsome and proper president of the Hartford Seminary, Robbins W. Barstow, as figurehead president of the Connecticut League. Paul Franklin stressed to reporters that the league had reached no decision on pursuing either a "), _c('a', {
    attrs: {
      "id": "page_89"
    }
  }, [_vm._v("1941 legislative effort or a court case, and several weeks later, when JPJ’s initial ten-week contract with the league was about to expire, the relationship was extended—with only Sallie Pease voting no—even though everyone acknowledged that no funds were being raised anywhere except in Greenwich."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-12",
      "id": "ch02-012-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Florence Darrach appreciated that the league’s best political chance lay in obtaining firm support from the Republican party, but she realized too that not all Connecticut Catholics were Democrats. She told her Massachusetts counterpart Loraine Campbell that it was too bad that Connecticut, unlike Massachusetts, did not have the option of proposing a popular referendum on the issue, but in mid-July she and Franklin went to have a long private chat with Connecticut’s first-term Republican governor, Raymond E. Baldwin, who seven years earlier had been the primary legislative sponsor of the league’s reform bill. A narrow upset winner over Wilbur Cross in 1938, Ray Baldwin represented a state Republican party that had transformed itself from the era of J. Henry Roraback into the progressive garb of the party’s 1940 presidential candidate, Wendell Willkie. Baldwin told Franklin and Darrach that personally he was “in sympathy with the birth control movement,” but that he did not want the issue interjected into the upcoming fall elections. “He asked Mrs. Darrach if she wanted to see him Governor again and if so said the quickest way to kill his chances and the chances of the Republican party would be for the League or Committee to introduce the birth control issue into the campaign.” The governor advised that “it would be infinitely better for all concerned for the Committee to do nothing in a political way until after the November elections. He said that the birth control issue was not as important as people believe because in the last election when he ran for Governor none of his opponents brought up the fact that he was known to be [a] supporter of birth control.” Darrach and Franklin restrained themselves from pointing out that if indeed this was so, it could in no way harm Baldwin’s reelection prospects for the issue to be raised, but they did directly ask the governor “if he would use his influence in bringing about a change in the law if the Committee agreed to do nothing in political circles until after the election.” “Of course,” Franklin noted, “he refused to answer this query.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-13",
      "id": "ch02-013-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Connecticut activists continued to flummox around without settling on any firm strategy. Laurence Janney volunteered to draft a bill for the 1941 legislature, and Paul Franklin, after undertaking an amateurish poll of citizens’ opinions on birth control, sent out a low-visibility press release asserting that 93 percent of Connecticut "), _c('a', {
    attrs: {
      "id": "page_90"
    }
  }, [_vm._v("residents backed a doctor’s right to prescribe it. Judge Kenneth Wynne told Franklin in an off-the-record conversation that a court case stood no chance of success, and while some league members did make queries about local legislative candidates, an early September newsletter correctly confessed that “the real work of the organization has yet to begin.”")])]), _c('a', {
    attrs: {
      "id": "page_90"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_90"
    }
  }, [_vm._v("By mid-September Sallie Pease and her Hartford colleagues were in open revolt against the way things were going, formally notifying the statewide steering committee that they would decline to contribute toward paying any further fees for JPJ and bluntly suggesting that need for “a workable, clear and practical plan which can be carried out mainly by volunteers” rather than “the present costly arrangement.” The Hartford group warned that “the continued employment of a high priced publicity firm from New York” might well be seized upon by birth control opponents come the 1941 legislature, and even a good Hartford friend of Darrach’s warned her that it “is not difficult to stir up an illogical opposition to measures proposed and advocated by those of you who reside so near the New York border” in wealthy Fairfield County."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-14",
      "id": "ch02-014-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In late October Warren Upson pointed out to his Connecticut colleagues a mid-September ruling by the Massachusetts Supreme Court that potentially could be viewed as a retreat from "), _c('i', [_vm._v("Gardner")]), _vm._v(". A Boston pharmacist, Lewis Corbett, had been arrested and convicted under the Massachusetts statute prohibiting the distribution of contraceptives for the crime of selling condoms to an undercover policeman. The court had reversed his conviction on the grounds that condoms could be used for protection against disease as well as for contraception, and in the absence of evidence that the seller knew which use a customer had in mind, no intent to violate the statute could be shown. It was a limited ruling, covering only condoms—as Harriet Pilpel later wrote, “the result of the holding is that practically speaking only the best type of contraceptives,” diaphragms, “are effectively barred from use in Massachusetts.” However, the tenor of the decision, as the "), _c('i', [_vm._v("Yale Law Journal")]), _vm._v(" noted, “is antithetical to that expressed two years earlier by the same court” in "), _c('i', [_vm._v("Gardner")]), _vm._v(" and then relied upon so centrally by the Connecticut Supreme Court in "), _c('i', [_vm._v("Nelson")]), _vm._v(". Massachusetts lawyers did not pursue the matter, but to Upson and others in Connecticut "), _c('i', [_vm._v("Corbett")]), _vm._v(" at least offered plausible grounds for asking the Connecticut court to revisit the subject of "), _c('i', [_vm._v("Nelson")]), _vm._v("."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-15",
      "id": "ch02-015-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Rather than a court case, the Massachusetts activists had set their eyes on getting a popular referendum vote on medically sanctioned "), _c('a', {
    attrs: {
      "id": "page_91"
    }
  }, [_vm._v("birth control onto the 1942 Massachusetts ballot. In May 1940, with that possibility in mind, they had commissioned a statewide poll. The results showed that 64 percent of respondents—and 45 percent of Roman Catholics—said yes when asked “Do you think people should be allowed to obtain birth control information from public clinics here in Massachusetts?” Even more notably, 82 percent of people—and 72 percent of Catholics—said yes when asked “Do you approve or disapprove of allowing Massachusetts doctors to provide birth control information to married women for health reasons?” Those answers indicated that birth control liberalization stood a far better chance with Massachusetts voters than with state legislators, and the first step toward obtaining a 1942 referendum vote was to file a minimum of twenty thousand petition signatures by late 1940. To aid in that campaign, Margaret Sanger herself scheduled a series of appearances across the state, and all went smoothly until Roman Catholic pastors in the industrial city of Holyoke called for the cancellation of her upcoming talk there. Sanger was scheduled to speak at Holyoke’s First Congregational Church, which initially held firm in its commitment until several church board members who were businessmen received personal calls from a prominent Catholic priest who expressed concern about future patronage of their businesses unless the Sanger talk was canceled. Only twenty-four hours before Sanger was to speak the church board reversed itself, and after at least one other unsuccessful attempt to secure an attractive venue, Sanger ended up delivering her remarks in a union hall. The potential lessons of this experience for a 1942 statewide referendum campaign on birth control should have been hard to ignore."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-16",
      "id": "ch02-016-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For the Connecticut activists, the November 1940 election results were even worse than they had anticipated: Republican Governor Baldwin was turned out of office by Democrat Robert A. Hurley, and estimates were that as many as nineteen members of the thirty-five seat state senate would be Roman Catholics. No more than thirteen likely supporters of any birth control bill could be identified, but while the Connecticut proponents realized that their chances for success were “remote” at best, they nonetheless concluded that they had no real choice except to put forward at least a modest version of a doctors-oriented reform bill. A legislative campaign, even if wholly unsuccessful, would keep the issue in the public eye; it also would make a subsequent court case seem more justified. Realizing that under the circumstances a modest legislative effort would be adequate, the relationship with JPJ was terminated as of early December and a full-time local "), _c('a', {
    attrs: {
      "id": "page_92"
    }
  }, [_vm._v("executive director, Bice Clemow—a journalist and close friend of one of Mrs. Hepburn’s sons-in-law—was hired instead. Many New York voices, including Ernst, Pilpel, and BCFA officials, as well as Pease and Hepburn, objected to the idea of a knowingly hopeless legislative campaign on behalf of any far from ideal bill, and Ernst attempted to sell the Connecticut lawyers on the same idea of a test case involving some birth control publication that he had unsuccessfully advocated in Massachusetts. The Connecticut attorneys were more interested in a test case involving an affirmative or declaratory civil suit brought on behalf of a physician who wanted to prescribe birth control for women patients, as distinct from a clinic opening and a defense against ensuing criminal charges, but one of their advisors, United States District Judge Carroll Hincks, warned that “the difficulty is to have an actual controversy” clearly shown in any such declaratory action. Consideration turned toward recruiting both a doctor/plaintiff and a senior lawyer of the “highest reputation in the bar” to bring the case, with Eleanor Calverly, who had worked for five years at the Hartford clinic, reluctantly bowing out because of family considerations."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-17",
      "id": "ch02-017-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By mid-January 1941 a consensus had evolved that both a declaratory test case and some legislative effort should be mounted. The first two high-status attorneys who were approached each declined, but the third, former state bar association president Frederick H. “Fritz” Wiggin of the prominent New Haven firm of Wiggin and Dana, readily agreed. Some advisors were surprised by Wiggin’s acceptance, for while he had with some hesitance helped Laurence Janney with the doctors’ amicus brief in "), _c('i', [_vm._v("Nelson")]), _vm._v(", he had also told Paul Franklin some months earlier that any test case “was doomed to failure” and that legislative reform was the league’s only recourse. Wiggin told Florence Darrach that the case would have to involve a situation where “a married woman would be very likely to lose her life” in pregnancy if refused birth control, and opined that in the Connecticut courts “this question might be decided either way, which is the equivalent of saying that I think there is a fair chance of a favorable decision.” Wiggin was unenthusiastic about but not flatly opposed to a legislative effort, and with his acquiescence Upson, Pease, Clemow, Creadick, and former house speaker William Hanna spent a long evening closeted with State Senator Alfred M. Bingham at Hartford’s Bond Hotel drafting what would be the league’s 1941 birth control bill."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-18",
      "id": "ch02-018-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So as purposely "), _c('i', [_vm._v("not")]), _vm._v(" to overlap with the upcoming court suit, the Bingham bill—and a similar one introduced in the state house by Westport representative Anne Arnold—spoke of authorizing “hospitals "), _c('a', {
    attrs: {
      "id": "page_93"
    }
  }, [_vm._v("or other health institutions” with five or more M.D.s—but "), _c('i', [_vm._v("not")]), _vm._v(" individual private doctors—to “prescribe contraceptive devices to meet health problems of married women.” Some doctors complained privately about that approach, but with the legislative hearing some eight weeks away, the bills attracted hardly any public attention. Instead, birth control news focused upon an angry interreligious debate between the league’s figurehead president, Robbins Barstow, and Hartford’s Father Andrew J. Kelly, who five years earlier had denounced the “busybody humanitarians” who had opened the Hartford clinic. The Barstow-Kelly brawl had been preceded by an exchange of opposing letters in the "), _c('i', [_vm._v("Waterbury American")]), _vm._v(" between Father Francis J. Barrett and Clara McTernan, but within short order the Kelly-Barstow exchanges were front-page news all across Connecticut.")])]), _c('a', {
    attrs: {
      "id": "page_93"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_93"
    }
  }, [_vm._v("Some weeks earlier Barstow had made the simple observation that birth control was an issue of “public welfare and not morality,” to which Kelly had responded by saying that the Hartford Diocese would withdraw from an annual interfaith service on account of such sacrilege. Barstow sought to assuage Kelly’s concern, explaining that he of course thought birth control “was distinctly a moral and spiritual matter,” and for several weeks the dispute seemed to fade. Then, just after the Bingham bill was introduced, Barstow declared in another speech that “it is contrary to our American principles of civil liberty to permit a situation where one particular religious viewpoint controls legislation governing the private lives of those who do not hold that doctrinal allegiance.” Kelly responded by accusing Barstow of “aligning himself with pagan forces” and “identifying God-fearing parents with stud farm animals.” The seminary executive ought to “choose between his position as president of a Christian foundation and president of a subversive league,” Kelly added, for “if he is Christian, I am not.” Barstow replied to this outburst with polite understatement, but Kelly persevered, labeling Barstow an “agnostic” who was championing a philosophy that was “essentially, admittedly and soundly pagan.” The league subtly responded with a "), _c('i', [_vm._v("Hartford Courant")]), _vm._v(" story noting that the majority of clinic patients between 1935 and 1940 had been Roman Catholic, and for ten days the uproar subsided."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-19",
      "id": "ch02-019-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then, in a February 27 speech at Wesleyan University in Middletown, Kit Hepburn criticized the "), _c('i', [_vm._v("Nelson")]), _vm._v(" decision and made an innocuous passing reference to Father Kelly that was picked up by the "), _c('i', [_vm._v("Hartford Courant")]), _vm._v(". Kelly responded that Hepburn, as a devotee of the philosophy of “naked paganism,” obviously had “little understanding of human nature” or “the content of morality.” Wesleyan President "), _c('a', {
    attrs: {
      "id": "page_94"
    }
  }, [_vm._v("James L. McConaughy then told the "), _c('i', [_vm._v("Courant")]), _vm._v(" that while he was “very sorry” about Connecticut’s anticontraception law, he was also “just a little sorry” that Hepburn had criticized the Connecticut Supreme Court during her talk, for “I can hardly see how they could have decided otherwise than they did.” He then released a letter to Hepburn asserting that “I ardently wish that we might have birth control clinics,” and Hepburn responded that she was sorry if she had embarrassed him by her criticism of the court’s “anti-social” ruling. Another Catholic cleric, Reverend Francis J. Sugrue of South Norwalk, eagerly joined the exchange by condemning birth control’s “lecherous leaders” for advocating “reckless irresponsibility.” Kelly added that Margaret Sanger had once advocated requiring advance licensing before mothers could have children, and when Sanger called the "), _c('i', [_vm._v("Courant")]), _vm._v(" to deny it, Kelly cited a 1934 Sanger article. As matters quieted once again, Connecticut League executive director Bice Clemow told the BCFA staff in New York that “Catholic opposition is rising in the state like a tidal wave.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-20",
      "id": "ch02-020-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While the public and many activists had been preoccupied with these exchanges, Fritz Wiggin had sought and found a willing plaintiff. Dr. Margaret Tyler, who for four years had worked in the New Haven clinic, had abashedly refused, but in early February Wiggin, helped by longtime league activist Betty Whittemore, successfully recruited sixty-five-year-old Yale Medical School professor and private practitioner Wilder Tileston. A quiet and private man who was well-known throughout the New Haven medical community, Tileston—with active help from Margaret Tyler—set about identifying and documenting the cases of three local women for whom a pregnancy, and the absence of birth control, could be a tangible threat to their lives. On March 13 he examined “Jane Doe,” a forty-one-year-old mother of five who was referred to him by New Haven Hospital through the efforts of Dr. Tyler. Jane Doe had had her last child just two months earlier and was suffering from extremely high blood pressure; when told she must avoid another pregnancy, she had asked how. Four days later New Haven Hospital referred “Mary Roe,” a twenty-two-year-old newlywed who was suffering from ongoing lung problems as a result of having contracted tuberculosis five years earlier, for which she had spent four years in a sanitorium. Lastly, on March 20, Tileston saw “Sarah Hoe,” a twenty-five-year-old poverty-stricken mother of three children, the youngest of whom was six months old.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That same day, March 20, Wiggin filed his formal complaint in Superior Court, naming New Haven County State’s Attorney Abraham S. Ullman—who had been in the post for less than four "), _c('a', {
    attrs: {
      "id": "page_95"
    }
  }, [_vm._v("months—as the defendant. It described the three women’s medical problems; Tileston stated that a pregnancy would be “exceedingly perilous” to Jane Doe’s life, and that “the best and safest medical treatment” for her was contraception as a “necessary preventative measure.” For Mary Roe, a pregnancy “would have a strong tendency” to reactivate her tuberculosis, which in turn “would undoubtedly disable her for a long time to come, and might cause her death.” If, through contraception, Mary Roe could avoid pregnancy for two to three years, she then should be able to have children without undue risks to her health. Sarah Hoe was presently “in good health,” the suit conceded, but another pregnancy so soon after her recent childbirth “would probably have a serious effect on her general health and might result in her permanent disability.” Additionally, a fourth child “would aggravate an economic condition already difficult, and hazardous to the health of the mother and her children.”")])]), _c('a', {
    attrs: {
      "id": "page_95"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_95"
    }
  }, [_vm._v("Having described the three cases, where “conception would probably cause (a) her death; (b) serious permanent injury to her health; (c) injury to her general health,” Wiggin asserted that the 1879 statute prohibiting Tileston from prescribing birth control for these women violated two provisions of the Connecticut Constitution and three amendments to the U.S. Constitution. Most significantly, he and Tileston contended that the law offended the Fourteenth Amendment’s guarantee against “depriving any person of life without due process of law” and also, in the context of the Amendment’s similar due process protection against deprivation of property, infringed upon Tileston’s “privilege of practicing his profession” as a doctor."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-21",
      "id": "ch02-021-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Only five days after the case’s filing was news of it released to the press, and it received very limited publicity. Tileston told the Associated Press that “Connecticut doctors have been faced with the alternatives of turning away mothers to whom another pregnancy may mean permanent injury to health or even death itself, or of subjecting themselves to criminal prosecution,” and that the law’s intrusion had to be remedied. On April 1 there was a very brief initial hearing in New Haven which received absolutely no news coverage, and nine days later attention turned to the long-delayed legislative hearing on Senator Bingham’s reform bill.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While Robbins Barstow was the leadoff witness for the bill’s supporters, emphasizing how it would insure “the individual liberties of married citizens,” the proponents had purposely weighted their presentation to women who could speak firsthand about the importance of clinic services: Dr. Hilda Standish, Daisy M. Dennison, who had "), _c('a', {
    attrs: {
      "id": "page_96"
    }
  }, [_vm._v("worked in the Norwalk clinic, and six former clinic patients. As two onlookers from BCFA noted, “The members of the committee listened more attentively to these women than to any of the speakers.” Twenty legislators also appeared to register their support, and then the other side took the floor, with Mrs. Francis E. Jones—whose husband had represented the opponents back in 1923 and 1931—saying that the Bishop of Hartford had asked her to register his opposition, along with that of some 131 affiliated groups for whom she also spoke. Among half a dozen opposing speakers the most notable was seventy-year-old State Labor Commissioner Cornelius J. Danaher, whom the BCFA visitors described as “a big, bull-necked, loud mouthed individual” who “pulled out all the stops” and characterized Margaret Sanger as “the crown princess of race suicide.” Then, as the hearing was breaking up, the dramatic highlight of the day occurred as forty-eight-year-old Republican Representative Bernard Matthies of Seymour, a birth control supporter, told the much larger Danaher that his had been “the damnedest speech I ever heard” and that “I have a good mind to punch you in the nose.” Danaher replied that “I’ll punch you in the nose if you don’t get out of here,” and as other legislators stepped between the two men, Matthies ended the confrontation by asking “How much did the priests pay you?”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-22",
      "id": "ch02-022-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Proponents and press observers agreed that the bill had no prospects in the senate, and hence might not even be brought up for passage in the house, but opposition forces continued their push, with the diocesan newspaper, the "), _c('i', [_vm._v("Catholic Transcript")]), _vm._v(", lambasting birth control as both “a flight from decency” and also “a flight to calamity.” Feeling obligated to address the hearing testimony of the former clinic patients, the "), _c('i', [_vm._v("Transcript")]), _vm._v(" declared that “the real problem is the rotten, inequitable economic system of which these people are the victims and of which many of the socially prominent birth prevention advocates are the vigilant guardians and fat beneficiaries.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Pondering their hopeless legislative chances, Florence Darrach and other Connecticut activists realized they had seriously erred nine months earlier when they had accepted then-Governor Baldwin’s advice that birth control not be raised as an issue in the 1940 elections. In 1942, Darrach told one reporter, that mistake of deferring to the Republican leadership would not be repeated: “We didn’t start out to be politicians, but we’re sick of any party solidarity which soft-pedals our effort to legalize birth control clinics.” Mitigating that irritation was the widespread belief that the "), _c('i', [_vm._v("Tileston")]), _vm._v(" suit might well resolve the problem. Harriet Pilpel volunteered that “the complaint is an excellent "), _c('a', {
    attrs: {
      "id": "page_97"
    }
  }, [_vm._v("job,” and Darrach told one friend that “"), _c('i', [_vm._v("many")]), _vm._v(" lawyers think that we are going to win the test case.… I am hopeful that by autumn we may be opening a few clinics” even if the legislative effort went nowhere."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-23",
      "id": "ch02-023-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On May 13, at the prodding of birth control supporters and against the wishes of the Republican leadership, the house Public Health and Safety Committee voted twelve to three to send an amended version of the Bingham bill, one that would allow "), _c('i', [_vm._v("all")]), _vm._v(" doctors to prescribe birth control, to the house floor. One week later, after a brief and perfunctory debate and rejection by 169 to 71 of a motion to table, the house passed the bill on a vote of 164 to 64. The senate members of the Public Health and Safety Committee voted two to one against the measure, but on May 27, largely through the efforts of Senator Bingham himself, the bill nonetheless reached the senate floor, where Bingham and leading opposition Senator Joseph P. Cooney of Hartford engaged in what one paper called a “stirring” debate in front of “the largest audience of the session,” most of whom were women. Bingham declared that the central issue was “whether freedom is to be given to human beings,” but when the senate roll was called, only nine members voted in favor of the bill, and twenty-three against. Of those opponents, twenty-one were Democrats, and twenty were Roman Catholics. The Connecticut League announced that the “battle of 1943” was now beginning, and said it would single out for special attention “any politician who himself practices medically sound birth control but denies it to ill and under-privileged families.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-24",
      "id": "ch02-024-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Eight days after the Connecticut senate vote both houses of the Massachusetts legislature took the next step toward assuring a statewide 1942 referendum when they declined to pass the birth control proposal. Proponents had successfully overcome an attempt by opponents to derail the referendum plan on the grounds that the Massachusetts Constitution barred popular votes on religious issues, with the Massachusetts Supreme Judicial Court stating that the birth control amendment was not a religious matter. Following those legislative votes the proponents would have to submit a modest number of additional petition signatures that summer, but the referendum plan appeared to be on track for a 1942 vote."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-25",
      "id": "ch02-025-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With the conclusion of the 1941 legislative session, the Connecticut activists vowed to take an aggressive interest in the 1942 selection of state senate candidates, particularly in politically competitive districts. Clemow and others were disappointed at the relative slowness with which the "), _c('i', [_vm._v("Tileston")]), _vm._v(" case was progressing, and because of crowded court dockets the entire summer passed without any significant "), _c('a', {
    attrs: {
      "id": "page_98"
    }
  }, [_vm._v("developments. By mid-September Wiggin and State’s Attorney Ullman had agreed to proceed by stipulation rather than conduct an actual trial, and the Connecticut League spent the fall impatiently waiting for the case to move forward. The league’s active membership dwindled significantly in the absence of a conspicuous program, and a well-publicized mid-October dinner in Hartford featuring Kit Hepburn and chaired by Sallie Pease drew only seventy-five people. Hepburn used the occasion to reflect upon her thirty years of political activism, explaining that birth control had attracted her because “I felt that women would always be hopelessly handicapped if they did not have control of how many children they produced.” “It’s perfectly all right,” she added, “for Catholics to follow the dictates of their church, but to force their idea on other people is Nazi procedure.” Outspoken Father Kelly quickly responded by asserting that “We shall enjoy civil liberties only so long as religion is entangled with our laws,” but no rejoinder ensued. By late November Clemow warned the league’s officers that “Every week we suffer from dwindling interest and flagging courage.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-26",
      "id": "ch02-026-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Finally, on December 2—just five days before the Pearl Harbor attack transformed the entire American scene—Wiggin and Ullman filed the "), _c('i', [_vm._v("Tileston")]), _vm._v(" stipulation in New Haven County Superior Court. Dr. Tileston’s medical evaluations of Doe, Roe, and Hoe had been reviewed and endorsed by four prominent fellow doctors, including James Raglan Miller, and a New Haven M.D. who examined all three of the women on behalf of Ullman, Dr. Samuel J. Goldberg, likewise concurred. In Jane Doe’s and Mary Roe’s cases, Goldberg agreed, pregnancies would pose a serious threat to the woman’s life and “should be prevented by any means available.” Pursuant to both sides’ agreement, Superior Court Judge Earnest C. Simpson signed a brief order referring the questions of law posed by the suit to the Connecticut Supreme Court, and oral argument before the high bench was scheduled for early February of 1942.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The full-scale outbreak of World War II significantly hampered the Connecticut League’s ability to attract volunteers and funds, and led the officers to focus their hopes even more heavily upon eventual success in the "), _c('i', [_vm._v("Tileston")]), _vm._v(" case. In late January Fritz Wiggin and his junior colleague, John Q. Tilson, Jr., filed their brief with the Connecticut Supreme Court, arguing that the 1879 statute had been intended solely as an antiobscenity measure and should not be construed as applying to medically approved contraception in cases where serious health threats existed. The "), _c('i', [_vm._v("Nelson")]), _vm._v(" ruling, they contended, “is not inconsistent with” such a position, for it “clearly reserved for future decision the question "), _c('a', {
    attrs: {
      "id": "page_99"
    }
  }, [_vm._v("of whether a physician may lawfully prescribe contraceptive devices where medical prescription is necessary to the life of the patient.” If the 1879 statute "), _c('i', [_vm._v("was")]), _vm._v(" read as prohibiting the prescription of birth control in such serious cases, they added, “it would be an unreasonable interference with the life and liberty of the physician and of his patients” as protected by the Fourteenth Amendment and hence would be unconstitutional.")])]), _c('a', {
    attrs: {
      "id": "page_99"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Wiggin and Tilson maintained that "), _c('i', [_vm._v("Gardner")]), _vm._v(" was “much weakened as authority” by "), _c('i', [_vm._v("Corbett")]), _vm._v(", which signaled “a distinct change in the opinion of the Massachusetts court.” The unspoken inference was that if the Massachusetts court could so quickly and nimbly change direction, so too could the Connecticut one. They echoed Upson’s emphasis from two years earlier that citizens possess an inherent right to protect their lives and health, and that “any attempt by the Legislature to outlaw medical contraception would be arbitrary and invalid since it would be taking from the citizen his inalienable right to liberty and health.” They concluded by trying to magnify the differences between "), _c('i', [_vm._v("Tileston")]), _vm._v(" and "), _c('i', [_vm._v("Nelson")]), _vm._v(", for “the facts in this case are far different” and "), _c('i', [_vm._v("Nelson")]), _vm._v(" “has no application to a situation where serious injury to health or danger to life is involved.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_99"
    }
  }, [_vm._v("“Ab” Ullman was viewed as a friendly professional adversary by Wiggin and Tilson, and Ullman’s brief in opposition was calm and straightforward. It noted, as the proponents had unspokenly conceded, that Sarah Hoe’s case, unlike Doe’s and Roe’s, was indistinguishable from "), _c('i', [_vm._v("Nelson")]), _vm._v(", and cited both the Connecticut precedent and "), _c('i', [_vm._v("Gardner")]), _vm._v(" as holding that “The language of these statutes forbids an exception for physicians under any circumstances.” Additionally, in light of Connecticut’s recent history, “The repeated rejection of proposed changes demonstrates the legislative intent to include all persons and all cases” under the statute. “We may doubt the wisdom of the statute or question its propriety,” Ullman conceded, “but the manifest intention of the Legislature of this State for all-out prohibition cannot be denied,” and for the court to hold otherwise “would in effect constitute legislation by judicial interpretation.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-27",
      "id": "ch02-027-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fritz Wiggin firmly instructed the league that he did "), _c('i', [_vm._v("not")]), _vm._v(" want a large turnout of members for the February 4 oral argument, for “This would be unusual, and … might irritate the Judges,” but Wiggin received a slightly frosty reception, particularly from Chief Justice Maltbie, even in the absence of any visible crowd. One league officer congratulated Wiggin on his “calm and dignified answers” to Maltbie’s many questions, and league office secretary Mabel Robbins said that she had been "), _c('a', {
    attrs: {
      "id": "page_100"
    }
  }, [_vm._v("similarly impressed: “I do not see how we can fail to get a favorable ruling after listening to your argument. The Chief Justice showed a decided prejudice at the beginning but it seemed to me you had no difficulty later in overcoming it.” Robbins added that her certainty that they would prevail had been further strengthened by Ullman’s argument, for it seemed as if “the prosecuting attorney was more for than against us.”")])]), _c('a', {
    attrs: {
      "id": "page_100"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_100"
    }
  }, [_vm._v("Wiggin himself, however, was a good deal less optimistic. “The Chief Justice said very frankly during the argument,” he told one activist, “that what bothered him the most was the repeated refusals of recent sessions of the General Assembly to amend the law in any way even to permit contraception under the advice and direction of physicians. He said it was asking a good deal in the face of this to request the court to read an exception into a statute which on its face has no exceptions. I gave him the best answers I could to that but I feel that if certain members of the court are favorably disposed to us, which I hope is so, they will have a hard time bringing the Chief Justice around.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-28",
      "id": "ch02-028-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For the next four months the Connecticut League did little more than sit and wait for the court to issue its decision. Kenneth Rose had succeeded in changing the name of the national group from the Birth Control Federation to the Planned Parenthood Federation of America (PPFA), and in May the Connecticut League followed suit, becoming the Planned Parenthood League of Connecticut (PPLC). Then, on June 2, came the decision from the Connecticut Supreme Court: a 3 to 2 affirmance of both the statute and "), _c('i', [_vm._v("Nelson")]), _vm._v(". As before, Justices Newell Jennings and Christopher Avery dissented, but the majority opinion, supported both by Chief Justice Maltbie and Justice Brown, was authored by the Court’s sole new member since "), _c('i', [_vm._v("Nelson")]), _vm._v(", and the hypothetical swing vote, Justice Arthur F. Ells. The legislature, both in 1879 and from 1917 to the present, had clearly intended that "), _c('i', [_vm._v("all")]), _vm._v(" contraception be forbidden: “The manifest intention of the legislature of this state, to date, for all-out prohibition cannot very well be denied.” Additionally, the legislature was constitutionally entitled to believe, and mandate, that abstinence from sexual relations, rather than the use of contraceptives, should be practiced by married women for whom a possible pregnancy could prove life-threatening. Avery and Jennings voiced agreement with the plaintiff’s contention that "), _c('i', [_vm._v("Nelson")]), _vm._v(" had been largely based upon "), _c('i', [_vm._v("Gardner")]), _vm._v(", which "), _c('i', [_vm._v("had")]), _vm._v(" been fundamentally undercut by "), _c('i', [_vm._v("Corbett")]), _vm._v(", but they were the minority."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-29",
      "id": "ch02-029-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Connecticut League was disappointed but not stunned by the outcome, and immediately vowed to appeal to the U.S. Supreme "), _c('a', {
    attrs: {
      "id": "page_101"
    }
  }, [_vm._v("Court. National PPFA quickly suggested that PPLC engage Morris Ernst to handle the appeal, and, in part because it initially was indicated that Ernst would do it for free, and in part because Wiggin did not at first seem especially interested, the Connecticut leadership readily agreed. Everyone appreciated that it was not certain that the Supreme Court would choose to hear the appeal, but PPLC officials felt they had little choice but to hope for the best, because, as Mabel Robbins told one colleague, “it would be tragic to have to go to the Legislature again.”")])]), _c('a', {
    attrs: {
      "id": "page_101"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_101"
    }
  }, [_vm._v("In late August Ernst and Pilpel filed the initial appeal papers with the Supreme Court. A month later Ab Ullman filed a brief opposing statement, emphasizing that “the real parties in interest” in the case were Doe, Roe, and Hoe, rather than Dr. Tileston, and that in their absence as actual plaintiffs, no decision of the case on its merits could properly take place. Two amicus briefs, one by Warren Upson on behalf of Connecticut doctors, and one by Charles E. Scribner of New York on behalf of other M.D.s, were also being prepared, and a “Dear Doctor” letter soliciting signatures for the Connecticut amicus brief was mailed to some fifteen hundred physicians. Over five hundred affirmative replies quickly came in, but the letter’s tough language, indicating that physicians’ rights were “under attack” by Ullman in “a barefaced assault on the entire medical profession” understandably angered the exceedingly cooperative state’s attorney. Upson took upon himself the task of remedying the frayed relationships, and after two weeks of time-consuming exchanges among all the parties a “Dear Doctor” letter was sent out in Upson’s name telling recipients that Ullman was simply “a conscientious public servant who is doing his duty.” Finally, in late October, both Ernst’s principal brief and the two amicus briefs were filed, with a total of over seven hundred doctors listed as endorsers, a tally that drew great considerable attention in the Connecticut press."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-30",
      "id": "ch02-030-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On November 3, however, birth control supporters suffered a huge and embarrassing setback when the voters of Massachusetts overwhelmingly "), _c('i', [_vm._v("rejected")]), _vm._v(" the referendum proposal that would have legalized the medical prescription of contraception for married women for whom a pregnancy would threaten their health. In the eyes of the Massachusetts proponents, the margin of defeat—58 to 42 percent—was wholly the result of what they viewed as an intensive Roman Catholic advertising campaign against the measure, a campaign whose featured slogan had been “Birth Control Is Against God’s Law—Vote NO.” Six months before the vote the proponents had overcome yet "), _c('a', {
    attrs: {
      "id": "page_102"
    }
  }, [_vm._v("another legal maneuver aimed at derailing the plebiscite, but the fall campaign had been an intense and emotional affair, and the Massachusetts activists were not wholly surprised at the outcome."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-31",
      "id": "ch02-031-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The PPLC viewed the Massachusetts result as extremely disheartening, but was overjoyed at Connecticut’s own election results: Republican Raymond E. Baldwin was returned to office as governor, and, more importantly, for the first time in twelve years there was a Republican majority in the state senate as well as in the house. This offered “a fighting chance for success” in the 1943 legislature, Florence Darrach told league members, but PPLC’s hopes remained focused on the "), _c('i', [_vm._v("Tileston")]), _vm._v(" case, and when the U.S. Supreme Court announced on November 9 that it would hear the appeal, those hopes were raised even further.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Inside the Supreme Court, however, "), _c('i', [_vm._v("Tileston")]), _vm._v(" v. "), _c('i', [_vm._v("Ullman")]), _vm._v(" looked like an unremarkable and probably fatally flawed appeal. Two serious problems were readily apparent. First, as law clerk Vern Countryman related to Justice William O. Douglas: “no ‘case or controversy,’” as required by the U.S. Constitution, “is presented on this appeal.” Ullman’s and Wiggin’s initial stipulation a year earlier stated only that prosecutors “claim or may claim” that medical prescription of birth control violated the 1879 statute, and, as Countryman pointed out, “This does not evidence a present controversy—it shows no more than that there may be a controversy now, or there may be a controversy arising in the future, or that no controversy will ever arise” with actual criminal charges being filed against an offending physician. Second, and even more notably, Countryman told Douglas, “I don’t believe that [the] Appellant,” Dr. Tileston, “has the standing to raise the constitutional questions here asserted. All of the constitutional rights which [the] Appellant contends are violated belong not to him, but to his patients”—just as Ullman had emphasized in pointing out that the three women were the real—but missing—plaintiffs in the case. “Were it not for these jurisdictional defects,” Countryman volunteered, “I believe that the case on the merits under due process is a substantial one,” and that the Court’s affirmance of "), _c('i', [_vm._v("Gardner")]), _vm._v(" four years earlier was not determinative: “this case is not similar. In the "), _c('i', [_vm._v("Gardner")]), _vm._v(" case there was no showing of the circumstances of the patients for whom the physician prescribed the contraceptives.” But Fritz Wiggin, however, had failed to include the women themselves as plaintiffs."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-32",
      "id": "ch02-032-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Morris Ernst and Harriet Pilpel had some sense of the serious procedural obstacles that they faced, and in late November they moved to recruit the country’s top expert in declaratory judgment suits—and a "), _c('a', {
    attrs: {
      "id": "page_103"
    }
  }, [_vm._v("personal friend of Dr. Tileston’s—Yale law professor Edwin Borchard, to their side. The proponents also agreed that both Upson and Scribner would submit supplementary amicus briefs, but despite almost daily correspondence amongst all the attorneys throughout the month of December, neither Borchard nor Ernst devoted much thought to the possibility that the Justices would consider the omission of the three women patients as plaintiffs to be a fatal flaw."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-33",
      "id": "ch02-033-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The oral argument of "), _c('i', [_vm._v("Tileston")]), _vm._v(" v. "), _c('i', [_vm._v("Ullman")]), _vm._v(" before the Supreme Court began late in the afternoon of Wednesday, January 13, 1943, and Morris Ernst was no more than two minutes into his initial remarks when Chief Justice Harlan Fiske Stone interrupted him to ask whether the Fourteenth Amendment issue in the case, in light of Wiggin’s initial complaint, was limited simply to the question of whether the Connecticut statute deprived someone of “life” without due process of law. Ernst answered that in the initial appeal papers to the U.S. Supreme Court he had cited the full Fourteenth Amendment panoply of “life, liberty, or property,” but Stone replied that the issue here was of course limited to whatever the Connecticut Supreme Court itself had passed upon. Ernst responded that the life of the patient was indeed involved, but Stone rightfully countered that the life claim had to involve the life of the plaintiff who was invoking the Fourteenth Amendment, namely Dr. Tileston. Justices William O. Douglas and Robert H. Jackson followed up with other questions, but then Chief Justice Stone jumped back in to ask whether there really was any actual controversy here, since the original complaint had not alleged any real threat of prosecution. Ernst answered that "), _c('i', [_vm._v("Nelson")]), _vm._v(" was powerful evidence of just such a threat, and Stone replied that the complaint might have satisfied that problem had it cited "), _c('i', [_vm._v("Nelson")]), _vm._v(", but it had not. Fortunately for Ernst, who later called the experience “most uncomfortable,” the Court adjourned each day at precisely four-thirty p.m. Warren Upson believed that Ernst had done “a splendid job” at coping with Stone’s onslaught, but there was no way of curing the original shortcomings that had been inherited from Fritz Wiggin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Upson, Ernst, and Charles Scribner spent a good part of the evening looking up references that might help to extricate Ernst from his predicament when the argument resumed on Thursday morning, but Ernst made no more headway against the Chief Justice then than he had on Wednesday. Finally, in open acknowledgment of how dire the situation was, Ernst volunteered that if the Court concluded that Stone was indeed correct, he would request a continuance and seek a formal clarification from the Connecticut Supreme Court that “liberty” and "), _c('a', {
    attrs: {
      "id": "page_104"
    }
  }, [_vm._v("“property” had indeed been at issue. Then Ernst introduced his colleague Edwin Borchard, who also tangled with the Chief Justice over the question of whether the 1879 statute’s very existence represented a threat of prosecution sufficient to create an actual controversy.")])]), _c('a', {
    attrs: {
      "id": "page_104"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_104"
    }
  }, [_vm._v("New Haven attorney William L. Beers, whom Ullman had hired six weeks earlier to help with "), _c('i', [_vm._v("Tileston")]), _vm._v(", opened the opposition argument. Beers focused upon the procedural problems, contending that Dr. Tileston “had shown no substantial right of his own” to be at issue. Then Ab Ullman addressed the merits, saying that “a state has the right to control the marital relations of its citizens” and that birth control involved “moral and sociological problems that are appropriate for the legislature but not for the courts.” Ernst had reserved a few minutes of his time for rebuttal, and finally for the first time was able to speak to the merits without being interrupted by questions about the technical flaws."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-34",
      "id": "ch02-034-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Afterward both Ernst and Upson were appropriately downcast about the likely outcome. Upson wrote Ab Ullman that “I thought that you and Bill Beers did altogether too well in arguing your side,” and to Nowell Creadick he explained that the real problem was not their opponents, but the combination of Fritz Wiggin and the Chief Justice. “I think that there are some members of the Court who would like to decide in our favor,” but “I think that the technical difficulties may prevent a decision on the merits.” If that indeed was the case, “I think we can safely assume that the majority of the Court was not with us.” Ernst told one friend that he fully expected the Court to reject the appeal, and when he and Upson met with the leaders of the Connecticut League to advise them about introducing a bill into the 1943 legislature, both men strongly recommended that a legislative campaign be mounted, for the chance of success in the Supreme Court now looked very modest indeed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ernst and Borchard were sufficiently perturbed at how the oral argument had gone that they agreed to take a decidedly unusual step: a postargument letter addressed to Chief Justice Stone that reiterated once again their assertion that the simple presence of "), _c('i', [_vm._v("Nelson")]), _vm._v(" as a precedent served as a more than adequate threat of criminal prosecution for a doctor such as Wilder Tileston should he prescribe contraception for a Jane Doe or Mary Roe. “During the oral argument several observations were made by members of the Court as to which there was no opportunity for comment,” Ernst cheekily asserted. “If this letter may properly be circulated and if in your judgment it would be of aid to the Court, I respectfully urge its distribution.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-35",
      "id": "ch02-035-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_105"
    }
  }, [_vm._v("Harlan Fiske Stone neither circulated nor acknowledged Ernst’s impudent letter. He had no need to, for the outcome of "), _c('i', [_vm._v("Tileston")]), _vm._v(" v. "), _c('i', [_vm._v("Ullman")]), _vm._v(" had been decided two days after oral argument and two days before Ernst had mailed his missive. Just as the barrage of questions at the argument had suggested, there was no doubt or disagreement within the Court that "), _c('i', [_vm._v("Tileston")]), _vm._v(" was indeed a fatally flawed case. As Justice William O. Douglas jotted to himself during the Justices’ private conference, Wiggin’s citation of “‘life’ only” under the Fourteenth Amendment was not correctable. Tileston—or Wiggin—“need not have [limited] his const[itutional] claim but he did.” Stone or some other Justice noted the apparent “close collaboration between pl[aintiff] and def[endant]” that was reflected in the case’s record, and in the absence of clearer evidence of a true controversy, “we have no case here … we take cases only where there is [a] case or controversy as defined in [the] Constitution.” Chief Justice Stone said that he would prepare a brief, unsigned per curiam opinion on behalf of his unanimous colleagues explaining the case’s defects and dismissing the appeal.")])]), _c('a', {
    attrs: {
      "id": "page_105"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_105"
    }
  }, [_vm._v("On Monday, February 1, the "), _c('i', [_vm._v("Tileston")]), _vm._v(" decision was announced. It noted that Wiggin’s original complaint “contained no allegations asserting any claim under the Fourteenth Amendment of infringement of appellant’s liberty or his property rights.” Additionally, the complaint’s reference to “life” clearly meant that of Dr. Tileston’s patients, not the doctor himself, and for that constitutional argument to be made, the patients themselves, and not merely their doctor, would have to be plaintiffs in the case."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-36",
      "id": "ch02-036-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Connecticut League’s lawyers were disappointed but not surprised by the Court’s quick and decisive action. Dr. Tileston called the result “not unexpected” and pointed out that the issue would now go before the 1943 legislature. Warren Upson told Morris Ernst that “everybody feels that you did a superb job under difficult handicaps,” but conceded that any “further action through the courts will be difficult. The only possibility” would be “a criminal suit in which a patient is actually prosecuted,” and such a case “obviously” would be difficult to generate.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ernst himself was both angered and embarrassed. He tried to persuade Wiggin and John Tilson to consider petitioning the Connecticut Supreme Court to reopen "), _c('i', [_vm._v("Tileston")]), _vm._v(" so that the initial defects could be corrected and the case resubmitted to the U.S. Supreme Court, but Wiggin wanted nothing more to do with the matter. Ernst broached the same idea to Upson, and Upson discussed the question with William Beer, who in turn raised it both with Ab Ullman and, very privately, "), _c('a', {
    attrs: {
      "id": "page_106"
    }
  }, [_vm._v("with Chief Justice Maltbie and Justice Arthur Ells. Ullman already had greeted news of the decision with an odd statement for the supposed victor, stressing that the ruling “did not involve the merits of birth control” and that the statute could soon be reviewed by the legislature. Ullman was unenthusiastic about any reopening of "), _c('i', [_vm._v("Tileston")]), _vm._v(", however, and Beer further told Upson that “both Maltbie and Ells are hostile to any clarification in the Connecticut Supreme Court.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-37",
      "id": "ch02-037-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Morris Ernst wanted both PPLC and PPFA to commit themselves immediately to mounting another case, this time on behalf of a patient as well as a doctor, but in Connecticut, league officials were now focusing upon the legislative session that lay immediately ahead. The "), _c('i', [_vm._v("Hartford Courant")]), _vm._v(" had responded to "), _c('i', [_vm._v("Tileston")]), _vm._v(" by stating that now the birth control debate would occur “in a considerably different climate from the one that prevailed a few years ago,” and that “a different outcome” might result because of the new Republican majority in the state senate. Upson and Yale’s Dr. C.-E. A. Winslow had helped an enthusiastic Republican house member, C. William Janson of Westport, draft the league’s reform bill, a purposely novel measure stating that only registered pharmacists could sell contraceptives. By mid-March, however, even the resolute Upson thought its chances in the senate were no better than “doubtful,” and in private league activists began to talk of searching for a willing plaintiff or two as soon as the legislative session concluded."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-38",
      "id": "ch02-038-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The 1943 legislative hearing took place on March 31, with Warren Upson taking advantage of the unconventional bill to stress that at present the "), _c('i', [_vm._v("sale")]), _vm._v(" of contraceptives—as distinct from both “use” and the attendant “aiding and abetting” statute—was neither prohibited nor regulated by state law. Louise Fisher, once again leading the opposition on behalf of the Bishop of Hartford, forthrightly insisted that the measure “basically attacks the Catholic principles of family life and is an infringement on the moral rights of the individual in that it attempts to alter the natural law and encourages the abuse of a normal human faculty.” Labor Commissioner Cornelius J. Danaher repeated his bravura performance from the 1941 hearing, this time invoking the costs of World War II as an additional reason for opposing a bill that represented “a direct assault on our strength as a nation.” It was “a matter of national survival,” Danaher insisted, that “America must propagate the family and perpetuate the species.… There should be no rationing of babies.” Shifting to more natural ground, the commissioner added that “contraception is an offense against the moral law” before returning to his patriotic theme that “We need more men and women who think "), _c('a', {
    attrs: {
      "id": "page_107"
    }
  }, [_vm._v("more of their country and less of their own comfort, convenience or pleasure.”")])]), _c('a', {
    attrs: {
      "id": "page_107"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_107"
    }
  }, [_vm._v("Danaher’s rhetorical dominance of the hearing was bad enough in itself, but the Hartford papers stressed the more serious news that quiet vote counting within the thirty-six-member state senate showed at least twenty firm votes against the Janson bill. On April 14, after rejecting several opposition amendments, including one to pay women two hundred fifty dollars per childbirth, the house passed the measure on a vote of 155 to 84. One week later, however, when the bill was debated in the senate, the final roll-call vote was even worse than expected, a 24 to 11 defeat. Upson and others turned a new ear toward Ernst’s and Pilpel’s renewed suggestions that a new court case be developed, and one senator advised Upson that he should discard any hope of ever getting any birth control bill through the state senate, for “in a highly Catholicized state” that “is almost next to the impossible.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-39",
      "id": "ch02-039-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("PPFA staffers recommended that the Connecticut and Massachusetts leagues consider joining forces behind some case, but Upson warned PPFA director Ken Rose that too much emphasis on creating another case could be detrimental to PPLC: “I think it would be harmful to the organization to have the members get the impression that all they have to do is raise the money and leave it to the lawyers to win the battles.” New PPLC president Harriet Crawford Janney, an experienced social worker whose husband had authored the amicus brief in "), _c('i', [_vm._v("Nelson")]), _vm._v(", agreed with Upson’s warning, but after one meeting of both Connecticut and Massachusetts activists to discuss a joint educational program, little occurred in either state until the beginning of the fall."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-40",
      "id": "ch02-040-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Throughout September PPFA staffer Edna McKinnon explored test case possibilities in both Massachusetts and Connecticut. Some thought was given to the idea of simply opening a clinic, probably in Greenwich, if a willing doctor could be found, but several months passed without any significant progress. Late in the year the Connecticut attorneys realized that league sponsorship of a clinic could leave all league officers and board members open to criminal charges under the state’s all-purpose conspiracy statute, and enthusiasm understandably cooled. National public opinion polls indicated that popular acceptance of birth control was continuing to grow, with 85 percent of women—and 69 percent of Catholic women—endorsing the availability of contraceptive information. But birth control opponents remained vocal, with Father Edgar Schmiedler, Director of the Family Life Bureau of the National Catholic Welfare Conference, writing in "), _c('i', [_vm._v("Reader’s Digest")]), _vm._v(" that birth control was “a cause that threatens the whole "), _c('a', {
    attrs: {
      "id": "page_108"
    }
  }, [_vm._v("Western world” and in particular was “a decided menace to the future leadership of the white race.” Offering a decidedly unique view in the midst of World War II, Schmiedler explained that “Japanese birth-control devices in the homes of America can be more destructive than Japanese bombers over Pearl Harbor. Bombs destroy. Birth control not only destroys but poisons.” But Schmiedler sounded pessimistic about the American future irrespective of Japanese imports, decrying “the putrid cess-pool that so much of American family life has become.” And the spread of birth control was the cause: “Loosen one thread in the moral fabric and the whole garment speedily disintegrates.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-41",
      "id": "ch02-041-41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By early 1944 both the Connecticut and the Massachusetts activists were still trying to identify a possible test case plaintiff. Finally, in mid-March, Harriet Janney discovered an interested doctor, Josephine Evarts, in Litchfield County in northwestern Connecticut, and on March 20 both Janney and Edna McKinnon visited her. Born forty-three years earlier in Vermont, Jo Evarts had graduated from Vassar and then from Columbia University’s College of Physicians and Surgeons. She had practiced in Kent, Connecticut, since 1929, and she told Janney and McKinnon that she was intrigued by the idea of a test case in part because her father had been an attorney. She of course dispensed contraceptives to her own patients, and there were two women, one with high blood pressure, and one with kidney disease, either or both of whom might make ideal coplaintiffs. Evarts struck them as “completely fearless” yet “cautious,” and ten days later Evarts had lunch in New York with PPFA director Ken Rose and two of the organization’s legal advisors, Charles Scribner and Morris Hadley. Evarts told them that one of the patients was leaving the area, and that while she herself remained willing if a case could proceed without publicity, that she also hoped “that a doctor could be found in some other county.” The lawyers nonetheless began making discreet inquiries with attorneys and local judges in Litchfield County, and Pilpel and Ernst moved assertively to ensure that if a case indeed developed, this time they would not be left trying to repair errors that others had made at the outset."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-42",
      "id": "ch02-042-42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By the time of PPLC’s annual meeting in mid-May the prior idea of doing a public education campaign in conjunction with the Massachusetts league had been discarded, but in considering it an effort had been made to identify a possible director for the program, and a recently widowed PPLC board member, Mary Van Zile Cunningham, had become the leading candidate. “Molly” Cunningham’s late husband Gerald, the longtime rector of Stamford’s "), _c('a', {
    attrs: {
      "id": "page_109"
    }
  }, [_vm._v("St. John’s Episcopal Church, had been an officer of the Connecticut League as early as 1928, and Molly herself had been active in the Stamford clinic in the late 1930s. Now, with the Massachusetts venture shelved and the 1945 legislative session on the horizon, the league decided that the time had come to return to having a full-time executive director of the sort that Bice Clemow had been in 1941, and Molly Cunningham was the choice.")])]), _c('a', {
    attrs: {
      "id": "page_109"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Hiring Molly Cunningham was the best move the Connecticut League had made since Sallie Pease and Kit Hepburn had been effectively deposed four years earlier. Born in 1888 in New York City, where her father was a reporter for the "), _c('i', [_vm._v("New York World")]), _vm._v(" and her mother a Republican district leader on the East Side, Molly Cunningham grew up in a political family; a much-discussed uncle on her mother’s side was one-time Connecticut Governor Morgan G. “Crow Bar” Bulkeley, so named because of the implement he had used to gain access to the state house chamber during one particularly contentious legislative session in the 1890s. After marriage, living on the Lower East Side of Manhattan, Molly Cunningham had worked as a poll watcher at East 12th Street and Avenue C; even forty years later she would recall her happiest experience in life as having been the historic rally at the Cooper Union celebrating the ratification of the Nineteenth Amendment and the winning of female suffrage.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_109"
    }
  }, [_vm._v("In seeking to legalize women’s access to birth control, “We are fighting for the same fundamental principle as the suffrage,” Molly Cunningham told that PPLC annual meeting. But no concrete progress was being made on the possible test case involving Dr. Evarts, and, despite Morris Ernst’s energetic prodding, no case was developing in Massachusetts, either. Cunningham and Connecticut president Janney began to discuss commissioning a professional public opinion poll of state voters’ views on the birth control issue as a useful weapon in the 1945 legislative session, and sometime in the summer Cunningham went to see Dr. Evarts, who indicated she was so busy that “she has not a minute for anything but her profession.” By early in the fall the Connecticut activists were focusing on the 1944 elections and the 1945 legislature, and a dispirited Morris Ernst was telling Margaret Sanger that in spite of all the meetings, letters and phone calls, “somehow nothing seems to develop” in either Massachusetts or Connecticut."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-43",
      "id": "ch02-043-43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The November 1944 elections once again returned Ray Baldwin to the Connecticut governorship, but otherwise the results were a Democratic sweep, resulting in perhaps the most unfavorable state "), _c('a', {
    attrs: {
      "id": "page_110"
    }
  }, [_vm._v("senate the Connecticut League had ever faced. Molly Cunningham acknowledged that any 1945 birth control bill would face “sure defeat,” but an effort nonetheless had to be made. In a situation where there was little if anything to lose, Cunningham immediately undertook a most creative stratagem, politely writing to the Bishop of Hartford, Maurice F. McAuliffe, to ask “if you think any useful purpose would be served” by her and Harriet Janney meeting with him to discuss what sort of bill the league might pursue in the 1945 legislature. Not surprisingly, Bishop McAuliffe wrote back without delay to say that any meeting “would be useless” and “unprofitable,” for “the opposition of the Catholic Church to artificial birth prevention is a matter of fundamental natural moral principle upon which there can be no compromise.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-44",
      "id": "ch02-044-44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cunningham and Janney also lost no time in approaching Ernst and Pilpel to see if a test case could indeed be mounted as an alternative to their hopeless legislative prospects. Ernst immediately sent out a polite but pointed letter of inquiry to Dr. Evarts, asking to meet with her soon: “I am quite persuaded that a properly conducted case could be won in the United States Supreme Court without any hazard to the doctors or patients involved. The great difficulty resides in the lack of courage on the part of the medical profession.” Morris Ernst would never be accused of excess subtlety, nor of lacking in hopefulness; a prominent profile of him earlier that year in "), _c('i', [_vm._v("Life")]), _vm._v(" magazine had highlighted his “quick-smiling charm” and “constitutional optimism”; it had also noted his “constant mouthing of well-known names,” his “overpowering preoccupation with sex,” and his “mild and middle-aged tendency toward bottom pinching.” The Connecticut women were already well acquainted with both aspects of Ernst’s personality, but for them the primary question was finding a willing plaintiff, and Ernst’s upbeat insistence that victory could indeed be won was deeply heartening. Ernst similarly continued to press the Massachusetts League, but by early 1945 no case was developing there, and he likewise had received no response from Dr. Evarts to either his first letter or to a second."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-45",
      "id": "ch02-045-45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In late January Representative Philip Curtis of Norfolk introduced a bill authorizing physicians to prescribe birth control “when necessary to save life or prevent serious injury to health,” and four weeks later PPLC released the results of a statewide survey that pollster Elmo Roper had conducted in December. Seventy percent of respondents answered yes when asked if doctors should be able to supply birth control to all married couples who requested it; 85 percent said yes if the married woman “would probably become an invalid” as a result of "), _c('a', {
    attrs: {
      "id": "page_111"
    }
  }, [_vm._v("another pregnancy. The poll news received disappointingly modest coverage in Connecticut newspapers, and no one suggested that the clear evidence of overwhelming popular support for the Curtis bill would have any effect on the state legislature.")])]), _c('a', {
    attrs: {
      "id": "page_111"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_111"
    }
  }, [_vm._v("On February 23—eleven months after Harriet Janney had first contacted her—Dr. Jo Evarts finally met with the eager Morris Ernst. She suggested he contact a Lakeville attorney whom she knew, G. Campbell Becket, and four days later Becket saw Ernst in New York. Becket in turn visited with the state’s attorney for Litchfield County, J. Howard Roberts of Thomaston, and broached the idea of an adversarial but friendly test case. Roberts said he was not at all eager to defend the Connecticut birth control statute, but nonetheless told Becket that “he would cooperate in every possible way” and that any patients’ names could of course be kept private. Evarts “still seems enthusiastic and ready to go,” Becket reassured Ernst and Pilpel, and Ernst began trying to schedule a personal meeting with Howard Roberts."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-46",
      "id": "ch02-046-46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On May 1 the public hearing on the Curtis bill took place before the joint legislative Committee on Public Health and Safety. The PPLC women played only supporting roles, and the principal affirmative speaker was a Roman Catholic union member and blue-collar worker from Stamford, John J. Hinman, who appeared on behalf of no organized group. He was followed by several ministers who were members of PPLC’s new Clergy Advisory Committee; Reverend C. Lawson Willard of New Haven’s Trinity Episcopal Church told the committee that “If this bill does not pass it will mean that one group in this state which is not the majority of the people,” will be able to “force the rest of us who are not members of that church and who do not accept their practice to conform with a practice in which we do not believe.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The redoubtable Louise Fisher once again appeared as the leadoff opposition speaker on behalf of the Diocese of Hartford. “Contraception and contraceptive devices are against the law of nature and the law of God,” she reiterated, and twenty years of PPLC publicity “has helped to tear down the moral fiber of our young people,” leading to a new wave of “free love and trial marriages.” She was joined by a new opposition representative, Lebanon attorney Thomas J. Dodd, but their remarks were almost unnecessary. Three weeks later the Public Health and Safety Committee killed the Curtis bill without even a recorded vote, and a downcast Molly Cunningham offered a bleak forecast: “It requires more imagination than the average person possesses to become excited about the attainment of a goal as remote as changing the birth control law in Connecticut seems to be at this point.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-47",
      "id": "ch02-047-47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_112"
    }
  }, [_vm._v("Harriet Janney unsurprisingly told those who attended PPLC’s annual meeting that “court action is indicated as the way to accomplish our objectives,” and on June 14 Ernst and Pilpel finally met with State’s Attorney J. Howard Roberts. Prosecutor Roberts was polite but noncommittal as Ernst, Pilpel, and “Cam” Becket discussed a possible case, and promised to think it over and get back to them. Becket subsequently told Ernst “obviously” Roberts “doesn’t relish the extra work” that such a thankless venture would entail, and four months passed without Roberts saying anything more than that he was too busy to offer a conclusive answer.")])]), _c('a', {
    attrs: {
      "id": "page_112"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_112"
    }
  }, [_vm._v("By early fall it looked as if a helpful Bridgeport attorney, Irwin E. Friedman, whom Ernst had happened to meet in a Nantucket restaurant during the summer, might have secured a cooperative prosecutor in the Fairfield County town of Westport, but that possibility then required the recruitment of a willing Westport area doctor in place of Jo Evarts, and Molly Cunningham had no such success. In November Ernst spent several days back in Litchfield County meeting with Becket and Jo Evarts, with Dr. Evarts telling him that she now had found two ideal patients, but in the absence of any firm commitment of cooperation from Howard Roberts the matter remained stationary. Ernst pondered sending Roberts a formal letter, either from himself or Evarts, detailing the patients’ cases and notifying him that the law. was being broken, but 1945 turned into 1946 without any further developments."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-48",
      "id": "ch02-048-48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Molly Cunningham warned her colleagues against “a certain defeatism” that was openly emerging within the Connecticut League, but four months later, with nothing new having transpired, even she was confessing to the board that “the line between realism and defeatism is a rather fine one.” The widespread apathy, she said at PPLC’s annual meeting, no doubt was “due in part to the fact that many doctors continue to give and private patients receive contraceptive service” and the resulting “general impression that everyone has access to birth control information”; hence many people believed that the old 1879 statute had no actual effect on anyone. At that May 1946 annual meeting Harriet Janney stepped down after three years as league president and was succeeded by Barbara Davenport, but less than three months later Davenport resigned because her husband’s business activities required her to be in New York City full time. Two months went by before a successor, Julie Howson, a longtime activist who fifteen years earlier had been a staff member at the American Birth Control League office, was selected and confirmed, and most of 1946 passed without the Connecticut League wrestling with anything more significant than these dual successions of officers."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-49",
      "id": "ch02-049-49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_113"
    }
  }, [_vm._v("In mid-October of 1946 PPLC finalized plans to introduce another doctors’ bill in the upcoming 1947 legislature, and arranged for the measure to be formally sponsored by a committee of one hundred leading Connecticut physicians. When the November elections resulted in a huge Republican sweep, Molly Cunningham rapidly spread the word that “the legislative outlook is the best in a great many years,” as twenty-seven Republicans—and only nine Democrats—would be in the 1947 state senate. Hence the bill would have “more than a good chance of success,” and Cunningham notified Ernst and Pilpel that the still-uncertain test case prospects should be put on hold until after the spring legislative outcome was known."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-50",
      "id": "ch02-050-50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On Friday, February 7, Avon Republican Representative John deK. Alsop introduced House Bill 953, authorizing physicians to prescribe contraceptives if a doctor believed that a pregnancy “would endanger the life or injure the health of a married woman.” Alsop, a thirty-two-year-old Yale graduate who had won a Bronze Star and France’s Croix de Guerre for a high-risk operation behind Nazi lines while serving as a captain in the OSS, was a prominent young star in state politics and was widely viewed as a likely future governor. His sponsorship was a major coup for PPLC, but the bill’s prospects were nowhere near as rosy as Molly Cunningham initially had predicted. The composition of the Public Health and Safety Committee was less than ideal, and, much more importantly, ten of the senate’s twenty-seven Republicans were Roman Catholic, as were seven of the nine Democrats. Alsop warned Cunningham that Republican Party leaders were saying privately that the bill’s chances were “quite doubtful,” and he recommended that the proponents keep a low public profile until the bill had been reported out of committee. The savvy Cunningham took Alsop’s warning to heart, and called on Harry B. Strong, chief of staff to newly elected Republican Governor James L. McConaughy, who had been caught in the crossfire of the Kit Hepburn-Father Kelly birth control exchanges six years earlier when he was president of Wesleyan. Back then McConaughy had said publicly that “I ardently wish that we might have birth control clinics,” but now, Strong told Cunningham, “the Governor will take no sides in the matter.… He will neither interfere nor make any expression on the bill.” Just as Alsop had indicated, evidence was mounting that the Republican leadership, now facing a new political scene in which a good portion of the party’s own supporters and elected officials were Roman Catholics, wanted no part of championing the legalization of birth control, especially if it might prevail and Republicans receive the potentially harmful credit."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-51",
      "id": "ch02-051-51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The tenor of the 1947 legislative battle underwent a sudden and "), _c('a', {
    attrs: {
      "id": "page_114"
    }
  }, [_vm._v("angry shift in early March when the Diocese of Hartford threatened to cancel the Catholic hospital staff privileges of five physicians whose names had appeared in state newspapers as members of the Committee of 100 doctors backing the Alsop bill. Two Bridgeport M.D.s, Elwood K. Jones and Allen F. Delevett, were notified that “it is utterly incompatible for a doctor on St. Vincent’s Hospital Staff … to "), _c('i', [_vm._v("publicly")]), _vm._v(" endorse and "), _c('i', [_vm._v("engage")]), _vm._v(" in the Planned Parenthood Program” and that “either you withdraw your name from the Committee” within one week “or you must resign from the Courtesy Staff.… We feel strongly that right is right and there can be no other alternative.” Similar notices were sent to three Waterbury doctors regarding their staff privileges at St. Mary’s Hospital.")])]), _c('a', {
    attrs: {
      "id": "page_114"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_114"
    }
  }, [_vm._v("The March 11 legislative hearing on the Alsop bill took place just several days after those letters were circulated, and two of the Waterbury doctors, Joseph L. Hetzel and Arthur H. Jackson, were among more than a dozen Connecticut physicians who joined other sponsors to speak in support of the measure. Alsop himself tried to sound optimistic about his bill’s chances, and sought to rebut newspaper reports that it had little likelihood of passage, but even the optimistic Molly Cunningham showed a private tally of sixteen firm no’s, only thirteen yes’s, and seven uncommitteds. Opponents from previous years such as Louise Fisher and Thomas Dodd were joined by a new representative of the Hartford Diocese, former state Senator Joseph P. Cooney, but the extensive press coverage of the hearing focused almost exclusively on news of the imminent dismissals facing Hetzel, Jackson, and their equally unrepentant colleagues."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-52",
      "id": "ch02-052-52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Alsop bill remained quietly in committee for the balance of the month, but the diocesan threats against the doctors helped mobilize new support for the legalization of birth control. The "), _c('i', [_vm._v("Hartford Courant")]), _vm._v(" editorialized that the only real issue was “the right of physicians to put science at the service of their patients,” but that endorsement provoked Hartford’s vociferous Father Andrew J. Kelly to insist that “human legislators have no jurisdiction to change divine laws.” The “suicidal individualists” who were the “proponents of birth prevention are not out to change a particular statute,” Kelly warned. “They would change, and by change I mean liquidate, the eternal moral code which makes man, in all his human acts, responsible to his Divine Creator.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In late March the five targeted doctors wrote to Hartford Bishop Henry J. O’Brien firmly requesting reinstatement of their staff privileges at St. Vincent’s and St. Mary’s, but on April 2 Father Lawrence E. Skelly, the diocesan director of hospitals, notified them that the church "), _c('a', {
    attrs: {
      "id": "page_115"
    }
  }, [_vm._v("would not reconsider: “The action taken by the Hospital has nothing to do with your right to your opinion or belief in any matter professional or otherwise.” If the diocese did not terminate their privileges, Skelly said, “your public action might give the impression that the Hospital endorses your views on this question.… The Hospital had no choice save to take action which would as directly, as distinctly and as publicly disassociate itself from your stand.” The doctors responded with a public letter sent to each member of the Connecticut legislature, emphasizing how the diocesan retaliation for their taking a public stand on an issue pending before the General Assembly represented “a serious threat against the right of physicians to free speech on medical subjects.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-53",
      "id": "ch02-053-53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Several town and county medical societies released formal statements condemning the dismissals, and a veteran Republican legislator from Bridgeport called for terminating state grants to the offending hospitals until the doctors were reinstated. A representative of the Waterbury Ministerial Association met privately and unsuccessfully with the diocesan chancellor to urge reconsideration, and the American Civil Liberties Union contacted the doctors seeking a full report on what had transpired. Then, on April 24, the Public Health and Safety Committee approved the Alsop bill by a vote of thirteen to six, and public attention shifted back to the legislative scene. Reporters were saying that confirmed senate opponents numbered at least twenty-two, while sympathetic legislators indicated it was only nineteen, and PPLC activists focused upon a series of evanescent rumors that one or another declared opponent was privately having second thoughts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Late in April the Connecticut State Medical Society’s House of Delegates voted overwhelmingly to endorse the Alsop bill, and on May 7 the house passed the measure by a wide margin in a standing rather than recorded vote. But the outlook for the senate vote, scheduled on May 14, remained either bleak or hopeless. The "), _c('i', [_vm._v("Courant")]), _vm._v(" weighed in with another powerful editorial, declaring that “this is a vote on the legal rights of responsible physicians, and nothing else,” but when senate Republicans caucused privately on the Alsop bill later that same day, the internal tally showed twelve no’s, eleven yes’s, and four uncommitted or absent. The two most committed senate backers of the bill, Herbert S. MacDonald and Charles S. House, had planned to push for a roll-call vote on the floor if the private Republican tally looked more promising, knowing that several wavering members would more likely vote in the affirmative if their position was to be formally recorded, but the caucus result precluded that effort. The following day, May 14, "), _c('a', {
    attrs: {
      "id": "page_116"
    }
  }, [_vm._v("when the bill was called up on the senate floor, the outcome was preordained, and the roll was not called. Reporters watching the voice vote on which the bill was defeated guessed that the margin was 23 to 12, with all nine Democrats being joined by fourteen Republicans, but Senator MacDonald later remembered hearing “19 audible ‘Nos’ … 14 vociferous ‘Yeas’, and three carefully disguised mumbles.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-54",
      "id": "ch02-054-54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The legislative defeat was yet another dispiriting experience for PPLC. The "), _c('i', [_vm._v("Courant")]), _vm._v(" noted that the absence of a recorded senate vote “reflects little credit” on the legislature, and rued that P. T. Barnum’s “hypocritical anachronism” would continue to remain a valid state law. “One of these days Connecticut will yet emerge into the twentieth century.” The more conservative "), _c('i', [_vm._v("Hartford Times")]), _vm._v(", however, rebuked its morning rival by editorializing that “it is idle for proponents of the legislation to insist that only a medical or health question is involved and not a religious or moral one, as long as a great religious organization holds to the contrary and its members”—or at least those holding legislative office—“are loyal to it.” Dr. Hetzel of Waterbury hoped the ACLU would consider possible legal action against the Catholic hospitals for dismissing the doctors in retaliation for exercising their right of free speech, and when four doctors in Massachusetts—where birth control proponents were just beginning to work toward another referendum vote in 1948—were similarly terminated in late May, Hetzel suggested joint action and pointed out that the retaliatory actions had widened the birth control effort into a wider civil liberties struggle. Molly Cunningham made much the same point at PPLC’s annual meeting, reminding her colleagues that “our particular fight is merely part of a larger and broader battle,” but in Waterbury Dr. Charles L. Larkin, the senior medical staff member at St. Mary’s—and the same man who had played such a shy and curious role in the 1939 Chase Dispensary situation—publicly rebuked Hetzel for pursuing the matter. There was no doubt, Larkin said, that Hetzel and his colleagues had been “working against one of the basic beliefs of the Catholic Church.” There was likewise no doubt that the diocesan authorities had “a right to make such a ruling,” and “There is no reason why we cannot go along just as we have in the past.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-55",
      "id": "ch02-055-55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The ACLU offered the doctors its formal support, but by mid-June most of Hetzel’s colleagues had decided not to initiate a law suit. Both Hetzel and one other physician, Oliver L. Stringfield, pondered the question for several more months before likewise deciding no, and PPLC as well again turned its attention toward possible court case challenges to the Connecticut law. Nothing new emerged there, "), _c('a', {
    attrs: {
      "id": "page_117"
    }
  }, [_vm._v("however, and the league began to consider involving itself in the 1948 state legislative elections on a specific senate district by senate district basis. By mid-October seven senate districts whose incumbents had not supported the Alsop bill, and which were susceptible to an electoral switch, had been identified, and PPLC started targeting those specific seats for intensive efforts in advance of the 1948 elections. By early 1948 actual organizing work was underway in four of those seven districts, and in April a half-time field worker, Nancy Doggett Williams, was hired to concentrate upon those areas. “Armed with a Vassar Alumnae address book and her own ingenuous personality,” PPLC president Julie Howson told league officers, “she is able to find committee chairmen in the most hopeless districts.” Also that spring, Boston Archbishop Richard J. Cushing delivered a major antibirth control speech in Hartford, declaring that “contraception is anti-social and anti-patriotic as well as absolutely immoral,” but otherwise the first six months of 1948 were relatively quiet. John Alsop advised Molly Cunningham that a PPLC defeat of even a single opposing senator could very well trigger enough reaction to insure 1949 passage of a birth control bill so long as Republicans did relatively well in the 1948 elections, and hopes for actually winning such a long-awaited triumph gradually increased."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-56",
      "id": "ch02-056-56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By July 1948 PPLC was concentrating its efforts upon two districts whose Republican incumbents had opposed the Alsop bill: Stanley Stroffolino in South Norwalk and Darien, and Alice V. Rowland in Ridgefield and Danbury. An attempt to block Stroffolino’s renomination as a Republican had failed, and a similar effort against Rowland was torpedoed when the families of the two principal PPLC volunteers were explicitly threatened with economic retaliation or worse if they did not desist. The leading volunteer had brushed off a visit by three unknown men who had “told her that she would be wise to stop her political efforts and hinted that there were many ways” in which she or her family might be penalized, but one week later the woman, “obviously on the verge of tears,” phoned Molly Cunningham: “My husband and I thought that we were unreachable, but we find we are not. We have just had a letter from a lawyer that is upsetting to us both. I am not at liberty to tell you any more about” it, the woman said, other than that it involved a local Danbury police court. PPLC then turned its efforts toward supporting Rowland’s Democratic—and probirth control—opponent, Minna Geddes, but on the Sunday before the November election a statement was read from the pulpits of each and every Catholic church in the district, informing parishioners that the "), _c('a', {
    attrs: {
      "id": "page_118"
    }
  }, [_vm._v("Republican candidate, rather than Geddes, had to be backed: “support of any candidate advocating birth control measures is a violation of the natural law of God which the Catholic church and Catholics are duty bound to uphold, and for any person to support such a program is a violation of the Sixth Commandment of Almighty God.” As Father John J. Kennedy of Danbury’s St. Peter’s Roman Catholic Church told reporters, “this is not a political issue, but one of a question of natural moral law,” and “no Catholic person in conscience can support any candidate favoring such legislation.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-57",
      "id": "ch02-057-57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Alice Rowland and Stanley Stroffolino both won reelection, and elsewhere other results were even worse: Democratic victories across much of Connecticut insured a total of at least twenty-one birth control opponents in the state senate, and in Massachusetts the referendum vote to legalize medically necessary birth control went down to defeat by a large margin—57 to 43 percent—that was almost as wide as the 1942 loss. Boston Archbishop Richard J. Cushing and the Boston Archdiocese had mounted a major campaign against the measure, utilizing weekly pulpit announcements and extensive radio ads that employed an updated slogan hearkening back to 1942: “Birth control is "), _c('i', [_vm._v("still")]), _vm._v(" against God’s law.” The church effort had been much more intense and outspoken than six years before; several months prior to the vote Boston College Law School Dean William J. Kenealy had told a legislative audience that use of birth control transformed marital sex into “mutual masturbation” and “a gross abuse of a God-given faculty” that hence amounted to nothing more than “pleasure by means of an unnatural act.” Any form of contraception, Kenealy had insisted, was “intrinsically evil and is therefore never justified”; the “only moral remedy is either periodic or total abstinence.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-58",
      "id": "ch02-058-58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the aftermath of both the Massachusetts and Connecticut setbacks, Molly Cunningham and her PPLC colleagues resolved to go through the motions of supporting a 1949 version of the Alsop bill even though there admittedly was no chance of success. Casting about for other options, PPLC thought again of initiating some kind of test case; as Cunningham told Harriet Pilpel, “I am becoming obsessed slowly but surely with a desire to somehow get off the dead center in which we find ourselves.” Cunningham’s deputy Nancy Williams wrote to her old friend Dorothy Bowles, whose husband Chester had won the Connecticut governorship in the Democratic sweep, but Mrs. Bowles responded brusquely that “I am afraid I cannot discuss with you the subject most on your mind. The Planned Parenthood Program is unquestionably a religious issue and for that reason I really cannot "), _c('a', {
    attrs: {
      "id": "page_119"
    }
  }, [_vm._v("discuss your problem.” Just as with previous, supposedly progressive governors such as Republican Ray Baldwin and Democrat James McConaughy, so too with liberal Democrat Chester Bowles would the legalization of birth control remain an untouchable issue."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-59",
      "id": "ch02-059-59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In early February a 1949 edition of the doctors’ bill was introduced in the legislature by Bozrah Republican Representative Lawrence M. Gilman. New PPLC president Katharine B. McKinney attempted to recruit Margaret Sanger to come to the state and speak at PPLC’s annual meeting, confessing that “We are at a low ebb in our efforts to get the law changed here and we badly need the inspiration.” The effort went awry, however, when McKinney was told that “Mrs. Sanger was willing to speak … provided that [PPLC] was willing to adopt a militant policy against the Roman Catholic Church. It was decided,” the board concluded, “that the League could not adopt such a policy at this time and therefore would withdraw the invitation to Mrs. Sanger to speak.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The legislative hearing on the Gilman bill took place on April 12 and was largely a rerun of previous years’ proceedings. Gilman himself announced that he would willingly amend the measure so as to authorize the medical prescription of birth control only in life-threatening situations, but less apologetic proponents included a representative from the Connecticut Conference of Congregational Churches and the president of the Connecticut State Medical Society. Other doctors who spoke for the bill included Hilda Standish and Josephine Evarts; the opponents also featured several physicians plus diocesan representatives Louise Fisher and Joseph P. Cooney, as well as a Meriden state senator who had introduced a bill prohibiting legislative consideration of any birth control proposals for the next four years. A representative from Ansonia tellingly declared that “A bill of this nature is an insult to the Catholic people in our great state,” and Ridgefield Senator Alice Rowland inquired as to why the proponents did not favor a statewide referendum vote, as in Massachusetts, even though Connecticut law did not provide for such an option."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-60",
      "id": "ch02-060-60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Three weeks after the hearing the Public Health and Safety Committee approved the Gilman bill on a secret ballot vote of twelve to five, but with observers reporting a minimum of twenty-six senators in firm opposition, the measure was not brought to the floor of either the house or the senate. Molly Cunningham immediately told her colleagues that “It is not at all too soon to be thinking about the nominations and elections” of 1950, but nothing of any political significance occurred during the balance of 1949. PPLC president Katharine "), _c('a', {
    attrs: {
      "id": "page_120"
    }
  }, [_vm._v("McKinney passed away unexpectedly in September after a sudden illness, and was replaced by her predecessor, Julie Howson, at much the same time that the leaders of the Massachusetts League were told by their lawyers that any test case should be brought not there but in Connecticut. Molly Cunningham continued to look for just such an opportunity throughout the fall and then into the early months of 1950, but nothing whatsoever materialized. In mid-February the sixty-two-year-old Cunningham informed the board that she wanted to step down as executive director as of the end of May, and the board easily and immediately agreed that Nancy Doggett Williams should step up to be Cunningham’s successor."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-61",
      "id": "ch02-061-61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On May 18 Molly Cunningham delivered her sixth and final annual report as PPLC’s executive director. She emphasized that “one of my greatest disappointments is that no suitable court case has been found,” and reminded the board that “the fundamental issue of our fight to change the Connecticut birth control law is that of civil liberties.” She had to concede that the outlook was not bright; doctors’ enthusiasm for actively supporting reform seemed to be waning, and two Yale Law School students who had undertaken an exhaustive survey of the league’s strategic options had come up with little to recommend. A new president, Mary Parker Milmine, would be succeeding Julie Howson, and Cunningham herself was not exactly retiring; that fall she would win election to the state house as a Republican representative from New Canaan.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Other than Cunningham’s victory, PPLC activists found relatively little to celebrate in the November 1950 election results. Chester Bowles was turned out of office by Republican John Davis Lodge, but the Democrats retained a nineteen to seventeen majority in the state senate. Back in 1948 a few Republicans privately had mused as to whether the birth control issue was partially to blame for Bowles’ victory, in that the Catholic church’s electoral activism in selected legislative races might well have increased turnout among top-of-the-ticket Democratic voters, and now the same theory was bandied about once again to explain the narrow loss of Republican U.S. Senate nominee Prescott Bush to Democrat William Benton—even though Lodge at the same time had topped Bowles by some seventeen thousand votes."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-62",
      "id": "ch02-062-62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Given the dim legislative outlook, new PPLC president Molly Milmine, a Bryn Mawr graduate whose husband was assistant headmaster of an exclusive prep school, pressed for continued consideration of test case ideas as well as preparations for a 1951 doctors’ bill. The initial legislative plan was to have four identical bills introduced—one "), _c('a', {
    attrs: {
      "id": "page_121"
    }
  }, [_vm._v("each by Republican and Democratic members of both the house and the senate, but only three materialized, as not a single senate Democrat was willing to publicly support the legalization of contraception. In part the problem was that party leadership control of the legislature, and particularly the senate, had grown tighter and tighter in the five years since Hartford political boss John M. Bailey had become Democratic state chairman, with real authority being exercised by Bailey rather than by the elected legislators; in part the problem more specifically was the result of Bailey’s extremely close, life-long friendship with former Hartford state Senator Joseph P. Cooney, who had been hired as principal legislative counsel and lobbyist by the Hartford Diocese several months after Bailey had become head of the state Democratic party.")])]), _c('a', {
    attrs: {
      "id": "page_121"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_121"
    }
  }, [_vm._v("Bailey was forty-seven, a graduate of Catholic University and Harvard Law School; Cooney was forty-four, a graduate of Georgetown University and Georgetown Law School, and in 1929 the two had begun a law practice together. In early 1933, during the second of four terms in the state senate, Joe Cooney had successfully sponsored Bailey for Bailey’s first public post, a two-year appointment to a Hartford Police Court judgeship. The two had remained close ever since, and once Bailey became Democratic party chairman in 1946, the centralization of political power in Connecticut quickly returned to a level that had not been seen since the heyday of Republican J. Henry Roraback two decades earlier. By the time that the 1951 legislature convened, Bailey’s power reached even well beyond the unusual authority of selecting Democratic floor leaders and committee chairmen; in the senate he employed the private caucus of the Democratic majority as a vehicle for all but totally eliminating public roll call votes from the senate’s procedures. During the entire 1951 session only "), _c('i', [_vm._v("eight")]), _vm._v(" roll-call votes took place in the senate, and on "), _c('i', [_vm._v("none")]), _vm._v(" of them did even a single Democratic senator vote against the Bailey leadership’s position."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-63",
      "id": "ch02-063-63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("PPLC’s three identical doctors’ bills were introduced in the house and senate on January 30, but league officials had no serious hopes of success. Prior to the April 11 hearing the issue received almost no public attention, but officials of the Hartford Diocese convened two private meetings, one in New Haven and one in Hartford on the day of the hearing, to be certain that opponents would be appropriately represented and otherwise well-prepared. Diocesan chancellor Monsignor John J. Hayes chaired both sessions and was responsible for overall strategy, Joseph Cooney later indicated, while Cooney himself was in charge of organizing the appropriate speakers for the hearing. “The "), _c('a', {
    attrs: {
      "id": "page_122"
    }
  }, [_vm._v("purely political aspects of the matter,” Cooney explained, “were taken care of by Monsignor Hayes,” who “directly approached the senators.” Hayes also “arranged to have letters sent to Senators and Representatives by constituents,” and also “arranged for women to sit in the galleries at the hearing and to voice their opposition.”")])]), _c('a', {
    attrs: {
      "id": "page_122"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_122"
    }
  }, [_vm._v("The official diocesan representatives, including Cooney and Louise Fisher, played a smaller role at the actual hearing than did a number of outspoken legislative opponents of birth control. Bridgeport Representative Wilton Reinhardt insisted that “I think these bills can well be a step toward legalizing abortion,” but overall, as the "), _c('i', [_vm._v("Hartford Times")]), _vm._v(" observed, “much of the bitterness evidenced at previous hearings was lacking” at the 1951 one. The two principal affirmative speakers were New Haven’s Reverend C. Lawson Willard and West Hartford urologist Dr. Robert H. Hepburn, whose mother—and PPLC’s landmark activist—had passed away less than a month earlier. Willard afterward thanked the committee and formally reminded them that the bills were designed “entirely to protect the health and lives of mothers,” rather than to facilitate “the limitation of the number of children,” but the proponents full well realized that no birth control bill, under whatever rationale, would ever be passed by John Bailey’s state senate."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-64",
      "id": "ch02-064-64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The prominence of the Bailey-Cooney alliance influenced a number of onlookers, including PPLC president Molly Milmine and executive director Nancy Williams, to adopt a harsher, Sanger-like attitude toward the Catholic hierarchy than previously had characterized the Connecticut reformers. One New Haven protestant minister, new to the state, told Milmine after watching the opponents’ performance at the hearing that “When you witness the bigotry and the blindness of the Totalitarianism of the Roman Catholic Church in this country, you can see that we have a real problem on our hands here.” Milmine replied that he was quite right: “I entirely agree with you that we are fighting here something which is potentially as dangerous as Totalitarianism, and am tempted sometimes to rush the League into this more important and imminent fight.” By mid-May, with the birth control bills still in committee, Nancy Williams underscored “the growing problem of Catholic domination in government” to PPLC’s board. “The undeniable control by the Roman Catholic church of the Democratic party” had forged “the chains which bind the state Senate”; it also raised, in Milmine’s words, the larger issue of “the danger the church is to the freedom of the individual.” And, as Williams trenchantly explained, it was all on account of “a law which the Catholics themselves do not respect and which stays on the books for one reason only. It is a symbol of Catholic power.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-65",
      "id": "ch02-065-65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_123"
    }
  }, [_vm._v("By the third week of May the Public Health and Safety Committee had voted eleven to four in favor of a birth control bill, but only after herculean efforts by Cornwall Representative Frank E. Calhoun did the measure actually make it to the house floor. On May 28 it passed on a vote of 121 to 62, with only three Democrats in favor, and ninety-two members not voting. Senate Public Health and Safety chairman Frank J. Monchun refused to bring the measure to the senate floor, however, despite a PPLC letter-writing campaign and distribution of leaflets in his Windsor district. The flyers attacked the 1879 law as “an infringement of personal liberty” and explained how PPLC’s doctors’ bill would protect “this ‘freedom of choice’ which is our birthright.” Molly Milmine attempted to arrange a face-to-face meeting with John M. Bailey, “but each and every attempt to approach him proved futile.” As close observer and former state Senator Herbert S. MacDonald commented on the unbreakable 1951 senate logjam, “All too obvious was the force of the State Democratic Chairman whose allegiance to the Catholic Church was all that was needed!”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-66",
      "id": "ch02-066-66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the wake of yet one more legislative defeat, the PPLC leadership once again turned its focus toward potential court cases. At least one board member suggested they consider opening clinics in several cities “to test the actual enforcement of the present law,” but Milmine continued to ponder some of the complicated declaratory judgment possibilities that had been suggested by the two Yale Law School students a year earlier. More experienced legal advisors judged those options too difficult to succeed, and spoke more positively of an actual clinic venture, but when Nancy Williams solicited Wiggin and Dana’s opinion, Fritz Wiggin offered a distinctly chilly evaluation. There was no reason to believe that the Connecticut Supreme Court would decide differently on the basic question than it had back in "), _c('i', [_vm._v("Tileston")]), _vm._v(", Wiggin declared. While there was “a reasonable possibility” that the United States Supreme Court might void the statute on Fourteenth Amendment due process liberty grounds if a criminal conviction under it was placed before them, any Connecticut prosecutor faced with a clinic opening might well proceed simply under the state’s all-purpose conspiracy statute rather than get tied up in trying to win convictions under the use and aiding-and-abetting provisions. Faced with Wiggin’s pessimistic perspective, Milmine, at the urging of Hartford insurance lawyer Buist Anderson, turned instead to a new and much younger possible lawyer, Hartford tax specialist John H. Riege, and in October PPLC formally asked Riege to survey test case prospects and report back by mid-December."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-67",
      "id": "ch02-067-67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In early November Riege met privately with retired Connecticut "), _c('a', {
    attrs: {
      "id": "page_124"
    }
  }, [_vm._v("Chief Justice William M. Maltbie “and had a very interesting and helpful discussion with him for an hour or so concerning some of our problems,” Riege told Milmine. Then in December Riege briefed the PPLC board on their potential legal options, explaining that the best possibility appeared to be a suit by a doctor and several patients requesting a declaratory judgment and an injunction against the 1879 statute from a "), _c('i', [_vm._v("federal")]), _vm._v(" district court. “The probability of obtaining a favorable decision in the [federal] District Court is greater than in the Connecticut Supreme Court,” Riege explained. Additionally, any case involving an actual criminal prosecution of a doctor and/or patient would run the risk of significant punishment if the Connecticut courts, as expected, continued to follow "), _c('i', [_vm._v("Nelson")]), _vm._v(" and "), _c('i', [_vm._v("Tileston")]), _vm._v(", and if the U.S. Supreme Court—as was “perhaps even probable,” Riege warned—declined review pursuant to "), _c('i', [_vm._v("Gardner")]), _vm._v(". Accepting Riege’s projection that the chances of success were “reasonably good” in a federal declaratory action, the PPLC board authorized him and Milmine to proceed with further work toward creating such a case."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-68",
      "id": "ch02-068-68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("During the early months of 1952 PPLC attempted to settle on a more experienced federal appellate litigator who could handle a case in conjunction with Riege. Some members objected to selecting Morris Ernst, and the Connecticut lawyers turned toward two other New York possibilities, Whitney North Seymour, of Simpson, Thacher and Bartlett, and John M. Harlan, a partner of the husband of one of PPLC’s board members, Laura Bushby. Talk of PPLC’s plans spread, and Riege scheduled a mid-March meeting with Seymour. Then, early in March, Milmine, Nancy Williams, and Laura Bushby all received telephone calls from the campaign manager for 1952 Republican Senate contender Prescott Bush. The manager “asked that the Planned Parenthood court case be postponed for the sake of Mr. Bush’s campaign,” but Molly Milmine “had replied that in her opinion postponement would be impossible.” When this news was shared with the board’s executive committee, former president Julie Howson “suggested that information about the nature of the case might reassure Mr. Bush, and it was agreed that this information [would] be given through Mr. Wilkie Bushby,” the board member’s husband. Riege’s meeting with Whitney Seymour and his son Whitney, Jr., as well as PPFA attorney Fifield Workum, another Simpson, Thacher partner, took place as scheduled on March 20, and by early May preparatory work was underway, with a clear understanding that nothing would be ready for actual filing in advance of the November 1952 elections."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-69",
      "id": "ch02-069-69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("PPLC’s annual meeting agreed to shift the state office from "), _c('a', {
    attrs: {
      "id": "page_125"
    }
  }, [_vm._v("Hartford to New Haven. Office manager Mabel Robbins, who had been with the league for over sixteen years, going back to the early days of the original Hartford clinic, would be retiring at the end of June, and by late May PPLC had arranged to rent space at 38 Trumbull Street, in a largely residential block of lovely nineteenth-century town houses, just down the street from where Nowell Creadick had housed the league’s office in the 1930s at 79 Trumbull. In late August, with nothing further having occurred concerning the possible court case, Seymour, Jr., alerted Riege that he and his father were coming to think that the procedural hurdles involved in any federal suit were considerable, and that even if those were overcome, the likelihood of success on the merits was “no better than fifty-fifty.” He recommended that PPLC focus instead on legislative reform possibilities, but Riege reminded him in reply that “there is practically no chance of obtaining relief from the Connecticut Legislature” and that odds of fifty-fifty in a court case were much better prospects than anything else available. To Milmine, Riege put their choice somewhat more bluntly: “we do not see how the political situation could deteriorate much further.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-70",
      "id": "ch02-070-70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In mid-October Milmine and Riege went to New York for a major meeting with both Seymours. Seymour, Sr., now estimated their chances at 45 percent and recommended that PPLC wait until the conclusion of the spring 1953 legislative session; he also suggested that they probably should file an action in state rather than federal court. Three weeks later PPLC’s strategic options shifted dramatically when the fall election results showed a Republican sweep and an apparent count of seventeen or perhaps eighteen firm supporters of birth control legalization in the thirty-six member state senate. In mid-November the board agreed to concentrate upon a legislative campaign, and Milmine advised Riege to focus on who ideally could litigate a state court test case come mid-1953 should that indeed prove necessary. By mid-January Riege had recommended and Milmine had interviewed a young partner at the Hartford law firm of Robinson, Robinson, and Cole, Bruce W. Manternach, and a legal fallback seemed ready should the legislative route fail once again."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-71",
      "id": "ch02-071-71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On February 3 the 1953 version of PPLC’s doctors’ bill was introduced by Fairfield Representative Norman K. Parsells. Within several weeks, however, indications of its likely prospects turned starkly negative with word that Republican Party leaders were fearful of future electoral fallout should the bill indeed pass and then be signed into law by Republican Governor John Davis Lodge. Moving swiftly to try to sidestep any Republican leadership decision to simply keep the bill in "), _c('a', {
    attrs: {
      "id": "page_126"
    }
  }, [_vm._v("committee, PPLC leaders requested a personal meeting with Governor Lodge."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-72",
      "id": "ch02-072-72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On Thursday, March 12, Nancy Williams and PPLC legislative committee chairman Jane Daniells met with Lodge and his chief of staff, former state Senator Charles S. House. Apparently the session was an unmitigated disaster, with the prickly Lodge believing that the PPLC duo had obtained the appointment under “false pretenses.” Within several days, as PPLC supporters from around the state wrote to Lodge urging him to back the Parsells bill, the governor apparently concluded that Williams and Daniells erroneously had passed the word that Lodge was opposed to passage. “I did not express an opinion on [the] legislation & I did not say I wanted to kill it,” an angry Lodge jotted to himself. Lodge evidently had intimated to his visitors that perhaps the legislature might pass a bill providing for a popular referendum on birth control legalization, with the unspoken suggestion being that he and the Republican leadership would approve only this, as no referendum outcome could be blamed on the governor or his party. Republican National Committee member Meade Alcorn then sent Lodge a brief memo John Riege had prepared at Alcorn’s suggestion, arguing that if a bill was not passed in 1953, the issue would only loom larger in future elections, and another PPLC supporter, Fairfield County attorney Leonard D. Adkins, began peppering the governor with feisty letters challenging him to start enforcing the 1879 statute if he did not believe it should be altered. The often-indecisive Lodge replied only that “I have expressed no opinion” on the Parsells bill."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-73",
      "id": "ch02-073-73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The 1953 hearing on the birth control measure was held on April 1, and it was a relatively brief and understated affair. Joe Cooney once again led the way for the diocesan opposition, and he quickly took the opportunity to throw down the political gauntlet of a popular vote resolution of the issue in the face of the bill’s proponents: “It is our contention that the opponents of this bill are not a minority, and that any time the legislature wants to place the matter on a referendum, it will prove conclusively that our viewpoint is upheld by the majority of Connecticut citizens.” Four days later Cooney repeated his suggestion, recommending that a birth control referendum be held in conjunction with any regularly scheduled state election, and Connecticut’s newspapers gave wide voice to his challenge."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-74",
      "id": "ch02-074-74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("PPLC lost little time in objecting to the referendum idea, arguing that it would be unconstitutional, very costly, and likely would incite religious strife. The Public Health and Safety Committee on April 7 "), _c('a', {
    attrs: {
      "id": "page_127"
    }
  }, [_vm._v("voted 12 to 9 against a referendum proposal, in spite of reports that Governor Lodge and Republican leaders strongly backed the idea. Committee reconsideration was scheduled for April 15, and a number of advisors and supportive legislators advised PPLC to accept a referendum measure, whether or not it would prove constitutional. Senate committee chairman Benton H. Grant of Stamford privately advised Molly Milmine that “a bill with referendum may be able to pass the Senate,” where as one without such a requirement stood “no chance whatsoever,” but on April 14 the PPLC board voted unanimously to oppose any referendum proposal and to seek legal action to block it should it emerge from the legislature."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-75",
      "id": "ch02-075-75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On April 15 the Public Health and Safety Committee adopted a referendum amendment by 10 to 8 and then approved the amended bill by 11 to 8. The following day, amid rumors that the Roman Catholic hierarchy, despite Cooney’s public pose, actually "), _c('i', [_vm._v("opposed")]), _vm._v(" any birth control referendum, diocesan Chancellor Hayes met privately with Governor Lodge in Stamford. Hayes reminded the governor how strongly the church supported the 1879 statute, evidently stressing how “the use of the sex function solely for pleasure … is an unnatural practice.” Of course, Hayes noted, “we are not trying to impose our religious views on others,” but “we feel that the moral principles which are the foundation of this law are unchangeable.” Much more pointedly, the chancellor also told Lodge that “passage of the bill would be indelibly associated with your party administration and your leadership,” and warned that any referendum would only stimulate interfaith bitterness. “We would, of course, win overwhelmingly as they realize, but at the risk of much unpleasantness.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-76",
      "id": "ch02-076-76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Senate chairman Grant, who had emerged as a reluctant champion of the referendum measure, tried to persuade Molly Milmine that PPLC should change its mind and accept a popular vote, but on April 23, to Milmine’s tremendous relief, Legislative Commissioner Elmer S. Ryan formally ruled that any referendum bill would be unconstitutional. That resolved PPLC’s most immediate worry, but it also all but guaranteed that no other version of a birth control bill would emerge from the 1953 Connecticut legislature. Senator Grant explained to one constituent that given the number of districts that encompassed urban, Catholic voters, the religious composition of the state senate, irrespective of party, was unlikely to change anytime soon. Hence the prospects for any legislative legalization of birth control were unlikely to get any better even in future legislatures: “I do not expect the existing statute to be altered in any way within a generation.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_128"
    }
  }, [_vm._v("Molly Milmine and other onlookers reluctantly acknowledged that Senator Grant was undeniably correct. Milmine already had put Bruce Manternach in touch with a Sharon physician, Dr. Robert L. Fisher, who had suggested he might act as a test case plaintiff along with a patient or two, and now Warren Upson added his voice, telling Milmine he was “enthusiastically in favor” of court action. “I believe that the existing law is unconstitutional” and would be so declared if and when the question came before the United States Supreme Court on the merits."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-77",
      "id": "ch02-077-77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("PPLC nonetheless did not want to give up the 1953 legislative fight without at least some further struggle, but on May 5 the Public Health and Safety Committee tabled the birth control bill by a vote of 11 to 8. The birth control story remained in the news, however, when Yale Law School professor Vern Countryman—Justice Douglas’s clerk on "), _c('i', [_vm._v("Tileston")]), _vm._v("—took United Press International correspondent David Robinson on a Saturday afternoon visit to a Liggett Drug Store in Hamden, where for three dollars Countryman easily purchased a box of Ramses condoms. “From the drug store,” Countryman later recounted, “Robinson and I went to the Hamden Police Station where I approached the lieutenant on duty at the desk, showed him my purchase, and said I wished to file criminal charges against the drug store. The lieutenant’s response was that the articles I had purchased were legal.” Countryman unsuccessfully tried to persuade first the lieutenant, and then a Hamden police detective, otherwise, but was told to see the local prosecutor, who was away from home. Early Monday morning Countryman and Robinson called on the prosecutor, who “was not enthusiastic” and, per "), _c('i', [_vm._v("Corbett")]), _vm._v(", noted the difference between prophylactic and contraceptive uses. Countryman reiterated his desire to file charges, but then the prosecutor mentioned that the Liggett’s was a locally owned franchise, not a corporate property. For Countryman, who purposely had chosen a chain store, that was a fatal flaw, for he had not wanted to target some unfortunate individual druggist. Countryman dropped his request, and his venture immediately faded from Connecticut’s front pages."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-78",
      "id": "ch02-078-78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The day after Countryman’s saga concluded, Cornwall Representative Frank Calhoun, the 1951 birth control sponsor, and New Canaan Representative Molly Cunningham, PPLC’s former executive director, began circulating a discharge petition to bring the 1953 bill to the house floor with or without a Public Health and Safety Committee report. Within four days they had more than the 140 necessary signatures, and the bill was placed on the house calendar. "), _c('a', {
    attrs: {
      "id": "page_129"
    }
  }, [_vm._v("Leonard Adkins and several other PPLC supporters in the Norwalk area attempted a different version of the Countryman ploy by mailing condoms to the Fairfield County state’s attorney and to Governor Lodge, but they attracted only news coverage, not indictments. The prosecutor contented himself with saying that yes, mailing the rubbers "), _c('i', [_vm._v("was")]), _vm._v(" a violation of the law; the governor continued to decline comment, but even four decades later many small foil packages of desiccated, 1953-vintage condoms could still be found safely stapled to the incoming letters in Lodge’s official papers in the Connecticut State Archives."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-79",
      "id": "ch02-079-79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On May 27, following a ninety-minute debate, the house passed PPLC’s doctors’ bill on a vote of 147 to 75, with only four Democrats among the yeas. Almost a dozen opponents warned against “the subjugation of man to passion and artificial sensuousness” or the danger of “race suicide”; one Wallingford representative recommended that “if our women would only get out their knitting bags and knit a few booties for the future generations, I think they would be well satisfied and happy, instead of self-centered.” The following day a somewhat different bill was brought to the senate floor, but only after a private Republican caucus had agreed that the measure would be killed on an unrecorded voice vote. Only two senators spoke publicly on behalf of it; afterward one of them, Public Health and Safety Committee chairman Ben Grant, bluntly told his constituents that the bill had failed on account of one single organization: “I do not know of one non-Catholic opposed to the bill.” The thirty-year battle over birth control, he said, showed Connecticut’s democratic institutions to be feeble and dishonorable: “The issue hangs like a ghost over the Legislature. It causes more double talk, insincerity, cringing and juggling than all other issues put together.… Representative government is revealed at its frightened worst.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-80",
      "id": "ch02-080-80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Molly Milmine reacted to the legislative denouement by trying to pump renewed effort into PPLC’s search for a test case and willing plaintiffs. Only in the state’s more rural counties were court dockets free from serious backlogs that would delay action on a case for many months after it was filed, and by early August Milmine believed she had found an appropriate and eager female patient, someone to combine with Dr. Fisher, through a recommendation from Jo Evarts. Bruce Manternach, however, the Hartford attorney who earlier had been retained to handle a case, now had a full fall schedule, and by early October he was telling Milmine that it would be December or January before he would have any time for PPLC’s potential endeavor."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-81",
      "id": "ch02-081-81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("PPLC since 1946 had been providing a very modest subsidy for a "), _c('a', {
    attrs: {
      "id": "page_130"
    }
  }, [_vm._v("Yale infertility clinic that was directed by Dr. Herbert Thoms, the chairman of the medical school’s obstetrics and gynecology department, and by late in the summer of 1953 PPLC had agreed to lend similar financial assistance to a marriage consultation service, based in the department of psychiatry, so that a part-time psychiatric social worker, Miriam Cohen Harper, could be added to the staff. Then, late in August 1953, Nancy Doggett Williams told Molly Milmine that she would be tendering her resignation as executive director, effective September 30, in order to take another job that was closer to her home. On top of that, PPLC fund-raising was running twelve thousand dollars behind the projected annual budget, and Williams’s one assistant, Jennie Heiser, who was primarily responsible for fund solicitations, had indicated that she would be leaving sometime within the next four to eight months.")])]), _c('a', {
    attrs: {
      "id": "page_130"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_130"
    }
  }, [_vm._v("No real efforts to locate or identify a replacement for Williams took place during September or October, and budget worries were somewhat alleviated by the absence of having to pay a director’s salary. Milmine continued to try to stimulate development of a test case, and a board subcommittee discussed future legislative options, but as of early November some board members wondered whether hiring a new director should be further postponed so that expenses could be minimized. One officer recommended that Milmine contact Helen Buxton, the wife of the newly named Yale ob/gyn department chairman and infertility clinic director, who was succeeding the retiring Dr. Thoms, as one of a number of potential new donors, and by the end of November the sense of imminent financial crisis had passed, even if the director’s job remained vacant."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-82",
      "id": "ch02-082-82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then one day Jennie Heiser was saying hello to the woman whose home was next door to the office, at 40 Trumbull, a woman in her fifties whom both Heiser and Molly Milmine knew as the executive secretary of the New Haven Human Relations Council. The neighbor understood that Nancy Williams had not yet been replaced, and Heiser, referring to their delayed search for a successor, half-seriously asked, “How would you like to be director of Planned Parenthood?” The neighbor answered “Phooey,” but Heiser mentioned the idea, and the conversation, to Molly Milmine, who agreed that it was worth following up. So the subsequent day or soon thereafter, Molly Milmine went next door to talk with Estelle Trebert Griswold about the possibility of becoming the new executive director of Connecticut Planned Parenthood."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes1#ch02-83",
      "id": "ch02-083-83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")])])])])])
}]}

/***/ }),
/* 76 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(77),
  /* template */
  __webpack_require__(78),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chapter',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-title"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "page_131"
    }
  }, [_vm._v("CHAPTER THREE")])])]), _c('a', {
    attrs: {
      "id": "page_131"
    }
  }, [_c('p', {
    staticClass: "chap-title-1"
  }, [_c('span', [_vm._v("One Vote Shy: Estelle Griswold, Fowler Harper, and the U.S. Supreme Court, 1954–1961")])]), _vm._v(" "), _c('p', {
    staticClass: "normal"
  }, [_vm._v("Estelle Trebert Griswold had mixed feelings about Molly Milmine’s suggestion that she consider becoming executive director of Connecticut Planned Parenthood. On one hand, as she later explained, “I needed a job very desperately,” for while being executive secretary of the New Haven Human Relations Council might seem professionally significant to Milmine and others, it was no longer a paying position; there simply was no money. On the other—well, Estelle Griswold did not feel she should explain that to Molly Milmine either.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Birth control was something Stelle Griswold of course had heard about; she and her husband, Dick, both Connecticut natives, had moved back to the state three years earlier. But birth control was not something Stelle Griswold knew very much about; in fact, as she explained it later, at the time of her first conversation with Molly Milmine, Stelle Griswold had never seen a diaphragm, did not know what one was, and was not sure what the word really meant.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_131"
    }
  }, [_vm._v("Having been born Roman Catholic, in Hartford, in June 1900, was not the reason. Although her father, Frank, a toolmaker, was not especially religious, her mother, Jennie Church Trebert, was Catholic, and even decades later Stelle would acknowledge that “I’m still considered a Catholic on the rolls.” Stelle had thought her parents had “a very strange marriage,” for her father was “a very volatile person” while her mother was “very placid.” There had been two older sons, only one of whom, Raymond, was still living when Stelle was born, and church-going never played a significant role in Stelle’s youth. She attended the Hartford public schools, skipping both the fourth and seventh grades, and then ")]), _c('a', {
    attrs: {
      "id": "page_132"
    }
  }, [_vm._v("Hartford High School, where she later said she was “kind of a tom boy” who had been suspended more than once for playing hookey and recruiting boys to do the same. Many of Stelle’s acquaintances, like her friend Hilda Crosby, who also graduated in 1920, came from somewhat better-off families, and most of them, unlike Stelle, went on to college. “I was very upset,” she recalled years later, “when they all went to college and there was no money nor interest on the part of my parents.”")])]), _c('a', {
    attrs: {
      "id": "page_132"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Stelle wanted to be a singer. “She had a beautiful contralto voice,” Hilda Crosby Standish later remembered, and for three years Stelle attended Hartford’s Hartt School of Music, rooming there and working in a bank to support herself More than once, she later said, she went for medical checkups to Dr. Thomas N. Hepburn, who lived near Stelle’s grandmother and whose wife was the well-known suffragist. Then, in 1922, without ever previously having left greater Hartford, she defied her family’s wishes and simply moved to Paris. Stelle got an office job as a bookkeeper, started singing at the American Cathedral, and quickly learned colloquial French. “I can swear in French with the best taxi driver there is,” she later boasted. She caught tuberculosis, spent some time in Nice, became engaged to a playwright, and ended up back in another office job in Paris.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then word reached Stelle that her mother was extremely ill, and reluctantly she returned to Hartford. She took a job in a bank, and first her father, and then her mother, passed away. Stelle went to New York to audition for singing jobs, was sent to Chicago for a position there, traveled from city to city singing with a show group for six months, and then ended up back in Hartford, working as a secretary to a gentleman who was the Belgian consul for New England. In Hartford she remet Richard Whitmore Griswold, two years her senior, whom she had known at Hartford High School before he had gone off to Yale and to brief service in World War I. Dick Griswold had had a series of advertising jobs in New York and New England, and had unsuccessfully tried to start an agency of his own in Hartford. By the fall of 1927 Stelle and Dick had decided to marry, and Dick took a salaried job with the Guardian Life Insurance Company in New York. They were married on October 20 at the Cathedral of St. John the Divine, with Hilda Crosby and other Hartford friends in attendance, and Stelle lined up various radio singing jobs while Dick commuted into the city from their home in Mount Vernon. She and her singing tutor took a long trip to France, but an illness of Dick’s forced Stelle to return home prematurely.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_132"
    }
  }, [_vm._v("Early in 1935 Guardian Life transferred Dick Griswold from New ")]), _c('a', {
    attrs: {
      "id": "page_133"
    }
  }, [_vm._v("York to Washington. Stelle’s singing tutor died, and Stelle gave up her idea of a career in music. After an illness of her own, Stelle ended up working as an office volunteer for her own doctor, and started taking courses at George Washington University toward a certificate as a medical technologist. That developed into a full-time job at GWU, and when Dick was called to active duty in Washington in Naval Intelligence in the fall of 1941, Stelle continued to work as a lab instructor at George Washington.")])]), _c('a', {
    attrs: {
      "id": "page_133"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Immediately upon the fall of Berlin in 1945, Dick Griswold was dispatched there to take charge of “investigative teams” under the rubric of the U.S. State Department’s Office of Political Affairs. Stelle went first to London, and then in late 1945 obtained a refugee resettlement job in Holland with the United Nations Relief and Rehabilitation Agency. Some months later Stelle was shifted to Frankfurt, then to Munich, and then Bremen, while Dick eventually was moved to Bremerhaven. By 1947 Stelle’s resettlement work was under the aegis of the American Christian Committee for Refugees, which in early 1948 was absorbed by Church World Service (CWS), a part of the World Council of Churches. Much of Stelle’s work involved helping people from eastern Europe relocate to South America, and Stelle herself endured a memorable but unpleasant month-long crossing of the Atlantic to Argentina on an overcrowded ship.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_133"
    }
  }, [_vm._v("In December 1950 Estelle returned to the United States, working for CWS in New York and commuting on weekends up to Connecticut, where Dick already had bought a house near New London. In mid-1951, tired of both the CWS bureaucracy and the long weekly commute, Estelle took the job with the New Haven Human Relations Council, Dick shifted his advertising work to New Haven, and they purchased the attractive town house at 40 Trumbull Street. Two years later, at Thanksgiving 1953, with the Human Relations Council out of money, Dick and Stelle were still there, and were eager to remain."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-1",
      "id": "ch03-01-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "normal2"
  }, [_vm._v("Molly Milmine was extremely impressed by her first long conversation with Estelle Griswold. “Her qualifications are perfect,” Milmine told Molly Cunningham, and other PPLC officers agreed “that there is no point to look further.” Stelle had led Milmine to believe that she “had two other offers which may get her away from us,” but Milmine hoped to convene the PPLC board by early the next week so that a formal job offer could be authorized.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As Estelle Griswold pondered whether to accept the forthcoming "), _c('a', {
    attrs: {
      "id": "page_134"
    }
  }, [_vm._v("offer, she thought of one old friend, someone she had not seen in some years, who certainly could offer some knowledgeable advice—Hilda Crosby Standish. Stelle knew that Hilda once had been very active in the Connecticut League; indeed, perhaps the last time Stelle actually had seen Hilda was sometime in the late 1930s, when Hilda had told Stelle about how much she enjoyed being medical director of the Hartford clinic. “I met her on a train one day,” Stelle recalled, “and she told me what she was doing. I wasn’t interested. It just left me cold. I wanted children and hadn’t been able to have them.”")])]), _c('a', {
    attrs: {
      "id": "page_134"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Stelle in 1953 was not going to raise that with Hilda, or with Milmine, but she did want to hear Hilda’s views on PPLC, and so after an initial phone call, Stelle drove up to Hartford to visit her old high school classmate. Hilda Standish had been busy raising her own family, and she thought Connecticut Planned Parenthood in 1953 was but a dim shadow of what the league had been fifteen years earlier in the era of Kit Hepburn and Sallie Pease. “It’s practically dead,” she told Stelle after retracing some of the earlier history. “If you really want to work your head off and get it above ground and going again, there’s no better place to work,” but the odds on making it a success were very long indeed. But Estelle, Hilda Standish later remembered in describing that conversation, was someone “for whom that was a real challenge.” “She was that type of person; that was just the thing that set her off.” “I thought if anybody could do it, Stelle could,” because “she always had her own ideas,” and “she got things done … like Mrs. Hepburn.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_134"
    }
  }, [_vm._v("Within two or three days of her visit to Hilda Standish, Estelle Griswold received Molly Milmine’s letter formally stating that the PPLC board on December 8 had voted unanimously to offer her the position of executive director, starting January 1, at an annual salary of five thousand forty dollars. The board, Milmine said, had been extremely impressed by her “phenomenally interesting experience.” Stelle, particularly affected by what was undeniably “a very good salary” offer, paused only two days before accepting. “I didn’t know a thing about it,” she later remembered, but it was too good, too convenient, and too challenging to imagine turning down. She was “honored and pleased” and “happy to accept,” Estelle wrote Milmine. “Under your leadership and guidance I hope to make a real contribution.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-2",
      "id": "ch03-02-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Being such a close and immediate neighbor offered Estelle Griswold an easy excuse for beginning to familiarize herself with PPLC’s office and programs even before she officially went on the payroll. A mid-January board meeting at which Estelle would formally be introduced was snowed out, but Molly Milmine brought her quickly up to speed "), _c('a', {
    attrs: {
      "id": "page_135"
    }
  }, [_vm._v("about the present status of the long-delayed possibility that Bruce Manternach would file a court suit on behalf of the northwestern Connecticut woman who had been recommended by Jo Evarts. The patient remained ready and willing, but wanted assurance, simply in light of her husband’s employment at a prep school with a potentially troublesome headmaster, that a case could be filed and taken forward without her actual name having to appear in any of the public papers. Milmine was hopeful, but Manternach immediately replied that that would not be possible: “she will have to be a plaintiff and her name will have to be used in the title of the action.” When Milmine passed along that unhappy news, the result was just what she had expected. “Our Kent witness has folded up,” Milmine told Manternach—“fear for her husband’s position and the reaction of his chief.” “I find it discouraging to have to wait so long to find someone, but I can easily sympathize with them for not longing for the inevitable publicity.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-3",
      "id": "ch03-03-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By early February Estelle Griswold was getting fully acclimated. On February 4 she and Jennie Heiser attended a Yale School of Public Health seminar on planned parenthood that featured a Yale gynecologist, Dr. Luther Musselman, and an outspoken professor from the Yale Law School, Fowler V. Harper, whose wife Miriam held the social work position at Yale’s marriage consultation service that was subsidized by PPLC. Finances were a serious concern, Estelle told the board members when she finally met them on February 9, for in January the organization had spent nineteen hundred dollars while taking in only three hundred dollars. She already was attending meetings of local PPLC supporters in Norwalk, New Canaan, Darien, and Hartford, and in early March Estelle told the board that those visits, along with a thorough review of PPLC’s files and an introductory visit to PPFA in New York, had convinced her that much more outreach was needed. PPLC’s program, she stressed, “must stem from locals, not be superimposed” from above. The organization “must reach and represent not only a small intellectual group”—namely the upper-middle class people who were so well-represented on PPLC’s board—“but become a mass movement.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-4",
      "id": "ch03-04-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Molly Milmine continued to hope that they could find a willing and appropriate plaintiff for a test case, but the spring months passed without progress. The new director of the Yale infertility clinic that PPLC had long subsidized, Dr. C. Lee Buxton, introduced himself and inquired about increased funding, but a commitment already had been made to try to channel additional dollars into the marriage consultation service. PPLC’s annual meeting, on May 18, agreed that a 1955 "), _c('a', {
    attrs: {
      "id": "page_136"
    }
  }, [_vm._v("legislative effort no doubt would be mounted, and Estelle Griswold, in her most extensive remarks so far, reminded everyone that the planned parenthood movement, both in Connecticut and nationally, would have to enlarge and expand if it was to succeed. “For thirty-seven years the upper upper and upper middle classes have been our support, but it is only the mass of people that can swing the vote.” Additionally, PPLC’s need for ethnic and economic diversity was also clear. The departing Jennie Heiser’s financial job would be filled part time by a young black woman, Frances McCoy, whom Estelle had just recruited, but more was needed, as everyone who had seen that morning’s headlines—on the momentous U.S. Supreme Court school desegregation decision in "), _c('i', [_vm._v("Brown")]), _vm._v(" v. "), _c('i', [_vm._v("Board of Education")]), _vm._v("—ought to realize. “We must show active interest in better housing, employment, good schools, and minority rights as related to our problem,” Estelle insisted. Molly Milmine, in her own remarks, went more than slightly out of her way to underline what an energizing and transformative effect Estelle Griswold already was having on Connecticut Planned Parenthood:")])]), _c('a', {
    attrs: {
      "id": "page_136"
    }
  }), _c('p', {
    staticClass: "blq-indent"
  }, [_c('a', {
    attrs: {
      "id": "page_136"
    }
  }, [_vm._v("She has brought us new interests, new connections, and a new eye to our problems. She, in the five months she has been with us, has already brought us new ideas, new thinking, and new friends and affiliations. She admits to no experience with legislative or political activities, but at the rate she has caught up with us already, I see no reason why she cannot do almost anything. We are very fortunate to have been able to gain her interest and her wide experience."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-5",
      "id": "ch03-05-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" "), _c('p', {
    staticClass: "indent1"
  }, [_vm._v("The summer of 1954 witnessed a minor stir over a new requirement adopted by Connecticut’s Commissioner of Food and Drugs, who had regulatory authority over pharmacists, that druggists should dispense diaphragms to women only upon presentation of a written prescription from an M.D. Some private doctors were reluctant to put their names on such written documents, and some druggists were perturbed that certain private physicians were simply purchasing and then supplying diaphragms themselves, thus leaving pharmacists out of the business. After much private uncertainty, the matter was resolved in September when the commissioner privately circulated a letter stating that “there is no reason why vaginal diaphragms may not be prescribed or ordered by a physician and such order filled by a pharmacist.… Such order may be given orally or in writing.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-6",
      "id": "ch03-06-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Even by mid-1954 Estelle Griswold believed that it would be some time before PPLC would be organizationally strong enough to win the legalization battle that still lay ahead. “We have a long way to go,” she "), _c('a', {
    attrs: {
      "id": "page_137"
    }
  }, [_vm._v("lectured the board in one report, “before we make a real impact on the public.” “It is somewhat discouraging at times,” she allowed to one PPFA staffer, “but I am convinced that with a little patience, hard work,” and “good counsel,” that matters would soon improve. “If we keep in mind the work,” she told one discouraged PPLC supporter, “that gave us our Constitution, the Emancipation Proclamation, the U.N., votes for women and many other privileges that we accept for granted today, we should continue to work for our cause. We may not have ‘success in our time,’ but we may help to achieve it for future generations.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-7",
      "id": "ch03-07-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By the fall of 1954, with the 1955 legislative session on the horizon, PPLC’s financial picture had modestly improved. Fran McCoy moved from part-time to full-time work, and when Dr. Buxton met with the board to ask for an additional three or four thousand dollars for the infertility clinic in 1955, the request was eventually approved. Two new part-time employees, secretary Anita Beloff and publicity director Ellen Switzer, also joined the staff, and an increased number of public meetings—including one in New Haven featuring Reverend C. Lawson Willard and law professor Fowler V. Harper—began to be held across the state. The November election results were unsatisfying, with a Democratic majority of twenty state senators in the offing, but Molly Milmine continued to hope that they might yet discover some qualified female patient who would be a willing test case plaintiff."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-8",
      "id": "ch03-08-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In late January both a doctors’ bill and a repeal measure were introduced in the 1955 Connecticut legislature at PPLC’s behest. Press observers forecast “certain defeat” for both proposals even well in advance of the April 20 hearing, at which Reverend Willard and Dr. Hilda Crosby Standish led the proponents, with another M.D. reading a statement on behalf of a busy Dr. C. Lee Buxton. The opponents were managed once again by diocesan spokesman Joseph P. Cooney, who included a personal attack on Hilda Standish in his remarks, alleging that she was “well known” as an advisory board member of the Euthanasia Society. Several opposing legislators offered defenses of “the laws of God,” and one opposing doctor warned that PPLC “is a small, local part of a large, well-financed international movement” that was not further identified, but by previous years’ standards, the 1955 hearing was relatively tame."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-9",
      "id": "ch03-09-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On May 3 the Public Health and Safety Committee on voice votes overwhelmingly approved both the repeal measure and the doctors’ bill. Two weeks later both bills came to the house floor, with opponents monopolizing much of the debate. One Bridgeport "), _c('a', {
    attrs: {
      "id": "page_138"
    }
  }, [_vm._v("representative alleged that the repeal measure could “be interpreted as legalizing abortion,” and a Plainfield member complained that the trouble with the bill’s proponents is that “they want to play, but they don’t want to pay,” but both the doctors’ bill, by a margin of 150 to 91, and the repeal measure, by a vote of 132 to 91, passed easily. On May 23, however, the senate rejected both bills on voice votes with hardly any debate, and the 1955 legislative effort to legalize birth control came to a quick and quiet end."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-10",
      "id": "ch03-010-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After the 1955 session, PPLC realized more clearly than ever before that there simply would never be a way to get any birth control bill through the state senate in the absence of a decisive Republican majority. Democratic Party chairman John Bailey, PPLC’s officers told the PPLC annual meeting, “has become so powerful that the Bishop no longer needs to watch over the Senate on this bill.” The party chairman, although of course not a member of the senate, attended each day’s private caucus of Democratic senators, and as one freshman Democrat later explained, Bailey’s “ability to help or restrain the ambition of the aspiring politician plays no insignificant role” in ensuring that not a single Democratic senator would step out of line on any bill about which Bailey had a decided preference.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Estelle Griswold appreciated the partisan dynamics, and was trying to channel more and more PPLC effort into building groups of local supporters all across the state, especially in the eastern half of Connecticut, where PPLC never had had any significant presence. Estelle herself had attended and spoken at approximately seventy local PPLC meetings of one sort of another in just her first five months on the job, and now, with Molly Milmine stepping down as president after six years, Estelle hoped to begin drawing a new wave of volunteers into the organization. The new president, Claudia McGinley of New Canaan, fully agreed, and later explained that it was largely because of Estelle Griswold’s vitality and dynamism that she had agreed to accept the presidency. One of McGinley’s first new moves was to persuade Dr. Lee Buxton to become chairman of a revived medical advisory committee, and Buxton did so only after endorsing Estelle Griswold’s view that wider political organizing, rather than professional lobbying, would be the only way to prevail: “if the people of the State through their Legislature, do not want to pass the legislation which the League advocates, the medical profession as such is not the organization to try to put it across.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-11",
      "id": "ch03-011-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By early June Estelle for the first time was turning her own attention toward test case possibilities, and a review of all the prior years’ "), _c('a', {
    attrs: {
      "id": "page_139"
    }
  }, [_vm._v("unproductive correspondence convinced her that the league’s remaining relationship with both John Riege and Bruce Manternach, if any, needed immediate review. Estelle went to New York for an introductory chat with Harriet Pilpel and a similar discussion with Patrick Malin, the executive director of the American Civil Liberties Union (ACLU). Estelle concluded that a functioning legal advisory committee had to be revived, and by early September both she and Claudia McGinley began meeting with Yale Law School professors Fowler Harper and Ralph S. Brown. A fund-raising shortfall led to the termination of PPLC’s support for Miriam Harper’s marriage counseling position, but Estelle and McGinley started thinking about a brand-new initiative, namely open and publicly advertised PPLC referrals for poorer women desiring diaphragm fittings to the birth control clinic that Planned Parenthood of Eastern Westchester operated in Port Chester, New York, just across the Connecticut state line from Greenwich. The Port Chester clinic already quietly offered reduced-rate services to Connecticut residents, and in early November Griswold and McGinley held their first meeting with the Port Chester directors to discuss an open and official referral program."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-12",
      "id": "ch03-012-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On December 1 PPLC sponsored a public forum at Yale Medical School that featured both Fowler Harper and Lee Buxton, and by Christmastime Griswold and McGinley’s referral plan had received official approval from PPFA in New York. In mid-January Estelle distributed a proposal recommending formal adoption of a public referral service, and noting that if any Connecticut authorities sought to challenge the policy, PPLC in conjunction with its Yale advisors and the ACLU would be able to defend the program on First Amendment freedom of speech grounds. An office would be opened in Norwalk to coordinate appointments and transportation to the Port Chester clinic; an additional benefit of such a public outreach effort might be the identification of an ideal patient for a test case. “Our first aim,” Estelle wrote, “is to help women, for health or economic reasons, to regulate the size of their families.” PPFA, highly impressed with the “high powered, efficient dynamo” now directing the Connecticut League, agreed to contribute three thousand dollars, or about half the first year cost of the program; PPLC would raise the rest.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On January 24 the PPLC board, with two Port Chester representatives in attendance, formally approved the referral operation. By mid-February PPFA had secured initial funds from an “anonymous” donor—actually St. Louis vaginal foam manufacturer Joseph Sunnen—and PPLC was beginning to train volunteers for handling the actual "), _c('a', {
    attrs: {
      "id": "page_140"
    }
  }, [_vm._v("referrals. Many of the lawyers were somewhat dubious that a First Amendment claim would be a decisive defense if the referral service did draw prosecutorial attention under the 1879 statute and the auxiliary aiding and abetting provision, but all agreed that any such interference was relatively unlikely."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-13",
      "id": "ch03-013-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In mid-March the upcoming opening of the referral service was announced to the Connecticut press, with significant stories running in seemingly every newspaper in the state. Most quoted Claudia McGinley as emphasizing that “we feel that it is our right under the First Amendment to the U.S. Constitution to give information about such centers in other states to husbands and wives who seek it.” The standard dispatch also added that “Planned Parenthood believes that all married couples have a democratic right to this knowledge,” and on April 10 the first formal referrals from the Norwalk office were transported to the Port Chester clinic."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-14",
      "id": "ch03-014-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Estelle Griswold and her colleagues were deeply pleased with the success of the referral project. No legal complaints or challenges were voiced, and for the first time since Estelle’s arrival more than two years earlier, PPLC finally had a tangible program. More importantly, as the minutes of May’s annual meeting noted, the referral program also represented “the first actual service rendered by PPLC for fifteen years.” Estelle explained her desire to eventually expand the referrals to other Planned Parenthood clinics in Mt. Kisco, New York, and Providence, Rhode Island, but PPLC as yet had neither the personnel nor the funds for that scale of activity. Everyone also hoped that a test case patient might somehow appear, but no wide-ranging search for one was underway. “We are fortunate in having as a director a person of imagination, experience, and organizational ability,” Beatrice Hessel, who headed one board committee, told the meeting, but “we have a small, much too small, nucleus of "), _c('i', [_vm._v("working")]), _vm._v(" volunteers.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-15",
      "id": "ch03-015-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The financial burden of the referral project led PPLC to notify Lee Buxton that its support for the infertility clinic would have to end at the close of the year, and throughout the summer and into the fall Estelle continued to hope for a test case. PPFA and its “anonymous” donor, Joseph Sunnen, were somewhat unhappy that the referral project, although quite successful, was not generating any national publicity or press attention, and both Griswold and McGinley had to invest unnecessary time in persuading PPFA to actually hand over the promised funds. As the fall elections approached, Molly Milmine in particular kept a close eye on the nominations and contests for different state senate seats, but when the November results and Dwight D. "), _c('a', {
    attrs: {
      "id": "page_141"
    }
  }, [_vm._v("Eisenhower’s coattails registered an unprecedented Republican sweep—thirty-one Republicans and only five Democrats in the state senate—PPLC’s legislative hopes immediately soared higher than ever before."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-16",
      "id": "ch03-016-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("PPLC quickly decided to go with a doctors’ bill rather than a repeal measure in the 1957 legislature, and by early December it was well appreciated that the thirty-one senate Republicans might not be quite as promising a group as some first thought, for some thirteen of them—along with the five Democrats—were Roman Catholics, a potentially lethal opposing bloc. As of late January, when Kent Representative Francis C. Cady formally introduced House Bill 572, Molly Milmine believed PPLC had sixteen firm senate supporters and a good shot at winning either support or convenient absences from up to five more. “This session is our big chance for success,” she told Griswold and the board, and “the hearing will be as medical as we can make it.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-17",
      "id": "ch03-017-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lee Buxton willingly acceded to Milmine’s request that he prepare to play a leading role in the mid-March hearing. Reviewing the transcript of the 1955 one, he told Milmine, left him both “amused” and “disturbed” at the misleading nature of the opposing physicians’ claims. “I do think that the simple presentation of two or three cases which have had tragic sequelae here” at Yale’s ob/ gyn ward at the Grace–New Haven Hospital within recent weeks “might make a fairly dramatic impression” on legislators: a twenty-eight-year-old woman, “Irene W.,” who had died three days earlier from severe rheumatic heart disease that had been exacerbated by her six-month pregnancy; a twenty-three-year-old woman with very high blood pressure and in her fourth month of pregnancy, “Ruth O.,” whom Buxton feared might very well die because of a severe cerebral hemorrhage. Milmine encouraged him in his preparations, and by late February she had also arranged for Sharon’s Dr. Robert Fisher—PPLC’s willing prospective plaintiff of several years earlier—to likewise be a featured witness. A week later Milmine gave the board’s executive committee her most optimistic report yet, saying “we now have eighteen senators who are with us,” although “some more firmly than others,” in addition to two others who “will not vote at all.” Other observers estimated the dependable total at only fifteen, but Milmine mused about whether Democratic Governor Abraham Ribicoff—who had voted against birth control legalization as a house member—would sign this bill should it reach his desk. Experienced advisors stressed that PPLC’s low profile was all to the good, especially in light of a major sectarian battle that was brewing over Archbishop Henry J. O’Brien—and Joseph Cooney’s—"), _c('a', {
    attrs: {
      "id": "page_142"
    }
  }, [_vm._v("decision that Catholic forces would go all-out to win legislative approval for a bill that would authorize publicly funded school bus transportation for nonpublic—i.e., parochial—school students."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-18",
      "id": "ch03-018-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At the March 21 hearing, Buxton, in countering some of the opponents’ 1955 remarks, emphasized that birth control and abortion—“killing another individual by therapeutic abortion”—were highly dissimilar. The latter involved “the killing of an unborn child” whereas birth control “is as different from abortion as day is from night.” Buxton, Fisher and a third colleague were followed by Joseph Cooney and several opposing physicians. One of them sought to persuade the committee that any use of birth control was harmful both to a woman and to any children she might have. “Sexuality … must be fully satisfied in order to maintain emotional health and equilibrium,” Dr. Salvatore Carraba of Hartford asserted. “Many women using contraceptive devices are frigid, and present a variety of ailments which are really a manifestation of their lack of sexual gratification.” Carraba was not asked what experiences his opinions were based upon, nor was he questioned about his second major claim: “Psychiatrists have noted that the problem child’s behavior can be traced to the emotionally unstable and sexually frustrated mother using birth control measures.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-19",
      "id": "ch03-019-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A dismayed Lee Buxton criticized such “irresponsible medical comments” privately to Estelle Griswold, and in early April the Public Health and Safety Committee approved the bill on a vote of 15 to 6. Press observers reported, in distinct contrast to Molly Milmine’s earlier optimism, that there were some twenty-two firm no votes in the senate, but on April 17 the house passed the bill by the impressive margin of 170 to 58. One week later, however, a private senate caucus in advance of the public floor vote resulted in a tally of fourteen yeas, twenty nays, and two abstentions. Hence the principal proponent, Wethersfield Republican Elmer S. Watson, agreed to simply a voice vote on the floor, and the bill was quickly defeated in what the "), _c('i', [_vm._v("Hartford Courant")]), _vm._v(" estimated was “about ten seconds.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-20",
      "id": "ch03-020-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Estelle and her colleagues were disappointed but not surprised at the legislative denouement. The referral service was an ongoing success, and Stelle told PPLC’s annual meeting in late May that “Our program is growing but our organization and fund-raising are still weak.” PPLC’s number one priority, she said, was to “Raise more money!”; privately her hopes of generating one or two test cases, right there in New Haven, were distinctly higher than ever before. Claudia McGinley privately praised her as “a dynamo of energy,” and sometime "), _c('a', {
    attrs: {
      "id": "page_143"
    }
  }, [_vm._v("in early June, after more than one attempt, Estelle finally succeeded in arranging a private conversation with New Haven County State’s Attorney Ab Ullman, still in office more than fourteen years after his victory in "), _c('i', [_vm._v("Tileston")]), _vm._v(". Ullman conceded that PPLC had no chance of modifying the anticontraception statute in the legislature, but he apparently was noncommittal as to whether he would at all welcome another situation that would place him in the position of having to defend a statute that he personally disliked."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-21",
      "id": "ch03-021-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The summer and fall of 1957 were seemingly quiet for PPLC. In late June the office moved five doors up Trumbull Street, to number 48, where they could enjoy substantially more space than had been available at number 38. Stelle’s salary was increased to six thousand dollars, and in October she attended an International Planned Parenthood conference in Berlin, where for the first time she met the ageing Margaret Sanger. But much more importantly, by sometime early in January 1958 her hope of actually filing a test case was beginning to approach fruition as Lee Buxton resolved that he and—presumably—several of his patients would go to court in the case that everyone had discussed—but no one had ever filed—in the fourteen years since the Supreme Court’s rejection of "), _c('i', [_vm._v("Tileston")]), _vm._v(" v. "), _c('i', [_vm._v("Ullman")]), _vm._v("."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-22",
      "id": "ch03-022-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])])]), _vm._v(" "), _c('p', {
    staticClass: "normal2"
  }, [_vm._v("Charles Lee Buxton had been chairman of Yale’s ob/gyn department, and responsible for its services at Grace–New Haven Hospital, for almost four years at the time that he agreed to be the lead plaintiff whom PPLC had been seeking for so many years. Fifty-three years old, he had grown up in St. Paul, Minnesota, where his father operated a lumber business. While attending a New Jersey prep school he had suffered a football injury that required multiple operations on his spine, and eighteen months recuperation, but he had gone on to graduate from Princeton and then earned his M.D. degree at Columbia in 1932. After internships and residencies, he joined Columbia’s medical faculty in 1938, specializing in research into cures for female infertility. World War II drew Buxton into the Navy for three years, but afterward he returned to Columbia and by 1951 he was a full professor with a lucrative private practice. But his uppermost professional goal was to have a departmental chairmanship, and when Yale, in 1953, offered him just that, he eagerly accepted, even at the cost—a very substantial cost—of giving up his private practice in return for extensive and unremunerative administrative duties. His four children—ages six to eleven—were all in school, and his wife Helen, a native of Massachusetts, was more than a little ambivalent about the move from "), _c('a', {
    attrs: {
      "id": "page_144"
    }
  }, [_vm._v("cosmopolitan New York to modest New Haven, and about the challenges that their dramatically reduced income would pose for family finances. But for Lee Buxton the chairmanship was more than worth it, and he had plunged eagerly into all its duties—“he was really married to the job,” Helen recalled almost forty years later. The PPLC-supported infertility clinic was one of those responsibilities, and when the request had come to testify at the March 1957 legislative hearing, Lee Buxton had willingly accepted."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-23",
      "id": "ch03-023-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The death of Irene W., and the serious illness of Ruth O.—the two serious pregnancy-related cases from early 1957—had each influenced Buxton’s legislative testimony about how the 1879 statute hindered women’s health care, but after the hearing, as he later recalled, “I sort of gave up the idea for a while.” But the problems did not go away. There was apparently another pregnancy-related fatality, and Ruth “Oldendorf”’s"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-24",
      "id": "ch03-024-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" pregnancy and extremely high blood pressure, while not fatal, nonetheless had had tragic results: she had suffered a serious stroke, and in June 1957 had miscarried a stillborn, seven-month fetus. The aftermath of the stroke had left her with impaired speech, only partial use of her right leg, little if any use of her right arm, and only modest hopes for future improvement. It had been a devastating experience for both Ruth and her husband, and another pregnancy would undeniably prove fatal. Additionally, just a few weeks after his legislative testimony, another patient, Anne K., who because of a blood disorder already had endured three unsuccessful pregnancies, suffered yet another full-term miscarriage. Both she and her husband, Hector, had felt traumatized by the repeated experience, and increasingly despaired about their hope of having children.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lee Buxton saw a good deal of both Ruth and Bob Oldendorf, and Anne and Hector Kinloch, during those months, and their difficulties were much on his mind. Then early in the fall another case presented itself. Elizabeth “Odegard”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-25",
      "id": "ch03-025-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" had arrived at Grace–New Haven Hospital just a few weeks earlier, with an incurably ill infant. Her two previous babies had already died in very early infancy—at nine and six days, respectively—within the previous three years, also because of unidentified congenital effects, and on October 17, at age ten weeks, this little boy too passed away. For the Odegards, as for the Oldendorfs and the Kinlochs, these tragic results of unsuccessful pregnancies threatened to be truly overwhelming.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The simultaneous presence of these cases, where three women all faced serious pregnancy-related threats to their physical and emotional health, raised the question of the anticontraception statute in Lee "), _c('a', {
    attrs: {
      "id": "page_145"
    }
  }, [_vm._v("Buxton’s mind once again. “So one day at a party,” he later remembered, “I talked with Fowler Harper,” whom he knew from their previous mutual panel appearances. Buxton told Harper about his patients and their medical needs for birth control, “and he thought maybe we could make a case for the law’s being unconstitutional—infringing on my rights as a doctor and the patient’s right to be treated—if I got together the evidence.” Buxton agreed to do so, and he did not delay."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-26",
      "id": "ch03-026-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Buxton apparently approached Anne and Hector Kinloch first. Hector, a graduate of Cambridge University in England and a U.S. Army veteran, was working on his Ph.D. in Yale’s history department and serving as director of the university’s International House, where they lived. Anne, a native of Rhode Island, was working as secretary to Yale’s Episcopal chaplain. They had been married two years, and had experienced an unsuccessful pregnancy in 1956 as well as the late miscarriage in the spring of 1957. Anne had had two earlier unsuccessful pregnancies in a previous marriage, and Lee Buxton had held out some hope that they might be able to circumvent the RH-negative incompatibility that underlay the repeated miscarriages. “It was a very difficult, indeed tragic” situation, Hector recalled thirty-five years later, a “searing” experience. They had both seen Lee Buxton “many times” in the course of 1957, and had been his patients for quite a while before he first broached the question of being anonymous fellow plaintiffs in a test case against the Connecticut statute. They readily agreed."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-27",
      "id": "ch03-027-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Buxton knew Ruth and Bob “Oldendorf” best. Bob and Ruth were both New Haven natives, and had married shortly before Bob went off to military service in Korea in 1954. Upon his return he took a job with a dairy company, and then in the spring of 1957 came Ruth’s pregnancy and stroke. They too, like Anne and Hector, had seen Buxton many times in the course of the year, and Buxton raised the topic of an anonymous court case with them somewhat tentatively at first, explaining that while he already had other participants, Ruth’s situation would make her a highly appropriate plaintiff—“he said he needed somebody to be ‘Jane Doe,’” Bob Oldendorf recalled years later. Buxton explained the statute to them, and how most Connecticut residents, and doctors, circumvented it in a quiet or “underhanded” manner. Beyond authorizing pseudonymous use of their names, Buxton said, “‘You won’t have to do anything,’” and “‘you’ll probably never get involved in it.’” Ruth was not in good health, and Bob was preoccupied with her prospects for recovery. But Lee Buxton had gone out of his way to do all that he could for Ruth, and while Bob at the time “didn’t really fully understand” what Buxton’s request entailed, he also did not doubt that "), _c('a', {
    attrs: {
      "id": "page_146"
    }
  }, [_vm._v("they should accede to this very modest request from someone who had been so kind and helpful. “That’s why I went along with it,” Bob remembered."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-28",
      "id": "ch03-028-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lee Buxton had seen much, much less of Elizabeth and David “Odegard.” Both natives of the west, David’s employer had transferred him from Indiana to New Haven in early September of 1957, when their third child was just five weeks old. Their first two babies had died in January 1954 and April 1955, and the prospects for this boy were highly uncertain. Their Indiana doctor had instructed them to go to Grace-New Haven Hospital immediately upon arrival in Connecticut, and had sent their medical records on ahead of them. It was a time of “a lot of stress for us,” Elizabeth later said with considerable understatement, and on October 17, just five weeks after their arrival in New Haven, this third child too passed away. Some weeks later, Buxton—who had not been their principal physician—raised the test case subject with them. After being assured of complete confidentiality, they put aside their initial hesitation and agreed. Thus by sometime in early January 1958, Lee Buxton had three compelling medical cases—and human stories—tentatively ready to take to court."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-29",
      "id": "ch03-029-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Medical tragedies were of course not the only events taking place at Yale during the fall of 1957. Jean Cressey and Marvin Durning were two students who met each other there that September. Jean was a Massachusetts native and Oberlin graduate who had spent a year in the Philippines and was just beginning Yale’s master of arts in teaching program. Marvin had graduated from Dartmouth in 1949 and had taken one year of classes at Yale Law School before winning a Rhodes Scholarship to England. That had been followed by four years in the Navy, and only in September 1957 was he returning to finish his final two years of law school. By Christmastime Jean and Marvin had decided to marry, and sometime just after New Year’s Jean made an appointment at Yale’s student health service to request birth control advice and a diaphragm. Although she remembered the battle over the 1948 Massachusetts birth control referendum, she was nonetheless taken aback when the female physician at the Yale health service informed her that such devices could not be fitted or provided in Connecticut, and that the closest Planned Parenthood clinic was across the state line in Westchester County, New York. Jean had a full course load, a student-teaching assignment, and several big exams fast approaching. Having to take most of a day to drive all the way to Port Chester and back for such a simple matter was inconvenient and irritating. “I was really annoyed,” she later remembered, “at the idea that I would have "), _c('a', {
    attrs: {
      "id": "page_147"
    }
  }, [_vm._v("to find my way to New York, to the closest Planned Parenthood, to get birth control advice.” Within a few days she made the trip down to Westchester. “I drove into town. I had the address, but I couldn’t quite find it right away, and I found a policeman, and I stopped and asked him. I didn’t ask by the full number of the address, I just asked where is ‘Fowler’ Street or whatever it was, and he said something like ‘Go up to the second traffic light, turn left, it’s in the first block on the right.’ A young woman in Connecticut license plates asking for the street was enough for him to know where I was going.”")])]), _c('a', {
    attrs: {
      "id": "page_147"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Jean’s trip was successful, but Marvin too was more than a little irritated at the inconvenience that the old Connecticut statute had caused Jean. “I was quite upset,” he recalled, and complained about it the next day at lunch in the law school to several friends. Afterward he went upstairs and mentioned his annoyance to his civil liberties professor, Tom Emerson. A quiet and understated man whom conservatives nonetheless viewed as a dangerous radical, Tom Emerson had a quick and specific reaction when Marv related Jean’s experience: “Go talk to Fowler Harper. Fowler is thinking about a case.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_147"
    }
  }, [_vm._v("Durning knew Harper from having taken his torts course back in 1949–1950, and Harper welcomed Emerson’s recommendation that Marvin see him. Perhaps several weeks had passed since his conversation with Lee Buxton at that party, and Marvin’s description of Jean having to drive all the way to Port Chester and back stimulated Harper’s indignation in an even more pointed way than had Buxton’s three case descriptions. “Fowler was outraged,” Tom Emerson later said in remembering Harper’s reaction to Durning’s visit, at the “governmental intrusion” into marital privacy that the old statute represented. “I don’t think that there had been a final decision to do something at the time of my first conversation with him,” Marvin Durning recalled, but within days of that visit, Fowler Harper, like Lee Buxton, made a firm decision that the 1879 statute should indeed be challenged in court as an unconstitutional exercise of government power."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-30",
      "id": "ch03-030-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fowler Harper had been at Yale Law School for nine years when he had those two successive conversations with Lee Buxton and Marv Durning, but he had had a significant and colorful career long before moving to New Haven. Born in Germantown, Ohio, in 1897, Harper began taking law classes at Ohio Northern University in 1918 and passed the Ohio bar even before his 1921 graduation. He took a job as football coach at a small Ohio college, survived a nearly fatal stabbing by an unidentified assailant in Kalamazoo, Michigan, and married an Iowa woman, Grace Gill. They had a daughter in 1925, and Harper "), _c('a', {
    attrs: {
      "id": "page_148"
    }
  }, [_vm._v("completed a master’s degree in English at the University of Iowa before earning a graduate law degree at the University of Michigan. He began publishing extensively in law journals, and after teaching law for several years at the University of North Dakota, in 1929 he moved to the Indiana University Law School. By the late 1930s Harper was a protegé of Indiana Governor—and former Indiana law dean—Paul V. McNutt, and in August 1939 McNutt, now in Washington, named him General Counsel of the Federal Security Agency, a New Deal bureaucratic construct that included the National Youth Administration, the Civilian Conservation Corps, the Public Health Service, the Office of Education, and the Social Security Board. Harper stayed in the position for only a year before returning to I.U., but in May 1942 McNutt appointed Harper deputy chairman of the War Manpower Commission, a high-profile position that Harper held for twelve months before resigning with a public blast that the commission’s work was too heavily influenced by private corporate interests. He moved for a few months to the Office on Economic Warfare, and then in September 1943 was named Solicitor of the Interior Department by Secretary Harold Ickes. After two years in that job, Harper returned to the I.U. Law School in the fall of 1945."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-31",
      "id": "ch03-031-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("While in Washington Harper had been a delegate to both the 1940 and 1944 Democratic National Conventions; he also had been a leading member of the National Lawyers Guild, an association of liberal and progressive attorneys which he first had joined in early 1937, and through the NLG Harper had become good friends with many fellow New Deal progressives, including Thomas I. Emerson. Back in Indiana, Harper in the summer of 1946 was one of the first signatories of a petition to put the Communist Party on the state ballot, and within a few months local American Legion chapters were charging that Harper was a leading figure in Indiana communism. State and Chicago newspapers heralded the allegation, and in early December 1946, seventeen years after first arriving in Bloomington, Harper submitted his resignation to I.U.’s Board of Trustees. “I am not a political sympathizer with the Communist party nor have I ever been in sympathy with its political philosophy, practices or objectives,” Harper declared, explaining that he had signed the petition at the request of a regional CIO official. Harper quickly filed suit against the "), _c('i', [_vm._v("Chicago Herald American")]), _vm._v(" over one outlandish story, later received a fifteen-thousand-dollar settlement, and by September 1947 had joined his friend Tom Emerson on the Yale Law School faculty.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A thorough FBI probe into Harper’s politics and affiliations in "), _c('a', {
    attrs: {
      "id": "page_149"
    }
  }, [_vm._v("Indiana uncovered only acquaintances who characterized him as an “enthusiastic dice player” and a self-described best friend who reported that “Harper has the idea he can drink anyone ‘under the table.’” Some colleagues attributed Harper’s heavy drinking to his time in Washington, while others saw its roots in his wife’s nervous condition, a circumstance which led to their 1950 divorce and to Harper’s subsequent very painful estrangement from his daughter. But the Indiana controversy and the move to Yale did not lessen Fowler’s active interest in politics and world affairs; within months of his arrival in New Haven he and another progressive colleague, Fred Rodell, persuaded twenty-two of the law school’s twenty-seven professors to sign a public letter calling for the abolition of the House Un-American Activities Committee, a declaration that resulted in heavy public criticism. Fowler also served as vice-chairman of the American League for a Free Palestine, and in September 1948, along with a U.S. Representative from New York, he narrowly escaped being killed by an Egyptian mortar shell during a trip through southern Palestine. In 1949, along with a small number of other progressives or leftists, he testified against the nomination of Attorney General Tom C. Clark to a seat on the U.S. Supreme Court, and two months later, at the instigation of a Yale undergraduate named William F. Buckley, Jr., Harper debated internal security policy with top-ranking FBI executive Louis B. Nichols. Throughout the early 1950s Harper published a raft of essays in such magazines as "), _c('i', [_vm._v("The Nation")]), _vm._v(" and "), _c('i', [_vm._v("The Atlantic Monthly")]), _vm._v(", attacking Truman administration internal security policies and lambasting the Supreme Court for anticommunist holdings such as "), _c('i', [_vm._v("Dennis")]), _vm._v(" v. "), _c('i', [_vm._v("United States")]), _vm._v(", which Harper termed “the worst blow to democracy since the Dred Scott decision” upholding slavery in 1856."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-32",
      "id": "ch03-032-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In December 1950 Fowler married Miriam Cohen, a progressive social worker at New York’s Jewish Board of Guardians, and Miriam moved up to New Haven. Fowler’s outspoken opinions and occasionally flamboyant style drew criticism from some Yale trustees and law school alumni, especially since the faculty also boasted two other well-known progressives, Emerson and Rodell—or “Tommy the Commy” and “Fred the Red” among right-wingers. One gentleman who met Fowler at a New Haven card game went so far as to write to Yale’s Provost to register a formal complaint about Harper’s poor manners at poker: “when he fails to win, which is very often, [he] tears the cards up and scatters the pieces around the room.” Considerably more serious were the ongoing complaints that Harper was some sort of subversive, and in March 1953, perhaps as a direct result of defending Dr. "), _c('a', {
    attrs: {
      "id": "page_150"
    }
  }, [_vm._v("John P. Peters of Yale’s Medical School against allegations that he was a communist, Harper apparently was asked to prepare an informal but written response to the charges. “I do not belong to any organization which I regard as a communist front,” he stated in a letter addressed to law school colleague Eugene V. Rostow. He recently "), _c('i', [_vm._v("had")]), _vm._v(" resigned “because of communist domination” from the National Committee for the Arts, Sciences and Professions, and he vowed that he would resign his membership in the National Lawyers Guild “immediately” if “I ever conclude that the Guild is communist dominated.” Two months later, however, when he told a Washington audience of the General Federation of Women’s Clubs during a debate that communists should be allowed to teach at American colleges, he was booed and hissed in a scene that drew front-page coverage in Washington newspapers. To add injury to insult, three days later the "), _c('i', [_vm._v("Washington Times Herald")]), _vm._v(" attacked Harper editorially and noted that he was the same person who had resigned from the Indiana faculty in 1947 amidst allegations of communist affiliation."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-33",
      "id": "ch03-033-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Not all of Harper’s life in the early 1950s was consumed by controversy, however. In 1952 he published "), _c('i', [_vm._v("Problems of the Family")]), _vm._v(", a book that addressed policy issues by combining social science with the law, and it was reviewed positively in a wide range of professional journals. Three decades later one legal historian singled out the volume as “a radical departure from traditional casebooks on domestic relations in its organization and in the help it sought from other disciplines.” Harper’s other scholarship also ranged widely, from a review of Alfred Kinsey’s "), _c('i', [_vm._v("Sexual Behavior in the Human Female")]), _vm._v(" to his primary specialty of torts. In 1956, after several years of work, Fowler and his colleague Fleming James published "), _c('i', [_vm._v("The Law of Torts")]), _vm._v(", a major treatise that would make their names familiar to several generations of American law students and lawyers."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-34",
      "id": "ch03-034-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Harper was one of the most popular members of the law school faculty, both with students, who found him highly accessible as well as personable, and with his colleagues, even those who disagreed sharply with his political views. Fleming James later remembered him as “the most truly altruistic and compassionate man I have ever known,” and Gene Rostow, not one of Harper’s particular friends, acknowledged that “he was without malice” and “everyone recognized his generosity of spirit and the purity of his motives.” Tom Emerson noted that Fowler’s “unorthodox nature did not take kindly to organizational routine or compromise” and that often “he did not care whose toes he stepped upon.” Rostow called him “a crusader by temperament” who "), _c('a', {
    attrs: {
      "id": "page_151"
    }
  }, [_vm._v("was “acutely sensitive to injustice” and had a low boiling point. He took great pleasure in all the many battles, Emerson and Rostow both agreed, and “the more violent the controversy the greater was his delight,” Emerson thought. Harper’s colleague and future federal judge Lou Pollak found both Fowler and Miriam to be “terribly gregarious people,” and Fowler and Miriam’s closest New Haven friend, psychologist Elizabeth Phillips, who earlier had worked with Miriam in New York, heartily agreed, adding—as someone who named her daughter for her friends—that he was particularly “wonderful with children.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-35",
      "id": "ch03-035-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But Fowler never shied from a controversy. In April 1954 he and his colleague Vern Countryman—the erstwhile Hamden condom purchaser and former Douglas clerk—faced off against Bill Buckley and L. Brent Bozell in a widely publicized debate about McCarthyism, and that same year—at the height of the Red Scare—Fowler sent a public greeting to a dinner marking the thirtieth anniversary of the Communist Party’s newspaper, "), _c('i', [_vm._v("The Daily Worker")]), _vm._v(": “If the government can destroy your newspaper, with which I disagree, I am most fearful that it can and sometime will suppress publications with which I agree.” Harper and Emerson that same year fought and lost a major battle within the law school to win tenure for Countryman, who had joined Harper in Dr. Peters’ case and would subsequently join him in filing a Supreme Court amicus brief in another major Communist Party case, "), _c('i', [_vm._v("Yates")]), _vm._v(" v. "), _c('i', [_vm._v("United States")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The following year Dr. Peters finally prevailed in the Supreme Court, with Thurman Arnold and Paul Porter handling the final argument instead of Harper, while Fowler himself triumphed in the Connecticut Supreme Court in a long-running and legally complicated damage suit he had brought against a dishonest real estate agent who had finagled Harper out of sixty-three acres of additional land in the course of selling him a seventeen-acre farm in Haddam, Connecticut in 1948–1949. Harper had recruited Catherine Roraback, a 1948 Yale Law School graduate whom both he and Tom Emerson previously had known in progressive circles in Washington, and who now was a colleague of theirs in the New Haven Civil Liberties Council, to try "), _c('i', [_vm._v("Harper")]), _vm._v(" v. "), _c('i', [_vm._v("Jere Adametz et al")]), _vm._v(". They had lost in the trial court, but in March 1955, in a 4 to 1 decision written by Justice—and former governor—Raymond E. Baldwin that cited some of Harper’s own work on torts, the Connecticut Supreme Court held that Adametz had committed fraud and that the sixty-three acres would be conveyed to Fowler at a price of one thousand dollars. It was a classic Harper contest and victory, and it carried the promise of at least a modest future windfall. The "), _c('a', {
    attrs: {
      "id": "page_152"
    }
  }, [_vm._v("following year, in August 1956, Fowler and Miriam set off to spend a year at Lucknow University in India on a Fulbright fellowship. Once a month Fowler also delivered lectures in Delhi, and at the end of the academic year the Harpers toured the countries of the Mediterranean and drove from Italy to Copenhagen before embarking on a cruise home. Then, within six months of Fowler’s return to New Haven, Lee Buxton had come up to him at that party and raised the subject of birth control."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-36",
      "id": "ch03-036-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" "), _c('p', {
    staticClass: "normal2"
  }, [_vm._v("Within a day or two of Marvin Durning’s stimulating visit, Fowler Harper called Lee Buxton to tell him the interesting news and was himself told of Buxton’s encouraging conversations with the Kinlochs, the “Oldendorfs,” and the “Odegards.” Fowler quickly began envisioning the related set of multiple cases that could be brought on behalf of Buxton, his patients, and—as of February 1, 1958—newlyweds Jean and Marvin Durning. Lee Buxton called Estelle Griswold to let her know of the hopeful developments, and Estelle immediately set to work to push things forward. She asked both Lee and Fowler to prepare their thoughts and be ready to share them with PPLC’s top officers, and she notified both PPLC president Claudia McGinley and first vice-president Bea Hessel that a real test case was now very much at hand. Sometime late in January she scheduled a luncheon meeting at the New Haven Lawn Club, and as Fowler looked ahead toward it, he explained to Estelle that since he had no experience in Connecticut trial courts, and was not even a formal member of the Connecticut bar, that they would have to bring in someone else to argue the cases prior to any appeal to the U.S. Supreme Court, where Fowler would handle things. Estelle readily assented, and Harper picked up the phone and called Katie Roraback.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fowler had known Katie for fifteen years, respected her political views, and had been pleased with their success in the Adametz litigation. A 1941 graduate of Mount Holyoke College, Katie had grown up principally in Brooklyn, New York, where her father was a Congregationalist minister. Her family’s roots, however, lay in northwestern Connecticut, where her grandfather had practiced law before serving on the Connecticut Supreme Court and where her uncle, J. Henry Roraback, had quietly built his fortune while creating his quarter century dominance of the Republican party and Connecticut state government.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But Katie Roraback was about as politically different from J. Henry as someone could get. An economics major at Mount Holyoke, her most "), _c('a', {
    attrs: {
      "id": "page_153"
    }
  }, [_vm._v("important undergraduate experience had been her interaction with female factory workers in a nearby city through the Student Industrial Club. After graduation Katie had worked in Washington, first at the Agriculture Department and then for the National War Labor Board, and had met both Fowler and Tom Emerson. In 1945 she had entered Yale Law School, and after graduation she had begun practicing in New Haven, focusing principally on commercial and labor law.")])]), _c('a', {
    attrs: {
      "id": "page_153"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Fowler in that initial phone call described the patients’ cases and asked Katie if she would like to participate. Roraback jokingly asked him, “In what capacity are you calling me, as an attorney or as a woman?” But she readily said yes, and Fowler asked her to join him at Estelle’s upcoming Lawn Club luncheon. It was there that she first met both Lee Buxton and Estelle, and it was there that Claudia McGinley and Bea Hessel, on behalf of PPLC, formally pledged the organization’s financial backing for the set of cases that Fowler, Lee, and Katie would now begin to prepare. Fowler explained to everyone that their goal would be to reach the United States Supreme Court and to win there, on constitutional grounds; no one should have any realistic expectation that the 1879 statute would be reinterpreted or struck down by the Connecticut courts. He explained as well that they would pose a series of challenges: Lee’s professional claim that a doctor should not criminally be barred from giving his patients appropriate medical advice and treatment, the patients’ own three claims that the wives’ health and, in at least one case, her very life would be at very serious risk in the absence of birth control, and, finally and most importantly, Jean and Marvin Durning’s more basic assertion, in what Fowler called the “civil rights” case, that any married couple should be able to obtain and use contraceptives without obstruction or intrusion by the state.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_153"
    }
  }, [_vm._v("Katie at that luncheon voiced only one request as a condition for her participation: “that I refused to have anything to do with Morris Ernst,” PPFA’s counsel and an aggressive anticommunist as well as a ham-handed sexist. Griswold, McGinley, and Hessel readily agreed that Ernst would have absolutely no role as the cases went forward, and Katie and Fowler left the Lawn Club fully committed to getting to work on the formal papers that would be necessary for filing suit in New Haven County Superior Court."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-37",
      "id": "ch03-037-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Sometime in April Fowler notified Estelle that they were about ready to go, and either late that month or early in May both Fowler and Katie went to Jean and Marvin Durning’s apartment at 6 Trumbull Street to have them sign a copy of the formal complaint that would "), _c('a', {
    attrs: {
      "id": "page_154"
    }
  }, [_vm._v("soon be filed on behalf of “Ralph and Rena Roe.” Katie had already met Ruth “Oldendorf,” who would indeed become “Jane Doe,” and was tremendously touched by both her struggle and Bob’s supportiveness. Everyone had assumed without question from the outset that pseudonyms would be employed all around, except with regard to Lee Buxton, and everyone additionally understood that it was highly unlikely that any of the non-M.D. plaintiffs would ever have to appear in court. Hector and Anne Kinloch would file suit as “Harold and Hanna Hoe,” and David and Elizabeth “Odegard” would be spoken of as “Paul and Pauline Poe.” On May 12 Fowler told Claudia McGinley that they were within a week to ten days of actually filing the cases, and on May 22 the five sets of papers were formally served on State’s Attorney Ab Ullman and officially docketed in Superior Court. Six days later Katie filed brief motions in four of the five actions seeking formal “permission to use fictitious names.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-38",
      "id": "ch03-038-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The initial complaints in "), _c('i', [_vm._v("Buxton")]), _vm._v(" v. "), _c('i', [_vm._v("Ullman")]), _vm._v(" and the four companion cases were relatively brief and simple, in part because both Roraback and Harper were all but certain that Superior Court would simply refer the basic constitutional questions to the Connecticut Supreme Court. Buxton’s suit alleged that the 1879 statute infringed upon his “property and liberty” in contravention of the Fourteenth Amendment to the U.S. Constitution; "), _c('i', [_vm._v("Poe")]), _vm._v(" v. "), _c('i', [_vm._v("Ullman")]), _vm._v(" understandably cited both “life and liberty” in making a Fourteenth Amendment challenge, and "), _c('i', [_vm._v("Roe")]), _vm._v(" v. "), _c('i', [_vm._v("Ullman")]), _vm._v(" most basically cited simply “liberty.” Roraback told Estelle Griswold that if they were fortunate the cases would reach the Connecticut Supreme Court before the end of the year, and PPLC’s late May annual meeting included a serious discussion of the expanded fund-raising that the organization would have to undertake. The cost of Katie Roraback’s time, plus simple expenses, was estimated as likely to come to between five and six thousand dollars, and while Fowler Harper came for free, PPLC informed Port Chester and the Mt. Kisco and Providence clinics that it would have to suspend payment of the contributions that previously had been offered to help subsidize their services to Connecticut residents."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-39",
      "id": "ch03-039-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Roraback had hoped to keep publicity about the cases to an absolute minimum until they reached Connecticut’s highest court, but on June 6, two weeks after their filing, the "), _c('i', [_vm._v("New Haven Register")]), _vm._v(" and the Associated Press made the suits front-page news all across the state. The newspapers provided only the bare-bones descriptions of the plaintiffs that had been offered in the official complaints, and no follow-up coverage ensued. The American Civil Liberties Union "), _c('a', {
    attrs: {
      "id": "page_155"
    }
  }, [_vm._v("immediately began discussing whether they should lend some sort of legal hand, but Estelle felt highly confident that these suits would bring eventual success irrespective of additional aid, telling one supporter that “we are already thinking and planning for the day we will open up a center in New Haven.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-40",
      "id": "ch03-040-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Neither Ab Ullman nor the state Attorney General’s office moved quickly to respond to Roraback’s filings, and the summer and early fall passed without any substantive developments. In New York City a major controversy over an unspoken but long-standing policy that prohibited doctors in the city’s public hospitals from providing birth control services remained in the news for months before culminating in a rule change that represented a significant Planned Parenthood victory, and a number of commentators, including several Roman Catholics, cited the New York events, and the Connecticut statute, as stellar examples of why public policies should not be guided or determined by church doctrine. Jesuit scholar John Courtney Murray expressly attacked the church’s defense of Connecticut’s contraceptive ban, contending that “Since it makes a public crime out of a private sin, and confuses morality with legality, and is unenforceable without police invasion of the bedroom, the statute is indefensible as a law.” The New York Archdiocese insisted that “No indication or need can change an action that is intrinsically immoral into an action that is moral and lawful,” but the Catholic magazine "), _c('i', [_vm._v("Commonweal")]), _vm._v(" firmly retorted that it was in Catholics’ own interest to keep moral questions separate from legal issues. In particular reference to Massachusetts and Connecticut, another "), _c('i', [_vm._v("Commonweal")]), _vm._v(" essay bluntly noted that the decades-long battles over laws that “are merely decorative” served “no real purpose other than” to allow for an ongoing “Catholic-Protestant power struggle.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-41",
      "id": "ch03-041-41",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In mid-September Morris Ernst, Harriet Pilpel and a third associate went up to New Haven to see Fowler Harper about the Connecticut cases, and Katie Roraback gritted her teeth and attended, largely so as to be sure that warm-hearted Fowler would not allow the New Yorkers to insinuate themselves. Harper and Roraback’s successful brush-off of the PPFA lawyers quietly raised some hackles in New York, however, and PPFA president Loraine Campbell, a Cambridge resident and a twenty-five-year veteran of the Massachusetts birth control wars, decided she had better check out Fowler Harper with several of her friends on the Harvard Law School faculty. Benjamin Kaplan praised Harper as a “tremendous fighter” of “enormous courage” who, like his Yale colleagues, was nonetheless a “soggy thinker,” but Lon L. Fuller, a figure of considerable repute, angrily denounced Harper as “a sleazy "), _c('a', {
    attrs: {
      "id": "page_156"
    }
  }, [_vm._v("character” whom Fuller would “not have anything to do with.” He told of Harper’s departure from Indiana, called "), _c('i', [_vm._v("Problems of the Family")]), _vm._v(" “rather unsound,” and termed Fowler a “left winger” and “exaggerated liberal who delights in shocking people.” A concerned Campbell drafted a letter to Claudia McGinley offering PPFA funding if PPLC would like to hire other attorneys, but finally contented herself simply with writing to Harper to offer praise of Lee Buxton and to request an update."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-42",
      "id": "ch03-042-42",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In early October Joseph Sunnen, the St. Louis vaginal foam manufacturer, donated a thousand dollars to PPLC to help with the cases, but the ongoing delay disappointed everyone. PPLC began making plans to sponsor a bill in the upcoming 1959 legislature, and Loraine Campbell and Harriet Pilpel repeatedly compared notes about how the Connecticut litigation might be improved. Pilpel and Ernst had encouraged Harper and Roraback to think about adding some additional cases in which ministers would complain that the 1879 statute interfered with religious liberty by prohibiting them from advising parishioners about the advisability of birth control, but Pilpel and Ernst were also eager to detect shortcomings in Harper and Roraback’s original complaints, with Ernst griping that the "), _c('i', [_vm._v("Doe")]), _vm._v(" case was a poor selection since her condition was so serious that only sterilization would really be appropriate. Campbell was concerned that the anonymity of the patients might eventually become a problem, but Pilpel assured her that Harper had said that at least two of the pseudonymous plaintiffs—namely Jean and Marvin Durning—would be willing to step forward if it became necessary. Pilpel also sought to leaven Campbell’s ongoing worries about Harper, jokingly telling her that the only serious problem was that Harper “drinks too much in the evening, but we can meet at day time!”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-43",
      "id": "ch03-043-43",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Late in October a frustrated Roraback, who already had tried several times without success to prod the defendants into action, filed a formal motion requesting a default judgment on account of her opponents’ failure to plead. On November 7 the state Attorney General’s office, in a clear signal that it was taking over defense of the actions from Ullman, filed similar two-page demurrers in all five cases, contending that the issues had been “conclusively determined” in "), _c('i', [_vm._v("Nelson")]), _vm._v(" and "), _c('i', [_vm._v("Tileston")]), _vm._v(" and that “there is no uncertainty” in any of the cases. “The passage of time and a change in Court personnel,” Assistant Attorney General Raymond J. Cannon said, “cannot be grounds for seeking a review.” An additional problem in four of the five suits, Cannon added, is that the plaintiffs “are fictitious persons and as such cannot invoke the powers of the Court to solve purely academic questions.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-44",
      "id": "ch03-044-44",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_157"
    }
  }, [_vm._v("Harper and Roraback were more concerned about the growing signs of intramural unhappiness within the New York world of Planned Parenthood than about Cannon’s response, for as Harper attempted to reassure Loraine Campbell, “We assume that we will lose in the state and our hopes are pinned upon an appeal to the Supreme Court.” They also lined up C. Lawson Willard and two other willing ministers as additional potential plaintiffs as Pilpel and Ernst had suggested, and in mid-November Harper went down to New York for a long conference with Ernst, Pilpel, Campbell, and PPFA director William Vogt in order to try to lay their concerns to rest. Ernst and Pilpel, perhaps still sensitive fifteen years later because of the damage caused by Fritz Wiggin’s initial error in the "), _c('i', [_vm._v("Tileston")]), _vm._v(" complaint, grilled Harper in some detail about language disparities in different paragraphs of the "), _c('i', [_vm._v("Doe")]), _vm._v(" complaint, and suggested that amended complaints might be advisable. Additionally, right after the meeting Campbell called Lee Buxton to be sure that he would suggest to Harper the advisability of an amicus brief that could be signed by prominent doctors."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-45",
      "id": "ch03-045-45",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On December 5, more than six months after the suits had been filed, Katie Roraback finally squared off against Ray Cannon of the state Attorney General’s office in an initial hearing before Superior Court Judge Frank T. Healey—a Waterbury native who twenty years earlier had been a fellow advisory board member along with Bill Fitzgerald for Father Eugene Cryne’s Diocesan Bureau of Social Service. Cannon, like the judge, was a Roman Catholic graduate of Holy Cross College and Yale Law School, and now he reiterated the two points he had stressed in his preliminary papers. First, all of the legal issues “presented in the present complaints have been so authoritatively determined by the "), _c('i', [_vm._v("Nelson")]), _vm._v(" and "), _c('i', [_vm._v("Tileston")]), _vm._v(" cases that there is not now any justiciable issue” remaining. Both decisions explicitly held that the judiciary “is without power to create any exceptions in the subject statutes,” and by asking for such the plaintiffs “are in effect seeking to have the Court act in a legislative capacity.” Second, he repeated his earlier assertion that the anonymity of plaintiffs in four of the five actions raised a serious and perhaps fatal procedural problem. Katie Roraback responded by telling Healey that another Superior Court judge, James Shannon, had verbally assured her that the Doe-Poe-Hoe-Roe usages were acceptable, and she rebutted Cannon’s substantive reliance on "), _c('i', [_vm._v("Nelson")]), _vm._v(" and "), _c('i', [_vm._v("Tileston")]), _vm._v(" by emphasizing the plaintiffs’ core contention: “These people have the right to be allowed to continue normal marital relations without being inhibited by the state.” Irrespective of the precedents, the 1879 law was so intrusive as to be "), _c('a', {
    attrs: {
      "id": "page_158"
    }
  }, [_vm._v("inherently unconstitutional: “A statute which by its very terms may inhibit the most personal relationships of marriage is itself unreasonable” and hence void. Judge Healey said only that he would take their arguments under advisement, and issue a decision sometime in the future."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-46",
      "id": "ch03-046-46",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Soon after that hearing the internecine tensions involving national Planned Parenthood took an odd but ultimately very important turn. For almost thirty years, since the 1929 raid on the Clinical Research Bureau, Morris Ernst had been Sanger’s—and then PPFA’s—principal lawyer. For much of that time he had prided himself on taking a less hostile attitude toward Roman Catholicism than was true of Sanger or some others within Planned Parenthood. Now, however, just after having reached his seventieth birthday, Ernst underwent something of a shift, insisting repeatedly to PPFA president Loraine Campbell that the organization needed to adopt a more hard-nosed stance. In mid-November Ernst had erupted at Campbell in front of several strangers, criticizing her “in the most vituperative way” for PPFA’s restraint, and Campbell had complained to many of her colleagues about this “utterly indefensible behavior on the part of the official counsel.” Harriet Pilpel, for twenty years Ernst’s principal deputy but now a forty-seven-year-old partner in her own right, advised Campbell to have a quiet lunch with her now-ageing mentor. A date was made for early December, and that very same morning a furious Claudia McGinley called Campbell to rebuke her for Ernst’s office having sent a junior associate to monitor the New Haven hearing and further lobby Fowler Harper on behalf of the New Yorkers’ tactical recommendations. Campbell angrily told McGinley that the young observer had been dispatched at "), _c('i', [_vm._v("her")]), _vm._v(" request because of the unresponsiveness of the Connecticut lawyers, but at lunch Ernst had little interest in discussing the Connecticut scene and instead returned to his “extremely rude” assault on Campbell’s and PPFA’s political cowardice. Ernst twice threatened to resign as PPFA’s counsel if his advice was not better heeded, and as Campbell later wrote, “I did everything I could to placate him because he really was in a dangerous and irrational mood and I was afraid that he might go out and shout from the housetops about what a lot of damn fools we are.” Campbell wondered if Ernst in part might be distraught over the fact that the Connecticut problem was finally on its way back to the Supreme Court, but without he himself playing a significant role, but in the aftermath of the angry lunch Harriet Pilpel attempted to reassure Campbell that both she and Ernst felt comfortable with Fowler Harper. Campbell wondered too if Ernst "), _c('a', {
    attrs: {
      "id": "page_159"
    }
  }, [_vm._v("was upset that PPFA had largely ignored his advice during the New York City hospitals controversy several months earlier, but it was Campbell’s explicit instructions to PPFA’s staff that later made the lunch so significant: in the future “all legal matters should be routed through Mrs. Pilpel herself and not through Morris.” After more than thirty years on the front lines, Morris Ernst would spend his remaining years talking mostly to himself."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-47",
      "id": "ch03-047-47",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On January 5, 1959, Frank Healey issued a sloppy and careless two-page decision upholding Cannon’s substantive objections to the five test case complaints. Failing to note even the U.S. Supreme Court ruling in "), _c('i', [_vm._v("Tileston")]), _vm._v(", Healey erroneously stated that "), _c('i', [_vm._v("Nelson")]), _vm._v(" had involved a patient and then offered little more than a brief reprise of the Connecticut Supreme Court’s majority opinion in "), _c('i', [_vm._v("Tileston")]), _vm._v(". Two weeks later Ray Cannon moved for a formal entry of judgment, and once that was done Katie Roraback in early February filed notices of appeal to the Connecticut Supreme Court. Fowler Harper was hopeful that oral argument there would take place sometime late in the spring, but within days of Healey’s decision Jean and Marv Durning informed him that they would be moving to Seattle once Marvin completed his final semester of law school courses that spring. Fowler, knowing that "), _c('i', [_vm._v("Roe")]), _vm._v(" v. "), _c('i', [_vm._v("Ullman")]), _vm._v(", the most important of the five cases, would have to then be withdrawn once they left the state, immediately began looking for another young married couple who could take the Durnings’ place."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-48",
      "id": "ch03-048-48",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("PPLC’s thinking about a 1959 legislative effort had been influenced both by the lawyers’ discussions about the advisability of filing several religious freedom cases on behalf of ministers and by the results of the November 1958 elections, in which the greatest Democratic sweep in decades had resulted in a twenty-nine to seven margin of Democratic control in the state senate and the first Democratic majority in the state house (141 to 138) since 1876. Estelle and others, recognizing that the legislative effort would of course be truly hopeless, decided to frame it in such a way as to give a publicity boost to the ensuing litigation: the 1959 bill would be a religious freedom as well as a maternal health measure, and would call for a statutory exception to the 1879 law when contraception was practiced “pursuant to spiritual or medical advice.” Harper himself drafted the measure, and Estelle recruited official support for it from the Connecticut Council of Churches and several other ministerial groups. Representative Dorothy Miller of Bolton formally introduced it in late January, and PPLC’s board agreed that the ministerial law suits that Harper had prepared would be held in abeyance until the legislative demise of the bill was sufficiently obvious "), _c('a', {
    attrs: {
      "id": "page_160"
    }
  }, [_vm._v("so as to supply an appropriate occasion for the public filing of the cases."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-49",
      "id": "ch03-049-49",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Not until late April did the 1959 legislative hearing take place, with attorney Frank P. Lockard from the Council of Churches serving as coordinator for the bill’s proponents. New Haven ministers George Teague of the First Methodist Church and C. Lawson Willard of Trinity Episcopal Church were the primary affirmative witnesses, with Willard testifying that the 1879 law represented “a curtailment and an infringement of my religious liberty” by prohibiting him from recommending birth control to parishioners. Joseph Cooney was once again the leading representative for the bill’s opponents, and when Bethany Representative Jack Turner began energetically questioning a Hartford physician who had spoken against the measure, Cooney jumped in and interrupted. Public Health and Safety Committee chairman Senator Norman Hewitt admonished him bluntly: “Mr. Cooney, I am sure you won’t allow that to happen again.… Mr. Turner has the right to ask any question that he desires and that right will be respected.” Turner himself told Cooney that “I don’t think your outburst was called for,” but when Turner resumed questioning the doctor, the diocesan lobbyist again interrupted in an effort to end the interrogation. An angry Hewitt rebuked him again: “Mr. Cooney, I am the chairman of the hearing and we will terminate it when we are ready.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cooney’s insolent performance offended the legislators, but it could not save the bill from its inevitable fate, and six days after the hearing the committee voted by secret ballot to reject it."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-50",
      "id": "ch03-050-50",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])]), _vm._v(" PPLC wasted no time in moving along with the next step in its plans, and four days after the committee vote ministers C. Lawson Willard, George Teague, and Luther Livingston each filed suit in New Haven County Superior Court, alleging that the 1879 statute was an unconstitutional infringement of their religious liberty and pastoral counseling rights as protected by the free exercise clause of the First Amendment. Harper had recruited another young New Haven attorney, Louise Evans Farr, whom he—and Willard—knew from the New Haven Civil Liberties Council, to handle the ministerial suits, and he had some hope that they might catch up to the others either at the Connecticut Supreme Court or at the U.S. Supreme Court.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Harper also hoped, more fervently, that one other case might catch up to the initial ones. Sometime in March, just prior to the formal withdrawal of "), _c('i', [_vm._v("Roe")]), _vm._v(" v. "), _c('i', [_vm._v("Ullman")]), _vm._v(", Marv Durning approached one of the few other married students at Yale Law School, David Trubek, who was in the first-year class. David, like his wife Louise, who was in the second-year class, was a New York native and a graduate of the University of "), _c('a', {
    attrs: {
      "id": "page_161"
    }
  }, [_vm._v("Wisconsin. They had been married the previous summer, just before David had started law school, and while neither of them had ever given the birth control issue much thought, they were both willing to sit down with Fowler Harper and discuss becoming the new plaintiffs making the crucial argument that "), _c('i', [_vm._v("any")]), _vm._v(" married couple, irrespective of health issues, had an inherent Fourteenth Amendment liberty right to use contraceptives. David and Louise Trubek not only agreed to be Marv and Jean Durning’s successors, they agreed to do so under their own actual names, and on May 20, following a pro forma consultation between the Trubeks and Lee Buxton, Katie Roraback filed "), _c('i', [_vm._v("Trubek")]), _vm._v(" v. "), _c('i', [_vm._v("Ullman")]), _vm._v(" in New Haven Superior Court."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-51",
      "id": "ch03-051-51",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Katie Roraback had filed her briefs on behalf of Lee Buxton and his patients with the Connecticut Supreme Court in mid-April, but Ray Cannon requested and received several extensions of the deadline for filing the state’s responses, insuring that oral argument would be put off until sometime in the fall. Roraback’s filings were substantive and professional, highlighting the physical and emotional traumas that the Does, Poes and Hoes each had faced, and noting, in contrast to "), _c('i', [_vm._v("Gardner, Nelson")]), _vm._v(", and "), _c('i', [_vm._v("Tileston")]), _vm._v(" that “Never before have individual citizens”—i.e., patients rather than doctors and clinic personnel—“raised these questions, nor have their rights been adjudicated, either in this court or in the Supreme Court of the United States.” She also frontally addressed the notion that the criminal prohibition of the use of contraceptives could not be unreasonable and unconstitutional "), _c('i', [_vm._v("if")]), _vm._v(" abstinence was indeed a reasonable alternative for married couples facing serious pregnancy-related health threats, as the Connecticut court had concluded back in "), _c('i', [_vm._v("Tileston")]), _vm._v(". “If their rights to life and liberty have meaning,” Roraback wrote, “they must … include the right to marriage and the enjoyment of the fullest bounties which that relationship can give.… Sexual intercourse is not a mere adjunct of marriage, which may or may not be engaged in depending on the health and bent of the husband and wife. It is a part of the basic fabric of the whole marital relation.” Lastly, Roraback also directly confronted Cannon’s contention that "), _c('i', [_vm._v("Nelson")]), _vm._v(" and "), _c('i', [_vm._v("Tileston")]), _vm._v(" were thoroughly controlling: “we do not believe that the questions here presented have been authoritatively settled. Even if this were not so, our courts are not so limited that they cannot re-examine vital questions of constitutional interpretation and individual rights when called upon to do so in the light of new events and experience.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-52",
      "id": "ch03-052-52",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("If Roraback, Harper, and Griswold were pleased with the briefs, however, their ostensible allies in New York were not. Harriet Pilpel "), _c('a', {
    attrs: {
      "id": "page_162"
    }
  }, [_vm._v("gently informed Harper that the Connecticut lawyers should plan to file additional reply briefs once Cannon had submitted his arguments, and hinted that if they chose not to do so, PPFA could file an amicus brief. Harper, after consulting with Roraback, firmly told Pilpel that that would be inadvisable, and Pilpel then informed PPFA that “some rather vigorous action” was called for to convince the Connecticut activists of the New Yorkers’ superior wisdom. Loraine Campbell responded that the national organization “might as well let them go to Hell their own way,” but Pilpel continued to lobby Harper and Roraback toward submitting a reply brief. They tolerated the prodding politely, but Bea Hessel, who was just succeeding Claudia McGinley as PPLC president, called Loraine Campbell to complain about the “unethical” conduct and to point out how Roraback and PPLC had expressly stipulated at the outset that there would be no involvement by Ernst and Pilpel’s law firm. Campbell understandably told Hessel that she too was no fan of Ernst’s, but several days later Claudia McGinley phoned to repeat PPLC’s complaint. In early June Pilpel went up to Yale to repeat the New York insistence on some additional filing to Harper in person, and while Harper was cordial and courteous, the following day Hessel again called Campbell to say that the ongoing New York pressure was infuriating Roraback. Campbell bluntly told Hessel “that we are frankly not happy [at] the way the cases are being developed,” that “it all seemed rather amateurish,” and that PPLC did not understand its subordinate relationship to PPFA."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-53",
      "id": "ch03-053-53",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In mid-June Fowler Harper, after consulting with both Roraback and Griswold, wrote Pilpel to present what he hoped would be an implicit compromise that would halt the internecine warfare. He reiterated that “any intervention on behalf of the national organization in the Connecticut proceedings is undesirable” since Roraback “insists, as I thought she would, that she cannot effectively collaborate with anyone else in the writing of a reply brief”—the first acknowledgment that there now indeed would be one. Suggestions would be welcome, but any PPFA amicus brief for the Connecticut court would not be. However, once the cases were appealed to the U.S. Supreme Court, a PPFA amicus brief there would indeed be appreciated: “since presumably I will be the only attorney directly concerned, you may count on my cooperation.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Loraine Campbell continued to fret about the competence of the Connecticut litigation. She tried unsuccessfully to get one friend’s spouse to have Whitney North Seymour review and critique Roraback’s work, and Campbell’s predecessor as PPFA president, "), _c('a', {
    attrs: {
      "id": "page_163"
    }
  }, [_vm._v("Frances Hand Ferguson, declined to ask her father, famed federal appellate judge Learned Hand, to prepare any such appraisal. Bea Hessel again told Campbell that the Connecticut League wanted “no further interference” while the cases remained in the state courts, but in early July Pilpel sent Harper a lengthy and detailed written critique of Roraback’s briefs. None of the points was either central or serious, but Harper continued to tolerate the incessant hectoring far more dispassionately than Roraback or Hessel."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-54",
      "id": "ch03-054-54",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In late July Ray Cannon finally filed his defense briefs, and again he sought to challenge the legitimacy of the anonymous patient plaintiffs. Since “Harold and Hanna Hoe,” for example, were “fictitious” names, “the real parties in interest have not disclosed their identity.” Thus, Cannon illogically continued, “If the plaintiffs are fictitious persons, it must also follow that the questions which they seek to have adjudicated are academic in nature and do not apply to specific individuals.” This in fact did "), _c('i', [_vm._v("not")]), _vm._v(" follow, but Cannon went on at some length to warn the court that the pseudonyms were “an extremely dangerous precedent” that potentially could open the door to fraudulent litigation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Cannon offered almost no substantive defense of the Connecticut statute, and Katie Roraback, who had indeed accepted the advisability of submitting reply briefs, told Pilpel that Cannon’s efforts “are hardly enlightening exercises in the arts of the law.” Roraback stressed that her reply briefs would incorporate “many of the suggestions which you so kindly made,” and when she filed them in late August their argumentation was distinctly more vigorous than Roraback’s earlier submissions. She countered Cannon by noting that the original complaints described the plaintiffs in “elaborate” detail and stated that Dr. Buxton maintained that “he is entitled to prescribe the use of contraceptives under any (not limited) circumstances, when in his professional opinion their use will protect the life and health and promote the welfare of his patients.” Since actual patient cases had never before been adjudicated, the Connecticut court ought to willingly reconsider "), _c('i', [_vm._v("Nelson")]), _vm._v(" and "), _c('i', [_vm._v("Tileston")]), _vm._v(", “especially where the facts so urgently called for the reassessment of prior pronouncements.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-55",
      "id": "ch03-055-55",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Neither Roraback nor Estelle Griswold held out any serious hope of prevailing in the Connecticut Supreme Court. They both knew that now-Chief Justice Raymond E. Baldwin had backed birth control liberalization twenty-five years earlier as a state legislator, although not when he was governor, and while Stelle and Bea Hessel were already thinking of being able to open a New Haven clinic sometime in 1961, they presumed that would occur only in the wake of a U.S. Supreme "), _c('a', {
    attrs: {
      "id": "page_164"
    }
  }, [_vm._v("Court ruling. A mid-September hearing sent the "), _c('i', [_vm._v("Trubek")]), _vm._v(" case forward for Connecticut Supreme Court consideration, and on October 7—sixteen months after their filing—the Connecticut high court finally heard oral argument by Roraback and Cannon on "), _c('i', [_vm._v("Poe-Hoe-Doe")]), _vm._v(" and "), _c('i', [_vm._v("Buxton")]), _vm._v(". Loraine Campbell and Harriet Pilpel went up to Hartford to observe, and Chief Justice Baldwin and Justice John H. King dominated the hearing with a wide range of challenging questions. Katie Roraback thought the argument went “quite well on the basic questions,” but was concerned that “a good deal of questioning and doubt was raised as to the propriety of the use of fictitious names.” She and Harper estimated that a decision ought to come by Christmastime, and although the ministerial cases were being delayed by the state, everyone in PPLC sat back to wait for the anticipated defeat that would then allow them to take their challenge onward and upward to the U.S. Supreme Court."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-56",
      "id": "ch03-056-56",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In late November birth control became a front-page national issue when a number of Roman Catholic bishops, acting through the National Catholic Welfare Conference, issued a public statement denouncing any use of public funds, either domestically or in foreign-aid programs, to disseminate birth control services. Prominent Protestant leaders strongly criticized the statement, but President Dwight D. Eisenhower seemed to endorse it, saying that birth control was “not a proper political or governmental activity or function or responsibility.” Other press coverage noted that the American Civil Liberties Union had recently voted to endorse PPLC’s challenge to the Connecticut anticontraception statute on both First and Fourteenth Amendment grounds, but the sectarian controversy more importantly offered an opportunity for journalists to highlight how widely accepted contraceptive practices now were in almost all portions of American society. Survey data indicated that some 81 percent of married white women of childbearing age now used or had used contraceptive devices, a significant increase from even five years earlier, and that approximately 38 percent of Roman Catholic women in that group also used devices and methods that their church hierarchy condemned. Just as Hilda Standish and her colleagues at the Hartford clinic had recognized twenty years earlier, there was a very large—and now growing—gap between the practices of Catholic lay people and the proclamations of church officials."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-57",
      "id": "ch03-057-57",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On December 22, 1959, the Connecticut Supreme Court unanimously upheld the 1879 law criminalizing the use or counseling of birth control. The opinion, written by Chief Justice—and one-time "), _c('a', {
    attrs: {
      "id": "page_165"
    }
  }, [_vm._v("birth control proponent—Raymond E. Baldwin, offered a lengthy recital of all the unsuccessful legislative efforts to alter the statute before insisting that “Courts cannot, by the process of construction, abrogate a clear expression of legislative intent, especially when, as here, unambiguous language is fortified by the refusal of the legislature, in the light of judicial interpretation, to change it.” Baldwin conceded that “By reason of the facts in the instant cases, the claims of infringement of constitutional rights are presented more dramatically than they have ever been before,” but that "), _c('i', [_vm._v("Nelson")]), _vm._v(" and "), _c('i', [_vm._v("Tileston")]), _vm._v(" nevertheless were controlling because the basic issues raised here were “essentially the same.” The chief justice also admitted that “It may well be that the use of contraceptives is indicated as the best and safest preventive measure which medical science can offer these plaintiffs,” but if the Connecticut legislature nonetheless chose to prohibit that measure and insist on abstinence instead, there was nothing that either Lee Buxton or the Connecticut judiciary could do about it.")])]), _c('a', {
    attrs: {
      "id": "page_165"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_165"
    }
  }, [_vm._v("Baldwin’s opinion completely avoided ever dealing with the individual rights and constitutional liberty claims that Roraback had advanced on behalf of her plaintiffs. Some months later, however, when a curious and amazed woman from Houston wrote to Hartford to ask if it actually was true that the practice of birth control was a criminal offense in Connecticut, Baldwin himself wrote her a long and detailed personal letter describing why the Connecticut Supreme Court had felt it had no other choice. The plaintiffs’ requests, he explained, “could not be granted without overruling two prior decisions and the presumed will of the state legislature.” The legislative branch, Baldwin stressed, has “always had the authority to pass statutes to promote the public health, safety and morals. Courts do not often interfere with such legislative determinations of how these objectives can best be served unless they are manifestly unreasonable,” and in "), _c('i', [_vm._v("Buxton")]), _vm._v(" the Connecticut court “refused to find that the legislation was so unreasonable that the collective judgment of the legislature should be overturned.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-58",
      "id": "ch03-058-58",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Few if any observers were surprised by news of the Connecticut ruling, however. Several national newspapers editorialized against the holding, with the "), _c('i', [_vm._v("New York Herald Tribune")]), _vm._v(" declaring that birth control is “quintessentially a matter of private, not public morality, and one to be resolved as a matter of individual conscience.” Estelle Griswold admitted privately to one friend that she had been surprised by the unanimity of the Connecticut defeat, but Fowler Harper moved immediately to appeal the decision to the U.S. Supreme Court. He had arranged for "), _c('a', {
    attrs: {
      "id": "page_166"
    }
  }, [_vm._v("his friend Eugene Gressman, a Washington attorney who was perhaps the nation’s leading expert on Supreme Court procedure, to handle much of the technical minutiae, and early in January Gressman advised Fowler that the clerk’s office at the court had recommended that they file two separate appeals, one of behalf of Dr. Buxton and the other on behalf of the patients. Just a few days later Harper learned that Anne and Hector Kinloch would be leaving New Haven in June to move to Australia, where Hector had accepted a history faculty appointment, and their departure would necessitate dropping “Harold and Hanna Hoe” from the set of cases. "), _c('i', [_vm._v("Trubek")]), _vm._v(" had not yet caught up, and hence only "), _c('i', [_vm._v("Doe")]), _vm._v(" and "), _c('i', [_vm._v("Poe")]), _vm._v(" would go forward, even though—unbeknownst to Harper—David and Elizabeth “Odegard,” or “Paul and Pauline Poe,” had no longer been Connecticut residents even when "), _c('i', [_vm._v("Poe")]), _vm._v(" was initially filed."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-59",
      "id": "ch03-059-59",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Both the ACLU and its small Connecticut affiliate, the CCLU, were already aiming toward filing an amicus brief on behalf of Buxton and his patients, and by early February Harper had contacted Whitney North Seymour, Sr., about coordinating the preparation of an amicus brief that could be filed on behalf of nationally prominent doctors. Katie Roraback continued to press forward with "), _c('i', [_vm._v("Trubek")]), _vm._v(", even though the ministerial cases seemed inextricably stalled, and by mid-March it had been agreed that Harriet Pilpel would prepare a Supreme Court amicus brief on behalf of PPFA. Harper himself was hard at work on drafting the initial substantive submission for the high court, the jurisdictional statement that would set out Buxton and the patients’ arguments for why the Supreme Court should hear their appeal. Gressman reviewed a first draft and recommended more attention to the constitutional rights claims and less to the medical acceptance of birth control, and on March 23 the two documents—one for "), _c('i', [_vm._v("Buxton")]), _vm._v(", one for "), _c('i', [_vm._v("Poe")]), _vm._v(" and "), _c('i', [_vm._v("Doe")]), _vm._v("—were formally filed."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-60",
      "id": "ch03-060-60",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Harper’s "), _c('i', [_vm._v("Poe")]), _vm._v(" submission was the longer and more important document. He described “Jane Doe” and “Pauline Poe’s” medical problems in greater detail than Roraback had employed in the original complaints, and then presented the crux of his constitutional argument. The Connecticut statutes, he noted, “purport to regulate the behavior of married persons in the privacy of their homes in an arbitrary manner which restricts their liberty and seriously jeopardizes the lives and health of spouses.” Four decades earlier, in 1923, the Supreme Court in "), _c('i', [_vm._v("Meyer")]), _vm._v(" v. "), _c('i', [_vm._v("Nebraska")]), _vm._v(" had spoken of “the right of the individual … to marry, establish a home and bring up children,” and Harper, citing that precedent, forthrightly insisted that “The right to marry and establish a "), _c('a', {
    attrs: {
      "id": "page_167"
    }
  }, [_vm._v("home … necessarily implies the right to engage in normal marital relations. And the right to engage in such relations embodies a personal freedom or privilege to procreate or not procreate as the individuals may desire or as medical factors may dictate. This right must therefore be considered as one of the bundle of rights which are ‘fundamental to the very existence and survival of the race,’” a category the Court had spoken of eighteen years earlier in "), _c('i', [_vm._v("Skinner")]), _vm._v(" v. "), _c('i', [_vm._v("Oklahoma")]), _vm._v(". “Legislation which leaves total abstention as the only alternative to death or impaired health is on its face arbitrary and unreasonable,” Harper contended, and represents “an unreasonable and arbitrary intrusion in the private affairs of the citizens of Connecticut.”")])]), _c('a', {
    attrs: {
      "id": "page_167"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Harper went on to point out that birth control had widespread public acceptance, citing a recent Gallup Poll result showing that 72 percent of respondents believed that contraceptive advice should be available to anyone who wanted it. Then he returned to the essence of his argument, seeking to persuade the nine justices of the clear unreasonableness of the Connecticut statute:")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent"
  }, [_vm._v("When the long arm of the law reaches into the bedroom and regulates the most sacred relations between a man and his wife, it is going too far. There must be a limit to the extent to which the moral scruples of a minority, or for that matter a majority, can be enacted into laws which regulate the sex life of all married people.")]), _vm._v(" "), _c('p', {
    staticClass: "blq-indent1"
  }, [_vm._v("Appellants are not contending that their rights of privacy, as such, are directly protected by the Fourteenth Amendment. They do submit, however, that their privacy is mercilessly being invaded by these laws and that, this being so, it is a highly important factor for this Court to consider in weighing the hardship upon individuals against the theoretical, if not entirely fictitious, advantages of the laws as promoting public morality.")])]), _c('p', {
    staticClass: "indent1"
  }, [_c('a', {
    attrs: {
      "id": "page_167"
    }
  }, [_vm._v("Harper reiterated the privacy point several times. “The normal and voluntary relations of spouses in the privacy of their homes is regarded as beyond the prying eyes of peeping Toms, be they police officers or legislators.” He drew a contrast between the Connecticut case and a 1952 Court decision, "), _c('i', [_vm._v("Public Utilities Commission")]), _vm._v(" v. "), _c('i', [_vm._v("Pollak")]), _vm._v(", where a challenge to the broadcasting of radio programs on public busses was rejected on the grounds that the unwilling listeners were, after all, out in public rather than at home. The patient plaintiffs here, Harper said, “complain that it is precisely their privacy in their homes and, indeed, in the most private part thereof that is invaded. They want to be let alone in the bedroom”—an implicit reference to a famous phrase, “the ")]), _c('a', {
    attrs: {
      "id": "page_168"
    }
  }, [_vm._v("right to be let alone,” that had been coined by the legal scholar Thomas M. Cooley in 1888. “They insist that marital intercourse may not be rationed, censored or regulated by priest, legislator or bureaucrat. Certainly, they contend, the ‘liberty’ guaranteed by the due process clause includes this, among the most sacred experiences of life.”")])]), _c('a', {
    attrs: {
      "id": "page_168"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_168"
    }
  }, [_vm._v("Harper closed his "), _c('i', [_vm._v("Poe")]), _vm._v(" statement with one final chorus: “These married persons contend that they have a constitutional right to marital intercourse in the privacy of their homes under medically approved conditions and under circumstances mutually satisfactory to them. What right, it may be asked, is more fundamental or more sacred?” In his much shorter, companion submission in "), _c('i', [_vm._v("Buxton")]), _vm._v(", Harper understandably focused upon the statutes’ infringement upon doctors’ professional obligation to safeguard their patients’ lives and health, decrying them as “laws which fly in the face of science.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-61",
      "id": "ch03-061-61",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Within the Supreme Court, some six weeks passed before "), _c('i', [_vm._v("Poe")]), _vm._v(" v. "), _c('i', [_vm._v("Ullman")]), _vm._v(" and Harper’s jurisdictional statements came under active consideration within the chambers of the Court’s nine justices. In order for such an appeal to be accepted for review, at least four justices would have to vote in favor of such consideration. The State of Connecticut had made no submission, and when Harper’s documents were reviewed in the different justices’ chambers, the brand-new law school graduates who were the justices’ law clerks had a wide variety of reactions. Justice William O. Douglas’s clerk, Steven Duke, offered little reaction other than that the patients’ claims were obviously stronger than Dr. Buxton’s, while Justice Tom C. Clark’s clerk, Cecil Wray—obviously not aware of Fowler Harper’s testimony against the justice’s nomination eleven years earlier—commended the Yale professor for writing “a very persuasive brief” and picking out “very strong cases” with which to challenge the statute. The Connecticut Supreme Court’s opinion “isn’t very strong,” and overall the plaintiffs appeared to have “a good case.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Chief Justice Earl Warren’s clerk, Murray Bring, was similarly impressed both by Harper’s “very persuasive” work and by the specific and “very well stated” facts of the patients’ cases. “If there is anything left of the doctrine of substantive due process”—the use of the Fourteenth Amendment’s “liberty” language to void a statute simply because it was an excessive and unreasonable infringement on individual freedom, a usage that the Court had largely abandoned after 1937 following enormous criticism of its extensive utilization to invalidate government regulation of business—“then it would be difficult to find a more appropriate case for an application” of it. Of course the subject "), _c('a', {
    attrs: {
      "id": "page_169"
    }
  }, [_vm._v("of birth control, with its sexual and religious overtones, might be “difficult and ticklish” for some—such as perhaps the rather prudish Chief Justice himself—but “I think it will be some time before a case will come along in which the facts are as appealing or the counsel is as competent.”")])]), _c('a', {
    attrs: {
      "id": "page_169"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_169"
    }
  }, [_vm._v("Howard Lesnick, Justice John Marshall Harlan’s clerk, took a decidedly less sanguine view. The merits of the case, he asserted, “are clouded by the poor quality of Professor Harper’s brief,” for Harper has “largely forgotten the particular claims of his clients” in favor of “a broadside attack on the statute.” Lesnick too thought that the patients’ claims were more significant than Buxton’s, and remarked that the patients’ real interest was in being able to have intercourse. “If the interest is thought sufficient to entitle it to constitutional protection, the question is one of substantive due process.” Regarding the subject matter, he noted that “This issue, ticklish as it is, is not so bad as "), _c('i', [_vm._v("Naim")]), _vm._v(" v. "), _c('i', [_vm._v("Naim")]), _vm._v("”—a case challenging Virginia’s criminalization of interracial marriage that the Court twice had dodged four years earlier. But, Lesnick added, the Connecticut statutes “have not been enforced against any of the appellants, and the Court could duck the whole question by finding a lack of sufficiently ripe controversy.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-62",
      "id": "ch03-062-62",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On Friday, May 20, the nine justices, meeting in the absolute privacy of their conference room, voted to hear "), _c('i', [_vm._v("Poe et al")]), _vm._v(". and "), _c('i', [_vm._v("Buxton")]), _vm._v(" v. "), _c('i', [_vm._v("Ullman")]), _vm._v(". Five members of the Court—Chief Justice Warren, and Justices Douglas, Harlan, William J. Brennan, and Potter Stewart—one more than necessary, voted in favor, while three justices—Hugo L. Black, Clark, and Charles E. Whittaker—voted to dismiss the appeal and thereby affirm the Connecticut court. For reasons he did not disclose, Justice Felix Frankfurter—PPLM’s informal advisor back in the late 1930s—declined to vote on whether to accept "), _c('i', [_vm._v("Poe")]), _vm._v("."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-63",
      "id": "ch03-063-63",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Three days later the Court announced its acceptance of "), _c('i', [_vm._v("Poe")]), _vm._v(" and "), _c('i', [_vm._v("Buxton")]), _vm._v(", with the twofold nature of the case meaning that three full hours—ninety minutes for each side—would be scheduled for oral argument sometime in the fall of 1960. PPLC held its annual meeting the day after the announcement, and while everyone was pleased, there was considerable mystification as to why Frankfurter had recused himself. Loraine Campbell told the Connecticut activists that neither Frankfurter nor his wife had ever contributed to PPLM, and Fowler Harper, as well as Harriet Pilpel, turned their attention toward coordinating the content of the different but complementary briefs that would be due in Washington by late August. Pilpel’s amicus brief for PPFA would be responsible for showing why sexual abstinence was not "), _c('a', {
    attrs: {
      "id": "page_170"
    }
  }, [_vm._v("a reasonable alternative to the use of contraception, while Whitney North Seymour’s on behalf of prominent doctors would emphasize physicians’ professional responsibilities to their patients. Connecticut’s Raymond Cannon, in a very unusual move, refused to grant the state’s pro forma consent to the filing of the PPFA and doctors’ briefs, hence requiring those amici to obtain the Court’s formal approval for their submissions."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-64",
      "id": "ch03-064-64",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Supreme Court’s acceptance of "), _c('i', [_vm._v("Poe")]), _vm._v(" drew some press attention. The "), _c('i', [_vm._v("New York Herald Tribune")]), _vm._v(" editorially welcomed the action and said it looked forward to the high court voiding a statute that “is a clear infringement of both professional and personal liberty” and that makes “the particular doctrine of the Catholic Church binding, on penalty of imprisonment, on persons of all faiths.” A Catholic priest writing in a relatively obscure religious journal stated that “a Catholic can justifiably favor repeal of the Connecticut and Massachusetts anti-contraceptive laws,” and "), _c('i', [_vm._v("Newsweek")]), _vm._v(" magazine ran a story reporting his remarks. Several weeks later, when a Catholic journalist’s monograph critiquing the statutes was issued by a small think-tank, "), _c('i', [_vm._v("Newsweek")]), _vm._v(" ran yet another story and an Associated Press dispatch highlighting his work appeared in almost all Connecticut newspapers."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-65",
      "id": "ch03-065-65",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In early July the U.S. State Department offered Fowler Harper a four-month visit to Africa as a visiting legal consultant to several different countries, and with some reluctance Harper wrote to the Supreme Court Clerk’s Office to request that the oral argument in "), _c('i', [_vm._v("Poe")]), _vm._v(" be postponed until sometime after he returned from the trip in late January of 1961. Harper’s friend Gene Gressman warned that he had “heard some discouraging comments about the ultimate outcome from someone who spoke to one of the outgoing clerks,” since a new group of fresh young law school graduates arrived at the Court each summer, but work on all the various briefs proceeded apace. ACLU Assistant Legal Director Melvin Wulf had undertaken some initial research for the ACLU/CCLU amicus brief, but Yale’s Tom Emerson had volunteered that his wife Ruth Calvin Emerson, a 1950 Yale Law School graduate, was interested in helping, and by late August both Ruth Emerson and Wulf had completed revised drafts of parts of the brief."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-66",
      "id": "ch03-066-66",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By mid-September all of the Supreme Court briefs had been completed and Fowler and Miriam Harper were off to Africa. Katie Roraback and Ray Cannon faced off before the Connecticut Supreme Court for the oral argument of "), _c('i', [_vm._v("Trubek")]), _vm._v(" v. "), _c('i', [_vm._v("Ullman")]), _vm._v(" on October 6, and within the following two weeks the U.S. Supreme Court—with Felix Frankfurter continuing to recuse himself—formally approved Harper’s "), _c('a', {
    attrs: {
      "id": "page_171"
    }
  }, [_vm._v("request for "), _c('i', [_vm._v("Poe")]), _vm._v("’s postponement and also officially accepted all of the amicus briefs for which Cannon had refused to give Connecticut’s consent. Cannon had told the Connecticut court that David and Louise Trubek’s problem was not the 1879 statute but the fact that they sought to “avoid some of the responsibilities of the marital status,” but the national climate regarding issues such as birth control continued to liberalize, with Catholic Democratic presidential nominee John F. Kennedy telling an audience of Protestant ministers in Texas that he desired an America “where no religious body seeks to impose its will directly or indirectly upon the general populace or the public acts of its officials.” A major medical magazine, in a story picked up by national newspapers, quoted Connecticut doctors as explaining how the state law actually affected only those citizens too poor to pay private physicians for diaphragm fittings, but a prominent Catholic periodical, reacting both to "), _c('i', [_vm._v("Poe")]), _vm._v(" and to Kennedy’s comments, acerbicly complained that “Unfortunately a growing number of Americans look upon contraception as their inalienable right.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-67",
      "id": "ch03-067-67",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fowler Harper’s Supreme Court brief expanded upon but closely paralleled the arguments he had emphasized in his initial jurisdictional statement six months earlier. He spoke of how the Connecticut statutes “invade the privacy of the citizen,” “the privacy of the home” and “regulate the private sex life of all married people”—a slight emendation of his earlier language, where the adjective “private” had not appeared. He repeated his insistence that “These spouses want to be let alone in the bedroom,” noted the antecedents of that phrase, and reiterated in slightly altered wording his contention that married couples have “a constitutionally protected right to marital intercourse in the privacy of their homes.” Harper concluded by charging that the Connecticut provisions “interfere mercilessly with the most intimate and sacred experiences in life.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Neither the Seymour amicus brief, presented on behalf of sixty-six physicians, nor the PPFA brief, submitted in the names of Ernst and Pilpel, offered any especially notable arguments. Ruth Emerson and Mel Wulf’s ACLU/CCLU brief, however, expanded significantly upon the privacy emphasis articulated by Harper, and offered an explicit Fourteenth Amendment due process liberty basis for their contentions: “the Fourteenth Amendment protects persons from invasions of their privacy by the states. The Connecticut statutes in issue, on their face, seek to regulate an aspect of marital conduct that is inherently private and beyond the reach of government.” They cited a 1949 Fourth Amendment search and seizure decision, "), _c('i', [_vm._v("Wolf")]), _vm._v(" v. "), _c('i', [_vm._v("Colorado")]), _vm._v(", written by "), _c('a', {
    attrs: {
      "id": "page_172"
    }
  }, [_vm._v("Frankfurter, as their primary privacy precedent. "), _c('i', [_vm._v("Wolf")]), _vm._v(" had held that “security of one’s privacy against arbitrary intrusion” is “‘implicit in the concept of ordered liberty,’” a landmark constitutional phrase and standard signifying a right of such especially significant importance that the Supreme Court would protect it under the Fourteenth Amendment’s “liberty” from any infringement by a state. Emerson and Wulf also quoted former Justice Louis D. Brandeis’s 1928 adoption of Thomas Cooley’s “right to be let alone” expression, and then presented the core of their argument:")])]), _c('a', {
    attrs: {
      "id": "page_172"
    }
  }, [_c('p', {
    staticClass: "blq-indent"
  }, [_vm._v("The invasion of privacy here is two-fold. First, the statute on its face restrains married couples from employing the most effective means of contraception when engaged in sexual intercourse. Secondly, as applied, the statute confronts appellants with the choice of engaging in sexual intercourse without contraceptive devices, thereby immediately threatening the life and health of the female spouses, or of abstaining entirely from sexual intercourse.")]), _vm._v(" "), _c('p', {
    staticClass: "normal3"
  }, [_vm._v("“Marriage and the family are the foundations of our culture, and the focal points about which individual lives revolve,” they went on. “No other rights are entitled to greater privacy than that normally bestowed upon the acts of intercourse and procreation.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_172"
    }
  }, [_vm._v("Thirty years later, in his midsixties, Mel Wulf archly insisted that writing the "), _c('i', [_vm._v("Poe")]), _vm._v(" brief had been particularly compelling. “I was then a single man, living in the Village, and sexually active if not promiscuous … I had a personal commitment to birth control, and also abortion.” The brief, however, understandably stressed marital and family values to the utmost. Emerson and Wulf maintained that the Connecticut statute should evoke “the same quality of outrage to civilized sensibilities” that Frankfurter had enunciated in an earlier case that had denounced compulsory pumping of a drug suspect’s stomach in order to secure evidence. They also noted that there were at least four additional Supreme Court precedents, reaching well beyond the search and seizure context, where the Court at least implicitly had acknowledged “a private right to conjugal or domestic matters,” including two—"), _c('i', [_vm._v("Meyer")]), _vm._v(" v. "), _c('i', [_vm._v("Nebraska")]), _vm._v(" and "), _c('i', [_vm._v("Pierce")]), _vm._v(" v. "), _c('i', [_vm._v("Society of Sisters")]), _vm._v("—which expressly recognized “marriage and the family as the ultimate repository of personal freedom.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-68",
      "id": "ch03-068-68",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("With Harper in Africa and the case on hold, the final months of 1960 passed relatively quietly. Loraine Campbell continued to gripe about PPLC, but Pilpel wrote Estelle Griswold a commendatory letter to say that “You have done such a wonderful thing in making these cases possible.” Estelle declined the honor, insisting that “my part has "), _c('a', {
    attrs: {
      "id": "page_173"
    }
  }, [_vm._v("been a secondary one. Had it not been for the professional courage of Dr. Buxton and Fowler Harper there might not have been a lawsuit for years to come. All I have done is to coordinate and help raise the funds,” which now totaled some fifteen thousand dollars in legal expenses. “In fact, at all times, our League has tried to avoid publicity in connection with the cases to give credit for independent action on the part of the litigants.”")])]), _c('a', {
    attrs: {
      "id": "page_173"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_173"
    }
  }, [_vm._v("Estelle was “reasonably sure of success” once the Supreme Court did hear "), _c('i', [_vm._v("Poe")]), _vm._v(", and she kept up a regular correspondence with Harper in Africa, seeking his instructions as to whether an immediate appeal of "), _c('i', [_vm._v("Trubek")]), _vm._v(" to the U.S. Supreme Court would be worth the additional costs once the Connecticut Supreme Court issued its anticipated decision. Harper immediately replied that he could compose the necessary documents himself, even in Africa, and he also arranged to review Ray Cannon’s brief in defense of the Connecticut statutes once it was filed with the Court in mid-October. Cannon’s modest seventeen-page effort emphasized the many occasions on which the state legislature had declined to alter the law before attempting to justify the statute’s continued validity. “There is no obligation that the most modern or scientific remedy be chosen” by the legislators as a lawful practice, he insisted, for “it seems obvious that the Connecticut Legislature, speaking for the people of Connecticut, believes that the indiscriminate use of contraceptives will have an eroding effect upon the moral standards of its people.” He disparaged Harper’s brief by contending that “for the most part appellants’ argument is sociological and physiological rather than legal,” and ended by objecting to a passing reference Harper had made indicating that “artificial devices to prevent conception are available in Connecticut to unmarried persons.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-69",
      "id": "ch03-069-69",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fowler informed Estelle that Pilpel’s notion that they ought to file a reply brief in answer to Cannon’s contentions was utterly unnecessary, and when the Connecticut Supreme Court, as expected, unanimously rejected "), _c('i', [_vm._v("Trubek")]), _vm._v(" on November 15, Fowler was still hoping that it might yet be combined with "), _c('i', [_vm._v("Poe")]), _vm._v(" in time for U.S. Supreme Court oral argument. PPLC had agreed that a repeal bill, written by Katie Roraback and ostensibly sponsored by the CCLU, would be introduced in the 1961 Connecticut legislature, and in late January two female representatives, Katherine Evarts of Kent and Evelyn Fisher of Oxford, put one forward. Various news stories and articles, including a critical essay on Harper’s and the ACLU’s briefs in the "), _c('i', [_vm._v("Yale Law Journal")]), _vm._v(", all highlighted the upcoming high court consideration of "), _c('i', [_vm._v("Poe")]), _vm._v(", and early in the new year the National Council of Churches explicitly condemned "), _c('a', {
    attrs: {
      "id": "page_174"
    }
  }, [_vm._v("anticontraception statutes as violations of “the religious and civil liberties of all citizens.” Fowler Harper returned from Africa in mid-January, and just a few days later he received official notification that the Supreme Court oral argument of "), _c('i', [_vm._v("Poe")]), _vm._v(" had been scheduled for February 27."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-70",
      "id": "ch03-070-70",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In preparation for the "), _c('i', [_vm._v("Poe")]), _vm._v(" hearing, several of the nine justices, as was their common practice, had one or another of their young law clerks prepare lengthy private memos analyzing the issues and the briefs that had been submitted in the case. Charles Fried, a 1960 Columbia Law School graduate who was one of Justice John Marshall Harlan’s two clerks, prepared a "), _c('i', [_vm._v("Poe")]), _vm._v(" memo that expanded upon the critical comments Howard Lesnick had offered Harlan ten months earlier. “Neither one of the parties gives us any help in deciding this case,” Fried began. “Fowler Harper’s jurisdictional statement is execrable and so is his brief on the merits—it misses the whole point that can be made for his position. The state, perhaps wisely, says as little as possible, on a sit-tight theory.” Nonetheless, Fried enthusiastically agreed with Harper’s basic position: “the right to privacy is one which enjoys specific constitutional sanction,” particularly with regard to “the right to privacy of the home being the purpose behind” the Fourth Amendment. Hence “a married couple, enjoying that status in the eyes of the state, in their intimate and specifically marital relations may follow their inclinations and consciences without interference” by the state. It was undeniable that “the substantive right” at issue here “is one of privacy,” particularly with regard to the home, and that “individual married couples have a right to engage in marital relations in the privacy of their own consciences and free of the intrusion of the criminal law.” Connecticut “cannot say,” Fried went on, “that a law intruding the criminal law into the privacy of the marital bedroom is "), _c('i', [_vm._v("just like")]), _vm._v(" a law forbidding adultery, fornication or homosexuality.” Indeed, as was well known, Connecticut’s “use” statute was utterly unique, and “If reasonableness is to be the test where the state admittedly encroaches on substantive rights, it is difficult indeed to conceive of more conclusive evidence of unreasonableness.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nonetheless, the case was not without visible problems. First off, one could argue that as yet “there has been no showing that there is a danger of enforcement” of the Connecticut statute. Similarly, “One cannot escape the feeling that at least as to the complaint of the couple here that this is a totally unnecessary piece of litigation,” and as to Dr. Buxton “clearly there is no such right” as a physician’s privilege “to practice his profession as he sees best” without any state regulation. Any focus on the specific facts of "), _c('i', [_vm._v("Poe")]), _vm._v(", Fried felt, would lead to a "), _c('a', {
    attrs: {
      "id": "page_175"
    }
  }, [_vm._v("conclusion that “The only possible argument that can be made is that married couples have a right to engage in marital relations without the fear—in some cases—of death or serious illness.” However, “the trouble with this argument is that it assumes what is to be proven: that married couples have some kind of innate right to marital relations, and that if the choice must be between contraception on one hand and abstinence or serious danger on the other that the couple has the right to resort to contraception. To my mind,” Fried concluded, “this is a much more debatable proposition” than the other, decidedly broader answer that the Court could announce, and that Fried himself expressly recommended: that “married couples have a right to privacy in their intimacy.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-71",
      "id": "ch03-071-71",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Justice William J. Brennan’s clerk for "), _c('i', [_vm._v("Poe")]), _vm._v(", however, offered a radically different—and far more skeptical—evaluation of the case than had Charles Fried. Richard S. Arnold, a 1960 Harvard Law School graduate, had, like all Brennan clerks at that time, been selected for the post by Harvard professor Paul Freund without ever having met or spoken with the justice himself. Prior to Harvard, Arnold had been an undergraduate at Yale and an active member of its Episcopal parish; years later he would happen to volunteer that perhaps his favorite Yale instructor had been a history graduate student whose wife he also knew through her job at the church: Hector and Anne Kinloch.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But if Richard Arnold had of course never heard of “Harold and Hanna Hoe,” his two long memos to Justice Brennan were decidedly unfavorable to “Paul and Pauline” "), _c('i', [_vm._v("Poe")]), _vm._v(". While Arnold believed there was no question that the appeals were rightfully within the Court’s jurisdiction, he nevertheless seriously doubted whether "), _c('i', [_vm._v("Poe")]), _vm._v(" and "), _c('i', [_vm._v("Buxton")]), _vm._v(" were, in an important but elaborate judicial term of art, “justiciable” and hence worthy of a decision on the merits. The problem was the sketchiness of the cases’ earlier development: “There was no trial, no witnesses were heard … no findings of fact were made.” Yet “on this record the Court is asked to declare that the Connecticut legislature has exceeded its power,” and the record was simply “not all one might wish on which to base a decision of a difficult constitutional issue,” particularly in the absence of “the refining and sharpening influence of an adversary trial.” It was unclear “just how much of an interference with individual liberty does this law entail,” and the record was also silent on the question of whether the “rhythm” method of trying to avoid pregnancies was distinctly less dependable than diaphragms or other prohibited devices. “If they exceed in reliability the next best method by only a small margin, then the choice which Connecticut "), _c('a', {
    attrs: {
      "id": "page_176"
    }
  }, [_vm._v("has made may be more reasonable than plaintiffs would have us believe.”")])]), _c('a', {
    attrs: {
      "id": "page_176"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Arnold had a further objection, however, one that literally had not dawned on Harper, Roraback, Cannon, or anyone else who so far had been involved with "), _c('i', [_vm._v("Poe")]), _vm._v(". If the Connecticut courts had erred in sustaining Cannon’s objections to the suits, Arnold told Brennan, then apparently, under Connecticut’s procedural rules, should the U.S. Supreme Court reverse the decision below, such a holding would then require Harper and Roraback "), _c('i', [_vm._v("to go to trial")]), _vm._v(" to prove their original contentions, rather than immediately and directly void the 1879 law. Hence the Supreme Court appeal “is somewhat premature. Since there is going to be a trial anyway, if appellants are to succeed, why not have the trial before this Court decides the constitutional issue, instead of after.” In short, Arnold said, the high court should “put off a decision” and delay “the evil day when this Court must tell Connecticut whether its law is valid.” “This is no hardship for the appellants,” he added, “since if we reversed at their request they would have to go to trial on remand anyway.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_176"
    }
  }, [_vm._v("Several days later Arnold gave Brennan a second long memorandum focusing on the constitutional questions in "), _c('i', [_vm._v("Poe")]), _vm._v(" and arguing that if the Court did reach those merits, “the skimpiness of the record will probably compel it to uphold the statute.” But Arnold readily conceded that “on a properly constructed record a holding of unconstitutionality would be required,” for while Connecticut could cite a valid interest “in prohibiting extramarital intercourse” as underlying the statute, “the appellants have on their side of the balance not only the general interest in marital privacy and autonomy, but also their particular interests in health and life.” In the final analysis, “when physical harm and possible death is thrown into the balance, I think the statute becomes unconstitutional as applied.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-72",
      "id": "ch03-072-72",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fowler Harper had agreed to share a portion of his oral argument time with Harriet Pilpel, and on Monday morning the two attorneys, accompanied by Katie Roraback, Pilpel’s associate Nancy Wechsler, Bea Hessel, Estelle Griswold, Miriam Harper, and the Harpers’ close friend Betty Phillips all arrived as scheduled at the Supreme Court. Lee Buxton was absent since he was spending the spring in Geneva, but immediately upon everyone’s arrival at the Court, Harper received surprising and troubling news: the oral argument was being postponed for two days because Justice Frankfurter was absent due to laryngitis. But Frankfurter had explicitly "), _c('i', [_vm._v("not")]), _vm._v(" taken part in "), _c('i', [_vm._v("any")]), _vm._v(" of the preliminary decisions regarding the case, so did this now mean both that he had changed his mind regarding recusal, "), _c('i', [_vm._v("and")]), _vm._v(" that he was "), _c('i', [_vm._v("especially")]), _vm._v(" eager to "), _c('a', {
    attrs: {
      "id": "page_177"
    }
  }, [_vm._v("take part? Harper was both perturbed at the delay, and worried about what Frankfurter’s conduct might mean. Hoping to get a better understanding of what was going on, in the absence of any explanation from the clerk’s office, Harper did a "), _c('i', [_vm._v("very")]), _vm._v(" highly unusual thing for counsel in a Supreme Court case: remembering that one of Justice Potter Stewart’s clerks, Jerry Israel, was a former Yale Law School student whom he had known in passing, Harper went to Stewart’s chambers, asked for Israel, and queried the highly surprised clerk as to whether he had any idea what was going on. Not surprisingly, Israel didn’t.")])]), _c('a', {
    attrs: {
      "id": "page_177"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_177"
    }
  }, [_vm._v("In fact, at about eight p.m. on Sunday evening the 26th, Frankfurter had called Chief Justice Warren at home to request the postponement on account of his laryngitis, and the Chief had agreed. The involuntary two-day delay did offer Pilpel and the Connecticut group, especially Griswold, Roraback, and Hessel, a much better opportunity to get to know each other in a friendly, nonadversarial setting, and Pilpel’s deputy, Nancy Wechsler, later mused that perhaps the unplanned and enforced camaraderie occasioned by the Supreme Court delay went a good way toward erasing most of the tensions that previously had so heavily colored the PPLC-Pilpel interactions."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-73",
      "id": "ch03-073-73",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By Wednesday, March 1, Felix Frankfurter had his voice back, and at two forty-five p.m. that afternoon "), _c('i', [_vm._v("Poe et al")]), _vm._v(". and "), _c('i', [_vm._v("Buxton")]), _vm._v(" v. "), _c('i', [_vm._v("Ullman")]), _vm._v(" were called for oral argument before the full bench of nine justices. Fowler Harper, in an impressively strong and clear voice, began his presentation by offering understated but extremely powerful descriptions of “Jane Doe’s” and “Pauline Poe’s” medical situations. Justice Potter Stewart interrupted with the first question, asking if he was correct in thinking that no Connecticut statute aside from the accessory one prohibited the sale or prescription of contraceptive articles, and after Harper answered yes, Stewart followed up by asking whether Harper was challenging Connecticut’s use statute only in the context of women facing serious health threats. Harper, slightly off stride for the first time in the hearing, replied that the plaintiffs were challenging the statutes both “on their face” and as applied, and then Felix Frankfurter jumped in to querulously ask Harper why no First Amendment free speech argument was being made on behalf of Dr. Buxton. Harper parried, conceding that that was true, but Frankfurter pursued him: “And why is that? I don’t understand it.” Harper paused for a considerable time, explained that there were other cases, the clergy ones, still pending below, and then gently conceded that perhaps a speech contention should have been included in the pleadings, but that since it was not, he could not argue it now. Another justice quietly interjected that the "), _c('a', {
    attrs: {
      "id": "page_178"
    }
  }, [_vm._v("Fourteenth Amendment also prohibited state interference with constitutionally protected speech, but Frankfurter again broke in, telling Harper “It’s not for me to decide how you should argue.” Laughter rippled through the courtroom, and Harper moved on to emphasize “the liberty of the marital relation” and how “these laws mercilessly invade the privacy of a married couple.” Potter Stewart interrupted to ask whether freedom to practice one’s religion was involved, and Harper answered yes while noting that these plaintiffs had not made that contention.")])]), _c('a', {
    attrs: {
      "id": "page_178"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Harper’s argument proceeded without interruption for some ten minutes before Justice Harlan asked him how many prosecutions a year there were under the Connecticut statutes. Harper responded that he did not know, and Stewart then asked, “Is the law really enforced?” Harper responded somewhat lamely than “I’m ignorant of the extent to which the law is enforced … so far as I know it has never been enforced against a person who used a contraceptive.… Police do not peek into people’s bedrooms to see whether they’re using contraceptives … I know of no prosecution of an individual for use.” Then he recovered and pointed out how, since the "), _c('i', [_vm._v("Nelson")]), _vm._v(" decision, “no public or private clinic for the purpose of advising on contraception” had operated in the state. “The people in Connecticut who need contraceptive advice from doctors most—the people in the lower income brackets and lower educational brackets—the people who need it most, do not get it, because there are no clinics available.” Justice Brennan asked Harper whether there were any similar statutes elsewhere, and after describing the Massachusetts one, Harper concluded his initial forty-five minutes and yielded to Harriet Pilpel.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Pilpel, relying heavily on her notes, spoke almost exclusively to medical considerations. Some eight minutes passed without a single question from any justice until Stewart queried her about what the medical view of contraception might have been in 1879, and Pilpel returned to her disquisition for another long stretch before Frankfurter inquired about Connecticut’s sterilization law and opined that perhaps Buxton should have sterilized “Jane Doe” and “Pauline Poe.” Pilpel pointed out that sterilization was irreversible, and then Frankfurter, joined by Justice Whittaker, began peppering her with questions as to whether doctors were more knowledgeable than legislators. Pilpel acknowledged that “we recognize that we have the heavy burden in this case,” and then further conceded that “my argument is restricted to these cases” of Poe and Doe’s specific medical conditions alone.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_178"
    }
  }, [_vm._v("Just before four p.m. Raymond Cannon began his argument in ")]), _c('a', {
    attrs: {
      "id": "page_179"
    }
  }, [_vm._v("defense of the Connecticut statutes. A far less effective speaker than Harper, or even Pilpel, Cannon floundered from point to point before Chief Justice Warren interrupted him with a pointed question as to whether Connecticut rightfully could deny life-saving treatment to someone in “Jane Doe’s” situation. “It is our view,” Cannon replied, “that it is the problem primarily for the legislature to determine what is the greater good and how to accomplish the greater good.” That answer provoked both Warren and Potter Stewart, who sarcastically told Cannon that that was like telling a patient that they had appendicitis and would die unless it was removed, but that appendix removals were not allowed. Then Warren followed up, expressing amazement that the law, in a situation such as Jane Doe’s, could prohibit her from receiving appropriate medical treatment. Cannon responded that “There are proper ways to prevent conception through the natural means which they call rhythm.… The legislature has adopted one system. The legislature is free to adopt whichever system it sees fit, provided it’s reasonable for the purpose for which the law is intended.” Felix Frankfurter drew Cannon into a colloquy about popular government and legislators, observing that “in a democracy they have a right to elect even ignorant people” to office. Frankfurter wondered whether there might be some “outside authoritarian power” that was coercing the Connecticut legislature to adopt a minority preference, and Cannon forthrightly declared that “I don’t believe there’s any outside power in Connecticut influencing the legislature.” Justice Brennan asked whether Cannon regarded the sale of certain articles for the prevention of disease to be legal in Connecticut, and Cannon said no, for any use of such articles was a violation of the 1879 law. Cannon added that he knew of at least two unreported cases some years earlier where store owners had been arrested for having contraceptive vending machines on their premises. Justice Hugo Black got Cannon to readily acknowledge that the law indeed prohibited Dr. Buxton from saying some things to patients that he professionally might want to, and then, at four thirty p.m., the Court adjourned for the day.")])]), _c('a', {
    attrs: {
      "id": "page_179"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_179"
    }
  }, [_vm._v("Shortly after noontime on Wednesday, March 2, the oral argument resumed with Felix Frankfurter all but monopolizing Ray Cannon’s remaining time. He asked Cannon whether contraceptives were widely available in the state, and when the assistant attorney general replied that “I have no personal knowledge of this,” the justice quipped that “I wasn’t attempting to explore your personal knowledge.” Frankfurter pursued the theme that actual convictions under the use statute were necessarily nonexistent, musing that “we’re talking about a theoretical ")]), _c('a', {
    attrs: {
      "id": "page_180"
    }
  }, [_vm._v("thing here, aren’t we?” Cannon gently demurred, saying “It may be academic, but it has some effect,” and a surprised Frankfurter responded with a sharp “What?” Cannon replied that the statute had a deterrent effect in protecting the “moral qualities” of Connecticut citizens. Frankfurter offered Cannon several opportunities to articulate additional purposes for the statute, and when Cannon failed to volunteer what Frankfurter was anticipating, the justice explained to the harried attorney that encouraging population growth was obviously a major premise for the law. John Harlan asked Cannon whether “Connecticut can pass a statute that impinges on the privacy of the marriage relationship,” and Cannon responded that since marriage of course effected the morals of a society, that the state necessarily could regulate the relationship.")])]), _c('a', {
    attrs: {
      "id": "page_180"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_180"
    }
  }, [_vm._v("Shortly after one p.m. Fowler Harper resumed his argument for the final twenty-five minutes of the hearing. He emphasized that contraceptive articles, including diaphragms, were quietly available for purchase in Connecticut pharmacies, and Justice Stewart, seemingly in agreement, interjected that “this may all be an abstract attack on the law” and that “the law has no impact.” Harper tried to back pedal rapidly, declaring that “The law certainly has an impact on Poe and Doe, and under it no clinics can function.” Justice Brennan immediately broke in, asking “Isn’t the operation of clinics what’s at stake here really?” Harper indicated yes, and just as the final time expired Brennan observed, as much to himself as to Harper, that “I take it that the Poes and Does can get what they need almost anyplace in Connecticut.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-74",
      "id": "ch03-074-74",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The PPLC and PPFA contingent were unanimously impressed with what a superb job Fowler Harper had done, especially in handling Justice Frankfurter’s many challenges, but they acknowledged to each other that the outcome was far from certain. Savvy press observers, including a UPI reporter and a "), _c('i', [_vm._v("Time")]), _vm._v(" magazine correspondent, however, frankly predicted, as the latter writer put it, that the peppery justice “had laid the basis for an opinion that the case was hypothetical” and hence nonjusticiable. And when the nine justices convened on Friday morning, March 3, to discuss and vote on "), _c('i', [_vm._v("Poe")]), _vm._v(" v. "), _c('i', [_vm._v("Ullman")]), _vm._v(" and the other cases that had been argued earlier that week, the journalists’ prognostication proved all too prophetic."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-75",
      "id": "ch03-075-75",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Chief Justice Earl Warren presided at each of the Court’s private conferences and spoke first. PPLC’s Bea Hessel had thought during the oral argument that the white-haired Chief Justice had “the mien of a loving father,” and his warm manner and kind-hearted nature made "), _c('a', {
    attrs: {
      "id": "page_181"
    }
  }, [_vm._v("him a popular figure among most of his brethren and among law clerks and court employees. Many of his clerks across the years appreciated that the Chief Justice was very much a family man and a traditionalist, someone who was discomforted not only by the pornographic materials which the court often had to review in obscenity cases but also by any discussion concerning sex. Some of the clerks would acknowledge as well the Chief’s relative disinterest in doctrinal technicalities, but clerks who watched carefully also noted Warren’s long private visits to Justice Brennan’s chambers the day before each of the Court’s weekly conferences.")])]), _c('a', {
    attrs: {
      "id": "page_181"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Warren began the discussion of "), _c('i', [_vm._v("Poe")]), _vm._v(" v. "), _c('i', [_vm._v("Ullman")]), _vm._v(" by observing that he could not call the Connecticut statute unconstitutional on its face, for to do so would represent a return to the largely abandoned doctrine of substantive due process. Just as importantly, the plaintiffs had made the justices “guinea pigs for an abstract principle,” and Warren did not want the Court to decide “contrived litigation” when contraceptives could be purchased in any Connecticut drugstore and where there was no indication that the 1879 statute had ever or would ever be enforced. In short, "), _c('i', [_vm._v("Poe")]), _vm._v(" might well fail to meet the constitutional requirement that the Court decide only real “cases or controversies.” Additionally, there were undeniable problems with the record: could a doctor be convicted under the accessory statute without proof of a patient’s use of a contraceptive, and was or was not the sale of such articles in Connecticut actually legal. Harper and PPFA’s medical evidence was in no way dispositive, and, all in all, whether or not the 1879 statute was unconstitutional as applied could be determined only after a trial had generated extensive evidence and findings. In short, the Chief would vote to dismiss the appeal and return "), _c('i', [_vm._v("Poe")]), _vm._v(" to the Connecticut courts.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_181"
    }
  }, [_vm._v("The most senior associate justice, Hugo L. Black, spoke next. An Alabama native and former U.S. Senator, Black was an enthusiastic tennis player who deeply enjoyed serving on the court. Blessed with an encyclopedic memory and deeply committed to a literalist judicial philosophy that lent both a consistency and a predictability to his votes, Black relied less upon his two law clerks for help in drafting opinions than perhaps any other member of the court. An outgoing man who was not shy about trying to persuade his colleagues to support his own intense views, Black nonetheless believed that philosophical differences should not interfere with friendly relations. His years of disagreements with Frankfurter had created some “real distance” between the two men, but when a clerk once referred to the other justice as “Felix,” Black firmly reprimanded him for such implicit disrespect. ")]), _c('a', {
    attrs: {
      "id": "page_182"
    }
  }, [_vm._v("Black was generally viewed as a liberal, but his closest friend on the court was the patrician John Harlan, whom many observers pigeonholed as a colorless conservative. Black like Warren was something of a prude on sexual matters, and while some clerks had ambivalent if not critical feelings about the justices for whom they worked, Black’s almost always felt that their justice was a wonderful man with an almost fatherly interest in furthering their appreciation of the law.")])]), _c('a', {
    attrs: {
      "id": "page_182"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("On "), _c('i', [_vm._v("Poe")]), _vm._v(" v. "), _c('i', [_vm._v("Ullman")]), _vm._v(", Black began by noting that ten months earlier he had voted to affirm the Connecticut court without hearing the appeal. He still felt that way with regard to the Poes and Jane Doe, Black explained, because it was not appropriate for the judiciary to review the reasonableness of Connecticut’s policy against any use of contraceptives. Personally, Black volunteered, it made no difference to him whether people used such devices, but the Court should not use the Fourteenth Amendment’s due process clause as a vehicle for second-guessing legislative choices on a topic where the Constitution set forth no explicit barrier. Regarding Dr. Buxton, however, Black felt very differently, for a doctor was entitled under the First Amendment to "), _c('i', [_vm._v("talk")]), _vm._v(" to his patients about everything or anything without any statutory interference or punishment. Black’s absolutist view of the First Amendment’s protection of speech was well known and well understood by his brethren, and his explanation that no doctor could be prosecuted as an “aider and abettor” did not surprise any of his colleagues. With regard to “the ladies,” however, Black would affirm.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The third justice to speak was the redoubtable Felix Frankfurter. An intense proponent of his views, especially with regard to the indispensable need for judicial restraint, Frankfurter’s stubborn persistence had visibly alienated both Warren and Brennan. Never close to Black, some clerks also believed that Frankfurter was barely on speaking terms with William O. Douglas. Frankfurter’s own clerks, with only a rare exception, were—like Brennan’s—selected for him by Harvard law professor Paul Freund, but Frankfurter regarded every clerk in the court as a potential recruit and never hesitated to discuss substantive issues with other justices’ clerks. Some clerks viewed Frankfurter as a troublesome “busybody” or “perverse character” who was sometimes openly “patronizing” toward one or another of his less-gifted brethren, but more than two decades of service on the Court had done nothing to dilute Frankfurter’s intellectual intensity or personal aggressiveness.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_182"
    }
  }, [_vm._v("On "), _c('i', [_vm._v("Poe")]), _vm._v(", Frankfurter’s remarks in conference followed naturally from his persistent queries during the oral argument. The Chief Justice was correct that the appeal should be dismissed, Frankfurter began, for ")]), _c('a', {
    attrs: {
      "id": "page_183"
    }
  }, [_vm._v("to reach the merits in this sort of a declaratory judgment action with such a minimal record would run the risk of issuing an improper, advisory opinion. He could not imagine, Frankfurter went on, any doctor not giving contraceptive advice for fear of going to jail; what the plaintiffs clearly wanted was authorization to open clinics. Instead they should take the risk of going to jail and then bring the case to the Supreme Court if they were actually prosecuted. Additionally, Frankfurter said, how could this Court simply rule that “rhythm” was no good?")])]), _c('a', {
    attrs: {
      "id": "page_183"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The next most senior justice, William O. Douglas, went after Frankfurter with alacrity. Indeed, he had been battling angrily with Frankfurter, among others, for all of his more than twenty years on the high court. Acknowledged as truly brilliant even by those who personally detested him, Douglas nonetheless was viewed as an intellectually lazy underachiever even by those who considered themselves his relative friends. Far and away the most reclusive and aloof of the justices, Douglas would never lobby any of his colleagues for support in a case and often would not even say hello to clerks whom he passed in the hallways. Only Douglas had one rather than two clerks, and almost without exception Douglas would scrawl out the first—and sometimes the only—draft of an opinion on a legal pad without any preparatory work by the clerk. Some years Douglas would hector the young man, others he would all but ignore him; among clerks from other chambers the almost unanimous impression was that William O. Douglas was “not a very nice human being.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Frankfurter, Douglas bluntly declared, was wrong on all counts. "), _c('i', [_vm._v("Poe")]), _vm._v(" was a legitimate declaratory judgment action, and undeniably involved a valid case and controversy. Moreover, the 1879 Connecticut statute was clearly unconstitutional on its face. The appeal should not be dismissed, and the Connecticut court’s decision should be reversed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Tom C. Clark, the fifth justice to speak, was a Texan who had been Harry Truman’s Attorney General before being nominated and confirmed as a justice despite Fowler Harper’s 1949 testimony against him. Personally popular among his colleagues and among the clerks, Clark was viewed by many of the clerks as “a wonderful politician” who was miscast as a Supreme Court justice. Some clerks judged him to be “by far the weakest intellect on the Court,” but he nonetheless was often a crucial swing vote, and he was on especially good terms with the similarly personable Warren. On "), _c('i', [_vm._v("Poe")]), _vm._v(", Clark’s comments were simple and highly succinct: the suit did not meet the constitutional case or controversy requirement, and the appeal should be dismissed.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_183"
    }
  }), _c('a', {
    attrs: {
      "id": "page_184"
    }
  }, [_vm._v("Next came John Marshall Harlan, the conservative and understated New Yorker who nine years earlier, while still in private practice, had been recommended to PPLC as a possible attorney for a declaratory judgment action. A justice for six years now, he was both a careful craftsman and a consistent yet thoughtful conservative—“a Frankfurter without the mustard,” one clerk from another chambers quipped. Among the clerks, Harlan was perhaps the most respected justice of all, and he was personally close to both Frankfurter and the court’s most junior member, Potter Stewart.")])]), _c('a', {
    attrs: {
      "id": "page_184"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“We have no business dismissing these cases,” Harlan began. The suits were not fictitious or feigned, they met the case or controversy standard, and there was no uncertainty as to how the Connecticut court had construed the 1879 law: it prohibited the contraceptive practices that the women plaintiffs had been told by their doctor were imperative. On the merits, Harlan said, it was not a close call: the statute was unconstitutional on its face, and indeed was “the most egregiously unconstitutional act I have seen since being on the Court.” For someone of John Harlan’s quiet and sober style, such a forceful and passionate statement was extremely unusual. The oral argument, Harlan went on, had submerged the real constitutional questions. He could not, like Black, vote to strike the Connecticut law on First Amendment grounds, but for him the Fourteenth Amendment’s due process clause, protecting “life, liberty, or property,” against state action, had substantive content apart from the specific provisions of the first eight amendments that the Court sometimes had “incorporated” to apply to the states through the language of the Fourteenth. And due process liberty, Harlan continued, protected “the right to be let alone.” Despite states’ broad powers to legislate in the area of health, the due process clause imposed limits, and a state could not use any and all means to regulate marital relations. The Connecticut law, he reminded his colleagues, was a “use” statute and as such was uniquely different from laws regulating the sale or prescription of such articles. Nothing could be more offensive to the concept of a “right to be let alone” than interjecting the criminal law into the privacy of the marital relationship. Police officers should not be able to get a search warrant to see if contraceptives could be found, and all other searches would pale in comparison to those that could follow from the Connecticut law. No matter what kind of record this case might have, the statute was unconstitutional on its face.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_184"
    }
  }, [_vm._v("Justice William J. Brennan, the Court’s only Roman Catholic member, had already told his two clerks, Richard Arnold and Dan Rezneck, ")]), _c('a', {
    attrs: {
      "id": "page_185"
    }
  }, [_vm._v("after the oral argument that he was definitely inclined to agree with what appeared to be the majority of his colleagues—and Arnold’s earlier recommendation—that "), _c('i', [_vm._v("Poe")]), _vm._v(" v. "), _c('i', [_vm._v("Ullman")]), _vm._v(" should be dismissed for failure to state an adequate controversy or to present a full and detailed record. They and other clerks were well aware of Brennan’s special closeness to the Chief Justice, and Brennan’s warm and approachable demeanor made him, like Tom Clark and Warren, one of the Court’s most personable and popular justices. Generally a quiet figure at oral arguments, Brennan’s remarks about "), _c('i', [_vm._v("Poe")]), _vm._v(" at the Friday conference were brief and succinct: it simply failed to meet the case or controversy standard.")])]), _c('a', {
    attrs: {
      "id": "page_185"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Charles E. Whittaker similarly had little to say. A justice for four years, Whittaker had been a Kansas City corporate attorney before being named to the federal bench, and then elevated to the Supreme Court, largely because of his close friendship with the president’s brother, Arthur Eisenhower. His own clerks viewed Whittaker as a quiet and “extremely conscientious man” who unfortunately was quite uncomfortable with and hence very indecisive about many constitutional questions. As a result, he had become a particular target of Felix Frankfurter’s incessant lobbying, and a wide range of clerks who had witnessed Frankfurter’s behavior toward the insecure Kansan felt that the situation was unpleasant and offensive. Whittaker’s chambers were next to those of Hugo Black, and while Black too would energetically woo him, Whittaker’s clerks thought that Black came as close to being Whittaker’s friend as anyone on the court. Black’s clerks watched with particular chagrin as Frankfurter “hounded and hounded” the neighboring justice, and when an unnerved Whittaker finally gave up and resigned from the Court a year later, more than one clerk readily concluded that Frankfurter unintentionally had “chased poor Whittaker off the Court.” But for "), _c('i', [_vm._v("Poe")]), _vm._v(" v. "), _c('i', [_vm._v("Ullman")]), _vm._v(", Whittaker said, Frankfurter was indeed correct: "), _c('i', [_vm._v("Poe")]), _vm._v(" did not satisfy the case or controversy requirement.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The Court’s ninth and most junior member was Potter Stewart, a forty-six-year-old Ohio Republican who was in only his third year as a justice. Already close to John Harlan, whose chambers were right next door, Stewart too was a moderate conservative with a clear attraction to issues of jurisdiction and procedure. Although he never failed to win the respect of his own clerks, in other chambers during Stewart’s early years on the high court many of the young assistants viewed him as something of a cipher.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_185"
    }
  }, [_vm._v("On "), _c('i', [_vm._v("Poe")]), _vm._v(", Stewart’s comments echoed those of Harlan. It would be “cynical,” he remarked, “to dismiss a case on the grounds that a law will not be enforced. A law is a law, and it is not a dead letter,” ")]), _c('a', {
    attrs: {
      "id": "page_186"
    }
  }, [_vm._v("especially when “as a practical matter there’s no clinic in Connecticut.” On the constitutional merits, Stewart said, he also fully agreed with John Harlan.")])]), _c('a', {
    attrs: {
      "id": "page_186"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_186"
    }
  }, [_vm._v("The discussion concluded, the tally was relatively clear: there were at least five clear votes—Warren, Frankfurter, Clark, Brennan, and Whittaker—for dismissing the appeals, and only three justices—Douglas, Harlan, and Stewart—who would reverse the Connecticut court and void the statute. Hugo Black apparently could be counted as a sixth vote for the majority in "), _c('i', [_vm._v("Poe")]), _vm._v(", but certainly not in "), _c('i', [_vm._v("Buxton")]), _vm._v(". Early Monday morning, three days later, when the Chief Justice’s assignment sheet was circulated to all chambers, the opinion for the Court in "), _c('i', [_vm._v("Poe")]), _vm._v(" v. "), _c('i', [_vm._v("Ullman")]), _vm._v(" was assigned to the justice who had almost recused himself: Felix Frankfurter."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-76",
      "id": "ch03-076-76",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Before the day was out, Frankfurter had jotted down a short but internally complex outline of how he wanted his clerks to go about drafting a "), _c('i', [_vm._v("Poe")]), _vm._v(" v. "), _c('i', [_vm._v("Ullman")]), _vm._v(" opinion, emphasizing that there should be a comprehensive canvassing of prior decisions in which the Court had similarly declined to reach the merits of a case that had been appealed. Frankfurter perchance had three clerks, rather than the usual two, for the 1960–1961 term, and that relative luxury offered him an opportunity that he chose to take full advantage of with "), _c('i', [_vm._v("Poe")]), _vm._v(": he gave his brief memo to both Dan Mayers, a Harvard Law School graduate who had been chosen for him by Paul Freund, and to Anthony “Tony” Amsterdam, a University of Pennsylvania Law School graduate and the special third clerk whom Frankfurter had taken on because of truly exceptional reports that Amsterdam was as brilliant a law student as anyone anywhere had seen in some time. Frankfurter’s instructions to Mayer and Amsterdam were unusual but not wholly out of character: "), _c('i', [_vm._v("both")]), _vm._v(" of them should work on preparing "), _c('i', [_vm._v("separate")]), _vm._v(" drafts of a "), _c('i', [_vm._v("Poe")]), _vm._v(" opinion in line with his framework, and, until the first of them had finished, they should "), _c('i', [_vm._v("not")]), _vm._v(" share or discuss their work with each other or with their third colleague, John French."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-77",
      "id": "ch03-077-77",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At much the same time that Felix Frankfurter was outlining "), _c('i', [_vm._v("Poe")]), _vm._v("’s demise, Fowler Harper was pondering how the Court’s obvious doubts about whether there actually was any realistic threat that the Connecticut statute would be enforced against anyone, doubts that had been so manifest in the repeated questions voiced during the oral argument, might be refuted and disproved. Remembering that the last reported effort to enforce the 1879 law was of course "), _c('i', [_vm._v("State")]), _vm._v(" v. "), _c('i', [_vm._v("Nelson")]), _vm._v(", and knowing that the very same William B. Fitzgerald who had prosecuted "), _c('i', [_vm._v("Nelson")]), _vm._v(" was still, twenty-one years later, the State’s Attorney at "), _c('a', {
    attrs: {
      "id": "page_187"
    }
  }, [_vm._v("Waterbury, Fowler Harper had an idea. He picked up the phone and called J. Warren Upson, who also, like his longtime friend Bill Fitzgerald, was still a leading figure on the Waterbury legal scene. Now fifty-seven years old, Warren Upson had been out of touch with the PPLC for over a decade, but he was immediately willing to try to help with Fowler Harper’s request: would Bill Fitzgerald be willing to execute a formal affidavit affirming that now, in 1961, he would pursue enforcement of the 1879 statute against any birth control clinic just as he had back in 1939–1940?")])]), _c('a', {
    attrs: {
      "id": "page_187"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_187"
    }
  }, [_vm._v("Wednesday, March 8, Warren Upson had “a long conference” with Bill Fitzgerald about their long-ago settlement of "), _c('i', [_vm._v("State")]), _vm._v(" v. "), _c('i', [_vm._v("Nelson")]), _vm._v(" two decades earlier, and while Fitzgerald affirmed that his position remained unchanged from what he had said in his formal statement in court on the day that the criminal charges against Clara McTernan and the two young doctors had been nolled, Fitzgerald nonetheless was unwilling to execute an affidavit for Fowler Harper to send along to the United States Supreme Court. Mulling the alternatives, Warren Upson selected the next best option: he unearthed a three-page copy of the court reporter’s transcript of Fitzgerald’s remarks back on April 2, 1940, and executed his own affidavit. He identified himself as counsel for the "), _c('i', [_vm._v("Nelson")]), _vm._v(" defendants and affirmed that the 1939 charges “were instituted in no sense with the prior knowledge of the accused and there was no pre-trial acquiescence by the accused that said actions would be instituted to test the constitutionality of the statutes in question.” He immediately sent both documents off to Harper, who in turn sent them at once to the Supreme Court for formal consideration. Chief Justice Warren alerted Frankfurter to the submission, and they both agreed that it should not be made an official part of the record or circulated to all nine chambers. But Frankfurter read both Upson’s affidavit and Fitzgerald’s 1940 declaration that “any person” who violated the 1879 statute “must expect to be prosecuted and punished in accordance with the literal provisions of the law,” and contemplated what if anything he should do about the apparent contradiction between this evidence of prosecutorial intent and the Court’s forthcoming decision that "), _c('i', [_vm._v("Poe")]), _vm._v(" should be dismissed because of the absence of any credible evidence that the patients or Dr. Buxton faced any tangible threat that the old law would be enforced against them. Even Frankfurter’s most supportive clerks realized that their justice was “such a rash character” that at times his actions could surprise anyone, but when Bill Fitzgerald picked up the phone and an unfamiliar voice introduced himself as Felix Frankfurter, the state’s attorney for a ")]), _c('a', {
    attrs: {
      "id": "page_188"
    }
  }, [_vm._v("moment wondered if someone was pulling his leg. But Frankfurter was Frankfurter, and as a “quite stunned” Fitzgerald subsequently related to his family, the justice wanted to talk about "), _c('i', [_vm._v("State")]), _vm._v(" v. "), _c('i', [_vm._v("Nelson")]), _vm._v(". Precisely what was said in the “pretty extraordinary” conversation was not recorded by either party, but whatever transpired did not alter Felix Frankfurter’s conviction that the legacy of "), _c('i', [_vm._v("State")]), _vm._v(" v. "), _c('i', [_vm._v("Nelson")]), _vm._v(" represented no barrier to the U.S. Supreme Court dismissing "), _c('i', [_vm._v("Poe")]), _vm._v(" v. "), _c('i', [_vm._v("Ullman")]), _vm._v(" on the grounds that no immediate threat of prosecution faced the "), _c('i', [_vm._v("Poe")]), _vm._v(" plaintiffs."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-78",
      "id": "ch03-078-78",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fortunately or unfortunately, however, neither Felix Frankfurter nor Fowler Harper kept up with the "), _c('i', [_vm._v("Wallingford Post")]), _vm._v(" or ever happened to hear of Thomas Coccomo. Forty years old and a resident of Deep River, Connecticut, Mr. Coccomo’s 1961 endeavors included a modest, wholesale effort to furnish contraceptive articles—condoms—to gas station operators interested in offering such items to retail customers. On March 3, 1961—the very same day that the nine justices of the U.S. Supreme Court were privately voting to dismiss "), _c('i', [_vm._v("Poe")]), _vm._v(" v. "), _c('i', [_vm._v("Ullman")]), _vm._v(" on the grounds that there was no evidence that the 1879 Connecticut anticontraception was ever enforced against anyone—Mr. Coccomo’s vocation took him to several service stations in North Haven, Connecticut. Someone apparently complained about his toils, for at one station his sales pitch was interrupted by Lieutenant Walter Berniere and Sergeant Thomas Nerreau of the North Haven police. They ascertained that Mr. Coccomo had approximately a hundred dollars’ worth of contraceptive articles in his car, and they promptly seized his merchandise and arrested him for violating the aiding and abetting portion of the 1879 statute.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Mr. Coccomo retained legal counsel, and four weeks after his arrest appeared in Wallingford Circuit Court before Judge John Daly. The prosecutor indicated that an agreement had been reached: Mr. Coccomo would plead guilty, and only a modest fine would be recommended as punishment in light of the fact that the constitutionality of the statute was under review by the U.S. Supreme Court. Coccomo’s attorney stated that he believed the maximum possible fine was fifty dollars, but Judge Daly disregarded his comment and imposed a penalty of seventy-five dollars. The North Haven Police Department would be instructed to burn all of the seized condoms. For better or for worse, Mr. Coccomo’s criminal conviction—and the "), _c('i', [_vm._v("Wallingford Post")]), _vm._v("’s front-page coverage of it—never entered into the Supreme Court’s consideration of whether "), _c('i', [_vm._v("Poe")]), _vm._v(" v. "), _c('i', [_vm._v("Ullman")]), _vm._v(" was anything more than an academic challenge to an unenforced statute."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-79",
      "id": "ch03-079-79",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_189"
    }
  }, [_vm._v("While Felix Frankfurter’s clerks set to work on a majority opinion for "), _c('i', [_vm._v("Poe")]), _vm._v(" v. "), _c('i', [_vm._v("Ullman")]), _vm._v(", Fowler Harper and PPLC waited patiently for a decision that they expected would be announced sometime in late May or early to mid-June. Harper submitted a jurisdictional statement for "), _c('i', [_vm._v("Trubek")]), _vm._v(" v. "), _c('i', [_vm._v("Ullman")]), _vm._v(" to the high court that largely copied his earlier arguments in "), _c('i', [_vm._v("Poe")]), _vm._v(", and PPLC made modest preparations for an April 12 legislative hearing on its 1961 repeal bill. Joseph Cooney chose to submit simply a written statement of opposition on behalf of the Connecticut Catholic hierarchy, and in the absence of any actual opponents, the 1961 hearing was a relatively brief and low-key affair. The principal affirmative witness, David Leventhal of the CCLU, devoted most of his remarks to emphasizing that the right to privacy was “perhaps "), _c('i', [_vm._v("the")]), _vm._v(" primary right guaranteed to the people of this state under the Constitution,” but committee chairman William F. Hickey told the hearing that his panel would “hold off action as long as possible” on the bill in anticipation that the U.S. Supreme Court might very well resolve the problem once and for all. Two weeks later the Public Health and Safety Committee approved the repeal bill, but proponents, knowing that the measure had no chance of passage in the state senate, simply left it on the calendar for the remainder of the legislative session rather than bring it up for a floor vote even in the house."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-80",
      "id": "ch03-080-80",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Estelle Griswold, like Fowler Harper, was not at all sure what the Supreme Court’s decision would be, but by mid-May she was certain of something else: that if the Court were to rule against PPLC and dismiss "), _c('i', [_vm._v("Poe")]), _vm._v(" v. "), _c('i', [_vm._v("Ullman")]), _vm._v(", the Connecticut League would move as quickly as possible to ignore and defy the old statute by openly offering some form of birth control services. PPLC had some sixty thousand dollars on hand to finance the opening of a clinic, especially should the law indeed be struck down, and Estelle discussed the possibilities with both outgoing president Bea Hessel and her incoming successor, Lucia Parks of Southport, whose PPLC involvement went back to the Hepburn era when she had worked as a volunteer at the Bridgeport clinic in 1938. At PPLC’s annual meeting on May 24, with everyone crossing their fingers in anticipation of a Supreme Court ruling that might well come any day, Fowler Harper spoke optimistically about their prospects and read from a hilarious forthcoming student essay that parodied the Connecticut law by analyzing how pet owners might be arrested if they utilized a new oral contraceptive that recently had been developed for animals. More seriously, Harper told the PPLCers that if the Supreme Court did rule against them, their principal challenge might then become finding a way to get Estelle Griswold jailed."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-81",
      "id": "ch03-081-81",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_190"
    }
  }, [_vm._v("It was not until June 3, three full months after the conference discussion that had decided "), _c('i', [_vm._v("Poe")]), _vm._v(" v. "), _c('i', [_vm._v("Ullman")]), _vm._v(", that Felix Frankfurter finally circulated to his colleagues a printed draft of an opinion for the Court. Both Dan Mayers and Tony Amsterdam had each prepared several successive drafts of a modest-sized opinion, and in the end Frankfurter chose to work from Amsterdam’s version, revising and modifying Amsterdam’s draft to a significant but not overwhelming extent. As soon as the Frankfurter opinion was distributed, John Harlan immediately sent a note to all his fellow justices notifying them that he would circulate a dissenting opinion “very shortly.” Harlan had been away from the Court for several weeks since the conference discussion of "), _c('i', [_vm._v("Poe")]), _vm._v(", undergoing surgery for a stomach ulcer, and he had turned over responsibility for preparing the opinion to one of his two clerks, Charles Fried. Harlan had orally instructed Fried to draft a dissent that stated that "), _c('i', [_vm._v("Poe")]), _vm._v(" was indeed justiciable, and while he said relatively little to his clerk about how, or at what length, to address the constitutional merits, both Fried and his coclerk, Philip Heymann, had heard the justice voice his outrage at the invasion of marital privacy that the Connecticut statute represented, and Fried knew full well that Harlan more than agreed with the enthusiastic advocacy of constitutional protection for marital privacy in the home that Fried had offered two months earlier in his initial memo on "), _c('i', [_vm._v("Poe")]), _vm._v(". Hence in Harlan’s absence Fried prepared a sixty-page typescript draft of an opinion that spoke both to the appeal’s justiciability and, at some length, to the plaintiffs’ constitutionally protected marital privacy. When Harlan returned from his hospitalization Fried waited curiously to see whether the justice would feel that he had gone too far. Little was said about it—“we didn’t have a lot of discussion,” Fried remembered thirty years later—but Harlan clearly liked the draft, and gave it only a modest pencil editing before sending it to the Court’s print shop and then, on June 14, to all of his eight colleagues."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-82",
      "id": "ch03-082-82",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Fried’s fellow clerks in other chambers were in many cases both impressed and more than a little amazed by the dissent that Justice Harlan circulated. Generally not privy, except in some chambers at second hand, to the comments that justices uttered in the court’s private conferences, Fried’s colleagues had heard neither Harlan’s passionate conference comments on "), _c('i', [_vm._v("Poe")]), _vm._v(" nor the similarly vociferous remarks that the justice had made to his own clerks. Some of them hence viewed Harlan’s strong denunciation of the Connecticut law as a constitutionally offensive violation of marital privacy and liberty as distinctly out of character for such a conservative and solemn justice. A few, such as Brennan clerk Richard Arnold, who would often give Fried a ride to "), _c('a', {
    attrs: {
      "id": "page_191"
    }
  }, [_vm._v("work in the mornings, already knew secondhand how strongly Harlan felt, but for many others the tone and content of the Harlan dissent came as quite a surprise. Virtually all of the clerks ate lunch together almost every day, and after ten months of close companionship the group had reached a clear consensus as to who were the undeniable intellectual stars—Amsterdam, Arnold, and Fried—and also knew their friends’ predilections and styles. Hence when the Harlan dissent was circulated and read, “Everyone knew it was Charles,” one colleague explained years later."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-83",
      "id": "ch03-083-83",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The same day that Harlan’s dissent circulated, a similar but considerably shorter one by William O. Douglas was also distributed to all chambers. Douglas usually prepared his dissents very soon after the initial conference, and this one had been ready for internal dissemination since late March. Douglas was also well-known for being extremely eager that the Court adjourn as early in May or June as was possible so that he could leave Washington, D.C., for his summer home in rural Washington state. On two recent mornings in succession the usually standoffish Douglas had sat down in the Court cafeteria beside a clerk from another chambers to whom he had never before spoken and asked the slightly startled young man, “When do you think we’ll get out of here?” The clerk had twice mumbled noncommittal responses, wondering the second day whether Douglas even realized he was reenacting the previous morning’s conversation. Then Douglas each time had launched into a soliloquy on how splendid the schedule had been in the late 1930s, when Douglas first came on the Court, and Charles Evans Hughes saw to it that they were done by Memorial Day. “Now there was a Chief Justice!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Douglas’s dissent in "), _c('i', [_vm._v("Poe")]), _vm._v(" was more thorough and carefully crafted than many Douglas opinions, and on the evening of June 13 Douglas had told fellow justice William J. Brennan that he would circulate it the following day. Two months earlier Brennan had sounded like a firm member of what appeared to be a five-vote Frankfurter majority, but now he was uncertain, and on the thirteenth and fourteenth he made that clear both to Douglas and to his own clerks. He indicated to Douglas that he might well choose to join Douglas’s own dissent, but Douglas, rather than welcoming and encouraging Brennan’s new inclination, instead warned him that such a shift would cause a serious problem: so far only two members of Frankfurter’s ostensible majority, Clark and Whittaker, had formally joined the opinion, and if either Brennan and/or Chief Justice Warren failed to go with Frankfurter, the absence of a fifth vote—in the context of Justice Black’s unique "), _c('a', {
    attrs: {
      "id": "page_192"
    }
  }, [_vm._v("stance—would leave the Court without any clear majority for deciding "), _c('i', [_vm._v("Poe")]), _vm._v(". Most importantly, Douglas noted, if they got tied up in any extensive reconsideration of "), _c('i', [_vm._v("Poe")]), _vm._v(", the hope of concluding the term next Monday, June 19, could very well be endangered. Hence it would be better, Douglas told Brennan, for him to ‘stick with Felix so we can get this case decided and get out of here.’"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-84",
      "id": "ch03-084-84",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Other cases too—particularly a 5 to 4 Fourth Amendment search and seizure decision that was being written by Justice Clark, "), _c('i', [_vm._v("Mapp")]), _vm._v(" v. "), _c('i', [_vm._v("Ohio")]), _vm._v(", were also scheduled for final ratification at a Friday conference and announcement on Monday the 19th, but throughout Wednesday the 14th and Thursday the 15th, Brennan remained undecided about "), _c('i', [_vm._v("Poe")]), _vm._v(", pondering whether he might prepare a small separate concurrence of his own rather than join either Frankfurter or Douglas. Hence the question of whether there would be a majority disposition of "), _c('i', [_vm._v("Poe")]), _vm._v(" remained highly uncertain, and on Thursday Frankfurter circulated a very slightly revised version of his previous draft. He pointed out to his colleagues in a cover letter that at two places in the opinion he had added sentences strengthening the decision’s reliance on the fact that no prosecutions under the statute had ever been pursued and that there were no indications that the law presently was being enforced against anyone.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The other uncertain member of the tentative Frankfurter majority was Earl Warren. The Chief Justice had not been fully persuaded by the initial version of Frankfurter’s opinion, and even the Thursday emendations had not completely eliminated his discomfort. He told his clerks that “I just hate to strike down any law that’s passed in the name of the public interest,” and while it seemed unlikely that he could imaginably join either Harlan or Douglas, heading into the Court’s final conference of the term neither Earl Warren nor Bill Brennan had firmly decided what they would do with "), _c('i', [_vm._v("Poe")]), _vm._v(" v. "), _c('i', [_vm._v("Ullman")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Friday morning in advance of that final conference Brennan instructed his clerk Richard Arnold to draft a brief separate concurrence, endorsing the dismissal of "), _c('i', [_vm._v("Poe")]), _vm._v(" on the grounds that the real Connecticut dispute concerned clinics, for Brennan to review right after the meeting. Then, once the conference was underway, Brennan just before eleven thirty a.m. sent out a note informing Arnold that the term was indeed going to conclude on Monday, that he "), _c('i', [_vm._v("was")]), _vm._v(" going to join in the dismissal of "), _c('i', [_vm._v("Poe")]), _vm._v(" by means of a separate concurrence, which he had promised his colleagues would be circulated before the end of the day, and that Arnold immediately should prepare a draft. Arnold sat down and did just that, and within a half hour sent in to Brennan for "), _c('a', {
    attrs: {
      "id": "page_193"
    }
  }, [_vm._v("his approval a five-sentence statement of Brennan’s views. Five minutes later Brennan sent out another note informing Arnold that his draft was fine and that it should be typed up and then distributed to all chambers.")])]), _c('a', {
    attrs: {
      "id": "page_193"
    }
  }), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_193"
    }
  }, [_vm._v("After the conference concluded, Arnold and other clerks learned the final score: the Chief Justice by the end of the day would join either the Frankfurter opinion or the Brennan concurrence, thus guaranteeing five clear votes for a dismissal of "), _c('i', [_vm._v("Poe")]), _vm._v(". Justice Black would be recorded as dissenting without opinion. By the end of the afternoon Justice Stewart, the other dissenter, circulated a three-sentence statement that hinted, but did not expressly state, that he shared the views of both Harlan and Douglas. Also late in the afternoon Earl Warren, at the urging of at least one of his clerks, sent Felix Frankfurter a two-word note—“I agree”—indicating that he would join Frankfurter rather than Brennan. The conference had similarly decided that the appeal in "), _c('i', [_vm._v("Trubek")]), _vm._v(" v. "), _c('i', [_vm._v("Ullman")]), _vm._v(" would also be dismissed, with Justices Douglas, Harlan, and Stewart in disagreement. Privately but perhaps most notably of all, Justice Brennan in recounting the conference to his clerks firmly revealed that were he actually to reach the merits in "), _c('i', [_vm._v("Poe")]), _vm._v(", he definitely could not vote to affirm the decision below and would instead vote to void the statute as applied. Thus by only the tiniest of margins had "), _c('i', [_vm._v("Poe")]), _vm._v(" v. "), _c('i', [_vm._v("Ullman")]), _vm._v("—and PPLC—come up one vote shy of convincing the United States Supreme Court that P. T. Barnum’s long-lived 1879 criminalization of birth control should finally be held constitutionally void."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-85",
      "id": "ch03-085-85",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85")])]), _vm._v(" "), _c('p', {
    staticClass: "normal2"
  }, [_vm._v("On Monday morning, June 19, the Supreme Court formally handed down its 5 to 4 dismissal of "), _c('i', [_vm._v("Poe")]), _vm._v(" v. "), _c('i', [_vm._v("Ullman")]), _vm._v(". The final version of the Frankfurter opinion that commanded only four votes came to just eleven small pages in print. It emphasized the “lack of immediacy” of any threat of prosecution, called the "), _c('i', [_vm._v("Poe")]), _vm._v(" challenge “abstract,” and brushed aside "), _c('i', [_vm._v("Nelson")]), _vm._v(" as a “test case.” “Neither counsel nor our own researches have discovered any other attempt to enforce” the 1879 law, and this “undeviating policy of nullification” of the old statute highlighted the “unreality” of the "), _c('i', [_vm._v("Poe, Doe")]), _vm._v(", and "), _c('i', [_vm._v("Buxton")]), _vm._v(" lawsuits. “Federal judicial power,” Frankfurter emphasized, “is to be exercised to strike down legislation … only at the instance of one who is himself immediately harmed, or immediately threatened with harm, by the challenged” law. Where there was no “realistic fear of prosecution,” Frankfurter concluded, “[t]his Court cannot be umpire to debates concerning harmless, empty shadows.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-86",
      "id": "ch03-086-86",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_194"
    }
  }, [_vm._v("William Brennan’s brief concurrence was simple and straightforward. The "), _c('i', [_vm._v("Poe")]), _vm._v(" appeal, he said, failed to present “a real and substantial controversy” and was based upon a “skimpy record.” He was unconvinced that the individual plaintiffs actually faced any real dilemma; the “true controversy” in Connecticut was instead “over the opening of birth-control clinics on a large scale.” Unless by some chance the state of Connecticut actually did make “a definite and concrete threat to enforce these laws against individual married couples,” the Court could “decide the constitutional questions urged upon us when, if ever, that real controversy” over the opening of clinics “flares up again.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-87",
      "id": "ch03-087-87",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Beyond the very brief indications of dissent filed by Justices Black and Stewart,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-88",
      "id": "ch03-088-88",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88")])]), _vm._v(" both William O. Douglas and John M. Harlan filed significant dissenting opinions. Douglas rebutted Frankfurter’s characterization of "), _c('i', [_vm._v("Nelson")]), _vm._v(" as simply a “test case,” invoked the First Amendment on behalf of Buxton, and concluded that the Fourteenth Amendment liberty rights of the “Poes” were undeniably violated by the 1879 statute. Privacy was among the components of liberty, and “‘Liberty’ is a conception that sometimes gains content from the emanations of other specific guarantees” in the Constitution “or from experience with the requirements of a free society.” Douglas noted how the Connecticut law “reaches into the intimacies of the marriage relationship,” and how, if enforced, it could “reach the point where search warrants issued and officers appeared in bedrooms to find out what went on.” "), _c('i', [_vm._v("Any")]), _vm._v(" possible enforcement against married couples, Douglas declared, would be “an invasion of the privacy that is implicit in a free society,” a privacy that “emanates from the totality of the constitutional scheme under which we live.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-89",
      "id": "ch03-089-89",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89")])])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("John Marshall Harlan’s dissent was more than twice the length of Douglas’s and three times the size of the Frankfurter opinion. He explained at some length why "), _c('i', [_vm._v("Poe")]), _vm._v(" was indeed justiciable and gave a detailed critique of Frankfurter’s characterization of "), _c('i', [_vm._v("Nelson")]), _vm._v(". Harlan quoted from both the April 1940 Fitzgerald statement and from Warren Upson’s affidavit that Harper had submitted, and also included a long footnote taking issue with the comments that Brennan had offered in his brief concurrence. On the constitutional issues, Harlan minced few words: “a statute making it a criminal offense for "), _c('i', [_vm._v("married couples")]), _vm._v(" to use contraceptives is an intolerable and unjustifiable invasion of privacy in the conduct of the most intimate concerns of an individual’s private life” and hence violated the due process clause of the Fourteenth Amendment. The Constitution’s language clearly indicated that the clause’s protection of “liberty” could not be reduced to any simple "), _c('a', {
    attrs: {
      "id": "page_195"
    }
  }, [_vm._v("definition or formula, Harlan emphasized, but what it shielded was “a freedom from all substantial arbitrary impositions and purposeless restraints.” The Connecticut law intruded upon “the most intimate details of the marital relation” and “allows the State to enquire into, prove and punish married people for the private use of their marital intimacy.” The “privacy of the home in its most basic sense” "), _c('i', [_vm._v("must be")]), _vm._v(" “a most fundamental aspect of ‘liberty,’” and not only within the contours of the Fourth Amendment’s protection against unreasonable searches and seizures. Harlan quoted a long segment from Justice Brandeis’s well-known 1928 espousal of “the right to be let alone,” and asserted that “the Constitution protects the privacy of the home against all unreasonable intrusion of whatever character.” Fourteenth Amendment liberty protected that privacy of the home not as a matter of property rights, but because it was the locus of what a prior decision had once termed “the private realm of family life which the state cannot enter.” “[I]t is difficult to imagine,” Harlan observed, “what is more private or more intimate than a husband and wife’s marital relations.”")])]), _c('a', {
    attrs: {
      "id": "page_195"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("The right of privacy, Harlan acknowledged, “is not an absolute. Thus, I would not suggest that adultery, homosexuality, fornication and incest are immune from criminal enquiry, however privately practiced.” But “the intimacy of husband and wife is necessarily an essential and accepted feature of the institution of marriage, an institution which the State not only must allow, but which always and in every age it has fostered and protected. It is one thing when the State exerts its power either to forbid extramarital sexuality altogether, or to say who may marry, but it is quite another when, having acknowledged a marriage and the intimacies inherent in it, it undertakes to regulate by means of the criminal law the details of that intimacy.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_195"
    }
  }, [_vm._v("All in all, Harlan concluded, “the appellants have presented a very pressing claim for constitutional protection” against the “utter novelty” of Connecticut’s “obnoxiously intrusive” statute. And although Lee Buxton, Estelle Griswold, and Fowler Harper had come up one vote shy in "), _c('i', [_vm._v("Poe")]), _vm._v(" v. "), _c('i', [_vm._v("Ullman")]), _vm._v(", what John Harlan had said in dissent would prepare the way not only for their eventual victory four years later over the legacy of P. T. Barnum, but would open the door as well for a further expansion of the struggle that neither Harlan nor Harper nor even Estelle Griswold had yet envisioned."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/xhtml/notes2#ch03-90",
      "id": "ch03-090-90",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90")])])])])
}]}

/***/ }),
/* 79 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(80),
  /* template */
  __webpack_require__(81),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 82 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(83),
  /* template */
  __webpack_require__(84),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(86),
  /* template */
  __webpack_require__(87),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 88 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(89),
  /* template */
  __webpack_require__(90),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 91 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(92),
  /* template */
  __webpack_require__(93),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(95),
  /* template */
  __webpack_require__(96),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(98),
  /* template */
  __webpack_require__(99),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(101),
  /* template */
  __webpack_require__(102),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 103 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(104),
  /* template */
  __webpack_require__(105),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 106 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(107),
  /* template */
  __webpack_require__(108),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 108 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(110),
  /* template */
  __webpack_require__(111),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 111 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 112 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(113),
  /* template */
  __webpack_require__(114),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 114 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(116),
  /* template */
  __webpack_require__(117),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 117 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(119),
  /* template */
  __webpack_require__(120),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 120 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(122),
  /* template */
  __webpack_require__(123),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 123 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(125),
  /* template */
  __webpack_require__(126),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 126 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(128),
  /* template */
  __webpack_require__(129),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 129 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(131),
  /* template */
  __webpack_require__(132),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 132 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(134),
  /* template */
  __webpack_require__(135),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 135 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(137),
  /* template */
  __webpack_require__(138),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 137 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 138 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(140),
  /* template */
  __webpack_require__(141),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 141 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(143),
  /* template */
  __webpack_require__(144),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 144 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(146),
  /* template */
  __webpack_require__(147),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 147 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(149),
  /* template */
  __webpack_require__(150),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 150 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(152),
  /* template */
  __webpack_require__(153),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 153 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(155),
  /* template */
  __webpack_require__(156),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 156 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("\nThis page is not included in the sample. Please click on any of the store links to buy the book (and access everything) or the social links to recommend it."), _c('br'), _vm._v("\nThank you.\n")])
}]}

/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(158),
  /* template */
  __webpack_require__(159),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'last',
  data: function data() {
    return {};
  },

  components: {}
});

/***/ }),
/* 159 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', [_vm._v("Thank you for reading this sample. Here are other books you might like.")]), _c('div', [_c('div', {
    attrs: {
      "id": "textcafe-gallery-widget-container"
    }
  }), _vm._v(" "), _c('script', {
    attrs: {
      "type": "application/javascript"
    }
  }, [_vm._v("\n      TextCafeWidget.config({\n          'type':'related',\n          'id':'9781504015554',\n          'coverImageWidth': '30',\n          'hideDescriptions': true\n      });\n      var textCafeGalleryWidget = TextCafeWidget.widgets.galleryWidget.new({selector:'#textcafe-gallery-widget-container'});\n      textCafeGalleryWidget.render();\n    ")])])])
}]}

/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["Vuetify"] = factory();
	else
		root["Vuetify"] = factory();
})(this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/dist/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 29);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["d"] = createSimpleFunctional;
/* harmony export (immutable) */ __webpack_exports__["e"] = createSimpleTransition;
/* harmony export (immutable) */ __webpack_exports__["b"] = createJavaScriptTransition;
/* harmony export (immutable) */ __webpack_exports__["f"] = directiveConfig;
/* harmony export (immutable) */ __webpack_exports__["a"] = addOnceEventListener;
/* harmony export (immutable) */ __webpack_exports__["g"] = getObjectValueByPath;
/* harmony export (immutable) */ __webpack_exports__["c"] = createRange;
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function createSimpleFunctional(c) {
  var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'div';

  return {
    functional: true,

    render: function render(h, _ref) {
      var data = _ref.data,
          children = _ref.children;

      data.staticClass = (c + ' ' + (data.staticClass || '')).trim();

      return h(el, data, children);
    }
  };
}

function createSimpleTransition(name) {
  var origin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top center 0';
  var mode = arguments[2];

  return {
    functional: true,

    props: {
      origin: {
        type: String,
        default: origin
      }
    },

    render: function render(h, context) {
      context.data = context.data || {};
      context.data.props = { name: name };
      context.data.on = context.data.on || {};

      if (mode) context.data.props.mode = mode;

      context.data.on.beforeEnter = function (el) {
        el.style.transformOrigin = origin;
        el.style.webkitTransformOrigin = origin;
      };

      return h('transition', context.data, context.children);
    }
  };
}

function createJavaScriptTransition(name, functions) {
  var css = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var mode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'in-out';

  return {
    functional: true,

    props: {
      css: {
        type: Boolean,
        default: css
      },
      mode: {
        type: String,
        default: mode
      }
    },

    render: function render(h, context) {
      var data = {
        props: _extends({}, context.props, {
          name: name
        }),
        on: functions
      };

      return h('transition', data, context.children);
    }
  };
}

function directiveConfig(binding) {
  var defaults = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return Object.assign({}, defaults, binding.modifiers, { value: binding.arg }, binding.value || {});
}

function addOnceEventListener(el, event, cb) {
  var once = function once() {
    cb();
    el.removeEventListener(event, once, false);
  };

  el.addEventListener(event, once, false);
}

function getObjectValueByPath(obj, path) {
  // credit: http://stackoverflow.com/questions/6491463/accessing-nested-javascript-objects-with-string-key#comment55278413_6491621
  if (!path || path.constructor !== String) return;
  path = path.replace(/\[(\w+)\]/g, '.$1'); // convert indexes to properties
  path = path.replace(/^\./, ''); // strip a leading dot
  var a = path.split('.');
  for (var i = 0, n = a.length; i < n; ++i) {
    var k = a[i];
    if (obj instanceof Object && k in obj) {
      obj = obj[k];
    } else {
      return;
    }
  }
  return obj;
}

function createRange(length) {
  return [].concat(_toConsumableArray(Array.from({ length: length }, function (v, k) {
    return k;
  })));
}

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dark: Boolean,
    light: Boolean
  }
});

/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isActive: !!this.value
    };
  },


  props: {
    value: {
      required: false
    }
  },

  watch: {
    value: function value(val) {
      this.isActive = !!val;
    },
    isActive: function isActive(val) {
      !!val !== this.value && this.$emit('input', val);
    }
  }
});

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__ = __webpack_require__(8);



/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_contextualable__["a" /* default */]],

  props: {
    disabled: Boolean,
    fa: Boolean,
    mdi: Boolean,
    large: Boolean,
    left: Boolean,
    medium: Boolean,
    right: Boolean,
    xLarge: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        _ref$children = _ref.children,
        children = _ref$children === undefined ? [] : _ref$children;

    if (props.fa || props.mdi) console.warn('The v-icon prop \'fa\' and \'mdi\' will be deprecated in the next release. Use \'fa\' or \'mdi\' prefix in icon name instead.');
    var iconName = '';
    var iconType = 'material-icons';

    if (children.length) {
      iconName = children.pop().text;
    } else if (data.domProps && data.domProps.textContent) {
      iconName = data.domProps.textContent;
      delete data.domProps.textContent;
    } else if (data.domProps && data.domProps.innerHTML) {
      iconName = data.domProps.innerHTML;
      delete data.domProps.innerHTML;
    }

    var thirdPartyIcon = iconName.indexOf('-') > -1;
    if (thirdPartyIcon) iconType = iconName.slice(0, iconName.indexOf('-'));

    // To keep things backwards compatible for now
    iconType = props.fa ? 'fa' : props.mdi ? 'mdi' : iconType;

    data.staticClass = (iconType + ' icon ' + (data.staticClass || '')).trim();
    data.attrs = data.attrs || {};

    var classes = {
      'icon--large': props.large,
      'icon--left': props.left,
      'icon--medium': props.medium,
      'icon--right': props.right,
      'icon--x-large': props.xLarge,
      'primary--text': props.primary,
      'secondary--text': props.secondary,
      'success--text': props.success,
      'info--text': props.info,
      'warning--text': props.warning,
      'error--text': props.error,
      'theme--dark': props.dark,
      'theme--light': props.light
    };

    var iconClasses = Object.keys(classes).filter(function (k) {
      return classes[k];
    }).join(' ');
    iconClasses && (data.staticClass += ' ' + iconClasses);

    // To keep things backwards compatible for now
    if (props.fa || props.mdi) {
      var comparison = props.fa ? 'fa' : 'mdi';

      if (iconName.indexOf(' ') > -1) data.staticClass += ' ' + comparison + '-' + iconName;else data.staticClass += ' ' + comparison + '-' + iconName.split(' ').join('-');
    }

    if (thirdPartyIcon) data.staticClass += ' ' + iconName;
    if (props.disabled) data.attrs.disabled = props.disabled;
    !(thirdPartyIcon || props.fa || props.mdi) && children.push(iconName);

    return h('i', data, children);
  }
});

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__badge__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__resize__ = __webpack_require__(78);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__scroll__ = __webpack_require__(79);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__tooltip__ = __webpack_require__(80);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__touch__ = __webpack_require__(81);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Badge", function() { return __WEBPACK_IMPORTED_MODULE_0__badge__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "ClickOutside", function() { return __WEBPACK_IMPORTED_MODULE_1__click_outside__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Ripple", function() { return __WEBPACK_IMPORTED_MODULE_3__ripple__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Resize", function() { return __WEBPACK_IMPORTED_MODULE_2__resize__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Scroll", function() { return __WEBPACK_IMPORTED_MODULE_4__scroll__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Tooltip", function() { return __WEBPACK_IMPORTED_MODULE_5__tooltip__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "Touch", function() { return __WEBPACK_IMPORTED_MODULE_6__touch__["a"]; });










/***/ }),
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_toggleable__["a" /* default */]],

  props: {
    activeClass: {
      type: String,
      default: 'btn--active'
    },
    block: Boolean,
    fab: Boolean,
    flat: Boolean,
    icon: Boolean,
    large: Boolean,
    loading: Boolean,
    outline: Boolean,
    ripple: {
      type: [Boolean, Object],
      default: true
    },
    round: Boolean,
    small: Boolean,
    tag: {
      type: String,
      default: 'button'
    },
    type: {
      type: String,
      default: 'button'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'btn': true,
        'btn--absolute': this.absolute,
        'btn--active': this.isActive,
        'btn--block': this.block,
        'btn--bottom': this.bottom,
        'btn--disabled': this.disabled,
        'btn--flat': this.flat,
        'btn--floating': this.fab,
        'btn--fixed': this.fixed,
        'btn--hover': this.hover,
        'btn--icon': this.icon,
        'btn--large': this.large,
        'btn--left': this.left,
        'btn--loader': this.loading,
        'btn--outline': this.outline,
        'btn--raised': !this.flat,
        'btn--right': this.right,
        'btn--round': this.round,
        'btn--small': this.small,
        'btn--top': this.top,
        'theme--dark': this.dark,
        'theme--light': this.light,
        'primary': this.primary && !this.outline,
        'secondary': this.secondary && !this.outline,
        'success': this.success && !this.outline,
        'info': this.info && !this.outline,
        'warning': this.warning && !this.outline,
        'error': this.error && !this.outline,
        'primary--text': this.primary && (this.outline || this.flat),
        'secondary--text': this.secondary && (this.outline || this.flat),
        'success--text': this.success && (this.outline || this.flat),
        'info--text': this.info && (this.outline || this.flat),
        'warning--text': this.warning && (this.outline || this.flat),
        'error--text': this.error && (this.outline || this.flat)
      };
    }
  },

  methods: {
    // Prevent focus to match md spec
    click: function click(e) {
      !this.fab && e.detail && this.$el.blur();

      this.$emit('click', e);
    },
    genContent: function genContent() {
      return this.$createElement('div', { 'class': 'btn__content' }, [this.$slots.default]);
    },
    genLoader: function genLoader() {
      var children = [];

      if (!this.$slots.loader) {
        children.push(this.$createElement('v-progress-circular', {
          props: {
            indeterminate: true,
            size: 26
          }
        }));
      } else {
        children.push(this.$slots.loader);
      }

      return this.$createElement('span', { 'class': 'btn__loading' }, children);
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    var children = [this.genContent()];

    tag === 'button' && (data.attrs.type = this.type);
    this.loading && children.push(this.genLoader());

    return h(tag, data, children);
  }
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VCarouselTransition */
/* unused harmony export VCarouselReverseTransition */
/* unused harmony export VTabTransition */
/* unused harmony export VTabReverseTransition */
/* unused harmony export VMenuTransition */
/* unused harmony export VFabTransition */
/* unused harmony export VDialogTransition */
/* unused harmony export VDialogBottomTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VFadeTransition; });
/* unused harmony export VScaleTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return VSlideXTransition; });
/* unused harmony export VSlideXReverseTransition */
/* unused harmony export VSlideYTransition */
/* unused harmony export VSlideYReverseTransition */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VExpandTransition; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__expand_transition__ = __webpack_require__(71);




// Component specific transitions
var VCarouselTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-transition');
var VCarouselReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('carousel-reverse-transition');
var VTabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-transition');
var VTabReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('tab-reverse-transition');
var VMenuTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('menu-transition');
var VFabTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fab-transition', 'center center', 'out-in');

// Generic transitions
var VDialogTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-transition');
var VDialogBottomTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('dialog-bottom-transition');
var VFadeTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('fade-transition');
var VScaleTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('scale-transition');
var VSlideXTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-transition');
var VSlideXReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-x-reverse-transition');
var VSlideYTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-transition');
var VSlideYReverseTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["e" /* createSimpleTransition */])('slide-y-reverse-transition');

// JavaScript transitions
var VExpandTransition = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["b" /* createJavaScriptTransition */])('expand-transition', __WEBPACK_IMPORTED_MODULE_1__expand_transition__["a" /* default */]);

/* harmony default export */ __webpack_exports__["d"] = ({
  VCarouselTransition: VCarouselTransition,
  VCarouselReverseTransition: VCarouselReverseTransition,
  VDialogTransition: VDialogTransition,
  VDialogBottomTransition: VDialogBottomTransition,
  VFabTransition: VFabTransition,
  VFadeTransition: VFadeTransition,
  VMenuTransition: VMenuTransition,
  VScaleTransition: VScaleTransition,
  VSlideXTransition: VSlideXTransition,
  VSlideXReverseTransition: VSlideXReverseTransition,
  VSlideYTransition: VSlideYTransition,
  VSlideYReverseTransition: VSlideYReverseTransition,
  VTabReverseTransition: VTabReverseTransition,
  VTabTransition: VTabTransition,
  VExpandTransition: VExpandTransition
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__themeable__ = __webpack_require__(1);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_0__themeable__["a" /* default */]],

  data: function data() {
    return {
      errorBucket: [],
      focused: false,
      tabFocused: false,
      lazyValue: this.value
    };
  },


  props: {
    appendIcon: String,
    appendIconCb: Function,
    disabled: Boolean,
    error: Boolean,
    errorMessages: {
      type: [String, Array],
      default: function _default() {
        return [];
      }
    },
    hint: String,
    hideDetails: Boolean,
    label: String,
    persistentHint: Boolean,
    placeholder: String,
    prependIcon: String,
    prependIconCb: Function,
    required: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tabindex: {
      default: 0
    },
    value: {
      required: false
    }
  },

  computed: {
    hasError: function hasError() {
      return this.validations.length || this.error;
    },
    inputGroupClasses: function inputGroupClasses() {
      return Object.assign({
        'input-group': true,
        'input-group--focused': this.focused,
        'input-group--dirty': this.isDirty,
        'input-group--tab-focused': this.tabFocused,
        'input-group--disabled': this.disabled,
        'input-group--error': this.hasError,
        'input-group--append-icon': this.appendIcon,
        'input-group--prepend-icon': this.prependIcon,
        'input-group--required': this.required,
        'input-group--hide-details': this.hideDetails,
        'input-group--placeholder': !!this.placeholder,
        'theme--dark': this.dark,
        'theme--light': this.light
      }, this.classes);
    },
    isDirty: function isDirty() {
      return this.inputValue;
    },
    modifiers: function modifiers() {
      var modifiers = {
        lazy: false,
        number: false,
        trim: false
      };

      if (!this.$vnode.data.directives) {
        return modifiers;
      }

      var model = this.$vnode.data.directives.find(function (i) {
        return i.name === 'model';
      });

      if (!model) {
        return modifiers;
      }

      return Object.assign(modifiers, model.modifiers);
    },
    validations: function validations() {
      return (!Array.isArray(this.errorMessages) ? [this.errorMessages] : this.errorMessages).concat(this.errorBucket);
    }
  },

  watch: {
    rules: function rules() {
      this.validate();
    }
  },

  mounted: function mounted() {
    this.validate();
  },


  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    genMessages: function genMessages() {
      var _this = this;

      var messages = [];

      if ((this.hint && this.focused || this.hint && this.persistentHint) && this.validations.length === 0) {
        messages = [this.genHint()];
      } else if (this.validations.length) {
        messages = this.validations.map(function (i) {
          return _this.genError(i);
        });
      }

      return this.$createElement('transition-group', {
        'class': 'input-group__messages',
        props: {
          tag: 'div',
          name: 'slide-y-transition'
        }
      }, messages);
    },
    genHint: function genHint() {
      return this.$createElement('div', {
        'class': 'input-group__hint',
        key: this.hint,
        domProps: { innerHTML: this.hint }
      });
    },
    genError: function genError(error) {
      return this.$createElement('div', {
        'class': 'input-group__error',
        key: error
      }, error);
    },
    genIcon: function genIcon(type) {
      var _class;

      var icon = this[type + 'Icon'];
      var cb = this[type + 'IconCb'];
      var hasCallback = typeof cb === 'function';

      return this.$createElement('v-icon', {
        'class': (_class = {}, _defineProperty(_class, 'input-group__' + type + '-icon', true), _defineProperty(_class, 'input-group__icon-cb', hasCallback), _class),
        on: {
          click: function click(e) {
            hasCallback && cb(e);
          }
        }
      }, icon);
    },
    genInputGroup: function genInputGroup(input) {
      var _this2 = this;

      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var children = [];
      var wrapperChildren = [];
      var detailsChildren = [];

      data = Object.assign({}, {
        'class': this.inputGroupClasses,
        attrs: {
          tabindex: this.tabindex
        },
        on: {
          blur: function blur() {
            return _this2.tabFocused = false;
          },
          click: function click() {
            return _this2.tabFocused = false;
          },
          keyup: function keyup(e) {
            if ([9, 16].includes(e.keyCode)) {
              _this2.tabFocused = true;
            }
          },
          keydown: function keydown(e) {
            if (!_this2.toggle) return;

            if ([13, 32].includes(e.keyCode)) {
              e.preventDefault();
              _this2.toggle();
            }
          }
        }
      }, data);

      if (this.$slots.label || this.label) {
        children.push(this.genLabel());
      }

      wrapperChildren.push(input);

      if (this.prependIcon) {
        wrapperChildren.unshift(this.genIcon('prepend'));
      }

      if (this.appendIcon) {
        wrapperChildren.push(this.genIcon('append'));
      }

      children.push(this.$createElement('div', {
        'class': 'input-group__input'
      }, wrapperChildren));

      detailsChildren.push(this.genMessages());
      this.counter && detailsChildren.push(this.genCounter());

      children.push(this.$createElement('div', {
        'class': 'input-group__details'
      }, detailsChildren));

      return this.$createElement('div', data, children);
    },
    validate: function validate() {
      var _this3 = this;

      this.errorBucket = [];

      this.rules.forEach(function (rule) {
        var valid = typeof rule === 'function' ? rule(_this3.value) : rule;

        if (valid !== true) {
          _this3.errorBucket.push(valid);
        }
      });
    }
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    primary: Boolean,
    secondary: Boolean,
    success: Boolean,
    info: Boolean,
    warning: Boolean,
    error: Boolean
  }
});

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    append: Boolean,
    disabled: Boolean,
    exact: Boolean,
    href: [String, Object],
    to: [String, Object],
    nuxt: Boolean,
    replace: Boolean,
    router: Boolean,
    ripple: {
      type: Boolean,
      default: true
    },
    tag: String
  },

  methods: {
    click: function click() {},
    generateRouteLink: function generateRouteLink() {
      var exact = this.exact;
      var tag = void 0;

      var data = {
        attrs: { disabled: this.disabled },
        class: this.classes,
        props: {},
        directives: [{
          name: 'ripple',
          value: this.ripple || false
        }],
        on: Object.assign({
          click: this.click
        }, this.$listeners || {})
      };

      if (typeof this.exact === 'undefined') {
        exact = this.to === '/' || this.to === Object(this.to) && this.to.path === '/';
      }

      if (this.to) {
        tag = this.nuxt ? 'nuxt-link' : 'router-link';
        data.props.to = this.to;
        data.props.exact = exact;
        data.props.activeClass = this.activeClass;
        data.props.append = this.append;
        data.props.replace = this.replace;
      } else {
        tag = this.href && 'a' || this.tag || 'a';

        if (tag === 'a') {
          data.attrs.href = this.href || 'javascript:;';
        }
      }

      return { tag: tag, data: data };
    }
  }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isBooted: false
    };
  },


  watch: {
    isActive: function isActive() {
      this.isBooted = true;
    }
  },

  methods: {
    showLazyContent: function showLazyContent(content) {
      return this.lazy && this.isBooted || !this.lazy ? content : null;
    }
  }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VListTileActionText */
/* unused harmony export VListTileAvatar */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return VListTileContent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return VListTileTitle; });
/* unused harmony export VListTileSubTitle */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VListGroup__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VListTileAction__ = __webpack_require__(21);







var VListTileActionText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__action-text', 'span');
var VListTileAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__avatar', 'v-avatar');
var VListTileContent = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__content', 'div');
var VListTileTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__title', 'div');
var VListTileSubTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('list__tile__sub-title', 'div');

/* harmony default export */ __webpack_exports__["c"] = ({
  VList: __WEBPACK_IMPORTED_MODULE_1__VList__["a" /* default */],
  VListTile: __WEBPACK_IMPORTED_MODULE_3__VListTile__["a" /* default */],
  VListGroup: __WEBPACK_IMPORTED_MODULE_2__VListGroup__["a" /* default */],
  VListTileAction: __WEBPACK_IMPORTED_MODULE_4__VListTileAction__["a" /* default */],
  VListTileActionText: VListTileActionText,
  VListTileAvatar: VListTileAvatar,
  VListTileContent: VListTileContent,
  VListTileTitle: VListTileTitle,
  VListTileSubTitle: VListTileSubTitle
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    absolute: Boolean,
    bottom: Boolean,
    fixed: Boolean,
    left: Boolean,
    right: Boolean,
    top: Boolean
  }
});

/***/ }),
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    flat: Boolean,
    height: {
      type: String,
      default: 'auto'
    },
    hover: Boolean,
    img: String,
    raised: Boolean,
    tile: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card ' + (data.staticClass || '')).trim();
    data.style = data.style || {};
    data.style.height = props.height;

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.flat) data.staticClass += ' card--flat';
    if (props.horizontal) data.staticClass += ' card--horizontal';
    if (props.hover) data.staticClass += ' card--hover';
    if (props.light) data.staticClass += ' theme--light';
    if (props.raised) data.staticClass += ' card--raised';
    if (props.tile) data.staticClass += ' card--tile';

    if (props.img) {
      data.style.background = 'url(' + props.img + ') center center / cover no-repeat';
    }

    return h('div', data, children);
  }
});

/***/ }),
/* 14 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      isSaving: false
    };
  },


  props: {
    actions: Boolean,
    autosave: Boolean,
    landscape: Boolean,
    noTitle: Boolean,
    scrollable: Boolean,
    value: {
      required: true
    },
    light: {
      type: Boolean,
      default: true
    },
    dark: Boolean
  },

  methods: {
    save: function save() {},
    cancel: function cancel() {},
    genSlot: function genSlot() {
      return this.$scopedSlots.default({
        save: this.save,
        cancel: this.cancel
      });
    }
  }
});

/***/ }),
/* 15 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    contentClass: {
      default: ''
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      if (_this._isDestroyed) return;

      var app = document.querySelector('[data-app]');

      if (!app) {
        return console.warn('Application is missing <v-app> component.');
      }

      app.insertBefore(_this.$refs.content, app.firstChild);
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (!this.$refs.content) return;

    // IE11 Fix
    try {
      this.$refs.content.parentNode.removeChild(this.$refs.content);
    } catch (e) {}
  }
});

/***/ }),
/* 16 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      overlay: null,
      overlayOffset: 0,
      overlayTransitionDuration: 500
    };
  },


  props: {
    hideOverlay: Boolean
  },

  beforeDestroy: function beforeDestroy() {
    this.removeOverlay();
  },


  methods: {
    genOverlay: function genOverlay() {
      var _this = this;

      if (!this.isActive || this.hideOverlay || this.isActive && this.overlay) return;

      this.overlay = document.createElement('div');
      this.overlay.className = 'overlay';
      this.overlay.onclick = function () {
        if (_this.permanent) return;else if (!_this.persistent) _this.isActive = false;else if (_this.isMobile) _this.isActive = false;
      };

      if (this.absolute) this.overlay.className += ' overlay--absolute';

      this.hideScroll();

      if (this.absolute) {
        // Required for IE11
        var parent = this.$el.parentNode;
        parent.insertBefore(this.overlay, parent.firstChild);
      } else {
        document.querySelector('[data-app]').appendChild(this.overlay);
      }

      this.overlay.clientHeight; // Force repaint
      requestAnimationFrame(function () {
        _this.overlay.className += ' overlay--active';
      });

      return true;
    },
    removeOverlay: function removeOverlay() {
      var _this2 = this;

      if (!this.overlay) {
        return this.showScroll();
      }

      this.overlay.classList.remove('overlay--active');

      setTimeout(function () {
        // IE11 Fix
        try {
          _this2.overlay.parentNode.removeChild(_this2.overlay);
          _this2.overlay = null;
          _this2.showScroll();
        } catch (e) {}
      }, this.overlayTransitionDuration);
    },
    hideScroll: function hideScroll() {
      // Check documentElement first for IE11
      // this.overlayOffset = document.documentElement &&
      //   document.documentElement.scrollTop ||
      //   document.body.scrollTop

      // document.body.style.top = `-${this.overlayOffset}px`
      // document.body.style.position = 'fixed'
      document.documentElement.style.overflow = 'hidden';
    },
    showScroll: function showScroll() {
      document.documentElement.removeAttribute('style');

      // if (!this.overlayOffset) return
      // document.body.scrollTop = this.overlayOffset
      // document.documentElement.scrollTop = this.overlayOffset
    }
  }
});

/***/ }),
/* 17 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list',

  provide: function provide() {
    return {
      listClick: this.listClick,
      listClose: this.listClose
    };
  },


  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      uid: null,
      groups: []
    };
  },


  props: {
    dense: Boolean,
    subheader: Boolean,
    threeLine: Boolean,
    twoLine: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list': true,
        'list--two-line': this.twoLine,
        'list--dense': this.dense,
        'list--three-line': this.threeLine,
        'list--subheader': this.subheader,
        'theme--dark dark--bg': this.dark,
        'theme--light light--bg': this.light
      };
    }
  },

  watch: {
    uid: function uid() {
      var _this = this;

      this.$children.filter(function (i) {
        return i.$options._componentTag === 'v-list-group';
      }).forEach(function (i) {
        return i.toggle(_this.uid);
      });
    }
  },

  methods: {
    listClick: function listClick(uid, force) {
      if (force) {
        this.uid = uid;
      } else {
        this.uid = this.uid === uid ? null : uid;
      }
    },
    listClose: function listClose(uid) {
      if (this.uid === uid) {
        this.uid = null;
      }
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      attrs: { 'data-uid': this._uid }
    };

    return h('ul', data, [this.$slots.default]);
  }
});

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-tile',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_2__directives__["Ripple"]
  },

  inheritAttrs: false,

  props: {
    activeClass: {
      type: String,
      default: 'list__tile--active'
    },
    avatar: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list__tile': true,
        'list__tile--avatar': this.avatar,
        'list__tile--disabled': this.disabled
      };
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    data.attrs = Object.assign({}, data.attrs, this.$attrs);

    return h('li', {
      attrs: {
        disabled: this.disabled
      }
    }, [h(tag, data, [this.$slots.default])]);
  }
});

/***/ }),
/* 19 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function directive(e, el, binding, v) {
  var cb = function cb() {
    return true;
  };

  if (binding.value) cb = binding.value;

  if (v.context.isActive && e && e.target && e.target !== el && !el.contains(e.target) && cb(e)) {
    v.context.isActive = false;
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: function bind(el, binding, v) {
    v.context.$vuetify.load(function () {
      var outside = document.querySelector('[data-app]');
      var click = function click(e) {
        return directive(e, el, binding, v);
      };
      outside.addEventListener('click', click, false);
      el._clickOutside = click;
    });
  },
  unbind: function unbind(el) {
    var outside = document.querySelector('[data-app]');
    outside && outside.removeEventListener('click', el._clickOutside, false);
  }
});

/***/ }),
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function style(el, value) {
  ['transform', 'webkitTransform'].forEach(function (i) {
    el.style[i] = value;
  });
}

var ripple = {
  show: function show(e, el, _ref) {
    var _ref$value = _ref.value,
        value = _ref$value === undefined ? {} : _ref$value;

    var container = document.createElement('span');
    var animation = document.createElement('span');

    container.appendChild(animation);
    container.className = 'ripple__container';

    if (value.class) {
      container.className += ' ' + value.class;
    }

    var size = el.clientWidth > el.clientHeight ? el.clientWidth : el.clientHeight;
    animation.className = 'ripple__animation';
    animation.style.width = size * (value.center ? 1 : 2) + 'px';
    animation.style.height = animation.style.width;

    el.appendChild(container);
    var computed = window.getComputedStyle(el);
    if (computed.position !== 'absolute' && computed.position !== 'fixed') el.style.position = 'relative';

    var offset = el.getBoundingClientRect();
    var x = value.center ? '50%' : e.clientX - offset.left + 'px';
    var y = value.center ? '50%' : e.clientY - offset.top + 'px';

    animation.classList.add('ripple__animation--enter');
    animation.classList.add('ripple__animation--visible');
    style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ') scale3d(0.01,0.01,0.01)');
    animation.dataset.activated = Date.now();

    setTimeout(function () {
      animation.classList.remove('ripple__animation--enter');
      style(animation, 'translate(-50%, -50%) translate(' + x + ', ' + y + ')  scale3d(0.99,0.99,0.99)');
    }, 0);
  },

  hide: function hide(el) {
    var ripples = el.getElementsByClassName('ripple__animation');

    if (ripples.length === 0) return;
    var animation = ripples[ripples.length - 1];
    var diff = Date.now() - Number(animation.dataset.activated);
    var delay = 400 - diff;

    delay = delay < 0 ? 0 : delay;

    setTimeout(function () {
      animation.classList.remove('ripple__animation--visible');

      setTimeout(function () {
        // Need to figure out a new way to do this
        try {
          if (ripples.length < 1) el.style.position = null;
          animation.parentNode && el.removeChild(animation.parentNode);
        } catch (e) {}
      }, 300);
    }, delay);
  }
};

function directive(el, binding, v) {
  if (binding.value === false) return;

  if ('ontouchstart' in window) {
    el.addEventListener('touchend', function () {
      return ripple.hide(el);
    }, false);
    el.addEventListener('touchcancel', function () {
      return ripple.hide(el);
    }, false);
  }

  el.addEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.addEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.addEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

function unbind(el, binding) {
  el.removeEventListener('touchstart', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('mousedown', function (e) {
    return ripple.show(e, el, binding);
  }, false);
  el.removeEventListener('touchend', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('touchcancel', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseup', function () {
    return ripple.hide(el);
  }, false);
  el.removeEventListener('mouseleave', function () {
    return ripple.hide(el);
  }, false);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  unbind: unbind
});

/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  name: 'list-tile-action',

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children;

    data.staticClass = data.staticClass ? 'list__tile__action ' + (data.staticClass || '') : 'list__tile__action';
    if ((children || []).length > 1) data.staticClass += ' list__tile__action--stack';

    return h('div', data, children);
  }
});

/***/ }),
/* 22 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_activator__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(84);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_position__ = __webpack_require__(85);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_utils__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__directives__ = __webpack_require__(4);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-menu',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_activator__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__mixins_keyable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_position__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_utils__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_toggleable__["a" /* default */]],

  directives: {
    ClickOutside: __WEBPACK_IMPORTED_MODULE_7__directives__["ClickOutside"]
  },

  data: function data() {
    return {
      autoIndex: null,
      dimensions: {
        activator: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        content: {
          top: 0, left: 0,
          bottom: 0, right: 0,
          width: 0, height: 0,
          offsetTop: 0, scrollHeight: 0
        },
        list: null,
        selected: null
      },
      direction: { vert: 'bottom', horiz: 'right' },
      isContentActive: false,
      isBooted: false,
      maxHeightAutoDefault: '200px',
      resizeTimeout: {},
      startIndex: 3,
      stopIndex: 0,
      tileLength: 0,
      window: {},
      absoluteX: 0,
      absoluteY: 0,
      hasJustFocused: false,
      focusedTimeout: {}
    };
  },


  props: {
    top: Boolean,
    left: Boolean,
    bottom: Boolean,
    right: Boolean,
    fullWidth: Boolean,
    auto: Boolean,
    offsetX: Boolean,
    offsetY: Boolean,
    disabled: Boolean,
    maxHeight: {
      default: 'auto'
    },
    nudgeTop: {
      type: Number,
      default: 0
    },
    nudgeBottom: {
      type: Number,
      default: 0
    },
    nudgeLeft: {
      type: Number,
      default: 0
    },
    nudgeRight: {
      type: Number,
      default: 0
    },
    nudgeWidth: {
      type: Number,
      default: 0
    },
    openOnClick: {
      type: Boolean,
      default: true
    },
    openOnHover: {
      type: Boolean,
      default: false
    },
    lazy: Boolean,
    closeOnClick: {
      type: Boolean,
      default: true
    },
    closeOnContentClick: {
      type: Boolean,
      default: true
    },
    activator: {
      default: null
    },
    origin: {
      type: String,
      default: 'top left'
    },
    transition: {
      type: String,
      default: 'menu-transition'
    },
    positionX: {
      type: Number,
      default: null
    },
    positionY: {
      type: Number,
      default: null
    },
    positionAbsolutely: {
      type: Boolean,
      default: false
    },
    maxWidth: [Number, String],
    minWidth: [Number, String]
  },

  computed: {
    calculatedMinWidth: function calculatedMinWidth() {
      var minWidth = parseInt(this.minWidth) || this.dimensions.activator.width + this.nudgeWidth + (this.auto ? 16 : 0);

      if (!this.maxWidth) return minWidth;

      var maxWidth = parseInt(this.maxWidth);

      return maxWidth < minWidth ? maxWidth : minWidth;
    },
    styles: function styles() {
      return {
        maxHeight: this.auto ? '200px' : isNaN(this.maxHeight) ? this.maxHeight : this.maxHeight + 'px',
        minWidth: this.calculatedMinWidth + 'px',
        maxWidth: parseInt(this.maxWidth) + 'px',
        top: this.calcTop() + 'px',
        left: this.calcLeft() + 'px'
      };
    },
    hasActivator: function hasActivator() {
      return !!this.$slots.activator || this.activator;
    }
  },

  watch: {
    activator: function activator(newActivator, oldActivator) {
      this.removeActivatorEvents(oldActivator);
      this.addActivatorEvents(newActivator);
    },
    disabled: function disabled(val) {
      val && this.deactivate();
    },
    hasJustFocused: function hasJustFocused(val) {
      var _this = this;

      if (!val) return;

      clearTimeout(this.focusedTimeout);
      this.focusedTimeout = setTimeout(function () {
        return _this.hasJustFocused = false;
      }, 550);
    },
    isActive: function isActive(val) {
      if (this.disabled) return;

      val && this.activate() || this.deactivate();
    },
    windowResizeHandler: function windowResizeHandler() {
      this.isBooted = false;
    }
  },

  mounted: function mounted() {
    window.addEventListener('resize', this.onResize, { passive: true });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.onResize, { passive: true });
    window.removeEventListener('resize', this.windowResizeHandler);
  },


  methods: {
    activate: function activate() {
      if (typeof window === 'undefined') return;
      this.isBooted = true;
      this.getTiles();
      this.updateDimensions();
      requestAnimationFrame(this.startTransition);
      this.$emit('activate');
    },
    deactivate: function deactivate() {
      this.isContentActive = false;
      this.$emit('deactivate');
    },
    onResize: function onResize() {
      clearTimeout(this.resizeTimeout);
      if (!this.isActive) return;
      this.resizeTimeout = setTimeout(this.updateDimensions, 200);
    },
    startTransition: function startTransition() {
      var _this2 = this;

      requestAnimationFrame(function () {
        return _this2.isContentActive = true;
      });
      requestAnimationFrame(this.calculateScroll);
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': 'menu',
      style: {
        display: this.fullWidth ? 'block' : 'inline-block'
      },
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this3.closeOnClick;
        }
      }],
      on: {
        keydown: function keydown(e) {
          if (e.keyCode === 27) _this3.isActive = false;else _this3.changeListIndex(e);
        }
      }
    };

    return h('div', data, [this.genActivator(), this.genTransition()]);
  }
});

/***/ }),
/* 23 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-linear',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["b" /* VFadeTransition */],
    VSlideXTransition: __WEBPACK_IMPORTED_MODULE_0__components_transitions__["c" /* VSlideXTransition */]
  },

  props: {
    active: {
      type: Boolean,
      default: true
    },
    buffer: Boolean,
    bufferValue: Number,
    error: Boolean,
    height: {
      type: [Number, String],
      default: 7
    },
    indeterminate: Boolean,
    info: Boolean,
    secondary: Boolean,
    success: Boolean,
    query: Boolean,
    warning: Boolean,
    value: {
      type: [Number, String],
      default: 0
    },
    colorFront: {
      type: String,
      default: null
    },
    colorBack: {
      type: String,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'progress-linear--query': this.query,
        'progress-linear--secondary': this.secondary,
        'progress-linear--success': this.success,
        'progress-linear--info': this.info,
        'progress-linear--warning': this.warning,
        'progress-linear--error': this.error
      };
    },
    styles: function styles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      if (this.buffer) {
        styles.width = this.bufferValue + '%';
      }

      return styles;
    },
    bufferStyles: function bufferStyles() {
      var styles = {};

      if (!this.active) {
        styles.height = 0;
      }

      return styles;
    }
  },

  methods: {
    genDeterminate: function genDeterminate(h) {
      return h('div', {
        ref: 'front',
        class: ['progress-linear__bar__determinate', this.colorFront],
        style: { width: this.value + '%' }
      });
    },
    genBar: function genBar(h, name) {
      return h('div', {
        class: ['progress-linear__bar__indeterminate', name, this.colorFront]
      });
    },
    genIndeterminate: function genIndeterminate(h) {
      return h('div', {
        ref: 'front',
        class: {
          'progress-linear__bar__indeterminate': true,
          'progress-linear__bar__indeterminate--active': this.active
        }
      }, [this.genBar(h, 'long'), this.genBar(h, 'short')]);
    }
  },

  render: function render(h) {
    var fade = h('v-fade-transition', [this.indeterminate && this.genIndeterminate(h)]);
    var slide = h('v-slide-x-transition', [!this.indeterminate && this.genDeterminate(h)]);

    var bar = h('div', { class: ['progress-linear__bar', this.colorBack], style: this.styles }, [fade, slide]);

    return h('div', {
      class: ['progress-linear', this.classes],
      style: { height: this.height + 'px' },
      on: this.$listeners
    }, [bar]);
  }
});

/***/ }),
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_generators__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__ = __webpack_require__(19);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__util_helpers__ = __webpack_require__(0);



















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-select',

  components: {
    VCard: __WEBPACK_IMPORTED_MODULE_4__components_cards_VCard__["a" /* default */],
    VCheckbox: __WEBPACK_IMPORTED_MODULE_5__components_selection_controls_VCheckbox__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_6__components_icons_VIcon__["a" /* default */],
    VList: __WEBPACK_IMPORTED_MODULE_7__components_lists_VList__["a" /* default */],
    VListTile: __WEBPACK_IMPORTED_MODULE_8__components_lists_VListTile__["a" /* default */],
    VListTileAction: __WEBPACK_IMPORTED_MODULE_9__components_lists_VListTileAction__["a" /* default */],
    VListTileContent: __WEBPACK_IMPORTED_MODULE_10__components_lists__["a" /* VListTileContent */],
    VListTileTitle: __WEBPACK_IMPORTED_MODULE_10__components_lists__["b" /* VListTileTitle */],
    VMenu: __WEBPACK_IMPORTED_MODULE_11__components_menus_VMenu__["a" /* default */]
  },

  directives: {
    clickOutside: __WEBPACK_IMPORTED_MODULE_12__directives_click_outside__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_autocomplete__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_generators__["a" /* default */]],

  data: function data() {
    return {
      content: {},
      hasFocused: false,
      inputValue: this.multiple && !this.value ? [] : this.value,
      isBooted: false,
      lastItem: 20,
      isActive: false,
      searchInputValue: this.searchInput
    };
  },


  props: {
    appendIcon: {
      type: String,
      default: 'arrow_drop_down'
    },
    auto: Boolean,
    autocomplete: Boolean,
    bottom: Boolean,
    chips: Boolean,
    close: Boolean,
    debounce: {
      type: Number,
      default: 200
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    filter: Function,
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    itemDisabled: {
      type: String,
      default: 'disabled'
    },
    maxHeight: {
      type: [Number, String],
      default: 300
    },
    minWidth: {
      type: [Boolean, Number, String],
      default: false
    },
    multiple: Boolean,
    multiLine: Boolean,
    offset: Boolean,
    searchInput: null,
    singleLine: Boolean,
    top: Boolean,
    returnObject: Boolean,
    overflow: Boolean,
    segmented: Boolean,
    editable: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field input-group--select': true,
        'input-group--auto': this.auto,
        'input-group--overflow': this.overflow,
        'input-group--segmented': this.segmented,
        'input-group--editable': this.editable,
        'input-group--autocomplete': this.autocomplete,
        'input-group--single-line': this.singleLine || this.isDropdown,
        'input-group--multi-line': this.multiLine,
        'input-group--chips': this.chips,
        'input-group--multiple': this.multiple
      };
    },
    computedContentClass: function computedContentClass() {
      var children = [this.auto ? 'menu__content--auto' : '', this.isDropdown ? 'menu__content--dropdown' : ''];

      return children.join(' ');
    },
    filteredItems: function filteredItems() {
      var items = this.autocomplete && this.searchValue ? this.filterSearch() : this.items;

      return !this.auto ? items.slice(0, this.lastItem) : items;
    },
    hasError: function hasError() {
      return this.validations.length || this.error || this.hasFocused && !this.focused && !this.isDirty && this.required;
    },
    isDirty: function isDirty() {
      return this.selectedItems.length;
    },
    isDropdown: function isDropdown() {
      return this.segmented || this.overflow || this.editable;
    },

    searchValue: {
      get: function get() {
        return this.searchInput || this.searchInputValue;
      },
      set: function set(val) {
        this.searchInputValue = val;
        this.$emit('update:searchInput', val);
      }
    },
    selectedItems: function selectedItems() {
      var _this = this;

      if (this.inputValue === null || typeof this.inputValue === 'undefined') return [];

      return this.items.filter(function (i) {
        if (!_this.multiple) {
          return _this.getValue(i) === _this.getValue(_this.inputValue);
        } else {
          // Always return Boolean
          return _this.inputValue.find(function (j) {
            return _this.getValue(j) === _this.getValue(i);
          }) !== undefined;
        }
      });
    }
  },

  watch: {
    inputValue: function inputValue(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      this.inputValue = val;
      this.validate();
      if (this.autocomplete || this.editable) {
        this.$nextTick(this.$refs.menu.updateDimensions);
      }
    },
    isActive: function isActive(val) {
      this.isBooted = true;
      this.lastItem += !val ? 20 : 0;

      if (!val) this.blur();else this.focus();
    },
    isBooted: function isBooted() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.content) {
          _this2.content.addEventListener('scroll', _this2.onScroll, false);
        }
      });
    },
    searchValue: function searchValue() {
      this.$refs.menu.listIndex = -1;
    }
  },

  mounted: function mounted() {
    var _this3 = this;

    this.$vuetify.load(function () {
      if (_this3._isDestroyed) return;

      _this3.content = _this3.$refs.menu.$refs.content;
    });
  },
  beforeDestroy: function beforeDestroy() {
    if (this.isBooted) {
      if (this.content) {
        this.content.removeEventListener('scroll', this.onScroll, false);
      }
    }
  },


  methods: {
    blur: function blur() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.focused = false;
        _this4.hasFocused = true;
        _this4.searchValue = null;
        _this4.$el.blur();
      });
    },
    focus: function focus() {
      var _this5 = this;

      this.focused = true;
      this.$refs.input && (this.autocomplete || this.editable) && this.$refs.input.focus();

      if (this.editable && this.inputValue !== null && typeof this.inputValue !== 'undefined') {
        this.$nextTick(function () {
          _this5.$refs.input.value = _this5.getValue(_this5.inputValue);
        });
      }
    },
    genLabel: function genLabel() {
      if (this.searchValue && !this.focused && this.isDirty) return null;

      var data = {};

      if (this.id) data.attrs = { for: this.id };

      return this.$createElement('label', data, this.label);
    },
    getPropertyFromItem: function getPropertyFromItem(item, field) {
      if (item !== Object(item)) return item;

      var value = Object(__WEBPACK_IMPORTED_MODULE_13__util_helpers__["g" /* getObjectValueByPath */])(item, field);

      return typeof value === 'undefined' ? item : value;
    },
    getText: function getText(item) {
      return this.getPropertyFromItem(item, this.itemText);
    },
    getValue: function getValue(item) {
      return this.getPropertyFromItem(item, this.itemValue);
    },
    onScroll: function onScroll() {
      var _this6 = this;

      if (!this.isActive) {
        requestAnimationFrame(function () {
          return _this6.content.scrollTop = 0;
        });
      } else {
        var showMoreItems = this.content.scrollHeight - (this.content.scrollTop + this.content.clientHeight) < 200;

        if (showMoreItems) {
          this.lastItem += 20;
        }
      }
    },
    selectItem: function selectItem(item) {
      var _this7 = this;

      if (!this.multiple) {
        this.inputValue = this.returnObject ? item : this.getValue(item);
      } else {
        var inputValue = this.inputValue.slice();
        var i = this.inputValue.findIndex(function (i) {
          return _this7.getValue(i) === _this7.getValue(item);
        });

        i !== -1 && inputValue.splice(i, 1) || inputValue.push(item);
        this.inputValue = inputValue.map(function (i) {
          return _this7.returnObject ? i : _this7.getValue(i);
        });
      }

      if (this.autocomplete || this.editable) {
        this.$nextTick(function () {
          _this7.searchValue = null;
          _this7.$refs.input && _this7.$refs.input.focus();
        });
      }

      this.$emit('change', this.inputValue);
    }
  },

  render: function render(h) {
    var _this8 = this;

    return this.genInputGroup([this.genSelectionsAndSearch(), this.genMenu()], {
      ref: 'activator',
      directives: [{
        name: 'click-outside',
        value: function value() {
          return _this8.isActive = false;
        }
      }],
      on: {
        keydown: this.onKeyDown // Located in mixins/autocomplete.js
      }
    });
  }
});

/***/ }),
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    noDataText: {
      type: String,
      default: 'No data available'
    }
  }
});

/***/ }),
/* 26 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives_ripple__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__ = __webpack_require__(3);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-checkbox',

  components: {
    VFadeTransition: __WEBPACK_IMPORTED_MODULE_2__components_transitions__["b" /* VFadeTransition */],
    VIcon: __WEBPACK_IMPORTED_MODULE_3__components_icons_VIcon__["a" /* default */]
  },

  directives: {
    Ripple: __WEBPACK_IMPORTED_MODULE_1__directives_ripple__["a" /* default */]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  data: function data() {
    return {
      inputIndeterminate: this.indeterminate
    };
  },


  props: {
    indeterminate: Boolean
  },

  computed: {
    classes: function classes() {
      return this.addColorClassChecks({
        'checkbox': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      if (this.inputIndeterminate) {
        return 'indeterminate_check_box';
      } else if (this.isActive) {
        return 'check_box';
      } else {
        return 'check_box_outline_blank';
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', [h('v-icon', {
      'class': {
        'icon--checkbox': this.icon === 'check_box'
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var data = {
      attrs: {
        role: 'checkbox',
        'aria-checked': this.inputIndeterminate && 'mixed' || this.isActive && 'true' || 'false',
        'aria-label': this.label
      }
    };

    return this.genInputGroup([transition, ripple], data);
  }
});

/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__colorable__ = __webpack_require__(28);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__input__ = __webpack_require__(7);



/* harmony default export */ __webpack_exports__["a"] = ({
  mixins: [__WEBPACK_IMPORTED_MODULE_1__input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: null,
    falseValue: null,
    trueValue: null
  },

  computed: {
    isActive: function isActive() {
      if (Array.isArray(this.inputValue)) {
        return this.inputValue.indexOf(this.value) !== -1;
      }

      if (!this.trueValue || !this.falseValue) {
        return this.value ? this.value === this.inputValue : Boolean(this.inputValue);
      }

      return this.inputValue === this.trueValue;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      this.inputIndeterminate = val;
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle },
        attrs: {
          for: this.$attrs.id
        }
      }, this.$slots.label || this.label);
    },
    toggle: function toggle() {
      if (this.disabled) {
        return;
      }

      var input = this.inputValue;
      if (Array.isArray(input)) {
        input = input.slice();
        var i = input.indexOf(this.value);

        if (i === -1) {
          input.push(this.value);
        } else {
          input.splice(i, 1);
        }
      } else if (this.trueValue || this.falseValue) {
        input = input === this.trueValue ? this.falseValue : this.trueValue;
      } else if (this.value) {
        input = this.value === this.inputValue ? null : this.value;
      } else {
        input = !input;
      }

      this.$emit('change', input);
    }
  }
});

/***/ }),
/* 28 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    color: String
  },
  methods: {
    addColorClassChecks: function addColorClassChecks(classes) {
      var parts = this.color ? this.color.trim().split(' ') : [''];
      var color = parts[0] + '--text';
      if (parts.length > 1) color += ' text--' + parts[1];
      classes[color] = !!this.color;
      return classes;
    }
  }
});

/***/ }),
/* 29 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__package_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__package_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_load__ = __webpack_require__(131);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_semver___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_semver__);
__webpack_require__(30);







function plugin(Vue) {
  Object.keys(__WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */]).forEach(function (key) {
    Vue.component(key, __WEBPACK_IMPORTED_MODULE_1__components__["a" /* default */][key]);
  });

  Object.keys(__WEBPACK_IMPORTED_MODULE_2__directives__).forEach(function (key) {
    Vue.directive(key, __WEBPACK_IMPORTED_MODULE_2__directives__[key]);
  });

  Vue.prototype.$vuetify = {
    load: __WEBPACK_IMPORTED_MODULE_3__util_load__["a" /* default */]
  };
}

function checkVueVersion() {
  var vueDep = __WEBPACK_IMPORTED_MODULE_0__package_json__["devDependencies"].vue;
  if (!__WEBPACK_IMPORTED_MODULE_4_semver___default.a.satisfies(window.Vue.version, vueDep)) {
    console.warn('Vuetify requires Vue version ' + vueDep);
  }
}

if (typeof window !== 'undefined' && window.Vue) {
  if (window.Vue.version) {
    checkVueVersion();
  }
  window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["default"] = (plugin);

/***/ }),
/* 30 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 31 */
/***/ (function(module, exports) {

module.exports = {
	"name": "vuetify",
	"version": "0.14.10",
	"author": {
		"name": "John Leider",
		"email": "john.j.leider@gmail.com"
	},
	"license": "MIT",
	"homepage": "http://vuetifyjs.com",
	"main": "dist/vuetify.js",
	"types": "index.d.ts",
	"scripts": {
		"watch": "cross-env TARGET=dev webpack --config build/config.js --progress --hide-modules --watch",
		"dev": "cross-env NODE_ENV=development webpack-dev-server --config build/webpack.dev.config.js --open --hot",
		"build": "rimraf dist && cross-env NODE_ENV=production node build/build.js --progress --hide-modules",
		"debug-build": "node --inspect --debug-brk build/build.js",
		"test": "cross-env NODE_ENV=test jest --no-cache --verbose",
		"test-coverage": "cross-env NODE_ENV=test jest --no-cache --coverage --verbose",
		"lint": "eslint --ext .js,.vue src"
	},
	"description": "Vue.js 2 Semantic Component Framework",
	"devDependencies": {
		"autoprefixer": "^6.6.0",
		"avoriaz": "^3.2.0",
		"babel-cli": "^6.24.1",
		"babel-core": "^6.24.1",
		"babel-eslint": "^7.1.1",
		"babel-jest": "^20.0.3",
		"babel-loader": "^7.1.1",
		"babel-plugin-add-filehash": "^6.9.4",
		"babel-plugin-module-resolver": "^2.7.1",
		"babel-plugin-transform-async-to-generator": "^6.24.1",
		"babel-plugin-transform-runtime": "^6.23.0",
		"babel-preset-env": "^1.5.1",
		"babel-preset-es2015": "^6.24.1",
		"babel-preset-stage-2": "^6.24.1",
		"chalk": "^1.1.3",
		"chromedriver": "^2.21.2",
		"cross-env": "^3.1.3",
		"cross-spawn": "^4.0.2",
		"css-loader": "^0.23.1",
		"css-mqpacker": "^6.0.1",
		"cssnano": "^3.10.0",
		"eslint": "^3.7.1",
		"eslint-config-standard": "^6.1.0",
		"eslint-config-vue": "^2.0.2",
		"eslint-friendly-formatter": "^2.0.5",
		"eslint-loader": "^1.6.1",
		"eslint-plugin-html": "^1.3.0",
		"eslint-plugin-promise": "^3.4.0",
		"eslint-plugin-pug": "^1.0.0",
		"eslint-plugin-standard": "^3.0.1",
		"eslint-plugin-vue": "^2.1.0",
		"eventsource-polyfill": "^0.9.6",
		"extract-text-webpack-plugin": "^3.0.0",
		"friendly-errors-webpack-plugin": "^1.6.1",
		"function-bind": "^1.0.2",
		"jest": "^20.0.4",
		"jest-cli": "^20.0.4",
		"jest-css-modules": "^1.1.0",
		"jest-serializer-html": "^4.0.0",
		"jest-vue-preprocessor": "^0.2.0",
		"lolex": "^1.4.0",
		"nightwatch": "^0.9.8",
		"opn": "^4.0.2",
		"optimize-css-assets-webpack-plugin": "^2.0.0",
		"optimize-js-plugin": "^0.0.4",
		"ora": "^0.3.0",
		"phantomjs-prebuilt": "^2.1.3",
		"postcss-loader": "^1.2.1",
		"precss": "^1.4.0",
		"pug": "^2.0.0-beta3",
		"pug-loader": "^2.3.0",
		"ress": "^1.1.1",
		"rimraf": "^2.5.4",
		"selenium-server": "2.53.1",
		"semver": "^5.3.0",
		"serialize-javascript": "^1.3.0",
		"shelljs": "^0.7.4",
		"style-loader": "^0.13.1",
		"stylus": "^0.54.5",
		"stylus-loader": "^2.1.1",
		"uglifyjs-webpack-plugin": "^0.4.6",
		"vue": "^2.4.1",
		"vue-loader": "^10.1.0",
		"vue-router": "^2.7.0",
		"vue-server-renderer": "^2.4.1",
		"vue-template-compiler": "^2.4.1",
		"webpack": "^3.2.0",
		"webpack-bundle-size-analyzer": "^2.7.0",
		"webpack-dev-server": "^2.6.1",
		"webpack-merge": "^4.1.0"
	},
	"dependencies": {},
	"engines": {
		"node": ">= 4.0.0",
		"npm": ">= 3.0.0"
	},
	"jest": {
		"verbose": false,
		"roots": [
			"<rootDir>/src"
		],
		"moduleFileExtensions": [
			"js",
			"vue"
		],
		"moduleDirectories": [
			"node_modules"
		],
		"moduleNameMapper": {
			"src/(.*)": "<rootDir>/src/$1"
		},
		"transform": {
			".*\\.(vue)$": "<rootDir>/node_modules/jest-vue-preprocessor",
			"\\.(styl)$": "<rootDir>/node_modules/jest-css-modules",
			".*\\.(vue|js)$": "<rootDir>/node_modules/babel-jest"
		},
		"transformIgnorePatterns": [
			"node_modules/(?!vue-router)"
		],
		"snapshotSerializers": [
			"jest-serializer-html"
		]
	}
};

/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__alerts__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__app__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__avatars__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__bottom_nav__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__buttons__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cards__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__carousel__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__chips__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__pickers__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__dialogs__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__dividers__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__expansion_panel__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__footer__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__grid__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__icons__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__lists__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__menus__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__toolbar__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__pagination__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__parallax__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__progress__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__selects__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__selection_controls__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__sliders__ = __webpack_require__(107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__subheaders__ = __webpack_require__(109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__steppers__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__tables__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__tabs__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__text_fields__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__snackbars__ = __webpack_require__(129);


































/* harmony default export */ __webpack_exports__["a"] = (Object.assign({}, __WEBPACK_IMPORTED_MODULE_0__alerts__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__app__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__avatars__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__bottom_nav__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__breadcrumbs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__buttons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_6__cards__["a" /* default */], __WEBPACK_IMPORTED_MODULE_7__carousel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_8__chips__["a" /* default */], __WEBPACK_IMPORTED_MODULE_9__pickers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_10__dialogs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_11__dividers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_12__expansion_panel__["a" /* default */], __WEBPACK_IMPORTED_MODULE_13__footer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_14__grid__["a" /* default */], __WEBPACK_IMPORTED_MODULE_15__icons__["a" /* default */], __WEBPACK_IMPORTED_MODULE_16__lists__["c" /* default */], __WEBPACK_IMPORTED_MODULE_17__menus__["a" /* default */], __WEBPACK_IMPORTED_MODULE_18__navigation_drawer__["a" /* default */], __WEBPACK_IMPORTED_MODULE_19__toolbar__["a" /* default */], __WEBPACK_IMPORTED_MODULE_20__pagination__["a" /* default */], __WEBPACK_IMPORTED_MODULE_21__parallax__["a" /* default */], __WEBPACK_IMPORTED_MODULE_22__progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_23__selects__["a" /* default */], __WEBPACK_IMPORTED_MODULE_24__selection_controls__["a" /* default */], __WEBPACK_IMPORTED_MODULE_25__sliders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_26__subheaders__["a" /* default */], __WEBPACK_IMPORTED_MODULE_27__steppers__["a" /* default */], __WEBPACK_IMPORTED_MODULE_28__tables__["a" /* default */], __WEBPACK_IMPORTED_MODULE_29__tabs__["a" /* default */], __WEBPACK_IMPORTED_MODULE_30__text_fields__["a" /* default */], __WEBPACK_IMPORTED_MODULE_31__transitions__["d" /* default */], __WEBPACK_IMPORTED_MODULE_32__snackbars__["a" /* default */]));

/***/ }),
/* 33 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VAlert__ = __webpack_require__(34);


/* harmony default export */ __webpack_exports__["a"] = ({
  VAlert: __WEBPACK_IMPORTED_MODULE_0__VAlert__["a" /* default */]
});

/***/ }),
/* 34 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__ = __webpack_require__(35);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-alert',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_transitionable__["a" /* default */]],

  props: {
    dismissible: Boolean,
    hideIcon: Boolean,
    icon: String
  },

  computed: {
    classes: function classes() {
      return {
        'alert': true,
        'alert--dismissible': this.dismissible,
        'error': this.error,
        'info': this.info,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'warning': this.warning
      };
    },
    mdIcon: function mdIcon() {
      switch (true) {
        case !!this.icon:
          return this.icon;
        case this.error:
          return 'warning';
        case this.info:
          return 'info';
        case this.success:
          return 'check_circle';
        case this.warning:
          return 'priority_high';
      }
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [h('div', this.$slots.default)];

    if (!this.hideIcon && this.mdIcon) {
      children.unshift(h('v-icon', {
        'class': 'alert__icon'
      }, this.mdIcon));
    }

    if (this.dismissible) {
      var close = h('a', {
        'class': 'alert__dismissible',
        domProps: { href: 'javascript:;' },
        on: { click: function click() {
            return _this.$emit('input', false);
          } }
      }, [h('v-icon', {
        props: { right: true }
      }, 'cancel')]);

      children.push(close);
    }

    var alert = h('div', {
      'class': this.classes,
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, children);

    if (!this.transition) return alert;

    return h('transition', {
      props: {
        name: this.transition,
        origin: this.origin,
        mode: this.mode
      }
    }, [alert]);
  }
});

/***/ }),
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    mode: String,
    origin: String,
    transition: String
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VApp__ = __webpack_require__(37);


/* harmony default export */ __webpack_exports__["a"] = ({
  VApp: __WEBPACK_IMPORTED_MODULE_0__VApp__["a" /* default */]
});

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    fixedFooter: Boolean,
    footer: Boolean,
    id: {
      type: String,
      default: 'app'
    },
    toolbar: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('application ' + (data.staticClass || '')).trim();
    data.staticClass += ' application--' + (props.dark ? 'dark' : 'light');

    props.footer && (data.staticClass += ' application--footer');
    props.fixedFooter && (data.staticClass += ' application--footer-fixed');
    props.toolbar && (data.staticClass += ' application--toolbar');

    data.attrs = { 'data-app': true };
    data.domProps = { id: props.id };

    return h('div', data, children);
  }
});

/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VAvatar */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var VAvatar = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('avatar');

/* harmony default export */ __webpack_exports__["a"] = ({
  VAvatar: VAvatar
});

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBottomNav__ = __webpack_require__(40);


/* harmony default export */ __webpack_exports__["a"] = ({
  VBottomNav: __WEBPACK_IMPORTED_MODULE_0__VBottomNav__["a" /* default */]
});

/***/ }),
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    shift: Boolean,
    value: { required: false }
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('bottom-nav ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' bottom-nav--absolute';
    if (props.shift) data.staticClass += ' bottom-nav--shift';
    if (props.value) data.staticClass += ' bottom-nav--active';

    return h('div', data, children);
  }
});

/***/ }),
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__ = __webpack_require__(43);



/* harmony default export */ __webpack_exports__["a"] = ({
  VBreadcrumbs: __WEBPACK_IMPORTED_MODULE_0__VBreadcrumbs__["a" /* default */],
  VBreadcrumbsItem: __WEBPACK_IMPORTED_MODULE_1__VBreadcrumbsItem__["a" /* default */]
});

/***/ }),
/* 42 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs',

  provide: function provide() {
    return {
      divider: this.divider
    };
  },


  props: {
    divider: {
      type: String,
      default: '/'
    },
    icons: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'breadcrumbs': true,
        'breadcrumbs--with-icons': this.icons
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': this.classes,
      props: { items: this.items }
    }, this.$slots.default);
  }
});

/***/ }),
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-breadcrumbs-item',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  inject: ['divider'],

  props: {
    activeClass: {
      type: String,
      default: 'breadcrumbs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = _defineProperty({
        'breadcrumbs__item': true
      }, this.activeClass, !this.disabled);

      return classes;
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      attrs: { 'data-divider': this.divider }
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__ = __webpack_require__(46);




/* harmony default export */ __webpack_exports__["a"] = ({
  VBtn: __WEBPACK_IMPORTED_MODULE_0__VBtn__["a" /* default */],
  VBtnToggle: __WEBPACK_IMPORTED_MODULE_1__VBtnToggle__["a" /* default */],
  VSpeedDial: __WEBPACK_IMPORTED_MODULE_2__VSpeedDial__["a" /* default */]
});

/***/ }),
/* 45 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-btn-toggle',

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: {
      required: false
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    mandatory: Boolean,
    multiple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'btn-toggle': true,
        'btn-toggle--selected': this.inputValue && (!this.multiple || this.inputValue.length)
      };
    }
  },

  methods: {
    isSelected: function isSelected(item) {
      if (!this.multiple) {
        return this.inputValue === item.value;
      }

      return this.inputValue.includes(item.value);
    },
    updateValue: function updateValue(item) {
      if (!this.multiple) {
        if (this.mandatory && this.inputValue === item.value) return;
        return this.$emit('change', this.inputValue === item.value ? null : item.value);
      }

      var items = this.inputValue.slice();

      var i = items.indexOf(item.value);
      if (i > -1) {
        items.length >= 1 && !this.mandatory && items.splice(i, 1);
      } else {
        items.push(item.value);
      }

      this.$emit('change', items);
    }
  },

  render: function render(h) {
    var _this = this;

    var buttons = this.items.map(function (item, index) {
      var children = [];

      item.text && children.push(h('span', item.text));
      item.icon && children.push(h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], item.icon));

      return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], {
        key: index,
        props: {
          flat: true
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.updateValue(item);
          }
        },
        attrs: {
          'data-selected': _this.isSelected(item),
          'data-index': index,
          'data-only-child': _this.isSelected(item) && (!_this.multiple || _this.inputValue.length === 1)
        }
      }, children);
    });

    return h('div', { class: this.classes }, buttons);
  }
});

/***/ }),
/* 46 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_positionable__ = __webpack_require__(12);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-speed-dial',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_positionable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    direction: {
      type: String,
      default: 'top',
      validator: function validator(val) {
        return ['top', 'right', 'bottom', 'left'].includes(val);
      }
    },
    hover: Boolean,
    transition: {
      type: String,
      default: 'scale-transition'
    }
  },

  computed: {
    classes: function classes() {
      return _defineProperty({
        'speed-dial': true,
        'speed-dial--top': this.top,
        'speed-dial--right': this.right,
        'speed-dial--bottom': this.bottom,
        'speed-dial--left': this.left,
        'speed-dial--absolute': this.absolute,
        'speed-dial--fixed': this.fixed
      }, 'speed-dial--direction-' + this.direction, true);
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [];
    var data = {
      'class': this.classes,
      directives: [{
        name: 'click-outside'
      }],
      on: {
        click: function click() {
          return _this.isActive = !_this.isActive;
        }
      }
    };

    if (this.hover) {
      data.on.mouseenter = function () {
        return _this.isActive = true;
      };
      data.on.mouseleave = function () {
        return _this.isActive = false;
      };
    }

    if (this.isActive) {
      children = (this.$slots.default || []).map(function (b, i) {
        b.key = i;

        return b;
      });
    }

    var list = h('transition-group', {
      'class': 'speed-dial__list',
      props: {
        name: this.transition,
        tag: 'div'
      }
    }, children);

    return h('div', data, [this.$slots.activator, list]);
  }
});

/***/ }),
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCard__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VCardMedia__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VCardTitle__ = __webpack_require__(49);





var VCardActions = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__actions');
var VCardText = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('card__text');

/* harmony default export */ __webpack_exports__["a"] = ({
  VCard: __WEBPACK_IMPORTED_MODULE_1__VCard__["a" /* default */],
  VCardActions: VCardActions,
  VCardMedia: __WEBPACK_IMPORTED_MODULE_2__VCardMedia__["a" /* default */],
  VCardText: VCardText,
  VCardTitle: __WEBPACK_IMPORTED_MODULE_3__VCardTitle__["a" /* default */]
});

/***/ }),
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-card-media',

  props: {
    contain: Boolean,
    height: {
      type: [Number, String],
      default: 'auto'
    },
    src: {
      type: String
    }
  },

  render: function render(h) {
    var data = {
      'class': 'card__media',
      style: {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      },
      on: this.$listeners
    };

    var children = [];

    if (this.src) {
      children.push(h('div', {
        'class': 'card__media__background',
        style: {
          background: 'url(' + this.src + ') center center / ' + (this.contain ? 'contain' : 'cover') + ' no-repeat'
        }
      }));
    }

    children.push(h('div', {
      'class': 'card__media__content'
    }, this.$slots.default));

    return h('div', data, children);
  }
});

/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    primaryTitle: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('card__title ' + (data.staticClass || '')).trim();

    if (props.primaryTitle) data.staticClass += ' card__title--primary';

    return h('div', data, children);
  }
});

/***/ }),
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCarousel__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__ = __webpack_require__(52);



/* harmony default export */ __webpack_exports__["a"] = ({
  VCarousel: __WEBPACK_IMPORTED_MODULE_0__VCarousel__["a" /* default */],
  VCarouselItem: __WEBPACK_IMPORTED_MODULE_1__VCarouselItem__["a" /* default */]
});

/***/ }),
/* 51 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__ = __webpack_require__(1);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      current: null,
      items: [],
      slideInterval: {},
      reverse: false
    };
  },


  props: {
    cycle: {
      type: Boolean,
      default: true
    },
    icon: {
      type: String,
      default: 'fiber_manual_record'
    },
    interval: {
      type: Number,
      default: 6000
    },
    leftControlIcon: {
      type: [Boolean, String],
      default: 'chevron_left'
    },
    rightControlIcon: {
      type: [Boolean, String],
      default: 'chevron_right'
    }
  },

  computed: {
    defaultState: function defaultState() {
      return {
        current: null,
        reverse: false
      };
    }
  },

  watch: {
    current: function current() {
      var _this = this;

      // Evaluate items when current changes to account for
      // dynamic changing of children
      this.items = this.$children.filter(function (i) {
        return i.$el.classList && i.$el.classList.contains('carousel__item');
      });

      this.items.forEach(function (i) {
        return i.open(_this.items[_this.current]._uid, _this.reverse);
      });

      !this.isBooted && this.cycle && this.restartInterval();
      this.isBooted = true;
    },
    cycle: function cycle(val) {
      val && this.restartInterval() || clearInterval(this.slideInterval);
    }
  },

  mounted: function mounted() {
    this.init();
  },


  methods: {
    genControls: function genControls() {
      return this.$createElement('div', {
        staticClass: 'carousel__controls'
      }, this.genItems());
    },
    genIcon: function genIcon(direction, icon, fn) {
      if (!icon) return null;

      return this.$createElement('div', {
        staticClass: 'carousel__' + direction
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
        props: {
          icon: true,
          dark: this.dark || !this.light,
          light: this.light
        },
        on: { click: fn }
      }, [this.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], icon)])]);
    },
    genItems: function genItems() {
      var _this2 = this;

      return this.items.map(function (item, index) {
        return _this2.$createElement(__WEBPACK_IMPORTED_MODULE_1__components_buttons_VBtn__["a" /* default */], {
          class: {
            'carousel__controls__item': true,
            'carousel__controls__item--active': index === _this2.current
          },
          props: {
            icon: true,
            dark: _this2.dark || !_this2.light,
            light: _this2.light
          },
          key: index,
          on: { click: _this2.select.bind(_this2, index) }
        }, [_this2.$createElement(__WEBPACK_IMPORTED_MODULE_2__components_icons_VIcon__["a" /* default */], _this2.icon)]);
      });
    },
    restartInterval: function restartInterval() {
      clearInterval(this.slideInterval);
      this.$nextTick(this.startInterval);
    },
    init: function init() {
      this.current = 0;
    },
    next: function next() {
      this.reverse = false;

      if (this.current + 1 === this.items.length) {
        return this.current = 0;
      }

      this.current++;
    },
    prev: function prev() {
      this.reverse = true;

      if (this.current - 1 < 0) {
        return this.current = this.items.length - 1;
      }

      this.current--;
    },
    select: function select(index) {
      this.reverse = index < this.current;
      this.current = index;
    },
    startInterval: function startInterval() {
      this.slideInterval = setInterval(this.next, this.interval);
    }
  },

  render: function render(h) {
    return h('div', {
      staticClass: 'carousel',
      directives: [{
        name: 'touch',
        value: {
          left: this.next,
          right: this.prev
        }
      }]
    }, [this.genIcon('left', this.leftControlIcon, this.prev), this.genIcon('right', this.rightControlIcon, this.next), this.genControls(), this.$slots.default]);
  }
});

/***/ }),
/* 52 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-carousel-item',

  data: function data() {
    return {
      active: false,
      reverse: false
    };
  },


  props: {
    src: {
      type: String,
      required: true
    },

    transition: {
      type: String,
      default: 'tab-transition'
    },

    reverseTransition: {
      type: String,
      default: 'tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    },
    styles: function styles() {
      return {
        backgroundImage: 'url(' + this.src + ')'
      };
    }
  },

  methods: {
    open: function open(id, reverse) {
      this.active = this._uid === id;
      this.reverse = reverse;
    }
  },

  render: function render(h) {
    var item = h('div', {
      class: {
        'carousel__item': true,
        'reverse': this.reverse
      },
      style: this.styles,
      on: this.$listeners,
      directives: [{
        name: 'show',
        value: this.active
      }]
    }, [this.$slots.default]);

    return h('transition', { props: { name: this.computedTransition } }, [item]);
  }
});

/***/ }),
/* 53 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VChip__ = __webpack_require__(54);


/* harmony default export */ __webpack_exports__["a"] = ({
  VChip: __WEBPACK_IMPORTED_MODULE_0__VChip__["a" /* default */]
});

/***/ }),
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__ = __webpack_require__(2);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-chip',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_toggleable__["a" /* default */]],

  props: {
    close: Boolean,
    label: Boolean,
    outline: Boolean,
    small: Boolean,
    value: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'chip': true,
        'chip--label': this.label,
        'chip--outline': this.outline,
        'chip--small': this.small,
        'chip--removable': this.close
      };
    }
  },

  render: function render(h) {
    var _this = this;

    var children = [this.$slots.default];
    var data = {
      'class': this.classes,
      attrs: { tabindex: -1 },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    };

    if (this.close) {
      children.push(h('a', {
        'class': 'chip__close',
        domProps: { href: 'javascript:;' },
        on: {
          click: function click(e) {
            e.stopPropagation();

            _this.$emit('input', false);
          }
        }
      }, [h('v-icon', { props: { right: true } }, 'cancel')]));
    }

    return h('span', data, children);
  }
});

/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDatePicker__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTimePicker__ = __webpack_require__(61);



/* harmony default export */ __webpack_exports__["a"] = ({
  VDatePicker: __WEBPACK_IMPORTED_MODULE_0__VDatePicker__["a" /* default */],
  VTimePicker: __WEBPACK_IMPORTED_MODULE_1__VTimePicker__["a" /* default */]
});

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_date_title__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__util_helpers__ = __webpack_require__(0);







var defaultDateFormat = function defaultDateFormat(val) {
  return new Date(val).toISOString().substr(0, 10);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-date-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_date_title__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_date_header__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_date_table__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_date_years__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_picker__["a" /* default */]],

  data: function data() {
    return {
      tableDate: new Date(),
      originalDate: this.value,
      currentDay: null,
      currentMonth: null,
      currentYear: null,
      isSelected: false,
      isReversing: false,
      narrowDays: []
    };
  },


  props: {
    locale: {
      type: String,
      default: 'en-us'
    },
    dateFormat: {
      type: Function,
      default: defaultDateFormat
    },
    titleDateFormat: {
      type: Object,
      default: function _default() {
        return { weekday: 'short', month: 'short', day: 'numeric' };
      }
    },
    headerDateFormat: {
      type: Object,
      default: function _default() {
        return { month: 'long', year: 'numeric' };
      }
    },
    formattedValue: {
      required: false
    },
    allowedDates: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    firstDayOfWeek: {
      type: [String, Number],
      default: 0
    },
    yearIcon: String
  },

  computed: {
    firstAllowedDate: function firstAllowedDate() {
      var date = new Date();
      date.setHours(12, 0, 0, 0);

      if (this.allowedDates) {
        var millisecondOffset = 1 * 24 * 60 * 60 * 1000;
        var valid = new Date(date);
        for (var i = 0; i < 31; i++) {
          if (this.isAllowed(valid)) return valid;

          valid.setTime(valid.getTime() + millisecondOffset);
        }
      }

      return date;
    },

    inputDate: {
      get: function get() {
        if (!this.value) return this.firstAllowedDate;
        if (this.value instanceof Date) return this.value;
        if (!isNaN(this.value) || typeof this.value === 'string' && this.value.indexOf(':') !== -1) return new Date(this.value);

        return new Date(this.value + 'T12:00:00');
      },
      set: function set(val) {
        this.$emit('input', val ? defaultDateFormat(val) : this.originalDate);
        this.$emit('update:formattedValue', val ? this.dateFormat(val) : this.dateFormat(this.originalDate));
      }
    },
    day: function day() {
      return this.inputDate.getDate();
    },
    month: function month() {
      return this.inputDate.getMonth();
    },
    year: function year() {
      return this.inputDate.getFullYear();
    },
    tableMonth: function tableMonth() {
      return this.tableDate.getMonth();
    },
    tableYear: function tableYear() {
      return this.tableDate.getFullYear();
    },
    computedTransition: function computedTransition() {
      return this.isReversing ? 'v-tab-reverse-transition' : 'v-tab-transition';
    }
  },

  watch: {
    isSelected: function isSelected(val) {
      var _this = this;

      val && this.$nextTick(function () {
        _this.$refs.years.scrollTop = _this.$refs.years.scrollHeight / 2 - 125;
      });
    },
    tableDate: function tableDate(val, prev) {
      this.isReversing = val < prev;
    },
    value: function value(val) {
      if (val) this.tableDate = this.inputDate;
    }
  },

  methods: {
    save: function save() {
      if (this.originalDate) {
        this.originalDate = this.value;
      } else {
        this.originalDate = this.inputDate;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputDate = this.originalDate;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(date) {
      if (!this.allowedDates) return true;

      if (Array.isArray(this.allowedDates)) {
        return !!this.allowedDates.find(function (allowedDate) {
          var d = new Date(allowedDate);
          d.setHours(12, 0, 0, 0);

          return d - date === 0;
        });
      } else if (this.allowedDates instanceof Function) {
        return this.allowedDates(date);
      } else if (this.allowedDates instanceof Object) {
        var min = new Date(this.allowedDates.min);
        min.setHours(12, 0, 0, 0);
        var max = new Date(this.allowedDates.max);
        max.setHours(12, 0, 0, 0);

        return date >= min && date <= max;
      }

      return true;
    }
  },

  created: function created() {
    var _this2 = this;

    var date = new Date();
    date.setDate(date.getDate() - date.getDay() + parseInt(this.firstDayOfWeek));

    Object(__WEBPACK_IMPORTED_MODULE_5__util_helpers__["c" /* createRange */])(7).forEach(function () {
      var narrow = date.toLocaleString(_this2.locale, { weekday: 'narrow' });
      _this2.narrowDays.push(narrow);

      date.setDate(date.getDate() + 1);
    });
  },
  mounted: function mounted() {
    this.currentDay = this.tableDate.getDate();
    this.currentMonth = this.tableDate.getMonth();
    this.currentYear = this.tableDate.getFullYear();
    this.tableDate = this.inputDate;
  },
  render: function render(h) {
    var children = [];

    !this.noTitle && children.push(this.genTitle());

    if (!this.isSelected) {
      var bodyChildren = [];

      bodyChildren.push(this.genHeader());
      bodyChildren.push(this.genTable());

      children.push(h('div', {
        'class': 'picker__body'
      }, bodyChildren));
    } else {
      children.push(this.genYears());
    }

    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--date': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark
      }
    }, children);
  }
});

/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYearIcon: function genYearIcon() {
      return this.yearIcon ? this.$createElement('v-icon', {
        props: {
          dark: true
        }
      }, this.yearIcon) : null;
    },
    genTitle: function genTitle() {
      var _this = this;

      var date = new Date(this.year, this.month, this.day);
      date = date.toLocaleString(this.locale, this.titleDateFormat);

      if (this.landscape) {
        if (date.indexOf(',') > -1) date = date.replace(',', ',<br>');else if (date.indexOf(' ') > -1) date = date.replace(' ', '<br>');
      }

      var text = this.$createElement('transition', {
        props: {
          name: 'slide-x-transition',
          mode: 'out-in'
        }
      }, [this.$createElement('div', {
        domProps: { innerHTML: date },
        key: date
      })]);

      return this.$createElement('div', {
        'class': 'picker__title'
      }, [this.$createElement('div', {
        'class': {
          'picker--date__title-year': true,
          'active': this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = true;
          }
        }
      }, [this.year, this.genYearIcon()]), this.$createElement('div', {
        'class': {
          'picker--date__title-date': true,
          'active': !this.isSelected
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this.isSelected = false;
          }
        }
      }, [text])]);
    }
  }
});

/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genHeader: function genHeader() {
      return this.$createElement('div', {
        'class': 'picker--date__header'
      }, [this.genSelector()]);
    },
    genBtn: function genBtn(change, children) {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          dark: this.dark,
          icon: true
        },
        nativeOn: {
          click: function click(e) {
            e.stopPropagation();
            _this.tableDate = new Date(_this.tableYear, change);
          }
        }
      }, children);
    },
    genSelector: function genSelector() {
      var date = new Date(this.tableYear, this.tableMonth);
      var header = this.$createElement('div', {
        'class': 'picker--date__header-selector-date'
      }, [this.$createElement(this.computedTransition, [this.$createElement('strong', {
        key: this.tableMonth
      }, date.toLocaleString(this.locale, this.headerDateFormat))])]);

      return this.$createElement('div', {
        'class': 'picker--date__header-selector'
      }, [this.genBtn(this.tableMonth - 1, [this.$createElement('v-icon', 'chevron_left')]), header, this.genBtn(this.tableMonth + 1, [this.$createElement('v-icon', 'chevron_right')])]);
    }
  }
});

/***/ }),
/* 59 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    wheelScroll: function wheelScroll(e) {
      e.preventDefault();

      var month = this.tableMonth;

      if (e.deltaY < 0) month++;else month--;

      this.tableDate = new Date(this.tableYear, month);
    },
    touch: function touch(value) {
      this.tableDate = new Date(this.tableYear, this.tableMonth + value);
    },
    genTable: function genTable() {
      var _this = this;

      var children = [];
      var data = {
        'class': 'picker--date__table',
        directives: [{
          name: 'touch',
          value: {
            left: function left(e) {
              return e.offsetX < -15 && _this.touch(1);
            },
            right: function right(e) {
              return e.offsetX > 15 && _this.touch(-1);
            }
          }
        }]
      };

      if (this.scrollable) {
        data.on = { wheel: this.wheelScroll };
      }

      children.push(this.$createElement('table', {
        key: this.tableMonth
      }, [this.genTHead(), this.genTBody()]));

      return this.$createElement('div', data, [this.$createElement(this.computedTransition, children)]);
    },
    genTHead: function genTHead() {
      var _this2 = this;

      var days = this.narrowDays.map(function (day) {
        return _this2.$createElement('th', day);
      });
      return this.$createElement('thead', this.genTR(days));
    },
    genTBody: function genTBody() {
      var _this3 = this;

      var children = [];
      var rows = [];
      var length = new Date(this.tableYear, this.tableMonth + 1, 0).getDate();

      var day = new Date(this.tableYear, this.tableMonth).getDay() - parseInt(this.firstDayOfWeek);

      for (var i = 0; i < day; i++) {
        rows.push(this.$createElement('td'));
      }

      var _loop = function _loop(_i) {
        var date = new Date(_this3.tableYear, _this3.tableMonth, _i, 12, 0, 0, 0);
        rows.push(_this3.$createElement('td', [_this3.$createElement('button', {
          'class': {
            'btn btn--floating btn--small btn--flat': true,
            'btn--active': _this3.isActive(_i),
            'btn--current': _this3.isCurrent(_i),
            'btn--light': _this3.dark,
            'btn--disabled': !_this3.isAllowed(date)
          },
          attrs: {
            type: 'button'
          },
          domProps: {
            innerHTML: '<span class="btn__content">' + _i + '</span>'
          },
          on: {
            click: function click() {
              var day = _i < 10 ? '0' + _i : _i;
              var tableYear = _this3.tableYear;
              var tableMonth = _this3.tableMonth + 1;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;

              _this3.inputDate = tableYear + '-' + tableMonth + '-' + day + 'T12:00:00';
              _this3.$nextTick(function () {
                return _this3.autosave && _this3.save();
              });
            }
          }
        })]));

        if (rows.length % 7 === 0) {
          children.push(_this3.genTR(rows));
          rows = [];
        }
      };

      for (var _i = 1; _i <= length; _i++) {
        _loop(_i);
      }

      if (rows.length) {
        children.push(this.genTR(rows));
      }

      children.length < 6 && children.push(this.genTR([this.$createElement('td', { domProps: { innerHTML: '&nbsp;' } })]));

      return this.$createElement('tbody', children);
    },
    genTR: function genTR() {
      var children = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return [this.$createElement('tr', data, children)];
    },
    isActive: function isActive(i) {
      return this.tableYear === this.year && this.tableMonth === this.month && this.day === i;
    },
    isCurrent: function isCurrent(i) {
      return this.currentYear === this.tableYear && this.currentMonth === this.tableMonth && this.currentDay === i;
    }
  }
});

/***/ }),
/* 60 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genYears: function genYears() {
      return this.$createElement('ul', {
        'class': 'picker--date__years',
        ref: 'years'
      }, this.genYearItems());
    },
    genYearItems: function genYearItems() {
      var _this = this;

      var children = [];

      var _loop = function _loop(i, length) {
        children.push(_this.$createElement('li', {
          'class': {
            active: _this.year === i
          },
          on: {
            click: function click(e) {
              e.stopPropagation();

              var tableMonth = _this.tableMonth + 1;
              var day = _this.day;
              tableMonth = tableMonth < 10 ? '0' + tableMonth : tableMonth;
              day = day < 10 ? '0' + day : day;

              _this.inputDate = i + '-' + tableMonth + '-' + day;
              _this.isSelected = false;
            }
          }
        }, i));
      };

      for (var i = this.year + 100, length = this.year - 100; i > length; i--) {
        _loop(i, length);
      }
      return children;
    }
  }
});

/***/ }),
/* 61 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_picker__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__util_helpers__ = __webpack_require__(0);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-time-picker',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_picker__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_time_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_time_title__["a" /* default */]],

  data: function data() {
    return {
      isDragging: false,
      rotate: 0,
      originalTime: this.value,
      period: 'am',
      selectingHour: true,
      ranges: {
        hours: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(24),
        minutes: Object(__WEBPACK_IMPORTED_MODULE_3__util_helpers__["c" /* createRange */])(60)
      }
    };
  },


  props: {
    format: {
      type: String,
      default: 'ampm',
      validator: function validator(val) {
        return ['ampm', '24hr'].includes(val);
      }
    },
    allowedHours: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    },
    allowedMinutes: {
      type: [Array, Object, Function],
      default: function _default() {
        return null;
      }
    }
  },

  computed: {
    is24hr: function is24hr() {
      return this.format !== 'ampm';
    },
    is24hrAfter12: function is24hrAfter12() {
      return this.selectingHour && this.is24hr && this.hour >= 12;
    },
    divider: function divider() {
      return this.selectingHour ? 12 : 60;
    },
    degrees: function degrees() {
      return this.degreesPerUnit * Math.PI / 180;
    },
    degreesPerUnit: function degreesPerUnit() {
      return 360 / this.divider;
    },

    inputTime: {
      get: function get() {
        if (this.value && !(this.value instanceof Date)) {
          if (!this.is24hr) {
            this.period = this.value.match(/pm/) ? 'pm' : 'am';
          }

          return this.value;
        }
        var value = new Date();

        if (this.value instanceof Date) {
          value = this.value;
        }

        var hour = value.getHours();
        var minute = value.getMinutes();
        var period = '';

        if (!this.is24hr) {
          hour = hour > 12 ? hour - 12 : hour;
          period = hour > 12 ? 'pm' : 'am';
        }

        period && (this.period = period);

        hour = this.firstAllowed('hour', hour);
        minute = this.firstAllowed('minute', minute);

        return hour + ':' + minute + period;
      },
      set: function set(val) {
        return this.$emit('input', val);
      }
    },
    timeArray: function timeArray() {
      return this.inputTime.replace(/(am|pm)/, '').split(':');
    },

    hour: {
      get: function get() {
        return parseInt(this.timeArray[0]);
      },
      set: function set(val) {
        if (!this.is24hr) {
          val = val > 12 ? val - 12 : val < 1 ? 12 : val;
        } else {
          val = val < 10 ? '0' + val : val > 23 ? '00' : val;
        }

        this.inputTime = val + ':' + this.minute + (!this.is24hr ? this.period : '');
      }
    },
    minute: {
      get: function get() {
        var minute = parseInt(this.timeArray[1]);

        return minute < 10 ? '0' + minute : minute > 59 ? '00' : minute;
      },
      set: function set(val) {
        val = val < 10 ? '0' + parseInt(val) : val > 59 ? '00' : val;
        var hour = this.hour;

        if (this.is24hr && hour < 10) {
          hour = '0' + hour;
        }

        this.inputTime = hour + ':' + val + (!this.is24hr ? this.period : '');
      }
    },
    clockHand: function clockHand() {
      if (this.selectingHour) return this.degreesPerUnit * this.hour;
      return this.degreesPerUnit * this.minute;
    },
    radius: function radius() {
      return this.clockSize / 2;
    },

    clockSize: {
      get: function get() {
        return this.size;
      },
      set: function set(val) {
        this.size = val;
      }
    },
    size: function size() {
      return this.landscape ? 250 : 280;
    }
  },

  watch: {
    period: function period(val) {
      var hour = !!this.allowedHours && this.selectingHour ? this.firstAllowed('hour', this.hour - 1) : this.hour;
      this.inputTime = hour + ':' + this.minute + val;
    },
    value: function value(val) {
      if (this.isSaving) {
        this.originalTime = this.inputTime;
        this.isSaving = false;
      }
    }
  },

  methods: {
    save: function save() {
      if (this.originalTime) {
        this.originalTime = this.value;
      } else {
        this.inputTime = this.inputTime;
        this.originalTime = this.inputTime;
      }

      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    cancel: function cancel() {
      this.inputTime = this.originalTime;
      if (this.$parent && this.$parent.isActive) this.$parent.isActive = false;
    },
    isAllowed: function isAllowed(type, value) {
      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return true;

      if (Array.isArray(allowed)) {
        return !!allowed.find(function (v) {
          return v === value;
        });
      } else if (allowed instanceof Function) {
        return allowed(value);
      } else if (allowed === Object(allowed)) {
        var range = type === 'minute' ? this.ranges.minutes : this.ranges.hours;
        var mod = type === 'minute' ? 60 : 24;

        if (allowed.min === String(allowed.min)) {
          allowed.min = this.convert12to24hr(allowed.min);
        }

        if (allowed.max === String(allowed.max)) {
          allowed.max = this.convert12to24hr(allowed.max);
        }

        var steps = allowed.max - allowed.min;
        value = type === 'hour' && !this.is24hr && this.period === 'pm' ? value + 12 : value;

        for (var i = 0; i <= steps; i++) {
          var index = (allowed.min + i) % mod;
          if (range[index] === value) return true;
        }

        return false;
      }

      return true;
    },
    convert12to24hr: function convert12to24hr(input) {
      input = input.toLowerCase();
      var pm = input.indexOf('pm') !== -1;
      var hour = parseInt(input.slice(0, input.indexOf(pm ? 'pm' : 'am')));

      return pm ? hour + 12 : hour;
    },
    generateRange: function generateRange(type, start) {
      var range = type === 'hour' ? this.ranges.hours : this.ranges.minutes;
      var offset = 1;

      if (type === 'hour' && !this.is24hr) {
        range = range.slice(1, 13);
        offset = 0;
      }

      return range.slice(start + offset, range.length).concat(range.slice(0, start + offset));
    },
    firstAllowed: function firstAllowed(type, value) {
      var _this = this;

      var allowed = this['allowed' + (type.charAt(0).toUpperCase() + type.slice(1)) + 's'];

      if (!allowed) return value;

      var range = this.generateRange(type, value);

      var first = range.find(function (v) {
        return _this.isAllowed(type, v);
      });

      return first || value;
    }
  },

  render: function render(h) {
    var children = [this.genBody()];

    !this.noTitle && children.unshift(this.genTitle());
    this.$scopedSlots.default && children.push(this.genSlot());

    return h('v-card', {
      'class': {
        'picker picker--time': true,
        'picker--landscape': this.landscape,
        'picker--dark': this.dark,
        'picker--light': this.light && !this.dark,
        'picker--time--hours': this.selectingHour
      }
    }, children);
  }
});

/***/ }),
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTitle: function genTitle() {
      var children = [this.genTime()];

      if (this.format === 'ampm') {
        children.push(this.genAMPM());
      }

      return this.$createElement('div', {
        'class': 'picker__title'
      }, children);
    },
    genTime: function genTime() {
      var _this = this;

      var hour = this.hour;

      if (this.is24hr && hour < 10) {
        hour = '0' + hour;
      }

      return this.$createElement('div', {
        'class': 'picker--time__title'
      }, [this.$createElement('span', {
        'class': { active: this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = true;
          }
        }
      }, hour), this.$createElement('span', {
        'class': { active: !this.selectingHour },
        on: {
          click: function click() {
            return _this.selectingHour = false;
          }
        }
      }, ':' + this.minute)]);
    },
    genAMPM: function genAMPM() {
      return this.$createElement('div', [this.genPeriod('am'), this.genPeriod('pm')]);
    },
    genPeriod: function genPeriod(period) {
      var _this2 = this;

      return this.$createElement('span', {
        'class': { active: this.period === period },
        on: { click: function click() {
            return _this2.period = period;
          } }
      }, period.toUpperCase());
    }
  }
});

/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      hasChanged: false
    };
  },

  methods: {
    genBody: function genBody() {
      var _this = this;

      var children = [this.genHand(this.selectingHour ? 'hour' : 'minute')];
      var data = {
        'class': 'picker--time__clock',
        on: {
          mousedown: this.onMouseDown,
          mouseup: this.onMouseUp,
          mouseleave: function mouseleave() {
            _this.isDragging && _this.onMouseUp();
          },
          touchstart: this.onMouseDown,
          touchend: this.onMouseUp,
          mousemove: this.onDragMove,
          touchmove: this.onDragMove
        },
        key: this.selectingHour ? 'hour' : 'minute',
        ref: 'clock'
      };

      this.selectingHour && children.push(this.genHours()) || children.push(this.genMinutes());

      if (this.scrollable) {
        data.on.wheel = function (e) {
          e.preventDefault();

          var diff = e.wheelDelta > 0 ? 1 : -1;
          var changing = _this.selectingHour ? 'changeHour' : 'changeMinute';

          _this[changing](diff);
        };
      }

      return this.$createElement('div', {
        'class': 'picker__body'
      }, [this.$createElement('v-fade-transition', {
        props: { mode: 'out-in' }
      }, [this.$createElement('div', data, children)])]);
    },
    genHand: function genHand(type) {
      var scale = this.is24hrAfter12 ? 'scaleY(0.6)' : '';
      return [this.$createElement('div', {
        'class': 'picker--time__clock-hand ' + type,
        style: {
          transform: 'rotate(' + this.clockHand + 'deg) ' + scale
        }
      })];
    },
    genHours: function genHours() {
      var hours = this.is24hr ? 24 : 12;
      var children = [];
      var start = 0;

      if (hours === 12) {
        hours++;
        start = 1;
      }

      for (var i = start; i < hours; i++) {
        children.push(this.$createElement('span', {
          'class': {
            'active': i === this.hour,
            'disabled': !this.isAllowed('hour', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + i + '</span>' }
        }));
      }

      return children;
    },
    genMinutes: function genMinutes() {
      var children = [];

      for (var i = 0; i < 60; i = i + 5) {
        var num = i;

        if (num < 10) num = '0' + num;
        if (num === 60) num = '00';

        children.push(this.$createElement('span', {
          'class': {
            'active': num.toString() === this.minute.toString(),
            'disabled': !this.isAllowed('minute', i)
          },
          style: this.getTransform(i),
          domProps: { innerHTML: '<span>' + num + '</span>' }
        }));
      }

      return children;
    },
    getTransform: function getTransform(i) {
      var _getPosition = this.getPosition(i),
          x = _getPosition.x,
          y = _getPosition.y;

      return { transform: 'translate(' + x + 'px, ' + y + 'px)' };
    },
    getPosition: function getPosition(i) {
      var radiusPercentage = this.selectingHour && this.is24hr && i >= 12 ? 0.5 : 0.8;
      var r = this.radius * radiusPercentage;
      i = this.selectingHour && this.is24hr ? i % 12 : i;
      return {
        x: Math.round(Math.sin(i * this.degrees) * r),
        y: Math.round(-Math.cos(i * this.degrees) * r)
      };
    },
    changeHour: function changeHour(time) {
      var _this2 = this;

      var range = this.generateRange('hour', this.hour);

      time < 0 && (range = range.reverse().slice(1));
      this.hour = range.find(function (h) {
        return _this2.allowedHours ? _this2.isAllowed('hour', h) : true;
      });

      return true;
    },
    changeMinute: function changeMinute(time) {
      var _this3 = this;

      var current = Number(this.minute);
      var range = this.generateRange('minute', current);

      time < 0 && (range = range.reverse().slice(1));
      var minute = range.find(function (m) {
        return _this3.allowedMinutes ? _this3.isAllowed('minute', m) : true;
      });

      this.minute = minute < 10 ? '0' + minute : minute;

      return true;
    },
    onMouseDown: function onMouseDown(e) {
      e.preventDefault();

      this.isDragging = true;
      this.onDragMove(e);
    },
    onMouseUp: function onMouseUp() {
      this.isDragging = false;
      !this.selectingHour && this.autosave && this.save();
      if (this.hasChanged) {
        this.selectingHour = false;
        this.hasChanged = false;
      }
    },
    onDragMove: function onDragMove(e) {
      e.preventDefault();
      if (!this.isDragging && e.type !== 'click') return;

      var rect = this.$refs.clock.getBoundingClientRect();
      var center = { x: rect.width / 2, y: 0 - rect.width / 2 };
      var clientY = 'touches' in e ? e.touches[0].clientY : e.clientY;
      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var coords = {
        y: rect.top - clientY,
        x: clientX - rect.left
      };

      var selecting = this.selectingHour ? 'hour' : 'minute';
      var value = Math.round(this.angle(center, coords) / this.degreesPerUnit);

      if (this.selectingHour && this.is24hr) {
        var insideClick = this.euclidean(center, coords) / this.radius < 0.65;
        value = insideClick ? value + 12 : value;

        // Necessary to fix edge case when selecting left part of 0 and 12
        value = this.angle(center, coords) >= 345 ? (value + 12) % 24 : value;
      }

      if (this.isAllowed(selecting, value)) {
        this[selecting] = value;
        this.hasChanged = true;
      }
    },
    euclidean: function euclidean(p0, p1) {
      var dx = Math.abs(p1.x - p0.x);
      var dy = Math.abs(p1.y - p0.y);

      return Math.sqrt(dx * dx + dy * dy);
    },
    angle: function angle(center, p1) {
      var p0 = {
        x: center.x,
        y: center.y + Math.sqrt(Math.abs(p1.x - center.x) * Math.abs(p1.x - center.x) + Math.abs(p1.y - center.y) * Math.abs(p1.y - center.y))
      };

      var value = 2 * Math.atan2(p1.y - p0.y, p1.x - p0.x);
      return Math.abs(value * 180 / Math.PI);
    }
  }
});

/***/ }),
/* 64 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDialog__ = __webpack_require__(65);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDialog: __WEBPACK_IMPORTED_MODULE_0__VDialog__["a" /* default */]
});

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__ = __webpack_require__(15);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-dialog',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_detachable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_toggleable__["a" /* default */]],

  props: {
    disabled: Boolean,
    persistent: Boolean,
    fullscreen: Boolean,
    fullWidth: Boolean,
    lazy: Boolean,
    origin: {
      type: String,
      default: 'center center'
    },
    width: {
      type: [String, Number],
      default: 290
    },
    scrollable: Boolean,
    transition: {
      type: [String, Boolean],
      default: 'dialog-transition'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'dialog': true,
        'dialog--active': this.isActive,
        'dialog--persistent': this.persistent,
        'dialog--fullscreen': this.fullscreen,
        'dialog--stacked-actions': this.stackedActions && !this.fullscreen,
        'dialog--scrollable': this.scrollable
      };
    }
  },

  watch: {
    isActive: function isActive(val) {
      if (val) {
        !this.fullscreen && !this.hideOverlay && this.genOverlay();
        this.fullscreen && this.hideScroll();
      } else {
        if (!this.fullscreen) this.removeOverlay();else this.showScroll();
      }
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.isBooted = this.isActive;
    this.$vuetify.load(function () {
      return _this.isActive && _this.genOverlay();
    });
  },


  methods: {
    closeConditional: function closeConditional(e) {
      // close dialog if !persistent and clicked outside
      return !this.persistent;
    }
  },

  render: function render(h) {
    var _this2 = this;

    var children = [];
    var data = {
      'class': this.classes,
      ref: 'dialog',
      directives: [{ name: 'click-outside', value: this.closeConditional }, { name: 'show', value: this.isActive }]
    };

    if (!this.fullscreen) {
      data.style = {
        width: isNaN(this.width) ? this.width : this.width + 'px'
      };
    }

    if (this.$slots.activator) {
      children.push(h('div', {
        'class': 'dialog__activator',
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (!_this2.disabled) _this2.isActive = !_this2.isActive;
          }
        }
      }, [this.$slots.activator]));
    }

    var dialog = h('transition', {
      props: {
        name: this.transition || '', // If false, show nothing
        origin: this.origin
      }
    }, [h('div', data, this.showLazyContent(this.$slots.default))]);

    children.push(h('div', {
      'class': ('dialog__content ' + this.contentClass).trim(),
      ref: 'content'
    }, [dialog]));

    return h('div', {
      'class': 'dialog__container',
      style: {
        display: !this.$slots.activator && 'none' || this.fullWidth ? 'block' : 'inline-block'
      }
    }, children);
  }
});

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VDivider__ = __webpack_require__(67);


/* harmony default export */ __webpack_exports__["a"] = ({
  VDivider: __WEBPACK_IMPORTED_MODULE_0__VDivider__["a" /* default */]
});

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var props = _ref.props,
        data = _ref.data,
        children = _ref.children;

    data.staticClass = ('divider ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.inset) data.staticClass += ' divider--inset';
    if (props.light) data.staticClass += ' theme--light';

    return h('hr', data);
  }
});

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__ = __webpack_require__(70);



/* harmony default export */ __webpack_exports__["a"] = ({
  VExpansionPanel: __WEBPACK_IMPORTED_MODULE_0__VExpansionPanel__["a" /* default */],
  VExpansionPanelContent: __WEBPACK_IMPORTED_MODULE_1__VExpansionPanelContent__["a" /* default */]
});

/***/ }),
/* 69 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel',

  props: {
    expand: Boolean
  },

  computed: {
    params: function params() {
      return {
        expand: this.expand
      };
    }
  },

  render: function render(h) {
    return h('ul', {
      'class': 'expansion-panel'
    }, this.$slots.default);
  }
});

/***/ }),
/* 70 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-expansion-panel-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      height: 'auto'
    };
  },


  props: {
    ripple: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'expansion-panel__header': true,
        'expansion-panel__header--active': this.isActive
      };
    }
  },

  methods: {
    closeConditional: function closeConditional(e) {
      return this.$parent.$el.contains(e.target) && !this.$parent.expand && !this.$el.contains(e.target);
    },
    toggle: function toggle() {
      this.isActive = !this.isActive;
    },
    genHeader: function genHeader(h) {
      var _this = this;

      return h('div', {
        class: this.classes,
        directives: [{
          name: 'click-outside',
          value: this.closeConditional
        }, {
          name: 'ripple',
          value: this.ripple
        }],
        on: {
          click: function click() {
            _this.isActive = !_this.isActive;
          }
        }
      }, [this.$slots.header]);
    },
    genBody: function genBody(h) {
      return h('div', {
        ref: 'body',
        class: 'expansion-panel__body',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [this.$slots.default]);
    }
  },

  render: function render(h) {
    var children = [];

    this.$slots.header && children.push(this.genHeader(h));
    children.push(h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [this.genBody(h)]));

    return h('li', children);
  }
});

/***/ }),
/* 71 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  enter: function enter(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Get height that is to be scrolled
    el.style.overflow = 'hidden';
    el.style.height = null;
    el.style.display = 'block';
    var height = el.clientHeight + 'px';
    el.style.height = 0;
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = height;
    }, 50);
  },
  afterEnter: function afterEnter(el) {
    el.style.height = 'auto';
    el.style.overflow = null;
  },
  leave: function leave(el, done) {
    // Remove initial transition
    el.style.transition = 'none';
    Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["a" /* addOnceEventListener */])(el, 'transitionend', done);

    // Set height before we transition to 0
    el.style.overflow = 'hidden';
    el.style.height = el.clientHeight + 'px';
    el.style.transition = null;

    setTimeout(function () {
      return el.style.height = 0;
    }, 50);
  }
});

/***/ }),
/* 72 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VFooter__ = __webpack_require__(73);


/* harmony default export */ __webpack_exports__["a"] = ({
  VFooter: __WEBPACK_IMPORTED_MODULE_0__VFooter__["a" /* default */]
});

/***/ }),
/* 73 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  props: {
    absolute: Boolean,
    fixed: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('footer ' + (data.staticClass || '')).trim();

    if (props.absolute) data.staticClass += ' footer--absolute';
    if (props.fixed) data.staticClass += ' footer--fixed';

    return h('footer', data, children);
  }
});

/***/ }),
/* 74 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


var Grid = function Grid(name) {
  return {
    functional: true,

    props: {
      id: String
    },

    render: function render(h, _ref) {
      var props = _ref.props,
          data = _ref.data,
          children = _ref.children;

      data.staticClass = (name + ' ' + (data.staticClass || '')).trim();

      if (data.attrs) {
        data.staticClass += ' ' + Object.keys(data.attrs).join(' ');
        delete data.attrs;
      }

      if (props.id) {
        data.domProps = data.domProps || {};
        data.domProps.id = props.id;
      }

      return h('div', data, children);
    }
  };
};

var VContainer = Grid('container');
var VFlex = Grid('flex');
var VLayout = Grid('layout');
var VSpacer = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('spacer');

/* harmony default export */ __webpack_exports__["a"] = ({
  VContainer: VContainer,
  VFlex: VFlex,
  VLayout: VLayout,
  VSpacer: VSpacer
});

/***/ }),
/* 75 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  VIcon: __WEBPACK_IMPORTED_MODULE_0__VIcon__["a" /* default */]
});

/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_transitions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-list-group',

  inject: ['listClick', 'listClose'],

  mixins: [__WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      isBooted: this.value
    };
  },


  props: {
    group: String,
    lazy: Boolean,
    noAction: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'list--group__header': true,
        'list--group__header--active': this.isActive,
        'list--group__header--no-action': this.noAction
      };
    }
  },

  watch: {
    isActive: function isActive() {
      this.isBooted = true;

      if (!this.isActive) {
        this.listClose(this._uid);
      }
    },
    $route: function $route(to) {
      var isActive = this.matchRoute(to.path);

      if (this.group) {
        if (isActive && this.isActive !== isActive) {
          this.listClick(this._uid);
        }
        this.isActive = isActive;
      }
    }
  },

  mounted: function mounted() {
    if (this.group) {
      this.isActive = this.matchRoute(this.$route.path);
    }

    if (this.isActive) {
      this.listClick(this._uid);
    }
  },


  methods: {
    click: function click() {
      var _this = this;

      if (!this.$refs.item.querySelector('.list__tile--disabled')) {
        requestAnimationFrame(function () {
          return _this.listClick(_this._uid);
        });
      }
    },
    toggle: function toggle(uid) {
      this.isActive = this._uid === uid;
    },
    matchRoute: function matchRoute(to) {
      if (!this.group) return false;
      return to.match(this.group) !== null;
    }
  },

  render: function render(h) {
    var group = h('ul', {
      'class': 'list list--group',
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      ref: 'group'
    }, [this.lazy && !this.isBooted ? null : this.$slots.default]);

    var item = h('div', {
      'class': this.classes,
      on: Object.assign({}, { click: this.click }, this.$listeners),
      ref: 'item'
    }, [this.$slots.item]);

    var transition = h(__WEBPACK_IMPORTED_MODULE_0__components_transitions__["a" /* VExpandTransition */], [group]);

    return h('div', { 'class': 'list--group__container' }, [item, transition]);
  }
});

/***/ }),
/* 77 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    icon: false,
    left: false,
    bottom: false,
    overlap: false,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  if (config.overlap) el.classList.add('badge--overlap');
  if (config.icon) el.classList.add('badge--icon');
  if (config.left) el.classList.add('badge--left');
  if (config.bottom) el.classList.add('badge--bottom');

  el.dataset.badge = config.value;
  el.classList.add('badge');
}

function unbind(el) {
  el.removeAttribute('data-badge');
  el.classList.remove('badge');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 78 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var debounce = function debounce(cb) {
    return setTimeout(cb, 50);
  };
  var onResize = function onResize() {
    clearTimeout(debounce);
    debounce(binding.value);
  };

  window.addEventListener('resize', onResize, { passive: true });
  el._onResize = onResize;
}

function unbind(el, binding) {
  window.removeEventListener('resize', el._onResize);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 79 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function inserted(el, binding) {
  var callback = typeof binding.value === 'function' ? binding.value : binding.value.callback;
  var options = binding.value.options || { passive: true };
  var target = binding.value.target || window;
  if (target === 'undefined') return;

  if (target !== window) {
    target = document.querySelector(target);
  }

  target.addEventListener('scroll', callback, options);

  el._onScroll = {
    target: target,
    options: options
  };
}

function unbind(el, binding) {
  var _el$_onScroll = el._onScroll,
      target = _el$_onScroll.target,
      options = _el$_onScroll.options;


  target.removeEventListener('scroll', binding.callback, options);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 80 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


function directive(el, binding) {
  var config = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["f" /* directiveConfig */])(binding, {
    top: true,
    visible: true
  });

  if (!config.visible || binding.expression && !binding.value) {
    return unbind(el);
  }

  unbind(el, binding, config);

  el.dataset.tooltip = config.html;
  el.dataset['tooltipLocation'] = config.value;
}

function unbind(el) {
  el.removeAttribute('data-tooltip');
  el.removeAttribute('data-tooltip-location');
}

/* harmony default export */ __webpack_exports__["a"] = ({
  bind: directive,
  updated: directive,
  componentUpdated: directive,
  unbind: unbind
});

/***/ }),
/* 81 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var touchstart = function touchstart(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchstartX = touch.clientX;
  wrapper.touchstartY = touch.clientY;

  wrapper.start && wrapper.start(Object.assign(event, wrapper));
};

var touchend = function touchend(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchendX = touch.clientX;
  wrapper.touchendY = touch.clientY;

  wrapper.end && wrapper.end(Object.assign(event, wrapper));

  handleGesture(wrapper);
};

var touchmove = function touchmove(event, wrapper) {
  var touch = event.changedTouches[0];
  wrapper.touchmoveX = touch.clientX;
  wrapper.touchmoveY = touch.clientY;

  wrapper.move && wrapper.move(Object.assign(event, wrapper));
};

var handleGesture = function handleGesture(wrapper) {
  var touchstartX = wrapper.touchstartX,
      touchendX = wrapper.touchendX,
      touchstartY = wrapper.touchstartY,
      touchendY = wrapper.touchendY;

  wrapper.offsetX = touchendX - touchstartX;
  wrapper.offsetY = touchendY - touchstartY;

  if (touchendX < touchstartX) {
    wrapper.left && wrapper.left(wrapper);
  }
  if (touchendX > touchstartX) {
    wrapper.right && wrapper.right(wrapper);
  }
  if (touchendY < touchstartY) {
    wrapper.up && wrapper.up(wrapper);
  }
  if (touchendY > touchstartY) {
    wrapper.down && wrapper.down(wrapper);
  }
};

function inserted(el, _ref) {
  var value = _ref.value;

  var wrapper = {
    touchstartX: 0,
    touchstartY: 0,
    touchendX: 0,
    touchendY: 0,
    touchmoveX: 0,
    touchmoveY: 0,
    offsetX: 0,
    offsetY: 0,
    left: value.left,
    right: value.right,
    up: value.up,
    down: value.down,
    start: value.start,
    move: value.move,
    end: value.end
  };

  var target = value.parent ? el.parentNode : el;
  var options = value.options || {};

  target.addEventListener('touchstart', function (e) {
    return touchstart(e, wrapper);
  }, options);
  target.addEventListener('touchend', function (e) {
    return touchend(e, wrapper);
  }, options);
  target.addEventListener('touchmove', function (e) {
    return touchmove(e, wrapper);
  }, options);
}

function unbind(el, _ref2) {
  var value = _ref2.value;

  var target = value.parent ? el.parentNode : el;

  if (!target) return;

  target.removeEventListener('touchstart', touchstart);
  target.removeEventListener('touchend', touchend);
  target.removeEventListener('touchmove', touchmove);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  inserted: inserted,
  unbind: unbind
});

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VMenu_js__ = __webpack_require__(22);


/* harmony default export */ __webpack_exports__["a"] = ({
  VMenu: __WEBPACK_IMPORTED_MODULE_0__VMenu_js__["a" /* default */]
});

/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    getActivator: function getActivator() {
      if (this.activator) return this.activator;
      return this.$refs.activator.children ? this.$refs.activator.children[0] : this.$refs.activator;
    },
    activatorClickHandler: function activatorClickHandler(e) {
      if (this.disabled) return;else if (this.openOnClick && !this.isActive) {
        this.isActive = true;
        this.absoluteX = e.clientX;
        this.absoluteY = e.clientY;
      } else if (this.closeOnClick && this.isActive) this.isActive = false;
    },
    mouseEnterHandler: function mouseEnterHandler(e) {
      if (this.disabled || this.hasJustFocused) return;
      this.hasJustFocused = true;
      this.isActive = true;
    },
    mouseLeaveHandler: function mouseLeaveHandler(e) {
      if (this.isContentActive) return;
      this.isActive = false;
    },
    addActivatorEvents: function addActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.addEventListener('click', this.activatorClickHandler);
    },
    removeActivatorEvents: function removeActivatorEvents() {
      var activator = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (!activator) return;
      activator.removeEventListener('click', this.activatorClickHandler);
    }
  }
});

/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genActivator: function genActivator() {
      if (!this.$slots.activator) return null;

      var options = {
        'class': {
          'menu__activator--active': this.hasJustFocused || this.isActive
        },
        staticClass: 'menu__activator',
        ref: 'activator',
        slot: 'activator',
        on: {}
      };

      if (this.openOnHover) {
        options.on['mouseenter'] = this.mouseEnterHandler;
        options.on['mouseleave'] = this.mouseLeaveHandler;
      } else if (this.openOnClick) {
        options.on['click'] = this.activatorClickHandler;
      }

      return this.$createElement('div', options, this.$slots.activator);
    },
    genTransition: function genTransition() {
      return this.$createElement('transition', {
        props: {
          name: this.transition,
          origin: this.origin
        }
      }, [this.genContent()]);
    },
    genContent: function genContent() {
      var _this = this;

      var booted = this.lazy && this.isBooted || !this.lazy;
      return this.$createElement('div', {
        'class': ('menu__content ' + this.contentClass).trim(),
        ref: 'content',
        style: this.styles,
        directives: [{
          name: 'show',
          value: this.isContentActive
        }],
        on: {
          click: function click(e) {
            e.stopPropagation();
            if (e.target.getAttribute('disabled')) return;
            if (_this.closeOnContentClick) _this.isActive = false;
          },
          mouseleave: function mouseleave(e) {
            _this.openOnHover && (_this.isActive = false);
          }
        }
      }, [booted ? this.$slots.default : null]);
    }
  }
});

/***/ }),
/* 85 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    // Revisit this
    calculateScroll: function calculateScroll() {
      if (this.selectedIndex === null) return;

      var scrollTop = 0;

      if (this.selectedIndex >= this.stopIndex) {
        scrollTop = this.$refs.content.scrollHeight;
      } else if (this.selectedIndex > this.startIndex) {
        scrollTop = this.selectedIndex * 48 - 56;
      }

      this.$refs.content.scrollTop = scrollTop;
    },
    calcLeftAuto: function calcLeftAuto() {
      var a = this.dimensions.activator;

      return parseInt(a.left - 16);
    },
    calcTopAuto: function calcTopAuto() {
      if (!this.hasActivator) return this.calcTop(true);

      var selectedIndex = Array.from(this.tiles).findIndex(function (n) {
        return n.classList.contains('list__tile--active');
      });

      if (selectedIndex === -1) {
        this.selectedIndex = null;

        return this.calcTop(true);
      }

      this.selectedIndex = selectedIndex;
      var actingIndex = selectedIndex;

      var offsetPadding = 1;
      // #708 Stop index should vary by tile length
      this.stopIndex = this.tiles.length > 4 ? this.tiles.length - 4 : this.tiles.length;

      if (selectedIndex > this.startIndex && selectedIndex < this.stopIndex) {
        actingIndex = 2;
        offsetPadding = 41;
      } else if (selectedIndex >= this.stopIndex) {
        offsetPadding = 9;
        actingIndex = selectedIndex - this.stopIndex;
      }

      return this.calcTop(true) + offsetPadding - actingIndex * 48;
    },
    calcLeft: function calcLeft() {
      if (this.auto) return this.calcLeftAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var left = this.left ? a.right - c.width : a.left;

      if (this.offsetX) left += this.left ? -a.width : a.width;
      if (this.nudgeLeft) left += this.nudgeLeft;
      if (this.nudgeRight) left -= this.nudgeRight;

      return this.calcXOverflow(left);
    },
    calcTop: function calcTop(force) {
      if (this.auto && !force) return this.calcTopAuto();

      var a = this.dimensions.activator;
      var c = this.dimensions.content;
      var top = this.top ? a.bottom - c.height : a.top;

      if (this.offsetY) top += this.top ? -a.height : a.height;
      if (this.nudgeTop) top -= this.nudgeTop;
      if (this.nudgeBottom) top += this.nudgeBottom;

      var defined = typeof window !== 'undefined';
      var pageYOffset = defined ? window.pageYOffset : 0;

      return this.calcYOverflow(top) + pageYOffset;
    },
    calcXOverflow: function calcXOverflow(left) {
      var hasWindow = typeof window !== 'undefined';
      var innerWidth = hasWindow ? window.innerWidth : 0;
      var maxWidth = Math.max(this.dimensions.content.width, this.calculatedMinWidth, parseInt(this.maxWidth) || 0);
      var totalWidth = left + maxWidth;
      var availableWidth = totalWidth - innerWidth;

      if ((!this.left || this.right) && availableWidth > 0) {
        left = innerWidth - maxWidth - (innerWidth > 1024 ? 30 : 12) // Account for scrollbar
        ;
      } else if (this.left && left < 0) left = 12;

      return left;
    },
    calcYOverflow: function calcYOverflow(top) {
      var totalHeight = top + this.dimensions.content.height;
      var defined = typeof window !== 'undefined';
      var innerHeight = defined ? window.innerHeight : 0;

      if (this.top && top < 0) top = 12;else if ((!this.top || this.bottom) && innerHeight < totalHeight) {
        top = innerHeight - this.dimensions.content.height;
      }

      return top < 12 ? 12 : top;
    },
    sneakPeek: function sneakPeek(cb) {
      var _this = this;

      requestAnimationFrame(function () {
        var el = _this.$refs.content;
        var currentDisplay = el.style.display;

        el.style.display = 'inline-block';
        cb();
        el.style.display = currentDisplay;
      });
    },
    absolutePosition: function absolutePosition() {
      return {
        offsetTop: 0,
        scrollHeight: 0,
        top: this.positionY || this.absoluteY,
        bottom: this.positionY || this.absoluteY,
        left: this.positionX || this.absoluteX,
        right: this.positionX || this.absoluteX,
        height: 0,
        width: 0
      };
    },
    updateDimensions: function updateDimensions() {
      var _this2 = this;

      this.sneakPeek(function () {
        _this2.dimensions = {
          activator: !_this2.hasActivator || _this2.positionAbsolutely ? _this2.absolutePosition() : _this2.measure(_this2.getActivator()),
          content: _this2.measure(_this2.$refs.content)
        };
      });
    }
  }
});

/***/ }),
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    measure: function measure(el, selector) {
      var getParent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      el = selector ? el.querySelector(selector) : el;

      if (!el) return null;

      var _el$getBoundingClient = el.getBoundingClientRect(),
          top = _el$getBoundingClient.top,
          bottom = _el$getBoundingClient.bottom,
          left = _el$getBoundingClient.left,
          right = _el$getBoundingClient.right,
          height = _el$getBoundingClient.height,
          width = _el$getBoundingClient.width;

      return {
        offsetTop: el.offsetTop,
        scrollHeight: el.scrollHeight,
        top: top, bottom: bottom, left: left, right: right, height: height, width: width
      };
    }
  }
});

/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      listIndex: -1,
      isUsingKeys: false,
      tiles: []
    };
  },

  watch: {
    isActive: function isActive(val) {
      if (!val) this.listIndex = -1;
    },
    listIndex: function listIndex(next, prev) {
      // For infinite scroll and autocomplete, re-evaluate children
      this.getTiles();

      if (next in this.tiles) {
        this.tiles[next].classList.add('list__tile--highlighted');
        this.$refs.content.scrollTop = next * 48;
      }

      prev in this.tiles && this.tiles[prev].classList.remove('list__tile--highlighted');
    }
  },

  methods: {
    changeListIndex: function changeListIndex(e) {
      [40, 38, 13].includes(e.keyCode) && e.preventDefault();
      e.keyCode === 32 && !this.isActive && e.preventDefault();

      if (this.listIndex === -1) this.setActiveListIndex();
      if ([27, 9].includes(e.keyCode)) return this.isActive = false;else if (!this.isActive && [13, 32].includes(e.keyCode)) {
        return this.isActive = true;
      }

      if (e.keyCode === 40 && this.listIndex < this.tiles.length - 1) {
        this.listIndex++;
      } else if (e.keyCode === 38 && this.listIndex > 0) {
        this.listIndex--;
      } else if (e.keyCode === 13 && this.listIndex !== -1) {
        this.tiles[this.listIndex].click();
      }
    },
    getTiles: function getTiles() {
      this.tiles = this.$refs.content.querySelectorAll('.list__tile');
    },
    setActiveListIndex: function setActiveListIndex() {
      var _this = this;

      this.tiles.forEach(function (t, i) {
        if (t.classList.contains('list__tile--active')) {
          _this.listIndex = i;
          return;
        }
      });
    }
  }
});

/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__ = __webpack_require__(89);


/* harmony default export */ __webpack_exports__["a"] = ({
  VNavigationDrawer: __WEBPACK_IMPORTED_MODULE_0__VNavigationDrawer__["a" /* default */]
});

/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives__ = __webpack_require__(4);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-navigation-drawer',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_2__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_overlayable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isActive: this.value,
      isBooted: false,
      isMobile: false,
      touchArea: {
        left: 0,
        right: 0
      }
    };
  },


  props: {
    absolute: Boolean,
    clipped: Boolean,
    disableRouteWatcher: Boolean,
    enableResizeWatcher: Boolean,
    height: String,
    floating: Boolean,
    miniVariant: Boolean,
    mobileBreakPoint: {
      type: Number,
      default: 1024
    },
    permanent: Boolean,
    persistent: Boolean,
    right: Boolean,
    temporary: Boolean,
    touchless: Boolean,
    value: { required: false }
  },

  computed: {
    calculatedHeight: function calculatedHeight() {
      return this.height || '100%';
    },
    classes: function classes() {
      return {
        'navigation-drawer': true,
        'navigation-drawer--absolute': this.absolute,
        'navigation-drawer--clipped': this.clipped,
        'navigation-drawer--close': !this.isActive,
        'navigation-drawer--floating': this.floating,
        'navigation-drawer--is-booted': this.isBooted,
        'navigation-drawer--is-mobile': this.isMobile,
        'navigation-drawer--mini-variant': this.miniVariant,
        'navigation-drawer--open': this.isActive,
        'navigation-drawer--permanent': this.permanent,
        'navigation-drawer--persistent': this.persistent,
        'navigation-drawer--right': this.right,
        'navigation-drawer--temporary': this.temporary,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    showOverlay: function showOverlay() {
      return !this.permanent && this.isActive && (this.temporary || this.isMobile);
    }
  },

  watch: {
    $route: function $route() {
      if (!this.disableRouteWatcher) {
        this.isActive = !this.closeConditional();
      }
    },
    isActive: function isActive(val) {
      this.$emit('input', val);
      this.showOverlay && val && this.genOverlay() || this.removeOverlay();
      this.$el.scrollTop = 0;
    },
    isMobile: function isMobile(val) {
      !val && this.removeOverlay();
    },
    permanent: function permanent(val) {
      this.$emit('input', val);
    },
    value: function value(val) {
      if (this.permanent) return;
      if (val !== this.isActive) this.isActive = val;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.checkIfMobile();
      setTimeout(function () {
        return _this.isBooted = true;
      }, 0);

      if (this.permanent) this.isActive = true;else if (this.isMobile) this.isActive = false;else if (!this.value && (this.persistent || this.temporary)) this.isActive = false;
    },
    checkIfMobile: function checkIfMobile() {
      this.isMobile = window.innerWidth < parseInt(this.mobileBreakPoint);
    },
    closeConditional: function closeConditional() {
      return !this.permanent && (this.temporary || this.isMobile);
    },
    onResize: function onResize() {
      var _this2 = this;

      clearTimeout(this.resizeTimeout);

      if (!this.enableResizeWatcher || this.permanent || this.temporary) return;

      this.resizeTimeout = setTimeout(function () {
        _this2.checkIfMobile();
        _this2.isActive = !_this2.isMobile;
      }, 200);
    },
    swipeRight: function swipeRight(e) {
      if (this.isActive && !this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (!this.right && e.touchstartX <= this.touchArea.left) this.isActive = true;else if (this.right && this.isActive) this.isActive = false;
    },
    swipeLeft: function swipeLeft(e) {
      if (this.isActive && this.right) return;
      this.calculateTouchArea();

      if (Math.abs(e.touchendX - e.touchstartX) < 100) return;else if (this.right && e.touchstartX >= this.touchArea.right) this.isActive = true;else if (!this.right && this.isActive) this.isActive = false;
    },
    calculateTouchArea: function calculateTouchArea() {
      if (!this.$el.parentNode) return;
      var parentRect = this.$el.parentNode.getBoundingClientRect();

      this.touchArea = {
        left: parentRect.left + 50,
        right: parentRect.right - 50
      };
    },
    genDirectives: function genDirectives() {
      var directives = [{
        name: 'click-outside',
        value: this.closeConditional
      }, {
        name: 'resize',
        value: this.onResize
      }];

      !this.touchless && directives.push({
        name: 'touch',
        value: {
          parent: true,
          left: this.swipeLeft,
          right: this.swipeRight
        }
      });

      return directives;
    }
  },

  render: function render(h) {
    var _this3 = this;

    var data = {
      'class': this.classes,
      style: { height: this.calculatedHeight },
      directives: this.genDirectives(),
      on: Object.assign({}, {
        click: function click() {
          return _this3.$emit('update:miniVariant', false);
        }
      }, this.$listeners)
    };

    return h('aside', data, [this.$slots.default, h('div', { 'class': 'navigation-drawer__border' })]);
  }
});

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VSystemBar__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VToolbar__ = __webpack_require__(92);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__ = __webpack_require__(93);






var VToolbarTitle = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__title');
var VToolbarItems = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('toolbar__items');

/* harmony default export */ __webpack_exports__["a"] = ({
  VSystemBar: __WEBPACK_IMPORTED_MODULE_1__VSystemBar__["a" /* default */],
  VToolbar: __WEBPACK_IMPORTED_MODULE_2__VToolbar__["a" /* default */],
  VToolbarItems: VToolbarItems,
  VToolbarTitle: VToolbarTitle,
  VToolbarSideIcon: __WEBPACK_IMPORTED_MODULE_3__VToolbarSideIcon__["a" /* default */]
});

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    lightsOut: Boolean,
    status: Boolean,
    window: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        props = _ref.props,
        children = _ref.children;

    data.staticClass = ('system-bar ' + (data.staticClass || '')).trim();

    if (props.dark) data.staticClass += ' theme--dark';
    if (props.light) data.staticClass += ' theme--light';
    if (props.status) data.staticClass += ' system-bar--status';
    if (props.window) data.staticClass += ' system-bar--window';
    if (props.lightsOut) data.staticClass += ' system-bar--lights-out';

    return h('div', data, children);
  }
});

/***/ }),
/* 92 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  data: function data() {
    return {
      isExtended: false,
      isScrolling: false,
      marginTop: 0,
      previousScroll: null,
      target: null
    };
  },

  props: {
    absolute: Boolean,
    card: Boolean,
    dense: Boolean,
    extended: Boolean,
    fixed: Boolean,
    flat: Boolean,
    floating: Boolean,
    prominent: Boolean,
    scrollOffScreen: Boolean,
    scrollTarget: String,
    scrollThreshHold: {
      type: Number,
      default: 100
    }
  },

  computed: {
    classes: function classes() {
      return {
        'toolbar': true,
        'elevation-0': this.flat,
        'toolbar--absolute': this.absolute,
        'toolbar--card': this.card,
        'toolbar--dense': this.dense,
        'toolbar--fixed': this.fixed,
        'toolbar--floating': this.floating,
        'toolbar--prominent': this.prominent,
        'toolbar--extended': this.isExtended,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    styles: function styles() {
      return {
        marginTop: this.marginTop
      };
    }
  },

  watch: {
    isScrolling: function isScrolling(val) {
      if (!val) this.marginTop = 0;else this.marginTop = -this.$refs.content.clientHeight - 6 + 'px';
    }
  },

  methods: {
    onScroll: function onScroll() {
      if (typeof window === 'undefined') return;

      if (!this.target) {
        this.target = this.scrollTarget ? document.querySelector(this.scrollTarget) : window;
      }

      var currentScroll = this.scrollTarget ? this.target.scrollTop : this.target.pageYOffset || document.documentElement.scrollTop;

      if (currentScroll < this.scrollThreshHold) return;

      if (this.previousScroll === null) {
        this.previousScroll = currentScroll;
      }

      this.isScrolling = this.previousScroll < currentScroll;

      this.previousScroll = currentScroll;
    }
  },

  render: function render(h) {
    this.isExtended = this.extended || !!this.$slots.extension;
    var children = [];
    var data = {
      'class': this.classes,
      style: this.styles,
      on: this.$listeners
    };

    if (this.scrollOffScreen) {
      data.directives = [{
        name: 'scroll',
        value: {
          callback: this.onScroll,
          target: this.scrollTarget
        }
      }];
    }

    children.push(h('div', {
      'class': 'toolbar__content',
      ref: 'content'
    }, this.$slots.default));

    if (this.isExtended) {
      children.push(h('div', {
        'class': 'toolbar__extension'
      }, this.$slots.extension));
    }

    return h('nav', data, children);
  }
});

/***/ }),
/* 93 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__ = __webpack_require__(3);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-toolbar-side-icon',

  functional: true,

  render: function render(h, _ref) {
    var slots = _ref.slots,
        listeners = _ref.listeners,
        props = _ref.props;

    var data = {
      staticClass: 'toolbar__side-icon',
      props: Object.assign(props, {
        icon: true
      }),
      on: listeners
    };

    var defaultSlot = slots().default;

    return h(__WEBPACK_IMPORTED_MODULE_0__components_buttons_VBtn__["a" /* default */], data, defaultSlot || [h(__WEBPACK_IMPORTED_MODULE_1__components_icons_VIcon__["a" /* default */], 'menu')]);
  }
});

/***/ }),
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VPagination__ = __webpack_require__(95);


/* harmony default export */ __webpack_exports__["a"] = ({
  VPagination: __WEBPACK_IMPORTED_MODULE_0__VPagination__["a" /* default */]
});

/***/ }),
/* 95 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-pagination',

  props: {
    circle: Boolean,
    disabled: Boolean,
    length: {
      type: Number,
      default: 0,
      validator: function validator(val) {
        return val % 1 === 0;
      }
    },
    value: {
      type: Number,
      default: 0
    },
    prevIcon: {
      type: String,
      default: 'chevron_left'
    },
    nextIcon: {
      type: String,
      default: 'chevron_right'
    }
  },

  watch: {
    value: function value() {
      this.init();
    }
  },

  computed: {
    classes: function classes() {
      return {
        'pagination': true,
        'pagination--circle': this.circle,
        'pagination--disabled': this.disabled
      };
    },
    items: function items() {
      if (this.length <= 5) {
        return this.range(1, this.length);
      }

      var min = this.value - 3;
      min = min > 0 ? min : 1;

      var max = min + 6;
      max = max <= this.length ? max : this.length;

      if (max === this.length) {
        min = this.length - 6;
      }

      var range = this.range(min, max);

      if (this.value >= 4 && this.length > 6) {
        range.splice(0, 2, 1, '...');
      }

      if (this.value + 3 < this.length && this.length > 6) {
        range.splice(range.length - 2, 2, '...', this.length);
      }

      return range;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load.call(this, this.init);
  },


  methods: {
    init: function init() {
      var _this = this;

      this.selected = null;

      // Change this
      setTimeout(function () {
        return _this.selected = _this.value;
      }, 100);
    },
    next: function next(e) {
      e.preventDefault();
      this.$emit('input', this.value + 1);
      this.$emit('next');
    },
    previous: function previous(e) {
      e.preventDefault();
      this.$emit('input', this.value - 1);
      this.$emit('previous');
    },
    range: function range(from, to) {
      var range = [];

      from = from > 0 ? from : 1;

      for (var i = from; i <= to; i++) {
        range.push(i);
      }

      return range;
    },
    genIcon: function genIcon(h, icon, disabled, fn) {
      return h('li', [h('a', {
        class: {
          'pagination__navigation': true,
          'pagination__navigation--disabled': disabled
        },
        attrs: { href: '#!' },
        on: { click: fn }
      }, [h(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], [icon])])]);
    },
    genItem: function genItem(h, i) {
      var _this2 = this;

      return h('a', {
        class: {
          'pagination__item': true,
          'pagination__item--active': i === this.value
        },
        attrs: { href: '#!' },
        on: {
          click: function click(e) {
            e.preventDefault();
            _this2.$emit('input', i);
          }
        }
      }, [i]);
    },
    genItems: function genItems(h) {
      var _this3 = this;

      return this.items.map(function (i) {
        return h('li', [isNaN(i) && h('span', { class: 'pagination__more' }, [i]) || _this3.genItem(h, i)]);
      });
    }
  },

  render: function render(h) {
    var children = [this.genIcon(h, this.prevIcon, this.value === 1, this.previous), this.genItems(h), this.genIcon(h, this.nextIcon, this.value === this.length, this.next)];

    return h('ul', { class: this.classes }, children);
  }
});

/***/ }),
/* 96 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VParallax__ = __webpack_require__(97);


/* harmony default export */ __webpack_exports__["a"] = ({
  VParallax: __WEBPACK_IMPORTED_MODULE_0__VParallax__["a" /* default */]
});

/***/ }),
/* 97 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_translatable__ = __webpack_require__(98);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-parallax',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_translatable__["a" /* default */]],

  props: {
    height: {
      type: [String, Number],
      default: 500
    },
    src: String
  },

  computed: {
    styles: function styles() {
      return {
        display: 'block',
        transform: 'translate3d(-50%, ' + this.parallax + 'px, 0)'
      };
    }
  },

  methods: {
    init: function init() {
      var _this = this;

      if (!this.$refs.img) return;

      if (this.$refs.img.complete) {
        this.translate();
        this.listeners();
      } else {
        this.$refs.img.addEventListener('load', function () {
          _this.translate();
          _this.listeners();
        }, false);
      }
    },
    objHeight: function objHeight() {
      return this.$refs.img.naturalHeight;
    },
    elOffsetTop: function elOffsetTop() {
      return this.$el.offsetTop;
    }
  },

  render: function render(h) {
    var container = h('div', {
      staticClass: 'parallax__image-container'
    }, [h('img', {
      staticClass: 'parallax__image',
      style: this.styles,
      attrs: {
        src: this.src
      },
      ref: 'img'
    })]);

    var content = h('div', {
      staticClass: 'parallax__content'
    }, this.$slots.default);

    return h('div', {
      staticClass: 'parallax',
      style: {
        height: parseInt(this.normalizedHeight) + 'px'
      },
      on: this.$listeners
    }, [container, content]);
  }
});

/***/ }),
/* 98 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      parallax: null,
      parallaxDist: null,
      percentScrolled: null,
      scrollTop: null,
      windowHeight: null,
      windowBottom: null
    };
  },


  computed: {
    normalizedHeight: function normalizedHeight() {
      return Number(this.height.toString().replace(/(^[0-9]*$)/, '$1'));
    },
    imgHeight: function imgHeight() {
      return this.objHeight();
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.translate, false);
    window.removeEventListener('resize', this.translate, false);
  },


  methods: {
    listeners: function listeners() {
      window.addEventListener('scroll', this.translate, false);
      window.addEventListener('resize', this.translate, false);
    },
    translate: function translate() {
      this.calcDimensions();

      this.percentScrolled = (this.windowBottom - this.elOffsetTop) / (this.normalizedHeight + this.windowHeight);

      this.parallax = Math.round(this.parallaxDist * this.percentScrolled);

      if (this.translated) {
        this.translated();
      }
    },
    calcDimensions: function calcDimensions() {
      var offset = this.$el.getBoundingClientRect();

      this.scrollTop = window.pageYOffset;
      this.parallaxDist = this.imgHeight - this.normalizedHeight;
      this.elOffsetTop = offset.top + this.scrollTop;
      this.windowHeight = window.innerHeight;
      this.windowBottom = this.scrollTop + this.windowHeight;
    }
  }
});

/***/ }),
/* 99 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__ = __webpack_require__(100);



/* harmony default export */ __webpack_exports__["a"] = ({
  VProgressLinear: __WEBPACK_IMPORTED_MODULE_0__VProgressLinear__["a" /* default */],
  VProgressCircular: __WEBPACK_IMPORTED_MODULE_1__VProgressCircular__["a" /* default */]
});

/***/ }),
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var _this = this;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-progress-circular',

  props: {
    button: Boolean,

    fill: {
      type: String,
      default: function _default() {
        return _this.indeterminate ? 'none' : 'transparent';
      }
    },

    indeterminate: Boolean,

    rotate: {
      type: Number,
      default: 0
    },

    size: {
      type: [Number, String],
      default: 32
    },

    width: {
      type: Number,
      default: 4
    },

    value: {
      type: Number,
      default: 0
    }
  },

  computed: {
    calculatedSize: function calculatedSize() {
      var size = Number(this.size);

      if (this.button) {
        size += 8;
      }

      return size;
    },
    circumference: function circumference() {
      return 2 * Math.PI * this.radius;
    },
    classes: function classes() {
      return {
        'progress-circular': true,
        'progress-circular--indeterminate': this.indeterminate,
        'progress-circular--button': this.button
      };
    },
    cxy: function cxy() {
      return this.indeterminate && !this.button ? 50 : this.calculatedSize / 2;
    },
    normalizedValue: function normalizedValue() {
      if (this.value < 0) {
        return 0;
      }

      if (this.value > 100) {
        return 100;
      }

      return this.value;
    },
    radius: function radius() {
      return this.indeterminate && !this.button ? 20 : (this.calculatedSize - this.width) / 2;
    },
    strokeDashArray: function strokeDashArray() {
      return Math.round(this.circumference * 1000) / 1000;
    },
    strokeDashOffset: function strokeDashOffset() {
      return (100 - this.normalizedValue) / 100 * this.circumference + 'px';
    },
    styles: function styles() {
      return {
        height: this.calculatedSize + 'px',
        width: this.calculatedSize + 'px'
      };
    },
    svgSize: function svgSize() {
      return this.indeterminate ? false : this.calculatedSize;
    },
    svgStyles: function svgStyles() {
      return {
        transform: 'rotate(' + this.rotate + 'deg)'
      };
    },
    viewBox: function viewBox() {
      return this.indeterminate ? '25 25 50 50' : false;
    }
  },

  methods: {
    genCircle: function genCircle(h, name, offset) {
      return h('circle', {
        class: 'progress-circular__' + name,
        attrs: {
          fill: 'transparent',
          cx: this.cxy,
          cy: this.cxy,
          r: this.radius,
          'stroke-width': this.width,
          'stroke-dasharray': this.strokeDashArray,
          'stroke-dashoffset': offset
        }
      });
    },
    genSvg: function genSvg(h) {
      var children = [!this.indeterminate && this.genCircle(h, 'underlay', 0), this.genCircle(h, 'overlay', this.strokeDashOffset)];

      return h('svg', {
        style: this.svgStyles,
        attrs: {
          xmlns: 'http://www.w3.org/2000/svg',
          height: this.svgSize,
          width: this.svgSize,
          viewBox: this.viewBox
        }
      }, children);
    }
  },

  render: function render(h) {
    var info = h('div', { class: 'progress-circular__info' }, [this.$slots.default]);
    var svg = this.genSvg(h);

    return h('div', {
      class: this.classes,
      style: this.styles,
      on: this.$listeners
    }, [svg, info]);
  }
});

/*
<template lang="pug">
  div(
    class="progress-circular"
    v-bind:class="classes"
    v-bind:style="styles"
    v-on="$listeners"
  )
    svg(
      xmlns="http://www.w3.org/2000/svg"
      v-bind:height="svgSize"
      v-bind:width="svgSize"
      v-bind:viewBox="viewBox"
      v-bind:style="svgStyles"
    )
      circle(
        class="progress-circular__underlay"
        fill="transparent"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="0"
        v-if="!indeterminate"
      )
      circle(
        class="progress-circular__overlay"
        v-bind:fill="fill"
        v-bind:cx="cxy"
        v-bind:cy="cxy"
        v-bind:r="radius"
        v-bind:stroke-width="width"
        v-bind:stroke-dasharray="strokeDashArray"
        v-bind:stroke-dashoffset="strokeDashOffset"
      )
    div(class="progress-circular__info")
      slot
</template>
*/

/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSelect__ = __webpack_require__(24);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSelect: __WEBPACK_IMPORTED_MODULE_0__VSelect__["a" /* default */]
});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    filterSearch: function filterSearch() {
      var _this = this;

      return this.items.filter(function (i) {
        var text = _this.getText(i);
        if (typeof text !== 'string') return false;

        return text.toLowerCase().indexOf(_this.searchValue.toLowerCase()) !== -1;
      });
    },
    onKeyDown: function onKeyDown(e) {
      this.$refs.menu.changeListIndex(e);
    }
  }
});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);


/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genMenu: function genMenu() {
      var _this = this;

      var offsetY = this.autocomplete || this.offset || this.isDropdown;
      var data = {
        ref: 'menu',
        props: {
          activator: this.$refs.activator,
          auto: this.auto,
          closeOnClick: false,
          closeOnContentClick: !this.multiple,
          contentClass: this.computedContentClass,
          disabled: this.disabled,
          maxHeight: this.maxHeight,
          nudgeTop: this.isDropdown ? 22 : offsetY ? 38 : 0,
          offsetY: offsetY,
          value: this.isActive
        },
        on: { input: function input(val) {
            return _this.isActive = val;
          } }
      };

      this.minWidth && (data.props.minWidth = this.minWidth);

      return this.$createElement('v-menu', data, [this.genList()]);
    },
    genSelectionsAndSearch: function genSelectionsAndSearch() {
      var _this2 = this;

      var input = void 0;

      if (this.autocomplete || this.editable) {
        input = this.$createElement('input', {
          'class': 'input-group--select__autocomplete',
          domProps: { value: this.searchValue },
          on: { input: function input(e) {
              return _this2.searchValue = e.target.value;
            } },
          attrs: { tabindex: -1 },
          ref: 'input',
          key: 'input'
        });
      }

      var selections = this.isDirty && (!this.editable || this.editable && !this.focused) ? this.genSelections() : [];
      input && selections.push(input);
      var group = this.$createElement('div', selections);

      return this.$createElement('div', {
        'class': 'input-group__selections',
        style: { 'overflow': 'hidden' },
        ref: 'activator'
      }, [group]);
    },
    genSelections: function genSelections() {
      var _this3 = this;

      var children = [];
      var chips = this.chips;
      var slots = this.$scopedSlots.selection;
      var length = this.selectedItems.length;

      this.selectedItems.forEach(function (item, i) {
        if (slots) {
          children.push(_this3.genSlotSelection(item));
        } else if (chips) {
          children.push(_this3.genChipSelection(item));
        } else {
          children.push(_this3.genCommaSelection(item, i < length - 1));
        }
      });

      return children;
    },
    genSlotSelection: function genSlotSelection(item) {
      return this.$scopedSlots.selection({ parent: this, item: item });
    },
    genChipSelection: function genChipSelection(item) {
      var _this4 = this;

      return this.$createElement('v-chip', {
        'class': 'chip--select-multi',
        props: { close: true },
        on: {
          input: function input() {
            return _this4.selectItem(item);
          },
          click: function click(e) {
            return e.stopPropagation();
          }
        },
        key: this.getValue(item)
      }, this.getText(item));
    },
    genCommaSelection: function genCommaSelection(item, comma) {
      return this.$createElement('div', {
        'class': 'input-group__selections__comma',
        key: JSON.stringify(this.getValue(item)) // Item may be an object
      }, '' + this.getText(item) + (comma ? ', ' : ''));
    },
    genList: function genList() {
      var _this5 = this;

      var children = this.filteredItems.map(function (o) {
        if (o.header) return _this5.genHeader(o);
        if (o.divider) return _this5.genDivider(o);else return _this5.genTile(o);
      });

      if (!children.length) {
        children.push(this.genTile(this.noDataText, true));
      }

      return this.$createElement('v-card', [this.$createElement('v-list', {
        ref: 'list'
      }, children)]);
    },
    genHeader: function genHeader(item) {
      return this.$createElement('v-subheader', {
        props: item
      }, item.header);
    },
    genDivider: function genDivider(item) {
      return this.$createElement('v-divider', {
        props: item
      });
    },
    genTile: function genTile(item, disabled) {
      var _this6 = this;

      var active = this.selectedItems.indexOf(item) !== -1;

      if (typeof disabled === 'undefined') {
        disabled = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["g" /* getObjectValueByPath */])(item, this.itemDisabled);
      }

      var data = {
        on: { click: function click(e) {
            return _this6.selectItem(item);
          } },
        props: {
          avatar: item === Object(item) && 'avatar' in item,
          ripple: true,
          value: active
        }
      };

      if (disabled) {
        data.props.disabled = disabled;
      }

      if (this.$scopedSlots.item) {
        return this.$createElement('v-list-tile', data, [this.$scopedSlots.item({ parent: this, item: item })]);
      }

      return this.$createElement('v-list-tile', data, [this.genAction(item, active), this.genContent(item)]);
    },
    genAction: function genAction(item, active) {
      var _this7 = this;

      if (!this.multiple) return null;

      var data = {
        'class': {
          'list__tile__action--select-multi': this.multiple
        },
        on: {
          click: function click(e) {
            e.stopPropagation();
            _this7.selectItem(item);
          }
        }
      };

      return this.$createElement('v-list-tile-action', data, [this.$createElement('v-checkbox', { props: { inputValue: active } })]);
    },
    genContent: function genContent(item) {
      return this.$createElement('v-list-tile-content', [this.$createElement('v-list-tile-title', this.getText(item))]);
    }
  }
});

/***/ }),
/* 104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VCheckbox__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VRadio__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VSwitch__ = __webpack_require__(106);




/* harmony default export */ __webpack_exports__["a"] = ({
  VCheckbox: __WEBPACK_IMPORTED_MODULE_0__VCheckbox__["a" /* default */],
  VRadio: __WEBPACK_IMPORTED_MODULE_1__VRadio__["a" /* default */],
  VSwitch: __WEBPACK_IMPORTED_MODULE_2__VSwitch__["a" /* default */]
});

/***/ }),
/* 105 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__ = __webpack_require__(28);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'radio',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_colorable__["a" /* default */]],

  model: {
    prop: 'inputValue',
    event: 'change'
  },

  props: {
    inputValue: [String, Number]
  },

  computed: {
    isActive: function isActive() {
      return this.inputValue === this.value;
    },
    classes: function classes() {
      return this.addColorClassChecks({
        'radio': true,
        'input-group--selection-controls': true,
        'input-group--active': this.isActive
      });
    },
    icon: function icon() {
      return this.isActive ? 'radio_button_checked' : 'radio_button_unchecked';
    }
  },

  methods: {
    genLabel: function genLabel() {
      return this.$createElement('label', {
        on: { click: this.toggle }
      }, this.label);
    },
    toggle: function toggle() {
      if (!this.disabled) {
        this.$emit('change', this.value);
      }
    }
  },

  render: function render(h) {
    var transition = h('v-fade-transition', {}, [h('v-icon', {
      'class': {
        'icon--radio': this.isActive
      },
      key: this.icon
    }, this.icon)]);

    var ripple = h('div', {
      'class': 'input-group--selection-controls__ripple',
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    return this.genInputGroup([transition, ripple]);
  }
});

/***/ }),
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_selectable__ = __webpack_require__(27);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'switch',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_selectable__["a" /* default */]],

  computed: {
    classes: function classes() {
      return {
        'input-group--selection-controls switch': true
      };
    },
    rippleClasses: function rippleClasses() {
      return {
        'input-group--selection-controls__ripple': true,
        'input-group--selection-controls__ripple--active': this.isActive
      };
    },
    containerClasses: function containerClasses() {
      return this.addColorClassChecks({
        'input-group--selection-controls__container': true,
        'input-group--selection-controls__container--light': this.light,
        'input-group--selection-controls__container--disabled': this.disabled
      });
    },
    toggleClasses: function toggleClasses() {
      return {
        'input-group--selection-controls__toggle': true,
        'input-group--selection-controls__toggle--active': this.isActive
      };
    }
  },

  render: function render(h) {
    var ripple = h('div', {
      'class': this.rippleClasses,
      on: Object.assign({}, {
        click: this.toggle
      }, this.$listeners),
      directives: [{
        name: 'ripple',
        value: { center: true }
      }]
    });

    var container = h('div', {
      'class': this.containerClasses
    }, [h('div', { 'class': this.toggleClasses }), ripple]);

    return this.genInputGroup([container]);
  }
});

/***/ }),
/* 107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSlider__ = __webpack_require__(108);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSlider: __WEBPACK_IMPORTED_MODULE_0__VSlider__["a" /* default */]
});

/***/ }),
/* 108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__util_helpers__ = __webpack_require__(0);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-slider',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  data: function data() {
    return {
      app: {},
      isActive: false,
      inputWidth: 0
    };
  },


  props: {
    inverted: Boolean,
    min: {
      type: [Number, String],
      default: 0
    },
    max: {
      type: [Number, String],
      default: 100
    },
    step: {
      type: [Number, String],
      default: null
    },
    thumbLabel: Boolean,
    value: [Number, String],
    vertical: Boolean,
    snap: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'input-group input-group--slider': true,
        'input-group--active': this.isActive,
        'input-group--dirty': this.inputWidth > 0,
        'input-group--disabled': this.disabled,
        'input-group--ticks': !this.disabled && this.step
      };
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        var min = this.min,
            max = this.max,
            step = this.step,
            snap = this.snap;

        val = val < min ? min : val > max ? max : val;
        if (Math.ceil(val) !== Math.ceil(this.lazyValue)) {
          this.inputWidth = this.calculateWidth(val);
        }

        var value = snap ? Math.round(val / step) * step : parseInt(val);
        this.lazyValue = value;

        if (value !== this.value) {
          this.$emit('input', value);
        }
      }
    },
    interval: function interval() {
      return 100 / (this.max - this.min) * this.step;
    },
    thumbContainerClasses: function thumbContainerClasses() {
      return {
        'slider__thumb-container': true,
        'slider__thumb-container--label': this.thumbLabel
      };
    },
    thumbStyles: function thumbStyles() {
      return {
        left: this.inputWidth + '%'
      };
    },
    tickContainerStyles: function tickContainerStyles() {
      return {
        transform: 'translate3d(0, -50%, 0)'
      };
    },
    trackStyles: function trackStyles() {
      var scaleX = this.calculateScale(1 - this.inputWidth / 100);
      var translateX = this.inputWidth < 1 && !this.isActive ? 8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    trackFillStyles: function trackFillStyles() {
      var inputWidth = this.inputWidth;
      var scaleX = this.calculateScale(inputWidth / 100);
      var translateX = inputWidth > 99 && !this.thumbLabel ? -8 + 'px' : 0;
      return {
        transform: 'scaleX(' + scaleX + ') translateX(' + translateX + ')'
      };
    },
    numTicks: function numTicks() {
      return parseInt((this.max - this.min) / this.step);
    }
  },

  watch: {
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.inputValue = this.value;
    this.$nextTick(function () {
      _this.inputWidth = _this.calculateWidth(_this.inputValue);
    });

    // Without a v-app, iOS does not work with body selectors
    this.app = document.querySelector('[data-app]') || console.warn('The v-slider component requires the present of v-app or a non-body wrapping element with the [data-app] attribute.');
  },


  methods: {
    calculateWidth: function calculateWidth(val) {
      if (this.snap) {
        val = Math.round(val / this.step) * this.step;
      }

      val = (val - this.min) / (this.max - this.min) * 100;

      return val < 0.15 ? 0 : val;
    },
    calculateScale: function calculateScale(scale) {
      if (scale < 0.02 && !this.thumbLabel) {
        return 0;
      }

      return this.disabled ? scale - 0.015 : scale;
    },
    onMouseDown: function onMouseDown(e) {
      var options = { passive: true };
      this.isActive = true;

      if ('touches' in e) {
        this.app.addEventListener('touchmove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'touchend', this.onMouseUp);
      } else {
        this.app.addEventListener('mousemove', this.onMouseMove, options);
        Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["a" /* addOnceEventListener */])(this.app, 'mouseup', this.onMouseUp);
      }
    },
    onMouseUp: function onMouseUp() {
      var options = { passive: true };
      this.isActive = false;
      this.app.removeEventListener('touchmove', this.onMouseMove, options);
      this.app.removeEventListener('mousemove', this.onMouseMove, options);
    },
    onMouseMove: function onMouseMove(e) {
      var _$refs$track$getBound = this.$refs.track.getBoundingClientRect(),
          offsetLeft = _$refs$track$getBound.left,
          trackWidth = _$refs$track$getBound.width;

      var clientX = 'touches' in e ? e.touches[0].clientX : e.clientX;
      var left = (clientX - offsetLeft) / trackWidth * 100;

      left = left < 0 ? 0 : left > 100 ? 100 : left;

      this.inputValue = this.min + left / 100 * (this.max - this.min);
    },
    onKeyDown: function onKeyDown(e) {
      if (!e.keyCode === 37 && !e.keyCode === 39) return;

      var direction = e.keyCode === 37 && -1 || e.keyCode === 39 && 1 || 0;
      var multiplier = e.shiftKey && 3 || e.ctrlKey && 2 || 1;
      var amount = this.snap && this.step || 1;

      this.inputValue = this.inputValue + direction * amount * multiplier;
    },
    sliderMove: function sliderMove(e) {
      if (!this.isActive) {
        this.onMouseMove(e);
      }
    },
    genThumbLabel: function genThumbLabel(h) {
      return h('v-scale-transition', {
        props: { origin: 'bottom center' }
      }, [h('div', {
        'class': 'slider__thumb--label__container',
        directives: [{
          name: 'show',
          value: this.isActive
        }]
      }, [h('div', { 'class': 'slider__thumb--label' }, [h('span', {}, parseInt(this.inputValue))])])]);
    },
    genThumbContainer: function genThumbContainer(h) {
      var children = [];
      children.push(h('div', { 'class': 'slider__thumb' }));

      this.thumbLabel && children.push(this.genThumbLabel(h));

      return h('div', {
        'class': this.thumbContainerClasses,
        style: this.thumbStyles,
        on: {
          touchstart: this.onMouseDown,
          mousedown: this.onMouseDown
        },
        ref: 'thumb'
      }, children);
    },
    genSteps: function genSteps(h) {
      var _this2 = this;

      var ticks = Object(__WEBPACK_IMPORTED_MODULE_1__util_helpers__["c" /* createRange */])(this.numTicks + 1).map(function (i) {
        var span = h('span', {
          class: 'slider__tick',
          style: {
            left: i * (100 / _this2.numTicks) + '%'
          }
        });

        return span;
      });

      return h('div', {
        'class': 'slider__ticks-container',
        style: this.tickContainerStyles
      }, ticks);
    },
    genTrackContainer: function genTrackContainer(h) {
      var children = [h('div', {
        'class': 'slider__track',
        style: this.trackStyles
      }), h('div', {
        'class': 'slider__track-fill',
        style: this.trackFillStyles
      })];

      return h('div', {
        'class': 'slider__track__container',
        ref: 'track'
      }, children);
    }
  },

  render: function render(h) {
    var children = [];

    children.push(this.genTrackContainer(h));
    this.step && children.push(this.genSteps(h));
    children.push(this.genThumbContainer(h));

    var slider = h('div', { 'class': 'slider' }, children);

    return this.genInputGroup([slider], {
      attrs: {
        role: 'slider',
        tabindex: this.tabindex
      },
      on: Object.assign({}, {
        mouseup: this.sliderMove,
        keydown: this.onKeyDown
      }, this.$listeners),
      directives: [{
        name: 'click-outside'
      }]
    });
  }
});

/***/ }),
/* 109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSubheader__ = __webpack_require__(110);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSubheader: __WEBPACK_IMPORTED_MODULE_0__VSubheader__["a" /* default */]
});

/***/ }),
/* 110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  functional: true,

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  props: {
    inset: Boolean
  },

  render: function render(h, _ref) {
    var data = _ref.data,
        children = _ref.children,
        props = _ref.props;

    data.staticClass = ('subheader ' + (data.staticClass || '')).trim();

    if (props.inset) data.staticClass += ' subheader--inset';
    if (props.light) data.staticClass += ' theme--light';
    if (props.dark) data.staticClass += ' theme--dark';

    return h('li', data, children);
  }
});

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VStepper__ = __webpack_require__(112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VStepperStep__ = __webpack_require__(113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VStepperContent__ = __webpack_require__(114);





var VStepperHeader = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('stepper__header');

/* harmony default export */ __webpack_exports__["a"] = ({
  VStepper: __WEBPACK_IMPORTED_MODULE_1__VStepper__["a" /* default */],
  VStepperContent: __WEBPACK_IMPORTED_MODULE_3__VStepperContent__["a" /* default */],
  VStepperHeader: VStepperHeader,
  VStepperStep: __WEBPACK_IMPORTED_MODULE_2__VStepperStep__["a" /* default */]
});

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    return {
      stepClick: this.stepClick
    };
  },
  data: function data() {
    return {
      inputValue: null,
      isBooted: false,
      steps: [],
      content: [],
      isReverse: false
    };
  },


  props: {
    nonLinear: Boolean,
    altLabels: Boolean,
    vertical: Boolean,
    value: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper': true,
        'stepper--is-booted': this.isBooted,
        'stepper--vertical': this.vertical,
        'stepper--alt-labels': this.altLabels,
        'stepper--non-linear': this.nonLinear,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    inputValue: function inputValue(val, prev) {
      var _this = this;

      this.isReverse = Number(val) < Number(prev);
      this.steps.forEach(function (i) {
        return i.toggle(_this.inputValue);
      });
      this.content.forEach(function (i) {
        return i.toggle(_this.inputValue, _this.isReverse);
      });

      this.$emit('input', this.inputValue);
      prev && (this.isBooted = true);
    },
    value: function value() {
      this.inputValue = this.value;
    }
  },

  mounted: function mounted() {
    this.$vuetify.load(this.init);
  },


  methods: {
    init: function init() {
      var _this2 = this;

      this.$children.forEach(function (i) {
        if (i.$options._componentTag === 'v-stepper-step') {
          _this2.steps.push(i);
        } else if (i.$options._componentTag === 'v-stepper-content') {
          i.isVertical = _this2.vertical;
          _this2.content.push(i);
        }
      });

      this.inputValue = this.value || this.steps[0].step || 1;
    },
    stepClick: function stepClick(step) {
      this.inputValue = step;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes
    }, this.$slots.default);
  }
});

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-step',

  inject: ['stepClick'],

  data: function data() {
    return {
      isActive: false,
      isInactive: true
    };
  },


  props: {
    complete: Boolean,
    completeIcon: {
      type: String,
      default: 'check'
    },
    editIcon: {
      type: String,
      default: 'edit'
    },
    errorIcon: {
      type: String,
      default: 'warning'
    },
    editable: Boolean,
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    step: [Number, String]
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__step': true,
        'stepper__step--active': this.isActive,
        'stepper__step--editable': this.editable,
        'stepper__step--inactive': this.isInactive,
        'stepper__step--error': this.hasError,
        'stepper__step--complete': this.complete
      };
    },
    hasError: function hasError() {
      return this.rules.some(function (i) {
        return i() !== true;
      });
    }
  },

  methods: {
    click: function click(e) {
      e.stopPropagation();

      if (this.editable) {
        this.stepClick(this.step);
      }
    },
    toggle: function toggle(step) {
      this.isActive = step.toString() === this.step.toString();
      this.isInactive = Number(step) < Number(this.step);
    }
  },

  render: function render(h) {
    var data = {
      'class': this.classes,
      directives: [{
        name: 'ripple',
        value: this.editable
      }],
      on: { click: this.click }
    };
    var stepContent = void 0;

    if (this.hasError) {
      stepContent = [h('v-icon', {}, this.errorIcon)];
    } else if (this.complete) {
      if (this.editable) {
        stepContent = [h('v-icon', {}, this.editIcon)];
      } else {
        stepContent = [h('v-icon', {}, this.completeIcon)];
      }
    } else {
      stepContent = this.step;
    }

    var step = h('span', { 'class': 'stepper__step__step' }, stepContent);
    var label = h('div', { 'class': 'stepper__label' }, this.$slots.default);

    return h('div', data, [step, label]);
  }
});

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-stepper-content',

  data: function data() {
    return {
      height: 0,
      isActive: false,
      isReverse: false,
      isVertical: false
    };
  },


  props: {
    step: {
      type: [Number, String],
      required: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'stepper__content': true
      };
    },
    computedTransition: function computedTransition() {
      return this.isReverse ? 'v-tab-reverse-transition' : 'v-tab-transition';
    },
    styles: function styles() {
      if (!this.isVertical) return {};

      return {
        height: !isNaN(this.height) ? this.height + 'px' : this.height
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'stepper__wrapper': true
      };
    }
  },

  watch: {
    isActive: function isActive() {
      if (!this.isVertical) {
        return;
      }

      if (this.isActive) {
        this.enter();
      } else {
        this.leave();
      }
    }
  },

  mounted: function mounted() {
    this.$refs.wrapper.addEventListener('transitionend', this.onTransition, false);
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.wrapper.removeEventListener('transitionend', this.onTransition, false);
  },


  methods: {
    onTransition: function onTransition() {
      if (!this.isActive) return;

      this.height = 'auto';
    },
    enter: function enter() {
      var _this = this;

      var scrollHeight = 0;

      // Render bug with height
      setTimeout(function () {
        scrollHeight = _this.$refs.wrapper.scrollHeight;
      }, 0);

      this.height = 0;

      // Give the collapsing element time to collapse
      setTimeout(function () {
        return _this.height = scrollHeight || 'auto';
      }, 450);
    },
    leave: function leave() {
      var _this2 = this;

      this.height = this.$refs.wrapper.clientHeight;
      setTimeout(function () {
        return _this2.height = 0;
      }, 0);
    },
    toggle: function toggle(step, reverse) {
      this.isActive = step.toString() === this.step.toString();
      this.isReverse = reverse;
    }
  },

  render: function render(h) {
    var contentData = {
      'class': this.classes
    };
    var wrapperData = {
      'class': this.wrapperClasses,
      style: this.styles,
      ref: 'wrapper'
    };

    if (!this.isVertical) {
      contentData.directives = [{
        name: 'show',
        value: this.isActive
      }];
    }

    var wrapper = h('div', wrapperData, [this.$slots.default]);
    var content = h('div', contentData, [wrapper]);

    return h(this.computedTransition, {
      on: this.$listeners
    }, [content]);
  }
});

/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VTableOverflow */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VDataTable__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VEditDialog__ = __webpack_require__(121);




var VTableOverflow = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('table__overflow');

/* harmony default export */ __webpack_exports__["a"] = ({
  VDataTable: __WEBPACK_IMPORTED_MODULE_1__VDataTable__["a" /* default */],
  VEditDialog: __WEBPACK_IMPORTED_MODULE_2__VEditDialog__["a" /* default */],
  VTableOverflow: VTableOverflow
});

/***/ }),
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_head__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_body__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__mixins_foot__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__mixins_progress__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__util_helpers__ = __webpack_require__(0);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-datatable',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_head__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_body__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__mixins_filterable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__mixins_foot__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__mixins_progress__["a" /* default */], __WEBPACK_IMPORTED_MODULE_5__mixins_themeable__["a" /* default */]],

  components: {
    VBtn: __WEBPACK_IMPORTED_MODULE_6__components_buttons_VBtn__["a" /* default */],
    VIcon: __WEBPACK_IMPORTED_MODULE_7__components_icons_VIcon__["a" /* default */],
    VProgressLinear: __WEBPACK_IMPORTED_MODULE_8__components_progress_VProgressLinear__["a" /* default */],
    VSelect: __WEBPACK_IMPORTED_MODULE_9__components_selects_VSelect__["a" /* default */],
    // Importing does not work properly
    'v-table-overflow': Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["d" /* createSimpleFunctional */])('table__overflow')
  },

  data: function data() {
    return {
      all: false,
      searchLength: 0,
      defaultPagination: {
        page: 1,
        rowsPerPage: 5,
        descending: false,
        totalItems: 0
      }
    };
  },


  props: {
    headers: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    headerText: {
      type: String,
      default: 'text'
    },
    hideActions: Boolean,
    noResultsText: {
      type: String,
      default: 'No matching records found'
    },
    rowsPerPageItems: {
      type: Array,
      default: function _default() {
        return [5, 10, 25, { text: 'All', value: -1 }];
      }
    },
    rowsPerPageText: {
      type: String,
      default: 'Rows per page:'
    },
    selectAll: [Boolean, String],
    search: {
      required: false
    },
    filter: {
      type: Function,
      default: function _default(val, search) {
        return val !== null && ['undefined', 'boolean'].indexOf(typeof val === 'undefined' ? 'undefined' : _typeof(val)) === -1 && val.toString().toLowerCase().indexOf(search) !== -1;
      }
    },
    customFilter: {
      type: Function,
      default: function _default(items, search, filter) {
        search = search.toString().toLowerCase();
        return items.filter(function (i) {
          return Object.keys(i).some(function (j) {
            return filter(i[j], search);
          });
        });
      }
    },
    customSort: {
      type: Function,
      default: function _default(items, index, isDescending) {
        if (index === null) return items;

        return items.sort(function (a, b) {
          var sortA = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(a, index);
          var sortB = Object(__WEBPACK_IMPORTED_MODULE_10__util_helpers__["g" /* getObjectValueByPath */])(b, index);

          if (isDescending) {
            var _ref = [sortB, sortA];
            sortA = _ref[0];
            sortB = _ref[1];
          }

          // Check if both are numbers
          if (!isNaN(sortA) && !isNaN(sortB)) {
            return sortA - sortB;
          }

          // Check if both cannot be evaluated
          if (sortA === null && sortB === null) {
            return 0;
          }

          var _map = [sortA, sortB].map(function (s) {
            return (s || '').toString().toLocaleLowerCase();
          });

          var _map2 = _slicedToArray(_map, 2);

          sortA = _map2[0];
          sortB = _map2[1];


          if (sortA > sortB) return 1;
          if (sortA < sortB) return -1;

          return 0;
        });
      }
    },
    value: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    items: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    },
    totalItems: {
      type: Number,
      default: null
    },
    loading: {
      type: [Boolean, String],
      default: false
    },
    selectedKey: {
      type: String,
      default: 'id'
    },
    pagination: {
      type: Object,
      default: null
    }
  },

  computed: {
    classes: function classes() {
      return {
        'datatable table': true,
        'datatable--select-all': this.selectAll !== false,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    },
    computedPagination: function computedPagination() {
      return this.pagination || this.defaultPagination;
    },
    hasSelectAll: function hasSelectAll() {
      return this.selectAll !== undefined && this.selectAll !== false;
    },
    itemsLength: function itemsLength() {
      if (this.search) return this.searchLength;
      return this.totalItems || this.items.length;
    },
    indeterminate: function indeterminate() {
      return this.hasSelectAll && this.someItems && !this.everyItem;
    },
    everyItem: function everyItem() {
      var _this = this;

      return this.filteredItems.length && this.filteredItems.every(function (i) {
        return _this.isSelected(i);
      });
    },
    someItems: function someItems() {
      var _this2 = this;

      return this.filteredItems.some(function (i) {
        return _this2.isSelected(i);
      });
    },
    getPage: function getPage() {
      var rowsPerPage = this.computedPagination.rowsPerPage;


      return rowsPerPage === Object(rowsPerPage) ? rowsPerPage.value : rowsPerPage;
    },
    pageStart: function pageStart() {
      return this.getPage === -1 ? 0 : (this.computedPagination.page - 1) * this.getPage;
    },
    pageStop: function pageStop() {
      return this.getPage === -1 ? this.itemsLength : this.computedPagination.page * this.getPage;
    },
    filteredItems: function filteredItems() {
      if (this.totalItems) return this.items;

      var items = this.items.slice();
      var hasSearch = typeof this.search !== 'undefined' && this.search !== null;

      if (hasSearch) {
        items = this.customFilter(items, this.search, this.filter);
        this.searchLength = items.length;
      }

      items = this.customSort(items, this.computedPagination.sortBy, this.computedPagination.descending);

      return this.hideActions && !this.pagination ? items : items.slice(this.pageStart, this.pageStop);
    },
    selected: function selected() {
      var _this3 = this;

      var selected = {};
      this.value.forEach(function (i) {
        return selected[i[_this3.selectedKey]] = true;
      });
      return selected;
    }
  },

  watch: {
    indeterminate: function indeterminate(val) {
      if (val) this.all = true;
    },
    someItems: function someItems(val) {
      if (!val) this.all = false;
    },
    search: function search() {
      this.updatePagination({ page: 1 });
    },
    everyItem: function everyItem(val) {
      if (val) this.all = true;
    }
  },

  methods: {
    updatePagination: function updatePagination(val) {
      var pagination = this.pagination || this.defaultPagination;
      var updatedPagination = Object.assign({}, pagination, val);

      if (this.pagination) {
        this.$emit('update:pagination', updatedPagination);
      } else {
        this.defaultPagination = updatedPagination;
      }
    },
    isSelected: function isSelected(item) {
      return this.selected[item[this.selectedKey]];
    },
    sort: function sort(index) {
      var _computedPagination = this.computedPagination,
          sortBy = _computedPagination.sortBy,
          descending = _computedPagination.descending;

      if (sortBy === null) {
        this.updatePagination({ sortBy: index, descending: false });
      } else if (sortBy === index && !descending) {
        this.updatePagination({ descending: true });
      } else if (sortBy !== index) {
        this.updatePagination({ sortBy: index, descending: false });
      } else {
        this.updatePagination({ sortBy: null, descending: null });
      }
    },
    needsTR: function needsTR(row) {
      return row.length && row.find(function (c) {
        return c.tag === 'td';
      });
    },
    genTR: function genTR(children) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      return this.$createElement('tr', data, children);
    },
    toggle: function toggle(value) {
      var _this4 = this;

      var selected = Object.assign({}, this.selected);
      this.filteredItems.forEach(function (i) {
        return selected[i[_this4.selectedKey]] = value;
      });

      this.$emit('input', this.items.filter(function (i) {
        return selected[i[_this4.selectedKey]];
      }));
    }
  },

  created: function created() {
    var firstSortable = this.headers.find(function (h) {
      return !('sortable' in h) || h.sortable;
    });

    this.defaultPagination.sortBy = firstSortable ? firstSortable.value : null;

    if (!this.rowsPerPageItems.length) {
      console.warn('The prop \'rows-per-page-items\' in v-data-table can not be empty.');
    } else {
      this.defaultPagination.rowsPerPage = this.rowsPerPageItems[0];
    }

    this.updatePagination(Object.assign({}, this.defaultPagination, this.pagination));
  },
  render: function render(h) {
    return h('v-table-overflow', {}, [h('table', {
      'class': this.classes
    }, [this.genTHead(), this.genTProgress(), this.genTBody(), this.genTFoot()])]);
  }
});

/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTHead: function genTHead() {
      var _this = this;

      var children = [];

      if (this.$scopedSlots.headers) {
        var row = this.$scopedSlots.headers({
          headers: this.headers,
          indeterminate: this.indeterminate,
          all: this.all
        });

        children = this.needsTR(row) ? this.genTR(row) : row;
      } else {
        var _row = this.headers.map(function (o) {
          return _this.genHeader(o);
        });
        var checkbox = this.$createElement('v-checkbox', {
          props: {
            dark: this.dark,
            light: this.light,
            color: this.selectAll === true && '' || this.selectAll,
            hideDetails: true,
            inputValue: this.all,
            indeterminate: this.indeterminate
          },
          on: { change: this.toggle }
        });

        this.hasSelectAll && _row.unshift(this.$createElement('th', [checkbox]));

        children = this.genTR(_row);
      }

      return this.$createElement('thead', [children]);
    },
    genHeader: function genHeader(header) {
      var array = [this.$scopedSlots.headerCell ? this.$scopedSlots.headerCell({ header: header }) : header[this.headerText]];

      return this.$createElement.apply(this, ['th'].concat(_toConsumableArray(this.genHeaderData(header, array))));
    },
    genHeaderData: function genHeaderData(header, children) {
      var _this2 = this;

      var classes = ['column'];
      var data = {};
      var pagination = this.computedPagination;

      if ('sortable' in header && header.sortable || !('sortable' in header)) {
        data.on = { click: function click() {
            return _this2.sort(header.value);
          } };
        if (!('value' in header)) {
          console.warn('Data table headers must have a value property that corresponds to a value in the v-model array');
        }

        classes.push('sortable');
        var icon = this.$createElement('v-icon', 'arrow_upward');
        if (header.align && header.align === 'left') {
          children.push(icon);
        } else {
          children.unshift(icon);
        }

        var beingSorted = pagination.sortBy === header.value;
        if (beingSorted) {
          classes.push('active');
          classes.push(pagination.descending ? 'desc' : 'asc');
        }
      }

      classes.push('text-xs-' + (header.align || 'right'));
      data.class = classes;

      return [data, children];
    }
  }
});

/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genTBody: function genTBody() {
      var children = [];

      if (!this.itemsLength) {
        children.push(this.genEmptyBody(this.noDataText));
      } else if (!this.filteredItems.length) {
        children.push(this.genEmptyBody(this.noResultsText));
      } else {
        children.push(this.genFilteredItems());
      }

      return this.$createElement('tbody', children);
    },
    genFilteredItems: function genFilteredItems() {
      var _this = this;

      return this.filteredItems.map(function (item, index) {
        var props = { item: item, index: index };
        var key = _this.selectedKey;

        Object.defineProperty(props, 'selected', {
          get: function get() {
            return _this.selected[item[_this.selectedKey]];
          },
          set: function set(value) {
            var selected = _this.value.slice();
            if (value) selected.push(item);else selected = selected.filter(function (i) {
              return i[key] !== item[key];
            });

            _this.$emit('input', selected);
          }
        });

        var row = _this.$scopedSlots.items(props);

        return _this.needsTR(row) ? _this.genTR(row, {
          attrs: { active: _this.isSelected(item) }
        }) : row;
      });
    },
    genEmptyBody: function genEmptyBody(text) {
      return this.genTR([this.$createElement('td', {
        'class': 'text-xs-center',
        attrs: { colspan: '100%' }
      }, text)]);
    }
  }
});

/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    genPrevIcon: function genPrevIcon() {
      var _this = this;

      return this.$createElement('v-btn', {
        props: {
          disabled: this.computedPagination.page === 1,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this.computedPagination.page;
            _this.updatePagination({ page: page - 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_left')]);
    },
    genNextIcon: function genNextIcon() {
      var _this2 = this;

      var pagination = this.computedPagination;
      var disabled = pagination.rowsPerPage < 0 || pagination.page * pagination.rowsPerPage >= this.itemsLength || this.pageStop < 0;

      return this.$createElement('v-btn', {
        props: {
          disabled: disabled,
          icon: true,
          flat: true,
          dark: this.dark,
          light: this.light
        },
        on: {
          click: function click() {
            var page = _this2.computedPagination.page;
            _this2.updatePagination({ page: page + 1 });
          }
        }
      }, [this.$createElement('v-icon', 'chevron_right')]);
    },
    genSelect: function genSelect() {
      var _this3 = this;

      return this.$createElement('div', {
        'class': 'datatable__actions__select'
      }, [this.rowsPerPageText, this.$createElement('v-select', {
        props: {
          items: this.rowsPerPageItems,
          value: this.computedPagination.rowsPerPage,
          hideDetails: true,
          auto: true,
          minWidth: '75px'
        },
        on: {
          input: function input(val) {
            _this3.updatePagination({
              page: 1,
              rowsPerPage: val
            });
          }
        }
      })]);
    },
    genPagination: function genPagination() {
      var pagination = '–';

      if (this.itemsLength) {
        var stop = this.itemsLength < this.pageStop || this.pageStop < 0 ? this.itemsLength : this.pageStop;

        pagination = this.$scopedSlots.pageText ? this.$scopedSlots.pageText({
          pageStart: this.pageStart + 1,
          pageStop: stop,
          itemsLength: this.itemsLength
        }) : this.pageStart + 1 + '-' + stop + ' of ' + this.itemsLength;
      }

      return this.$createElement('div', {
        'class': 'datatable__actions__pagination'
      }, [pagination]);
    },
    genActions: function genActions() {
      return [this.$createElement('div', {
        'class': 'datatable__actions'
      }, [this.genSelect(), this.genPagination(), this.genPrevIcon(), this.genNextIcon()])];
    },
    genTFoot: function genTFoot() {
      var children = [];

      if (this.$slots.footer) {
        var footer = this.$slots.footer;
        var row = this.needsTR(footer) ? this.genTR(footer) : footer;

        children.push(row);
      }

      if (!this.hideActions) {
        children.push(this.genTR([this.$createElement('td', {
          attrs: { colspan: '100%' }
        }, this.genActions())]));
      }

      if (!children.length) return null;
      return this.$createElement('tfoot', children);
    }
  }
});

/***/ }),
/* 120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      color: ''
    };
  },


  watch: {
    loading: function loading(val) {
      if (val) this.color = val;
    }
  },

  methods: {
    genTProgress: function genTProgress() {
      var loader = this.$createElement('v-progress-linear', {
        props: {
          primary: this.color === 'primary',
          secondary: this.color === 'secondary',
          success: this.color === 'success',
          info: this.color === 'info',
          warning: this.color === 'warning',
          error: this.color === 'error',
          indeterminate: true,
          height: 3,
          active: !!this.loading
        }
      });

      var col = this.$createElement('th', {
        class: 'column',
        attrs: {
          colspan: '100%'
        }
      }, [loader]);

      return this.$createElement('thead', {
        class: 'datatable__progress'
      }, [this.genTR([col])]);
    }
  }
});

/***/ }),
/* 121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-edit-dialog',

  data: function data() {
    return {
      isActive: false,
      isSaving: false
    };
  },


  props: {
    cancelText: {
      default: 'Cancel'
    },
    large: Boolean,
    lazy: Boolean,
    saveText: {
      default: 'Save'
    },
    transition: {
      type: String,
      default: 'slide-x-reverse-transition'
    }
  },

  watch: {
    isActive: function isActive(val) {
      val && this.$emit('open') && setTimeout(this.focus, 50); // Give DOM time to paint

      if (!val) {
        !this.isSaving && this.$emit('cancel');
        this.isSaving && this.$emit('close');
        this.isSaving = false;
      }
    }
  },

  methods: {
    cancel: function cancel() {
      this.isActive = false;
    },
    focus: function focus() {
      var input = this.$refs.content.querySelector('input');
      input && input.focus();
    },
    save: function save() {
      this.isSaving = true;
      this.isActive = false;
      this.$emit('save');
    },
    genButton: function genButton(fn, text) {
      return this.$createElement('v-btn', {
        props: {
          flat: true,
          primary: true,
          light: true
        },
        on: { click: fn }
      }, text);
    },
    genActions: function genActions() {
      return this.$createElement('div', {
        'class': 'small-dialog__actions',
        directives: [{
          name: 'show',
          value: this.large
        }]
      }, [this.genButton(this.cancel, this.cancelText), this.genButton(this.save, this.saveText)]);
    },
    genContent: function genContent() {
      var _this = this;

      return this.$createElement('div', {
        'class': 'small-dialog__content',
        on: {
          keydown: function keydown(e) {
            e.keyCode === 27 && _this.cancel();
            e.keyCode === 13 && _this.save();
          }
        },
        ref: 'content'
      }, [this.$slots.input]);
    }
  },

  render: function render(h) {
    var _this2 = this;

    return h('v-menu', {
      'class': 'small-dialog',
      props: {
        transition: this.transition,
        origin: 'top right',
        right: true,
        value: this.isActive,
        closeOnContentClick: false,
        lazy: this.lazy
      },
      on: {
        input: function input(val) {
          return _this2.isActive = val;
        }
      }
    }, [h('a', {
      domProps: { href: 'javascript:;' },
      slot: 'activator'
    }, this.$slots.default), this.genContent(), this.genActions()]);
  }
});

/***/ }),
/* 122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__util_helpers__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__VTabs__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__VTabsItem__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__VTabsContent__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__VTabsBar__ = __webpack_require__(126);






var VTabsSlider = Object(__WEBPACK_IMPORTED_MODULE_0__util_helpers__["d" /* createSimpleFunctional */])('tabs__slider', 'li');

var VTabsItems = {
  name: 'v-tabs-items',

  render: function render(h) {
    return h('div', { 'class': { 'tabs__items': true } }, [this.$slots.default]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  VTabsItem: __WEBPACK_IMPORTED_MODULE_2__VTabsItem__["a" /* default */],
  VTabsItems: VTabsItems,
  VTabs: __WEBPACK_IMPORTED_MODULE_1__VTabs__["a" /* default */],
  VTabsContent: __WEBPACK_IMPORTED_MODULE_3__VTabsContent__["a" /* default */],
  VTabsBar: __WEBPACK_IMPORTED_MODULE_4__VTabsBar__["a" /* default */],
  VTabsSlider: VTabsSlider
});

/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_themeable__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_themeable__["a" /* default */]],

  provide: function provide() {
    var _this = this;

    return {
      slider: this.slider,
      tabClick: this.tabClick,
      isScrollable: function isScrollable() {
        return _this.scrollable;
      },
      isMobile: function isMobile() {
        return _this.isMobile;
      }
    };
  },
  data: function data() {
    return {
      activators: [],
      activeIndex: null,
      isMobile: false,
      reverse: false,
      target: null,
      tabsSlider: null,
      targetEl: null,
      tabsContainer: null
    };
  },


  props: {
    centered: Boolean,
    fixed: Boolean,
    grow: Boolean,
    icons: Boolean,
    mobileBreakPoint: {
      type: [Number, String],
      default: 1024
    },
    value: String,
    scrollable: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    classes: function classes() {
      return {
        'tabs': true,
        'tabs--centered': this.centered,
        'tabs--fixed': this.fixed,
        'tabs--grow': this.grow,
        'tabs--icons': this.icons,
        'tabs--mobile': this.isMobile,
        'tabs--scroll-bars': this.scrollable,
        'theme--dark': this.dark,
        'theme--light': this.light
      };
    }
  },

  watch: {
    value: function value() {
      this.tabClick(this.value);
    },
    activeIndex: function activeIndex() {
      this.updateTabs();
      this.$emit('input', this.target);
      this.isBooted = true;
    }
  },

  mounted: function mounted() {
    var _this2 = this;

    this.$vuetify.load(function () {
      var activators = _this2.$slots.activators;

      if (!activators || !activators.length || !activators[0].componentInstance) return;

      var bar = activators[0].componentInstance.$children;
      // // This is a workaround to detect if link is active
      // // when being used as a router or nuxt link
      var i = bar.findIndex(function (t) {
        return t.$el.firstChild.classList.contains('tabs__item--active');
      });

      var tab = _this2.value || (bar[i !== -1 ? i : 0] || {}).action;

      tab && _this2.tabClick(tab) && _this2.onResize();
    });
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.resize, { passive: true });
  },


  methods: {
    onResize: function onResize() {
      this.isMobile = window.innerWidth < this.mobileBreakPoint;
      this.slider();
    },
    slider: function slider(el) {
      var _this3 = this;

      this.tabsSlider = this.tabsSlider || this.$el.querySelector('.tabs__slider');

      this.tabsContainer = this.tabsContainer || this.$el.querySelector('.tabs__container');

      if (!this.tabsSlider || !this.tabsContainer) return;

      this.targetEl = el || this.targetEl;

      if (!this.targetEl || !this.tabsContainer) return;

      // Gives DOM time to paint when
      // processing slider for
      // dynamic tabs
      this.$nextTick(function () {
        // #684 Calculate width as %
        var width = _this3.targetEl.scrollWidth / _this3.tabsContainer.clientWidth * 100;

        _this3.tabsSlider.style.width = width + '%';
        _this3.tabsSlider.style.left = _this3.targetEl.offsetLeft + 'px';
      });
    },
    tabClick: function tabClick(target) {
      var _this4 = this;

      var setActiveIndex = function setActiveIndex(index) {
        if (_this4.activeIndex === index) {
          // #762 update tabs display
          // In case tabs count got changed but activeIndex didn't
          _this4.updateTabs();
        } else {
          _this4.activeIndex = index;
        }
      };

      this.target = target;

      var content = this.$refs.content;
      if (!content) {
        setActiveIndex(target);
        return;
      }

      this.$nextTick(function () {
        var nextIndex = content.$children.findIndex(function (i) {
          return i.id === target;
        });
        _this4.reverse = nextIndex < _this4.activeIndex;
        setActiveIndex(nextIndex);
      });
    },
    updateTabs: function updateTabs() {
      var _this5 = this;

      var activators = this.$slots.activators;
      var content = this.$refs.content;

      if (!activators || !activators.length || activators.length && !activators[0].componentInstance) return;

      activators[0].componentInstance.$children.filter(function (i) {
        return i.$options._componentTag === 'v-tabs-item';
      }).forEach(function (i) {
        return i.toggle(_this5.target);
      });

      content && content.$children.forEach(function (i) {
        return i.toggle(_this5.target, _this5.reverse, _this5.isBooted);
      });
    }
  },

  render: function render(h) {
    var content = [];
    var slot = [];
    var iter = this.$slots.default || [];

    iter.forEach(function (c) {
      if (!c.componentOptions) slot.push(c);else if (c.componentOptions.tag === 'v-tabs-content') content.push(c);else slot.push(c);
    });

    var tabs = content.length ? h('v-tabs-items', {
      ref: 'content'
    }, content) : null;

    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [slot, this.$slots.activators, tabs]);
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_route_link__ = __webpack_require__(9);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-item',

  inject: ['slider', 'tabClick'],

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_route_link__["a" /* default */]],

  data: function data() {
    return {
      isActive: false
    };
  },


  props: {
    activeClass: {
      type: String,
      default: 'tabs__item--active'
    }
  },

  computed: {
    classes: function classes() {
      var classes = {
        'tabs__item': true,
        'tabs__item--disabled': this.disabled
      };

      classes[this.activeClass] = !this.to && this.isActive;

      return classes;
    },
    action: function action() {
      var to = this.to || this.href;

      if (!to || to === Object(to)) return this._uid;

      return to.replace('#', '');
    }
  },

  watch: {
    $route: function $route() {
      this.to && this.callSlider();
    }
  },

  mounted: function mounted() {
    this.callSlider();
  },


  methods: {
    callSlider: function callSlider() {
      var _this = this;

      setTimeout(function () {
        _this.$el.firstChild.classList.contains('tabs__item--active') && _this.slider(_this.$el);
      }, 0);
    },
    click: function click(e) {
      e.preventDefault();

      if (!this.to && !this.href) return;

      if (!this.to) {
        this.tabClick(this.action);
      }

      this.callSlider();
    },
    toggle: function toggle(action) {
      var _this2 = this;

      this.isActive = this.action === action;

      this.$nextTick(function () {
        _this2.isActive && _this2.slider(_this2.$el);
      });
    }
  },

  render: function render(h) {
    var _generateRouteLink = this.generateRouteLink(),
        tag = _generateRouteLink.tag,
        data = _generateRouteLink.data;

    return h('li', {
      'class': 'tabs__li'
    }, [h(tag, data, this.$slots.default)]);
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_bootable__ = __webpack_require__(10);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-content',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_bootable__["a" /* default */]],

  data: function data() {
    return {
      isActive: false,
      reverse: false
    };
  },


  props: {
    id: {
      type: String,
      required: true
    },
    lazy: Boolean,
    transition: {
      type: String,
      default: 'v-tab-transition'
    },
    reverseTransition: {
      type: String,
      default: 'v-tab-reverse-transition'
    }
  },

  computed: {
    computedTransition: function computedTransition() {
      return this.reverse ? this.reverseTransition : this.transition;
    }
  },

  methods: {
    toggle: function toggle(target, reverse, showTransition) {
      this.$el.style.transition = !showTransition ? 'none' : null;
      this.reverse = reverse;
      this.isActive = this.id === target;
    }
  },

  render: function render(h) {
    return h(this.computedTransition, {}, [h('div', {
      'class': 'tabs__content',
      domProps: { id: this.id },
      directives: [{
        name: 'show',
        value: this.isActive
      }],
      on: this.$listeners
    }, this.lazy && this.isBooted || !this.lazy ? this.$slots.default : null)]);
  }
});

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__directives__ = __webpack_require__(4);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-tabs-bar',

  directives: {
    Resize: __WEBPACK_IMPORTED_MODULE_1__directives__["Resize"]
  },

  inject: ['isScrollable', 'isMobile'],

  data: function data() {
    return {
      isOverflowing: false,
      scrollOffset: 0,
      itemOffset: 0,
      startX: 0
    };
  },


  computed: {
    classes: function classes() {
      return {
        'tabs__bar': true
      };
    },
    containerClasses: function containerClasses() {
      return {
        'tabs__container': true
      };
    },
    wrapperClasses: function wrapperClasses() {
      return {
        'tabs__wrapper': true,
        'tabs__wrapper--scrollable': this.isScrollable(),
        'tabs__wrapper--overflow': this.isOverflowing
      };
    },
    containerStyles: function containerStyles() {
      return {
        'transform': 'translateX(' + -this.scrollOffset + 'px)'
      };
    },
    leftIconVisible: function leftIconVisible() {
      return !this.isMobile() && this.isScrollable() && this.isOverflowing && this.scrollOffset > 0;
    },
    rightIconVisible: function rightIconVisible() {
      if (this.isMobile() || !this.isScrollable() || !this.isOverflowing) return;

      // Check one scroll ahead to know the width of right-most item
      var container = this.$refs.container;
      var item = this.newOffsetRight(this.scrollOffset, this.itemOffset);
      var itemWidth = item && container.children[item.index].clientWidth || 0;
      var scrollOffset = this.scrollOffset + container.clientWidth;

      return container.scrollWidth - scrollOffset > itemWidth * 0.30;
    }
  },

  methods: {
    genContainer: function genContainer() {
      return this.$createElement('ul', {
        'class': this.containerClasses,
        'style': this.containerStyles,
        ref: 'container'
      }, this.$slots.default);
    },
    genIcon: function genIcon(direction) {
      var capitalize = direction.charAt(0).toUpperCase() + direction.slice(1);
      return this.$createElement(__WEBPACK_IMPORTED_MODULE_0__components_icons_VIcon__["a" /* default */], {
        props: _defineProperty({}, '' + direction, true),
        style: { display: 'inline-flex' },
        on: {
          click: this['scroll' + capitalize]
        }
      }, 'chevron_' + direction);
    },
    genWrapper: function genWrapper() {
      return this.$createElement('div', {
        class: this.wrapperClasses,
        directives: [{
          name: 'touch',
          value: {
            start: this.start,
            move: this.move,
            end: this.end
          }
        }]
      }, [this.genContainer()]);
    },
    start: function start(e) {
      this.startX = this.scrollOffset + e.touchstartX;
      this.$refs.container.style.transition = 'none';
    },
    move: function move(e) {
      var offset = this.startX - e.touchmoveX;
      this.scrollOffset = offset;
    },
    end: function end(e) {
      this.onResize();
      var container = this.$refs.container;
      var scrollWidth = container.scrollWidth - this.$el.clientWidth / 2;
      container.style.transition = null;

      if (this.scrollOffset < 0 || !this.isOverflowing) {
        this.scrollOffset = 0;
      } else if (this.scrollOffset >= scrollWidth) {
        var lastItem = container.children[container.children.length - 1];
        this.scrollOffset = scrollWidth - lastItem.clientWidth;
      }
    },
    scrollLeft: function scrollLeft() {
      var _newOffset = this.newOffset('Left'),
          offset = _newOffset.offset,
          index = _newOffset.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    scrollRight: function scrollRight() {
      var _newOffset2 = this.newOffset('Right'),
          offset = _newOffset2.offset,
          index = _newOffset2.index;

      this.scrollOffset = offset;
      this.itemOffset = index;
    },
    onResize: function onResize() {
      if (this._isDestroyed) return;

      var container = this.$refs.container;
      this.isOverflowing = container.clientWidth < container.scrollWidth;
    },
    newOffset: function newOffset(direction) {
      return this['newOffset' + direction](this.scrollOffset, this.itemOffset);
    },
    newOffsetLeft: function newOffsetLeft(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = 0;

      for (var index = currentIndex - 1; index >= 0; index--) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset >= container.clientWidth) {
            return { offset: currentOffset - offset, index: index + 1 };
          }
          offset = newOffset;
        }
      }

      return { offset: 0, index: 0 };
    },
    newOffsetRight: function newOffsetRight(currentOffset, currentIndex) {
      var container = this.$refs.container;
      var items = container.children;
      var offset = currentOffset;

      for (var index = currentIndex; index < items.length; index++) {
        if (!items[index].classList.contains('tabs__slider')) {
          var newOffset = offset + items[index].clientWidth;
          if (newOffset > currentOffset + container.clientWidth) {
            return { offset: offset, index: index };
          }
          offset = newOffset;
        }
      }

      return null;
    }
  },

  render: function render(h) {
    return h('div', {
      'class': this.classes,
      directives: [{
        name: 'resize',
        value: this.onResize
      }]
    }, [this.genWrapper(), this.leftIconVisible ? this.genIcon('left') : null, this.rightIconVisible ? this.genIcon('right') : null]);
  }
});

/***/ }),
/* 127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VTextField__ = __webpack_require__(128);


/* harmony default export */ __webpack_exports__["a"] = ({
  VTextField: __WEBPACK_IMPORTED_MODULE_0__VTextField__["a" /* default */]
});

/***/ }),
/* 128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_input__ = __webpack_require__(7);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-text-field',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_input__["a" /* default */]],

  inheritAttrs: false,

  data: function data() {
    return {
      hasFocused: false,
      inputHeight: null
    };
  },


  props: {
    autofocus: Boolean,
    autoGrow: Boolean,
    counter: Boolean,
    fullWidth: Boolean,
    max: [Number, String],
    min: [Number, String],
    multiLine: Boolean,
    placeholder: String,
    prefix: String,
    rows: {
      default: 5
    },
    singleLine: Boolean,
    solo: Boolean,
    suffix: String,
    textarea: Boolean,
    type: {
      type: String,
      default: 'text'
    }
  },

  computed: {
    classes: function classes() {
      return {
        'input-group--text-field': true,
        'input-group--single-line': this.singleLine,
        'input-group--solo': this.solo,
        'input-group--multi-line': this.multiLine,
        'input-group--full-width': this.fullWidth,
        'input-group--prefix': this.prefix,
        'input-group--suffix': this.suffix,
        'input-group--textarea': this.textarea
      };
    },
    hasError: function hasError() {
      return this.validations.length || this.errorMessages.length > 0 || !this.counterIsValid() || !this.validateIsValid() || this.error;
    },
    count: function count() {
      var inputLength = void 0;
      if (this.inputValue) inputLength = this.inputValue.toString().length;else inputLength = 0;
      var min = inputLength;

      if (this.counterMin !== 0 && inputLength < this.counterMin) {
        min = this.counterMin;
      }

      return min + ' / ' + this.counterMax;
    },
    counterMin: function counterMin() {
      var parsedMin = parseInt(this.min, 10);
      return isNaN(parsedMin) ? 0 : parsedMin;
    },
    counterMax: function counterMax() {
      var parsedMax = parseInt(this.max, 10);
      return isNaN(parsedMax) ? 25 : parsedMax;
    },

    inputValue: {
      get: function get() {
        return this.value;
      },
      set: function set(val) {
        if (this.modifiers.trim) {
          val = val.trim();
        }

        if (this.modifiers.number) {
          val = Number(val);
        }

        if (!this.modifiers.lazy) {
          this.$emit('input', val);
        }

        this.lazyValue = val;
      }
    },
    isDirty: function isDirty() {
      return this.lazyValue !== null && typeof this.lazyValue !== 'undefined' && this.lazyValue.toString().length > 0 || this.placeholder;
    }
  },

  watch: {
    focused: function focused(val) {
      this.hasFocused = true;
    },
    value: function value() {
      this.lazyValue = this.value;
      this.validate();
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    }
  },

  mounted: function mounted() {
    var _this = this;

    this.$vuetify.load(function () {
      _this.multiLine && _this.autoGrow && _this.calculateInputHeight();
      _this.autofocus && _this.focus();
    });
  },


  methods: {
    calculateInputHeight: function calculateInputHeight() {
      var _this2 = this;

      this.inputHeight = null;

      this.$nextTick(function () {
        var height = _this2.$refs.input.scrollHeight;
        var minHeight = _this2.rows * 24;
        var inputHeight = height < minHeight ? minHeight : height;
        _this2.inputHeight = inputHeight;
      });
    },
    onChange: function onChange(e) {
      this.lazyValue = e.target.value;
      this.$emit('change', this.lazyValue || null);
    },
    onInput: function onInput(e) {
      this.inputValue = e.target.value;
      this.multiLine && this.autoGrow && this.calculateInputHeight();
    },
    blur: function blur(e) {
      var _this3 = this;

      this.validate();
      this.$nextTick(function () {
        return _this3.focused = false;
      });
      this.$emit('blur', e);
    },
    focus: function focus(e) {
      this.focused = true;
      this.$refs.input.focus();
      this.$emit('focus', e);
    },
    genCounter: function genCounter() {
      return this.$createElement('div', {
        'class': {
          'input-group__counter': true,
          'input-group__counter--error': !this.counterIsValid()
        }
      }, this.count);
    },
    genInput: function genInput() {
      var tag = this.multiLine || this.textarea ? 'textarea' : 'input';

      var data = {
        style: {
          'height': this.inputHeight && this.inputHeight + 'px'
        },
        domProps: {
          autofocus: this.autofocus,
          disabled: this.disabled,
          required: this.required,
          value: this.lazyValue
        },
        attrs: _extends({}, this.$attrs, {
          tabindex: this.tabindex,
          'aria-label': !this.$attrs.id && this.label // Label `for` will be set if we have an id
        }),
        on: _extends({}, this.$listeners, {
          blur: this.blur,
          input: this.onInput,
          focus: this.focus
        }),
        ref: 'input'
      };

      if (this.placeholder) data.domProps.placeholder = this.placeholder;

      if (!this.counter) {
        if (![undefined, null].includes(this.max)) data.attrs.max = this.max;
        if (![undefined, null].includes(this.min)) data.attrs.min = this.min;
      }

      if (!this.textarea && !this.multiLine) {
        data.domProps.type = this.type;
      } else {
        data.domProps.rows = this.rows;
      }

      var children = [this.$createElement(tag, data)];

      this.prefix && children.unshift(this.genFix('prefix'));
      this.suffix && children.push(this.genFix('suffix'));

      return children;
    },
    genFix: function genFix(type) {
      return this.$createElement('span', {
        'class': 'input-group--text-field__' + type
      }, this[type]);
    },

    counterIsValid: function counterIsValid() {
      var val = this.inputValue && this.inputValue.toString() || '';

      return !this.counter || val.length >= this.counterMin && val.length <= this.counterMax;
    },
    validateIsValid: function validateIsValid() {
      return !this.required || this.required && this.isDirty || !this.hasFocused || this.hasFocused && this.focused;
    }
  },

  render: function render() {
    return this.genInputGroup(this.genInput(), { attrs: { tabindex: false } });
  }
});

/***/ }),
/* 129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__VSnackbar__ = __webpack_require__(130);


/* harmony default export */ __webpack_exports__["a"] = ({
  VSnackbar: __WEBPACK_IMPORTED_MODULE_0__VSnackbar__["a" /* default */]
});

/***/ }),
/* 130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__ = __webpack_require__(2);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'v-snackbar',

  mixins: [__WEBPACK_IMPORTED_MODULE_0__mixins_contextualable__["a" /* default */], __WEBPACK_IMPORTED_MODULE_1__mixins_toggleable__["a" /* default */]],

  data: function data() {
    return {
      activeTimeout: {}
    };
  },


  props: {
    absolute: Boolean,
    bottom: Boolean,
    left: Boolean,
    multiLine: Boolean,
    right: Boolean,
    top: Boolean,
    timeout: {
      type: Number,
      default: 6000
    },
    vertical: Boolean
  },

  computed: {
    classes: function classes() {
      return {
        'snack': true,
        'snack--active': this.isActive,
        'snack--absolute': this.absolute,
        'snack--bottom': this.bottom || !this.top,
        'snack--left': this.left,
        'snack--multi-line': this.multiLine && !this.vertical,
        'snack--right': this.right,
        'snack--top': this.top,
        'snack--vertical': this.vertical,
        'primary': this.primary,
        'secondary': this.secondary,
        'success': this.success,
        'info': this.info,
        'warning': this.warning,
        'error': this.error
      };
    },
    computedTransition: function computedTransition() {
      return this.top ? 'v-slide-y-transition' : 'v-slide-y-reverse-transition';
    }
  },

  watch: {
    isActive: function isActive() {
      var _this = this;

      clearTimeout(this.activeTimeout);

      if (this.isActive && this.timeout) {
        this.activeTimeout = setTimeout(function () {
          _this.isActive = false;
        }, this.timeout);
      }
    }
  },

  render: function render(h) {
    var children = [];

    if (this.isActive) {
      children.push(h('div', {
        'class': 'snack__content'
      }, this.$slots.default));
    }

    return h('div', {
      'class': this.classes,
      on: this.$listeners
    }, [h(this.computedTransition, children)]);
  }
});

/***/ }),
/* 131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function load(cb) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  if (document.readyState === 'complete') {
    return setTimeout(cb, 0);
  }

  if (document.readyState === 'interactive' && i <= 10) {
    return setTimeout(function () {
      return load(cb, i + 1);
    }, 200);
  }

  window.addEventListener('load', cb);
}

/* harmony default export */ __webpack_exports__["a"] = (load);

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = SemVer;

// The debug function is excluded entirely from the minified version.
/* nomin */ var debug;
/* nomin */ if (typeof process === 'object' &&
    /* nomin */ process.env &&
    /* nomin */ process.env.NODE_DEBUG &&
    /* nomin */ /\bsemver\b/i.test(process.env.NODE_DEBUG))
  /* nomin */ debug = function() {
    /* nomin */ var args = Array.prototype.slice.call(arguments, 0);
    /* nomin */ args.unshift('SEMVER');
    /* nomin */ console.log.apply(console, args);
    /* nomin */ };
/* nomin */ else
  /* nomin */ debug = function() {};

// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
exports.SEMVER_SPEC_VERSION = '2.0.0';

var MAX_LENGTH = 256;
var MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;

// The actual regexps go on exports.re
var re = exports.re = [];
var src = exports.src = [];
var R = 0;

// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.

// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.

var NUMERICIDENTIFIER = R++;
src[NUMERICIDENTIFIER] = '0|[1-9]\\d*';
var NUMERICIDENTIFIERLOOSE = R++;
src[NUMERICIDENTIFIERLOOSE] = '[0-9]+';


// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.

var NONNUMERICIDENTIFIER = R++;
src[NONNUMERICIDENTIFIER] = '\\d*[a-zA-Z-][a-zA-Z0-9-]*';


// ## Main Version
// Three dot-separated numeric identifiers.

var MAINVERSION = R++;
src[MAINVERSION] = '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')\\.' +
                   '(' + src[NUMERICIDENTIFIER] + ')';

var MAINVERSIONLOOSE = R++;
src[MAINVERSIONLOOSE] = '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')\\.' +
                        '(' + src[NUMERICIDENTIFIERLOOSE] + ')';

// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.

var PRERELEASEIDENTIFIER = R++;
src[PRERELEASEIDENTIFIER] = '(?:' + src[NUMERICIDENTIFIER] +
                            '|' + src[NONNUMERICIDENTIFIER] + ')';

var PRERELEASEIDENTIFIERLOOSE = R++;
src[PRERELEASEIDENTIFIERLOOSE] = '(?:' + src[NUMERICIDENTIFIERLOOSE] +
                                 '|' + src[NONNUMERICIDENTIFIER] + ')';


// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.

var PRERELEASE = R++;
src[PRERELEASE] = '(?:-(' + src[PRERELEASEIDENTIFIER] +
                  '(?:\\.' + src[PRERELEASEIDENTIFIER] + ')*))';

var PRERELEASELOOSE = R++;
src[PRERELEASELOOSE] = '(?:-?(' + src[PRERELEASEIDENTIFIERLOOSE] +
                       '(?:\\.' + src[PRERELEASEIDENTIFIERLOOSE] + ')*))';

// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.

var BUILDIDENTIFIER = R++;
src[BUILDIDENTIFIER] = '[0-9A-Za-z-]+';

// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.

var BUILD = R++;
src[BUILD] = '(?:\\+(' + src[BUILDIDENTIFIER] +
             '(?:\\.' + src[BUILDIDENTIFIER] + ')*))';


// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.

// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.

var FULL = R++;
var FULLPLAIN = 'v?' + src[MAINVERSION] +
                src[PRERELEASE] + '?' +
                src[BUILD] + '?';

src[FULL] = '^' + FULLPLAIN + '$';

// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
var LOOSEPLAIN = '[v=\\s]*' + src[MAINVERSIONLOOSE] +
                 src[PRERELEASELOOSE] + '?' +
                 src[BUILD] + '?';

var LOOSE = R++;
src[LOOSE] = '^' + LOOSEPLAIN + '$';

var GTLT = R++;
src[GTLT] = '((?:<|>)?=?)';

// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
var XRANGEIDENTIFIERLOOSE = R++;
src[XRANGEIDENTIFIERLOOSE] = src[NUMERICIDENTIFIERLOOSE] + '|x|X|\\*';
var XRANGEIDENTIFIER = R++;
src[XRANGEIDENTIFIER] = src[NUMERICIDENTIFIER] + '|x|X|\\*';

var XRANGEPLAIN = R++;
src[XRANGEPLAIN] = '[v=\\s]*(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:\\.(' + src[XRANGEIDENTIFIER] + ')' +
                   '(?:' + src[PRERELEASE] + ')?' +
                   src[BUILD] + '?' +
                   ')?)?';

var XRANGEPLAINLOOSE = R++;
src[XRANGEPLAINLOOSE] = '[v=\\s]*(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:\\.(' + src[XRANGEIDENTIFIERLOOSE] + ')' +
                        '(?:' + src[PRERELEASELOOSE] + ')?' +
                        src[BUILD] + '?' +
                        ')?)?';

var XRANGE = R++;
src[XRANGE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAIN] + '$';
var XRANGELOOSE = R++;
src[XRANGELOOSE] = '^' + src[GTLT] + '\\s*' + src[XRANGEPLAINLOOSE] + '$';

// Tilde ranges.
// Meaning is "reasonably at or greater than"
var LONETILDE = R++;
src[LONETILDE] = '(?:~>?)';

var TILDETRIM = R++;
src[TILDETRIM] = '(\\s*)' + src[LONETILDE] + '\\s+';
re[TILDETRIM] = new RegExp(src[TILDETRIM], 'g');
var tildeTrimReplace = '$1~';

var TILDE = R++;
src[TILDE] = '^' + src[LONETILDE] + src[XRANGEPLAIN] + '$';
var TILDELOOSE = R++;
src[TILDELOOSE] = '^' + src[LONETILDE] + src[XRANGEPLAINLOOSE] + '$';

// Caret ranges.
// Meaning is "at least and backwards compatible with"
var LONECARET = R++;
src[LONECARET] = '(?:\\^)';

var CARETTRIM = R++;
src[CARETTRIM] = '(\\s*)' + src[LONECARET] + '\\s+';
re[CARETTRIM] = new RegExp(src[CARETTRIM], 'g');
var caretTrimReplace = '$1^';

var CARET = R++;
src[CARET] = '^' + src[LONECARET] + src[XRANGEPLAIN] + '$';
var CARETLOOSE = R++;
src[CARETLOOSE] = '^' + src[LONECARET] + src[XRANGEPLAINLOOSE] + '$';

// A simple gt/lt/eq thing, or just "" to indicate "any version"
var COMPARATORLOOSE = R++;
src[COMPARATORLOOSE] = '^' + src[GTLT] + '\\s*(' + LOOSEPLAIN + ')$|^$';
var COMPARATOR = R++;
src[COMPARATOR] = '^' + src[GTLT] + '\\s*(' + FULLPLAIN + ')$|^$';


// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
var COMPARATORTRIM = R++;
src[COMPARATORTRIM] = '(\\s*)' + src[GTLT] +
                      '\\s*(' + LOOSEPLAIN + '|' + src[XRANGEPLAIN] + ')';

// this one has to use the /g flag
re[COMPARATORTRIM] = new RegExp(src[COMPARATORTRIM], 'g');
var comparatorTrimReplace = '$1$2$3';


// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
var HYPHENRANGE = R++;
src[HYPHENRANGE] = '^\\s*(' + src[XRANGEPLAIN] + ')' +
                   '\\s+-\\s+' +
                   '(' + src[XRANGEPLAIN] + ')' +
                   '\\s*$';

var HYPHENRANGELOOSE = R++;
src[HYPHENRANGELOOSE] = '^\\s*(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s+-\\s+' +
                        '(' + src[XRANGEPLAINLOOSE] + ')' +
                        '\\s*$';

// Star ranges basically just allow anything at all.
var STAR = R++;
src[STAR] = '(<|>)?=?\\s*\\*';

// Compile to actual regexp objects.
// All are flag-free, unless they were created above with a flag.
for (var i = 0; i < R; i++) {
  debug(i, src[i]);
  if (!re[i])
    re[i] = new RegExp(src[i]);
}

exports.parse = parse;
function parse(version, loose) {
  if (version instanceof SemVer)
    return version;

  if (typeof version !== 'string')
    return null;

  if (version.length > MAX_LENGTH)
    return null;

  var r = loose ? re[LOOSE] : re[FULL];
  if (!r.test(version))
    return null;

  try {
    return new SemVer(version, loose);
  } catch (er) {
    return null;
  }
}

exports.valid = valid;
function valid(version, loose) {
  var v = parse(version, loose);
  return v ? v.version : null;
}


exports.clean = clean;
function clean(version, loose) {
  var s = parse(version.trim().replace(/^[=v]+/, ''), loose);
  return s ? s.version : null;
}

exports.SemVer = SemVer;

function SemVer(version, loose) {
  if (version instanceof SemVer) {
    if (version.loose === loose)
      return version;
    else
      version = version.version;
  } else if (typeof version !== 'string') {
    throw new TypeError('Invalid Version: ' + version);
  }

  if (version.length > MAX_LENGTH)
    throw new TypeError('version is longer than ' + MAX_LENGTH + ' characters')

  if (!(this instanceof SemVer))
    return new SemVer(version, loose);

  debug('SemVer', version, loose);
  this.loose = loose;
  var m = version.trim().match(loose ? re[LOOSE] : re[FULL]);

  if (!m)
    throw new TypeError('Invalid Version: ' + version);

  this.raw = version;

  // these are actually numbers
  this.major = +m[1];
  this.minor = +m[2];
  this.patch = +m[3];

  if (this.major > MAX_SAFE_INTEGER || this.major < 0)
    throw new TypeError('Invalid major version')

  if (this.minor > MAX_SAFE_INTEGER || this.minor < 0)
    throw new TypeError('Invalid minor version')

  if (this.patch > MAX_SAFE_INTEGER || this.patch < 0)
    throw new TypeError('Invalid patch version')

  // numberify any prerelease numeric ids
  if (!m[4])
    this.prerelease = [];
  else
    this.prerelease = m[4].split('.').map(function(id) {
      if (/^[0-9]+$/.test(id)) {
        var num = +id;
        if (num >= 0 && num < MAX_SAFE_INTEGER)
          return num;
      }
      return id;
    });

  this.build = m[5] ? m[5].split('.') : [];
  this.format();
}

SemVer.prototype.format = function() {
  this.version = this.major + '.' + this.minor + '.' + this.patch;
  if (this.prerelease.length)
    this.version += '-' + this.prerelease.join('.');
  return this.version;
};

SemVer.prototype.toString = function() {
  return this.version;
};

SemVer.prototype.compare = function(other) {
  debug('SemVer.compare', this.version, this.loose, other);
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return this.compareMain(other) || this.comparePre(other);
};

SemVer.prototype.compareMain = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  return compareIdentifiers(this.major, other.major) ||
         compareIdentifiers(this.minor, other.minor) ||
         compareIdentifiers(this.patch, other.patch);
};

SemVer.prototype.comparePre = function(other) {
  if (!(other instanceof SemVer))
    other = new SemVer(other, this.loose);

  // NOT having a prerelease is > having one
  if (this.prerelease.length && !other.prerelease.length)
    return -1;
  else if (!this.prerelease.length && other.prerelease.length)
    return 1;
  else if (!this.prerelease.length && !other.prerelease.length)
    return 0;

  var i = 0;
  do {
    var a = this.prerelease[i];
    var b = other.prerelease[i];
    debug('prerelease compare', i, a, b);
    if (a === undefined && b === undefined)
      return 0;
    else if (b === undefined)
      return 1;
    else if (a === undefined)
      return -1;
    else if (a === b)
      continue;
    else
      return compareIdentifiers(a, b);
  } while (++i);
};

// preminor will bump the version up to the next minor release, and immediately
// down to pre-release. premajor and prepatch work the same way.
SemVer.prototype.inc = function(release, identifier) {
  switch (release) {
    case 'premajor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor = 0;
      this.major++;
      this.inc('pre', identifier);
      break;
    case 'preminor':
      this.prerelease.length = 0;
      this.patch = 0;
      this.minor++;
      this.inc('pre', identifier);
      break;
    case 'prepatch':
      // If this is already a prerelease, it will bump to the next version
      // drop any prereleases that might already exist, since they are not
      // relevant at this point.
      this.prerelease.length = 0;
      this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;
    // If the input is a non-prerelease version, this acts the same as
    // prepatch.
    case 'prerelease':
      if (this.prerelease.length === 0)
        this.inc('patch', identifier);
      this.inc('pre', identifier);
      break;

    case 'major':
      // If this is a pre-major version, bump up to the same major version.
      // Otherwise increment major.
      // 1.0.0-5 bumps to 1.0.0
      // 1.1.0 bumps to 2.0.0
      if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0)
        this.major++;
      this.minor = 0;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'minor':
      // If this is a pre-minor version, bump up to the same minor version.
      // Otherwise increment minor.
      // 1.2.0-5 bumps to 1.2.0
      // 1.2.1 bumps to 1.3.0
      if (this.patch !== 0 || this.prerelease.length === 0)
        this.minor++;
      this.patch = 0;
      this.prerelease = [];
      break;
    case 'patch':
      // If this is not a pre-release version, it will increment the patch.
      // If it is a pre-release it will bump up to the same patch version.
      // 1.2.0-5 patches to 1.2.0
      // 1.2.0 patches to 1.2.1
      if (this.prerelease.length === 0)
        this.patch++;
      this.prerelease = [];
      break;
    // This probably shouldn't be used publicly.
    // 1.0.0 "pre" would become 1.0.0-0 which is the wrong direction.
    case 'pre':
      if (this.prerelease.length === 0)
        this.prerelease = [0];
      else {
        var i = this.prerelease.length;
        while (--i >= 0) {
          if (typeof this.prerelease[i] === 'number') {
            this.prerelease[i]++;
            i = -2;
          }
        }
        if (i === -1) // didn't increment anything
          this.prerelease.push(0);
      }
      if (identifier) {
        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
        if (this.prerelease[0] === identifier) {
          if (isNaN(this.prerelease[1]))
            this.prerelease = [identifier, 0];
        } else
          this.prerelease = [identifier, 0];
      }
      break;

    default:
      throw new Error('invalid increment argument: ' + release);
  }
  this.format();
  this.raw = this.version;
  return this;
};

exports.inc = inc;
function inc(version, release, loose, identifier) {
  if (typeof(loose) === 'string') {
    identifier = loose;
    loose = undefined;
  }

  try {
    return new SemVer(version, loose).inc(release, identifier).version;
  } catch (er) {
    return null;
  }
}

exports.diff = diff;
function diff(version1, version2) {
  if (eq(version1, version2)) {
    return null;
  } else {
    var v1 = parse(version1);
    var v2 = parse(version2);
    if (v1.prerelease.length || v2.prerelease.length) {
      for (var key in v1) {
        if (key === 'major' || key === 'minor' || key === 'patch') {
          if (v1[key] !== v2[key]) {
            return 'pre'+key;
          }
        }
      }
      return 'prerelease';
    }
    for (var key in v1) {
      if (key === 'major' || key === 'minor' || key === 'patch') {
        if (v1[key] !== v2[key]) {
          return key;
        }
      }
    }
  }
}

exports.compareIdentifiers = compareIdentifiers;

var numeric = /^[0-9]+$/;
function compareIdentifiers(a, b) {
  var anum = numeric.test(a);
  var bnum = numeric.test(b);

  if (anum && bnum) {
    a = +a;
    b = +b;
  }

  return (anum && !bnum) ? -1 :
         (bnum && !anum) ? 1 :
         a < b ? -1 :
         a > b ? 1 :
         0;
}

exports.rcompareIdentifiers = rcompareIdentifiers;
function rcompareIdentifiers(a, b) {
  return compareIdentifiers(b, a);
}

exports.major = major;
function major(a, loose) {
  return new SemVer(a, loose).major;
}

exports.minor = minor;
function minor(a, loose) {
  return new SemVer(a, loose).minor;
}

exports.patch = patch;
function patch(a, loose) {
  return new SemVer(a, loose).patch;
}

exports.compare = compare;
function compare(a, b, loose) {
  return new SemVer(a, loose).compare(b);
}

exports.compareLoose = compareLoose;
function compareLoose(a, b) {
  return compare(a, b, true);
}

exports.rcompare = rcompare;
function rcompare(a, b, loose) {
  return compare(b, a, loose);
}

exports.sort = sort;
function sort(list, loose) {
  return list.sort(function(a, b) {
    return exports.compare(a, b, loose);
  });
}

exports.rsort = rsort;
function rsort(list, loose) {
  return list.sort(function(a, b) {
    return exports.rcompare(a, b, loose);
  });
}

exports.gt = gt;
function gt(a, b, loose) {
  return compare(a, b, loose) > 0;
}

exports.lt = lt;
function lt(a, b, loose) {
  return compare(a, b, loose) < 0;
}

exports.eq = eq;
function eq(a, b, loose) {
  return compare(a, b, loose) === 0;
}

exports.neq = neq;
function neq(a, b, loose) {
  return compare(a, b, loose) !== 0;
}

exports.gte = gte;
function gte(a, b, loose) {
  return compare(a, b, loose) >= 0;
}

exports.lte = lte;
function lte(a, b, loose) {
  return compare(a, b, loose) <= 0;
}

exports.cmp = cmp;
function cmp(a, op, b, loose) {
  var ret;
  switch (op) {
    case '===':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a === b;
      break;
    case '!==':
      if (typeof a === 'object') a = a.version;
      if (typeof b === 'object') b = b.version;
      ret = a !== b;
      break;
    case '': case '=': case '==': ret = eq(a, b, loose); break;
    case '!=': ret = neq(a, b, loose); break;
    case '>': ret = gt(a, b, loose); break;
    case '>=': ret = gte(a, b, loose); break;
    case '<': ret = lt(a, b, loose); break;
    case '<=': ret = lte(a, b, loose); break;
    default: throw new TypeError('Invalid operator: ' + op);
  }
  return ret;
}

exports.Comparator = Comparator;
function Comparator(comp, loose) {
  if (comp instanceof Comparator) {
    if (comp.loose === loose)
      return comp;
    else
      comp = comp.value;
  }

  if (!(this instanceof Comparator))
    return new Comparator(comp, loose);

  debug('comparator', comp, loose);
  this.loose = loose;
  this.parse(comp);

  if (this.semver === ANY)
    this.value = '';
  else
    this.value = this.operator + this.semver.version;

  debug('comp', this);
}

var ANY = {};
Comparator.prototype.parse = function(comp) {
  var r = this.loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var m = comp.match(r);

  if (!m)
    throw new TypeError('Invalid comparator: ' + comp);

  this.operator = m[1];
  if (this.operator === '=')
    this.operator = '';

  // if it literally is just '>' or '' then allow anything.
  if (!m[2])
    this.semver = ANY;
  else
    this.semver = new SemVer(m[2], this.loose);
};

Comparator.prototype.toString = function() {
  return this.value;
};

Comparator.prototype.test = function(version) {
  debug('Comparator.test', version, this.loose);

  if (this.semver === ANY)
    return true;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  return cmp(version, this.operator, this.semver, this.loose);
};


exports.Range = Range;
function Range(range, loose) {
  if ((range instanceof Range) && range.loose === loose)
    return range;

  if (!(this instanceof Range))
    return new Range(range, loose);

  this.loose = loose;

  // First, split based on boolean or ||
  this.raw = range;
  this.set = range.split(/\s*\|\|\s*/).map(function(range) {
    return this.parseRange(range.trim());
  }, this).filter(function(c) {
    // throw out any that are not relevant for whatever reason
    return c.length;
  });

  if (!this.set.length) {
    throw new TypeError('Invalid SemVer Range: ' + range);
  }

  this.format();
}

Range.prototype.format = function() {
  this.range = this.set.map(function(comps) {
    return comps.join(' ').trim();
  }).join('||').trim();
  return this.range;
};

Range.prototype.toString = function() {
  return this.range;
};

Range.prototype.parseRange = function(range) {
  var loose = this.loose;
  range = range.trim();
  debug('range', range, loose);
  // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
  var hr = loose ? re[HYPHENRANGELOOSE] : re[HYPHENRANGE];
  range = range.replace(hr, hyphenReplace);
  debug('hyphen replace', range);
  // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
  range = range.replace(re[COMPARATORTRIM], comparatorTrimReplace);
  debug('comparator trim', range, re[COMPARATORTRIM]);

  // `~ 1.2.3` => `~1.2.3`
  range = range.replace(re[TILDETRIM], tildeTrimReplace);

  // `^ 1.2.3` => `^1.2.3`
  range = range.replace(re[CARETTRIM], caretTrimReplace);

  // normalize spaces
  range = range.split(/\s+/).join(' ');

  // At this point, the range is completely trimmed and
  // ready to be split into comparators.

  var compRe = loose ? re[COMPARATORLOOSE] : re[COMPARATOR];
  var set = range.split(' ').map(function(comp) {
    return parseComparator(comp, loose);
  }).join(' ').split(/\s+/);
  if (this.loose) {
    // in loose mode, throw out any that are not valid comparators
    set = set.filter(function(comp) {
      return !!comp.match(compRe);
    });
  }
  set = set.map(function(comp) {
    return new Comparator(comp, loose);
  });

  return set;
};

// Mostly just for testing and legacy API reasons
exports.toComparators = toComparators;
function toComparators(range, loose) {
  return new Range(range, loose).set.map(function(comp) {
    return comp.map(function(c) {
      return c.value;
    }).join(' ').trim().split(' ');
  });
}

// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
function parseComparator(comp, loose) {
  debug('comp', comp);
  comp = replaceCarets(comp, loose);
  debug('caret', comp);
  comp = replaceTildes(comp, loose);
  debug('tildes', comp);
  comp = replaceXRanges(comp, loose);
  debug('xrange', comp);
  comp = replaceStars(comp, loose);
  debug('stars', comp);
  return comp;
}

function isX(id) {
  return !id || id.toLowerCase() === 'x' || id === '*';
}

// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0
function replaceTildes(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceTilde(comp, loose);
  }).join(' ');
}

function replaceTilde(comp, loose) {
  var r = loose ? re[TILDELOOSE] : re[TILDE];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('tilde', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p))
      // ~1.2 == >=1.2.0 <1.3.0
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    else if (pr) {
      debug('replaceTilde pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      ret = '>=' + M + '.' + m + '.' + p + pr +
            ' <' + M + '.' + (+m + 1) + '.0';
    } else
      // ~1.2.3 == >=1.2.3 <1.3.0
      ret = '>=' + M + '.' + m + '.' + p +
            ' <' + M + '.' + (+m + 1) + '.0';

    debug('tilde return', ret);
    return ret;
  });
}

// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0
// ^1.2.3 --> >=1.2.3 <2.0.0
// ^1.2.0 --> >=1.2.0 <2.0.0
function replaceCarets(comp, loose) {
  return comp.trim().split(/\s+/).map(function(comp) {
    return replaceCaret(comp, loose);
  }).join(' ');
}

function replaceCaret(comp, loose) {
  debug('caret', comp, loose);
  var r = loose ? re[CARETLOOSE] : re[CARET];
  return comp.replace(r, function(_, M, m, p, pr) {
    debug('caret', comp, _, M, m, p, pr);
    var ret;

    if (isX(M))
      ret = '';
    else if (isX(m))
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    else if (isX(p)) {
      if (M === '0')
        ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
      else
        ret = '>=' + M + '.' + m + '.0 <' + (+M + 1) + '.0.0';
    } else if (pr) {
      debug('replaceCaret pr', pr);
      if (pr.charAt(0) !== '-')
        pr = '-' + pr;
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p + pr +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p + pr +
              ' <' + (+M + 1) + '.0.0';
    } else {
      debug('no pr');
      if (M === '0') {
        if (m === '0')
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + m + '.' + (+p + 1);
        else
          ret = '>=' + M + '.' + m + '.' + p +
                ' <' + M + '.' + (+m + 1) + '.0';
      } else
        ret = '>=' + M + '.' + m + '.' + p +
              ' <' + (+M + 1) + '.0.0';
    }

    debug('caret return', ret);
    return ret;
  });
}

function replaceXRanges(comp, loose) {
  debug('replaceXRanges', comp, loose);
  return comp.split(/\s+/).map(function(comp) {
    return replaceXRange(comp, loose);
  }).join(' ');
}

function replaceXRange(comp, loose) {
  comp = comp.trim();
  var r = loose ? re[XRANGELOOSE] : re[XRANGE];
  return comp.replace(r, function(ret, gtlt, M, m, p, pr) {
    debug('xRange', comp, ret, gtlt, M, m, p, pr);
    var xM = isX(M);
    var xm = xM || isX(m);
    var xp = xm || isX(p);
    var anyX = xp;

    if (gtlt === '=' && anyX)
      gtlt = '';

    if (xM) {
      if (gtlt === '>' || gtlt === '<') {
        // nothing is allowed
        ret = '<0.0.0';
      } else {
        // nothing is forbidden
        ret = '*';
      }
    } else if (gtlt && anyX) {
      // replace X with 0
      if (xm)
        m = 0;
      if (xp)
        p = 0;

      if (gtlt === '>') {
        // >1 => >=2.0.0
        // >1.2 => >=1.3.0
        // >1.2.3 => >= 1.2.4
        gtlt = '>=';
        if (xm) {
          M = +M + 1;
          m = 0;
          p = 0;
        } else if (xp) {
          m = +m + 1;
          p = 0;
        }
      } else if (gtlt === '<=') {
        // <=0.7.x is actually <0.8.0, since any 0.7.x should
        // pass.  Similarly, <=7.x is actually <8.0.0, etc.
        gtlt = '<';
        if (xm)
          M = +M + 1;
        else
          m = +m + 1;
      }

      ret = gtlt + M + '.' + m + '.' + p;
    } else if (xm) {
      ret = '>=' + M + '.0.0 <' + (+M + 1) + '.0.0';
    } else if (xp) {
      ret = '>=' + M + '.' + m + '.0 <' + M + '.' + (+m + 1) + '.0';
    }

    debug('xRange return', ret);

    return ret;
  });
}

// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
function replaceStars(comp, loose) {
  debug('replaceStars', comp, loose);
  // Looseness is ignored here.  star is always as loose as it gets!
  return comp.trim().replace(re[STAR], '');
}

// This function is passed to string.replace(re[HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0
function hyphenReplace($0,
                       from, fM, fm, fp, fpr, fb,
                       to, tM, tm, tp, tpr, tb) {

  if (isX(fM))
    from = '';
  else if (isX(fm))
    from = '>=' + fM + '.0.0';
  else if (isX(fp))
    from = '>=' + fM + '.' + fm + '.0';
  else
    from = '>=' + from;

  if (isX(tM))
    to = '';
  else if (isX(tm))
    to = '<' + (+tM + 1) + '.0.0';
  else if (isX(tp))
    to = '<' + tM + '.' + (+tm + 1) + '.0';
  else if (tpr)
    to = '<=' + tM + '.' + tm + '.' + tp + '-' + tpr;
  else
    to = '<=' + to;

  return (from + ' ' + to).trim();
}


// if ANY of the sets match ALL of its comparators, then pass
Range.prototype.test = function(version) {
  if (!version)
    return false;

  if (typeof version === 'string')
    version = new SemVer(version, this.loose);

  for (var i = 0; i < this.set.length; i++) {
    if (testSet(this.set[i], version))
      return true;
  }
  return false;
};

function testSet(set, version) {
  for (var i = 0; i < set.length; i++) {
    if (!set[i].test(version))
      return false;
  }

  if (version.prerelease.length) {
    // Find the set of versions that are allowed to have prereleases
    // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
    // That should allow `1.2.3-pr.2` to pass.
    // However, `1.2.4-alpha.notready` should NOT be allowed,
    // even though it's within the range set by the comparators.
    for (var i = 0; i < set.length; i++) {
      debug(set[i].semver);
      if (set[i].semver === ANY)
        continue;

      if (set[i].semver.prerelease.length > 0) {
        var allowed = set[i].semver;
        if (allowed.major === version.major &&
            allowed.minor === version.minor &&
            allowed.patch === version.patch)
          return true;
      }
    }

    // Version has a -pre, but it's not one of the ones we like.
    return false;
  }

  return true;
}

exports.satisfies = satisfies;
function satisfies(version, range, loose) {
  try {
    range = new Range(range, loose);
  } catch (er) {
    return false;
  }
  return range.test(version);
}

exports.maxSatisfying = maxSatisfying;
function maxSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return rcompare(a, b, loose);
  })[0] || null;
}

exports.minSatisfying = minSatisfying;
function minSatisfying(versions, range, loose) {
  return versions.filter(function(version) {
    return satisfies(version, range, loose);
  }).sort(function(a, b) {
    return compare(a, b, loose);
  })[0] || null;
}

exports.validRange = validRange;
function validRange(range, loose) {
  try {
    // Return '*' instead of '' so that truthiness works.
    // This will throw if it's invalid anyway
    return new Range(range, loose).range || '*';
  } catch (er) {
    return null;
  }
}

// Determine if version is less than all the versions possible in the range
exports.ltr = ltr;
function ltr(version, range, loose) {
  return outside(version, range, '<', loose);
}

// Determine if version is greater than all the versions possible in the range.
exports.gtr = gtr;
function gtr(version, range, loose) {
  return outside(version, range, '>', loose);
}

exports.outside = outside;
function outside(version, range, hilo, loose) {
  version = new SemVer(version, loose);
  range = new Range(range, loose);

  var gtfn, ltefn, ltfn, comp, ecomp;
  switch (hilo) {
    case '>':
      gtfn = gt;
      ltefn = lte;
      ltfn = lt;
      comp = '>';
      ecomp = '>=';
      break;
    case '<':
      gtfn = lt;
      ltefn = gte;
      ltfn = gt;
      comp = '<';
      ecomp = '<=';
      break;
    default:
      throw new TypeError('Must provide a hilo val of "<" or ">"');
  }

  // If it satisifes the range it is not outside
  if (satisfies(version, range, loose)) {
    return false;
  }

  // From now on, variable terms are as if we're in "gtr" mode.
  // but note that everything is flipped for the "ltr" function.

  for (var i = 0; i < range.set.length; ++i) {
    var comparators = range.set[i];

    var high = null;
    var low = null;

    comparators.forEach(function(comparator) {
      if (comparator.semver === ANY) {
        comparator = new Comparator('>=0.0.0')
      }
      high = high || comparator;
      low = low || comparator;
      if (gtfn(comparator.semver, high.semver, loose)) {
        high = comparator;
      } else if (ltfn(comparator.semver, low.semver, loose)) {
        low = comparator;
      }
    });

    // If the edge version comparator has a operator then our version
    // isn't outside it
    if (high.operator === comp || high.operator === ecomp) {
      return false;
    }

    // If the lowest version comparator has an operator and our version
    // is less than it then it isn't higher than the range
    if ((!low.operator || low.operator === comp) &&
        ltefn(version, low.semver)) {
      return false;
    } else if (low.operator === ecomp && ltfn(version, low.semver)) {
      return false;
    }
  }
  return true;
}

exports.prerelease = prerelease;
function prerelease(version, loose) {
  var parsed = parse(version, loose);
  return (parsed && parsed.prerelease.length) ? parsed.prerelease : null;
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(133)))

/***/ }),
/* 133 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ })
/******/ ]);
});
//# sourceMappingURL=vuetify.js.map

/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,t){ true?module.exports=t():"function"==typeof define&&define.amd?define("VueShortkey",[],t):"object"==typeof exports?exports.VueShortkey=t():e.VueShortkey=t()}("undefined"!=typeof self?self:this,function(){return function(e){function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}var n={};return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{configurable:!1,enumerable:!0,get:r})},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},t.p="../dist/",t(t.s=0)}([function(e,t,n){"use strict";(function(r){function o(e){if(Array.isArray(e)){for(var t=0,n=Array(e.length);t<e.length;t++)n[t]=e[t];return n}return Array.from(e)}var c;n(2),n(3);var u={},i={},a=[],l=[],s=!1,f=function(e){return e="string"==typeof e?JSON.parse(e.replace(/\'/gi,'"')):e,e instanceof Array?{"":e}:e},p=function(e,t,n,r){var o=!0===n.modifiers.push,c=!0===n.modifiers.avoid,u=!0==!n.modifiers.focus,i=!0===n.modifiers.once;c?(a=a.filter(function(e){return!e===t}),a.push(t)):v({b:e,push:o,once:i,focus:u,el:r.elm})},y=function(e,t){for(var n in e){var r=u.encodeKey(e[n]),o=i[r].el.indexOf(t);i[r].el.length>1&&o>-1?i[r].el.splice(o,1):delete i[r]}};u.install=function(e,t){l=[].concat(o(t&&t.prevent?t.prevent:[])),e.directive("shortkey",{bind:function(e,t,n){var r=f(t.value);p(r,e,t,n)},update:function(e,t,n){var r=f(t.oldValue);y(r,e);var o=f(t.value);p(o,e,t,n)},unbind:function(e,t){var n=f(t.value);y(n,e)}})},u.decodeKey=function(e){return d(e)},u.encodeKey=function(e){var t={};t.shiftKey=e.includes("shift"),t.ctrlKey=e.includes("ctrl"),t.metaKey=e.includes("meta"),t.altKey=e.includes("alt");var n=d(t);return n+=e.filter(function(e){return!["shift","ctrl","meta","alt"].includes(e)}).join("")};var d=function(e){var t="";return("Shift"===e.key||e.shiftKey)&&(t+="shift"),("Control"===e.key||e.ctrlKey)&&(t+="ctrl"),("Meta"===e.key||e.metaKey)&&(t+="meta"),("Alt"===e.key||e.altKey)&&(t+="alt"),"ArrowUp"===e.key&&(t+="arrowup"),"ArrowLeft"===e.key&&(t+="arrowleft"),"ArrowRight"===e.key&&(t+="arrowright"),"ArrowDown"===e.key&&(t+="arrowdown"),"AltGraph"===e.key&&(t+="altgraph"),"Escape"===e.key&&(t+="esc"),"Enter"===e.key&&(t+="enter"),"Tab"===e.key&&(t+="tab")," "===e.key&&(t+="space"),"PageUp"===e.key&&(t+="pageup"),"PageDown"===e.key&&(t+="pagedown"),"Home"===e.key&&(t+="home"),"End"===e.key&&(t+="end"),"Delete"===e.key&&(t+="del"),"Backspace"===e.key&&(t+="backspace"),"Insert"===e.key&&(t+="insert"),"NumLock"===e.key&&(t+="numlock"),"CapsLock"===e.key&&(t+="capslock"),"Pause"===e.key&&(t+="pause"),"ContextMenu"===e.key&&(t+="contextmenu"),"ScrollLock"===e.key&&(t+="scrolllock"),"BrowserHome"===e.key&&(t+="browserhome"),"MediaSelect"===e.key&&(t+="mediaselect"),(e.key&&" "!==e.key&&1===e.key.length||/F\d{1,2}|\//g.test(e.key))&&(t+=e.key.toLowerCase()),t},h=function(e){var t=new CustomEvent("shortkey",{bubbles:!1});i[e].key&&(t.srcKey=i[e].key);var n=i[e].el;n[n.length-1].dispatchEvent(t)};u.keyDown=function(e){(!i[e].once&&!i[e].push||i[e].push&&!s)&&h(e)},r&&Object({NODE_ENV:"production"})&&function(){document.addEventListener("keydown",function(e){var t=u.decodeKey(e);if(m(t))if(e.preventDefault(),e.stopPropagation(),i[t].focus)u.keyDown(t),s=!0;else if(!s){var n=i[t].el;n[n.length-1].focus(),s=!0}},!0),document.addEventListener("keyup",function(e){var t=u.decodeKey(e);m(t)&&(e.preventDefault(),e.stopPropagation(),(i[t].once||i[t].push)&&h(t)),s=!1},!0)}();var v=function(e){var t=e.b,n=e.push,r=e.once,o=e.focus,c=e.el;for(var a in t){var l=u.encodeKey(t[a]),s=i[l]&&i[l].el?i[l].el:[];s.push(c),i[l]={push:n,once:r,focus:o,key:a,el:s}}},m=function(e){var t=!!a.find(function(e){return e===document.activeElement}),n=!!l.find(function(e){return document.activeElement&&document.activeElement.matches(e)});return!!i[e]&&!(t||n)};void 0!==e&&e.exports?e.exports=u:void 0!==(c=function(){return u}.call(t,n,t,e))&&(e.exports=c)}).call(t,n(1))},function(e,t){function n(){throw new Error("setTimeout has not been defined")}function r(){throw new Error("clearTimeout has not been defined")}function o(e){if(s===setTimeout)return setTimeout(e,0);if((s===n||!s)&&setTimeout)return s=setTimeout,setTimeout(e,0);try{return s(e,0)}catch(t){try{return s.call(null,e,0)}catch(t){return s.call(this,e,0)}}}function c(e){if(f===clearTimeout)return clearTimeout(e);if((f===r||!f)&&clearTimeout)return f=clearTimeout,clearTimeout(e);try{return f(e)}catch(t){try{return f.call(null,e)}catch(t){return f.call(this,e)}}}function u(){h&&y&&(h=!1,y.length?d=y.concat(d):v=-1,d.length&&i())}function i(){if(!h){var e=o(u);h=!0;for(var t=d.length;t;){for(y=d,d=[];++v<t;)y&&y[v].run();v=-1,t=d.length}y=null,h=!1,c(e)}}function a(e,t){this.fun=e,this.array=t}function l(){}var s,f,p=e.exports={};!function(){try{s="function"==typeof setTimeout?setTimeout:n}catch(e){s=n}try{f="function"==typeof clearTimeout?clearTimeout:r}catch(e){f=r}}();var y,d=[],h=!1,v=-1;p.nextTick=function(e){var t=new Array(arguments.length-1);if(arguments.length>1)for(var n=1;n<arguments.length;n++)t[n-1]=arguments[n];d.push(new a(e,t)),1!==d.length||h||o(i)},a.prototype.run=function(){this.fun.apply(null,this.array)},p.title="browser",p.browser=!0,p.env={},p.argv=[],p.version="",p.versions={},p.on=l,p.addListener=l,p.once=l,p.off=l,p.removeListener=l,p.removeAllListeners=l,p.emit=l,p.prependListener=l,p.prependOnceListener=l,p.listeners=function(e){return[]},p.binding=function(e){throw new Error("process.binding is not supported")},p.cwd=function(){return"/"},p.chdir=function(e){throw new Error("process.chdir is not supported")},p.umask=function(){return 0}},function(e,t){Element.prototype.matches||(Element.prototype.matches=Element.prototype.matchesSelector||Element.prototype.msMatchesSelector||Element.prototype.webkitMatchesSelector)},function(e,t){!function(){if("undefined"!=typeof window)try{var e=new window.CustomEvent("test",{cancelable:!0});if(e.preventDefault(),!0!==e.defaultPrevented)throw new Error("Could not prevent default")}catch(e){var t=function(e,t){var n,r;return t=t||{},t.bubbles=!!t.bubbles,t.cancelable=!!t.cancelable,n=document.createEvent("CustomEvent"),n.initCustomEvent(e,t.bubbles,t.cancelable,t.detail),r=n.preventDefault,n.preventDefault=function(){r.call(this);try{Object.defineProperty(this,"defaultPrevented",{get:function(){return!0}})}catch(e){this.defaultPrevented=!0}},n};t.prototype=window.Event.prototype,window.CustomEvent=t}}()}])});
//# sourceMappingURL=index.js.map

/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

(function (global, factory) {
   true ? factory(__webpack_require__(163)) :
  typeof define === 'function' && define.amd ? define(['hammerjs'], factory) :
  (factory(global.Hammer));
}(this, (function (Hammer) { 'use strict';

Hammer = 'default' in Hammer ? Hammer['default'] : Hammer;

function assign(target) {
  var sources = [], len = arguments.length - 1;
  while ( len-- > 0 ) sources[ len ] = arguments[ len + 1 ];
  for (var i = 0; i < sources.length; i++) {
    var source = sources[i];
    var keys = Object.keys(source);
    for (var i$1 = 0; i$1 < keys.length; i$1++) {
      var key = keys[i$1];
      target[key] = source[key];
    }
  }
  return target
}
function createProp() {
  return {
    type: Object,
    default: function() { return {} }
  }
}
function capitalize (str) {
  return str.charAt(0).toUpperCase() + str.slice(1)
}
var directions = ['up', 'down', 'left', 'right', 'horizontal', 'vertical', 'all'];
function guardDirections (options) {
  var dir = options.direction;
  if (typeof dir === 'string') {
    var hammerDirection = 'DIRECTION_' + dir.toUpperCase();
    if (directions.indexOf(dir) > -1 && Hammer.hasOwnProperty(hammerDirection)) {
      options.direction = Hammer[hammerDirection];
    } else {
      console.warn('[vue-touch] invalid direction: ' + dir);
    }
  }
  return options
}
var config = {
};
var customEvents = {
};
var gestures = [
  'pan','panstart','panmove','panend','pancancel','panleft','panright','panup','pandown',
  'pinch','pinchstart','pinchmove','pinchend','pinchcancel','pinchin','pinchout',
  'press','pressup',
  'rotate','rotatestart','rotatemove','rotateend','rotatecancel',
  'swipe','swipeleft','swiperight','swipeup','swipedown',
  'tap'
];
var gestureMap = {
  pan: 'pan',
  panstart: 'pan',
  panmove: 'pan',
  panend: 'pan',
  pancancel: 'pan',
  panleft: 'pan',
  panright: 'pan',
  panup: 'pan',
  pandown: 'pan',
  pinch: 'pinch',
  pinchstart: 'pinch',
  pinchmove: 'pinch',
  pinchend: 'pinch',
  pinchcancel: 'pinch',
  pinchin: 'pinch',
  pinchout: 'pinch',
  press: 'press',
  pressup: 'press',
  rotate: 'rotate',
  rotatestart: 'rotate',
  rotatemove: 'rotate',
  rotateend: 'rotate',
  rotatecancel: 'rotate',
  swipe: 'swipe',
  swipeleft: 'swipe',
  swiperight: 'swipe',
  swipeup: 'swipe',
  swipedown: 'swipe',
  tap: 'tap'
};

var Component = {
  props: {
    options: createProp(),
    tapOptions: createProp(),
    panOptions: createProp(),
    pinchOptions: createProp(),
    pressOptions: createProp(),
    rotateOptions: createProp(),
    swipeOptions: createProp(),
    tag: { type: String, default: 'div' },
    enabled: {
      default: true,
      type: [Boolean, Object],
    }
  },
  mounted: function mounted() {
    if (!this.$isServer) {
      this.hammer = new Hammer.Manager(this.$el, this.options);
      this.recognizers = {};
      this.setupBuiltinRecognizers();
      this.setupCustomRecognizers();
      this.updateEnabled(this.enabled);
    }
  },
  destroyed: function destroyed() {
    if (!this.$isServer) {
      this.hammer.destroy();
    }
  },
  watch: {
    enabled: {
      deep: true,
      handler: function handler() {
        var args = [], len = arguments.length;
        while ( len-- ) args[ len ] = arguments[ len ];
        (ref = this).updateEnabled.apply(ref, args);
        var ref;
      }
    }
  },
  methods: {
    setupBuiltinRecognizers: function setupBuiltinRecognizers()  {
      var this$1 = this;
      for (var i = 0; i < gestures.length; i++) {
        var gesture = gestures[i];
        if (this$1._events[gesture]) {
          var mainGesture = gestureMap[gesture];
          var options = assign({}, (config[mainGesture] || {}), this$1[(mainGesture + "Options")]);
          this$1.addRecognizer(mainGesture, options);
          this$1.addEvent(gesture);
        }
      }
    },
    setupCustomRecognizers: function setupCustomRecognizers() {
      var this$1 = this;
      var gestures$$1 = Object.keys(customEvents);
      for (var i = 0; i < gestures$$1.length; i++) {
        var gesture = gestures$$1[i];
        if (this$1._events[gesture]) {
          var opts = customEvents[gesture];
          var localCustomOpts = this$1[(gesture + "Options")] || {};
          var options = assign({}, opts, localCustomOpts);
          this$1.addRecognizer(gesture, options, {mainGesture: options.type});
          this$1.addEvent(gesture);
        }
      }
    },
    addRecognizer: function addRecognizer(gesture, options, ref) {
      if ( ref === void 0 ) ref = {};
      var mainGesture = ref.mainGesture;
      if (!this.recognizers[gesture]) {
        var recognizer = new Hammer[capitalize(mainGesture || gesture)](guardDirections(options));
        this.recognizers[gesture] = recognizer;
        this.hammer.add(recognizer);
        recognizer.recognizeWith(this.hammer.recognizers);
      }
    },
    addEvent: function addEvent(gesture) {
      var this$1 = this;
      this.hammer.on(gesture, function (e) { return this$1.$emit(gesture, e); });
    },
    updateEnabled: function updateEnabled(newVal, oldVal) {
      var this$1 = this;
      if (newVal === true) {
        this.enableAll();
      } else if (newVal === false) {
        this.disableAll();
      } else if (typeof newVal === 'object') {
        var keys = Object.keys(newVal);
        for (var i = 0; i < keys.length; i++) {
          var event = keys[i];
          if (this$1.recognizers[event]) {
            newVal[event]
              ? this$1.enable(event)
              : this$1.disable(event);
          }
        }
      }
    },
    enable: function enable(r) {
      var recognizer = this.recognizers[r];
      if (!recognizer.options.enable) {
        recognizer.set({ enable: true });
      }
    },
    disable: function disable(r) {
      var recognizer = this.recognizers[r];
      if (recognizer.options.enable) {
        recognizer.set({ enable: false });
      }
    },
    toggle: function toggle(r) {
      var recognizer = this.recognizers[r];
      if (recognizer) {
        recognizer.options.enable
          ? this.disable(r)
          : this.enable(r);
      }
    },
    enableAll: function enableAll(r) {
      this.toggleAll({ enable: true });
    },
    disableAll: function disableAll(r) {
      this.toggleAll({ enable: false });
    },
    toggleAll: function toggleAll(ref) {
      var this$1 = this;
      var enable = ref.enable;
      var keys = Object.keys(this.recognizers);
      for (var i = 0; i < keys.length; i++) {
        var r = this$1.recognizers[keys[i]];
        if (r.options.enable !== enable) {
          r.set({ enable: enable });
        }
      }
    },
    isEnabled: function isEnabled(r) {
      return this.recognizers[r] && this.recognizers[r].options.enable
    }
  },
  render: function render(h) {
    return h(this.tag, {}, this.$slots.default)
  }
};

var installed = false;
var vueTouch = { config: config, customEvents: customEvents };
vueTouch.install = function install(Vue, opts) {
  if ( opts === void 0 ) opts = {};
  var name = opts.name || 'v-touch';
  Vue.component(name, assign(Component, { name: name }));
  installed = true;
}.bind(vueTouch);
vueTouch.registerCustomEvent = function registerCustomEvent(event, options) {
  if ( options === void 0 ) options = {};
  if (installed) {
    console.warn(("\n      [vue-touch]: Custom Event '" + event + "' couldn't be added to vue-touch.\n      Custom Events have to be registered before installing the plugin.\n      "));
    return
  }
  options.event = event;
  customEvents[event] = options;
  Component.props[(event + "Options")] = {
    type: Object,
    default: function default$1() { return {} }
  };
}.bind(vueTouch);
vueTouch.component = Component;
if (true) {
  module.exports = vueTouch;
} else if (typeof define == "function" && define.amd) {
  define([], function(){ return vueTouch });
} else if (typeof window !== 'undefined' && window.Vue) {
  window.VueTouch = vueTouch;
  Vue.use(vueTouch);
}

})));
//# sourceMappingURL=vue-touch.js.map


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! Hammer.JS - v2.0.7 - 2016-04-22
 * http://hammerjs.github.io/
 *
 * Copyright (c) 2016 Jorik Tangelder;
 * Licensed under the MIT license */
(function(window, document, exportName, undefined) {
  'use strict';

var VENDOR_PREFIXES = ['', 'webkit', 'Moz', 'MS', 'ms', 'o'];
var TEST_ELEMENT = document.createElement('div');

var TYPE_FUNCTION = 'function';

var round = Math.round;
var abs = Math.abs;
var now = Date.now;

/**
 * set a timeout with a given scope
 * @param {Function} fn
 * @param {Number} timeout
 * @param {Object} context
 * @returns {number}
 */
function setTimeoutContext(fn, timeout, context) {
    return setTimeout(bindFn(fn, context), timeout);
}

/**
 * if the argument is an array, we want to execute the fn on each entry
 * if it aint an array we don't want to do a thing.
 * this is used by all the methods that accept a single and array argument.
 * @param {*|Array} arg
 * @param {String} fn
 * @param {Object} [context]
 * @returns {Boolean}
 */
function invokeArrayArg(arg, fn, context) {
    if (Array.isArray(arg)) {
        each(arg, context[fn], context);
        return true;
    }
    return false;
}

/**
 * walk objects and arrays
 * @param {Object} obj
 * @param {Function} iterator
 * @param {Object} context
 */
function each(obj, iterator, context) {
    var i;

    if (!obj) {
        return;
    }

    if (obj.forEach) {
        obj.forEach(iterator, context);
    } else if (obj.length !== undefined) {
        i = 0;
        while (i < obj.length) {
            iterator.call(context, obj[i], i, obj);
            i++;
        }
    } else {
        for (i in obj) {
            obj.hasOwnProperty(i) && iterator.call(context, obj[i], i, obj);
        }
    }
}

/**
 * wrap a method with a deprecation warning and stack trace
 * @param {Function} method
 * @param {String} name
 * @param {String} message
 * @returns {Function} A new function wrapping the supplied method.
 */
function deprecate(method, name, message) {
    var deprecationMessage = 'DEPRECATED METHOD: ' + name + '\n' + message + ' AT \n';
    return function() {
        var e = new Error('get-stack-trace');
        var stack = e && e.stack ? e.stack.replace(/^[^\(]+?[\n$]/gm, '')
            .replace(/^\s+at\s+/gm, '')
            .replace(/^Object.<anonymous>\s*\(/gm, '{anonymous}()@') : 'Unknown Stack Trace';

        var log = window.console && (window.console.warn || window.console.log);
        if (log) {
            log.call(window.console, deprecationMessage, stack);
        }
        return method.apply(this, arguments);
    };
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} target
 * @param {...Object} objects_to_assign
 * @returns {Object} target
 */
var assign;
if (typeof Object.assign !== 'function') {
    assign = function assign(target) {
        if (target === undefined || target === null) {
            throw new TypeError('Cannot convert undefined or null to object');
        }

        var output = Object(target);
        for (var index = 1; index < arguments.length; index++) {
            var source = arguments[index];
            if (source !== undefined && source !== null) {
                for (var nextKey in source) {
                    if (source.hasOwnProperty(nextKey)) {
                        output[nextKey] = source[nextKey];
                    }
                }
            }
        }
        return output;
    };
} else {
    assign = Object.assign;
}

/**
 * extend object.
 * means that properties in dest will be overwritten by the ones in src.
 * @param {Object} dest
 * @param {Object} src
 * @param {Boolean} [merge=false]
 * @returns {Object} dest
 */
var extend = deprecate(function extend(dest, src, merge) {
    var keys = Object.keys(src);
    var i = 0;
    while (i < keys.length) {
        if (!merge || (merge && dest[keys[i]] === undefined)) {
            dest[keys[i]] = src[keys[i]];
        }
        i++;
    }
    return dest;
}, 'extend', 'Use `assign`.');

/**
 * merge the values from src in the dest.
 * means that properties that exist in dest will not be overwritten by src
 * @param {Object} dest
 * @param {Object} src
 * @returns {Object} dest
 */
var merge = deprecate(function merge(dest, src) {
    return extend(dest, src, true);
}, 'merge', 'Use `assign`.');

/**
 * simple class inheritance
 * @param {Function} child
 * @param {Function} base
 * @param {Object} [properties]
 */
function inherit(child, base, properties) {
    var baseP = base.prototype,
        childP;

    childP = child.prototype = Object.create(baseP);
    childP.constructor = child;
    childP._super = baseP;

    if (properties) {
        assign(childP, properties);
    }
}

/**
 * simple function bind
 * @param {Function} fn
 * @param {Object} context
 * @returns {Function}
 */
function bindFn(fn, context) {
    return function boundFn() {
        return fn.apply(context, arguments);
    };
}

/**
 * let a boolean value also be a function that must return a boolean
 * this first item in args will be used as the context
 * @param {Boolean|Function} val
 * @param {Array} [args]
 * @returns {Boolean}
 */
function boolOrFn(val, args) {
    if (typeof val == TYPE_FUNCTION) {
        return val.apply(args ? args[0] || undefined : undefined, args);
    }
    return val;
}

/**
 * use the val2 when val1 is undefined
 * @param {*} val1
 * @param {*} val2
 * @returns {*}
 */
function ifUndefined(val1, val2) {
    return (val1 === undefined) ? val2 : val1;
}

/**
 * addEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function addEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.addEventListener(type, handler, false);
    });
}

/**
 * removeEventListener with multiple events at once
 * @param {EventTarget} target
 * @param {String} types
 * @param {Function} handler
 */
function removeEventListeners(target, types, handler) {
    each(splitStr(types), function(type) {
        target.removeEventListener(type, handler, false);
    });
}

/**
 * find if a node is in the given parent
 * @method hasParent
 * @param {HTMLElement} node
 * @param {HTMLElement} parent
 * @return {Boolean} found
 */
function hasParent(node, parent) {
    while (node) {
        if (node == parent) {
            return true;
        }
        node = node.parentNode;
    }
    return false;
}

/**
 * small indexOf wrapper
 * @param {String} str
 * @param {String} find
 * @returns {Boolean} found
 */
function inStr(str, find) {
    return str.indexOf(find) > -1;
}

/**
 * split string on whitespace
 * @param {String} str
 * @returns {Array} words
 */
function splitStr(str) {
    return str.trim().split(/\s+/g);
}

/**
 * find if a array contains the object using indexOf or a simple polyFill
 * @param {Array} src
 * @param {String} find
 * @param {String} [findByKey]
 * @return {Boolean|Number} false when not found, or the index
 */
function inArray(src, find, findByKey) {
    if (src.indexOf && !findByKey) {
        return src.indexOf(find);
    } else {
        var i = 0;
        while (i < src.length) {
            if ((findByKey && src[i][findByKey] == find) || (!findByKey && src[i] === find)) {
                return i;
            }
            i++;
        }
        return -1;
    }
}

/**
 * convert array-like objects to real arrays
 * @param {Object} obj
 * @returns {Array}
 */
function toArray(obj) {
    return Array.prototype.slice.call(obj, 0);
}

/**
 * unique array with objects based on a key (like 'id') or just by the array's value
 * @param {Array} src [{id:1},{id:2},{id:1}]
 * @param {String} [key]
 * @param {Boolean} [sort=False]
 * @returns {Array} [{id:1},{id:2}]
 */
function uniqueArray(src, key, sort) {
    var results = [];
    var values = [];
    var i = 0;

    while (i < src.length) {
        var val = key ? src[i][key] : src[i];
        if (inArray(values, val) < 0) {
            results.push(src[i]);
        }
        values[i] = val;
        i++;
    }

    if (sort) {
        if (!key) {
            results = results.sort();
        } else {
            results = results.sort(function sortUniqueArray(a, b) {
                return a[key] > b[key];
            });
        }
    }

    return results;
}

/**
 * get the prefixed property
 * @param {Object} obj
 * @param {String} property
 * @returns {String|Undefined} prefixed
 */
function prefixed(obj, property) {
    var prefix, prop;
    var camelProp = property[0].toUpperCase() + property.slice(1);

    var i = 0;
    while (i < VENDOR_PREFIXES.length) {
        prefix = VENDOR_PREFIXES[i];
        prop = (prefix) ? prefix + camelProp : property;

        if (prop in obj) {
            return prop;
        }
        i++;
    }
    return undefined;
}

/**
 * get a unique id
 * @returns {number} uniqueId
 */
var _uniqueId = 1;
function uniqueId() {
    return _uniqueId++;
}

/**
 * get the window object of an element
 * @param {HTMLElement} element
 * @returns {DocumentView|Window}
 */
function getWindowForElement(element) {
    var doc = element.ownerDocument || element;
    return (doc.defaultView || doc.parentWindow || window);
}

var MOBILE_REGEX = /mobile|tablet|ip(ad|hone|od)|android/i;

var SUPPORT_TOUCH = ('ontouchstart' in window);
var SUPPORT_POINTER_EVENTS = prefixed(window, 'PointerEvent') !== undefined;
var SUPPORT_ONLY_TOUCH = SUPPORT_TOUCH && MOBILE_REGEX.test(navigator.userAgent);

var INPUT_TYPE_TOUCH = 'touch';
var INPUT_TYPE_PEN = 'pen';
var INPUT_TYPE_MOUSE = 'mouse';
var INPUT_TYPE_KINECT = 'kinect';

var COMPUTE_INTERVAL = 25;

var INPUT_START = 1;
var INPUT_MOVE = 2;
var INPUT_END = 4;
var INPUT_CANCEL = 8;

var DIRECTION_NONE = 1;
var DIRECTION_LEFT = 2;
var DIRECTION_RIGHT = 4;
var DIRECTION_UP = 8;
var DIRECTION_DOWN = 16;

var DIRECTION_HORIZONTAL = DIRECTION_LEFT | DIRECTION_RIGHT;
var DIRECTION_VERTICAL = DIRECTION_UP | DIRECTION_DOWN;
var DIRECTION_ALL = DIRECTION_HORIZONTAL | DIRECTION_VERTICAL;

var PROPS_XY = ['x', 'y'];
var PROPS_CLIENT_XY = ['clientX', 'clientY'];

/**
 * create new input type manager
 * @param {Manager} manager
 * @param {Function} callback
 * @returns {Input}
 * @constructor
 */
function Input(manager, callback) {
    var self = this;
    this.manager = manager;
    this.callback = callback;
    this.element = manager.element;
    this.target = manager.options.inputTarget;

    // smaller wrapper around the handler, for the scope and the enabled state of the manager,
    // so when disabled the input events are completely bypassed.
    this.domHandler = function(ev) {
        if (boolOrFn(manager.options.enable, [manager])) {
            self.handler(ev);
        }
    };

    this.init();

}

Input.prototype = {
    /**
     * should handle the inputEvent data and trigger the callback
     * @virtual
     */
    handler: function() { },

    /**
     * bind the events
     */
    init: function() {
        this.evEl && addEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && addEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && addEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    },

    /**
     * unbind the events
     */
    destroy: function() {
        this.evEl && removeEventListeners(this.element, this.evEl, this.domHandler);
        this.evTarget && removeEventListeners(this.target, this.evTarget, this.domHandler);
        this.evWin && removeEventListeners(getWindowForElement(this.element), this.evWin, this.domHandler);
    }
};

/**
 * create new input type manager
 * called by the Manager constructor
 * @param {Hammer} manager
 * @returns {Input}
 */
function createInputInstance(manager) {
    var Type;
    var inputClass = manager.options.inputClass;

    if (inputClass) {
        Type = inputClass;
    } else if (SUPPORT_POINTER_EVENTS) {
        Type = PointerEventInput;
    } else if (SUPPORT_ONLY_TOUCH) {
        Type = TouchInput;
    } else if (!SUPPORT_TOUCH) {
        Type = MouseInput;
    } else {
        Type = TouchMouseInput;
    }
    return new (Type)(manager, inputHandler);
}

/**
 * handle input events
 * @param {Manager} manager
 * @param {String} eventType
 * @param {Object} input
 */
function inputHandler(manager, eventType, input) {
    var pointersLen = input.pointers.length;
    var changedPointersLen = input.changedPointers.length;
    var isFirst = (eventType & INPUT_START && (pointersLen - changedPointersLen === 0));
    var isFinal = (eventType & (INPUT_END | INPUT_CANCEL) && (pointersLen - changedPointersLen === 0));

    input.isFirst = !!isFirst;
    input.isFinal = !!isFinal;

    if (isFirst) {
        manager.session = {};
    }

    // source event is the normalized value of the domEvents
    // like 'touchstart, mouseup, pointerdown'
    input.eventType = eventType;

    // compute scale, rotation etc
    computeInputData(manager, input);

    // emit secret event
    manager.emit('hammer.input', input);

    manager.recognize(input);
    manager.session.prevInput = input;
}

/**
 * extend the data with some usable properties like scale, rotate, velocity etc
 * @param {Object} manager
 * @param {Object} input
 */
function computeInputData(manager, input) {
    var session = manager.session;
    var pointers = input.pointers;
    var pointersLength = pointers.length;

    // store the first input to calculate the distance and direction
    if (!session.firstInput) {
        session.firstInput = simpleCloneInputData(input);
    }

    // to compute scale and rotation we need to store the multiple touches
    if (pointersLength > 1 && !session.firstMultiple) {
        session.firstMultiple = simpleCloneInputData(input);
    } else if (pointersLength === 1) {
        session.firstMultiple = false;
    }

    var firstInput = session.firstInput;
    var firstMultiple = session.firstMultiple;
    var offsetCenter = firstMultiple ? firstMultiple.center : firstInput.center;

    var center = input.center = getCenter(pointers);
    input.timeStamp = now();
    input.deltaTime = input.timeStamp - firstInput.timeStamp;

    input.angle = getAngle(offsetCenter, center);
    input.distance = getDistance(offsetCenter, center);

    computeDeltaXY(session, input);
    input.offsetDirection = getDirection(input.deltaX, input.deltaY);

    var overallVelocity = getVelocity(input.deltaTime, input.deltaX, input.deltaY);
    input.overallVelocityX = overallVelocity.x;
    input.overallVelocityY = overallVelocity.y;
    input.overallVelocity = (abs(overallVelocity.x) > abs(overallVelocity.y)) ? overallVelocity.x : overallVelocity.y;

    input.scale = firstMultiple ? getScale(firstMultiple.pointers, pointers) : 1;
    input.rotation = firstMultiple ? getRotation(firstMultiple.pointers, pointers) : 0;

    input.maxPointers = !session.prevInput ? input.pointers.length : ((input.pointers.length >
        session.prevInput.maxPointers) ? input.pointers.length : session.prevInput.maxPointers);

    computeIntervalInputData(session, input);

    // find the correct target
    var target = manager.element;
    if (hasParent(input.srcEvent.target, target)) {
        target = input.srcEvent.target;
    }
    input.target = target;
}

function computeDeltaXY(session, input) {
    var center = input.center;
    var offset = session.offsetDelta || {};
    var prevDelta = session.prevDelta || {};
    var prevInput = session.prevInput || {};

    if (input.eventType === INPUT_START || prevInput.eventType === INPUT_END) {
        prevDelta = session.prevDelta = {
            x: prevInput.deltaX || 0,
            y: prevInput.deltaY || 0
        };

        offset = session.offsetDelta = {
            x: center.x,
            y: center.y
        };
    }

    input.deltaX = prevDelta.x + (center.x - offset.x);
    input.deltaY = prevDelta.y + (center.y - offset.y);
}

/**
 * velocity is calculated every x ms
 * @param {Object} session
 * @param {Object} input
 */
function computeIntervalInputData(session, input) {
    var last = session.lastInterval || input,
        deltaTime = input.timeStamp - last.timeStamp,
        velocity, velocityX, velocityY, direction;

    if (input.eventType != INPUT_CANCEL && (deltaTime > COMPUTE_INTERVAL || last.velocity === undefined)) {
        var deltaX = input.deltaX - last.deltaX;
        var deltaY = input.deltaY - last.deltaY;

        var v = getVelocity(deltaTime, deltaX, deltaY);
        velocityX = v.x;
        velocityY = v.y;
        velocity = (abs(v.x) > abs(v.y)) ? v.x : v.y;
        direction = getDirection(deltaX, deltaY);

        session.lastInterval = input;
    } else {
        // use latest velocity info if it doesn't overtake a minimum period
        velocity = last.velocity;
        velocityX = last.velocityX;
        velocityY = last.velocityY;
        direction = last.direction;
    }

    input.velocity = velocity;
    input.velocityX = velocityX;
    input.velocityY = velocityY;
    input.direction = direction;
}

/**
 * create a simple clone from the input used for storage of firstInput and firstMultiple
 * @param {Object} input
 * @returns {Object} clonedInputData
 */
function simpleCloneInputData(input) {
    // make a simple copy of the pointers because we will get a reference if we don't
    // we only need clientXY for the calculations
    var pointers = [];
    var i = 0;
    while (i < input.pointers.length) {
        pointers[i] = {
            clientX: round(input.pointers[i].clientX),
            clientY: round(input.pointers[i].clientY)
        };
        i++;
    }

    return {
        timeStamp: now(),
        pointers: pointers,
        center: getCenter(pointers),
        deltaX: input.deltaX,
        deltaY: input.deltaY
    };
}

/**
 * get the center of all the pointers
 * @param {Array} pointers
 * @return {Object} center contains `x` and `y` properties
 */
function getCenter(pointers) {
    var pointersLength = pointers.length;

    // no need to loop when only one touch
    if (pointersLength === 1) {
        return {
            x: round(pointers[0].clientX),
            y: round(pointers[0].clientY)
        };
    }

    var x = 0, y = 0, i = 0;
    while (i < pointersLength) {
        x += pointers[i].clientX;
        y += pointers[i].clientY;
        i++;
    }

    return {
        x: round(x / pointersLength),
        y: round(y / pointersLength)
    };
}

/**
 * calculate the velocity between two points. unit is in px per ms.
 * @param {Number} deltaTime
 * @param {Number} x
 * @param {Number} y
 * @return {Object} velocity `x` and `y`
 */
function getVelocity(deltaTime, x, y) {
    return {
        x: x / deltaTime || 0,
        y: y / deltaTime || 0
    };
}

/**
 * get the direction between two points
 * @param {Number} x
 * @param {Number} y
 * @return {Number} direction
 */
function getDirection(x, y) {
    if (x === y) {
        return DIRECTION_NONE;
    }

    if (abs(x) >= abs(y)) {
        return x < 0 ? DIRECTION_LEFT : DIRECTION_RIGHT;
    }
    return y < 0 ? DIRECTION_UP : DIRECTION_DOWN;
}

/**
 * calculate the absolute distance between two points
 * @param {Object} p1 {x, y}
 * @param {Object} p2 {x, y}
 * @param {Array} [props] containing x and y keys
 * @return {Number} distance
 */
function getDistance(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];

    return Math.sqrt((x * x) + (y * y));
}

/**
 * calculate the angle between two coordinates
 * @param {Object} p1
 * @param {Object} p2
 * @param {Array} [props] containing x and y keys
 * @return {Number} angle
 */
function getAngle(p1, p2, props) {
    if (!props) {
        props = PROPS_XY;
    }
    var x = p2[props[0]] - p1[props[0]],
        y = p2[props[1]] - p1[props[1]];
    return Math.atan2(y, x) * 180 / Math.PI;
}

/**
 * calculate the rotation degrees between two pointersets
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} rotation
 */
function getRotation(start, end) {
    return getAngle(end[1], end[0], PROPS_CLIENT_XY) + getAngle(start[1], start[0], PROPS_CLIENT_XY);
}

/**
 * calculate the scale factor between two pointersets
 * no scale is 1, and goes down to 0 when pinched together, and bigger when pinched out
 * @param {Array} start array of pointers
 * @param {Array} end array of pointers
 * @return {Number} scale
 */
function getScale(start, end) {
    return getDistance(end[0], end[1], PROPS_CLIENT_XY) / getDistance(start[0], start[1], PROPS_CLIENT_XY);
}

var MOUSE_INPUT_MAP = {
    mousedown: INPUT_START,
    mousemove: INPUT_MOVE,
    mouseup: INPUT_END
};

var MOUSE_ELEMENT_EVENTS = 'mousedown';
var MOUSE_WINDOW_EVENTS = 'mousemove mouseup';

/**
 * Mouse events input
 * @constructor
 * @extends Input
 */
function MouseInput() {
    this.evEl = MOUSE_ELEMENT_EVENTS;
    this.evWin = MOUSE_WINDOW_EVENTS;

    this.pressed = false; // mousedown state

    Input.apply(this, arguments);
}

inherit(MouseInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function MEhandler(ev) {
        var eventType = MOUSE_INPUT_MAP[ev.type];

        // on start we want to have the left mouse button down
        if (eventType & INPUT_START && ev.button === 0) {
            this.pressed = true;
        }

        if (eventType & INPUT_MOVE && ev.which !== 1) {
            eventType = INPUT_END;
        }

        // mouse must be down
        if (!this.pressed) {
            return;
        }

        if (eventType & INPUT_END) {
            this.pressed = false;
        }

        this.callback(this.manager, eventType, {
            pointers: [ev],
            changedPointers: [ev],
            pointerType: INPUT_TYPE_MOUSE,
            srcEvent: ev
        });
    }
});

var POINTER_INPUT_MAP = {
    pointerdown: INPUT_START,
    pointermove: INPUT_MOVE,
    pointerup: INPUT_END,
    pointercancel: INPUT_CANCEL,
    pointerout: INPUT_CANCEL
};

// in IE10 the pointer types is defined as an enum
var IE10_POINTER_TYPE_ENUM = {
    2: INPUT_TYPE_TOUCH,
    3: INPUT_TYPE_PEN,
    4: INPUT_TYPE_MOUSE,
    5: INPUT_TYPE_KINECT // see https://twitter.com/jacobrossi/status/480596438489890816
};

var POINTER_ELEMENT_EVENTS = 'pointerdown';
var POINTER_WINDOW_EVENTS = 'pointermove pointerup pointercancel';

// IE10 has prefixed support, and case-sensitive
if (window.MSPointerEvent && !window.PointerEvent) {
    POINTER_ELEMENT_EVENTS = 'MSPointerDown';
    POINTER_WINDOW_EVENTS = 'MSPointerMove MSPointerUp MSPointerCancel';
}

/**
 * Pointer events input
 * @constructor
 * @extends Input
 */
function PointerEventInput() {
    this.evEl = POINTER_ELEMENT_EVENTS;
    this.evWin = POINTER_WINDOW_EVENTS;

    Input.apply(this, arguments);

    this.store = (this.manager.session.pointerEvents = []);
}

inherit(PointerEventInput, Input, {
    /**
     * handle mouse events
     * @param {Object} ev
     */
    handler: function PEhandler(ev) {
        var store = this.store;
        var removePointer = false;

        var eventTypeNormalized = ev.type.toLowerCase().replace('ms', '');
        var eventType = POINTER_INPUT_MAP[eventTypeNormalized];
        var pointerType = IE10_POINTER_TYPE_ENUM[ev.pointerType] || ev.pointerType;

        var isTouch = (pointerType == INPUT_TYPE_TOUCH);

        // get index of the event in the store
        var storeIndex = inArray(store, ev.pointerId, 'pointerId');

        // start and mouse must be down
        if (eventType & INPUT_START && (ev.button === 0 || isTouch)) {
            if (storeIndex < 0) {
                store.push(ev);
                storeIndex = store.length - 1;
            }
        } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
            removePointer = true;
        }

        // it not found, so the pointer hasn't been down (so it's probably a hover)
        if (storeIndex < 0) {
            return;
        }

        // update the event in the store
        store[storeIndex] = ev;

        this.callback(this.manager, eventType, {
            pointers: store,
            changedPointers: [ev],
            pointerType: pointerType,
            srcEvent: ev
        });

        if (removePointer) {
            // remove from the store
            store.splice(storeIndex, 1);
        }
    }
});

var SINGLE_TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var SINGLE_TOUCH_TARGET_EVENTS = 'touchstart';
var SINGLE_TOUCH_WINDOW_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Touch events input
 * @constructor
 * @extends Input
 */
function SingleTouchInput() {
    this.evTarget = SINGLE_TOUCH_TARGET_EVENTS;
    this.evWin = SINGLE_TOUCH_WINDOW_EVENTS;
    this.started = false;

    Input.apply(this, arguments);
}

inherit(SingleTouchInput, Input, {
    handler: function TEhandler(ev) {
        var type = SINGLE_TOUCH_INPUT_MAP[ev.type];

        // should we handle the touch events?
        if (type === INPUT_START) {
            this.started = true;
        }

        if (!this.started) {
            return;
        }

        var touches = normalizeSingleTouches.call(this, ev, type);

        // when done, reset the started state
        if (type & (INPUT_END | INPUT_CANCEL) && touches[0].length - touches[1].length === 0) {
            this.started = false;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function normalizeSingleTouches(ev, type) {
    var all = toArray(ev.touches);
    var changed = toArray(ev.changedTouches);

    if (type & (INPUT_END | INPUT_CANCEL)) {
        all = uniqueArray(all.concat(changed), 'identifier', true);
    }

    return [all, changed];
}

var TOUCH_INPUT_MAP = {
    touchstart: INPUT_START,
    touchmove: INPUT_MOVE,
    touchend: INPUT_END,
    touchcancel: INPUT_CANCEL
};

var TOUCH_TARGET_EVENTS = 'touchstart touchmove touchend touchcancel';

/**
 * Multi-user touch events input
 * @constructor
 * @extends Input
 */
function TouchInput() {
    this.evTarget = TOUCH_TARGET_EVENTS;
    this.targetIds = {};

    Input.apply(this, arguments);
}

inherit(TouchInput, Input, {
    handler: function MTEhandler(ev) {
        var type = TOUCH_INPUT_MAP[ev.type];
        var touches = getTouches.call(this, ev, type);
        if (!touches) {
            return;
        }

        this.callback(this.manager, type, {
            pointers: touches[0],
            changedPointers: touches[1],
            pointerType: INPUT_TYPE_TOUCH,
            srcEvent: ev
        });
    }
});

/**
 * @this {TouchInput}
 * @param {Object} ev
 * @param {Number} type flag
 * @returns {undefined|Array} [all, changed]
 */
function getTouches(ev, type) {
    var allTouches = toArray(ev.touches);
    var targetIds = this.targetIds;

    // when there is only one touch, the process can be simplified
    if (type & (INPUT_START | INPUT_MOVE) && allTouches.length === 1) {
        targetIds[allTouches[0].identifier] = true;
        return [allTouches, allTouches];
    }

    var i,
        targetTouches,
        changedTouches = toArray(ev.changedTouches),
        changedTargetTouches = [],
        target = this.target;

    // get target touches from touches
    targetTouches = allTouches.filter(function(touch) {
        return hasParent(touch.target, target);
    });

    // collect touches
    if (type === INPUT_START) {
        i = 0;
        while (i < targetTouches.length) {
            targetIds[targetTouches[i].identifier] = true;
            i++;
        }
    }

    // filter changed touches to only contain touches that exist in the collected target ids
    i = 0;
    while (i < changedTouches.length) {
        if (targetIds[changedTouches[i].identifier]) {
            changedTargetTouches.push(changedTouches[i]);
        }

        // cleanup removed touches
        if (type & (INPUT_END | INPUT_CANCEL)) {
            delete targetIds[changedTouches[i].identifier];
        }
        i++;
    }

    if (!changedTargetTouches.length) {
        return;
    }

    return [
        // merge targetTouches with changedTargetTouches so it contains ALL touches, including 'end' and 'cancel'
        uniqueArray(targetTouches.concat(changedTargetTouches), 'identifier', true),
        changedTargetTouches
    ];
}

/**
 * Combined touch and mouse input
 *
 * Touch has a higher priority then mouse, and while touching no mouse events are allowed.
 * This because touch devices also emit mouse events while doing a touch.
 *
 * @constructor
 * @extends Input
 */

var DEDUP_TIMEOUT = 2500;
var DEDUP_DISTANCE = 25;

function TouchMouseInput() {
    Input.apply(this, arguments);

    var handler = bindFn(this.handler, this);
    this.touch = new TouchInput(this.manager, handler);
    this.mouse = new MouseInput(this.manager, handler);

    this.primaryTouch = null;
    this.lastTouches = [];
}

inherit(TouchMouseInput, Input, {
    /**
     * handle mouse and touch events
     * @param {Hammer} manager
     * @param {String} inputEvent
     * @param {Object} inputData
     */
    handler: function TMEhandler(manager, inputEvent, inputData) {
        var isTouch = (inputData.pointerType == INPUT_TYPE_TOUCH),
            isMouse = (inputData.pointerType == INPUT_TYPE_MOUSE);

        if (isMouse && inputData.sourceCapabilities && inputData.sourceCapabilities.firesTouchEvents) {
            return;
        }

        // when we're in a touch event, record touches to  de-dupe synthetic mouse event
        if (isTouch) {
            recordTouches.call(this, inputEvent, inputData);
        } else if (isMouse && isSyntheticEvent.call(this, inputData)) {
            return;
        }

        this.callback(manager, inputEvent, inputData);
    },

    /**
     * remove the event listeners
     */
    destroy: function destroy() {
        this.touch.destroy();
        this.mouse.destroy();
    }
});

function recordTouches(eventType, eventData) {
    if (eventType & INPUT_START) {
        this.primaryTouch = eventData.changedPointers[0].identifier;
        setLastTouch.call(this, eventData);
    } else if (eventType & (INPUT_END | INPUT_CANCEL)) {
        setLastTouch.call(this, eventData);
    }
}

function setLastTouch(eventData) {
    var touch = eventData.changedPointers[0];

    if (touch.identifier === this.primaryTouch) {
        var lastTouch = {x: touch.clientX, y: touch.clientY};
        this.lastTouches.push(lastTouch);
        var lts = this.lastTouches;
        var removeLastTouch = function() {
            var i = lts.indexOf(lastTouch);
            if (i > -1) {
                lts.splice(i, 1);
            }
        };
        setTimeout(removeLastTouch, DEDUP_TIMEOUT);
    }
}

function isSyntheticEvent(eventData) {
    var x = eventData.srcEvent.clientX, y = eventData.srcEvent.clientY;
    for (var i = 0; i < this.lastTouches.length; i++) {
        var t = this.lastTouches[i];
        var dx = Math.abs(x - t.x), dy = Math.abs(y - t.y);
        if (dx <= DEDUP_DISTANCE && dy <= DEDUP_DISTANCE) {
            return true;
        }
    }
    return false;
}

var PREFIXED_TOUCH_ACTION = prefixed(TEST_ELEMENT.style, 'touchAction');
var NATIVE_TOUCH_ACTION = PREFIXED_TOUCH_ACTION !== undefined;

// magical touchAction value
var TOUCH_ACTION_COMPUTE = 'compute';
var TOUCH_ACTION_AUTO = 'auto';
var TOUCH_ACTION_MANIPULATION = 'manipulation'; // not implemented
var TOUCH_ACTION_NONE = 'none';
var TOUCH_ACTION_PAN_X = 'pan-x';
var TOUCH_ACTION_PAN_Y = 'pan-y';
var TOUCH_ACTION_MAP = getTouchActionProps();

/**
 * Touch Action
 * sets the touchAction property or uses the js alternative
 * @param {Manager} manager
 * @param {String} value
 * @constructor
 */
function TouchAction(manager, value) {
    this.manager = manager;
    this.set(value);
}

TouchAction.prototype = {
    /**
     * set the touchAction value on the element or enable the polyfill
     * @param {String} value
     */
    set: function(value) {
        // find out the touch-action by the event handlers
        if (value == TOUCH_ACTION_COMPUTE) {
            value = this.compute();
        }

        if (NATIVE_TOUCH_ACTION && this.manager.element.style && TOUCH_ACTION_MAP[value]) {
            this.manager.element.style[PREFIXED_TOUCH_ACTION] = value;
        }
        this.actions = value.toLowerCase().trim();
    },

    /**
     * just re-set the touchAction value
     */
    update: function() {
        this.set(this.manager.options.touchAction);
    },

    /**
     * compute the value for the touchAction property based on the recognizer's settings
     * @returns {String} value
     */
    compute: function() {
        var actions = [];
        each(this.manager.recognizers, function(recognizer) {
            if (boolOrFn(recognizer.options.enable, [recognizer])) {
                actions = actions.concat(recognizer.getTouchAction());
            }
        });
        return cleanTouchActions(actions.join(' '));
    },

    /**
     * this method is called on each input cycle and provides the preventing of the browser behavior
     * @param {Object} input
     */
    preventDefaults: function(input) {
        var srcEvent = input.srcEvent;
        var direction = input.offsetDirection;

        // if the touch action did prevented once this session
        if (this.manager.session.prevented) {
            srcEvent.preventDefault();
            return;
        }

        var actions = this.actions;
        var hasNone = inStr(actions, TOUCH_ACTION_NONE) && !TOUCH_ACTION_MAP[TOUCH_ACTION_NONE];
        var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_Y];
        var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X) && !TOUCH_ACTION_MAP[TOUCH_ACTION_PAN_X];

        if (hasNone) {
            //do not prevent defaults if this is a tap gesture

            var isTapPointer = input.pointers.length === 1;
            var isTapMovement = input.distance < 2;
            var isTapTouchTime = input.deltaTime < 250;

            if (isTapPointer && isTapMovement && isTapTouchTime) {
                return;
            }
        }

        if (hasPanX && hasPanY) {
            // `pan-x pan-y` means browser handles all scrolling/panning, do not prevent
            return;
        }

        if (hasNone ||
            (hasPanY && direction & DIRECTION_HORIZONTAL) ||
            (hasPanX && direction & DIRECTION_VERTICAL)) {
            return this.preventSrc(srcEvent);
        }
    },

    /**
     * call preventDefault to prevent the browser's default behavior (scrolling in most cases)
     * @param {Object} srcEvent
     */
    preventSrc: function(srcEvent) {
        this.manager.session.prevented = true;
        srcEvent.preventDefault();
    }
};

/**
 * when the touchActions are collected they are not a valid value, so we need to clean things up. *
 * @param {String} actions
 * @returns {*}
 */
function cleanTouchActions(actions) {
    // none
    if (inStr(actions, TOUCH_ACTION_NONE)) {
        return TOUCH_ACTION_NONE;
    }

    var hasPanX = inStr(actions, TOUCH_ACTION_PAN_X);
    var hasPanY = inStr(actions, TOUCH_ACTION_PAN_Y);

    // if both pan-x and pan-y are set (different recognizers
    // for different directions, e.g. horizontal pan but vertical swipe?)
    // we need none (as otherwise with pan-x pan-y combined none of these
    // recognizers will work, since the browser would handle all panning
    if (hasPanX && hasPanY) {
        return TOUCH_ACTION_NONE;
    }

    // pan-x OR pan-y
    if (hasPanX || hasPanY) {
        return hasPanX ? TOUCH_ACTION_PAN_X : TOUCH_ACTION_PAN_Y;
    }

    // manipulation
    if (inStr(actions, TOUCH_ACTION_MANIPULATION)) {
        return TOUCH_ACTION_MANIPULATION;
    }

    return TOUCH_ACTION_AUTO;
}

function getTouchActionProps() {
    if (!NATIVE_TOUCH_ACTION) {
        return false;
    }
    var touchMap = {};
    var cssSupports = window.CSS && window.CSS.supports;
    ['auto', 'manipulation', 'pan-y', 'pan-x', 'pan-x pan-y', 'none'].forEach(function(val) {

        // If css.supports is not supported but there is native touch-action assume it supports
        // all values. This is the case for IE 10 and 11.
        touchMap[val] = cssSupports ? window.CSS.supports('touch-action', val) : true;
    });
    return touchMap;
}

/**
 * Recognizer flow explained; *
 * All recognizers have the initial state of POSSIBLE when a input session starts.
 * The definition of a input session is from the first input until the last input, with all it's movement in it. *
 * Example session for mouse-input: mousedown -> mousemove -> mouseup
 *
 * On each recognizing cycle (see Manager.recognize) the .recognize() method is executed
 * which determines with state it should be.
 *
 * If the recognizer has the state FAILED, CANCELLED or RECOGNIZED (equals ENDED), it is reset to
 * POSSIBLE to give it another change on the next cycle.
 *
 *               Possible
 *                  |
 *            +-----+---------------+
 *            |                     |
 *      +-----+-----+               |
 *      |           |               |
 *   Failed      Cancelled          |
 *                          +-------+------+
 *                          |              |
 *                      Recognized       Began
 *                                         |
 *                                      Changed
 *                                         |
 *                                  Ended/Recognized
 */
var STATE_POSSIBLE = 1;
var STATE_BEGAN = 2;
var STATE_CHANGED = 4;
var STATE_ENDED = 8;
var STATE_RECOGNIZED = STATE_ENDED;
var STATE_CANCELLED = 16;
var STATE_FAILED = 32;

/**
 * Recognizer
 * Every recognizer needs to extend from this class.
 * @constructor
 * @param {Object} options
 */
function Recognizer(options) {
    this.options = assign({}, this.defaults, options || {});

    this.id = uniqueId();

    this.manager = null;

    // default is enable true
    this.options.enable = ifUndefined(this.options.enable, true);

    this.state = STATE_POSSIBLE;

    this.simultaneous = {};
    this.requireFail = [];
}

Recognizer.prototype = {
    /**
     * @virtual
     * @type {Object}
     */
    defaults: {},

    /**
     * set options
     * @param {Object} options
     * @return {Recognizer}
     */
    set: function(options) {
        assign(this.options, options);

        // also update the touchAction, in case something changed about the directions/enabled state
        this.manager && this.manager.touchAction.update();
        return this;
    },

    /**
     * recognize simultaneous with an other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    recognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'recognizeWith', this)) {
            return this;
        }

        var simultaneous = this.simultaneous;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (!simultaneous[otherRecognizer.id]) {
            simultaneous[otherRecognizer.id] = otherRecognizer;
            otherRecognizer.recognizeWith(this);
        }
        return this;
    },

    /**
     * drop the simultaneous link. it doesnt remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRecognizeWith: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRecognizeWith', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        delete this.simultaneous[otherRecognizer.id];
        return this;
    },

    /**
     * recognizer can only run when an other is failing
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    requireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'requireFailure', this)) {
            return this;
        }

        var requireFail = this.requireFail;
        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        if (inArray(requireFail, otherRecognizer) === -1) {
            requireFail.push(otherRecognizer);
            otherRecognizer.requireFailure(this);
        }
        return this;
    },

    /**
     * drop the requireFailure link. it does not remove the link on the other recognizer.
     * @param {Recognizer} otherRecognizer
     * @returns {Recognizer} this
     */
    dropRequireFailure: function(otherRecognizer) {
        if (invokeArrayArg(otherRecognizer, 'dropRequireFailure', this)) {
            return this;
        }

        otherRecognizer = getRecognizerByNameIfManager(otherRecognizer, this);
        var index = inArray(this.requireFail, otherRecognizer);
        if (index > -1) {
            this.requireFail.splice(index, 1);
        }
        return this;
    },

    /**
     * has require failures boolean
     * @returns {boolean}
     */
    hasRequireFailures: function() {
        return this.requireFail.length > 0;
    },

    /**
     * if the recognizer can recognize simultaneous with an other recognizer
     * @param {Recognizer} otherRecognizer
     * @returns {Boolean}
     */
    canRecognizeWith: function(otherRecognizer) {
        return !!this.simultaneous[otherRecognizer.id];
    },

    /**
     * You should use `tryEmit` instead of `emit` directly to check
     * that all the needed recognizers has failed before emitting.
     * @param {Object} input
     */
    emit: function(input) {
        var self = this;
        var state = this.state;

        function emit(event) {
            self.manager.emit(event, input);
        }

        // 'panstart' and 'panmove'
        if (state < STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }

        emit(self.options.event); // simple 'eventName' events

        if (input.additionalEvent) { // additional event(panleft, panright, pinchin, pinchout...)
            emit(input.additionalEvent);
        }

        // panend and pancancel
        if (state >= STATE_ENDED) {
            emit(self.options.event + stateStr(state));
        }
    },

    /**
     * Check that all the require failure recognizers has failed,
     * if true, it emits a gesture event,
     * otherwise, setup the state to FAILED.
     * @param {Object} input
     */
    tryEmit: function(input) {
        if (this.canEmit()) {
            return this.emit(input);
        }
        // it's failing anyway
        this.state = STATE_FAILED;
    },

    /**
     * can we emit?
     * @returns {boolean}
     */
    canEmit: function() {
        var i = 0;
        while (i < this.requireFail.length) {
            if (!(this.requireFail[i].state & (STATE_FAILED | STATE_POSSIBLE))) {
                return false;
            }
            i++;
        }
        return true;
    },

    /**
     * update the recognizer
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        // make a new copy of the inputData
        // so we can change the inputData without messing up the other recognizers
        var inputDataClone = assign({}, inputData);

        // is is enabled and allow recognizing?
        if (!boolOrFn(this.options.enable, [this, inputDataClone])) {
            this.reset();
            this.state = STATE_FAILED;
            return;
        }

        // reset when we've reached the end
        if (this.state & (STATE_RECOGNIZED | STATE_CANCELLED | STATE_FAILED)) {
            this.state = STATE_POSSIBLE;
        }

        this.state = this.process(inputDataClone);

        // the recognizer has recognized a gesture
        // so trigger an event
        if (this.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED | STATE_CANCELLED)) {
            this.tryEmit(inputDataClone);
        }
    },

    /**
     * return the state of the recognizer
     * the actual recognizing happens in this method
     * @virtual
     * @param {Object} inputData
     * @returns {Const} STATE
     */
    process: function(inputData) { }, // jshint ignore:line

    /**
     * return the preferred touch-action
     * @virtual
     * @returns {Array}
     */
    getTouchAction: function() { },

    /**
     * called when the gesture isn't allowed to recognize
     * like when another is being recognized or it is disabled
     * @virtual
     */
    reset: function() { }
};

/**
 * get a usable string, used as event postfix
 * @param {Const} state
 * @returns {String} state
 */
function stateStr(state) {
    if (state & STATE_CANCELLED) {
        return 'cancel';
    } else if (state & STATE_ENDED) {
        return 'end';
    } else if (state & STATE_CHANGED) {
        return 'move';
    } else if (state & STATE_BEGAN) {
        return 'start';
    }
    return '';
}

/**
 * direction cons to string
 * @param {Const} direction
 * @returns {String}
 */
function directionStr(direction) {
    if (direction == DIRECTION_DOWN) {
        return 'down';
    } else if (direction == DIRECTION_UP) {
        return 'up';
    } else if (direction == DIRECTION_LEFT) {
        return 'left';
    } else if (direction == DIRECTION_RIGHT) {
        return 'right';
    }
    return '';
}

/**
 * get a recognizer by name if it is bound to a manager
 * @param {Recognizer|String} otherRecognizer
 * @param {Recognizer} recognizer
 * @returns {Recognizer}
 */
function getRecognizerByNameIfManager(otherRecognizer, recognizer) {
    var manager = recognizer.manager;
    if (manager) {
        return manager.get(otherRecognizer);
    }
    return otherRecognizer;
}

/**
 * This recognizer is just used as a base for the simple attribute recognizers.
 * @constructor
 * @extends Recognizer
 */
function AttrRecognizer() {
    Recognizer.apply(this, arguments);
}

inherit(AttrRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof AttrRecognizer
     */
    defaults: {
        /**
         * @type {Number}
         * @default 1
         */
        pointers: 1
    },

    /**
     * Used to check if it the recognizer receives valid input, like input.distance > 10.
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {Boolean} recognized
     */
    attrTest: function(input) {
        var optionPointers = this.options.pointers;
        return optionPointers === 0 || input.pointers.length === optionPointers;
    },

    /**
     * Process the input and return the state for the recognizer
     * @memberof AttrRecognizer
     * @param {Object} input
     * @returns {*} State
     */
    process: function(input) {
        var state = this.state;
        var eventType = input.eventType;

        var isRecognized = state & (STATE_BEGAN | STATE_CHANGED);
        var isValid = this.attrTest(input);

        // on cancel input and we've recognized before, return STATE_CANCELLED
        if (isRecognized && (eventType & INPUT_CANCEL || !isValid)) {
            return state | STATE_CANCELLED;
        } else if (isRecognized || isValid) {
            if (eventType & INPUT_END) {
                return state | STATE_ENDED;
            } else if (!(state & STATE_BEGAN)) {
                return STATE_BEGAN;
            }
            return state | STATE_CHANGED;
        }
        return STATE_FAILED;
    }
});

/**
 * Pan
 * Recognized when the pointer is down and moved in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function PanRecognizer() {
    AttrRecognizer.apply(this, arguments);

    this.pX = null;
    this.pY = null;
}

inherit(PanRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PanRecognizer
     */
    defaults: {
        event: 'pan',
        threshold: 10,
        pointers: 1,
        direction: DIRECTION_ALL
    },

    getTouchAction: function() {
        var direction = this.options.direction;
        var actions = [];
        if (direction & DIRECTION_HORIZONTAL) {
            actions.push(TOUCH_ACTION_PAN_Y);
        }
        if (direction & DIRECTION_VERTICAL) {
            actions.push(TOUCH_ACTION_PAN_X);
        }
        return actions;
    },

    directionTest: function(input) {
        var options = this.options;
        var hasMoved = true;
        var distance = input.distance;
        var direction = input.direction;
        var x = input.deltaX;
        var y = input.deltaY;

        // lock to axis?
        if (!(direction & options.direction)) {
            if (options.direction & DIRECTION_HORIZONTAL) {
                direction = (x === 0) ? DIRECTION_NONE : (x < 0) ? DIRECTION_LEFT : DIRECTION_RIGHT;
                hasMoved = x != this.pX;
                distance = Math.abs(input.deltaX);
            } else {
                direction = (y === 0) ? DIRECTION_NONE : (y < 0) ? DIRECTION_UP : DIRECTION_DOWN;
                hasMoved = y != this.pY;
                distance = Math.abs(input.deltaY);
            }
        }
        input.direction = direction;
        return hasMoved && distance > options.threshold && direction & options.direction;
    },

    attrTest: function(input) {
        return AttrRecognizer.prototype.attrTest.call(this, input) &&
            (this.state & STATE_BEGAN || (!(this.state & STATE_BEGAN) && this.directionTest(input)));
    },

    emit: function(input) {

        this.pX = input.deltaX;
        this.pY = input.deltaY;

        var direction = directionStr(input.direction);

        if (direction) {
            input.additionalEvent = this.options.event + direction;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Pinch
 * Recognized when two or more pointers are moving toward (zoom-in) or away from each other (zoom-out).
 * @constructor
 * @extends AttrRecognizer
 */
function PinchRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(PinchRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'pinch',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.scale - 1) > this.options.threshold || this.state & STATE_BEGAN);
    },

    emit: function(input) {
        if (input.scale !== 1) {
            var inOut = input.scale < 1 ? 'in' : 'out';
            input.additionalEvent = this.options.event + inOut;
        }
        this._super.emit.call(this, input);
    }
});

/**
 * Press
 * Recognized when the pointer is down for x ms without any movement.
 * @constructor
 * @extends Recognizer
 */
function PressRecognizer() {
    Recognizer.apply(this, arguments);

    this._timer = null;
    this._input = null;
}

inherit(PressRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PressRecognizer
     */
    defaults: {
        event: 'press',
        pointers: 1,
        time: 251, // minimal time of the pointer to be pressed
        threshold: 9 // a minimal movement is ok, but keep it low
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_AUTO];
    },

    process: function(input) {
        var options = this.options;
        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTime = input.deltaTime > options.time;

        this._input = input;

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (!validMovement || !validPointers || (input.eventType & (INPUT_END | INPUT_CANCEL) && !validTime)) {
            this.reset();
        } else if (input.eventType & INPUT_START) {
            this.reset();
            this._timer = setTimeoutContext(function() {
                this.state = STATE_RECOGNIZED;
                this.tryEmit();
            }, options.time, this);
        } else if (input.eventType & INPUT_END) {
            return STATE_RECOGNIZED;
        }
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function(input) {
        if (this.state !== STATE_RECOGNIZED) {
            return;
        }

        if (input && (input.eventType & INPUT_END)) {
            this.manager.emit(this.options.event + 'up', input);
        } else {
            this._input.timeStamp = now();
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Rotate
 * Recognized when two or more pointer are moving in a circular motion.
 * @constructor
 * @extends AttrRecognizer
 */
function RotateRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(RotateRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof RotateRecognizer
     */
    defaults: {
        event: 'rotate',
        threshold: 0,
        pointers: 2
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_NONE];
    },

    attrTest: function(input) {
        return this._super.attrTest.call(this, input) &&
            (Math.abs(input.rotation) > this.options.threshold || this.state & STATE_BEGAN);
    }
});

/**
 * Swipe
 * Recognized when the pointer is moving fast (velocity), with enough distance in the allowed direction.
 * @constructor
 * @extends AttrRecognizer
 */
function SwipeRecognizer() {
    AttrRecognizer.apply(this, arguments);
}

inherit(SwipeRecognizer, AttrRecognizer, {
    /**
     * @namespace
     * @memberof SwipeRecognizer
     */
    defaults: {
        event: 'swipe',
        threshold: 10,
        velocity: 0.3,
        direction: DIRECTION_HORIZONTAL | DIRECTION_VERTICAL,
        pointers: 1
    },

    getTouchAction: function() {
        return PanRecognizer.prototype.getTouchAction.call(this);
    },

    attrTest: function(input) {
        var direction = this.options.direction;
        var velocity;

        if (direction & (DIRECTION_HORIZONTAL | DIRECTION_VERTICAL)) {
            velocity = input.overallVelocity;
        } else if (direction & DIRECTION_HORIZONTAL) {
            velocity = input.overallVelocityX;
        } else if (direction & DIRECTION_VERTICAL) {
            velocity = input.overallVelocityY;
        }

        return this._super.attrTest.call(this, input) &&
            direction & input.offsetDirection &&
            input.distance > this.options.threshold &&
            input.maxPointers == this.options.pointers &&
            abs(velocity) > this.options.velocity && input.eventType & INPUT_END;
    },

    emit: function(input) {
        var direction = directionStr(input.offsetDirection);
        if (direction) {
            this.manager.emit(this.options.event + direction, input);
        }

        this.manager.emit(this.options.event, input);
    }
});

/**
 * A tap is ecognized when the pointer is doing a small tap/click. Multiple taps are recognized if they occur
 * between the given interval and position. The delay option can be used to recognize multi-taps without firing
 * a single tap.
 *
 * The eventData from the emitted event contains the property `tapCount`, which contains the amount of
 * multi-taps being recognized.
 * @constructor
 * @extends Recognizer
 */
function TapRecognizer() {
    Recognizer.apply(this, arguments);

    // previous time and center,
    // used for tap counting
    this.pTime = false;
    this.pCenter = false;

    this._timer = null;
    this._input = null;
    this.count = 0;
}

inherit(TapRecognizer, Recognizer, {
    /**
     * @namespace
     * @memberof PinchRecognizer
     */
    defaults: {
        event: 'tap',
        pointers: 1,
        taps: 1,
        interval: 300, // max time between the multi-tap taps
        time: 250, // max time of the pointer to be down (like finger on the screen)
        threshold: 9, // a minimal movement is ok, but keep it low
        posThreshold: 10 // a multi-tap can be a bit off the initial position
    },

    getTouchAction: function() {
        return [TOUCH_ACTION_MANIPULATION];
    },

    process: function(input) {
        var options = this.options;

        var validPointers = input.pointers.length === options.pointers;
        var validMovement = input.distance < options.threshold;
        var validTouchTime = input.deltaTime < options.time;

        this.reset();

        if ((input.eventType & INPUT_START) && (this.count === 0)) {
            return this.failTimeout();
        }

        // we only allow little movement
        // and we've reached an end event, so a tap is possible
        if (validMovement && validTouchTime && validPointers) {
            if (input.eventType != INPUT_END) {
                return this.failTimeout();
            }

            var validInterval = this.pTime ? (input.timeStamp - this.pTime < options.interval) : true;
            var validMultiTap = !this.pCenter || getDistance(this.pCenter, input.center) < options.posThreshold;

            this.pTime = input.timeStamp;
            this.pCenter = input.center;

            if (!validMultiTap || !validInterval) {
                this.count = 1;
            } else {
                this.count += 1;
            }

            this._input = input;

            // if tap count matches we have recognized it,
            // else it has began recognizing...
            var tapCount = this.count % options.taps;
            if (tapCount === 0) {
                // no failing requirements, immediately trigger the tap event
                // or wait as long as the multitap interval to trigger
                if (!this.hasRequireFailures()) {
                    return STATE_RECOGNIZED;
                } else {
                    this._timer = setTimeoutContext(function() {
                        this.state = STATE_RECOGNIZED;
                        this.tryEmit();
                    }, options.interval, this);
                    return STATE_BEGAN;
                }
            }
        }
        return STATE_FAILED;
    },

    failTimeout: function() {
        this._timer = setTimeoutContext(function() {
            this.state = STATE_FAILED;
        }, this.options.interval, this);
        return STATE_FAILED;
    },

    reset: function() {
        clearTimeout(this._timer);
    },

    emit: function() {
        if (this.state == STATE_RECOGNIZED) {
            this._input.tapCount = this.count;
            this.manager.emit(this.options.event, this._input);
        }
    }
});

/**
 * Simple way to create a manager with a default set of recognizers.
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Hammer(element, options) {
    options = options || {};
    options.recognizers = ifUndefined(options.recognizers, Hammer.defaults.preset);
    return new Manager(element, options);
}

/**
 * @const {string}
 */
Hammer.VERSION = '2.0.7';

/**
 * default settings
 * @namespace
 */
Hammer.defaults = {
    /**
     * set if DOM events are being triggered.
     * But this is slower and unused by simple implementations, so disabled by default.
     * @type {Boolean}
     * @default false
     */
    domEvents: false,

    /**
     * The value for the touchAction property/fallback.
     * When set to `compute` it will magically set the correct value based on the added recognizers.
     * @type {String}
     * @default compute
     */
    touchAction: TOUCH_ACTION_COMPUTE,

    /**
     * @type {Boolean}
     * @default true
     */
    enable: true,

    /**
     * EXPERIMENTAL FEATURE -- can be removed/changed
     * Change the parent input target element.
     * If Null, then it is being set the to main element.
     * @type {Null|EventTarget}
     * @default null
     */
    inputTarget: null,

    /**
     * force an input class
     * @type {Null|Function}
     * @default null
     */
    inputClass: null,

    /**
     * Default recognizer setup when calling `Hammer()`
     * When creating a new Manager these will be skipped.
     * @type {Array}
     */
    preset: [
        // RecognizerClass, options, [recognizeWith, ...], [requireFailure, ...]
        [RotateRecognizer, {enable: false}],
        [PinchRecognizer, {enable: false}, ['rotate']],
        [SwipeRecognizer, {direction: DIRECTION_HORIZONTAL}],
        [PanRecognizer, {direction: DIRECTION_HORIZONTAL}, ['swipe']],
        [TapRecognizer],
        [TapRecognizer, {event: 'doubletap', taps: 2}, ['tap']],
        [PressRecognizer]
    ],

    /**
     * Some CSS properties can be used to improve the working of Hammer.
     * Add them to this method and they will be set when creating a new Manager.
     * @namespace
     */
    cssProps: {
        /**
         * Disables text selection to improve the dragging gesture. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userSelect: 'none',

        /**
         * Disable the Windows Phone grippers when pressing an element.
         * @type {String}
         * @default 'none'
         */
        touchSelect: 'none',

        /**
         * Disables the default callout shown when you touch and hold a touch target.
         * On iOS, when you touch and hold a touch target such as a link, Safari displays
         * a callout containing information about the link. This property allows you to disable that callout.
         * @type {String}
         * @default 'none'
         */
        touchCallout: 'none',

        /**
         * Specifies whether zooming is enabled. Used by IE10>
         * @type {String}
         * @default 'none'
         */
        contentZooming: 'none',

        /**
         * Specifies that an entire element should be draggable instead of its contents. Mainly for desktop browsers.
         * @type {String}
         * @default 'none'
         */
        userDrag: 'none',

        /**
         * Overrides the highlight color shown when the user taps a link or a JavaScript
         * clickable element in iOS. This property obeys the alpha value, if specified.
         * @type {String}
         * @default 'rgba(0,0,0,0)'
         */
        tapHighlightColor: 'rgba(0,0,0,0)'
    }
};

var STOP = 1;
var FORCED_STOP = 2;

/**
 * Manager
 * @param {HTMLElement} element
 * @param {Object} [options]
 * @constructor
 */
function Manager(element, options) {
    this.options = assign({}, Hammer.defaults, options || {});

    this.options.inputTarget = this.options.inputTarget || element;

    this.handlers = {};
    this.session = {};
    this.recognizers = [];
    this.oldCssProps = {};

    this.element = element;
    this.input = createInputInstance(this);
    this.touchAction = new TouchAction(this, this.options.touchAction);

    toggleCssProps(this, true);

    each(this.options.recognizers, function(item) {
        var recognizer = this.add(new (item[0])(item[1]));
        item[2] && recognizer.recognizeWith(item[2]);
        item[3] && recognizer.requireFailure(item[3]);
    }, this);
}

Manager.prototype = {
    /**
     * set options
     * @param {Object} options
     * @returns {Manager}
     */
    set: function(options) {
        assign(this.options, options);

        // Options that need a little more setup
        if (options.touchAction) {
            this.touchAction.update();
        }
        if (options.inputTarget) {
            // Clean up existing event listeners and reinitialize
            this.input.destroy();
            this.input.target = options.inputTarget;
            this.input.init();
        }
        return this;
    },

    /**
     * stop recognizing for this session.
     * This session will be discarded, when a new [input]start event is fired.
     * When forced, the recognizer cycle is stopped immediately.
     * @param {Boolean} [force]
     */
    stop: function(force) {
        this.session.stopped = force ? FORCED_STOP : STOP;
    },

    /**
     * run the recognizers!
     * called by the inputHandler function on every movement of the pointers (touches)
     * it walks through all the recognizers and tries to detect the gesture that is being made
     * @param {Object} inputData
     */
    recognize: function(inputData) {
        var session = this.session;
        if (session.stopped) {
            return;
        }

        // run the touch-action polyfill
        this.touchAction.preventDefaults(inputData);

        var recognizer;
        var recognizers = this.recognizers;

        // this holds the recognizer that is being recognized.
        // so the recognizer's state needs to be BEGAN, CHANGED, ENDED or RECOGNIZED
        // if no recognizer is detecting a thing, it is set to `null`
        var curRecognizer = session.curRecognizer;

        // reset when the last recognizer is recognized
        // or when we're in a new session
        if (!curRecognizer || (curRecognizer && curRecognizer.state & STATE_RECOGNIZED)) {
            curRecognizer = session.curRecognizer = null;
        }

        var i = 0;
        while (i < recognizers.length) {
            recognizer = recognizers[i];

            // find out if we are allowed try to recognize the input for this one.
            // 1.   allow if the session is NOT forced stopped (see the .stop() method)
            // 2.   allow if we still haven't recognized a gesture in this session, or the this recognizer is the one
            //      that is being recognized.
            // 3.   allow if the recognizer is allowed to run simultaneous with the current recognized recognizer.
            //      this can be setup with the `recognizeWith()` method on the recognizer.
            if (session.stopped !== FORCED_STOP && ( // 1
                    !curRecognizer || recognizer == curRecognizer || // 2
                    recognizer.canRecognizeWith(curRecognizer))) { // 3
                recognizer.recognize(inputData);
            } else {
                recognizer.reset();
            }

            // if the recognizer has been recognizing the input as a valid gesture, we want to store this one as the
            // current active recognizer. but only if we don't already have an active recognizer
            if (!curRecognizer && recognizer.state & (STATE_BEGAN | STATE_CHANGED | STATE_ENDED)) {
                curRecognizer = session.curRecognizer = recognizer;
            }
            i++;
        }
    },

    /**
     * get a recognizer by its event name.
     * @param {Recognizer|String} recognizer
     * @returns {Recognizer|Null}
     */
    get: function(recognizer) {
        if (recognizer instanceof Recognizer) {
            return recognizer;
        }

        var recognizers = this.recognizers;
        for (var i = 0; i < recognizers.length; i++) {
            if (recognizers[i].options.event == recognizer) {
                return recognizers[i];
            }
        }
        return null;
    },

    /**
     * add a recognizer to the manager
     * existing recognizers with the same event name will be removed
     * @param {Recognizer} recognizer
     * @returns {Recognizer|Manager}
     */
    add: function(recognizer) {
        if (invokeArrayArg(recognizer, 'add', this)) {
            return this;
        }

        // remove existing
        var existing = this.get(recognizer.options.event);
        if (existing) {
            this.remove(existing);
        }

        this.recognizers.push(recognizer);
        recognizer.manager = this;

        this.touchAction.update();
        return recognizer;
    },

    /**
     * remove a recognizer by name or instance
     * @param {Recognizer|String} recognizer
     * @returns {Manager}
     */
    remove: function(recognizer) {
        if (invokeArrayArg(recognizer, 'remove', this)) {
            return this;
        }

        recognizer = this.get(recognizer);

        // let's make sure this recognizer exists
        if (recognizer) {
            var recognizers = this.recognizers;
            var index = inArray(recognizers, recognizer);

            if (index !== -1) {
                recognizers.splice(index, 1);
                this.touchAction.update();
            }
        }

        return this;
    },

    /**
     * bind event
     * @param {String} events
     * @param {Function} handler
     * @returns {EventEmitter} this
     */
    on: function(events, handler) {
        if (events === undefined) {
            return;
        }
        if (handler === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            handlers[event] = handlers[event] || [];
            handlers[event].push(handler);
        });
        return this;
    },

    /**
     * unbind event, leave emit blank to remove all handlers
     * @param {String} events
     * @param {Function} [handler]
     * @returns {EventEmitter} this
     */
    off: function(events, handler) {
        if (events === undefined) {
            return;
        }

        var handlers = this.handlers;
        each(splitStr(events), function(event) {
            if (!handler) {
                delete handlers[event];
            } else {
                handlers[event] && handlers[event].splice(inArray(handlers[event], handler), 1);
            }
        });
        return this;
    },

    /**
     * emit event to the listeners
     * @param {String} event
     * @param {Object} data
     */
    emit: function(event, data) {
        // we also want to trigger dom events
        if (this.options.domEvents) {
            triggerDomEvent(event, data);
        }

        // no handlers, so skip it all
        var handlers = this.handlers[event] && this.handlers[event].slice();
        if (!handlers || !handlers.length) {
            return;
        }

        data.type = event;
        data.preventDefault = function() {
            data.srcEvent.preventDefault();
        };

        var i = 0;
        while (i < handlers.length) {
            handlers[i](data);
            i++;
        }
    },

    /**
     * destroy the manager and unbinds all events
     * it doesn't unbind dom events, that is the user own responsibility
     */
    destroy: function() {
        this.element && toggleCssProps(this, false);

        this.handlers = {};
        this.session = {};
        this.input.destroy();
        this.element = null;
    }
};

/**
 * add/remove the css properties as defined in manager.options.cssProps
 * @param {Manager} manager
 * @param {Boolean} add
 */
function toggleCssProps(manager, add) {
    var element = manager.element;
    if (!element.style) {
        return;
    }
    var prop;
    each(manager.options.cssProps, function(value, name) {
        prop = prefixed(element.style, name);
        if (add) {
            manager.oldCssProps[prop] = element.style[prop];
            element.style[prop] = value;
        } else {
            element.style[prop] = manager.oldCssProps[prop] || '';
        }
    });
    if (!add) {
        manager.oldCssProps = {};
    }
}

/**
 * trigger dom event
 * @param {String} event
 * @param {Object} data
 */
function triggerDomEvent(event, data) {
    var gestureEvent = document.createEvent('Event');
    gestureEvent.initEvent(event, true, true);
    gestureEvent.gesture = data;
    data.target.dispatchEvent(gestureEvent);
}

assign(Hammer, {
    INPUT_START: INPUT_START,
    INPUT_MOVE: INPUT_MOVE,
    INPUT_END: INPUT_END,
    INPUT_CANCEL: INPUT_CANCEL,

    STATE_POSSIBLE: STATE_POSSIBLE,
    STATE_BEGAN: STATE_BEGAN,
    STATE_CHANGED: STATE_CHANGED,
    STATE_ENDED: STATE_ENDED,
    STATE_RECOGNIZED: STATE_RECOGNIZED,
    STATE_CANCELLED: STATE_CANCELLED,
    STATE_FAILED: STATE_FAILED,

    DIRECTION_NONE: DIRECTION_NONE,
    DIRECTION_LEFT: DIRECTION_LEFT,
    DIRECTION_RIGHT: DIRECTION_RIGHT,
    DIRECTION_UP: DIRECTION_UP,
    DIRECTION_DOWN: DIRECTION_DOWN,
    DIRECTION_HORIZONTAL: DIRECTION_HORIZONTAL,
    DIRECTION_VERTICAL: DIRECTION_VERTICAL,
    DIRECTION_ALL: DIRECTION_ALL,

    Manager: Manager,
    Input: Input,
    TouchAction: TouchAction,

    TouchInput: TouchInput,
    MouseInput: MouseInput,
    PointerEventInput: PointerEventInput,
    TouchMouseInput: TouchMouseInput,
    SingleTouchInput: SingleTouchInput,

    Recognizer: Recognizer,
    AttrRecognizer: AttrRecognizer,
    Tap: TapRecognizer,
    Pan: PanRecognizer,
    Swipe: SwipeRecognizer,
    Pinch: PinchRecognizer,
    Rotate: RotateRecognizer,
    Press: PressRecognizer,

    on: addEventListeners,
    off: removeEventListeners,
    each: each,
    merge: merge,
    extend: extend,
    assign: assign,
    inherit: inherit,
    bindFn: bindFn,
    prefixed: prefixed
});

// this prevents errors when Hammer is loaded in the presence of an AMD
//  style loader but by script tag, not by the loader.
var freeGlobal = (typeof window !== 'undefined' ? window : (typeof self !== 'undefined' ? self : {})); // jshint ignore:line
freeGlobal.Hammer = Hammer;

if (true) {
    !(__WEBPACK_AMD_DEFINE_RESULT__ = (function() {
        return Hammer;
    }).call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
} else if (typeof module != 'undefined' && module.exports) {
    module.exports = Hammer;
} else {
    window[exportName] = Hammer;
}

})(window, document, 'Hammer');


/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Url */
/* unused harmony export Http */
/* unused harmony export Resource */
/*!
 * vue-resource v1.5.1
 * https://github.com/pagekit/vue-resource
 * Released under the MIT License.
 */

/**
 * Promises/A+ polyfill v1.1.4 (https://github.com/bramstein/promis)
 */

var RESOLVED = 0;
var REJECTED = 1;
var PENDING = 2;

function Promise$1(executor) {

    this.state = PENDING;
    this.value = undefined;
    this.deferred = [];

    var promise = this;

    try {
        executor(function (x) {
            promise.resolve(x);
        }, function (r) {
            promise.reject(r);
        });
    } catch (e) {
        promise.reject(e);
    }
}

Promise$1.reject = function (r) {
    return new Promise$1(function (resolve, reject) {
        reject(r);
    });
};

Promise$1.resolve = function (x) {
    return new Promise$1(function (resolve, reject) {
        resolve(x);
    });
};

Promise$1.all = function all(iterable) {
    return new Promise$1(function (resolve, reject) {
        var count = 0, result = [];

        if (iterable.length === 0) {
            resolve(result);
        }

        function resolver(i) {
            return function (x) {
                result[i] = x;
                count += 1;

                if (count === iterable.length) {
                    resolve(result);
                }
            };
        }

        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolver(i), reject);
        }
    });
};

Promise$1.race = function race(iterable) {
    return new Promise$1(function (resolve, reject) {
        for (var i = 0; i < iterable.length; i += 1) {
            Promise$1.resolve(iterable[i]).then(resolve, reject);
        }
    });
};

var p = Promise$1.prototype;

p.resolve = function resolve(x) {
    var promise = this;

    if (promise.state === PENDING) {
        if (x === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        var called = false;

        try {
            var then = x && x['then'];

            if (x !== null && typeof x === 'object' && typeof then === 'function') {
                then.call(x, function (x) {
                    if (!called) {
                        promise.resolve(x);
                    }
                    called = true;

                }, function (r) {
                    if (!called) {
                        promise.reject(r);
                    }
                    called = true;
                });
                return;
            }
        } catch (e) {
            if (!called) {
                promise.reject(e);
            }
            return;
        }

        promise.state = RESOLVED;
        promise.value = x;
        promise.notify();
    }
};

p.reject = function reject(reason) {
    var promise = this;

    if (promise.state === PENDING) {
        if (reason === promise) {
            throw new TypeError('Promise settled with itself.');
        }

        promise.state = REJECTED;
        promise.value = reason;
        promise.notify();
    }
};

p.notify = function notify() {
    var promise = this;

    nextTick(function () {
        if (promise.state !== PENDING) {
            while (promise.deferred.length) {
                var deferred = promise.deferred.shift(),
                    onResolved = deferred[0],
                    onRejected = deferred[1],
                    resolve = deferred[2],
                    reject = deferred[3];

                try {
                    if (promise.state === RESOLVED) {
                        if (typeof onResolved === 'function') {
                            resolve(onResolved.call(undefined, promise.value));
                        } else {
                            resolve(promise.value);
                        }
                    } else if (promise.state === REJECTED) {
                        if (typeof onRejected === 'function') {
                            resolve(onRejected.call(undefined, promise.value));
                        } else {
                            reject(promise.value);
                        }
                    }
                } catch (e) {
                    reject(e);
                }
            }
        }
    });
};

p.then = function then(onResolved, onRejected) {
    var promise = this;

    return new Promise$1(function (resolve, reject) {
        promise.deferred.push([onResolved, onRejected, resolve, reject]);
        promise.notify();
    });
};

p.catch = function (onRejected) {
    return this.then(undefined, onRejected);
};

/**
 * Promise adapter.
 */

if (typeof Promise === 'undefined') {
    window.Promise = Promise$1;
}

function PromiseObj(executor, context) {

    if (executor instanceof Promise) {
        this.promise = executor;
    } else {
        this.promise = new Promise(executor.bind(context));
    }

    this.context = context;
}

PromiseObj.all = function (iterable, context) {
    return new PromiseObj(Promise.all(iterable), context);
};

PromiseObj.resolve = function (value, context) {
    return new PromiseObj(Promise.resolve(value), context);
};

PromiseObj.reject = function (reason, context) {
    return new PromiseObj(Promise.reject(reason), context);
};

PromiseObj.race = function (iterable, context) {
    return new PromiseObj(Promise.race(iterable), context);
};

var p$1 = PromiseObj.prototype;

p$1.bind = function (context) {
    this.context = context;
    return this;
};

p$1.then = function (fulfilled, rejected) {

    if (fulfilled && fulfilled.bind && this.context) {
        fulfilled = fulfilled.bind(this.context);
    }

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.then(fulfilled, rejected), this.context);
};

p$1.catch = function (rejected) {

    if (rejected && rejected.bind && this.context) {
        rejected = rejected.bind(this.context);
    }

    return new PromiseObj(this.promise.catch(rejected), this.context);
};

p$1.finally = function (callback) {

    return this.then(function (value) {
        callback.call(this);
        return value;
    }, function (reason) {
        callback.call(this);
        return Promise.reject(reason);
    }
    );
};

/**
 * Utility functions.
 */

var ref = {};
var hasOwnProperty = ref.hasOwnProperty;
var ref$1 = [];
var slice = ref$1.slice;
var debug = false, ntick;

var inBrowser = typeof window !== 'undefined';

function Util (ref) {
    var config = ref.config;
    var nextTick = ref.nextTick;

    ntick = nextTick;
    debug = config.debug || !config.silent;
}

function warn(msg) {
    if (typeof console !== 'undefined' && debug) {
        console.warn('[VueResource warn]: ' + msg);
    }
}

function error(msg) {
    if (typeof console !== 'undefined') {
        console.error(msg);
    }
}

function nextTick(cb, ctx) {
    return ntick(cb, ctx);
}

function trim(str) {
    return str ? str.replace(/^\s*|\s*$/g, '') : '';
}

function trimEnd(str, chars) {

    if (str && chars === undefined) {
        return str.replace(/\s+$/, '');
    }

    if (!str || !chars) {
        return str;
    }

    return str.replace(new RegExp(("[" + chars + "]+$")), '');
}

function toLower(str) {
    return str ? str.toLowerCase() : '';
}

function toUpper(str) {
    return str ? str.toUpperCase() : '';
}

var isArray = Array.isArray;

function isString(val) {
    return typeof val === 'string';
}

function isFunction(val) {
    return typeof val === 'function';
}

function isObject(obj) {
    return obj !== null && typeof obj === 'object';
}

function isPlainObject(obj) {
    return isObject(obj) && Object.getPrototypeOf(obj) == Object.prototype;
}

function isBlob(obj) {
    return typeof Blob !== 'undefined' && obj instanceof Blob;
}

function isFormData(obj) {
    return typeof FormData !== 'undefined' && obj instanceof FormData;
}

function when(value, fulfilled, rejected) {

    var promise = PromiseObj.resolve(value);

    if (arguments.length < 2) {
        return promise;
    }

    return promise.then(fulfilled, rejected);
}

function options(fn, obj, opts) {

    opts = opts || {};

    if (isFunction(opts)) {
        opts = opts.call(obj);
    }

    return merge(fn.bind({$vm: obj, $options: opts}), fn, {$options: opts});
}

function each(obj, iterator) {

    var i, key;

    if (isArray(obj)) {
        for (i = 0; i < obj.length; i++) {
            iterator.call(obj[i], obj[i], i);
        }
    } else if (isObject(obj)) {
        for (key in obj) {
            if (hasOwnProperty.call(obj, key)) {
                iterator.call(obj[key], obj[key], key);
            }
        }
    }

    return obj;
}

var assign = Object.assign || _assign;

function merge(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source, true);
    });

    return target;
}

function defaults(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {

        for (var key in source) {
            if (target[key] === undefined) {
                target[key] = source[key];
            }
        }

    });

    return target;
}

function _assign(target) {

    var args = slice.call(arguments, 1);

    args.forEach(function (source) {
        _merge(target, source);
    });

    return target;
}

function _merge(target, source, deep) {
    for (var key in source) {
        if (deep && (isPlainObject(source[key]) || isArray(source[key]))) {
            if (isPlainObject(source[key]) && !isPlainObject(target[key])) {
                target[key] = {};
            }
            if (isArray(source[key]) && !isArray(target[key])) {
                target[key] = [];
            }
            _merge(target[key], source[key], deep);
        } else if (source[key] !== undefined) {
            target[key] = source[key];
        }
    }
}

/**
 * Root Prefix Transform.
 */

function root (options$$1, next) {

    var url = next(options$$1);

    if (isString(options$$1.root) && !/^(https?:)?\//.test(url)) {
        url = trimEnd(options$$1.root, '/') + '/' + url;
    }

    return url;
}

/**
 * Query Parameter Transform.
 */

function query (options$$1, next) {

    var urlParams = Object.keys(Url.options.params), query = {}, url = next(options$$1);

    each(options$$1.params, function (value, key) {
        if (urlParams.indexOf(key) === -1) {
            query[key] = value;
        }
    });

    query = Url.params(query);

    if (query) {
        url += (url.indexOf('?') == -1 ? '?' : '&') + query;
    }

    return url;
}

/**
 * URL Template v2.0.6 (https://github.com/bramstein/url-template)
 */

function expand(url, params, variables) {

    var tmpl = parse(url), expanded = tmpl.expand(params);

    if (variables) {
        variables.push.apply(variables, tmpl.vars);
    }

    return expanded;
}

function parse(template) {

    var operators = ['+', '#', '.', '/', ';', '?', '&'], variables = [];

    return {
        vars: variables,
        expand: function expand(context) {
            return template.replace(/\{([^{}]+)\}|([^{}]+)/g, function (_, expression, literal) {
                if (expression) {

                    var operator = null, values = [];

                    if (operators.indexOf(expression.charAt(0)) !== -1) {
                        operator = expression.charAt(0);
                        expression = expression.substr(1);
                    }

                    expression.split(/,/g).forEach(function (variable) {
                        var tmp = /([^:*]*)(?::(\d+)|(\*))?/.exec(variable);
                        values.push.apply(values, getValues(context, operator, tmp[1], tmp[2] || tmp[3]));
                        variables.push(tmp[1]);
                    });

                    if (operator && operator !== '+') {

                        var separator = ',';

                        if (operator === '?') {
                            separator = '&';
                        } else if (operator !== '#') {
                            separator = operator;
                        }

                        return (values.length !== 0 ? operator : '') + values.join(separator);
                    } else {
                        return values.join(',');
                    }

                } else {
                    return encodeReserved(literal);
                }
            });
        }
    };
}

function getValues(context, operator, key, modifier) {

    var value = context[key], result = [];

    if (isDefined(value) && value !== '') {
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') {
            value = value.toString();

            if (modifier && modifier !== '*') {
                value = value.substring(0, parseInt(modifier, 10));
            }

            result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
        } else {
            if (modifier === '*') {
                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        result.push(encodeValue(operator, value, isKeyOperator(operator) ? key : null));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            result.push(encodeValue(operator, value[k], k));
                        }
                    });
                }
            } else {
                var tmp = [];

                if (Array.isArray(value)) {
                    value.filter(isDefined).forEach(function (value) {
                        tmp.push(encodeValue(operator, value));
                    });
                } else {
                    Object.keys(value).forEach(function (k) {
                        if (isDefined(value[k])) {
                            tmp.push(encodeURIComponent(k));
                            tmp.push(encodeValue(operator, value[k].toString()));
                        }
                    });
                }

                if (isKeyOperator(operator)) {
                    result.push(encodeURIComponent(key) + '=' + tmp.join(','));
                } else if (tmp.length !== 0) {
                    result.push(tmp.join(','));
                }
            }
        }
    } else {
        if (operator === ';') {
            result.push(encodeURIComponent(key));
        } else if (value === '' && (operator === '&' || operator === '?')) {
            result.push(encodeURIComponent(key) + '=');
        } else if (value === '') {
            result.push('');
        }
    }

    return result;
}

function isDefined(value) {
    return value !== undefined && value !== null;
}

function isKeyOperator(operator) {
    return operator === ';' || operator === '&' || operator === '?';
}

function encodeValue(operator, value, key) {

    value = (operator === '+' || operator === '#') ? encodeReserved(value) : encodeURIComponent(value);

    if (key) {
        return encodeURIComponent(key) + '=' + value;
    } else {
        return value;
    }
}

function encodeReserved(str) {
    return str.split(/(%[0-9A-Fa-f]{2})/g).map(function (part) {
        if (!/%[0-9A-Fa-f]/.test(part)) {
            part = encodeURI(part);
        }
        return part;
    }).join('');
}

/**
 * URL Template (RFC 6570) Transform.
 */

function template (options) {

    var variables = [], url = expand(options.url, options.params, variables);

    variables.forEach(function (key) {
        delete options.params[key];
    });

    return url;
}

/**
 * Service for URL templating.
 */

function Url(url, params) {

    var self = this || {}, options$$1 = url, transform;

    if (isString(url)) {
        options$$1 = {url: url, params: params};
    }

    options$$1 = merge({}, Url.options, self.$options, options$$1);

    Url.transforms.forEach(function (handler) {

        if (isString(handler)) {
            handler = Url.transform[handler];
        }

        if (isFunction(handler)) {
            transform = factory(handler, transform, self.$vm);
        }

    });

    return transform(options$$1);
}

/**
 * Url options.
 */

Url.options = {
    url: '',
    root: null,
    params: {}
};

/**
 * Url transforms.
 */

Url.transform = {template: template, query: query, root: root};
Url.transforms = ['template', 'query', 'root'];

/**
 * Encodes a Url parameter string.
 *
 * @param {Object} obj
 */

Url.params = function (obj) {

    var params = [], escape = encodeURIComponent;

    params.add = function (key, value) {

        if (isFunction(value)) {
            value = value();
        }

        if (value === null) {
            value = '';
        }

        this.push(escape(key) + '=' + escape(value));
    };

    serialize(params, obj);

    return params.join('&').replace(/%20/g, '+');
};

/**
 * Parse a URL and return its components.
 *
 * @param {String} url
 */

Url.parse = function (url) {

    var el = document.createElement('a');

    if (document.documentMode) {
        el.href = url;
        url = el.href;
    }

    el.href = url;

    return {
        href: el.href,
        protocol: el.protocol ? el.protocol.replace(/:$/, '') : '',
        port: el.port,
        host: el.host,
        hostname: el.hostname,
        pathname: el.pathname.charAt(0) === '/' ? el.pathname : '/' + el.pathname,
        search: el.search ? el.search.replace(/^\?/, '') : '',
        hash: el.hash ? el.hash.replace(/^#/, '') : ''
    };
};

function factory(handler, next, vm) {
    return function (options$$1) {
        return handler.call(vm, options$$1, next);
    };
}

function serialize(params, obj, scope) {

    var array = isArray(obj), plain = isPlainObject(obj), hash;

    each(obj, function (value, key) {

        hash = isObject(value) || isArray(value);

        if (scope) {
            key = scope + '[' + (plain || hash ? key : '') + ']';
        }

        if (!scope && array) {
            params.add(value.name, value.value);
        } else if (hash) {
            serialize(params, value, key);
        } else {
            params.add(key, value);
        }
    });
}

/**
 * XDomain client (Internet Explorer).
 */

function xdrClient (request) {
    return new PromiseObj(function (resolve) {

        var xdr = new XDomainRequest(), handler = function (ref) {
                var type = ref.type;


                var status = 0;

                if (type === 'load') {
                    status = 200;
                } else if (type === 'error') {
                    status = 500;
                }

                resolve(request.respondWith(xdr.responseText, {status: status}));
            };

        request.abort = function () { return xdr.abort(); };

        xdr.open(request.method, request.getUrl());

        if (request.timeout) {
            xdr.timeout = request.timeout;
        }

        xdr.onload = handler;
        xdr.onabort = handler;
        xdr.onerror = handler;
        xdr.ontimeout = handler;
        xdr.onprogress = function () {};
        xdr.send(request.getBody());
    });
}

/**
 * CORS Interceptor.
 */

var SUPPORTS_CORS = inBrowser && 'withCredentials' in new XMLHttpRequest();

function cors (request) {

    if (inBrowser) {

        var orgUrl = Url.parse(location.href);
        var reqUrl = Url.parse(request.getUrl());

        if (reqUrl.protocol !== orgUrl.protocol || reqUrl.host !== orgUrl.host) {

            request.crossOrigin = true;
            request.emulateHTTP = false;

            if (!SUPPORTS_CORS) {
                request.client = xdrClient;
            }
        }
    }

}

/**
 * Form data Interceptor.
 */

function form (request) {

    if (isFormData(request.body)) {
        request.headers.delete('Content-Type');
    } else if (isObject(request.body) && request.emulateJSON) {
        request.body = Url.params(request.body);
        request.headers.set('Content-Type', 'application/x-www-form-urlencoded');
    }

}

/**
 * JSON Interceptor.
 */

function json (request) {

    var type = request.headers.get('Content-Type') || '';

    if (isObject(request.body) && type.indexOf('application/json') === 0) {
        request.body = JSON.stringify(request.body);
    }

    return function (response) {

        return response.bodyText ? when(response.text(), function (text) {

            var type = response.headers.get('Content-Type') || '';

            if (type.indexOf('application/json') === 0 || isJson(text)) {

                try {
                    response.body = JSON.parse(text);
                } catch (e) {
                    response.body = null;
                }

            } else {
                response.body = text;
            }

            return response;

        }) : response;

    };
}

function isJson(str) {

    var start = str.match(/^\s*(\[|\{)/);
    var end = {'[': /]\s*$/, '{': /}\s*$/};

    return start && end[start[1]].test(str);
}

/**
 * JSONP client (Browser).
 */

function jsonpClient (request) {
    return new PromiseObj(function (resolve) {

        var name = request.jsonp || 'callback', callback = request.jsonpCallback || '_jsonp' + Math.random().toString(36).substr(2), body = null, handler, script;

        handler = function (ref) {
            var type = ref.type;


            var status = 0;

            if (type === 'load' && body !== null) {
                status = 200;
            } else if (type === 'error') {
                status = 500;
            }

            if (status && window[callback]) {
                delete window[callback];
                document.body.removeChild(script);
            }

            resolve(request.respondWith(body, {status: status}));
        };

        window[callback] = function (result) {
            body = JSON.stringify(result);
        };

        request.abort = function () {
            handler({type: 'abort'});
        };

        request.params[name] = callback;

        if (request.timeout) {
            setTimeout(request.abort, request.timeout);
        }

        script = document.createElement('script');
        script.src = request.getUrl();
        script.type = 'text/javascript';
        script.async = true;
        script.onload = handler;
        script.onerror = handler;

        document.body.appendChild(script);
    });
}

/**
 * JSONP Interceptor.
 */

function jsonp (request) {

    if (request.method == 'JSONP') {
        request.client = jsonpClient;
    }

}

/**
 * Before Interceptor.
 */

function before (request) {

    if (isFunction(request.before)) {
        request.before.call(this, request);
    }

}

/**
 * HTTP method override Interceptor.
 */

function method (request) {

    if (request.emulateHTTP && /^(PUT|PATCH|DELETE)$/i.test(request.method)) {
        request.headers.set('X-HTTP-Method-Override', request.method);
        request.method = 'POST';
    }

}

/**
 * Header Interceptor.
 */

function header (request) {

    var headers = assign({}, Http.headers.common,
        !request.crossOrigin ? Http.headers.custom : {},
        Http.headers[toLower(request.method)]
    );

    each(headers, function (value, name) {
        if (!request.headers.has(name)) {
            request.headers.set(name, value);
        }
    });

}

/**
 * XMLHttp client (Browser).
 */

function xhrClient (request) {
    return new PromiseObj(function (resolve) {

        var xhr = new XMLHttpRequest(), handler = function (event) {

                var response = request.respondWith(
                'response' in xhr ? xhr.response : xhr.responseText, {
                    status: xhr.status === 1223 ? 204 : xhr.status, // IE9 status bug
                    statusText: xhr.status === 1223 ? 'No Content' : trim(xhr.statusText)
                });

                each(trim(xhr.getAllResponseHeaders()).split('\n'), function (row) {
                    response.headers.append(row.slice(0, row.indexOf(':')), row.slice(row.indexOf(':') + 1));
                });

                resolve(response);
            };

        request.abort = function () { return xhr.abort(); };

        xhr.open(request.method, request.getUrl(), true);

        if (request.timeout) {
            xhr.timeout = request.timeout;
        }

        if (request.responseType && 'responseType' in xhr) {
            xhr.responseType = request.responseType;
        }

        if (request.withCredentials || request.credentials) {
            xhr.withCredentials = true;
        }

        if (!request.crossOrigin) {
            request.headers.set('X-Requested-With', 'XMLHttpRequest');
        }

        // deprecated use downloadProgress
        if (isFunction(request.progress) && request.method === 'GET') {
            xhr.addEventListener('progress', request.progress);
        }

        if (isFunction(request.downloadProgress)) {
            xhr.addEventListener('progress', request.downloadProgress);
        }

        // deprecated use uploadProgress
        if (isFunction(request.progress) && /^(POST|PUT)$/i.test(request.method)) {
            xhr.upload.addEventListener('progress', request.progress);
        }

        if (isFunction(request.uploadProgress) && xhr.upload) {
            xhr.upload.addEventListener('progress', request.uploadProgress);
        }

        request.headers.forEach(function (value, name) {
            xhr.setRequestHeader(name, value);
        });

        xhr.onload = handler;
        xhr.onabort = handler;
        xhr.onerror = handler;
        xhr.ontimeout = handler;
        xhr.send(request.getBody());
    });
}

/**
 * Http client (Node).
 */

function nodeClient (request) {

    var client = __webpack_require__(165);

    return new PromiseObj(function (resolve) {

        var url = request.getUrl();
        var body = request.getBody();
        var method = request.method;
        var headers = {}, handler;

        request.headers.forEach(function (value, name) {
            headers[name] = value;
        });

        client(url, {body: body, method: method, headers: headers}).then(handler = function (resp) {

            var response = request.respondWith(resp.body, {
                status: resp.statusCode,
                statusText: trim(resp.statusMessage)
            });

            each(resp.headers, function (value, name) {
                response.headers.set(name, value);
            });

            resolve(response);

        }, function (error$$1) { return handler(error$$1.response); });
    });
}

/**
 * Base client.
 */

function Client (context) {

    var reqHandlers = [sendRequest], resHandlers = [];

    if (!isObject(context)) {
        context = null;
    }

    function Client(request) {
        while (reqHandlers.length) {

            var handler = reqHandlers.pop();

            if (isFunction(handler)) {

                var response = (void 0), next = (void 0);

                response = handler.call(context, request, function (val) { return next = val; }) || next;

                if (isObject(response)) {
                    return new PromiseObj(function (resolve, reject) {

                        resHandlers.forEach(function (handler) {
                            response = when(response, function (response) {
                                return handler.call(context, response) || response;
                            }, reject);
                        });

                        when(response, resolve, reject);

                    }, context);
                }

                if (isFunction(response)) {
                    resHandlers.unshift(response);
                }

            } else {
                warn(("Invalid interceptor of type " + (typeof handler) + ", must be a function"));
            }
        }
    }

    Client.use = function (handler) {
        reqHandlers.push(handler);
    };

    return Client;
}

function sendRequest(request) {

    var client = request.client || (inBrowser ? xhrClient : nodeClient);

    return client(request);
}

/**
 * HTTP Headers.
 */

var Headers = function Headers(headers) {
    var this$1 = this;


    this.map = {};

    each(headers, function (value, name) { return this$1.append(name, value); });
};

Headers.prototype.has = function has (name) {
    return getName(this.map, name) !== null;
};

Headers.prototype.get = function get (name) {

    var list = this.map[getName(this.map, name)];

    return list ? list.join() : null;
};

Headers.prototype.getAll = function getAll (name) {
    return this.map[getName(this.map, name)] || [];
};

Headers.prototype.set = function set (name, value) {
    this.map[normalizeName(getName(this.map, name) || name)] = [trim(value)];
};

Headers.prototype.append = function append (name, value) {

    var list = this.map[getName(this.map, name)];

    if (list) {
        list.push(trim(value));
    } else {
        this.set(name, value);
    }
};

Headers.prototype.delete = function delete$1 (name) {
    delete this.map[getName(this.map, name)];
};

Headers.prototype.deleteAll = function deleteAll () {
    this.map = {};
};

Headers.prototype.forEach = function forEach (callback, thisArg) {
        var this$1 = this;

    each(this.map, function (list, name) {
        each(list, function (value) { return callback.call(thisArg, value, name, this$1); });
    });
};

function getName(map, name) {
    return Object.keys(map).reduce(function (prev, curr) {
        return toLower(name) === toLower(curr) ? curr : prev;
    }, null);
}

function normalizeName(name) {

    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
        throw new TypeError('Invalid character in header field name');
    }

    return trim(name);
}

/**
 * HTTP Response.
 */

var Response = function Response(body, ref) {
    var url = ref.url;
    var headers = ref.headers;
    var status = ref.status;
    var statusText = ref.statusText;


    this.url = url;
    this.ok = status >= 200 && status < 300;
    this.status = status || 0;
    this.statusText = statusText || '';
    this.headers = new Headers(headers);
    this.body = body;

    if (isString(body)) {

        this.bodyText = body;

    } else if (isBlob(body)) {

        this.bodyBlob = body;

        if (isBlobText(body)) {
            this.bodyText = blobText(body);
        }
    }
};

Response.prototype.blob = function blob () {
    return when(this.bodyBlob);
};

Response.prototype.text = function text () {
    return when(this.bodyText);
};

Response.prototype.json = function json () {
    return when(this.text(), function (text) { return JSON.parse(text); });
};

Object.defineProperty(Response.prototype, 'data', {

    get: function get() {
        return this.body;
    },

    set: function set(body) {
        this.body = body;
    }

});

function blobText(body) {
    return new PromiseObj(function (resolve) {

        var reader = new FileReader();

        reader.readAsText(body);
        reader.onload = function () {
            resolve(reader.result);
        };

    });
}

function isBlobText(body) {
    return body.type.indexOf('text') === 0 || body.type.indexOf('json') !== -1;
}

/**
 * HTTP Request.
 */

var Request = function Request(options$$1) {

    this.body = null;
    this.params = {};

    assign(this, options$$1, {
        method: toUpper(options$$1.method || 'GET')
    });

    if (!(this.headers instanceof Headers)) {
        this.headers = new Headers(this.headers);
    }
};

Request.prototype.getUrl = function getUrl () {
    return Url(this);
};

Request.prototype.getBody = function getBody () {
    return this.body;
};

Request.prototype.respondWith = function respondWith (body, options$$1) {
    return new Response(body, assign(options$$1 || {}, {url: this.getUrl()}));
};

/**
 * Service for sending network requests.
 */

var COMMON_HEADERS = {'Accept': 'application/json, text/plain, */*'};
var JSON_CONTENT_TYPE = {'Content-Type': 'application/json;charset=utf-8'};

function Http(options$$1) {

    var self = this || {}, client = Client(self.$vm);

    defaults(options$$1 || {}, self.$options, Http.options);

    Http.interceptors.forEach(function (handler) {

        if (isString(handler)) {
            handler = Http.interceptor[handler];
        }

        if (isFunction(handler)) {
            client.use(handler);
        }

    });

    return client(new Request(options$$1)).then(function (response) {

        return response.ok ? response : PromiseObj.reject(response);

    }, function (response) {

        if (response instanceof Error) {
            error(response);
        }

        return PromiseObj.reject(response);
    });
}

Http.options = {};

Http.headers = {
    put: JSON_CONTENT_TYPE,
    post: JSON_CONTENT_TYPE,
    patch: JSON_CONTENT_TYPE,
    delete: JSON_CONTENT_TYPE,
    common: COMMON_HEADERS,
    custom: {}
};

Http.interceptor = {before: before, method: method, jsonp: jsonp, json: json, form: form, header: header, cors: cors};
Http.interceptors = ['before', 'method', 'jsonp', 'json', 'form', 'header', 'cors'];

['get', 'delete', 'head', 'jsonp'].forEach(function (method$$1) {

    Http[method$$1] = function (url, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1}));
    };

});

['post', 'put', 'patch'].forEach(function (method$$1) {

    Http[method$$1] = function (url, body, options$$1) {
        return this(assign(options$$1 || {}, {url: url, method: method$$1, body: body}));
    };

});

/**
 * Service for interacting with RESTful services.
 */

function Resource(url, params, actions, options$$1) {

    var self = this || {}, resource = {};

    actions = assign({},
        Resource.actions,
        actions
    );

    each(actions, function (action, name) {

        action = merge({url: url, params: assign({}, params)}, options$$1, action);

        resource[name] = function () {
            return (self.$http || Http)(opts(action, arguments));
        };
    });

    return resource;
}

function opts(action, args) {

    var options$$1 = assign({}, action), params = {}, body;

    switch (args.length) {

        case 2:

            params = args[0];
            body = args[1];

            break;

        case 1:

            if (/^(POST|PUT|PATCH)$/i.test(options$$1.method)) {
                body = args[0];
            } else {
                params = args[0];
            }

            break;

        case 0:

            break;

        default:

            throw 'Expected up to 2 arguments [params, body], got ' + args.length + ' arguments';
    }

    options$$1.body = body;
    options$$1.params = assign({}, options$$1.params, params);

    return options$$1;
}

Resource.actions = {

    get: {method: 'GET'},
    save: {method: 'POST'},
    query: {method: 'GET'},
    update: {method: 'PUT'},
    remove: {method: 'DELETE'},
    delete: {method: 'DELETE'}

};

/**
 * Install plugin.
 */

function plugin(Vue) {

    if (plugin.installed) {
        return;
    }

    Util(Vue);

    Vue.url = Url;
    Vue.http = Http;
    Vue.resource = Resource;
    Vue.Promise = PromiseObj;

    Object.defineProperties(Vue.prototype, {

        $url: {
            get: function get() {
                return options(Vue.url, this, this.$options.url);
            }
        },

        $http: {
            get: function get() {
                return options(Vue.http, this, this.$options.http);
            }
        },

        $resource: {
            get: function get() {
                return Vue.resource.bind(this);
            }
        },

        $promise: {
            get: function get() {
                var this$1 = this;

                return function (executor) { return new Vue.Promise(executor, this$1); };
            }
        }

    });
}

if (typeof window !== 'undefined' && window.Vue) {
    window.Vue.use(plugin);
}

/* harmony default export */ __webpack_exports__["a"] = (plugin);



/***/ }),
/* 165 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 166 */
/***/ (function(module, exports, __webpack_require__) {

!function(e,n){if(true)module.exports=n();else if("function"==typeof define&&define.amd)define([],n);else{var t=n();for(var r in t)("object"==typeof exports?exports:e)[r]=t[r]}}("undefined"!=typeof self?self:this,(function(){return function(e){var n={};function t(r){if(n[r])return n[r].exports;var o=n[r]={i:r,l:!1,exports:{}};return e[r].call(o.exports,o,o.exports,t),o.l=!0,o.exports}return t.m=e,t.c=n,t.d=function(e,n,r){t.o(e,n)||Object.defineProperty(e,n,{enumerable:!0,get:r})},t.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},t.t=function(e,n){if(1&n&&(e=t(e)),8&n)return e;if(4&n&&"object"==typeof e&&e&&e.__esModule)return e;var r=Object.create(null);if(t.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:e}),2&n&&"string"!=typeof e)for(var o in e)t.d(r,o,function(n){return e[n]}.bind(null,o));return r},t.n=function(e){var n=e&&e.__esModule?function(){return e.default}:function(){return e};return t.d(n,"a",n),n},t.o=function(e,n){return Object.prototype.hasOwnProperty.call(e,n)},t.p="",t(t.s=0)}([function(e,n,t){"use strict";function r(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function o(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?r(t,!0).forEach((function(n){i(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):r(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}function i(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}t.r(n);var c={$vue:null,id:null,router:null,fields:{},customIdFields:{},ignoreRoutes:[],linkers:[],commands:{},disabled:!1,customResourceURL:null,set:[],require:[],ecommerce:{enabled:!1,options:null,enhanced:!1},autoTracking:{screenview:!1,shouldRouterUpdate:null,skipSamePath:!1,exception:!1,exceptionLogs:!0,page:!0,transformQueryString:!0,pageviewOnLoad:!0,pageviewTemplate:null,untracked:!0,prependBase:!0},debug:{enabled:!1,trace:!1,sendHitTask:!0},batch:{enabled:!1,delay:500,amount:2},checkDuplicatedScript:!1,disableScriptLoader:!1,beforeFirstHit:s,ready:s,untracked:[]},a=o({},c);function u(e){!function e(n,t){return Object.keys(t).forEach((function(r){var o=n[r]&&Object.prototype.toString.call(n[r]);"[object Object]"!==o&&"[object Array]"!==o?n[r]=t[r]:e(n[r],t[r])})),n}(a,e)}function f(){return a.id?[].concat(a.id):[]}var l=a;function s(){}var p=function(e){console.warn("[vue-analytics] ".concat(e))};function d(e,n){return new Promise((function(t,r){var o=document.head||document.getElementsByTagName("head")[0],i=document.createElement("script");if(i.async=!0,i.src=e,i.charset="utf-8",n){var c=document.createElement("link");c.href=n,c.rel="preconnect",o.appendChild(c)}o.appendChild(i),i.onload=t,i.onerror=r}))}function y(e){return e.name||e.replace(/-/gi,"")}function b(e,n){if(f().length>1){var t=y(n);return"".concat(t,".").concat(e)}return e}var m,v=function(e){if(e.then)return e;if("function"==typeof e){var n=e();return n.then?n:Promise.resolve(n)}return Promise.resolve(e)};function g(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var h=[];function w(e){for(var n=arguments.length,t=new Array(n>1?n-1:0),r=1;r<n;r++)t[r-1]=arguments[r];"undefined"!=typeof window&&f().forEach((function(n){var r,o={m:b(e,n),a:t};window.ga?l.batch.enabled?(h.push(o),m||(m=setInterval((function(){h.length?h.splice(0,l.batch.amount).forEach((function(e){var n;(n=window).ga.apply(n,[e.m].concat(g(e.a)))})):(clearInterval(m),m=null)}),l.batch.delay))):(r=window).ga.apply(r,[b(e,n)].concat(t)):l.untracked.push(o)}))}function O(e){return(O="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function j(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];"object"!==O(n[0])||n[0].constructor!==Object?w("set",n[0],n[1]):w("set",n[0])}function P(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function S(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function k(){if(window.ga||!l.debug.enabled){if(window.ga){var e=f();l.debug.enabled&&(window.ga_debug={trace:l.debug.trace}),e.forEach((function(n){var t=y(n),r=l.customIdFields[n]||{},o=e.length>1?function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?P(t,!0).forEach((function(n){S(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):P(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},l.fields,{},r,{name:t}):l.fields;window.ga("create",n.id||n,"auto",o)})),l.beforeFirstHit();var n=l.ecommerce;if(n.enabled){var t=n.enhanced?"ec":"ecommerce";n.options?w("require",t,n.options):w("require",t)}l.linkers.length>0&&(w("require","linker"),w("linker:autoLink",l.linkers)),l.debug.sendHitTask||j("sendHitTask",null)}}else p("Google Analytics has probably been blocked.")}var E=function(){2!=arguments.length?w("require",arguments.length<=0?void 0:arguments[0]):w("require",arguments.length<=0?void 0:arguments[0],arguments.length<=1?void 0:arguments[1])};function A(e){return(A="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var x=function(){var e;l.set.forEach((function(e){var n=e.field,t=e.value;if(void 0===n||void 0===t)throw new Error('[vue-analytics] Wrong configuration in the plugin options.\nThe "set" array requires each item to have a "field" and a "value" property.');j(n,t)})),e=["ec","ecommerce"],l.require.forEach((function(n){if(-1!==e.indexOf(n)||-1!==e.indexOf(n.name))throw new Error("[vue-analytics] The ecommerce features are built-in in the plugin. \nFollow the ecommerce instructions available in the documentation.");if("string"!=typeof n&&"object"!==A(n))throw new Error('[vue-analytics] Wrong configuration in the plugin options. \nThe "require" array requires each item to be a string or to have a "name" and an "options" property.');var t=n.name||n;n.options?E(t,n.options):E(t)}))};function T(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r=n[0];if(1===n.length&&"string"==typeof r)return w("send","screenview",{screenName:r});w.apply(void 0,["send","screenview"].concat(n))}function D(e){return(D="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function q(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];var r;n.length&&!n[0]||(n.length&&n[0].currentRoute&&(r=n[0].currentRoute),n.length&&function(e){return e.query&&e.params}(n[0])&&(r=n[0]),r?R(r):(j("page","object"===D(n[0])?n[0].page:n[0]),w.apply(void 0,["send","pageview"].concat(n))))}function R(e){if(![(n=e).name,n.path].filter(Boolean).find((function(e){return-1!==l.ignoreRoutes.indexOf(e)}))){var n,t=l.autoTracking,r=e.meta.analytics,o=(void 0===r?{}:r).pageviewTemplate||t.pageviewTemplate;if(t.screenview&&!e.name)throw new Error("[vue-analytics] Route name is mandatory when using screenview.");if(t.screenview)T(e.name);else if(o)q(o(e));else{var i=l.router,c=l.autoTracking,a=c.transformQueryString,u=c.prependBase,f=function(e){var n=Object.keys(e).reduce((function(n,t,r,o){var i=r===o.length-1,c=e[t];return null==c?n:n+="".concat(t,"=").concat(c).concat(i?"":"&")}),"");return""!==n?"?".concat(n):""}(e.query),s=i&&i.options.base,p=u&&s,d=e.path+(a?f:"");q(d=p?function(e,n){var t=n.split("/"),r=e.split("/");return""===t[0]&&"/"===e[e.length-1]&&t.shift(),r.join("/")+t.join("/")}(s,d):d)}}}function I(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var L=function(){var e=!(arguments.length>0&&void 0!==arguments[0])||arguments[0];"undefined"!=typeof window&&f().forEach((function(n){window["ga-disable-".concat(n)]=e}))},_=function(){if("undefined"!=typeof document&&"undefined"!=typeof window){if(l.id){var e,n,t=[v(l.id),v(l.disabled)];if(e=l.checkDuplicatedScript,n=l.disableScriptLoader,[Boolean(window&&window.ga),e&&!(Array.prototype.slice.call(document.getElementsByTagName("script")).filter((function(e){return-1!==e.src.indexOf("analytics")||-1!==e.src.indexOf("gtag")})).length>0),!n].some(Boolean)){var r="https://www.google-analytics.com",o=l.debug.enabled?"analytics_debug":"analytics",i=l.customResourceURL?d(l.customResourceURL):d("".concat(r,"/").concat(o,".js"),r);t.push(i.catch((function(){p("An error occured! Please check your connection or disable your AD blocker")})))}return Promise.all(t).then((function(e){var n,t,r;u({id:e[0],disabled:e[1]}),L(l.disabled),k(),x(),l.untracked.forEach((function(e){w.apply(void 0,[e.m].concat(I(e.a)))})),n=l.router,t=l.autoTracking,r=l.$vue,t.page&&n&&n.onReady((function(){t.pageviewOnLoad&&n.history.ready&&R(n.currentRoute),n.afterEach((function(e,o){var i=t.skipSamePath,c=t.shouldRouterUpdate;i&&e.path===o.path||("function"!=typeof c||c(e,o))&&r.nextTick().then((function(){R(n.currentRoute)}))}))})),l.ready()})).catch((function(e){l.debug.enabled&&p(e.message)}))}p('Missing the "id" parameter. Add at least one tracking domain ID')}};var B=function(e){var n=arguments.length>1&&void 0!==arguments[1]&&arguments[1];w("send","exception",{exDescription:e,exFatal:n})},H=function(e){if(l.autoTracking.exception){window.addEventListener("error",(function(e){B(e.message)}));var n=e.config.errorHandler;e.config.errorHandler=function(e,t,r){B(e.message),l.autoTracking.exceptionLogs&&console.error(e),"function"==typeof n&&n.call(void 0,e,t,r)}}},F=B;function M(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function U(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}var $=function(e){return"".concat(l.ecommerce.enhanced?"ec":"ecommerce",":").concat(e)},C=["addItem","addTransaction","addProduct","addImpression","setAction","addPromo","send"].reduce((function(e,n){return function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?M(t,!0).forEach((function(n){U(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):M(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},e,U({},n,(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];w.apply(void 0,[$(n)].concat(t))})))}),{}),N={event:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","event"].concat(n))},exception:F,page:q,query:w,require:E,set:j,social:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","social"].concat(n))},time:function(){for(var e=arguments.length,n=new Array(e),t=0;t<e;t++)n[t]=arguments[t];w.apply(void 0,["send","timing"].concat(n))},screenview:T,ecommerce:C,disable:function(){return L(!0)},enable:function(){return L(!1)},commands:l.commands},Q={inserted:function(e,n,t){var r=Object.keys(n.modifiers);0===r.length&&r.push("click"),r.forEach((function(r){e.addEventListener(r,(function(){var e="string"==typeof n.value?l.commands[n.value]:n.value;if(!e)throw new Error("[vue-analytics] The value passed to v-ga is not defined in the commands list.");e.apply(t.context)}))}))}};function W(e){return function(e){if(Array.isArray(e)){for(var n=0,t=new Array(e.length);n<e.length;n++)t[n]=e[n];return t}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function G(e,n){return function(e){if(Array.isArray(e))return e}(e)||function(e,n){if(!(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e)))return;var t=[],r=!0,o=!1,i=void 0;try{for(var c,a=e[Symbol.iterator]();!(r=(c=a.next()).done)&&(t.push(c.value),!n||t.length!==n);r=!0);}catch(e){o=!0,i=e}finally{try{r||null==a.return||a.return()}finally{if(o)throw i}}return t}(e,n)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function z(e,n){var t=Object.keys(e);if(Object.getOwnPropertySymbols){var r=Object.getOwnPropertySymbols(e);n&&(r=r.filter((function(n){return Object.getOwnPropertyDescriptor(e,n).enumerable}))),t.push.apply(t,r)}return t}function J(e,n,t){return n in e?Object.defineProperty(e,n,{value:t,enumerable:!0,configurable:!0,writable:!0}):e[n]=t,e}function K(e){u(function(e){for(var n=1;n<arguments.length;n++){var t=null!=arguments[n]?arguments[n]:{};n%2?z(t,!0).forEach((function(n){J(e,n,t[n])})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(t)):z(t).forEach((function(n){Object.defineProperty(e,n,Object.getOwnPropertyDescriptor(t,n))}))}return e}({},arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},{$vue:e})),e.directive("ga",Q),e.prototype.$ga=e.$ga=N,H(e),_()}t.d(n,"default",(function(){return K})),t.d(n,"analyticsMiddleware",(function(){return V})),t.d(n,"onAnalyticsReady",(function(){return X})),t.d(n,"event",(function(){return Y})),t.d(n,"ecommerce",(function(){return Z})),t.d(n,"set",(function(){return ee})),t.d(n,"page",(function(){return ne})),t.d(n,"query",(function(){return te})),t.d(n,"screenview",(function(){return re})),t.d(n,"time",(function(){return oe})),t.d(n,"require",(function(){return ie})),t.d(n,"exception",(function(){return ce})),t.d(n,"social",(function(){return ae}));var V=function(e){e.subscribe((function(e){var n=e.payload;if(n&&n.meta&&n.meta.analytics){var t=n.meta.analytics;if(!Array.isArray(t))throw new Error('The "analytics" property needs to be an array');t.forEach((function(e){var n,t,r=e.shift(),o=e;if(r.includes(":")){var i=G(r.split(":"),2);r=i[0],n=i[1]}if(!(r in N))throw new Error('[vue-analytics:vuex] The type "'.concat(r,"\" doesn't exist."));if(n&&!(n in N[r]))throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" has not method "').concat(n,'".'));if("ecommerce"===r&&!n)throw new Error('[vue-analytics:vuex] The type "'.concat(r,'" needs to call a method. Check documentation.'));n?(t=N[r])[n].apply(t,W(o)):N[r].apply(N,W(o))}))}}))},X=function(){return new Promise((function(e,n){var t=setInterval((function(){"undefined"!=typeof window&&window.ga&&(e(),clearInterval(t))}),10)}))},Y=N.event,Z=N.ecommerce,ee=N.set,ne=N.page,te=N.query,re=N.screenview,oe=N.time,ie=N.require,ce=N.exception,ae=N.social}])}));

/***/ })
],[16]);


// WEBPACK FOOTER //
// js/app.fe95302c3773ed5cb5b3.js